export default {
  'QR6K9h': '变更为企业客户',
  'SXr/TJ': '更改客户名称及地址',
  'cDZ00w': '查看',
  'tVoPUq': '新建',
  'tXBsQE': '撤回变更',
  'yeM3H9': '当前有变更中的信息，且变更审核未完成，审核通过后才可使用新的信息进行操作，可点击查看详情。',
  '37UnDp': '是否允许销售主账户库存',
  '5yWf2/': '账户认证状态',
  'E8fzoC': '账户可用状态',
  'ElicqC': '客户名称',
  'OtNA8e': '我的资料',
  'yOMNOj': '是',
  'P/eul9': '否',
  'UBD4b9': '地址',
  'a3sL9l': '开户类型',
  'ehoAjT': '客户类型',
  'pV2t/S': '基本信息',
  '1vuDaF': '待激活',
  '3+1Jck': '已认证',
  '8PESa6': '禁用',
  'CLqPBU': '编辑',
  'DUQXFs': '中国大陆客户',
  'KOVFgK': '待审核',
  'Nxf0U5': '个人客户',
  'P13p8i': '审核不通过',
  'Wt7gRM': '海外客户(其他)',
  'XDzVGN': '中国澳门客户',
  'Xqm9/H': '待认证',
  'YA0JvR': '海外客户(澳大利亚)',
  'bzvDaH': '中国香港客戶',
  'dqeSBE': '企业客户',
  'eobwrx': '中国台湾客户',
  'sZSyGZ': '启用',
  'QsOl4N': '查看变更记录',
  '0unUTD': '紧急联系人电话',
  '4wwVxZ': '收件人手机',
  '6YyMOz': '收件人',
  'Ojk15q': '收件人地址',
  'fJNcQC': '钱包可消费国家',
  'tuGgMn': '紧急联系人',
  'b5l2vN': '保存',
  'dGBGbt': '全部',
  'KASLGt': '请根据当前账户预计充值的币种，选择对应的国家，避免产生不必要的汇损。',
  'MEbxQi': '手机号码不正确',
  'Kwqd8h': '联系人',
  'LabgPq': '添加联系人',
  '+4lD9e': '姓名',
  '5aTPaf': '财务类',
  '5cbASK': '直邮/邮政小包/专线',
  '87+CkL': '国内仓',
  'CS1nBc': '公司物流部门负责人',
  'FlbEqp': '最后一公里',
  'JeSd9K': '其他',
  'JsKHKZ': '全部业务',
  'KNi3io': '联系人微信',
  'O77bxe': '业务人员',
  'Q0U6lO': '主联系人',
  'SiW90w': '具体职务名称',
  'UtE0dS': '操作',
  'XeiAal': '删除',
  'XlmRrF': '头程物流运输',
  'ayzEHe': '关务清关',
  'bBGcVD': '海外仓库内及出库',
  'dedKWK': '公司总负责人',
  'e0Sn9Q': '普通员工',
  'hDx3/S': '邮箱',
  'kjXGsB': '业务类型',
  'sZ4TxG': '退货管理',
  't9+g0f': '手机号码',
  'vkuBHV': '联系人职务',
  'ZhSSVD': '编辑联系人',
  'FkpSdN': '微信号',
  'SgFQRw': '温馨提示：主联系人邮箱和手机号码将作为找回密码的途径，请谨慎填写',
  'Tkqx5r': '具体职务',
  'gSS3He': '联系人姓名',
  '0iSYp3': '确定要删除联系人吗？',
  '0iT2j9': '此操作如果涉及邮箱地址、手机号码的变更以及找回密码，会将系统默认订阅内容和找回密码邮件发送到新的邮箱地址或手机，是否继续？',
  'Xhn2gT': '请选择',
  'bKAoaM': '手机验证码',
  'jhfb/7': '保存成功',
  'mZGgaM': '重新发送({countdown}s)',
  'ypMY0M': '获取验证码',
  '0pw2t2': '发货人',
  '5FboZ/': '类型',
  'UWWODP': '收货人',
  'Unr58u': '更新时间',
  'YQa0fs': '新增',
  'ekxzlF': '名称',
  'f9OHsz': '提单收/发货人配置',
  'h/j3a5': '联系人电话',
  'iUMM+c': '联系电话',
  'wCmFtE': '请输入非中文字符',
  'zYYUzJ': '新增收/发货人',
  'Qqmpu5': '确定删除吗？',
  '0P9Dam': '经营单位名称',
  '174V9v': '只能输入1-999的正整数',
  'BfpU2q': '德国VAT优先级配置',
  'JcnLqY': '仅支持审核通过状态的VAT',
  'Zf1gfY': '入库禁止自动分配',
  'gUQJOD': '出库自动分配优先级',
  'n/weLR': '输入1-999的正整数，不输入按默认规则分配',
  'vrXgIZ': '英国VAT优先级配置',
  'IuggbZ': '特别提示，以下情况万邑通不予办理退货：',
  'Vzw58T': '（3）其他依法不应办理退货的。',
  'nRN2tZ': '海外仓',
  'pjeZQ1': '（2）不接受买家自行送至仓库上门退件。',
  'qU4NBE': '（1）不接收任何到付退件,请提前支付运费。',
  'Cmh20w': '新增地址',
  'EGCtVA': '地址编号',
  'I/ecfs': '以下地址仅用于“国际送仓FBA”订单的客户自定义仓库地址',
  'Ls/792': '编号',
  'Ozm+wK': '国家/地区',
  'R2D5Dv': '创建时间',
  'Ut8+i2': '审核通过',
  'W9Nshi': '审核状态',
  'o/NKeE': '默认地址',
  'zarB4B': '电话',
  '+mhlOQ': '仅适用于快递退回的客户使用。',
  '2cscD/': '地址编号为订单批量导入或API下单时使用，由您自定义编写（支持任意字母、数字），但提交后不可修改',
  '4P3k8y': 'ISP退件地址',
  '5iyXaV': '以下地址仅用于"国际递送ISP"快递退回件签收地址',
  'HJ9/xO': '请输入字母和数字',
  'I3KHY+': '寄件/提货地址',
  'LZGKge': 'FBA收货地址',
  'ZT3XmT': '省',
  'aqQg0p': '区域',
  'gvnY3J': '城市',
  'lfTX1B': '邮编',
  'xnNdNf': '退货地址',
  '89AO9d': '如：OAK6',
  'EPwTKQ': '街道1',
  'Y0pQ9+': '街道2',
  'Zh3+AG': '地址编号为订单批量导入或API下单时使用，自定义编写（任意字母，数字），提交后不可修改。',
  'cAO9+Q': '可填写仓库名称及其他备注信息',
  'h/rxnW': '州/省',
  'ma1bk0': '门牌号',
  'Vy+2vj': '注：请输入手机号码',
  'kavVIg': '您的修改已提交,客服人员将对信息进行审核,请耐心等待大约1个工作日的时间。',
  '2cJWcY': '中文联系人',
  '6X3PH/': '英文联系人',
  'FdxNc2': '中国地址选择区域后，邮编将自动填写',
  'I1csCB': '中文地址',
  'iXLW4z': '请输入详细地址，省市区信息无需再次输入',
  's4Uh1V': '英文地址',
  '+a6DnG': '审核中',
  'C2bl/o': '验货仓',
  'FjEahZ': '审核详情',
  'K+M18J': '该地址不支持上门揽收',
  'MTtFwJ': '审核情况',
  'W4KBof': '揽收方式',
  'Xcsk6t': '不在供应商揽收范围内',
  'XmRKnc': '备注',
  'jnerdQ': '该城市揽收地址超限',
  'ptQCRK': '产品线',
  'sEnMXQ': '审核未通过',
  'uyiJ3u': '未审核',
  '3Y6eOz': '失效',
  'BbeuTL': '非WINIT承运进口商',
  'C/pEBf': '查看维护记录',
  'D+H90c': '经营单位列表',
  'G93Pnn': '清关方式',
  'MFvoiw': '出口商',
  'MSzsZn': '作废',
  'QV3pnn': '状态',
  'SaqVpv': '自有进口商递延清关',
  'WrhSGw': '普通清关',
  'Zq5tH7': '维护时间',
  'bqbDVw': '查询',
  'cawvIS': '最后更新时间',
  'gnxH14': '开票进口商',
  'lH1uep': '进口商',
  'rafcJa': '维护记录',
  'wpl80v': '贸易商',
  'zeMk2K': '草稿',
  '7fXxGd': '英制单位',
  'CaAumf': '重量计量单位 : 磅 (lb);长度计量单位 : 英寸 (inch)',
  'EFsNaj': '偏好设置',
  'H2shJb': '重量计量单位 : 公斤 (kg);长度计量单位 : 厘米 (cm)',
  'veounH': '公制单位',
  'wZ+mT6': '选择计量单位',
  '/CDgDv': 'EIN号',
  '1AeGN2': 'LUCID号',
  '47GdDb': '关闭',
  '62OTLP': '下单渠道',
  'EJNWSf': '<strong>API：</strong>{break}使用API下单，采用智能推荐下单后，如系统推荐的发货仓与原仓库不一致，会以报错的形式进行提示，客户可根据提示信息修改后重新提交。{break}<strong>批量导入：</strong>{break}使用批量导入下单时，采用智能推荐推荐下单，如系统推荐的发货方案（发货仓库和派送方式的组合）与原方案不一致，弹出提示界面，如推荐方案有库存，可代替原方案下单；如推荐方案无库存，则只展示，不改变原下单方案。',
  'sX4SJM': '<strong>智能推荐下单：</strong>{break}智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息，基于尾程最优成本&最优时效的原则，计算出最优发货方案（发货仓库和派送方式的组合），并推荐给客户。如需使用智能推荐，请选择主仓下单。',
  'EJpN+O': 'ABN号',
  'M+2rs2': 'BOND号',
  'M32toW': '提交时间',
  'QCtV9X': '智能推荐下单',
  'ZUPzqr': '开启',
  'cBSx2y': '自动发货',
  'dWSaKv': 'EORI号',
  'RKlsu6': '出库智能推荐配置',
  'ilxqI8': '自动发货：自动发货是指系统会自动根据自动推荐所计算出的最优发货方案自动帮客户进行发货，无需客户二次确认。如您有指定仓库发货的需求请勿开启！',
  'nlhDkH': 'Bussiness Number(BN)',
  'th8lNA': 'VAT号',
  'ux3AEe': '说明',
  'uzP8rj': '审核通过时间',
  '0POKcW': '应用区域',
  'bfcFzv': '平台同步',
  'l6DYl/': '批量导入',
  'Qc8f+x': '至少选择一个下单渠道/应用区域！',
  'k8xgfx': '至少选择一个下单渠道！',
  '0hqZKL': '语言设置',
  'zRZV02': '商品申报价值可在通过万邑联或 API 下单时填写并提交。',
  'T8UlhA': '若按订单维度填写申报价值，系统将按您填写的金额分摊至对应 SKU。',
  'hzYI1M': '若按SKU 维度填写申报价值：',
  'F18MFf': '当全部 SKU 均已填写申报价值时，以您实际填写的金额为准；',
  's+rM90': '当部分 SKU 未传入申报价值，或申报价值为 0时，系统将在申报价值获取规则中直接跳过「下单时填写」规则，从下一优先级规则依次获取货值，作为该 SKU 的申报货值。',
  'Xsrcgd': '订单总申报价值为所有 SKU 申报价值之和。',
  '6tpF/e': '下单时填写',
  '7wofGo': '应用',
  'C8evWc': 'SKU发货国家的出口申报价值',
  'GlTTjv': '平台销售价格（仅限ebay平台）',
  'Gwj7xc': '恢复默认',
  'JUpZ++': 'SKU发货国家的进口申报价值',
  'MDCxK0': '获取顺序',
  'RKJ5i8': '注意：{break} 1. 申报价值获取来源选项不能全部取消，至少保留一项。{break} 2. 当未设置申报价值获取顺序时，默认获取顺序为：{break} 下单时填写＞平台销售价格（仅限ebay平台）＞SKU发货国家的出口申报价值＞ SKU发货国家的进口申报价值',
  'W3sY1n': '申报价值获取来源',
  'aBSjju': '获取来源',
  'aq5/iT': '订单发货仓对应国家获取的商品进口申报价',
  'cUGZlH': '订单发货仓对应国家获取的商品出口申报价',
  'kyIaVY': '若您在万邑联的平台同步绑定了eBay店铺，系统自动获取的订单商品总费用',
  'qJVc8e': '申报价值获取设置',
  'BG+fLq': '帮助指南',
  'FJZaXL': '搜索到{total}条记录 "{keyword}" 的结果',
  'zUjHmW': '<strong>抱歉，没有找到与“{keyword}”相关的文档</strong>{break} 建议您：{break} 看看输入的文字是否有误{break} 去掉可能不必要的字词，如“的”、“什么”等',
  'zvNTfS': '进入指南',
  'xUjLTE': '搜索',
  '3/xobX': '请授权eBay查询协议',
  '7uKffF': '授权eBay查询协议',
  'GKxsGv': '授权eBay查询协议!',
  'r0/TUu': '确定',
  '/554iQ': 'eBay账号',
  'H0w708': '关联eBay账号',
  'IPC1Nx': '商品编码',
  'VpfuUi': '规格',
  'c4RKNC': '批量导出',
  'r2dEd/': '重置',
  'xJ3UzU': '国家',
  'zJ+fPt': '维护商品',
  '1WkxFB': '未提交商品，请您搜索出商品后再提交！',
  'AFr5qh': '请输入国家',
  'OxFkJJ': '请输入关联eBay账号',
  'a6Yyuu': '请输入商品编码！',
  'JN5iZt': '提交成功',
  'ENPgS/': '提交',
  'Idl9bN': '下载上传模板',
  'OVecAI': '成功',
  'UxWoxB': '请上传文件！',
  'e6Kx8h': '上传导入文件',
  'jvT5eh': '允许上传文件类型为：.xls .xlsx',
  '553X02': '单个变更',
  '7hIS0P': '新增绑定关系',
  'IGEePO': '批量变更',
  'i+8CAV': '提交变更',
  'uq1Q7O': '可用库存数',
  'yy7EDI': '上传',
  'h7PahP': '绑定时间',
  'kc0dbR': '变更',
  '7tXP5z': '请输入商品编码',
  '5vOrMy': '您修改的商品编码已提交成功。',
  'OiUovQ': '注意：{break} 1、 请不要修改任何字段或文件格式；{break} 2、一次仅允许导入2000条数据，超过时请拆分为多个文件；{break} 3、导入成功的结果请您前往【<a>eBay认证仓商品查询</a>】进行查看。{break}',
  'Q3iOKS': 'eBay认证仓商品查询',
  'S0QUcN': '您已导入成功，请前往eBay认证仓推送商品页查看绑定结果。{break} 提交成功 {successNum} 条，提交失败 {failNum} 条。 {failNum, select, 0 {} other {失败的导入数据和失败原因 <failUrl>点击下载文件</failUrl>} }',
  'l85pdw': '注意：{break} 1、仅在【账号管理】为已启用的eBay账号，库存信息会同步到eBay，您可前往【<a0>账号管理</a0>】查看eBay账号状态；{break} 2、该页面仅展示已绑定的商品信息，未绑定请前往【<a1>eBay认证仓商品管理</a1>】进行绑定；{break}',
  'tqdJgC': '绑定推送/解绑',
  'w5d7pQ': '您已导入成功，请前往eBay认证仓推送商品页查看绑定结果。',
  'zQgm+f': '温馨提示：{break} 1、已绑定推送商品不允许变更商品关联的eBay账号、国家；{break} 2、提交变更时请您核实提交结果，提交后将依据变更，绑定推送关联信息或解除绑定不再推送关联信息。{break}',
  'Tjer6Q': '出库自动分配优先级：包括出库、盘亏等所有减库存的单据，只适用普通库存；UK-Defer入库的库存仍将按先入先出规则优先分配。',
  'U5Vumz': '未配置的VAT按默认规则自动分配，出库自动分配优先级低于配置规则中的VAT。',
  'sCNEKm': '出库自动分配优先级：包括出库、盘亏等所有减库存的单据。',
  'x7XBYH': '入库禁止自动分配：如果选择Y，退货、盘盈等加库存场景，此VAT不参与分配。',
  'cMDiKi': '以下地址用于“海外仓的验货、提货地址”“国际递送ISP” 和“国际送仓FBA”订单的提货或寄件地址新增地址。',
  'oSlHJh': '国际递送ISP/eDS 产品，同一个城市不允许超过2个揽收地址。',
  '+eZfm3': '《信息授权协议》',
  '2QzYmY': '取消',
  '2dToBQ': 'VAT信息',
  '32RoB6': '《德国海外仓仓储协议》',
  '3YXmhj': '重新提交',
  '608d8o': '日志',
  '9WauWf': 'Bussiness Number(BN)文件',
  'C6gmWp': '出口商注册地址',
  'DZfXfd': '请仔细查看协议并同意',
  'DnlTlc': '《英国海外仓仓储协议》',
  'F70ljy': '选择普通清关的需要缴纳进口清关增值税和关税',
  'FNgKWM': '撤回',
  'FsjBUE': '税务代理声明函',
  'GkNbe+': '资料',
  'Hd1SOD': '选择开票进口商不可以作为清关进口商',
  'I+27a0': 'EBAY店铺绑定VAT截图',
  'JfR4m8': '不能包含中文字符',
  'KfmqkT': '保存成草稿',
  'LRaUkx': '出入库数据授权协议',
  'ODfvW/': '出口商名称',
  'Qv+LG3': '《关于德国包装法义务的法律约束力申明》',
  'Rq/p8Q': '我们确认已经符合英国关于增值税的要求并同意签署',
  'SSUtSr': 'EORI文件/激活截图',
  'Sxq3ys': '请输入欧盟国家名称',
  'VsT/ah': '营业执照',
  'WEgQND': 'PVA进口承诺函',
  'WSq7p2': 'VAT注册证',
  'ZKKStI': 'BOND证明',
  'ZXhbHG': '贸易商注册地址',
  'dbS2AO': '不走万邑通头程运输',
  'eGYTrD': '进口商注册地址',
  'fKSz21': '贸易商名称',
  'fRH1j+': '请输入经营单位名称',
  'g+ULz4': '万邑通将应英国海关税务总署（HMRC）要求提供相应的信息和文件给英国海关税务总署（HMRC）',
  'gA384i': '维护',
  'h/HUTI': '适用国家/地区',
  'hMAtte': 'RIS文件',
  'nubBQI': '我已阅读并同意签署',
  'prYaF1': '选择自有进口商递延清关需要缴纳进口清关关税，不缴纳增值税，UK的进口商申请该报关方式需要上传“PVA申请函”，“英国税务代理的抬头信纸申明函”，“VAT报税证明”（VAT注册日期超过6个月，提供前一季度报税证明/VAT注册日期6个月以内，后续提供从注册日期起计算第5个月的申报记录），请在上传资料时完成提交。',
  'q3xYc9': 'ABN注册证',
  'qSAraU': '法人/董事',
  'rgQ1Wi': '以及',
  'tsqy8I': 'LUCID注册文件/注册截图',
  'usIIRS': 'PVA申请函',
  'vDCwZ9': '上传文件',
  'vr5TVT': '请输入',
  'xykin+': '统一社会信用代码',
  'yn1SL5': '进口商名称',
  'BdHisb': '操作时间',
  'Da7ks5': '请输入18为字母与数字',
  'a/r3qH': '操作人',
  'atGbyi': '请输入18位信用代码',
  'e1tqgk': '作废后无法再撤回，请确认是否作废？',
  'tLzna4': '操作动作',
  'IbJWUq': '是否作废当前维护信息？',
  'QieJUI': '变更字段',
  'gsnEOr': '变更前',
  'pS8NPW': '变更后',
  'Dj/XZS': '请勿输入空格',
  'ej75mI': '请输入有效的电话号码',
  'XwwFFy': '报关方式',
  'mqQjid': '身份证/护照正反面',
  'r+pn1G': '选择自有进口商递延清关需要缴纳进口清关关税，不缴纳增值税，UK的进口商申请该报关方式需要上传“PVA申请函”，“英国税务代理的抬头信纸申明函”，“VAT报税证明”（VAT注册日期超过6个月，提供前一季度报税证明/VAT注册日期6个月以内，后续提供从注册日期起计算第5个月的申报记录），请在上传资料时完成提交。',
  '6RphVF': '请上传文件',
  'D+QVwb': '头程非WINIT承运可选择此清关方式。',
  'o1vWQc': '当前维护记录是指已经通过审核并启用的进口商，在变更关键信息时，需要再次审核的审核记录。 {break}核通过后才可成功变更，未审核通过则变更无效。',
  'v8rn/V': '使用客户自有进口商做进口，只缴纳关税，不缴纳VAT增值税。UK的进口商申请该清关方式需要"英国税务代理的抬头信纸申明函”发至指定邮箱（可咨询销售开通），上传“PVA申请函”“出入库授权协议" "PVA声明函”。',
  'vsXTPj': '使用第三方进口商做进口，需要缴纳缴纳关税和杂费（不提供税单）。',
  '3Atmuu': '确认失效',
  'BTlPVu': '登录校验日志',
  'BbSb0z': '修改',
  'BtZh7z': '创建',
  'Q4mnEi': '审核通过后修改',
  'liLr1Z': '是否删除当前信息？',
  'mUCGVr': '确认有效',
  'rthds+': '是否撤回当前信息？',
  'sdupnt': '确认异常',
  'xk9Koe': '维护日志',
  'y3ogvt': '维护审核通过',
  'yyHJG6': '是否删除当前维护信息？',
  'N5niLf': 'Business Number(BN)',
  'T61GlG': '当前维护记录是指已经通过审核并启用的{name}，在变更关键信息时，需要再次审核的审核记录。{break}核通过后才可成功变更，未审核通过则变更无效。',
  'WMI5sr': 'Business Number(BN)文件',
  '+hneSS': '提交维护',
  'OTPfbv': '变更时间',
  'WMGcE3': '维护审核不通过',
  'byKmgP': '{start} 至 {end}， 共 {total} 条记录',
  'N5Lfmq': '不允许的文件格式',
  'niXKkN': '文件大小超过10M',
  '7gd0PB': '资料错误提示',
  '86uQ8V': '以下文件地址失效，请重新上传：{files}',
  'GJghrF': '注意：上传资料格式限制为pdf、jpg、png，大小限制10M，单文件类型限制10个',
  'HlgPNt': '中国大陆',
  'Lszars': '美国',
  'PIBLYF': '中国香港',
  'trcfDz': '例图{index}',
  '/Fo4sl': 'UK海外仓线上协议',
  '/h0Qy3': '地址名称',
  '1m6Ukk': '地址编码',
  'AcTHLQ': '无效',
  'Cyu6TT': '收货地址',
  'FXq3sc': '发货地址',
  'JJl2M9': '导出',
  'naS99r': '有效',
  'yjFeF+': '第三方仓地址',
  'qZZtQ0': '该地址下单不可用',
  'Df3vzk': '拖拽调整顺序',
  'FS9wfs': '重新提交维护',
  '2lXLcA': '请选择适用国家',
  '3GEmd9': '查看地址字符自动修正逻辑',
  'hiw+Xi': '地址自动修正配置',
  'kyspuD': '适用国家',
  'pyipaf': '启用自动修正地址字符',
  'rVuTxV': '变更日志',
  'gYnrwb': '所有',
  '10jb3V': '启用自动截取门牌号',
  'Yx3wUi': '启用自动修正城市',
  'o1Hwo3': '变更人',
  'tGCYrC': '变更内容',
  '876ii/': '2、签署<url>《全球地址自动优化协议》</url>后，系统将自动启用以下所有修正项，如需关闭请去掉勾选后保存。',
  'B8Is1c': '1、启用地址自动修正，需提前签署<url>《全球地址自动优化协议》</url>，否则以下配置不可编辑',
  'P4iDwm': '查看门牌号截取逻辑',
  'UYZ3z+': '查看自动修正城市逻辑',
  '6AxC42': '收件人邮箱',
  'CmaYfv': '收件人VAT/EORI',
  'UVmTM9': '收件人姓名',
  'abk9Do': '收件人电话',
  'k/3yRK': '常用出库地址',
  'oN/kSF': '预约信息',
  'uoZwj+': '创建人',
  '3eRWcP': '邮箱地址',
  '6kdpEu': '收货人信息',
  '9YhIAD': '邮件预约',
  'HNavdr': '公司名称',
  'V2u2QJ': '预约要求',
  'jetAYE': '电话预约',
  'siSti3': '地址信息',
  'ea3Q5D': '电话号码',
  '3XMw6o': '责任人公司',
  'AG/fPb': '地址2',
  'B7TTEB': '鉴于以下提交的内容，我/我司声明：{break} 1.对于由我/我司的欧盟责任人负责的每件商品{break} a.商品/其包装或随附文件中标有欧盟责任人的名称和联系详情，包括邮政地址{break} b.欧盟责任人拥有符合性声明(或性能声明),并有权访问相关技术文档以证明符合要求{break} 2.如果我/我司的欧盟责任人发生任何变更,将通知贵司{break} 3.上述提交的所有信息均属实,如有虚假信息导致的任何责任及后果将由我/我司承担',
  'EpqiOL': '确认是否生效？',
  'IIqX9O': '电子邮件',
  'KZEXfv': '确认是否失效？',
  'etW1Tw': '负责人状态',
  'jrh2fV': '编码',
  'qRFx1i': '新增负责人',
  'qWBL/6': '商品负责人',
  's4hJju': '详情',
  'uUvS4a': '地址1',
  'w1B/h4': '生效',
  '1AtZdk': '前往提交订单页',
  '36+mbi': '处理状态',
  '9AIfVS': '成功数量',
  'ARrflw': '文件名称',
  'KnTZPE': '失败数量',
  'NLpJXo': '耗时（分钟）',
  'NPKHC7': '下载失败数量',
  'O2kIme': '批量上传结果',
  'uMZCpR': '所有数量',
  '+eaHJw': '批量新增',
  'G2smdP': '中文名称',
  'L5h07e': '批量移除',
  'Ly/R6V': '指定不良品混合存储',
  'RlzFYp': '确定移除吗？',
  'XF6xi6': '请选择需要移除的商品！',
  'aHlr3k': '移除',
  'D1o32K': '异常日期',
  'IIpaxH': '异常类型',
  'UfxykZ': '原因',
  'l0qKOL': '异常库存数量',
  'hYlWkF': '最多支持{count}个编码，使用逗号或换行分隔',
  'veOJme': '数量超过{count}个',
  'txkkWO': '关联单号',
  '2C37Hc': '异常单号',
  'LLD1es': '异常原因',
  'k1dsDk': '关联业务单号',
  '0D60ha': '更多',
  '46Xee4': '目的国进出口商',
  'WVZBn4': '目的国进出口商注册地址',
  'sWBQDd': '目的国进出口商名称',
  '6qPVaC': '尾程指定进口商',
  '7BkuKz': '下单设置',
  'QeeTzU': '进口国',
  'ckpzhc': '出口国',
  'yvg8P4': '尾程指定出口商',
  '75uiZ7': '请输入{fieldName}',
  '+benQU': '您好，不可以同时选择同一个国家或者同为欧盟国家作为进出口商，请重新选择',
  'm3uVGW': '进出口国组合配置重复，请重新选择',
  'n/orQt': '尾程进出口商配置',
  'h+ZVJS': '【尾程指定出口商】和【尾程指定进口商】必须指定其中一个，不能同时为空',
  '+k3Q5q': '尾程进出口商可指定国家下使用的进出口商，【尾程指定出口商】和【尾程指定进口商】必须指定其中一个，不能同时为空',
  'wxbfiR': '该目的国进出口商已失效，请重新配置',
  'KR0Hgn': '原产地出口商注册地址',
  'O8r6Nr': '原产地出口商名称',
  'auxh85': '其他设置',
  'eu9UcL': '原产地出口商',
  '7Rb0P0': '请输入0-30个字符',
  '9SnCRm': '错误提醒',
  'BugeSn': '仅支持zip格式的压缩包{break}将每个商品的德语说明书规范文件名称后，压缩为一个zip格式的文件，方可进行上传。{break}压缩包内文件名规范：商品编码&&&规格',
  'DqPtfZ': '有',
  'EIebSr': '无',
  'HvXKb+': '导入类型',
  'MCgWp2': '导入成功',
  'NzmP6C': '纸质德语说明书',
  'O6OGAx': '商品条码',
  'Up6Ro9': '下载导入模板',
  'X5vmSB': '德语说明书链接',
  'cpiawR': '支持doc格式或pdf格式，限制10M以下',
  'hwLqlW': '导入只支持XLS、XLSX格式文件，导入文件中的链接最长支持30个字符',
  'iwbG4U': '中文名称{break}英文名称',
  'oH13Vj': '导入',
  'pVp/bh': '请选择文件上传',
  'rpg4rj': '德语说明书文件',
  'xraZsK': '点击此处',
  'srQkrR': '说明：{break}a.电子档说明书，需进行库内增值把说明书打印出来添加到商品里{break}b.说明书链接，商品出库时将在面单上打印对应的德语说明书的链接，但该功能受限于尾程派送供应商，建议您尽快把德语说明书纸质文件添加到商品里{break}c.颜色标红的商品必须带有纸质的德语说明书',
  '+CFe0t': 'Winit标准包装',
  '/CesoY': '体积(CBM)',
  '0B0jPm': '天',
  '1ZbDC3': '重量(kg)',
  '2+X2n8': '批量删除',
  '23ZRo5': '出口商VAT',
  '2IBaY7': '请输入数字且小数点后不超过四位',
  '3xzQSW': '不能选择的原因',
  '6+iYA0': '序号',
  '63L59R': '客制包装',
  '6EHwdX': '托盘类型',
  '7FRGXg': '批量添加商品',
  '7n6a/K': '商品信息',
  '7riRKk': '批量添加',
  '8VzrEu': '请选择币种',
  '9bnXiC': '单一产品',
  '9k+FW2': '尾托',
  '9ll3dY': '包材类型',
  '9qzdVH': '包裹重量(kg)',
  'Ao74DA': '订单包材商品编码',
  'BHT1Cr': 'SKU类型',
  'CKRHYP': '折扣金额',
  'DTvHkh': '以下报价仅供参考，最终以出库单的实际计费为准，如有疑问，请与您的客服代表或业务经理联系，谢谢！',
  'Dpm+6x': '发货仓，收件人国家和邮编，商品信息为必填项{break} 如果您填写邮编不正确，将无法测算费用{break} 如果您使用【非WINIT注册商品】测算，填写的重量或体积超过渠道限制，将无法测算费用{break} 如果需要测算TOLL相关的渠道费用，或收件人国家为AU，请填写省份/州和城市信息{break} 如果需要测算要申报的渠道，使用【非WINIT注册商品】测算时，请填写销售金额及币种信息并且请在【万邑联-个人中心-申报价值获取设置】页面勾选【申报价值获取来源】为“下单时填写”',
  'GBQ8fq': '托盘长*宽*高',
  'GMujSv': '销售金额',
  'HRSUhm': '若SKU类型为单一产品，请填写出库单商品个数；若SKU类型为套装产品或箱产品，请填写出库的套数或箱数',
  'HzFVgP': '请选择商品再进行计算',
  'KgH03N': '全托',
  'MBDvr0': '请输入宽',
  'MPleAI': '商品名称',
  'NgGZZ2': '请输入12位及以上数字或字母',
  'O0A1Oq': '长*宽*高(cm)',
  'Og2Qdv': '不可选择产品',
  'P410bl': '请输入长',
  'QrBLOg': '一单多包裹',
  'THHekX': '库存单元标准件数',
  'TTavqO': '常规出库',
  'TdB0f7': '请输入高',
  'UH1kCc': '添加',
  'VGcpgt': '派送时效',
  'WHdJYA': 'Winit产品',
  'Z+i6Rm': '商品规格',
  'bZaON1': '金额输入限制0.01-999999.99，最多两位小数',
  'bduxF6': 'Winit已注册商品',
  'cIVTIx': '托盘个数',
  'cQZEJX': '超托',
  'cstWzE': '进口商VAT',
  'dJ89Br': '增值服务',
  'eLEnSl': '非Winit注册商品',
  'fMEG4U': '一单多面单打包',
  'hAZ9h3': '高请输入数字且小数点后不超过两位',
  'hR9/2a': '包裹长(cm)x宽(cm)x高(cm)',
  'hTL5aU': '托盘数',
  'hTZnwL': '返利金额',
  'i0bc3f': '币种',
  'i1oH9G': '包装方式',
  'i738m0': '出库加包装',
  'igMfLW': '套装产品',
  'jOZW14': '托盘出库',
  'k7s6O7': '发货仓',
  'lqAG8L': '箱产品',
  'mDikX0': '出库数量',
  'mhxee1': '费用项名称',
  'nIWEr7': '可选择产品',
  'ohULHS': '收件人国家',
  'w6vqtD': 'IOSS NO.',
  'wauDMi': '总费用',
  'xuLZNZ': '长请输入数字且小数点后不超过两位',
  'yx2O+K': '应收金额',
  'zO/rYo': '出库方式',
  'zy6bEq': '宽请输入数字且小数点后不超过两位',
  '2w153i': '实收金额',
  'IFSxrU': '费用项编码',
  'tc4Ood': '请选择数据',
  'Bc++8m': '气泡袋',
  'Dm23uJ': '纸箱',
  'f9THke': '快递袋',
  'sPJoAT': '派送费用预估',
  'TdtC9s': '请选择发货仓',
  'XiHRkz': '共 {total} 条记录',
  'bFMl+l': '请选择商品并添加',
  'SfYiE5': '输入的值必须是大于0的整数',
  '//WaV/': '单品化管理',
  '/XgsKl': '是否有只上货机标',
  '1+Uose': '权限设置',
  '1E5dGB': '有品牌',
  '2MJUJn': '启用出库组套',
  '44gmfc': '商品化管理',
  '5xncPr': '是否有限制出口标',
  '7RULl5': '启用后，可以按批次管理商品并指定批次出库',
  'A5gRQm': '是否有锂电池UN标',
  'B5hVJ7': '展开更多设置',
  'BTv3tF': '不加包装',
  'EcMORf': '启用批次管理',
  'FOxVvr': '启用后，您可以维护包材商品。出库时可以配置使用客制物流包装',
  'Hs7Y9S': '商品设置',
  'I8NwoI': '选择不加包装，则注册商品默认全部不加包装。{break}需要加包装，注册商品才会需要填写包装信息，可以对商品添加包装偏好，后续仍可对单个商品进行修改。',
  'IOnZfu': '是否有易碎品标',
  'JJR2vL': '是否有正面朝上标',
  'KWQDuK': '启用后，可以指定商品按照出库组套规则进行规范打包',
  'L4Rf/B': '默认设置，后续仍可对单个商品进行修改。',
  'RShmXn': '管理方式',
  'S/KCTh': '需要加包装',
  'S30Plx': '商品出库包装',
  'V2w9jQ': '启用套装产品',
  'XL7Ecj': '是否有9类危险品标',
  'XQ0eW6': '商品入库包装',
  'Z2NCKN': '启用客制包材',
  'dBkhSm': '启用后，可针对单一产品SKU维护箱产品',
  'eq/wHb': '无品牌',
  'et9PbY': '启用多个第三方商品条码',
  'fZCpT7': '启用箱产品',
  'ipcBHJ': '默认设置，后续仍可对单个商品进行修改。{break}当通过API注册商品时，不填则默认管理方式为当前偏好。',
  'nkXqB0': '是否有品牌',
  'ooWceD': '是否有只限陆运标',
  'rvY6SV': '收起更多设置',
  'sCJ51j': '启用后，可以对同个商品维护多个第三方商品条码',
  'wgwaXi': '启用后，可针对单一产品SKU维护套装产品',
  'xE1H+X': '设置',
  '5knzXk': '商品出库包装偏好',
  'Ak9BaJ': '出库包材类型',
  'CB041o': '单一订单',
  'DxV5Uw': '出库包装类别',
  'EMKEjY': '默认设置，后续仍可对单个商品进行修改',
  'NV9VX7': '复合订单',
  'V0RiZp': '操作成功',
  'nP04RA': '选择需要加包装会默认开启出库加包装使用权限，注册商品时需填写包装信息，导入模板也会随之更改（需重新下载导入模板）。确认需要加包装吗？',
  '1i8ZrX': '商品包装材质',
  '4MGor2': '入库包装',
  'EWhdiR': '裸货不支持直接出库，请维护出库包装偏好为需要加包装，否则商品无法注册提交',
  'Gz4aGL': '出库包装',
  'H6C/SG': '商品包装形状',
  'OD7P5z': '去签署',
  'vDrXbl': '商品入库包装偏好',
  'NFpCub': '销售包装不支持直接出库，请维护出库包装偏好为需要加包装，否则商品无法注册提交{break}{break}若您仍需使用销售包装出库，请签署<url>《销售包装商品海外仓免责协议》</url>',
  'DmqHzL': '客制包材使用说明如下，请先仔细阅读后再打开。打开后若维护了客制包材将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用客制包材吗？',
  'IKjl4Y': '出库组套使用说明如下，请先仔细阅读后再打开。打开后若添加了组套将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用出库组套吗？',
  'i2iyhb': '箱产品使用说明如下，请先仔细阅读后再打开。打开后若创建了箱产品将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用箱产品吗？',
  'iZYhRR': '批次管理使用说明如下，请先仔细阅读后再打开。打开后将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用批次管理吗？',
  'jX7MAR': '第三方商品条码使用说明如下，请先仔细阅读后再打开。打开后若对商品配置了多个第三方条码将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用多个第三方商品条码吗？',
  'mLKBZu': '套装产品使用说明如下，请先仔细阅读后再打开。打开后若创建了套装产品将不允许关闭，请谨慎操作！<url>《查看操作指引》</url>{break}{break}确认要启用套装产品吗？',
  '+Xgzdq': '是否带有电池',
  'DpcGY6': '是否为食品',
  'FGVjpL': '是否带有液体',
  'nJAKFn': '更改商品管理方式偏好，将影响注册商品时默认取值，请谨慎操作。确认是否要切换偏好？{break}特别注意：ERP对接通过API接口注册商品时，商品管理方式不传值会默认取当前偏好管理方式，更新会影响后续注册商品属性。若API注册商品已传值则不受影响。',
  'USKhsn': '搜索的 "{keyword}" 的结果',
  'J1Q+MP': '跳过',
  '66h8jy': '操作指引',
  '19Jq5n': '共选中{count}项',
  '1WXIxS': '解绑',
  'DBt/Kx': '单品条码',
  'FEb7U2': '确认',
  'Ig8gbN': '单品状态',
  'R5GY4d': '导入日期',
  'Wz9vSw': '格式输入错误,请换行分隔',
  'XlNGpT': '导入时间',
  'ZPVUga': '失败原因如下:',
  'CW17P+': '复制删除失败条码',
  'XOD0e7': '删除失败！',
  'mUf6oZ': '共删除{totalNumber}条，成功{sucessNumber}条，失败{failNumber}条',
  'u4FyMa': '删除成功！',
  'x79O39': '是否确定删除？',
  'J9jPRL': '复制成功',
  'Zmju6f': '是否确定删除？{break}删除后此单品将无法识别。如需使用可再次导入。',
  'aINg/w': '共选中{count}项{brack}删除后此单品码将无法识别。如需使用可再次导入。',
  'nE9ED6': '商品编码/单品条码必填',
  'v0yFyE': '支持{count}个查询, 多个换行分隔',
  '16GLc2': '导入标题',
  'EJ8eWW': '请重新上传文件',
  'PqthfX': '导入只支持XLS、XLSX格式文件',
  'QJWMv+': '下载明细',
  'Qw6uy2': 'SI码',
  'aFoyrY': '异常信息',
  'msjKFi': '说明：单次最多支持导入2000行数据;导入的单品条码会自动忽酪大小写（例:A001=a001)',
  'yiJCTd': '导入数量',
  'zKvO0B': '导入失败',
  'DVNJXJ': '海外仓名称',
  'qXXyG3': '当前是否有权限',
  'trneJA': '下单时是否显示',
  'x/c7oO': '入库仓库权限与偏好设置',
  'CYysYX': '入库仓库权限开启后，您无法主动关闭权限，如果您暂时不使用该仓库，可在此关闭，下单时将不再展示该仓库。',
  'Dpt9uk': '1.请先详细阅读[说明]内的权限描述，部分仓库的入库权限需要联系销售，沟通细节后开启；部分仓库您可自行开启入库权限;{break}2.权限一旦开启，无法关闭，您可选择下单时不展示，若确实需要关闭，请线下联系销售。',
  'JSgfNL': '权限一旦开启，无法主动关闭，但您可选择下单时不展示。开启前请确认该仓库的说明内容[{content}]',
  'Yms1oN': '确认开启',
  'dNnCF+': '权限一旦开启，无法主动关闭，但您可选择下单时不展示。开启前请确认该仓库的说明内容',
  '+QWQ7W': '丢失',
  '3oxdqD': '冻结库存详情',
  '4Cv856': '仓库',
  '51UNgD': '订单类型',
  '7NAcml': '在途预售库存',
  '7jOH23': '禁止出库详情',
  '8eXVBt': '销毁',
  '9YU+8d': '已丢失待客户确认',
  '9y5qSL': '客户确认时间',
  'AG7PGl': '可用数量-单一产品',
  'BEt562': '不良品',
  'BNzv8f': '待销毁',
  'C9KK8/': '发货仓DOI',
  'D/f5lj': '已选中{count}项，',
  'ID5w3K': '冻结库存',
  'IXB0ef': '在库库存',
  'JPAdAP': '库存状态',
  'JQ/Ist': '国家DOI',
  'Km0LJq': '在库库存=可用库存+冻结库存',
  'L9MjKF': '30天平均库存',
  'Lt5p5C': '标准件数',
  'OA+Xwp': '预售待出库',
  'P7a7B/': '调整原因',
  'PnCden': '可用库存',
  'QSV2/G': '订单号',
  'QchsUr': '15天平均日销量',
  'Qo/0n7': '丢失确认中',
  'RT/7og': '历史销量',
  'RbA7OQ': '异动库存数量',
  'SWKjFA': '{code}异动单品条码',
  'T7WawI': '条码值',
  'TpgfJ8': '请先勾选项目，再进行批量操作',
  'URlHB2': '30天平均日销量',
  'VdJkh+': '15天平均库存',
  'W2+wGW': '商品等级',
  'WsRSAn': '冻结',
  'WwDNC5': '待出库',
  'X762xx': '确定是否“销毁”？',
  'XOOIse': '冻结时间',
  'XlFayN': '禁止时间',
  'YUZvPl': '分类调整',
  'YnxgOi': 'VAT失效',
  'ZVeUDz': '可用数量-套装产品',
  'Zdo26n': 'Winit批次号',
  'btoiBR': '历史代销量',
  'cRTCYq': '没有单品条码',
  'cU49d1': '确定是否“丢失”？',
  'ccnZxp': '在途库存',
  'cflP7Y': '批量操作',
  'cuhpZK': '历史入库',
  'dLxQHX': '批量盘盈',
  'dgQSya': '批量销毁',
  'fFmyYM': '数量',
  'fWbzVI': '禁止出库原因',
  'fnadHf': '可用数量-箱产品',
  'j6IHvr': '查看详情',
  'jCTrLS': '原因类型',
  'k6yR1Q': '批量丢失',
  'lGKG8E': '商品编码:',
  'lLWqdW': '禁止出库',
  'n+BMoU': '盘盈',
  'nESkNw': '出库',
  'oOn0Fr': '确定是否“盘盈”？',
  'pii09f': 'DOI',
  'qauzml': '商品编码: {code}',
  'tQ0Q32': '良品',
  'w9wMqE': '90以上',
  'wKT8Cc': '异动类型',
  'xR2mTp': '7天平均库存',
  'xRoxY9': '在库异常',
  'yq0/8z': '7天平均日销量',
  'zVQSYe': '复制全部单品条码',
  'zgawnw': '30以下',
  '3etnsJ': '商品库存详情',
  'mlFgct': '在库异常库存详情',
  't0kvjC': '查看全部',
  '2Po2YS': '自定义备注',
  'CMMjhY': '列展示',
  'dS21yU': '国内验货的订单总在途库存，含在途预售库存',
  '1DsLji': '盘亏',
  'AZxE/7': '已盘亏待客户确认',
  'WA8SWg': '批量盘亏',
  'zJebwh': '确定是否“盘亏”？',
  'eZAtxt': '字段展开',
  '/54ans': '联系我们',
  '5XTs5h': '未开通',
  'AzoW7u': '绑定平台账号',
  'CYaf7V': '合作平台',
  'CqNtWB': '在线客服',
  'FO80Dr': '公告',
  'L9AWTW': '立即充值',
  'LJ4oo0': '海外仓可下单余额',
  'bpnKHs': 'ISP钱包账户',
  'cDLItQ': '服务热线',
  'dQk0wJ': 'QQ群',
  'iAGw0w': 'ISP可下单余额',
  'mFqrQH': '周一至周六',
  'qCIS/C': '海外仓钱包账户',
  'yYPe3y': '官方微信',
  'z3zd1c': '我的钱包',
  '0NHAD7': 'Ascan平均耗时(工作日/小时)',
  '26DC55': '注册商品',
  '3R9vaL': '手动输入商品信息',
  '4IKihp': '提交资料',
  '5WHhDh': '创建SKU',
  '7XxAs8': '订单配送数量',
  '7fauGF': '库存准确率',
  '8RMTyh': 'Dscan平均耗时(工作日/天)',
  '9HIheN': '待还账单',
  'Al4hA+': '计算费用',
  'AmrrcV': '下载详细仓租尾程报价',
  'BJTA9X': '上架及时率',
  'Cpevaa': '重量',
  'EdQOh6': '待办事项',
  'FBa9eA': '创建入库单',
  'FE59Oe': '请选择仓库',
  'GwpK9X': '联系客户经理',
  'KiyShr': '存储在万邑通仓库的商品数量(个)？',
  'LMdsl4': '货物在哪个国家履约？',
  'MvStWs': '近3个月',
  'OrZu3X': '公开价',
  'PTKAsz': '开通仓库权限',
  'Pv8aT1': '出库及时率',
  'Rh/Y5b': '异常订单',
  'Sa0aiY': '近一年',
  'SkRR/r': '当前客户数据',
  'UHii1H': '默认开通部分仓库，需开通美西或英国仓库权限，请点击此处',
  'V8qnx7': '近6个月',
  'W0fifu': '签订合同',
  'WWlgnl': '快速创建SKU',
  'Xfbnoa': '近7天',
  'Zh1x4W': '退货待处理',
  'aedLAU': '宽',
  'baV1Ei': '长',
  'cMSkQ5': '订单配送时效',
  'hBkLmp': '高',
  'ik+mqU': '近1个月',
  'jSyO7i': '仓配指标',
  'kTgc5v': 'Winit头程运输',
  'kteyYj': '下载详细头程报价',
  'm/LYrd': '选择已注册商品',
  'mvaPZW': '仓租费用',
  'o9u8xE': '尾程费用预估',
  'r8cl4c': '商品待处理',
  'rV6Ikp': '请先签订服务合同和协议，我们才能为您提供基础服务',
  'uWDBT3': '万邑通数据',
  'v+gjOA': '以下指标数据T+1，非实时数据',
  'vN3oQA': '视频教程',
  'wpzAgZ': 'winit仓库指标信息',
  'wwmySt': '一口价',
  'zLIDw1': '履约费用测算',
  'zdb024': '尾程履约费用',
  'uqm47n': '平均耗时',
  'B8/NTe': '我的数据',
  'UdsGuw': '去绑定',
  '4uI559': '即统计周期内，准确无误出库的商品占全部商品的比例',
  '5/pZpj': '即物流公司揽收第一次扫描到目的地最后一次扫描的时间点信息',
  '9Fzg5x': '即统计周期内，正常出库的订单占全部订单的比例',
  'Yueu4d': '即商品从到仓到上架至货架的时间效率',
  'bybWts': '即客户下单后，物流公司揽收包裹后进入到尾程仓库的第一次扫描时间点信息',
  'E7VjfS': '仓租费用预估',
  'Ge0lbr': '商品重量',
  'w+DoTf': '商品尺寸',
  'kPcnam': '【{fieldName}】请输入大于0的数字，最多{digits}位小数',
  'h1qBUu': '测算商品选择',
  '+c20Bq': '尾程指标',
  '2IVg9s': '退货指标',
  '42ASVQ': '标准海外仓快递入库',
  '6EkZOI': '货物物流属性',
  '7PAub+': '到仓上架及时率',
  '9QCBnw': '出库指标',
  '9p6smW': '货物从国内哪个港口发出？',
  '9qb80q': '入库方式',
  'A9Tz/W': '空运',
  'BKXdVC': 'Winit头程运费',
  'D2G0C4': '统计单元',
  'Epktmm': '直发自验入库',
  'Hg/8GB': '海运',
  'ID6XQq': '卸货上架及时率',
  'MNTXeZ': '月',
  'Np+Iw0': '周',
  'Qpi3DY': '日',
  'R/uhzG': '货物发往哪个国家履约',
  'SVKHsT': '自定义日期',
  'WZ68qc': '包裹',
  'WbPzFJ': '横坐标维度',
  'XYdT8p': '运输方式',
  'ZGJHHK': '到仓卸货及时率',
  'ZcM+gl': '直发海外验入库',
  'aDdguC': '标准海外仓入库',
  'd5xPIO': '入库指标',
  'gNbcdl': '快递',
  'o8kLqD': '头程运输方式',
  'DpnauN': '时间',
  'MHQn6p': '用户选择周期后转化为具体日期，周起始{周日开始到周六结束}；每年第一周和最后一周会跨年统计',
  'SGfALI': '指标类型',
  'VLj4TX': '指标值',
  'dRP+2A': '分母',
  'upV5YZ': '数据说明',
  'ySoacE': '分子',
  '+70F5G': '包裹上架及时率(不含异常)',
  '+tjEe2': '异常包裹数',
  '3wNvEr': '正常未上架',
  'JkNfUW': '及时上架包裹数',
  'S1rbJ3': '超时未上架',
  'SeNsek': '超时上架包裹数',
  'SnHWjC': '包裹上架及时率(含异常)',
  'ek1T28': '应上架包裹数',
  'iV9J/A': '指标',
  'qee9ZL': '维度',
  'uqF4+w': '未上架包裹数',
  'VglISO': '季度',
  '04xGKp': '1. 分母：目标统计周期内，实际出库包裹数{break}分子：分母范围内，实际产生Dscan时间<=目标产生Dscan时间的包裹数"{break}2. 分母：实际出库日期范围内，实际出库包裹数{break}分子：产生Dscan总耗时"',
  '2Bdgmz': '超时Ascan包裹数',
  '2lkHR6': '未履约订单数',
  '4D20an': '应履约订单数',
  '4kz3bn': '标准出库',
  '70rwvT': '分母：应暂存日期汇总的自提订单数{break}分子：分母范围内,在应暂存日期23:59点前暂存到自提货架区的订单数',
  '7XH7nH': '包裹卸货及时率(含异常)',
  '80fD5c': '超时未上架包裹数',
  '8VFtm8': '未出库订单数',
  '9AWRj6': '包裹AATscan率',
  'C63z6s': '包裹Dscan及时率',
  'CAyA0a': '正常未暂存订单数',
  'CCv+GA': '及时卸货包裹数',
  'CDh1Z0': '包裹Ascan及时率',
  'DKuZRC': 'Ascan平均耗时',
  'DPV9rx': '自提出库',
  'DSYISn': '及时Ascan包裹数',
  'FPMFhy': '应卸货包裹数',
  'Fjwf8i': 'Dscan平均耗时',
  'HkwQAL': '超时暂存订单数',
  'IFg102': '正常出库订单数',
  'KCCu84': '超时未出库履约订单数',
  'KetzY1': '超时未Dscan包裹数',
  'O3tvz6': '应处理订单数',
  'OXckHM': '应暂存订单数',
  'QflAU5': '暂存及时率',
  'QhGzOU': '分母：目标上架日期（包裹到仓时间 + SLA）范围内，应上架包裹数；{break}分子：分母范围内，包裹实际上架日期<=目标上架日期的包裹数',
  'R+bb+H': '正常未Ascan包裹数',
  'R05sfI': '超时AATscan率包裹数',
  'T8EZBS': '未Ascan包裹数',
  'UAuAfS': '超时未处理订单数',
  'Uh+qYa': '销毁出库',
  'UqstXw': 'Ascan及时率&平均耗时',
  'Uu9ZOD': '应出库订单数',
  'VSe5Uw': '分母：实际出库日期范围内，实际出库包裹数{break}分子：产生ATTscan包裹数"',
  'VVFpWJ': '订单出库履约及时率',
  'VsSqY5': '订单错发率',
  'WUr4rT': '超时未卸货包裹数',
  'WxCghz': '分母：目标卸货日期（包裹到仓时间 + SLA）范围内，应卸货扫描包裹数{break}分子：分母范围内，包裹实际卸货日期<=目标卸货日期的包裹数"',
  'XSSKN4': '超时Dscan包裹数',
  'YSXXUs': '订单',
  'YSfC7P': '正常未处理订单',
  'Z2dCu9': '分母：目标上架日期（包裹卸货扫描时间 + SLA）范围内，应上架包裹数{break}分子：分母范围内，包裹实际上架日期<=目标上架日期的包裹数',
  'ZkUwmd': '未暂存订单数',
  'a+G37I': '正常未上架包裹数',
  'b1DsV8': '分母：目标出库日期范围内，非草稿 / 客户作废 / 万邑通作废 / 抓单失败作废的应出库包裹数{break}分子：分母范围内，实际出库日期<=目标出库日期的包裹数"',
  'bReBTV': '正常未Dscan包裹数',
  'c5ZVUt': '超时未Ascan包裹数',
  'cDzsuR': '及时出库订单数',
  'cGhzfI': '及时AATscan率包裹数',
  'd9LVhN': 'Dscan及时率&平均耗时',
  'e5FeD4': '超时出库订单数',
  'ecuDmM': '订单出库错发率',
  'eelcKV': '转仓出库',
  'h5/Zm7': '超时未暂存订单数',
  'hfS5uu': '包裹卸货及时率(不含异常)',
  'iNmyS0': '1. 分母：目标统计周期内，实际出库包裹数{break}分子：分母范围内，实际产生Ascan时间<=目标产生Ascan时间的包裹数"{break}2. 分母：目标出库日期范围内，产生Ascan包裹数{break}分子：产生Ascan总耗时"',
  'inzYEx': '退货类型',
  'iySA8M': '正常未出库订单数',
  'jBvMBS': '超时卸货包裹数',
  'jQ8TO3': '订单暂存及时率',
  'jed6Xm': '分母：目标出库日期范围内，非草稿 / 客户作废 / 万邑通作废 / 抓单失败作废的应出库包裹数{break}分子：分母范围内，实际出库时间<=目标出库时间的包裹数',
  'k75tZv': '超时未出库订单数',
  'kMNnhp': '应Dscan包裹数',
  'l/MdYt': '及时处理订单数',
  'n/cvYW': 'AATscan率',
  'nCq48k': '正常未卸货包裹数',
  'ntw3S3': '应AATscan率包裹数',
  'ofFLk1': '退货处理及时率',
  'pJfOu6': '订单出库及时率',
  'qcRLQI': '出库履约及时率',
  'rjLU6N': '超时出库履约订单数',
  'sN8Get': '及时出库履约订单数',
  'tMq0kR': '未卸货包裹数',
  'ta6pfJ': '及时暂存订单数',
  'tmRLpn': '超时处理订单数',
  'tueJPY': '正常未出库履约订单数',
  'u/Nmqf': '及时Dscan包裹数',
  'u9OXnl': '未Dscan包裹数',
  'v++ddI': '错发出库订单数',
  'v5BXop': '应Ascan包裹数',
  'w3cM8T': '订单处理及时率',
  'xvWSVx': '分母：目标出库日期范围内，非草稿 / 客户作废 / 万邑通作废 / 抓单失败作废的应出库订单数{break}分子：到账日期范围内，错发订单数（海外仓标准索赔中索赔类型为“错发货物”、“漏发货物”、“多发货物”的订单）',
  'yHvp8+': '库存单元',
  'z1MEnJ': '未处理订单数',
  '71WlLj': '退货/退货处理及时率',
  'BUgJtV': '关注指标',
  'E/j2ry': '入库/到仓上架及时率',
  'O3Cery': '出库/出库履约及时率',
  'gsXmkI': '尾程/Ascan及时率',
  '/HSkL1': '货物预计在万邑通仓库存放多长时间？',
  '4xrCgJ': '长*宽*高',
  '2ABlbj': '仅仅支持Ebay和Tiktok平台，且费用中包含了入库和出库的处理费',
  'Q260fk': '您未开通服务权限，此功能暂不可查看',
  'TSMoUa': '创建1个SKU之后：您已创建了商品，可以创建更多商品进行使用哦',
  'gKKcGV': '去开通权限',
  'G5HeYy': '此商品体积<单品最小存储体积{m}CBM，则此商品按{m}CBM计算库存总体积',
  'qR+EsV': '库存总体积<{n}CBM，按最小仓储体积{n}CBM计算仓储费',
  '1/vSZm': '出库履约率',
  'Ayb5cF': '订单出库履约率',
  'BiLWKP': '出库/出库履约率',
  'sNnQU4': '透明清晰的报价方案，我们的客户经理会在12小时与您取得联系',
  'aerjpH': '资料已审核通过，已为您开通海外仓服务权限，可以查看菜单啦',
  'aHWOLO': '请先提交资料，等待人工审核后即可开通海外仓服务权限',
  'Nc3gof': '您已创建了商品，可以创建更多商品进行使用哦',
  'OmtISj': '请先创建商品，商品完成需要审核，通过后该商品可正式使用',
  '7rA83N': '请先创建入库单，选择产品服务和填写其他信息，才能成功下单哦',
  'KdyIP8': '您已创建了入库单，可以继续创建更多入库单满足您的需求',
  'hZ7k5Z': '分区价',
  '+1q99V': '复制失败商品编码',
  '+3E5ja': '商品编码/商品条码',
  '+Kr+Se': '超时未出库数',
  '+NQng8': '请选择进口国',
  '+QQt1w': '上传德语说明书',
  '+QVEe6': '最多支持500个查询',
  '+WN6K9': '将每个商品的德语说明书规范文件名称后，压缩为一个zip格式的文件，方可进行上传。',
  '+XkXdN': '注册重量{break}核实重量',
  '+Z+s/M': '注册中',
  '+lSrdL': '继续注册商品',
  '//OPe1': '化工产品',
  '/4CAvs': '仅限草稿、注册退回、更新退回状态才能提交',
  '/51T4K': '出口美国的商品受美国各个部门监管，对商品安全，标签，认证等要求严格，为避免商品运到美国后因此类问题导致退运或销毁，特提醒商家注意以下问题：',
  '/EyqOO': '正常未卸货数',
  '/SaZle': '当前商品对应类别无有效WEEE信息，请添加提交审核，且审核通过后再进行关联操作',
  '/jX11C': '是否包材商品',
  '/qfPiv': '商品包装',
  '/y/o6o': '请选择修改类型',
  '/yVpDb': '默认',
  '0J/EZT': 'Dscan及时率',
  '0mdRKn': '行号',
  '0oOC0x': '<strong>裸货</strong>：没有任何包装的货物。{break} winit不支持裸货出库，裸货请维护出库包装。{break} <strong>销售包装</strong>：商品出厂时带有的包装。{break}商品为销售包装，且为高货值，则不支持直接出库，请维护出库包装。{break} <strong>物流包装</strong>：商品的包装可支持出库。{break}商品为物流包装，则支持直接出库，可不维护出库包装。',
  '0wrGaG': '输入内容不能小于{min}个字符',
  '15n1gp': '行数',
  '1CVLEB': '模板填写数据太多？{a}',
  '1EETXi': '包材承重(kg)',
  '1WEaVW': '处理及时率',
  '1eOrvk': '快捷关联WEEE',
  '1fFSJC': '卸货及时率(不含异常)',
  '1l12Kb': 'WEEE注册号',
  '23GoDH': '共 {total} 条数据，失效后如果退货需要关联原SKU，则需要重新生效，请确认是否失效该商品',
  '2AAXee': '箱产品详情',
  '2KeuAm': '创建套装产品',
  '2LLzO1': '在导出文件中，修改需要更新的商品信息，选择标准模板导入并重新提交注册 <a>去提交></a>',
  '2Nufpg': '是否属于DG危险品',
  '2O5LA4': '批量失效',
  '2PBb7y': '无需原产地',
  '2Rvzhl': '对木制品及木制包装物熏蒸需提供熏蒸证书，特别是木制品需注意欧盟EUTR法规的尽职信息调查。',
  '2T9AV3': '共享库存',
  '2TXB25': '以下商品已经含有注册进口国：',
  '2TqpMq': '及时出库履约数',
  '2oCbSB': '带液体',
  '2zRAX7': '商品注册成功',
  '2zlu4l': '英国政府更新了将产品投放至英国市场的指南文件：{break} 1. 从2023年1月1日后进口到英国的UKCA标志领域涵盖的商品必须要有UKCA标，即替代了原有的CE标。{break} 2. 对于已经进口到英国市场的现有库存产品，不需要进行重新测试或重新做UKCA标识。{break} 3. 2025年12月31日之前，继续允许企业自主选择在产品本体的铭牌上或产品随附的文件上标识UKCA标志。从2026年1月1日起，只能在产品本体铭牌上进行标识。{break} 4. 对于从EEA之外的地区进口到英国的产品，仍然按照原先的规定，从2023年1月1日起，其进口商信息需要标识在产品本体的标签上。除非在产品尺寸太小或形状特殊而不允许的情况下，才可以接受标识在随附文件上。{break} 相关细节请查看英国官网链接：{url}',
  '3+8YgJ': '请输入预警天数',
  '3CpNmb': '电池防火标',
  '3UDwTJ': '套装/箱标准件数',
  '3emMvn': '辅助指标',
  '3m2zVX': '请根据所选择的批次属性提供示意图，需要能识别到属性信息在商品的具体位置，图片中需如示意图进行标识说明。后续Winit会根据提供的示意图查验商品信息。<red>最多上传1张图片，限制为5M以内的jpg,gif,bmp,png格式。</red>',
  '430sH9': 'DG危险品补充信息',
  '4Cyq/R': '预警天数',
  '4Jk7wc': '应履约数',
  '4cdhBz': '重要指标',
  '4mJLTr': '及时上架数',
  '57UMhM': '出口到英国带插头的商品必须是英国规格的插头且不允许配英规转接头。比如美规或欧规插头配英规转接头的那种商品，如被质量监管部门查到，只能退运或销毁。',
  '5BFAgi': '监管条件',
  '5BJFy9': '批量上传文件',
  '5M7Vly': '上传结果',
  '5QMQYr': 'WEEE信息需补充或更新？<a>去编辑</a>',
  '5vH5Pk': '超时未暂存数',
  '5yAzV3': '品牌名称',
  '64kzDB': '商品特性',
  '6DKIQa': '提示：若商品内无纸质说明书，则需要提供德语说明书链接，商品出库时将在面单上打印对应的德语说明书的链接，但该功能受限于尾程派送供应商，建议您尽快把德语说明书纸质文件添加到商品里',
  '6DlkQ0': '未出库数',
  '6M2O6P': '关联WEEE',
  '6ON040': '是否退货商品',
  '6Qu7pB': '维护箱产品',
  '6Y0p2/': '下一步',
  '7/jbov': '更新中',
  '73SuB6': '请在商品列表中筛选需要更新的商品，并选择按照标准导入模板形式导出或<a>下载导入模板</a>，填写商品所有信息后导入',
  '7KxUw1': '应卸货数',
  '7YEo3Z': '应暂存数',
  '7jl7uN': '更新商品批次信息',
  '7oy56p': '超时上架数',
  '7u24R2': '备注信息',
  '88Ahen': '待修改',
  '89eJ3z': '已填写其他信息，需选择国家',
  '8DMyyb': '如商品或包装贴UL, ETL以及EPA等标签，请提供相关的认证书的复印件，一旦查货无法提供相应证书，会因侵权而遭到退运或销毁。',
  '8FC2V+': '箱内标准件数',
  '8K9huq': '打印数量',
  '8KQe8R': '德语说明书类型',
  '8chdAt': '年',
  '90BZso': '更新商品出/入库包装信息',
  '9HPrzg': '最多支持500个商品编码/商品条码/第三方编码',
  '9Kfyp/': '失效后如果退货需要关联原SKU，则需要重新生效，请确认是否失效该商品',
  '9Rk5ct': '(包括易碎品标、仅限上货机标、限制出口、仅限陆运、正面朝上标)',
  '9VJr3i': '请输入大于0的数，最多保留2位小数',
  '9l1yrc': '失败原因',
  '9q5iFF': '产品分组',
  'A6gWi0': '错发出库数',
  'A94SDx': '旺季加收旺季附加费',
  'AIm0ow': '上传SOP',
  'AM5ZYU': '图片格式限制为jpg,gif,bmp,png',
  'AOBoNV': '此套装产品内含x件单一产品',
  'AXD5yi': '待补充',
  'AcRVLv': '若需要采集包裹码则会在出库环节进行采集，出库单信息支持查询，前提是需要保证实物包裹上存在包裹条码！',
  'AcfqYm': '电池重量(kg)',
  'Aoiung': '您暂未设置偏好，请在[个人中心-偏好设置-商品偏好]中设置相关信息。设置后，点击隐藏偏好信息，则已设置偏好的信息将自动隐藏',
  'Aqtj8n': '打印商品条码',
  'AroxgK': '删除结果',
  'AsN7cg': '超时Ascan数',
  'B13gcH': '<strong>单品化管理：</strong>一物一码。售卖的单个商品都只有全局唯一的一个单品条码。{break}<strong>商品化管理：</strong>一类一码。同一个SKU所有的单品都是相同的商品条码。',
  'B7br4z': '禁售天数',
  'B8xiJD': '带插座',
  'BC74I9': '提示信息',
  'BFz2A6': '当前进口申报价格较高，可以在投保商品管理模块对该商品进行投保，投保的商品在库内会提供更精细化管理',
  'BKKHqg': '注册长*宽*高(cm)',
  'BY90Z8': '保障商品价格的真实性；对于故意夸大或者降低申报价值的，贵方应自行承担相关商品损失（如海关扣货等）以及给万邑通造成的直接和间接损失（包括但不限于销毁费、运费、律师费、政府罚款）；',
  'BfWmDr': '补充资料',
  'BgiBV1': '需注意事项：{break} 1. 用木制容器装运的货品必须附有熏蒸证明书，证明符合检疫规定；{break} 2. 澳洲订有规例，禁止生产、进口及销售含有致癌物质、石棉材质的服装及消费品。{break} 3. 燃油类的商品（发动机、割草机、链锯等），需要有以下相关认证（EPA、CARB、97/68/EC或澳洲产品豁免号，以上的其中之一），否则有罚款召回风险。',
  'BhoBfm': '超时暂存数',
  'Bkg7uQ': '主指标',
  'Bm5GdP': '中国台湾',
  'Bue+Ip': '查看并使用《个性模板》',
  'C4HPJc': '上传成功',
  'C5ShJS': '保存草稿',
  'C5uin2': '更新进口国出口申报价值',
  'C7Cq4t': '美国商品公告',
  'CJA3gl': '请选择出库包材类型',
  'CN+A8h': '是否共享库存',
  'CNKrTB': '请选择商品负责人/欧代信息',
  'CbJiR0': '箱产品包装',
  'CcGGyt': '请先选择国家/地区',
  'CgkufA': '将按照以下商品特性生成个性模板，导入需填写符合特性的商品，不符合会导致注册失败',
  'Ch3B3M': '共 {total} 条记录，成功启用 {successCount}',
  'ChzSZX': '修改电池资料',
  'ClROa7': '文件最多上传{maxCount}个，大小限制50M以内，格式限制为jpg,jpeg,png,pdf',
  'Cwym4h': '批量提交',
  'D5ZkQe': '新增第三方商品条码',
  'D6Hvvx': '电池能量WH=电池容量AH*电池电压V',
  'DWpV38': '未处理数',
  'DiLA5q': '当前已选择 {num} 个商品，请选择需要新增注册的国家',
  'E2kRYi': '批量启用',
  'EFPHaV': '卖家直发',
  'EVTQjd': '上传实物批次信息示意图',
  'Ebnrof': '如您选择添加欧代信息，则标签将带有已关联的欧代信息；如不选择则不会带有。',
  'F3ndvv': '删除失败',
  'F7X0fu': '导出所有商品信息',
  'FKf3GC': '请输入原产地',
  'FMPuj8': '商品列表',
  'FRtCeT': '退回',
  'FTG2vb': '商品负责人名称',
  'FbM2/d': 'Excel批量导入',
  'FetaMe': '澳洲商品公告',
  'G22f+9': '《德国生产者责任延伸包装法》已于2022年7月1日实行。法规要求将包装好的商品销往德国的卖家需通过德国中央管理机构"Zentrale Stelle Verpackungsregister" "进行注册获得LUCID号码，申报对应商品包装的体积和类型等信息并缴纳相应的费用，同时法规也明确履约服务提供商以及电商平台不得为没有按法规要求注册的卖家提供服务。',
  'GDFkBa': '英国进出口和税收属同一个部门监管（HMRC），以及实行的英国尽职调查法规和平台代扣代缴，为商家长远发展考虑，建议用自己的公司名称和英国的增值税号(VAT)和进口备案号（EORI）作进口。',
  'GTt01+': '商品链接',
  'GdNyZk': '出口申报价值(USD)',
  'H/vKxr': '确认重量(kg)',
  'H7BeZD': '出口国家/地区',
  'HIRKi3': '维护套装产品',
  'HMxZwz': '资料类型',
  'HWUi9z': '出库包装信息',
  'HnsXky': '无限制',
  'HxgJs9': '根据《市场监管法规（EU）2019/1020》的要求，自2021年7月16日起，带有 CE 标志并且是在欧盟境外制造的商品，需确保此类商品含有真实有效的欧盟责任人信息以及对应国家语言说明书。在法规生效后，在欧盟销售带有 CE 标志的商品但没有欧盟负责人属于违法行为。',
  'I0f7tt': '确认删除吗？',
  'I4GWHd': '及时Dscan数',
  'I7cmTD': '商品属性',
  'INWrne': '商品携带标签',
  'IzXisV': '套装产品包装材质',
  'JGDWfH': 'Ascan及时率',
  'JILwsB': '操作日志',
  'JO4DwF': '对于物品的描述，不能是gifts这样的模糊字眼，可能会导致清关障碍。为了确保顺利清关，需提供具体详细的没有歧义的商品说明。',
  'Jalqk9': '若发现申报信息与实际信息不符的商品，万邑通保留不予提供服务的权利。',
  'Jddr2L': '英国海关禁止进入的商品: 所有仿牌假牌物品、认证或标识不齐全的商品，英国海关可能追究法律责任。',
  'JvOkw0': '商品包裹类型',
  'KIwL6G': '及时出库数',
  'KLNwDD': '文件格式限制为jpg,jpeg,png,pdf',
  'KRVF+S': '请输入打印数量',
  'KVd/IG': '确认长*宽*高(cm)',
  'KYjz/l': '请输入大于0且最多保留两位小数的数值',
  'Keyqza': '请选择原产地',
  'KrHmK0': '请选择商品负责人/欧代信息：',
  'Ksh8H4': '正常未上架数',
  'LRuQNL': 'WEEE类别',
  'LWSLHa': '温馨提示',
  'LxCyKX': '请上传',
  'LzaEIM': '去查看',
  'M+7kjk': '去设置偏好',
  'M0LDIV': '批次属性',
  'M1h6SK': '入库商品包装信息',
  'MJZFFa': '商品管理方式',
  'MPh7VW': '{num} 个草稿商品，已录入完整信息待提交审核',
  'MTpHsb': '维护包材信息',
  'MUuzgH': '进口后海关会有3年追诉期，为避免海关后期发现低报而产生的补税和罚金，建议进口申报价值如实申报。',
  'Mke7E0': '为商家长远发展考虑，鼓励卖家用自己的公司名称的增值税号(VAT)和进口备案号（EORI）进口。',
  'MllGRu': '头程类型',
  'MmmpSu': '去查看>',
  'MqnPY2': '标准箱宽(cm)',
  'MrgM6t': '导出商品全部信息',
  'Mwk+U+': '出库错发率',
  'MxBCpe': '下载错误数据',
  'MxxEYf': '收起',
  'MzuCgp': '进口申报价',
  'N6tEuo': '选择注册进口国',
  'NGs9sO': '返回',
  'NIfhB7': '未选择商品，请到商品列表重新选择',
  'NMg99l': '是否启用条码值库存',
  'NOtdIq': '上传说明书',
  'NUN0tG': '新增成功',
  'NXKJ/G': '包材尺寸(cm)',
  'Ndc8Tz': '{successCount} 个商品已成功删除',
  'NnaTvD': '绑定负责人',
  'NoURe9': '资料状态',
  'Nw3DyH': '请确保商品不出现任何侵犯知识产权的图案或说明，包括版权、外观专利、知名商标。',
  'O1baSg': '注册重量(kg)',
  'O5zQhu': '是否启用批次',
  'OA/GYS': '是否采集包裹码',
  'OnimtZ': '注册长*宽*高{break}核实长*宽*高',
  'OoH4Vn': '已完善',
  'OzxoGd': '出库包装修改',
  'P3OlMG': '请先选择进口国家/地区',
  'PAR7vC': '进口关税和GST计算：进口关税按货品在装运港的船上交货价征收，商品服务税（GST） 按CIF价征收，进口申报价格必须按公平交易价格申报，如申报价值过低引起澳洲海关查验，以及引起的补缴关税，相应的罚金以及其他损失，我司有权进行追索。',
  'PKJshZ': '请输入大于0的数，最多保留4位小数',
  'PMnXeY': '待提交',
  'PUESE0': '{successCount} 个商品已成功删除，失败 {failCount} 个，失败原因：',
  'PjkNQN': '英国商品公告',
  'Q37+lZ': '请输入保质期',
  'Q7MQdK': '原产地',
  'QCshfb': '为避免商品运到英国口岸后因各种问题导致退运或销毁，特提醒商家注意以下问题：',
  'QUFY6d': '进口后HMRC会有3年追诉期，为避免HMRC后期发现低报而产生的补税和罚金，建议进口申报价值如实申报。',
  'QdYQx3': '为避免商品运到德国口岸后因各种问题导致退运或销毁，特提醒商家注意以下问题：',
  'QpxSsT': '及时ATTscan百分比',
  'QuQaaA': 'UN编码',
  'QxhxD9': '周一~周五{break} 00:00-12:00提交，当天18:00前审核完毕{break} 12:01-24:00提交，次日(自然日)11:00前审核完毕{break} 周六~周日{break} 周六00:00-12:00提交，当天16:00前审核完毕{break} 周六12:01-周日24:00提交，周一11:00前审核完毕{break} 法定节假日{break} 次日(自然日)24:00前审核完毕{break}',
  'QxzrbX': '商品保存草稿成功',
  'RFLMGm': '标准箱重量(kg)',
  'RSl8E8': '指定包材SKU',
  'RrD1hw': '中文名称/英文名称',
  'RtFK89': '目前一口价仅支持美国，平台为Ebay和Tiktok，敬请期待其他国家（开通一口价权限请联系客户经理）',
  'S25bPA': '正常未出库数',
  'S2Dp+M': '此告示上未穷尽所有可能引起海关退运或销毁的情况，仅就经常出现的问题进行陈述，如因以上及未提及的事件且非我司的原因引起的损失，我司将有权进行追索。',
  'SBagFp': '快捷打印条码',
  'SCsxgT': '请输入禁售天数',
  'SFGJw1': '当前商品提交的修改信息正在审核中，请在更新中查看待审核的商品信息{a}',
  'SGXH2R': '进口国家/地区',
  'SX//Dm': '批次管理类型',
  'Seke8U': '正常未处理',
  'StEQQQ': '应Ascan数',
  'T6gsxx': '您选择的国家目前暂不支持尾程渠道发货，请下载具体系统报价确认支持的国家',
  'TPXs+A': '及时Ascan数',
  'TedMK6': '此SKU必须保证随货携带纸质德语说明书',
  'TroLmA': '德国海关禁止进入的商品: 所有仿牌假牌物品、认证或标识不齐全的商品，德国海关及当地执法部门严查该类商品，除面临商品召回外，还可能追究法律责任。',
  'TsDnUk': '隐藏偏好设置',
  'U9ILfl': '上架及时率(不含异常)',
  'UH3LUp': '责任人公司名称',
  'UKk9aQ': '请输入大于0的正整数',
  'UOhShp': '电池包装',
  'UQkIe2': '生成个性模板',
  'UaXAnK': '商品出库/入库受限，请及时处理',
  'Uf/d6B': '正常未Ascan数',
  'Ura5sN': '仅支持维护已发布商品',
  'VHPbrK': '核实长*宽*高{unit}',
  'VJMEti': '文件数据校验完毕',
  'VKV22J': '启用结果',
  'VbRKGW': '批量新增进口国',
  'VppX7w': '正常未出库履约数',
  'W+R6B3': '补充/确认进口国信息',
  'W01wC8': '商品长(cm)x宽(cm)x高(cm)',
  'WAfyY4': '进口申报价值(USD)',
  'WGAE7N': '应处理数',
  'WQyw5k': '立体内径尺寸(cm)',
  'WaaLFK': '德国相关网站供参考{break}德国反倾销反补贴的查询网址：{url1}{break}{url2}{break}德国生产者责任延伸包装法：{url3}{break}市场监管法规（EU）2019/1020：{url4}',
  'WdQS7N': '此告示未能穷尽所有可能引起查验、退运或销毁以及在澳洲海关可能出现的情况，只就常见问题进行陈述，如因以上及未提及的事件且非我司的原因引起的损失，我司将有权进行追索。',
  'Wdmil2': '展开',
  'X1F+7G': '提交失败，请修改后重新提交',
  'X5Wxae': '展示偏好设置',
  'XFd0Fa': '箱产品包装材质',
  'XGMo7a': '超时未出库履约数',
  'XJFtiF': '带三合板或高密度板',
  'XnL5tl': '二手商品',
  'Xp/Q3h': '请选择商品管理方式',
  'XqPll/': '德语说明书要求',
  'XuoVmX': '套装产品信息',
  'XxHAs0': '商品数量',
  'Y/0R7Y': '套内标准件数',
  'YKwdXz': '退回原因',
  'ZFM0cj': '链接审核状态',
  'ZVh7Di': '模板填写数据太多？推荐使用个性模板',
  'Zfm4bD': '选择批次属性后，则下入库单需要提供对应的批次信息，验货将会按此属性核验商品批次信息［入库批次管理除外］，后续仓库则按照批次属性进行库内操作及存储。',
  'ZgRLsG': '进口申报价必填',
  'ZmT1uG': '高货值(收费有差异)',
  'ZqCedb': '已上传',
  'ZvZ3JO': '电子电器类商品要符合WEEE(EAR)的规定, WEEE所涵盖的商品列表见以下网址，确认自己的商品是否需要注册WEEE(EAR)，如不按要求注册最高罚款20万欧元。{url}',
  'aDf3/y': '是否有过敏原',
  'aJTjri': 'Winit头程产品：{productName}',
  'aMjKQb': '单个新增',
  'aO1LOt': '第一步',
  'aXTw6o': '未知，请检查模版或导入数据是否正确',
  'acIqwr': '型号',
  'afAy25': '出库包装类别为“Winit标准包装”时，如果“出库包材类型”不指定，Winit将按快递袋-气泡袋-纸箱优先顺序自动匹配合适的包材',
  'ahaefV': '中国',
  'ahiPbf': 'SKU编码',
  'aveTGO': '错误提示',
  'ax2mk0': '{text}',
  'b7E1fz': '请选择你需要导出的商品',
  'bW7xAs': '是否入库',
  'bi+JOO': '距离失效日期还有【x】天时禁止提交标准出库单，避免买家收到商品时已过期。',
  'c2fUse': '修改类型',
  'cGY0iX': '请输入注册重量',
  'cJNSDx': '查看分区价',
  'cNVhxt': '批量更新高货值',
  'cQYNoa': '第三方商品条码',
  'cSHhM6': 'UN标签-电话号码',
  'cTA59M': '超时未卸货数',
  'cYYpNG': '电池种类',
  'cfjOFN': '出入库包装信息',
  'cqZp4l': '超时未Dscan数',
  'cuPSNv': '箱产品信息',
  'cul60h': '核实长*宽*高(cm)',
  'd3ABzd': '应ATTscan百分比',
  'dOQj0E': '商品重量(kg)',
  'dadBln': '超时出库履约数',
  'dqi2SA': '{successCount}个商品已成功提交，失败 {failCount} 请先完善商品信息再提交审核',
  'dsW/zv': '正常未Dscan数',
  'e4q896': '批量绑定负责人',
  'eCjyf7': '正常出库数',
  'eDxwA7': '批量更新商品链接',
  'eNioNS': '授权成功',
  'eRBGSf': '暂无数据，点击下方新增',
  'eUSpdN': '查看更多',
  'eef6wN': '注册重量{unit}',
  'f3GjX/': '请输入2~999的正整数',
  'f9f9Kr': '尺寸重量信息',
  'fKfc8J': '待办提醒',
  'fmBsCH': '操作内容',
  'foXtVC': '商品状态',
  'fr8qvK': '文件上传成功，请等待数据校验结果',
  'fwQPTM': '失效结果',
  'g+vrQp': '入库包装全部无以下标签',
  'g+xiOs': '对木制品及木制包装物熏蒸需提供熏蒸证书。',
  'g/fKXQ': '万邑通{break}2022年8月',
  'g8RPWw': '当前商品提交的修改信息已被退回，请及时处理{a}',
  'gGMGjZ': '注册长*宽*高{unit}',
  'gLHALd': '食品',
  'ggvI6Z': '全选',
  'glaaIG': '错误原因',
  'gyQd//': '超时未上架数',
  'gzYOOP': '{icon}您注册的商品会在{time}内尽快维护完毕，请耐心等待～',
  'h53sPj': '超时未处理数',
  'h6p1Q+': '开始日期',
  'h7w4pz': '暂无数据',
  'h8bTqV': '未上传',
  'hElHo2': '打印欧代信息',
  'hShFQM': '批量修改',
  'hYEDUA': '商品链接或图片需与实物完全一致，且该信息能展示出该商品的商标、材质、功能等信息，以便万邑通对该商品进行归类审价；',
  'heSp6Q': '绑定商品负责人',
  'hk5FKM': '包材商品',
  'i4tQ/S': '输入内容不能大于{max}个字符',
  'i5Q88U': '退货商品',
  'i5rp4m': '全部不带电',
  'iC7OaE': '创建箱产品',
  'iCg2nh': '为了提高注册效率，请您先在[个人中心-偏好设置-商品偏好]中配置商品偏好',
  'iUcoKw': '全部无品牌',
  'ixHwoW': '更新商品信息（通用）',
  'iyu8lU': '关联WEEE信息',
  'j2i5Dm': '此告示书上未穷尽所有可能引起海关退运或销毁的情况，仅就经常出现的问题进行陈述，因以上未提及的情况且非我司原因引起的退运和销毁事件导致的损失，我司将有权进行追索。',
  'j3YsUm': '如您电商清关，请确保您提供的售卖链接有效期保持最少2个月以上，如因售卖链接失效导致的清关失败，会影响您的清关时效。',
  'j94Rtp': '请输入数字、+、-，不允许有字母，支持24位',
  'jCHgBE': '未暂存数',
  'jCOU5w': '进口申报信息',
  'jPqtQS': '带电池',
  'jb+IKU': '仅支持标签纸打印，单次打印不得超过5000个。',
  'jd+iFu': '海关建议申报价值(USD)',
  'jl8oxj': '货型',
  'k84DAN': '仅限草稿、注册退回、更新退回状态才能删除',
  'kCh5Jz': '提示',
  'kS4Jbz': 'ATTscan率',
  'kX1Ecr': '证书',
  'l5jvRO': '入库包装信息',
  'l6bu0+': '保质期',
  'lCxJRw': '及时处理数',
  'lHoE+P': '批量添加第三方商品条码',
  'lIIML6': '<strong>保质期管理：</strong>按商品批次的失效时间，先失效的先出库，支持近有效期的批次进行预警和禁售。商品有保质期。{break} <strong>生产批次管理：</strong>按商品批次的生产时间，先生产的先出库。商品无保质期。{break} <strong>入库批次管理：</strong>按商品批次在海外仓的入库时间，先入库的先出库。商品无保质期。',
  'lSx3mU': '带磁性',
  'laZwLw': '此箱产品内含x件单一产品',
  'loyE8B': '超时ATTscan百分比',
  'lqnHUQ': '失败 {failCount}，失败原因：{reason}',
  'lrwsA+': '没有选择要打印的条码',
  'lzaCiy': '未上架数',
  'm8y8Ah': '资料证书',
  'mM9rak': '未卸货数',
  'mMJovn': '新增证书',
  'mMoNpI': '核实重量(kg)',
  'mN/UxY': '<strong>电池芯：</strong>电池只有一个电池芯，或者多个电池芯但没经过串联或并联封装{break} <strong>电池组：</strong>由两个及以上的电池芯串联或并联封装组合{break} <strong>例如：</strong>多个18650电池组合的移动电源，选电池组；多个18650电池但没有串联/并联，仅多块包装销售，选电池芯',
  'mNrNBK': '应出库数',
  'mRshYx': '仅支持zip格式的压缩包',
  'mU2j8v': '批量上传德语说明书',
  'mgCZHX': '未Ascan数',
  'mkAC6d': '超时未Ascan数',
  'mnE1nk': '距离失效日期还有【x】天时进行邮件提示，便于及时调整该SKU该批次的销售策略。',
  'nDwIwd': '已发布',
  'nHRaHR': '打印单品条码',
  'nIRket': '请拖拽或点击上传文件',
  'nJIJx6': '查不到该商品数据，请确认该商品是否存在！',
  'nL/cut': '新增进口国',
  'nUqM8t': '去提交',
  'nVqR0D': '德国商品公告',
  'naZmU6': '带原木',
  'nn8pTx': '提交成功，请等待工作人员审核',
  'nr36zQ': '免仓租',
  'oHUyJP': '更新商品包裹类型',
  'oIsUki': '支持doc格式或者pdf格式，限制10M以下',
  'oRsWj6': '规定时间',
  'od3FGh': '涉及到CPSC（消费品安全协会）的商品，如玩具等商品，需有CPSC指定检测机构出具的测试报告，商品还需按要要求贴有对应的标识，详情请查看以下链接：{url}',
  'ohFmwm': '超时处理数',
  'oiMpRX': '依据当地服务规定，UN标签需提供相应的联系电话。{break}示例：+86-12311112222；',
  'ozUGJe': '套装产品形状',
  'p56EUO': '更新商品携带标签信息',
  'p7fE35': '电池能量(WH)',
  'pIQ+WJ': '超时Dscan数',
  'pYzaIX': '禁止入库',
  'peveA/': '下载个性模板',
  'pkIYyv': '标准箱高(cm)',
  'pzGkXS': '数据已删除，可能会导致未完成的国际送仓单（不含全球送整柜）无法操作，请知悉',
  'pzwZ9y': '电池芯/电池组',
  'q0mwSH': '示例图',
  'qAVsY3': '支持针对勾选的商品批量更新商品信息',
  'qF98LW': '单次最多可导入500条数据',
  'qUKj7E': '复制',
  'qb91VW': '应Dscan数',
  'r1Qtd7': '全部不加包装',
  'r2gvAb': '导入结果',
  'r2imrW': '海关会与质量监管部门一起查验商品质量是否符合相关标准，请确保所有去德国海外仓的商品都必须符合德国政府部门的规定，一旦海关或当地质量监管部门查验，必须能够立即提供与商品一致的，真实有效的CE证书或其他政府部门要求的相关证书，否则由此导致的扣货、罚款等责任，由客户承担。',
  'r3V/O0': '金融商品',
  'r6h3uT': '操作失败',
  'rFlDQ6': '未Dscan数',
  'rG82gu': '出口申报信息',
  'rLn5dB': '查看明细',
  'rMMK/m': '导出当前商品列表信息',
  'rOhC+k': '根据澳洲政府公布的进口要求，澳洲进口的商品必须贴有对应的英文商品标签（品名、品牌、型号、厂家信息、成分、商品描述、原产地等），如海关查验发现商品缺少英文商品标签，可能面临没收商品以及罚款。详细通知请参考官方链接：{url}',
  'rXzI0V': '请选择包装类型',
  'rd4gqB': '第二步',
  'ri851W': '不再提醒',
  'rkOwDC': '{successCount}个商品已成功提交',
  'rnq3gI': '去授权',
  's+FI1a': '请选择包材类型',
  's3uVOZ': '压缩包内文件名规范：商品编码&&&规格',
  's8V1Ln': '带粉末',
  's9IA1X': '上架及时率(含异常)',
  'sHviTp': '上一步',
  'sNTEDM': '模板数据共 {totalCount} 条，导入成功 {successCount} 条，失败 {errorCount} 条',
  'saZBsM': '涉及医疗器械的商品，美国强制需要FDA注册证书。',
  'saeFbf': '文件',
  'sgy8n9': '未履约数',
  'snEEkg': '单次最多可导入500条数据。{a}',
  'sy8edt': 'Excel批量修改',
  't8Teof': '已勾选 {num} 个条码，单次打印总条码数不得超过5000个',
  'tJx4Tw': '标签尺寸',
  'tgduNy': '重复选择证书',
  'tgzh55': '全部非食品',
  'th2jmN': '批量打印条码',
  'twj8Sm': '过敏原',
  'u1qllb': '图片大小限制5M以内',
  'u98d/e': '按导入标准模板中所需的信息导出',
  'uDKUFd': '已发布的商品若修改需要审核信息，则需等审核通过后才会更新商品信息',
  'uFoVy0': '已失效',
  'uKB+1J': '应上架数',
  'uNCf4c': '卸货及时率(含异常)',
  'uNolam': '进口地',
  'uabkfT': '共 {total} 条数据，成功失效 {successCount}',
  'uiTJW+': '超时卸货数',
  'undBgZ': '英文名称',
  'uqDSio': '各国公告',
  'uqU3/A': '套装产品包装',
  'v+rZz+': '请选择说明书类型',
  'vG+1rL': '文件大小请勿超过50M，请压缩后上传',
  'vHFAJd': '商品形状',
  'vOYTyV': '异常数',
  'vP5CrI': '根据当前商品列表展示信息导出',
  'vSerbC': '进出口申报信息',
  'vbDYzP': 'WEEE类型',
  'vg5G1j': '标准箱长(cm)',
  'w/VsZL': '统计单位',
  'w1cMGO': '结束日期',
  'w9U47g': '编辑套装产品',
  'wIiCxn': '确认重新启用该商品吗？',
  'wJ4QYJ': '请输入包材承重',
  'wRcMxY': '商品负责人/欧代信息需补充或更新？<a>去编辑</a>',
  'wY0zTb': '编辑箱产品',
  'wcogSJ': '点击下载《标准模板》',
  'wd6jjx': '正常未暂存数',
  'wp3dhe': '确认重新启用这些商品吗？',
  'wz0mVq': '没有错误数据',
  'xADAFC': '及时卸货数',
  'xB2mDj': '所有外包装上一定要有产地标志，如确认是中国制造，一定要有“Made in China”标志。',
  'xGotZu': '该链接审核状态仅适用于一WINIT承运-德国&英国递延和电商清关,其他产品不受影响。',
  'xLTrlY': '商品注册审核结果不代表商品在通关、运输和仓储中无风险！{break}因商品自身或信息有误引起的包括但不限于商品通关、贸易、侵权和质量等责任和纠纷, 需由客户自行承担，感谢您的理解和配合~',
  'xQYCD1': '若开启共享库存，出库时无需指定SKU类型及标准库存SI件数，Winit系统将按出库单中单一产品需出库总数自动分配',
  'xeApVG': '待提交商品',
  'xjFUOB': '注册进口国',
  'y1/0I4': '18+',
  'yG4nnB': '导出失败商品条码',
  'yMlPtn': '套装产品详情',
  'ybIMxw': '商品提交成功',
  'yz3gHz': '商品保存成功',
  'z+8yDs': '及时暂存数',
  'zCjZBU': '立体外径尺寸(cm)',
  'zFDcg6': '导出列表同标准模板，支持修改后通过excel导入更新',
  'zG8yxE': ', 失败 {failCount}，失败原因：',
  'zI1Wyd': '出库加包装信息',
  'zf0KBc': '修改完成',
  'zubwCo': '超时出库数',
  '0bGJDI': '带电',
  'NoTiXs': '非食品',
  'PmAk6c': '仓储总体积=单个商品体积 （单个商品体积＜{n}m³，则按{n}m³）* 库存数量',
  'YVWUH+': '商品个性模板',
  'cLPzLe': '有标签',
  'ceUK9M': '无标签',
  'ipVi6y': '加包装',
  'mdJrUd': '仓储总体积＜最小仓储体积{m}m³，则按{m}m³计算仓租费',
  'rghOE1': '不带电',
  '4jxBkZ': '超时ATTscan数',
  'fVUxJR': '应ATTscan数',
  'hWDK0B': '及时ATTscan数',
  '3MEyqn': '货物从国内哪个城市发出？',
  '8Gf88Y': '您未提交资料，此功能暂不可查看',
  'E2NwYO': 'Dscan平均耗时(工作日天数)',
  'EHTOHW': 'Ascan平均耗时(工作日小时)',
  'FTAz9m': '核实重量{unit}',
  'rl4uyx': '请先创建商品，商品审核通过后才能创建入库单',
  '0GibQM': '增加头程运输费用',
  '10k6dI': '配送订单的商品数量',
  '5BwsBi': '国内仓发货至海外仓',
  '9kZAq1': '预估',
  'EPXw7D': '特货',
  'Krteov': '仓储费用',
  'RisHP+': '旺季会增加旺季仓储附加费',
  'TZpo1e': '履约费用总览',
  'ZA2DsJ': '头程运输费用',
  'aFUwPf': '指定服务价格查询',
  'h20CZ1': '一口价预估',
  'mYmfrE': '预计海外仓存放时间',
  'ng05bx': '一个买家订单内购买的商品件数',
  'r+WXwG': '国内发货城市',
  'xWwXLV': '普货',
  'Dq/R41': '若单件商品体积<{m}CBM，则按{m}CBM计费',
  'BR35ri': '出库类型',
  'Mk43Ju': '此结果是根据输入参数测算的海运-运输费/空运-运输费，实际以下单为准!',
  'OWX7o9': '商品在哪个国家履约？',
  'VYvc1A': '一个买家订单端到端的履约预估成本',
  'iDWfFc': '订单派送时效',
  'mR4Z9G': '履约费用试算',
  'nw+1Hz': '尾程派送订单的商品数量',
  'vGNlLD': '已授权，请在平台查看信息',
  '1RASRC': '您输入的尺寸信息暂未匹配到头程产品，请您下载报价查看或联系客户经理解答',
  '2UAyc8': '履约时效: {start}-{end}工作日',
  'A+bKfm': '厘米/公斤',
  'C0sWNj': '是否变更成“{sizeType}”测算？',
  'PpG3NC': 'Winit头程运输费用',
  'U50aCL': '快速创建入库单',
  'WpcAaR': '您输入的尺寸信息暂未匹配到尾程产品，请您下载报价查看或联系客户经理解答',
  'kLR3/1': '此费用仅为试算费用，具体消费情况以实际发货为准',
  'noAe6D': '预计海外仓存放时长',
  'rD/rqe': '费用合计',
  'sYWXZa': '如果您需要根据确定的地址计算尾程费用，请点击“指定服务价格查询”填写具体地址进行计算',
  't3l5ML': '英寸/磅',
  'xpf5RE': '您输入的尺寸信息暂未匹配到仓储费用，请您下载报价查看或联系客户经理解答',
  'g8S3b2': '以上费用未包括出入库处理费',
  'wbTQL5': '单个订单支持最大配送商品数量在10个以内，请您输入正确的数量',
  'aUe2XA': '高级设置',
  'bQuDUJ': '仅限草稿、注册退回状态才能删除',
  '29YcX4': '指国内至海外仓的运输费用，如使用Winit承运的头程服务请勾选此项',
  '9UxuCd': '测算仓库',
  'C9yrox': '履约国家',
  'F3YP+/': '请注意：旺季会额外产生旺季附加费。',
  'bkBXOL': '我要精确计算费用',
  'iBahRB': '以上试算费用仅供参考，实际费用以系统扣费为准。',
  'yo4o7l': '如需指定产品或收件地址计算履约费用，可点击此链接跳转查询。',
  '0WBg0k': '入库处理费',
  'VTxBYV': '商品超出尺寸/重量限制，请重新填写。{lengthMin}{sizeUnit}≤长≤{lengthMax}{sizeUnit}，{widthMin}{sizeUnit}≤宽≤{widthMax}{sizeUnit}，{heightMin}{sizeUnit}≤高≤{heightMax}{sizeUnit}，{weightMin}{weightUnit}≤重量≤{weightMax}{weightUnit}，{densityMin}kg/m3≤密度≤{densityMax}kg/m3',
  'G80Yfa': '已包含出库处理费',
  'hrDPjg': '已包含出入库处理费',
  '/mrUV7': '自定义',
  '0CBIls': '自定义仓组名称',
  '2kWiny': '自定义仓组编码',
  '6CwNwM': '上传至草稿',
  '8g7PU8': '新增产品组',
  '9pc1MK': '发货优先级',
  'Bl3B+J': '产品优先级',
  'D/Yid+': '是否启用',
  'HUgTwr': '必须选择其中一项',
  'Izo8nC': '买家分区',
  'KhGQV1': '单仓发货策略',
  'LTEd2f': '入库',
  'N33pTc': '新增仓组',
  'Ob9vJt': '产品组列表',
  'P0bLNx': '订单批量上传设置',
  'PtFTAG': '允许多仓发货',
  'QCXk/g': '是否启动',
  'U5iN47': '发货策略',
  'VaPlbo': '产品组名称',
  'Vo+Xz7': '产品组编码',
  'WcSEBf': '禁止同一个SKU拆多仓',
  'a7KRmz': '上传至已提交',
  'g912oq': '进出口商配置',
  'hT7MT5': '多仓发货策略',
  'izS7og': '标准',
  'jw88JB': '新增产品',
  'n0YiRc': '仓组信息',
  'ncq348': '优先级',
  'pQfHnF': '智能推荐配置',
  'xKEYMt': '编辑产品组',
  'ywJMgk': '类别',
  'zthu91': '产品',
  '/dtKXK': '输入内容不能超过128个字符！',
  'A+/0HA': '选择的产品存在重复',
  'EzNenN': '取消启用此仓库，您已选择的产品组[产品组名称]下产品[产品名称]将不支持推荐，系统将自动删除此产品，请确认是否停用？',
  'P6bkBi': '取消启用此仓库？',
  'QLbJkZ': '仓组编码',
  'XuDX2o': '暂无数据,请',
  'myrfJ/': '切换到其他国家，需要重新选择产品分组，系统将清空已选择的产品分组，请确认是否切换？',
  'pDx3hV': '请选择产品',
  'qZrzit': '未添加产品',
  'rn5AwM': '请先启用仓库',
  'w3pzFa': '此产品编码已经被使用',
  'EMppKo': '产品组[{productGroupName}]下产品[{productNames}]',
  'LtGXYt': '您选择的产品{productName}在产品组{productGroupName}里面已存在，请修改后再保存{brack}',
  'o+GSTm': '您输入的产品组编码已存在',
  'oCeXGU': '取消启用此仓库，您已选择的{content}将不支持推荐，系统将自动删除此产品，请确认是否停用？',
  'rtNipg': '取消启用此仓库，您已选择的产品组下产品将不支持推荐，系统将自动删除此产品，请确认是否停用？',
  'XzxeM5': '搜索产品',
  'wI4k/a': '仓组列表',
  'VJr0ui': '计费重(KG/CBM)',
  'B1xc4D': '账户名称',
  'HoBJEe': '账户ID',
  'ZQATNs': '单据类型',
  'hzo2kV': '业务单号',
  'dsROvR': '交易日期',
  'vYbdwI': '交易类型',
  'er7lkB': '金额',
  'IAXzUL': '下单/仓租日期',
  'ZmP5ua': '主单号',
  '9yrgtf': '卖家订单号',
  '7hnqmZ': '包裹号',
  'I0+bNm': '目的仓',
  'zKjr6y': '产品名称',
  'qJKFfY': '目的国',
  'P/iomR': '物流分区',
  'e53tsC': 'SKU及数量',
  'MwjxBM': '重量(KG)',
  'nmj+AS': '计费方式',
  // '8ScwNO': '如需查询和导出12个月以前的历史数据，请联系在线客服。',
  'IqkgWZ': '关键字',

  'I7bO+W': '可用余额合计(USD)',
  'qGJjK8': '已担保还款金额(USD)',
  'ac+1ZB': '可用余额(USD)',
  'WPtJUd': '汇率(转USD)',
  'jWa321': '可用余额',
  'Gs6y7L': '冻结金额',
  'AkjhOp': '账户余额',
  'D/ycuA': '付款',
  '6XUyoX': '冻结明细',
  'KZsciT': '购汇/转入',
  'VJ35lD': '最后还款日',
  'r+gAzL': '已出账单的未还清金额按每天浮动汇率统一转美元展示，由于每天汇率变动及还款方向所用汇率不同，此金额仅供参考。实际还款请参照还款预估的待还金额。',
  '7RhTil': '账单预估待还金额(USD)',
  'j41fsS': '去还款',
  '+CjwvP': '还款评估',
  'lR08XW': '可下单金额',
  'BV7zhA': '点击查看',
  'ehedRS': '个账单待还，请在最后还款日前及时还款，若未及时还款，按逾期日利率',

  'oi8wFv': '可下单金额USD',
  'rtyTG2': '账户内可用于下单的金额（按每日浮动汇率统一转USD展示）',
  'oNrwxy': '可用余额USD',
  'KJ8nVz': '可用待入账USD',
  'Ro2q9R': '所有币种的可用待入账合计（按每日浮动汇率统一转USD展示）',
  'Yy819n': '授信额度（USD）',
  'jK4Nnf': '头程临时额度（USD）',
  'qtAVwx': '出库单编号',
  'ENWxyt': '消费',
  '5ISj3t': 'Winit返利',
  'zpU3Yb': '礼品卡抵扣',
  '9moHyC': '优惠券抵扣',
  'HkZt6P': '出库单',
  'Aj4jXY': '入库单',
  'AJzkTP': '仓储单',
  'SDT4n4': '退货单',
  'hkowEP': '标准索赔单',
  'ZeCQE2': '海外仓账户',
  'YmfoQv': '收取逾期费用。',
  'IW8HMr': '已逾期',
  // 'YmfoQv': '收取逾期费用。',
  'ItEF5s': '商务折扣',
  '3FoZNl': '轨迹查询',
  'CCs6QA': '目的港',
  'CwBUk9': '截止下单',
  'G47GIt': '航班航次',
  'NVsDWV': '预计发货',
  'RstqI4': '起始仓',
  'U+63ns': '发货方式',
  'U0oOyg': '海外仓尾程查件申请',
  'eITI+b': '预计到达',
  'moQ/pq': '始发仓',
  'nkbxtM': '请输入跟踪号，最多一次性支持30个跟踪号，号码间请用“空格、逗号以及换行”隔开。',
  'sIulVO': '截止收货',
  'sk3D+j': '物流计划',
  'y8Y856': '启运港',
  'zolGw6': '已截单',
  '+pOhR+': '文件类型',
  '/cqdKk': '下载',
  '0OWEyT': '切换为单品化管理后无法添加第三方商品条码，同时将清空已维护第三方商品条码。确认要切换吗？',
  '2cnobD': '文件上传',
  '60lhcg': 'SKU[{code}]提交失败，必须保证随货携带纸质说明书，若您无法提供，商品将无法出库。详询客服',
  '9BNdhd': '仅限注册待审核、注册退回、已发布、更新退回、更新待审核的商品，才能批量上传文件',
  'B35fQu': '启用出库加包装服务后，注册商品时需填写包装信息，导入模板也会随之更改(需重新下载导入模板)。{break}启用后无法关闭，确认需要加包装吗?',
  'HwyF+e': '启用出库加包装服务',
  'IQB8CW': '添加文件',
  'KTL7xe': '仅限草稿、注册退回状态的商品，才能删除',
  'Lychr5': '包装类别为[Winit标准包装]时,包材类型不能为[不加包装]',
  'M0Jk1q': '仅限已发布的商品，才能打印条码',
  'MLkhBi': '跳过，为其余商品新增进口国',
  'P9HL7J': '仅限已发布的商品，才能新增进口国',
  'TLZkuQ': '从文件管理中选择',
  'UVc9ET': '文件不足需补充？<a>去编辑</a>',
  'UduVZX': '选择文件',
  'X2PFlN': '仅限补充类型全部都为商品负责人的商品，才能批量绑定',
  'XI/sng': '复制链接',
  'XUIiyo': '仅限补充类型全部都为德语说明书的商品，才能批量操作',
  'do5UYM': '是否被商品引用',
  'gL2wtJ': '提交结果',
  'gLFXUo': '审核不通过，请重新维护',
  'hb/4W7': '本地上传文件',
  'r+E4Jq': '仅限草稿状态的商品，才能提交',
  'r1IImU': '知道了',
  'Jc2rPw': '请输入0~30个字符',
  'qQPq6P': '德语说明书链接最多30个字符',
  'sRBJ5R': '支持50M以内的jpg,jpeg,png,pdf格式文件',
  '71F+U7': '文件最多上传{maxCount}个',
  '7VOwCe': '重新选择',
  'FFdW4c': '批量维护德语说明书',
  'Tlz8ww': '维护德语说明书',
  'lQZq1z': '维护说明书',
  'yySTyc': '此SKU必须保证随货携带纸质说明书，否则出库会受限，请确认是否携带纸质说明书？',

  '+Bp/vI': '个人账户',
  '+EKnLz': '未证明的付款，将被原路退回。',
  '+GpSaa': '富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准。',
  '+aB+94': '*汇率(USD)',
  '+aFDe8': '汇款时间',
  '+mn2aK': '付款渠道',
  '/4F0HL': '授信额度(USD)',
  '/BYjbl': '确定要一键开通吗？',
  '/S2M/C': '转出信息',
  '/VO4aK': '还所有币种的欠款。',
  '/vwubC': '海外仓费用测算',
  '/zEZR9': '请选择钱包类型',
  '0X1r6A': '手续费：',
  '1y/RY3': '待还金额',
  '29Bujy': '4.点击可查看收款说明',
  '2dGT9s': '还款预估',
  '2ku/TP': '内作为押金，账户余额 + 押金 >0，可正常消费。',
  '2ygZv/': '卡类型',
  '3BONOy': '付款记录',
  '3YANVl': '你已成功开通ISP账户。',
  '3mOyjF': '请选择付款渠道',
  '3sq/jr': '头程临时额度(USD)',
  '43p9pl': '您当前尚未开通海外仓账户，一键开通后可以：',
  '6cQmi+': '如需使用富友付款，请确保账户主体上传的资料文件为最新版，否则将无法完成付款到账',
  '4WnUuL': '银行地址：',
  '4YQfnV': '你已成功开通海外仓账户。',
  '4hvYiT': '提交付款',
  '5P5/Mh': '付款金额不能大于',
  '5QTRWB': '计费重(KG)',
  '6/ZybD': '账单无欠款或已还清，无需进行还款预估',
  '6K/a0B': '暂停',
  '6pFnBP': '当前可用于还款金额',
  '77wjVR': '进行处理，证明付款主体与接受付款的万邑通账户是同一主体。超过',
  '7R+2Zn': '可用待入账',
  '7TOxPh': '联行号：',
  '7uCsR+': '汇款金额',
  '7yRO8w': '如何进行海外仓费用测算',
  '82y49D': '发起账户',
  '8i9KCx': '2.不同钱包之间，支持任意币种相互转换。',
  '9/IwWU': '您当前尚未开通ISP账户，一键开通后可以：',
  '9JX759': '请填写大于0的两位小数',
  '9bsH+T': '1.线下付款单通常需要1~3个工作日才会入账。如急需使用付款金额，请用线上付款。',
  '9nOyKf': '与万邑通账户的注册名称不一致！',
  '9oZAA6': '账号注册与管理',
  '9ppYjb': '备注：该笔金额将在',
  'Aj8GCU': '商品注册和管理',
  'BB3JzJ': '【提交证明】',
  'ux+6D/': '未逾期账单b',
  'CN1Myp': 'Paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；其他线上渠道则全额退还。',
  'CnJrhy': '请点击',
  'DkxKwM': '清晰查询ISP消费记录和账单;',
  'EznDMN': '待入账退款手续费说明：paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准；其他线上渠道则全额退还。',
  'FbGkhC': 'Payoneer账号解除关联成功！',
  'FlqSrP': '待入账担保冻结',
  'GJqMVO': '还款币种',
  'H7VDO0': '如何进行商品注册',
  'HC2zVC': '账单已还清，无需还款',
  'HP1Bh4': '当前可转出：',
  'HV+RrC': '选项一：还所有币种的欠款，还款顺序为1234567（不还未出账单的其他币种的欠款）。',
  'HesHBG': '请输入卖家订单号',
  'IFdU1p': '确定解绑Payoneer账号吗?',
  'IIW5jM': '付款失败',
  'IRZDt1': '请选择收款账号',
  'Ic3VRb': '付款金额',
  'JVWd7i': '借记卡',
  'Jh+0Zh': '2.同一个账单内，付款币种的欠款还清后，其他币种按欠款金额从大到小的顺序购汇还款',
  'K1GUT5': '待还',
  'KCVyDg': '转入成功',
  'KPlzwS': '付款提示',
  'KQ2i0E': '保存并提交付款',
  'L/WfHi': '请选择转入币种',
  'M7nstf': '付款单号',
  'HYJRdP': '只还付款币种的欠款',
  'MaPa8K': '有余额的账户为欠款账户担保还款的金额，在担保时按当天汇率统一转美元进行担保。若欠款账户实际还清，则该金额会自动调整为0。',
  'Mq7E3I': '指最新一期账单对应币种的剩余待还金额，非实时欠款。',
  'NwL8D2': '付款下单使用ISP产品及服务;',
  'OMT30j': '如何提交资料开通权限',
  'P4kzRS': 'Payoneer将会收取等同于您提现手续费的支付手续费。如有异议，请联系您的Payoneer客户经理。',
  'PfZZIE': '最小录入金额为0.01',
  'Pz9nMI': '支付渠道处理中,请隔1~5分钟左右在付款单查询付款状态',
  'Pzdaeh': '=可用余额*汇率。由于汇率波动，可用余额USD也随汇率动态变化。',
  'QYZ9Zx': '头程额度详情',
  'RJiV2P': '一键开通',
  'RY0kPp': '确认还款',
  'Ri66Qg': '进行还款操作，处理完毕后，账单预估待还金额将自动更新。不同账户之间不能相互还款。',
  'SLJmsv': '确认还款后，系统将按照',
  'SPT6N5': '支付渠道返回的付款主体用户名：',
  'Sq4y+b': '=待入账总额-待入账担保冻结-待入账退款冻结',
  'StJL1v': '转入金额',
  'TBZp+D': '若要只还付款币种的欠款,请修改还款优先级设置。',
  'TqsGZy': '请选择付款账户类型',
  'U1a5b6': '请输入TrackingNo',
  'UIl1do': '如您的主账户主体无法付款，请直接变更主账户主体，无需注册子账户。',
  'UbVGIy': '入账金额：',
  'UdMGCn': '待入账退款冻结',
  'UrwhFI': '还所有币种的欠款',
  'Ut/pd3': '1.同钱包内，支持不同币种相互转换，不支持同币种转换。',
  'VZZTLA': '额度详情',
  'VgiKkA': '可用待入账(USD)',
  'VxJpE0': '3.待入账退款手续费说明：',
  'VzyupL': '账户：',
  'WAIPZ7': '为不影响海外仓下单，接下来请先付款。',
  'WKL0h2': '上传格式仅限于jpg, gif, png, jpeg, pdf, doc, xls, csv, docx, xlsx，大小不超过2M',
  'WMHRvU': '请输入付款金额，限制2位小数',
  'X4GxQb': '=可用待入账*汇率（USD）',
  'XdbxuW': '手续费',
  'XfVGBl': '线上付款',
  'Xgm4f8': '主账户',
  'XjiQM6': '可下单金额(USD)',
  'Y1DU7Y': 'TEMU后台及万邑通后台基础设置',
  'Yq7bo5': '交易号',
  'YsDkfI': '今日汇率：',
  'Z5TkZp': '如何进行账号注册',
  'Z6Sgc7': '还款',
  'Z7Qmhr': '待还总计',
  'a6ZOkV': '每天下午3点获取招行汇率作为次日的汇率使用，招行汇率查看地址',
  'aB10CI': '1.按出账单时间的先后顺序还账',
  'aDobaI': '失败原因:',
  'adagiy': '还款优先级设置',
  'bOeriS': '=可用待入账(USD)',
  'bhqbML': '多个业务单号用英文逗号隔开，支持查100个订单',
  'bmpsI4': '汇率*',
  'c0L+yJ': '为不影响ISP下单，接下来请先付款。',
  'csDC/0': '开户名：',
  'd8I+tD': '若Payoneer有待入账单据，解绑后可能会导致退款失败，若无请忽略。',
  'dMLnuv': '付款下单使用海外仓出库、入库、国际送仓、退货等产品及服务;',
  'dMXzwA': '提交资料审核后自动开通权限',
  'dde1iG': '转入钱包',
  'dgCSCT': '收款账号',
  'e0EBzw': '转入账户',
  'eGcy2N': '入账账户',
  'eLSgnP': '账户总览',
  'eRQHjK': '付款金额不能小于',
  'eUvdyt': '当前被冻结的金额',
  'ecuOhs': '失败原因的描述（后台有返回就展示，没有就不展示）',
  'etbYTE': '文件大小需小于2M',
  'f8hvof': '付款账户类型',
  'fLc+XS': '待入账详情',
  'gAJffR': '选项二：只还付款币种的欠款，还款顺序为147。',
  'gDdy3P': '2.待入账退款手续费说明',
  'gLueKi': '自动还款优先级',
  'gMHwLF': '请选择卡类型',
  'gTawBp': '可用余额明细',
  'hQllsy': '子账户',
  'hehTR6': '绑定账号',
  'ikHYS2': 'ISP账户',
  'ikulRv': '当前无可用余额，点击',
  'jCBjGq': '线下付款',
  'jZ73eo': '入账金额',
  'kV7zH8': '开通海外仓账户',
  'kdB1AH': '无payoneer账号？',
  'koaAco': '收款渠道',
  'l2g8wQ': '1.付款主体名称与我司注册名称不一致时，将在第12天自动发起退款；为避免影响您下单，请使用相同主体名称进行支付。',
  'l7f7r8': '若要还所有币种的欠款，请修改还款优先级设置。',
  'llD/i8': '请上传附件！',
  'm0y10W': '信用卡',
  'm1RY2+': '转出金额',
  'mG5cQ0': '只还付款币种的欠款。',
  'mMJ1Rl': '3.币种CNY/HKD的最小转出金额为0.1，币种GBP/EUR/AUD/USD/CAD的最小转出金额为0.01。',
  'mhaWrg': '我要付款',
  'mvk8fk': '可避免账单逾期：',
  'nHkdvI': '未出账单c',
  'nKlulI': '取消付款',
  'nT7ZVh': '如何进行后台基础设置',
  'nVdGLm': '转入信息',
  'ordSAe': '公司账户',
  'p0X04m': '钱包类型',
  'pFzElE': '点击注册',
  'qQO1Kx': '请选择收款渠道',
  'qn8PaB': '案例：假设用户有逾期账单a，未逾期账单b，消费未出账单c，abc按时间先后顺序发生，都有USD、AUD、GBP欠款，且AUD的欠款金额数>GBP欠款金额数。若付款足额的USD：',
  'qsDvGz': '账户',
  'qwYCNh': '开户行：',
  'rCo8W8': '个',
  'rGARdg': '请选择汇款时间',
  'sQo+08': '转出账户',
  'tKr1pi': '额度分配',
  'tb1UtE': '最小录入金额为0.1',
  'ti7lc2': 'Payoneer暂不支持注册在以下国家的账户：澳大利亚、日本、俄罗斯。请使用注册在其他国家的payoneer账户进行授权支付。',
  'uMgaXV': '2.付款主体名称与我司注册名称不一致时，将在第12天自动发起退款；为避免影响您下单，请使用相同主体名称的账号进行支付。',
  'v5UE43': '待入账总额',
  'vv2W/D': '开通ISP账户',
  'vy/OTR': '=账户余额-冻结金额',
  'w0hdTL': '3.我司坚决执行《中华人民共和国反洗钱法》的相关规定，付款后如需退款，将由付款渠道原路径退还。 对涉嫌洗钱、虚假交易等行为，我司有义务向相关部门举报并协助公安机关提供证据。',
  'wBFOVC': '账号授权',
  'wPdOYa': '清晰查询海外仓消费记录和账单;',
  'wm1m74': '请选择转出币种',
  'wnNJYN': '入账金额以实际到账金额为准',
  'wq/8d2': '收款说明',
  'wsJMPz': '转出钱包',
  'wxKEvn': '请绑定账号授权',
  'xHiFxP': '银行代码：',
  'xOOX40': '本次付款金额,将会',
  'xSePXT': '获取更多优惠及返利',
  'xch+qQ': '预估还款金额',
  'xsvWWt': '逾期账单a',
  'y9h4Ep': '继续付款',
  'yA6qzf': '不够汇还其他币种的欠款，可能导致账单逾期',
  'yILY8H': '付款成功',
  'ydgrO7': '已认证或（已开通服务）的账户，才可以作为付款发起账户。',
  'yfhtRM': '附件',
  'ym4AWb': '当前账户对应币种的余额，含冻结金额。',
  'z1tAjb': '此处的单币种待还金额只是根据当前汇率兑换后得到的一个预估金额。因每天汇率都会发生变化，还款时请按当天的汇率为准。',
  'T7vDas': '付款还款优先级',
  'PCAxv5': '请登录主账户开通',
  'QZVGH2': '主账户还未开通',
  '+/mKIm': '送港类型',
  '+Haf5X': '预计上架时间',
  '+KV1mF': '默认提货类型',
  '+VZ9L9': '{warehouseName}{break}SI数量/拆分比例%',
  '+b49JP': '新增商品',
  '+ouZSO': '打托内包裹数',
  '//BDmI': '上架异常区',
  '/1VwD2': '报错信息',
  '/3s7PF': '仓库联系人电话',
  '/AhSAS': '验货中',
  '/GAWbE': '国内拆原单号',
  '/HFG6y': '快递单号只支持6到40位的英文和数字',
  '/KZ2WA': '实际采集识别码',
  '/cQzqv': '请填写正整数！',
  '/crqpT': '已扣货',
  '/kUXrS': '查看转存',
  '/lKNmz': 'SLA{a0}',
  '/pS13+': '请添加发票信息',
  '0+4E11': '修改成功',
  '04Gdfx': '请先添加商品',
  '05s3bE': '不可选择的原因',
  '09Xv5V': '请选择出口商',
  '0Cs9O2': '空包裹',
  '0LXLDR': '备注：如您选择添加欧代信息，则标签将带有已关联的欧代信息；如不选择则不会带有',
  '0OjWgU': '批量收起商品信息',
  '0Q/VKe': '如果不填写，选择订单后会自动生成，并可修改',
  '0Yqdvb': '创建自验单',
  '0eFd5u': '运输中',
  '0n+GhK': '暂时无法提供快递单号，先确认发货，订单到仓前可提供。',
  '0oRCPJ': '更多地址',
  '1+iXcF': '批量创建预约单',
  '148weM': '预付费用',
  '1AcjeR': '请选择{field}',
  '1Cm5u2': '创建预约单',
  '1Fsq2f': '订单内包裹序号，仅作为计数查看，无需支持扫描',
  '1SrwnE': '<span>注：以上费用为预估费用，费用冻结时间为：国内验货仓验货完成/直发海外验为已提交。{break}</span> <span>账户可用余额小于系统预估费用则无法提交订单，烦请在下单前确保账户可用余额充足。</span>',
  '1Un03g': '异常状态',
  '1Wvoid': '快捷下单',
  '1b90aB': '验货方式',
  '1eYE4O': '上架差异数量',
  '1f8TDn': '提货地址',
  '1kQP8C': 'WINIT产品',
  '2145JR': '终止详情',
  '29nc3A': '实际重量(kg)',
  '2K4z2R': '识别码信息不能为空！',
  '2N21Ip': '偏好名称',
  '2Y/zPo': '预付费用合计',
  '2f2ltn': '整单商品按不良品上架',
  '2mmTtR': '请输入数字且小数点后不超过六位',
  '2pylzZ': '多个单号需换行，最多支持{num}个。双击切换到单个查询',
  '3FrfH2': '请选择提货时间',
  '3Jc4/0': '发票申报信息',
  '3R6r9b': '否，边验货边装箱（验货方式：新自验）',
  '3Tv9vo': '包裹条码',
  '3U8Sns': '请维护起航时间',
  '4/Afmm': '生产日期',
  '4/cfmf': '批量打印包裹条码',
  '48ov53': '若选择了套装产品/箱产品，则数量表示套数/箱数',
  '4AtBWc': '提货类型',
  '4JMVek': '切换后将清空现有的箱单信息，您需要重新导入箱单。请确认是否切换？',
  '4Y5o/o': '编辑快递单号',
  '4Z9Hsl': '请输入{field}',
  '4bqHG6': '待审批',
  '4zXeKC': 'C包裹条码数',
  '5AMYmr': '进口报关类型',
  '5Hy2HW': '异常说明',
  '5MwSDO': '确认取消 <span>{mainOrderNo}</span> 订单合并吗？取消订单合并后，头程费用将独立计算。',
  '5WkW6a': '国内仓扣货数量',
  '5ZVPiX': '增值预约',
  '5eNIMa': '提货时间',
  '5m+OgD': '添加识别码',
  '5s/d5K': '关联调整单号',
  '64ulHJ': '费用名称',
  '66awCH': '刷新',
  '6EnlKE': '是否免自验',
  '72NkSW': '更新并关闭页面',
  '7L70OD': '实际体积(CBM)',
  '7VvMbL': '送港时间',
  '7q/H5d': '单号去重',
  '7tb4y9': '请维护集装箱号',
  '8/zli1': '待预约',
  '84F3+v': '不支持修改推荐偏好信息进行下单，如不使用此偏好，请使用其他方式下单，谢谢！',
  '87NQWt': '全部收齐',
  '8EFvsh': '表示该商品实际上架或验货的数量',
  '8N2XyN': '是否主子菜单',
  '8Nd7ys': '是否确认回退到草稿？',
  '8OKx0+': '支持维护客户包裹的订单列表',
  '8PwcJP': '[下单 | 验货 | 实际 | 上架]',
  '8RyGw7': '联系方式',
  '8VaERm': '导出您导入包裹信息/商品信息的文件,方便您在原来的文件上修改后重新导入。',
  '8aVf1s': '新增识别码',
  '8yOIaG': '打印份数',
  '9F8Tn0': '查看费用明细',
  '9Jdkl/': '发票总金额(USD)：{money}',
  '9U7C/w': '申报价值',
  '9bK+VQ': '预计到仓时间(当地)',
  'ABsoZh': '批量导入客户包裹',
  'ACzUlr': '不提供并取消待办',
  'ADgz1i': '请点击此处下载<url>商品信息模板</url>',
  'AIQmaJ': '继续下单',
  'ARAdzq': '(截货到上架的时间是{maxSla}个自然日)',
  'B2Qpws': '下单体积(CBM)',
  'B6fE/x': '已卸货',
  'B8oYdO': '拆分调整',
  'BQqOxZ': '货物处理方式',
  'BQrZ98': '批量打印商品条码',
  'BvRA7E': '汇总数量',
  'ByDy2W': '商品中文名称',
  'ByyC+Y': '新增快递单号',
  'C8gyRs': '是否确认生效？生效后可通过筛选条件继续查询。',
  'C90Kr8': '集装箱号',
  'CBNdcR': '是，待验货（验货方式：旧自验）：已确定箱单信息，下单环节录入完整的包裹和商品的绑定关系。{break}否，边验货边装箱（验货方式：新自验）：未确定箱单信息，下单时仅填写商品信息，验货时现场操作APP绑定商品与包裹的关系。',
  'CBhqWQ': '总商品数：',
  'CJovuJ': '请选择出口报关类型',
  'COLDy1': '处理人',
  'CORiCX': '散货',
  'CSKXy4': '良品上架数量:{a0}{break}不良品上架数量:{a1}',
  'Ci0uZW': '包裹已到仓且存在待您操作的异常，请到《异常信息》处理，异常处理后仓库会继续正常上架并计入库处理费。',
  'CmFNm0': '部分到仓',
  'CykO0a': '草稿单是否有效',
  'DLVpO9': '请注意，选择免自验后，订单将在提交后自动完成验货，无法再修改箱单信息',
  'DapT6x': '已维护起航时间，请同时维护集装箱号',
  'E+NBXN': '口罩类商品请提供CE认证（欧州），医用口罩类商品请提供FDA认证（美国），否则库内会进行扣货，如已提供请忽略',
  'E7XGNI': 'HSCOOD',
  'EPU9xw': '请选择目的仓相同的订单创建预约单',
  'EQ3QSv': '单品数量',
  'ESC6Yn': '包裹列表',
  'EX2W4q': '直接确认发货',
  'EgNwCT': '请先选择是否明确装箱清单。',
  'F8Cxjp': '整柜照片',
  'FBADnU': '已验货',
  'FDm4J5': '仓库地址：',
  'FMXIS2': '异常名称',
  'FUpkCM': '存在异常单',
  'FUty4V': '目标上架时间(当地)',
  'FtPVQO': '配置偏好',
  'FvcItB': '截止收货时间',
  'G0phnd': '编辑入库下单偏好',
  'GAdpHS': '增值',
  'GTx/vJ': '验货数据支持多次导入，每次导入会清空当前订单所有历史验货数据，以最后一次导入数据为准。',
  'Gqin8B': '已转出',
  'Gr4OaP': '子包裹条码',
  'H+5XWJ': '出口报关类型',
  'H/88FZ': '订单状态',
  'H1BfHj': '已下单',
  'H6fRPF': '第三方箱号',
  'H74WHM': '快速自验',
  'H7aOFH': '待更新',
  'HB0v/l': '默认预计上架时间最早的物流计划',
  'HEsWMo': '编辑商品',
  'HGZs22': '识别码',
  'HIB2bG': '请仔细阅读<url>《直发头程用户手册》</url>,若因未按规定操作导致违规产生 额外费用、收货上架延误等结果，Winit不承担任何责任！',
  'HQNu2M': '总包裹数：',
  'HclFq/': '请输入数字且小数点后不超过两位',
  'HeBDj3': '查看历史异常',
  'Hh4Skh': '标签文件',
  'Hi/cDm': '合并子单',
  'HjCmpq': '调拨单号',
  'Hps8qJ': '{warehouseName}{break}SI数量|包裹数',
  'HxabgS': '商品尺寸（cm）',
  'I8h0ir': '再次下单',
  'IKLUiW': '支持创建预约单的订单列表',
  'IQcPaX': '实际采集快递单号',
  'IX2QXb': '总单品数：',
  'Ib2hT8': '预约仓库',
  'IeO0m8': '预计到仓时间',
  'IpFfcK': '凭证照片',
  'IqBF9S': '包裹外包装已张贴的自定义箱唛条码，需支持扫描识别，WINIT系统内需唯一',
  'J/7xTf': '是否明确装箱清单',
  'J01u91': '默认送港类型',
  'J8dULN': '箱号',
  'JISjDR': '箱唛样式',
  'JT2B6+': '上架有差异',
  'JhQ/Jm': '汇总数量{break}SI数量|包裹数',
  'JloVFv': '支持维护起航时间订单列表',
  'JoFqsi': '无该权限！',
  'K8uL5W': '温馨提醒：如因此问题造成海关扣货或查验，所产生费用、责任等风险须由客户自行承担。',
  'KB4dfq': '已收货',
  'KBc/G+': '上架数量',
  'KGzTFK': '请填写大于0的数，最多保留3位小数',
  'KQ5tz8': '费用预估',
  'KRrlyx': '无法确定快递单号与包裹的关系，请在下表输入并保存此订单的快递单号。（多次保存会自动去重并做追加处理）',
  'KVkKPj': '实际上架时间',
  'Keyhlo': '费用',
  'KwEmp3': '批量上传识别码',
  'LIyazS': '更新人',
  'LbBp8z': '终止数量',
  'LbzjeJ': '确认发货',
  'LpjYFr': '<title>温馨提示:</title>{break}<span>请注意正确选择该订单的进口商，系统会以此进口商信息记录该在途订单商品信息，万邑通会根据英国海关税务总署（HRMC）的要求提供该进口商的在途、在库和出库信息。</span>',
  'LqWKF0': '订单信息更改，预估费用发生变化，如有需要请至<url>订单详情</url>查看最新预估费用。点击订单详情超链至详情页。',
  'Ls1X2Z': '已处理',
  'M0EUx8': '展开更多',
  'M7XhhM': 'A+包裹条码数',
  'MHVja0': '出运地',
  'MNhsuy': '实际生产日期',
  'Ml6cXJ': '选择需要复制的订单',
  'MntjRj': '该订单的送仓方式属于快递且是无箱单，请提供识别码信息，Winit会基于识别码信息识别订单',
  'Mp5/Kf': '订单信息',
  'N25MSc': '预约状态',
  'NUm1lw': '发货供应商',
  'Nnflg8': '因只支持整包拆分,结果可能有差异,请查看最终结果',
  'NxRF/D': 'B包裹条码数',
  'O2GkC8': '预约成功',
  'O2w7aQ': '请先选择Wint入库产品再创建自验单',
  'O78/NO': '客户',
  'ONp4Fs': '温馨提示：重新上传会清空原先导入的信息',
  'OOa7/r': '添加子单',
  'OPMsMJ': '异常创建时间',
  'OW95UK': '<span>如果您明确送仓时间，请选择正确的送仓时间，如果您尚不明确送仓时间，可使用系统默认计算出的送仓时间，谢谢！</span>',
  'OXu/wN': '是否主子订单',
  'ObFFIO': '下单时间',
  'OtbHOY': '识别码最长128个字符',
  'PcnKff': '签收信息',
  'PiyAfP': '预约类型',
  'Q0IJ2Z': '快递公司',
  'Q58yf2': '默认推荐',
  'QYstE7': '合并后的主单为入库单 {orderNo}，合并后无法更换主单。',
  'Qjs1ZE': '签收单照片',
  'QreDuh': '异常预约',
  'Qzs7rS': '订单轨迹',
  'R6Haep': '发起转存',
  'RAwLcV': '新建入库单',
  'RMaTq1': '是否铅封异常',
  'RWKKkV': '批量维护维护包裹条码',
  'RlYLsE': '费用说明',
  'RuIqtm': '接口未返回数据，生成文件失败',
  'S/8L6Q': '整柜',
  'SGFD07': '是否参与调拨',
  'SLK/K9': '总标签条码 = 包裹数量 X 打印份数 如需重复打印多张标签，请指定打印份数，相同的标签将排列在一起。',
  'SM5IQ2': '批量导入快递单号',
  'SSOUy/': '更新并到下一步',
  'STnfmz': '打托数',
  'SU88Fc': '包裹数',
  'SUm34B': '海外卸货时间',
  'SYsndp': '请确保导入数据的准确性，否则将影响您账户的信用等级。',
  'SlzHdq': '请至少选择一个订单再提交',
  'Sn2I9N': '当前订单下单总包裹数{estimatePackageQty}个，已上架{shelvePackageQty}个，已丢失{lostPackageQty}个，已终止{stopPackageQty}个，请确认是否已全部上架完成？操作后剩余{remainingPackageQty}个包裹将自动终止，并且无法恢复',
  'Sne4x8': '新增入库下单偏好',
  'SqE6Xs': '产地',
  'T4IvBW': '第三方编码',
  'TBbEyx': '新提交',
  'TH1ziY': '已到仓',
  'TKdhhF': '增值信息',
  'TLgurL': '<span>如提货类型选择"WINIT上门提货",且提货地址为非免费揽收区域,收费标准请参见WINIT海外仓价卡, 如价卡无报价,请先咨询WINIT客服获取报价.</span>',
  'TTRtNs': '发票总金额(USD)：{invoiceMoney}',
  'TXukVl': '关联订单号表示该入库单相关的增值单中，对应的原入库单或新入库单。仅展示已受理、仓库处理中、仓库已处理、已完成增值单中的关联订单号',
  'TbuyGo': '客户订单号',
  'Td1kBU': '关联订单号',
  'Thj8cY': '是，待验货（验货方式：旧自验）',
  'TlN+E+': '若选择了套装产品/箱产品,则数量表示套数/箱数',
  'TlmivL': '入库下单设置',
  'TmeS4t': 'Winit',
  'TpnoPg': '仓库电话：',
  'TqOQZ7': '实际费用',
  'TuZEiB': '验货数量',
  'U5YRJc': '取消验货',
  'URH0xP': '预约单号',
  'UTgFmZ': '包裹重量（kg）',
  'UjxKxu': '终止',
  'UzUKJU': '维护进口商',
  'V/Q/MF': '全部取消',
  'V3EgJJ': '集装箱号应为 四位大写字母+7位数字，请检查后提交',
  'VdzlrR': '请点击此处',
  'VgoWxA': 'Winit费用',
  'VhKC/g': '逐个添加',
  'ViVCdK': '上架完成时间',
  'VvQxun': '已丢失',
  'W5OmHx': '入库单号',
  'W60tFR': '下单日期',
  'WGM/sd': '打印包裹条码',
  'WPq6RS': '导出已导入信息',
  'WVa6Gz': '是否A+',
  'WeJSWO': '整柜柜型',
  'WntfLd': '国内仓信息',
  'Wq3cD+': '是否高贷值',
  'WqyrgN': '部分上架',
  'Wy9Mf2': '今天',
  'X1YR3n': '回到草稿',
  'XA+N8d': '编辑包裹',
  'XBalI+': '实际产品批次号',
  'XCMy9u': '请选择快递公司',
  'XFFD/P': '批量查看商品信息',
  'XLlfn6': '反馈增值',
  'XOzvJn': '输入两个字符系统自动匹配SKU',
  'XauMax': '编辑转存',
  'XnTAmU': '实际失效日期',
  'Y0Vai9': '实际条码值',
  'YEHu7B': '长宽高',
  'YII2+w': '失效日期',
  'YncPzL': '若选择使用该增值服务，当入库订单内某SKU单一产品库存以A包入库，且满足该SKU箱产品箱规，则会自动转为箱产品库存上架。',
  'YqBDBe': '<title>温馨提示:</title>{break}<span>英国非Winit承运订单，请于货物到仓前提供内容完整的进口报关文件，如未提供有效的清关文件，万邑通有权基于英国海关税务总署（HRMC）对仓库的尽职要求针对该订单禁售，谢谢。</span>',
  'YrPv/S': '存储模式数量',
  'Z3nsrC': '请选择删除项!',
  'Z7aHkZ': '冻结节点',
  'ZOZfwr': '您当前的下单信息将自动为您保存至草稿单{orderNo}，请确认是否取消？',
  'ZTlBmE': '入库单号：',
  'ZfgKqB': '请<url>点击此处</url>下载箱单信息模板。',
  'ZlNu8o': '如提货类型选择"WINIT上门提货",且提货地址为非免费揽收区域,收费标准请参见WINIT海外仓价卡,如价卡无报价,请先咨询WINIT客服获取报价.',
  'ZpXeP3': '预计到达时间',
  'a03CGi': '包括铅封照片、开箱照片、受潮进水照片',
  'a2fLkA': '请选择识别码类型',
  'a5E0Ng': '子包裹海外扫描时间',
  'a5l3By': '请输入0-100,最多为两位小数',
  'a7NkIa': '截止下单时间',
  'aB+BJ/': '使用箱单信息生成申报',
  'aDBVmD': '快递单号',
  'aMiNon': '送仓方式',
  'agQLWz': '关联调整类型',
  'av2paB': '需要客户提供信息',
  'avQKT6': '请输入正整数',
  'b6ccYv': '可用产品共 {a0} 条 不可用 {a1} 条 <a2>不能选择的产品展开</a2>',
  'b9JmDO': '取消发货',
  'bEG5tG': '下载批量上传识别码模板',
  'bGVE1B': '批量维护客户包裹码',
  'bOqVvl': '请输入快递单号',
  'bccJSU': '包裹重量',
  'beiLZA': '箱单信息不能为空！',
  'bjzFIC': '预计发货时间',
  'bpSdwX': '未打托包裹数',
  'btRxj0': '费用信息',
  'btmsJu': '已终止',
  'c2hDMK': '可确定快递单号与包裹的关系，请下载此订单模板，导入上传。（多次导入支持更新）',
  'c2y2qR': '导入快递单号',
  'cNQ0gh': '下载模板，导入上传（针对已确定快递单号与包裹的关系）',
  'cQMY2E': '确定操作删除吗?',
  'cS931W': '申报中文品名',
  'cY3iEX': '取消转存',
  'coU8Jk': '单品数',
  'ct6g4c': '您发起终止的订单，若订单包裹到达海外仓，将被拦截无法上架，暂存至异常区并会产生额外暂存费用，确认继续终止吗？',
  'dASZuG': '提交并确认发货',
  'dCFfNa': '该订单的送仓方式属于整柜，请维护起航时间！',
  'dF+aMA': '是否受潮进水',
  'dGF8Sn': '编辑识别码',
  'dOBmL8': '保存并确认发货',
  'dQD3ZJ': '验货状态',
  'dfIz/T': '上传快递单号',
  'dpcPCu': '预估费用',
  'dssjRY': '申报价值（USD）',
  'e1d/Ws': '以上费用为预估费用，最终以实际收费为准。',
  'e8cbAb': '仓库名称',
  'eOIKED': '核实尺寸（cm）',
  'eelCv6': '全部清除',
  'el0Kz3': '预计送仓方式',
  'enLtM3': '扣费节点',
  'ex+IzV': '核实重量（kg）',
  'f36rK/': '请选择进口商',
  'f69V6p': '签收时间',
  'f6CeZ+': '请输入非A+包裹条码数',
  'fC2QjX': '维护出口商',
  'fDddkK': '主单订单号',
  'fEWKZV': '产品批次号',
  'fQXTj6': '快递信息',
  'fWEyf9': '已全部上架',
  'fZDGEe': '签收人',
  'fmXbdW': 'HSCODE',
  'fuDs1B': '异常到仓',
  'g9bh34': '商品英文名称',
  'gB3QVh': '包裹等级',
  'gSmKzH': '计费重(kg)',
  'gmG+u8': '丢失数量',
  'gsVL49': '尊敬的客户，您好！{break}<desc>根据美国海关及边境保护局最近发布的通知，禁止进口中国新疆维吾尔自治区的棉花产品（全部或部分使用该棉花生产的产品）。因中国棉花大部分生长在该地区，从中国进口含有棉花的产品有可能被扣留或禁止入境，详情请查看美国海关及边境保护局的通知链接。</desc>{break}<url>点击链接地址</url>',
  'h5VsBC': '普通预约',
  'hJbAF7': '箱单信息',
  'hOPDPX': '是否确认发货',
  'hPJkFk': '提柜地址',
  'hYC7rP': '您更改的信息将涉及下单结构的调整，将默认清空箱单信息，请确认是否调整？',
  'hZHPZo': '请选择Winit入库产品!',
  'hkVN9x': '请确认订单是否已全部验货，验货完成后将不能修改订单信息。',
  'hl1rBH': '入库单识别码',
  'hvGSWe': '验货仓/出运地',
  'hxJVQJ': '申报单价(USD)',
  'i6uYTF': '切换后将清空现有的箱单信息，您需要重新导入箱单，请确认是否切换？',
  'iEwi00': '该订单的送仓方式属于快递，请维护快递单号！Winit会基于快递单号获取物流轨迹。',
  'iJRlKo': '仓库地址',
  'iL72fa': '双击切换到批量查询',
  'iMfa45': '支持上传快递单号的订单列表',
  'iT2mOO': '是否确认失效？失效后可通过筛选条件继续查询。',
  'iYbZ9o': '申报单价 (USD)',
  'iZK+78': '拆单原单号',
  'jDrbVr': '入库单验货状态处于验货中/验货完成，不允许修改！',
  'jESlL9': '近{days}天',
  'jF4g5j': '请选择非A+包裹的商品进行打印',
  'jJzjJ7': '待验货',
  'jOFy6Z': '仅发生异常情况时才有相应照片，包括异常托盘图片、异常包裹图片等',
  'jSb67m': '发货计划',
  'jcMe0a': '请至少选择一个订单',
  'ji5/jU': '该偏好删除后不可恢复，确定要删除吗？',
  'k3gNi8': '识别码信息',
  'k3gVMn': '<title>温馨提示:</title>{break} <span>1.请指定BC类包裹目的仓</span>{break} <span>2.系统将按照分仓比例对A类包裹自动进行拆分，支持自行调整，确认提交后系统将自动拆分成多个订单</span>{break} <span>3.如希望统一贴包裹条码，请在订单提交前打印包裹条码；提交后需按拆分后订单分开打印贴标</span>',
  'kMMJmC': '装箱信息以您订单导入包裹信息为准，如需调整，请在完成自验前重新导入订单包裹信息。',
  'kVZ7cV': '取消合并',
  'khjSsg': '<title>温馨提示</title>{break}<span>下入库单时，我们将根据你设置的入库下单偏好自动带出您的偏好信息，提升你的下单效率</span>{break}<span>偏好设置步骤：</span>{a0}',
  'klLCMR': '扣货数量',
  'ksgpo6': '每一张快递入库单申报价值不能大于{max}美金，请更改申报价值 或拆分发货',
  'kuDo/J': '{field}不能为空',
  'kyVVoP': '起航时间',
  'lNQLAr': '无法提供快递单号。',
  'mLsoqa': '已反馈',
  'md3nxV': '请至少选择一个子单再提交',
  'myc/4W': '是否A+包裹',
  'nHbUPX': '单一产品转箱产品',
  'nLwKh5': '偏好名称不能为空',
  'nhwDW2': '请选择项目',
  'niU4F4': '包裹序号',
  'nnZ5Oj': '若识别码类型为快递单号,则需要填 写对应的快递公司;若识别码类型为入库单号,则无需填写,系统将自动填充。',
  'ntW28d': '识别码类型',
  'nyrsly': '若勾选订单数据则会按照选择的订单填充模版，未勾选则下载空模板',
  'o4Vv1R': '请填写信息！',
  'o7iVPm': '包裹尺寸（cm）',
  'oNsmAy': '包裹信息',
  'oOZt0C': '签收类型',
  'oPxsc7': '打印订单条码',
  'oxmeg2': '商品重量（kg）',
  'p0QER/': '违规行为包括但不限于以下：{break} ①直发头程包裹面单/运单/提单/发票等物流单据未按照万邑通自发头程要求填写，包含了WINIT或其他WINIT 员工的名字等字样{break} ② 直发头程不是发货人承担税金（DDP、DTP、 F/D等）的付款模式；{break} ③入库单状态异常：直发自验入库单不为运输中，直发海外验入库单不为已下单；{break} ④直发头程入库单（非快递送仓）未预约送仓/未按预约时间送仓等"',
  'p7k/3V': '已选择 {num} 条记录',
  'pDE/NS': '请添加商品',
  'pNlKO3': '子',
  'pPLFGM': '仓库名称：',
  'pPxUIG': '请勾选订单',
  'per6Wc': '扣费时间',
  'pfdzsY': '默认选择最早的提货时间',
  'pmnxx5': '国内仓扣货',
  'pwc6NQ': '新增偏好',
  'pxcOgS': '请点击下载<url>多SKU类型入库箱单信息模板</url>{break}（适用于已开通套装/箱产品白名单或条码值管理白名单的客户）',
  'qALFFF': '打印箱单',
  'qCkP6I': '多个单号需换行',
  'qIXpnS': '未识别',
  'qLA8ku': '请勾选目的仓相同的订单',
  'qO/UNZ': '时效',
  'qU/PvG': '路线',
  'qlYzaa': '立即下单',
  'qsBMLq': '子包裹号',
  'r9PIIM': '同一包裹仅支持添加1箱箱产品',
  's3X4br': '签收单号',
  's6jr9x': 'A包裹条码数',
  's9gMG0': '请点击上传文件',
  'sC2Q9O': '启航时间',
  'sD68ps': '<title>温馨提示:</title>{break} <span>智能国内拆单PSC订单，提交后系统将按规则自动拆分成多张订单，下单后续如有变更，请在拆分后的子单中进行修改</span>',
  'sDg3+u': '下单重量(kg)',
  'sU6jlq': '库存单元数',
  'sZhuDU': '客户包裹条码',
  'snyKle': '请点击下载<url>多SKU类型入库箱单信息模板</url>{break}（适用于已开通套装/箱产品白名单或条码值管理白名单/批次管理白名单/万邑联免自验白名单的客户）',
  'sziYw4': '批量维护包裹条码',
  'tGh90c': '必须大于0，小于等于{maxMoney}，最多保留2位小数',
  'tZ+xcf': '处理时间',
  'tZE20T': '下单数量',
  'txh7Ok': '该下单方式暂不支持此类商品入库',
  'u0n0TG': '总体积(CBM)',
  'uEX5d+': 'Winit订单号',
  'uX7sD/': '入库日期',
  'uhRzgM': '包裹长*宽*高',
  'usAYZQ': '最多支持{num}个查询',
  'ux8iYZ': '异常照片',
  'v+ZpZ/': '商品数量（SKU）',
  'vNKRrK': '快捷下单导航',
  'vOJVtM': '暂确认发货',
  'vPrigA': '订单来源',
  'vY9yDh': '温馨提示：',
  'vkZ8aE': '箱单信息导入成功后即完成更新，请确认是否更新？',
  'vp+HUi': '个人下单偏好',
  'w00px3': '是否确认取消越库？',
  'whKaxL': '请输入识别码',
  'wk5u+s': '导入失败记录',
  'wyM+iH': '申报英文品名',
  'x+J841': '库存等级',
  'x3GvYe': '若使用该增值服务，则入库单入库后，将整单商品按不良品上架至不良品区。',
  'xNeD5U': '已取消',
  'xZo6jh': '验货完成',
  'xjO4wW': '调整',
  'yE+gNd': '验货类型',
  'yGaq41': '仅支持标签纸打印,单次打印不得超过{maxBatchPrint}个',
  'yM40CJ': '<span>如箱单信息变更，系统将对拆分结果进行重新计算</span>{break}<span>以下数据仅包含A与A+包裹</span>',
  'yPL67T': '预约码',
  'yQkOEi': 'Winit入库产品',
  'yufptr': '时效单位',
  'yvm8n2': '已上架',
  'yzEJ6Q': '新增包裹',
  'zE6N7L': '异常',
  'zEP9We': '如需打印条码 <a>点击此处</a> 进入订单详情。',
  'zEcTCR': '全部清空',
  'zGN0WZ': '批量导入起航时间',
  'zKkAh7': '国内仓发货数量',
  'zXfo9H': '订单的预计送仓方式是整柜/散货，请在送仓前进行预约 <url>点击前往预约送仓</url>',
  '+K2mxF': '查看绑定商品',
  '+as26z': '绑定商品',
  '/9BA4E': '若未填写则以winit实际采集为准，请注意保质期商品的禁售天数',
  '/XXHj8': '备注：以上是通过移除单号同步的FNSKU信息，请您先绑定Winit商品编码。',
  '1a4I+M': '批量维护第三方包裹条码',
  '216TEI': '地址：',
  '3/5ReX': '保存并关闭',
  '5JPEEe': '取消勾选后将清空当前商品信息，请确认是否取消勾选？',
  '7MMXPF': '暂时无法提供快递单号，先确认发货，货物到仓前可提供。',
  '7zzDTz': '是否明确装箱信息',
  '8NvecW': '添加商品行',
  '8QanX6': '【是，待验货（验货方式：旧自验）】：已确定装箱信息，下单环节可直接录入包裹和商品的绑定关系。{break}【否，边验货边装箱（验货方式：新自验）】：未确定装箱信息，下单时仅填写商品信息，验货时扫描并绑定商品与包裹的关系。',
  '9T27Yk': '预付费用总计: {allmoney} {currency}',
  '9vGfC2': '订单信息更改，预估费用发生变化，如有需要请至<url>订单详情</url>查看最新预估费用。',
  'CcQbSa': '未签署{name},<url>请点击链接进行签署</url>',
  'CqRSDm': '{warehouseName}{break}SI数量|拆分比例%',
  'CwyC8y': '请先选择{field}',
  'F3jPfS': '联系人：',
  'FGaAuD': '请输入移除单号，支持多个换行输入',
  'I0iNxa': '获取商品明细',
  'I1W1lj': '保质期及生产批次管理的商品，若未填写则以winit实际采集为准，请注意保质期商品的禁售天数',
  'IKtkLx': '联系电话：',
  'K3TeL/': '待处理',
  'N+5Ddk': '请输入Amazon店铺账号',
  'NHsSAb': '国家：',
  'O5JvNY': '移除单号',
  'OtByF3': '开通了条码值管理的商品，条码值必填。同一个包裹内，同一SKU类型同种库存单元标准件数（若有）的商品，条码值需相同',
  'POaD2E': '使用当前Winit产品,需要先签订清关协议,<url>签订方式请点击链接查看</url>。',
  'PV1cTK': '请输入数字且小数点后不超过三位',
  'PfOCPu': '采集快递单号',
  'b6OX/n': '复制下单',
  'bLlEAh': '搜索后显示格式为：商品编码-商品名称-规格【SKU类型-库存单元标准件数（若有）】',
  'bjURnX': '未启用出库加包装服务',
  'dSHhYW': '报关信息',
  'dXNw7m': 'Winit商品编码',
  'ekm5RV': '邮箱：',
  'fuj7WB': '批量导入第三方包裹条码',
  'g6XoUD': '针对整柜订单,货物离港后请及时在万邑联维护订单【起航时间】 否则将会影响订单预约送仓!',
  'gECtkR': '操作地点',
  'hZIYSK': '费用总计:',
  'hdaFx9': '<url>如何填写送仓方式？</url> {break}散货：散件/托盘等非整柜的卡车派送，送仓前必须预约； {break}整柜：国际运输方式是整柜才可选，送仓前必须预约； {break}快递：无需预约',
  'iiRPff': '是否同步亚马逊移除订单',
  'kFZ6Sy': 'Winit承运：指国内仓截货至海外仓上架的全程时效；{break}卖家直发：指货物到海外仓后的上架时效',
  'l0+dWr': '第三方包裹条码',
  'm0/5Lx': '批量上传包裹',
  'mhM8WV': '勾选同步亚马逊移除单将清空商品信息，请确认是否勾选？',
  'rFRyfW': '支持维护第三方包裹条码的订单列表',
  'sFLVr4': '提交订单后可查看',
  'ubfSYP': '批量上传商品',
  'vWP3K2': '请点击下载<url>导入模板</url>',
  'vsSpHk': '新增下一个',
  'vtcir0': '<url>如何填写国际运输方式？</url>',
  'wY/k9X': '若未填写则以winit实际采集为准',
  'xD3QFO': '费用信息<span>（实际扣费金额与预估金额可能不一致，以实际扣费金额为准）</span>',
  'xMUB1N': 'Amazon店铺账号',
  'y52KzK': '30天内不再提醒',
  'yvyrt3': '重新绑定商品',
  'zOwd77': '智能国内拆单PSC订单，提交后系统将按规则自动拆分成多张订单，下单后续如有变更，请在拆分后的子单中进行修改',
  'gjldFJ': '截取后快递单号',
  'jgK8RF': '打印发货凭证',
  'NpkuXN': '是否同步亚马逊订单',
  'TwvSPX': '来源',
  'x51qTM': '截取前快递单号',
  'RGuxf+': '单次打印超过{maxNumber}张标签条码时，请前往导出中心下载文件',
  'mG/n2r': '使用当前Winit产品,需要先签订清关协议,签订操作文档请<url>点击链接</url>查看，前往提供清关代理协议请<url2>点击链接</url2>。',
  'S14cUE': '用于包裹计数和标识，便于粘贴对应包裹标签，不支持扫描',
  'lD8xXw': '以实际到账金额为准',
  'RJP6qH': '核实重量',
  'aRhAJi': '核实尺寸',
  'pE1TYn': '包裹尺寸',
  'xGK0dH': '海外仓收件信息',
  'azlx3A': '海外仓收件信息<span>请注意：请务必按照下述的【联系人】和【地址】信息填写发货，否则将影响仓库收货处理。感谢配合。</span>',
  '6dK+q1': '打印提货通知',
  'Gh7kDk': '国内仓收件信息',
  '3yxbjy': '仓库电话',
  '0nfqFU': '请输入业务单号',
  'GwOy47': '工作日',
  'thQW+8': '自然日',
  '9n8bNu': '支付中',
  '8PS/Vj': '待入账',
  '/jiyIp': '金额合计',
  '7NqucZ': '切换成【自定义】，系统将清空【标准】已选择的配置，请确认是否切换？',
  '8YBttT': '{zone}已失效',
  'GXynBY': '切换成【标准】，系统将清空【自定义】已选择的配置，请确认是否切换？',
  'MVnxEB': '查看仓组',
  'XrLeOk': '智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息,基于配置的发货策略计算出最优发货方案(发货仓库和派送方式的组合)后,自动按照最优方案发货{break} 注： {break} - 如果订单为组套订单，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单来源为“平台同步”并且电商平台为“速卖通”或“TIkTok”，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果客户下单时指定了批次商品，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单的收货人类型为“FBA转仓-VC订单”或“FBA转仓-非VC订单”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单包含不允许拆单的增值服务，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 预售订单无在库库存不支持推荐仓库和产品发货{break}',
  't041qm': '产品不能超过 {recommendMaxProductCount} 个',
  'zn3DrJ': 'SKU不允许拆分到多个仓库发货',
  'znH959': '编辑仓组',
  '2Ydaow': '日期格式适用国家',
  'Amn7e1': '请输入批次日期格式',
  'HPr7xm': '请提供商品上的日期格式，实物到仓后依据此格式进行采集核对商品日期',
  '2A0aBn': '进口申报价值',
  'Mg5eiu': '批次日期格式',
  'qB04Og': '上传实物上的批次信息示意图',
  '/earsF': '费用合计_明细',
  'FVI3+2': '请选择{fieldName}',
  'Ms1ITn': '价格',
  'VVcSSC': '分区价预估',
  'ruoc98': '分区',
  '1t+pdo': '条码值(FNsku)',
  '9qb/fX': '勾选此服务后，将为您采集包裹上的快递单号，并在入库单显示快递单号与包裹条码的关联关系。',
  'ACbtGO': '如果您选择了提货日期无法选择到提货时间段，请选择其他日期，谢谢！',
  'BkIerX': '此入库单提交后将无法再次编辑移除单和商品信息，请确认信息无误后再提交，感谢配合！',
  'JWCoTB': '以下费用为预估费用，最终以实际收费为准。',
  'SYvcgF': '移除单操作说明',
  'ZXB19i': '移除单号最多支持输入10个',
  'o9M0aX': '如您未进行Amazon店铺账号授权，请<url>点击链接</url>进行授权。授权完成后需开启自动同步移除单设置，请<url2>点击链接</url2>进行开启。',
  'xXyarK': '快速注册商品',
  'y7R4i8': '可用产品共 {a0} 条 不可用 {a1} 条 <a2>展开不可用的产品</a2>',
  'yVvA0A': '识别码类型请选择[入库单号]即可，亚马逊移除快递单号后续将为您自动同步，无需再手工录入。',
  'xHe3ea': '条码值为通过亚马逊移除单号同步的FNsku信息。请您填写并绑定对应商品的Winit商品编码。如您尚未注册商品，请先注册商品后再进行绑定操作。',
  'Q1REvd': '<span>注：以下费用为预估费用，费用冻结时间为：国内验货仓验货完成/直发海外验为已提交。{break}</span> <span>账户可用余额小于系统预估费用则无法提交订单，烦请在下单前确保账户可用余额充足。</span>',
  'pKedas': '<strong>单品化管理：</strong>一物一码。售卖的单个商品都只有全局唯一的一个单品条码。{break}<strong>商品化管理：</strong>一类一码。同一个SKU所有的单品都是相同的商品条码。{break}<strong>示例：</strong>{img}',
  'v1nBi8': '请输入批次日期格式',
  'xR0TDl': '<strong>裸货</strong>：没有任何包装的货物。{break} winit不支持裸货出库，裸货请维护出库包装。{break} <strong>销售包装</strong>：商品出厂时带有的包装。{break}商品为销售包装，且为高货值，则不支持直接出库，请维护出库包装。{break} <strong>物流包装</strong>：商品的包装可支持出库。{break}商品为物流包装，则支持直接出库，可不维护出库包装。{break} <strong>示例</strong>：{img}',
  '08FD55': '重开发票',
  '0mUTze': '+本期付款',
  '1Thrlh': 'Proof Of Delivery交付凭证，是指在货物交付完成后，收货方签署的一份文件或记录，用于证明货物已经按时、完好地送达并且已经被签收。',
  '2HVDUM': '账单模板',
  '3I1qk6': '接收邮箱',
  '6W0m3g': '请勾选计费明细再提交',
  '73GscL': '下载账单',
  '7gBBpn': '账单模板设置',
  '7hsSLH': '=预估总剩余待还USD-已担保金额USD',
  '9HN07h': '数据已为您导出,请前往【新报表管理】进行下载。如数据量较大，可能需要稍等一会。',
  '9TKbuS': '组合账单',
  '9zz9ZO': '=上期余额+本期付款+本期收入-本期支出',
  'A6Op4y': '各币种的剩余待还按实时汇率转USD展示',
  'AZj+tf': '生成对账单',
  'Agccw2': '温馨提示{break} 1.支持自定义客户名称格式和自定义发票地址{break} 2.支持自定义付款账号{break} 3.已生成的电子发票不支持再次更改客户名称、地址{break}',
  'BHp1I1': '=应还金额-已还金额',
  'CVEBvE': '账单类型',
  'D61vFu': '客户名称格式',
  'D9OL3m': '指本期账单的消费支出合计',
  'DNxAOh': '上期余额',
  'EuwSjA': '为保证计费明细数据完整，请您在账单日上午9:00后再提交下载申请',
  'Fm/6zF': '下载计费明细',
  'GCMCkP': '-本期支出',
  'HgHOzH': '组合',
  'IZLNsL': '选择计费明细',
  'JVXLNs': '正在生成{text}，请稍后再试',
  'JsuXOm': '独立',
  'K2nEHB': '担保还清',
  'KGWfZy': '当前账期无{text}',
  'KZIm0Q': '下载发票',
  'LyL2IF': '下载成功后将会发送费用明细文件至您的邮箱，请准确录入接收邮箱。',
  'MI4Snx': '账单',
  'MLkOlx': '逾期天数',
  'MfytXC': '无欠款',
  'N2BWAQ': '是否分币种开票',
  'NLMRo3': '请勾选文件类型之后再点击确定',
  'O7Eu2j': 'example',
  'OQMV/1': '统计本期账单日及之后的已还款金额，若本期账单日及之后有付款、返利、重算退费等数据进来，该金额将持续更新，直至账单实际还清后不再变动。',
  'PVWng2': '凭证文件',
  'Pg9Rpj': '=剩余待还',
  'Pm2h+6': '请选择文件类型',
  'Q5w/fU': '应还金额',
  'Rxln8B': '正在生成文件，请稍后再试',
  'SNNgc9': '区间不大于31天，且不能选择当天',
  'U2D3GT': '支持付款币种',
  'UIxU1v': '海外仓账单',
  'VDNJ1O': '-已还金额',
  'VqHQ0G': '预估总剩余待还金额(USD)',
  'W4h+L/': '前往下载',
  'XEpI/L': '未还清',
  'XQVNb1': '账单区间',
  'biRBp6': '若您需定制账单模板（收费服务），请联系销售或客服。',
  'cMgr3G': '开具电子发票',
  'dH6HXW': '有余额无欠款的账户给欠款账户担保还款的金额',
  'dgSE4n': '导出账单列表',
  'e8F20V': '选择是，一个币种一张发票；选择否，所有币种只开具一张发票',
  'fLrdaK': '独立账单',
  'gATNz6': '开具发票',
  'gCCsj6': '自定义账单',
  'hT0UeC': '通用模板',
  'hzb2RD': '本期账单应还款金额，=本期支出-本期收入+往期未还清金额',
  'iiJJ9Q': '下载凭证文件',
  'ilUGfb': '已担保金额(USD)',
  'k6WL09': '设置接收邮箱',
  'kCUOZc': '预估最低待还(USD)',
  'kpqLgd': '请选择计费明细(仅供参考, 实际以账单为准)',
  'l217Ij': '请填写正确的email',
  'l7612M': '计费明细',
  '3xw2pa': '=本期付款入账金额（付款金额-付款手续费）+本期购汇转入-本期购汇转出',
  'pOpm5W': '归档日期获取异常',
  'pRnE4N': '当前账期无凭证文件',
  'qVilOl': '温馨提示：请下载文件之后进行解压处理才可正常打开',
  'qkVFdo': '+本期收入',
  'sJ4LRj': '定制模板',
  'sP9NPq': '=上期账单的期末余额',
  'tbHHxh': 'ISP账单',
  'tyeviX': '实际还清',
  'uM3JdF': '自提签名文件',
  'v5/qhM': '账单状态',
  'vkMWl1': '下载对账单',
  'vwIDLR': '发票地址',
  'wEsN/D': '，下个账单日生效',
  'wkJVRb': '账单日',
  'wngIz/': '请选择海外仓账单模板，更改后下个账单日生效',
  'xFfCkV': '=期末余额',
  'xf4Cok': '由于计费明细数据较多，预计需要1～3小时完成下载。',
  'xjL8gr': '账单模板已更改为',
  'xsgE1x': '指本期账单的返利、商务折扣、重算退费等收入合计',
  'KRm37t': '担保还清指拿无欠款的账户余额给欠款账户进行担保还款，暂时避免账单逾期',
  '/+6Tlk': '未退款',
  '/Ppy4h': '交易时间',
  '1976aM': '美付宝',
  '2Kxmmo': '转入',
  '2zFaPz': '翼支付',
  '30EC+P': '申请时间',
  '3I0TSX': '提交证明',
  '4hcFAe': '已成功开出电子收据',
  '4zuYYE': '购汇汇率',
  '5+bLlU': '批量导出失败',
  '5vhDlk': '付款主体用户名',
  '6JSgZS': '购汇记录',
  '6K/bMl': '易联快捷支付-新',
  '8RMxkK': '解冻',
  '9h6CQ0': '确定进行此操作吗?',
  'AmlBt7': '待入账减少',
  'C0unZT': '付款方式',
  'CiDzns': '交易名称',
  'DCknXQ': '易联快捷支付-旧',
  'EFfAoQ': '易联',
  'EH123B': '拉卡拉',
  'Ewl2Oe': '开具电子收据',
  'GCRkX0': '转出账户名称',
  'HRMFFC': '付款/汇款日期',
  'IYQMcP': '转入账户ID',
  'IugZez': 'payoneer',
  'JZ/pPr': '失败反馈',
  'JjMaCQ': '富友',
  'Maoscw': '线上付款单',
  'NSzPbt': '转出',
  'OQovFR': '单据号码',
  'Omkcu0': '已开收据',
  'OrfTjz': '付款日期',
  'P3OAHZ': '汇款日期',
  'PczLtN': 'WorldFirst',
  'UQsx/X': 'AIRWALLEX',
  'VCMN8h': '扣款',
  'VCcwE6': '转出币种',
  'VGUUOs': '退款状态',
  'WjALRF': '更改付款人',
  'XWzXar': '转出账户Id',
  'XkQfZs': '线下付款单',
  'bNGPYA': '是否冻结',
  'cA1Ws2': '转入账户名称',
  'cNbG7k': '下载电子收据',
  'eHCi/8': '入账完成时间',
  'fFCfj0': '审核意见',
  'fmLMom': 'paypal',
  'gbprFA': '银盈通',
  'gspCjo': '待入账增加',
  'jrDkH0': '待入账冻结',
  'n1BMn0': '购汇时间',
  'nTUBhV': '审核备注',
  'olossh': '授信额度',
  'qAYUi5': '转入币种',
  'sgoT1L': '系统授信',
  'tnA6LP': '全额退款',
  'v0uPwE': '还款方式',
  'vPm/tD': '待入账解冻',
  'yEiEuN': '初始化',
  'zkp5Gj': '当前账户对应币种的现金余额',
  'cOfpGZ': '金融账户线下付款',
  'sbK/du': '部分退款',
  'tBCWIa': '线下付款收款账户',
  '/LN0dz': '提交认证材料',
  '06ydEC': '工商/公安机关出具的更名材料',
  '0WyKK9': '授信额度详情',
  '1Be2tl': '本次没有重新分配额度！',
  '2XlYQy': '线上-payoneer',
  '2dR8L8': '固定额度长期调整',
  '3BpBXg': '添加付款人',
  '4usBT3': '币种类型',
  '5A94rW': '头程临时额度详情',
  '6YVRXw': '您提交的信息需要在银行返回脱敏卡号的基础上补充隐藏的部分，例如：6222****1314 ，填写：622200001314，只需要真实的补充*号的部分即可 。',
  '6c9bAh': '支付渠道返回卡号',
  '6iq4+V': '付款人维护',
  '7J3yRf': '请将匿名信息补充完整',
  '7kLsHL': 'ISP自动购汇转出币种优先级',
  '82wYZO': '请输入{min}~{max}的数。',
  '9sWKE8': '海外仓自动购汇转出币种优先级',
  '9xdXiy': '支持200个任意字符',
  'ARUtA1': '修改手续费',
  'B7sWL9': '授信手续费率(日)',
  'ByGlnw': '本人确认以上信息真实有效，并严格遵循《中华人民共和国反洗钱法》相关规定，同时同意该账户建立成功后，本人的历史待入账将转移至此账户钱包，本人确认已经同意并知晓以上内容。',
  'C31gUe': '账号组额度信息',
  'CaL1j5': '固定额度开通',
  'Dk/nSd': '客户可用状态',
  'DnvIjJ': '账单还清后恢复',
  'EP3hY+': 'Winit账户',
  'FN2KJv': '临时额度到期',
  'Gl93ta': '商业登记证',
  'GyK2ns': '入账账户ID',
  'HTyEWD': '水单附件',
  'I5P0tH': '调整值(USD)',
  'JUra4d': '到期',
  'JnSTBq': '是否临时额度',
  'K2AUa1': '总额度',
  'KYUIZR': '账单还清',
  'LSMhE9': '逾期手续费率(日)',
  'LVcITT': '-已用额度',
  'MTRndr': '原订单信息',
  'MXGoMs': '额度占比',
  'N+aVj3': '个性化设置',
  'P0+Vn4': '现有额度',
  'R/khAR': '证明材料类型',
  'SCtQJF': '延期还款',
  'SWt3dI': '临时额度到期时间',
  'T8zx3Y': '登记付款人（英文）',
  'UH1oUV': '线下-转账支付',
  'UpsVgV': '额度币种',
  'Uz5q4D': '总额度信息',
  'UzfgD8': '只显示2018.03.22之后的额度变化信息',
  'VZcKf/': '开通',
  'WDhkia': '若当前主体未注册子账户，请务必先前往注册子账户，在子账户认证通过后，再提交关系证明！',
  'XNwxfY': '线上-paypal',
  'Xv6Zt3': '固定额度临时调整到期',
  'XvglP0': '入账账户名称',
  'ZbuQhO': '系统自动恢复',
  'aCHUPv': '提交关系证明',
  'aKhgRz': '固定额度临时调整',
  'ahpaj8': '账户组',
  'aoySH5': '账单逾期末还暂停',
  'c+HGJC': '还款优先级',
  'c8pyCO': '额度生效时间',
  'cRkUwN': '账单逾期未还',
  'e2EuFU': '支付渠道账户信息截图',
  'exDDgb': '调整后复原',
  'f9UHPd': '完整姓名',
  'fP/5jz': '原付款记录',
  'fhs4vd': '额度共享',
  'fxBfjX': '已签署',
  'g0Ks/u': '重新分配后的子账户额度之和，已超出总额度，不允许提交！',
  'hh028b': '未签署',
  'hjFT+i': '子账户签署',
  'jryv+i': '停用',
  'ldrfDm': '固定额度到期',
  'mWrcQ+': '实际信息',
  'ms8jKv': '调整后临时额度(USD)',
  'mx4b6E': '额度失效日期',
  'p6R2U5': '临时额度生效时间',
  'pmdXFO': '登记付款人（中文）',
  'pxlLW/': '临时额度开通',
  'qoUX1p': '固定额度长期调整到期',
  'sLaJS7': '支付渠道',
  'sxulyn': '重新分配额度',
  't9Zbku': '登记付款账号',
  'vFLRB0': '子账户额度协议签署状态',
  'vePxOp': '正常',
  'vrGnEX': '匿名信息补齐验证',
  'w6ND0+': '补充&验证付款人信息',
  'wzdVDX': '审核时间',
  'x/gO31': '主子关系证明状态',
  'xSPqpc': '您提交的信息需要在银行返回脱敏名称的基础上补充隐藏的部分，例如：张* ，只能填写：张字开头，2个字的姓名，只需要真实的补充*号的部分即可 。',
  'xWutar': '是否可分配',
  'xqOuVQ': '自动购汇转出币种优先级',
  'yTqIuo': '额度到期时间',
  'yqSzWz': '额度生效日期',
  'zYHOkU': '完整卡号',
  'zcNWAZ': '实际付款人（中文）',
  'zmRPq1': '=剩余额度',
  '/KdHB0': '请选择实际付款人（中文）',
  '07XnFn': '转账支付',
  '3YpJS6': '上传材料',
  '4168zc': '海外仓冻结交易明细',
  '9Y//gQ': '已担保还款金额生效时间',
  '9cS3L3': '导入只支持jpg，jpeg，png，pdf,文件大小小于5M',
  'BEAP5q': '请上传材料！',
  'E8ZNSd': '额度自动调整',
  'F2CUgO': '线下',
  'GOarWl': '请输入完整姓名',
  'K6sGHx': '渠道',
  'MJttIP': '主',
  'OrTfWA': '线上',
  'UKRYgR': '文件大小需小于5M',
  'VPky+K': '无额度',
  'XA24ZP': '额度人工调整',
  'ZT1qr1': '温馨提示{break} 1. 如需查询和导出12个月以前的历史数据，请联系在线客服。',
  'ZWTiom': '海外仓额度',
  'Zr9Dss': '失败',
  'b2xoKS': '账户Id',
  'bE8OQ2': '重新分配后，留给主账户的额度不能小于主账户的已用额度！',
  'kqFivl': '已担保还款金额详情',
  'lDtEGy': 'Payoneer',
  'lcVvbr': '请输入完整卡号',
  'nzAb/p': '基础额度',
  'osNaFE': '富友快捷支付',
  'r/V4bn': '主体一致的证明材料最大上传五个文件，证件照片需清晰、完整、无反光',
  'sfnAcf': '新增付款人',
  'y6RlMb': '易联快捷支付',
  '0+2kI2': 'paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准；其他线上渠道则全额退还。',
  '32FSGv': '该笔金额将在',
  'JY6Tha': '（拖动可更改排序）',
  'g2OLbW': '待入账退款手续费说明：',
  'tAmjwH': '备注：',
  '/pYzfM': '1. 系统会在每月的1号自动生成海外仓账单，每周1自动生成ISP账单。过此时间还未生成账单，则请联系客服。{break} 2. 如需下载2021.12.31以前的历史账单，请联系在线客服。{break} 3. 只有2017.07.31以后生成的账单系统才提供开具电子发票，并不再提供人工开发票。自定义账单及2017.07.31以前的历史账单系统不支持开具电子发票，如需开发票请联系万邑通在线客服。{break} 4. 如需生成3个月以前的自定义账单，请联系在线客服。{break} 5. 2018-02-04升级后 “本期费用” 分为 “本期支出” 与 “本期收入” 。2018-02-04以前账单的 “本期费用” 只在 “本期支出” 列显示。{break} 6. 只有2023年6月之后生成的账单才支持下载计费明细；只支持下载近6个月的计费明细，若需导出12个月以前的数据，请联系在线客服。',
  'yI753E': '情况说明',
  '3Y7klw': '错误信息',
  'L3hqUI': '是否立即启用该配置？',
  'T65PYY': '{text}已失效',
  'Yh7u3v': '智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息,基于配置的发货策略计算出最优发货方案(发货仓库和派送方式的组合)后,自动按照最优方案发货{break} 注： {break} - 如果订单为组套订单，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单来源为“平台同步”并且电商平台为“速卖通”或“TIkTok”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果客户下单时指定了批次商品，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单的收货人类型为“FBA转仓-VC订单”或“FBA转仓-非VC订单”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单包含不允许拆单的增值服务，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 预售订单无在库库存不支持推荐仓库和产品发货{break}',
  'EP+LXH': '多个单号需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'aqlBZQ': '(送仓准备中：我司会根据服务时效安排送仓,请您耐心等待)',
  'z6C48a': '多个快递单号需换行或用英文逗号或英文分号隔开',
  'vtc2Bz': '您未选择产品组，请至少选择一条记录后再保存',
  'H3MIdb': '数据已为您导出,请前往【自定义账单】进行下载。如数据量较大，可能需要稍等一会。',
  'bv8fp+': '批量导出交易明细',
  'yg+WfY': '暂无数据资料',
  'DeRAMA': '1. 只有2017.01.01以后付款成功的付款单系统才提供开具电子收据，并不再提供人工开收据。2017.01.01以前的历史付款单系统不支持开具电子收据，如需开收据请联系万邑通销售代表。{break} 2. 线下付款单通常需要1~3个工作日才会入账。{break} 3. 由于监管要求，待入账金额将在付款后的第12天自动发起退款并原路退回，请保证对应的账户有足够的余额用于扣款，否则将影响下单！{break} 4. 待入账退款手续费说明：paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准；其他线上渠道则全额退还。',
  'Rel6LS': '1. 如需查询和导出12个月以前的历史数据，请联系在线客服。',
  'drKhD7': '1. 如需查询和导出12个月以前的历史数据，请联系在线客服。{break} 2. 授信手续费、逾期手续费，币种CNY/HKD的最小收费金额为0.1，币种GBP/EUR/AUD/USD/CAD的最小收费金额为0.01。',
  'nVnqxu': '1. 可设置自动购汇转出币种的优先级，在自动购汇还款时若有多个币种可用余额＞0，会按此顺序自动购汇还其他币种欠款。{break} 2. 转入币种的优先级，按欠款原币金额从大到小顺序，依次还款。{break} 3. 购汇时间，预付款账户，每天凌晨自动购汇；额度账户，账单的最后还款日的每天凌晨自动购汇。{break} 4. 币种CNY/HKD的最小转出金额为0.1，币种GBP/EUR/AUD/USD/CAD的最小转出金额为0.01。',
  '8ScwNO': '如需查询和导出12个月以前的历史数据，请联系在线客服。',
  'aRdrxL': '1. 付款时，如果支付渠道返回的付款主体用户名与接受付款的万邑通账户名称不一致，该笔付款金额将暂缓入账。{break} 2. 请您在12个自然日内，根据提示上传相关材料，证明付款主体与接受付款的万邑通账户是同一主体，逾期未证明的付款，将被原路退回。',
  'eocwkf': '请点击文件上传',
  '2BWMJO': '员工',
  '5gvduE': '企查查信息/公司年报 (扫描件/复印件/照片/截图均可)',
  '7q44jI': '户口本/结婚证 (扫描件/复印件/照片均可)',
  '7wqEOF': '当月',
  '8C681+': '我已阅读完毕并同意',
  '9NStpL': '关系证明-朋友&非直系亲属 (双方签字证明)',
  'Dvsk2S': '关系证明-同一集团或实控人 (双方敲公章)',
  'FTcmHB': '下月',
  'GKmXYb': '下周',
  'IDhXnO': '请勾选',
  'K6KFx2': '同意',
  'TRJ2m9': '属于同一个集团或同一最终控制人',
  'bO/2Dn': '每周一',
  'iW2zML': '直系亲属 (配偶、父母、子女)',
  'ijzBKx': '每月1号和16号',
  'kEnOJX': '第三周',
  'ljo7wL': '每月1号',
  'lz37HI': '朋友或非直系亲属',
  'mb1NTL': '第四周',
  'qbyohT': '额度协议签署',
  'tAGBJe': '社保证明/劳动合同 (扫描件/复印件/照片/截图均可)',
  'vAuGZ8': '第二周',
  '/6gyil': '重置为默认值',
  '8TJtfD': '下载附件',
  'QxCYIy': '海外仓账户默认：USD → CNY → HKD → GBP → EUR → AUD → CAD顺序购汇。 例如：USD、CNY可用余额＞0，自动购汇时会先用USD购汇还其他币种欠款，若未还清会再用CNY购汇继续还。',
  'WnGw42': '当前账单无计费明细',
  'iyWSE7': '我已阅读并同意',
  'n1Vx1f': '您提交的信息和银行返回信息不一致，例如：张* 可以填写：张三，不可以填写：李四',
  'qEIdoZ': '《额度授予协议》',
  'v/il0E': '《担保协议》',
  'KofsN/': '股东\\法人\\董事',
  'G85A7S': '1. 付款主体名称与我司注册名称不一致时，将在第12天自动发起退款；为避免影响您下单，请使用相同主体名称进行支付。{break} 2. 待入账退款手续费说明{break} <a2>Paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；其他线上渠道则全额退还。</a2> <a2>富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准。</a2> 3. 我司坚决执行《中华人民共和国反洗钱法》的相关规定，付款后如需退款，将由付款渠道原路径退还。 对涉嫌洗钱、虚假交易等行为，我司有义务向相关部门举报并协助公安机关提供证据。{break} 4. 点击可查看收款说明 <a1>收款说明></a1>{break} 5. 如您的主账户主体无法付款，请直接变更主账户主体，无需注册子账户。{break}',
  'nEoXwk': '1. 线下付款单通常需要1~3个工作日才会入账。如急需使用付款金额，请用线上付款。{break} 2. 付款主体名称与我司注册名称不一致时，将在第12天自动发起退款；为避免影响您下单，请使用相同主体名称的账号进行支付。{break} 3. 待入账退款手续费说明：{break} <a2>Paypal、Airwallex、富友信用卡超过90天及线下转账渠道按照到账金额退款，原付款手续费不退还；其他线上渠道则全额退还。</a2> <a2>富友线上超过90天的退款、易联线上超过350天的退款及线下转账退款，额外产生的退款手续费，按照实际发生的费用扣除，请以实际到账金额为准。</a2> 4. 点击可查看收款说明 <a1>收款说明></a1>{break} 5. 如您的主账户主体无法付款，请直接变更主账户主体，无需注册子账户。{break}',
  'v2HOxg': '1. 同钱包内，支持不同币种相互转换，不支持同币种转换。{break} 2. 不同钱包之间，支持任意币种相互转换。{break} 3. 币种CNY/HKD的最小转出金额为0.1，币种GBP/EUR/AUD/USD/CAD的最小转出金额为0.01。',
  'Rg50kB': 'ISP账户默认：CNY → HKD → USD → GBP → EUR → AUD → CAD顺序购汇',
  'K/XBN5': '1.支持自定义客户名称格式和自定义发票地址{break} 2.支持自定义付款账号{break} 3.已生成的电子发票不支持再次更改客户名称、地址{break}',
  'qZjKi5': '支持自定义客户名称格式、发票地址、付款账号',
  '/HG2Ex': '添加SKU',
  '5qxgHV': '请勾选需要添加的商品',
  '8N9CHd': '策略优先级：自定义策略 > 全局策略',
  '97Ezg6': '设置销量参考周期',
  '9jy52o': '策略类型',
  'EhpZRc': '【{name}】策略添加SKU',
  'EwSqIq': '失效后将自动清空策略内SKU, 是否确认失效？',
  'G12/1D': '最多支持500个SKU编码',
  'GsiqV5': '查看全部{num}个',
  'H2OXqK': '推荐设置：单一产品按近4周，套装产品按近6周，箱产品按近8周。',
  'Hxs6Qn': '列表',
  'IUpc6p': '点击前往',
  'JLuSaS': '新增自动拆零策略',
  'K5qzOu': '全局策略',
  'LS1Plr': '共享库存自动拆零策略',
  'LU1GKG': 'SKU的关联策略仓库与当前策略仓库有重叠，不支持添加',
  'MHg1rP': '编辑成功',
  'MWfQTj': '全局策略不能失效',
  'MjhYfS': '策略已失效，不支持添加SKU',
  'Mxj3rv': '选择近X周的周均销量',
  'NxN2H3': '新增策略',
  'PGRHGF': '移除成功',
  'PMcYxK': '策略内SKU',
  'VJaooL': '设置共享库存自动拆零策略',
  'We/I3N': '未添加SKU',
  'Wf1RuS': '是否确认生效？',
  'X/lLj9': '关联策略',
  'cjZbLG': '在推荐设置的场景下，假设单一产品近4周的周均销量为100件/周，套装产品的近6周的周均销量为5套/周，箱产品的近8周的周均销量为2箱/周；则每周单一产品的可用库存低于100件且套装产品的可用库存大于5套或者箱产品可用库存大于2箱时，将自动触发套装产品或箱产品拆零，保证接下来一周单一产品的可用库存至少有100件。',
  'cz1Je0': '请输入中文、字母或数字',
  'd9QEcp': '适用仓库',
  'e6JvoK': '策略名称',
  'fMbkSR': '存在未完成入库单或库存，不允许切换共享库存！',
  'lYOl5J': '【{name}】策略内SKU',
  'lfSY4h': '失效成功',
  'nel6io': '此策略是为了避免因单一产品不足在出库环节进行拆箱导致影响订单的出库时效，Winit会基于自动拆零的策略进行提前调整库存！',
  'nxeBGd': '示例：',
  'pfdh/O': '添加成功',
  'sIBroV': '编辑自动拆零策略',
  'u9m/ZU': '说明：针对标准出库单以及自提出库单数据进行统计对应SKU在海外仓的销量【排除调拨、销毁等异常出库数据】',
  'vzfWmX': '生效成功',
  'wx/TF7': '是否确认失效？',
  'ySdsnX': '请勾选需要移除的商品',
  'zqbS5z': '是否有效',
  '2gRKLj': '此账号当前未配置共享库存自动拆零全局策略，为了不影响后续订单出库时效，在注册共享库存的箱产品或套装产品时，需要先配置共享库存自动拆零全局策略！{a}配置',
  '4heyxi': '您未签署{name}，验货类型无法选择客户自验货，请<url>点击链接</url>进行签署！',
  'dnCZn1': '您未签署{name}，头程类型无法选择卖家直发，请<url>点击链接</url>进行签署！',
  'BDNpYQ': '否，边验货边装箱（验货方式：新自验）',
  'ROVd94': '是，待验货（验货方式：旧自验）',
  'TImPz+': '【是，待验货（验货方式：旧自验）】：已确定装箱信息，下单环节可直接录入包裹和商品的绑定关系。{break}【否，边验货边装箱（验货方式：新自验）】：未确定装箱信息，下单时仅填写商品信息，验货时扫描并绑定商品与包裹的关系。',
  'MB2LgI': '请先选择地址!',
  'VuUe2t': '请选择ISP账单模板，更改后下个账单日生效',
  'fijT/3': '单一产品A+包裹或箱产品的长宽高可不填写，系统将默认使用对应商品的核实尺寸或注册尺寸；如果填写了长宽高，则系统将以填写的信息为准。单一产品A/B/C包裹的长宽高信息则为必填项。',
  '+ON0XV': '体积',
  '2ud0Ps': '注册体积{unit}',
  '3Sf2xZ': '删除规格后，使用该商品时直接输入商品编码，无需输入规格，确认删除该商品规格？',
  '8nvAOf': '仅限已发布有规格的商品，才能批量删除规格',
  'LI0QcI': '核实体积{unit}',
  'Mit5WO': '仅限已发布的商品，才能失效',
  'ZjVhvB': '进口关税率',
  'aiBGBs': '删除成功',
  'bgMh+d': '删除规格后，使用这些商品时直接输入商品编码，无需输入规格，确认删除这些商品规格吗？',
  'fyQGOQ': '批量删除规格',
  'lZO/p4': '商品【{code}】存在待审核的信息，暂不允许失效！',
  'qgAEcy': '商品【{code}】存在的草稿或审核退回的信息会同步删除，是否确认失效？',
  'y/WY+Q': '删除规格',
  '0/JiLr': '取消原因',
  '0IvHRh': '业务单据号',
  '4Mjvd8': '批次号',
  '4eHs8/': '查看批次信息',
  '4uRbsZ': '批次日期',
  '7uzUWe': '增值服务信息',
  '8L1Vo2': '长（CM）',
  '96Mzoq': '已完成',
  'AmjYIb': '部分完成/退回原因',
  'DUdram': '轨迹信息',
  'E+q8Ix': '费用金额',
  'E64+fz': '服务要求',
  'LRFh5P': '货物信息',
  'U17oU+': '轨迹',
  'fRZHbx': '宽（CM）',
  'foMY4M': '增值单号',
  'l0mW6t': '最新更新时间',
  'myoSWy': '体积（CBM）',
  'n0ENBy': '取消成功',
  'rv/Usx': '增值服务名称',
  'sp7nZt': '高（CM）',
  't223jZ': '完成时间',
  'tBRn1O': '增值服务编码',
  'uV7dt+': '服务时效',
  've8HCy': '重量（KG）',
  'z0iqAA': '增值产品',

  '0G9X0v': '待提货商品数量',
  '0hxzxw': '查看异常图片',
  '1I0n5S': '新商品规格',
  '1sIR79': '提货凭证',
  '356QM5': '查看增值明细',
  '4MHR84': '新单品条码',
  '5FbBko': '异常对象',
  '67aNgO': '新包裹条码',
  '7je90N': '新商品编码',
  '85WD1d': '新商品库存单元标准件数',
  '92ekDt': '增值结果',
  'En+SYV': '异常终止',
  'Fp8Tez': '处理中',
  'GBUVRa': '新商品SKU类型',
  'GuCNNs': '实际包装材料',
  'HUsRbx': '容器信息',
  'JTcOXu': 'X/Y，X表示下发增值单数量，Y表示实际完成数量',
  'K7fvln': '新第三方商品条码',
  'KB9hTa': '新第三方包裹条码',
  'LltneG': '新第三方单品条码',
  'Pnfg9a': '更换商品包装数量',
  'QaDES9': '新入库单号',
  'QbqTeH': '上架方式',
  'QoasKf': '库存标准件数',
  'RjHfgY': '提货商品数量',
  'SS6m7z': '待自提',
  'YlP2qM': '取消时间',
  'b0ZfpV': '全部订单',
  'd/Js41': '新商品条码',
  'hdZRSS': '商品辨识数量',
  'iGo2n+': '贴标数量',
  'lGy6FF': '取消失败原因',
  'pHN8Vk': '销毁包裹数量',
  'sNXLd2': '第三方单品条码',
  'IqSvUm': '预计完成时间（当地）',
  'RsyScM': '取消中',
  '/lOLnU': '配套电池或纯电池',
  '08x8yY': '品类',
  '3LDpVN': '确认放弃更新这些商品信息吗？',
  '6a7FnP': '放弃更新',
  '8qMa5b': '确认放弃更新这个商品信息吗？',
  '9N69Wd': 'UK',
  'KY1hUt': ', 如对审核结果有疑问，请备注说明后重新提交！',
  'S+maKB': 'DE',
  'TKMdbN': '商品品类所需证书资料类型参考如下，具体以审核结果为准：',
  'c+Tzsj': '化妆品',
  'czdURM': 'US&AU',
  'gJpxi9': 'ALL',
  'inZ2fY': 'US',
  'jSrT6A': '化工品',
  'qlcOmV': '批量放弃更新',
  'vzV/vh': '德国交流电产品',
  '3ShLsH': '1.工厂出具的MSDS+运输鉴定报告；或检测公司出具的MSDS、产品标签图片',
  'C2Lc0y': '1.工厂出具的MSDS+运输鉴定报告；或检测公司出具的MSDS；2.CPNP注册+产品标签图片',
  'Hc/VCq': 'FDA注册信息、产品标签图片',
  'UBGvU5': '检测公司出具的MSDS、产品标签图片',
  'YYUhWG': 'EMC测试报告、LVD测试报告、ROHS测试报告、德语说明书、产品标签图片',
  'bIygCY': '1.工厂出具的MSDS+运输鉴定报告；或检测公司出具的MSDS；2.SCPN注册+产品标签图片',
  'qxXnHH': 'MSDS、UN38.3测试报告、产品标签图片',
  '5WtgqL': '实际散箱数',
  '77ijwJ': '实际托盘数',
  'ge0k/G': '是否全部打托',
  '8glgCt': '该winit入库产品不需要{field}，已默认清空原报关方式。',
  'SnK9qH': '进口报关',
  'WEOLvF': '出口报关',
  'fKCBMw': '进口/出口报关',
  '6SHbN1': '进出口商类型',
  'QBmXie': '<bold>致使用Winit澳大利亚仓库商家的重要通知</bold>{break}{break} 1.这是一则致货至Winit澳大利亚的悉尼和墨尔本仓库商家的重要通知和更新。如果您不了解或不遵守澳大利亚贸易和海关法律，可能会导致您的商品被澳大利亚边境部队（ABF）官员扣押，您有责任支付相关的关税和商品服务税（GST），并可能受到经济处罚。点击“确认”即表示您已经阅读并理解了此通知，并会确保遵守澳大利亚贸易和海关法律。{break} {break}<bold>商家的责任</bold>{break} 2.根据Winit的供应链管理服务协议（服务协议）和用户手册的规定，在将商品进口到澳大利亚时，商家有责任：{break} (a) 准确填写并提交相关的进口申报或自我评估清关申报（进口文件）；{break} (b) 在进口文件中申报商品的真实和正确价值；以及{break} (c) 支付与商品相关的澳大利亚关税和税款。{break} {break}<bold>商家低估进口文件中的商品价值</bold>{break} 3.Winit了解到，ABF正在调查并采取行动，以处理商家在报关单中低估进口到澳大利亚的商品价值，并因此导致适用关税和GST被低估或逃税的行为（逃避关税和税收行为）。{break} 4.ABF已发现部分商家利用电商履行中心（例如Winit在澳大利亚的仓库）进行逃避关税和税收行为，尤其是商家使用自我评估清关申报（Self-Assessed Clearance Declaration）来申报价值低于1000澳元的商品的情况。ABF正在积极监控商家发往Winit澳大利亚仓库的商品，以发现逃避关税和税收行为。{break} 5.逃避关税和税收行为是违法的，可能导致以下后果：{break} (a) 商品在澳大利亚边境被ABF扣押；{break} (b) 商家未来进口的商品在澳大利亚边境被ABF扣留；以及{break} (c) ABF就任何未付或少付的关税和GST向您发出要求或采取其他措施，您可能需要承担经济处罚。{break} 6.如果ABF告知Winit商家参与了逃避关税和税收行为，Winit可能拒绝接收该商家的货物，并可能关闭商家的账户。{break} {break}<bold>文件保存</bold>{break} 7.根据澳大利亚贸易和海关法，任何向澳大利亚进口商品的人都必须在进口后五年内保留其所持有的与进口商品或其运往澳大利亚的货物有关的所有商业文件副本。ABF可以要求出示这些文件，如果不遵守ABF的要求，可能会被处以罚款。{break} 8.保留的商业文件必须包括证明进口货物价值和进口文件中申报内容的文件。{break} 9.为了协助遵守澳大利亚贸易和海关法，大多数进口商使用扫描和电子存储商业文件的系统，并为进口到澳大利亚的每件物品保存一个特定文件。{break} {break}<bold>聘请持牌报关行</bold>{break} 10.根据Winit服务协议和用户手册的规定，Winit不负责货物在澳大利亚的清关。商家在将货物进口到澳大利亚时，应聘请持牌报关行协助，以确保商家遵守澳大利亚贸易和海关法律。澳大利亚持牌报关行的列表可在此找到：https://www.abf.gov.au/licensing/brokers/brokerages。{break} 11.根据Winit服务协议和用户手册的规定，Winit不是，也不得在任何进口文件中被列为“进口商”或“收货人”。持牌报关行可以帮助商家准确填写进口文件。如果进口文件没有准确和正确填写，可能会导致上文第5段所述的后果。',
  'kkSJOW': '海外本地清关：出库单增值清关用途 ;头程清关：入库单头程清关用途',
  'CXgGuD': '进口国家/地区【{country}】存在待审核的数据，不支持更新出口国！',
  'YDqiDF': '出口国家/地区为美国时，进口国家/地区仅允许选择美国!',
  'U76H/p': '商品编辑，进口国家/地区不允许选择美国!',
  'l98JzC': '不同意',
  'q/ghwH': '知悉并确认',
  'dbqk8C': '系统通知',
  '4vbg3w': '商品注册失败',
  'TrLI6T': '禁止入库原因 :',
  'c8JvVZ': '限直发原因 :',
  'cwEnUp': '退回原因 :',
  'sEWD9z': '商品提交失败',
  'NzT9mX': '提交失败',
  '+DQSwD': '单一订单出库包装方式',
  '+Dyoci': '应暂存完成时间（当地）',
  '+Ex1Ub': '上传订单',
  '+MCCzw': '启动退货',
  '+d+5RN': '上传商品标签--UPC',
  '+nHJ/w': '节省费用',
  '+sAXDI': '账户组余额',
  '/2tze7': '您当前填写的信息未保存，切换到其他的出库类型系统将清空您已输入的信息，请确认是否切换？',
  '/Cq3eP': '平台订单号',
  '/b6CMw': '点击此处上传',
  '/dU+JR': '准时',
  '02l0Ae': '1.仅支持需要补充增值的标准出库订单;{break} 2.当前页面批量下单的订单不支持智能推荐；{break} 3.上传的订单的仓库必须相同，若存在不同出库仓库的订单请您分成多次提交；{break} 4.请先上传批量模板文件（一次不允许超过200个单），再提交增值服务，全部上传成功后再点击确认。{break}',
  '0OkKZE': '出完全部库存',
  '0SA8N+': '指定装箱仅支持单一产品、套装产品的A类包裹。即1个包裹限制只能装1种SKU',
  '0fFyLn': 'PickUp-三方面单',
  '1+N/2B': '上传标签文件对应关系',
  '1/ktAg': '上传BOL',
  '15E/3/': '本次总共选择{total}单，打印成功{successCount}单，打印失败{failedCount}单。',
  '1ECAGD': '导入只支持PDF格式文件',
  '1ES4Cj': '折扣',
  '1IlqrQ': '默认打托标准',
  '1ZZ4wT': '派送失败',
  '1dw1ka': '上传包裹标签',
  '1mMngo': '将在库SKU更换为其他SKU，可通过此服务将原SKU库存进行扣减',
  '2AuwQx': '出库单号',
  '2EGeQe': '该订单号允许重复',
  '2Lpdn9': '如果是三方面单 {a}',
  '2RLkKp': '<fw500>模板更新</fw500>: 支持在所有Sheet页面纵向填写SKU信息',
  '2zxhhz': '退货手工销毁',
  '3I/ms8': '地址正确',
  '3fzzUW': '提供自提出库服务，自提订单提交成功后可在指定时间预约到仓提货。',
  '3zOUmJ': '子订单信息',
  '4/kwLe': '批量作废',
  '40CuD+': '上传人',
  '434sTE': '查看标准说明',
  '47Gtdd': '示例图片',
  '4Jxo1m': '<fw600>填写tips</fw600>: {break} 1.如果同一订单有多个SKU，请填写多行SKU信息，并在对应的列【客户订单号】中填写相同客户订单号，且SKU信息对应的订单信息需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同时填写SKU信息，如果您的SKU较少，建议在#Sheet1 中填写SKU信息{break} 3.如果您的SKU较多，建议您在#Sheet2 中填写SKU信息，SKU信息里面需填写对应的订单所在的行号{break} 4.使用《标准出库-平台专用模板》时，若平台为“ebay”，则商品信息*必填Item ID和*Transaction ID、*Platform Seller ID{break} 5.请上传XLSX格式模板, 最多可导入5W条数据，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传{break}',
  '4NtVJg': '温馨提示，再次下单不会附带原单的增值服务，如需增值服务请在新单重新勾选。',
  '4SHLfn': '批量导入任务号',
  '4w2WuG': 'WINIT跟踪号',
  '50IN3Z': '需下载模板文件，填写商品编码与第三方编码的关系。',
  '50OvR9': '需下载模板文件，填写各个包裹的标签信息。(生成文件如上示例)',
  '5GSF64': '系统只提供时间周期为 {maxDates} 天的数据导出',
  '5S5tsO': '文件大小限制5M以内',
  '5gxemz': '提供第三方面单出库，自提订单提交成功后可在指定时间预约到仓提货。',
  '5t/r6A': '应出库日期(当地)',
  '5xs1cX': '商品编码个数超出最大限制{num}，请调整',
  '62zELz': '请选择出库类型',
  '65FwA5': '退货信息',
  '66A+Ni': '子单出库仓库',
  '6IbkK3': '点击下载模板',
  '6LYgjW': '请勾选左侧的增值服务～',
  '6aJQnL': '操作方式',
  '6hkcCU': '商品欧代标签存在不同',
  '6vtXkE': '商品英代标签存在不同',
  '773k6g': '原下单方案',
  '7B6nt3': '库内增值服务',
  '7G93qx': '请上传已填写商品信息的XLSX格式模板',
  '7cPWC5': '作废原因',
  '7jzaZI': '长宽高(cm)',
  '7lKqi+': '商品英代标签全部相同',
  '7uCeyn': '您选择的Winit产品不属于Winit Guaranteed Delivery可选服务或无法在Winit Guaranteed Delivery指定时间内送达，是否继续下单？',
  '8J8XY/': '分销商',
  '8PVXv+': '平台订单ID',
  '8VqvlV': '价格(原币)',
  '8hMZxs': '物料领用',
  '8rR3Jg': '派送商名称',
  '8rs/NL': '订单已生成出库单（批次号为 {taskNo}），点击确认按钮您将前往全部订单单页面查看您上传的订单。',
  '8wDxhI': '包材规格',
  '97k+rx': '添加一行',
  '9DFxej': '子订单[{orderNo}]退货超期未处理自动生成的订单，不支持作废。',
  '9ptMBm': 'WINIT包裹条码',
  'AD6FxO': '标签类型数量',
  'Al/UXu': '根据您上传的面单文件识别不出来跟踪号，请确认上传的文件是否正确？',
  'B2Cv/r': '指定商品组托标准',
  'B5ATQM': '标签文件存在不同',
  'B5nx/K': '贴包裹标签',
  'B6jIUx': '新增常用地址',
  'BHFoDf': '上传多个文件并提供和包裹对应关系',
  'BNXm17': '打包尺寸',
  'BlWytY': '请填写大于0的数，最多保留2位小数',
  'BlIeiJ': '视频查询',
  'Byb5tg': '上传多个文件并提供和标签对应关系',
  'C09zE5': '派送状态',
  'CMfUc1': '退货单号',
  'CPoCuB': '平台信息',
  'D0wNcl': '如以校验失败的地址下单，会导致妥投失败，且DHL packet service服务会收取地址校验费，建议下单前更正地址！',
  'D2yFUI': '平台商品ID',
  'D3cmbL': '下单仓库',
  'D8w/qv': '查看平台信息',
  'DJGKP5': '导入只支持XLSX格式文件',
  'DJqEEW': '请按以下说明选择文件类型并上传PDF文件： {break} 1.若订单顺序与包裹标签顺序一致，请选用【一份文件上传包裹标签】上传一份多页的包裹标签文件，上传文件后Winit将按照模版表格行对应订单顺序和包裹标签进行顺序匹配。{break} 2.若订单顺序与包裹标签顺序不一致，请上传多份包裹标签文件并上传订单与包裹标签文件匹配关系。{break}',
  'DLzlsg': '取消当前增值服务',
  'DXzi63': '容器号',
  'DYSv18': '下载装箱明细',
  'Dnvmrb': '根据您的订单信息未匹配到清关运输方式，请联系客服报障',
  'DrOmcS': '查看单品信息',
  'Drd4Cm': '未指定组托标准的SKU将默认此标准打托',
  'DshrUk': '上传英代信息',
  'EIMaiD': '后台导入',
  'EenrW5': '订单已生成草稿单（批次号为 {taskNo}），点击确认按钮您将前往出库全部订单页面查看您上传的草稿单或提交草稿单。',
  'EnI5P6': '确定进行此操作吗？',
  'EoGXO0': '库存类型',
  'EzuXw/': 'Item ID',
  'FTlLKH': '批次商品下单设置',
  'FVDTCu': '上传欧代信息',
  'FVM5pZ': '以下时间取操作地点当地时区',
  'Frjn9M': '选择其他产品',
  'G/EhYP': '推荐下单方案',
  'GB5SuZ': '总出库数量必须等于平台出库数量',
  'GRMbmN': '套',
  'GaK/Vr': '出库时间(当地)',
  'GpT0/r': '分销平台',
  'GstMVP': '批量导入商品模板',
  'H2Ir0k': '贴包裹需上传各包裹标签，上传包裹后请您下载模板文件，并在文件中填写各包裹对应的面单文件名！',
  'HHNWe8': '需下载模板文件，填写商品编码与欧代标签的关系。(生成文件如上示例)',
  'HODeyW': '说明：投保金额即为保额，指针对特定声明价值货物投保的金额，如投保金额为100人民币，则该货物声明价值即为100人民币。',
  'HPuNoQ': '校验结果',
  'HWAcVU': '第三方物流公司名称',
  'HhXur8': '收货信息',
  'Hxrofw': '校验国家、州/城市、邮编失败,您可以<url>点击这里</url>进行查询。',
  'I2h+Kv': '修改订单信息',
  'I5rvby': '如果是普通自提 {a}',
  'IUBOYb': '出库打托服务',
  'IWDyfz': '批量上传带增值的出库单',
  'IkoWrk': '您未选中商品，请选择商品',
  'IlMZBb': '上传面单',
  'IpEZ8l': '总计',
  'IshHqQ': '贴商品标签',
  'IwvlMe': '预售状态',
  'J/jch8': '请按以下说明选择文件类型并上传PDF文件： {break} 1.若所有订单对应的ASN标签一致，请上传一页一张的ASN标签文件并填写ASN号。{break} 2.若订单对应的ASN标签不一致，请上传订单与ASN标签文件匹配关系并上传标签文件。{break}',
  'J0D5h+': '开始时间',
  'JEUHWo': '总价',
  'JIUNqP': '注册公司名称',
  'JMPE8r': '托盘',
  'JRKRJu': '下载装箱明细模板',
  'JWp1+n': '取消此增值，系统将清空增值服务对应的服务要求和增值文件，请确认是否取消？',
  'JiY83H': '当前订单的收货人类型不允许超托时,不支持选择允许超托',
  'KAnh4T': '导入草稿订单号',
  'KJGutH': '服务编码',
  'KUggdg': '尺寸输入规则：长=最长边，宽=次长边，高=最短边',
  'KW8qOm': '选择模板',
  'KvSBDO': '本次总共导出 {total} 个订单，成功 {successCount} 个，失败 {failedCount} 个，抓取中 {obtainingCount} 个。',
  'L2yN1f': '温馨提示：以上费用为系统预估费用，最终收费按实际扣费为准；所有费用由用户直接支付，不接受第三方代为付款',
  'LFVWAz': '点击此处下载《标准出库-平台专用模板》',
  'LSjXDT': '子订单号',
  'LWJl4z': '当前订单的SKU预设了组托标准，仓库将按照预设标准打托。',
  'LcEeSH': '合计（原币）',
  'Lfctnu': '需下载模板文件，填写商品编码与英代标签的关系。',
  'Lmn5aa': '注意：{break} 1.仅支持第三方面单直接出库业务;{break} 2.请先上传批量模板文件，再上传第三方面单，全部上传成功后再点击确认；{break} 3.上传第三方面单时，需要上传文件名和卖家订单号的关系。{break} 4.第三方面单仅支持上传PDF格式文件{break} 5.请上传XLSX格式订单模板；{break} 6.最多可导入200个订单，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传；{break}',
  'MZImmT': '第一个包裹标签号',
  'MuoKTV': 'ASN标签号',
  'N2QSRJ': '选中的订单中存在【字段验证】为失败的订单，无法提交',
  'NDBcfT': '上传成功(条)',
  'NF8SKF': '指定批次',
  'NKvk/k': '需要订单状态更新至”暂存完成“后，再进行文件资料的补充',
  'NRCc5i': '自定义配置我的增值',
  'Nde41V': '德国地址校验',
  'NlQvfL': '修正前|修正后',
  'Nqqyky': '箱',
  'NwDD+7': '平台买家ID',
  'O2zmfw': 'Winit预计{time}送达',
  'O635R5': '跟踪号上传状态',
  'OOnFav': '公司地址',
  'OVPYND': '不通过',
  'OXLLOk': '发货VAT',
  'OgVdYL': '12位及以上（只能是数字或字母）',
  'OinASF': '新增出库单',
  'OjkedZ': '共选择{allNum}单{break} 验证通过: {successNum} 单{break} 验证不通过:<span> {failNum} </span>单{break} 不支持验证: {noNum} 单{break}',
  'OmRJNz': '标准出库-普通模板（导入草稿订单号）',
  'OtBOYx': '托盘尺寸要求',
  'OydMwQ': '查看商品组托标准',
  'PrLo66': '是否允许超托',
  'Q/v5qb': '【上传标签文件】请上传单张可直接打印的标签文件，避免将多个条码放在同一个文件中。上传的文件应为适合直接粘贴在单个商品/包裹上的标签。',
  'Q4u6Eq': '收件人城市',
  'Q6JH65': '已作废',
  'QG3yCE': '下载失败订单',
  'QPWEgx': '点击此处下载《销毁出库-通用模板》',
  'QfncnO': '提供Winit海外仓自提服务，提交成功后可在指定时间到达Winit海外仓完成自提。',
  'Qqgk1C': '预计送达时间',
  'QuMfBo': '费用更优方案推荐',
  'RMTT8J': '请输入库内增值服务名称',
  'RR2OQ+': '说明：投保金额即为保额，指针对特定声明价值货物投保的金额，如投保金额为100USD，则该货物声明价值即为100USD。',
  'RSe9dd': '最大可下单金额 取自可消费国家为发货地所在国或为ALL的账户中最多的可用余额，如有疑问请询问客服。',
  'RfJMgc': '坏账客户商品自动销毁',
  'RrGMSk': '前往草稿订单',
  'Rrp9mD': '一、若货物不属于转仓场景请选择收货人类型为“买家订单”；{break} 二、转仓货物若属于以下场景请选择对应收货人类型：{break} 场景1、Amazon Seller Central账号补货至亚马逊仓库，请选择“FBA转仓-非VC订单”{break} 场景2、Amazon Vendor Central账号补货至亚马逊仓库，请选择”FBA转仓-VC订单“{break} 场景3、不需要更换商品标签且收货人非Amazon仓库，请选择“转第三方仓”。{break}',
  'RyXQqJ': '上传时间',
  'SOKtWI': '返利',
  'Sd/K3d': '自提出库-第三方面单服务',
  'SmNURf': '如果您不需要这些增值服务,请取消勾选,取消后,在下单时系统将不会再向您推荐',
  'TE9fLA': '切换模板类型，系统将清空您已上传的数据，清空后需要重新上传，请确认是否切换？',
  'TNZK2r': '需线下增值',
  'TZSi0K': '根据您上传的面单文件识别出来的跟踪号[{a0}]和您填写的跟踪号[{a1}]不匹配，请确认上传的文件是否正确？',
  'TfqsbO': '德国地址校验结果',
  'ThdPvz': '上传托盘标签',
  'Til6hA': '提供从Winit海外仓到买家手上的点到点的物流活动',
  'TthmIg': '发货凭证一次仅支持 {max} 个订单，建议分批打印',
  'TwZVBu': '按下单日期当日汇率转USD加总展示,由于汇率波动,金额也随汇率动态变化',
  'TzYmJV': '请选择Winit产品',
  'U/VC1c': '确认提交出库单？',
  'U5Oz18': '订单{orderNo}已打印成功',
  'UIunAN': '合计',
  'USh36q': '该出库单尚未上传跟踪号',
  'UV/rmz': '需下载模板文件，填写商品编码与UPC编码的关系。',
  'UWp5me': '地址建议',
  'UhA9nk': '包裹标签号',
  'Uz8jF0': '切换文件类型，将清空已填写信息，您确认进行切换吗？',
  'VECjAW': '获取文件地址失败！',
  'VSoODL': 'eBay+',
  'VVoTD/': '(一共导入 {totalCount} 条，成功 {successCount} 条，失败 {errorCount} 条)',
  'VgYd5U': '跟踪号与订单关系模板',
  'VjGXk1': '上传标签编码',
  'VtILvi': '推荐',
  'VwfsyG': '服务名称',
  'W4m4yi': '总条目数',
  'W9/gSX': '下单指定批次',
  'WM1Y0D': '{0}仅支持大于{1}{2}，并且小于等于{3}{2}的投保金额，最多保留2位小数，请重新输入金额。',
  'WffqIr': '失效VAT冻结库存自提',
  'WpEGiG': '已分配',
  'WpcKmi': '查看生成文件',
  'XCM1oC': '全部ASN标签相同上传一份文件',
  'XOto+a': '账户余额不足，当前余额：{amountTotal}USD，订单预估金额：{amount}USD，请付款后下单',
  'XRKL56': '如果是平台订单 {a}',
  'XLw/TB': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传5000个商品,超出5000个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M,如果文件过大,请拆分成多个文件分批次上传{break} 4. 导入的商品如果已存在,导入后将覆盖原有商品的数量',
  'XaUufT': '最晚出库时间',
  'Y7VuWC': '如果是非平台订单 {a}',
  'YAhd/V': '最新轨迹',
  'YLFxSN': '商品数(总数/已完成)',
  'YML81t': '如果您这些仓库有库存的话，还可以节省 {span}',
  'YO3xxT': '总共导入 {num1} 条,校验成功 {num2} 条,校验失败 {num3} 条',
  'YSCxEM': '单个提交',
  'YTCWoO': '联系邮箱',
  'YW7cc3': '收货VAT',
  'YXI1uR': '您已经导入过此文件，请确认是否需要重新导入？',
  'Yb+UzV': '预计需等待 {predictTime} 秒，订单校验完成后可上填写增值信息，请您稍后！',
  'YhQ2ey': '所属sheet',
  'YmKEHX': '批量打印发货凭证',
  'YpIZck': '总出库数量',
  'Yrb5u4': '指定日期出库',
  'Z/p3Wh': '费用项',
  'Z6QOHS': '必大于0,小于等于可用库存',
  'ZIfuAh': '上传标签',
  'Zf9p2v': '批量选择商品',
  'ZxY3ke': '所选订单若处于出库确认，如取消成功，可能会收取订单作废费用；{break}所选订单若处于拣选中或拣选完成，如取消成功，会收取订单作废费用和重新上架费用，作废后无法撤销，您是否确认作废该订单？',
  'a5CPqJ': '点击此处下载《自提出库-通用模板》',
  'a88xyg': '产品/服务',
  'aHUIrW': '收货人类型即将更新，需要将您的增值服务文件全部清空。',
  'aQiOXp': '出货仓库',
  'acNis3': '手工下单',
  'aob7LP': '预计取件时间',
  'aq6K5m': '快递单号/BOL',
  'aqYzZC': '查看上传文件',
  'ardfyD': '针对第三方面单出库订单，需要WINIT协助交货给指定尾程服务商，可使用此模板。{break} - 此模板可支持的增值服务仅限于：出库加包装。其他增值服务需线下提供增值服务单。',
  'as2D1h': '需下载模板文件，填写商品编码与FNSKU编码的关系。',
  'bW1e0R': '请选择商品',
  'beZa6n': '上传商品标签，需提供商品标签以及商品编码与上传文件的匹配关系，请您先下载匹配关系模板！',
  'bijCNG': '作废订单',
  'bs99RG': '收货详细地址',
  'bxPEv+': '需下载模板文件，填写商品编码与英代标签的关系。(生成文件如上示例)',
  'byhnay': '商品组托标准',
  'cAZy20': '模板导入',
  'cgL+Sv': '包裹状态',
  'cgj8zj': '订单信息即将更新，需要将您的增值服务文件全部清空。',
  'coQgJF': '收件人邮编',
  'crlcm2': '面单信息',
  'cz74rV': '商品下架',
  'd3djw9': '最早出库时间',
  'd7oELP': '上传第三方面单',
  'dCjlw2': '准时派送',
  'dDAdR6': '需下载模板文件，填写商品编码与FNSKU编码的关系。(生成文件如上示例)',
  'df0DoP': '服务状态：<span>{serviceStatus}</span>{break}目标妥投时间:{targetDeliveredTime}{break}实际妥投时间:{actualDeliveredTime}{break}应出库时间: {targetOutTime}{break}实际出库时间: {actualOutTime}',
  'dsvRaJ': '需要暂存',
  'dzTL7Z': '复合订单出库包装方式',
  'e/x7rA': '商品类型',
  'e/yYiE': '批量导出（新）',
  'e4+j3h': '如果需要更多增值服务 {a}',
  'eCH8u3': '请选择有效的日期范围！',
  'eDbSh9': '担保',
  'eQQPv4': '预估耗时(分钟)',
  'fAPVId': '上传失败(条)',
  'fKxbAs': '作废结果',
  'fPKUBh': '上传ASN标签',
  'fexDv7': '是否预售',
  'forWFG': '获取导出文件地址失败！',
  'fsfYE2': '1.提货仓库地址和提货时间将在订单打包完成后提供,请留意主联系人邮箱或在订单详情页面查询;{break} 收到通知邮件后,凭出库单号、提货码信息到仓库自提;{break} 美国地区订单若是卡车公司提货,建议卖家提前与卡车公司确认并在提货前提供BOL文件给仓库,若提货人因仓库无BOL拒绝提货而产生的相关费用由卖家承担。{break} 2.自提单需打包完成后才支持提货,若因提货人提前抵达仓库导致放空由卖家承担相关费用。{break}',
  'fulsyY': '您更改了订单内的商品，需要重新选择增值，请确认是否需要更改?',
  'g+Qwn3': '费用明细',
  'gGL07o': '请输入商品编码, 多个商品请换行输入, 最多支持输入{num}个商品',
  'gM923M': '耗材',
  'gj4PmC': '不支持作废',
  'gtaRBw': '选择常用地址',
  'gw9jMp': '尺寸规格',
  'h+L5Oa': '标签文件全部相同',
  'hIYnem': '匹配关系模板文件',
  'hJmdHo': '允许同时操作的订单最大数量为 {max}',
  'hQUDGa': 'IOSS No.',
  'hTuIlj': '总出库数量必须大于指定批次出库数量',
  'hjjUgn': '每次最多支持提交{maxNumber}单，您选择了{number}单，请减少数量。',
  'hnxwdw': '派送完成',
  'iEYp1K': '一单多面单的跟踪号若为多个时请您填写主跟踪号，上传面单请提供pdf文件。',
  'iroH6Z': '出库完成',
  'itTkxY': '点击下载模板文件',
  'j2CnJn': '打托标准等级名称',
  'jC5cJ9': '请安排提货前先留意订单状态是否是打包完成状态，如果不是请联系在线客服',
  'jKQAn/': '进出口商信息',
  'jMku/A': '上传匹配关系',
  'jOOJ20': 'wGD校验',
  'jldSIC': '包裹标签匹配关系模板文件',
  'jq07Ch': '全部订单数：{totalCount}; 已校验订单数：{checkNum}',
  'jv0mRc': '文件名重复，请重新选择！',
  'k3HTaT': '组套关系编码',
  'k6VOTr': '买家ID',
  'kHi2k4': '请输入尾程增值服务名称',
  'kXUpBC': '店铺ID',
  'kjhfZH': '退货自动销毁',
  'klH6bS': '包材编码',
  'ktkm2G': '点击此处下载《标准出库-通用模板》',
  'kugx4v': '输入商品编码，或者双击选择编码添加商品',
  'kvwSlC': '平台交易号',
  'kw/r4N': '标准出库-普通模板（支持多种增值服务）',
  'l+Ey3+': '以上费用为系统预估费用，最终收费按实际扣费为准。',
  'l/eBoQ': '销毁/商品下架',
  'l9XE8F': '通过',
  'lWoH/C': '发生时间',
  'lYy9nF': '托盘码',
  'lcs8Cl': '结束日期必须在开始日期之后！',
  'lnucNJ': '跟踪号',
  'lyzr6E': '双击批量查询',
  'm17b5x': '设为常用地址',
  'm3thhL': '服务过程',
  'm5sTom': '优惠价',
  'mPGkgC': '自提出库-自提服务1.0',
  'mR+AbS': '模板文件',
  'my5+MV': '邮箱地址格式不对!',
  'n1fRuF': '子订单',
  'n4Uj59': '平台店铺ID',
  'njGJyr': '电商平台信息',
  'nnawzy': '原币',
  'nz5vIk': '待确认',
  'o4DYG7': '长宽高（cm）',
  'oG8Hy3': '确认添加',
  'oH6SVx': '仅支持第三方物流自提,托盘出库方式的自提需满足最小下单体积0.96CBM{break} 请下单后提交"出库增加/更改产品或单品标签"增值服务,提供第三方物流公司面单(快递面单/BOL等)信息{break} 自提单完成增值后请在Day2 24:00之前完成提货(增值完成当天为Day0),将从Day 3 开始收取滞仓费,滞仓费收费标准请见《增值与异常服务报价》{break}',
  'oHHxMC': '订单[{orderNo}]退货超期未处理自动生成的订单，不支持作废。',
  'oK0S4l': 'Transaction ID',
  'oXly2z': '签署相关协议',
  'ouOOBA': '派送商',
  'ozL2c6': 'ASN标签匹配关系模板文件',
  'p37xrN': '商品欧代标签全部相同',
  'p9SD4i': '销售总额',
  'pBvQw4': '上传商业发票',
  'pR+nKi': '一份文件上传包裹标签',
  'pafbPl': '上传装箱明细',
  'pam1F6': '上传标签文件',
  'ptBWFQ': '自动加包装',
  'pw6nJB': '原价',
  'pzINE7': '出库商品组套',
  'qC5Rts': '自提出库-自提暂存服务',
  'qK21Mm': '正常下单',
  'qKXRjL': '常用地址',
  'qVEbQk': '批量导入商品',
  'qXqspx': '组托标准名称',
  'qeijb+': '上传标签与包裹的匹配关系',
  'qm8Kc8': '仓库处理中',
  'qnPvi9': '批量导出（旧）',
  'qznrTS': '自提地址信息',
  'r/YGTN': '增值文件',
  'r4ktet': 'ASN编码',
  'rDmhRB': '超时',
  'rTOYrN': '点这里,还能再为您节省: {span} >>>',
  'sGF/mQ': '合计(原币)',
  'sIZFs0': '平台出库数量必须等于总出库数量',
  'sM4Kbb': '个人信息',
  'sWzcHw': '订单销售总金额',
  'sb1vdX': '进行中',
  'svNhj4': '推荐方案派送时效',
  't3/i/R': '增值服务设置',
  't4OrzR': '商品',
  'tE8T0+': '当前产品由于"{error}"原因不可用，请选择其他产品或取消增值服务[{serviceName}]',
  'tRKFpY': '原方案派送时效',
  'thGDHR': '多个单号需换行或用英文逗号隔开,最多支持{num}个,双击切换到单个查询',
  'tj9cGr': '计费产品',
  'tqI0pC': '打托标准等级',
  'tzzE+T': '请输入正确信息',
  'u96JkE': '我们为您提供了一项自定义偏好的增值服务设置功能，您可以根据自己的需求选择不同的增值服务内容进行设置。完成偏好选项的设置后，请记得点击“保存”按钮，以确保您的偏好设置生效。',
  'uAWnfm': '电商平台',
  'uYKziw': '包裹数(总数/已完成)',
  'uaFgSD': '日期范围不能超过一个月！',
  'ucXEJT': '导出清单',
  'uh/9ZL': '下单产品',
  'ukQdI7': '下载失败原因',
  'upDufj': '产品信息',
  'v04auv': '结束时间',
  'vHQASu': '派送时效(天)',
  'vJKdss': '收货人类型',
  'vKCjcc': '发件人VAT Owner',
  'vMg/7N': 'API下单',
  'vY4wOI': '库存单元{break}标准件数',
  'vtFAqc': '修改产品[{pscName}]时，系统显示不支持已选的增值服务[{vasName}]。修改后将清空选择的增值服务，需要重新选择。请确认是否修改？',
  'vvIwaz': '订单号 {orderNo} 校验不通过，原因：{msg}',
  'wQZP1z': '失败订单',
  'wQzRtS': '未分配',
  'wYm9QK': '商品明细',
  'weVvn9': '填写平台信息',
  'wehBYg': '跨境/跨区发货时填写，填写金额会均摊到商品并生成发票',
  'wftiJ6': '最多可导入5W条数据，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传',
  'wurdpg': '文字说明',
  'x34SYE': '上传并提交',
  'xBSsPx': '在Winit海外仓当中的滞销品进行销毁处理，从而减少卖家库存及仓储费',
  'xKfDzT': '合计节省费用: {span}',
  'xNdC7g': '平台选择错误将无法享受认证仓发货的保护政策。比如实际是eBay订单，但未选择“eBay”，eBay将无法识别订单是认证仓发货。',
  'xU66C0': '尾程增值服务',
  'xi9ohN': '发货VAT Owner',
  'xt+0Wf': '容器类型',
  'xvn3Wk': '导入订单信息',
  'y3Vt3x': '自提出库上传模板',
  'y6KQu/': '上传跟踪号',
  'yMdx29': '需下载模板文件，填写商品编码与欧代标签的关系。',
  'yPxAoX': '销毁单在下单成功后的2个工作日,开始停止计仓租费用。',
  'yTQ3Wj': '确认批量打印选中订单吗？',
  'ya6vKV': '输入编码搜索...',
  'ycrCub': '请填写作废原因',
  'ymeo/a': '{a}',
  'yt+3Z8': '托盘名称',
  'z4OEaB': '收件人VAT Owner',
  'zY9LUW': '该功能支持用户批量选择增值服务并上传标签文件，如贴商品标或贴欧代标等。',
  'zdrSdM': '件',
  'ze81cw': '贴ASN标签，需填写ASN编码以及上传标签文件。',
  'ztnKvN': '贴包裹标签，需填写包裹标签号以及上传标签文件。',
  '85cRES': '下单商品包含DG商品，为符合供应商要求，系统将自动创建【检查并补贴DG标签】的增值服务，并收取相应的增值服务费用，请下单后前往订单详情中查看增值服务及相关费用。',
  'EJp6Wx': '<fw600>填写tips</fw600>: {break} 1.如果同一订单有多个SKU，请填写多行SKU信息，并在对应的列【客户订单号】中填写相同客户订单号，且SKU信息对应的订单信息需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同时填写SKU信息，如果您的SKU较少，建议在#Sheet1 中填写SKU信息{break} 3.如果您的SKU较多，建议您在#Sheet2 中填写SKU信息，SKU信息里面需填写对应的订单所在的行号{break} 4.请上传XLSX格式模板, 最多可导入5W条数据，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传{break}',
  'IvZQuR': '请输入商品编码, 多个商品请换行输入, 最多支持输入{num}个商品, 双击切换到单个查询',
  'ad/9Ry': '最大可下单金额',
  'tmQnHt': '由于选择了增值服务【{vasName}】，尾程产品的收费金额已发生变化，请确认是否查看变化？',
  'bIB2Zm': '实际完成数量',
  'w17jPW': '下单包装材料',
  '3xLqg9': '宽(cm)',
  'OlONZd': '高(cm)',
  'WGqv+Q': '长(cm)',
  '+mYTzz': '您切换后的产品【{prductName}】中针对您已选择的增值服务【{vasName}】中只允许选择其一，切换后系统将清空已选择的增值服务和输入的服务要求，请确认是否切换？',
  '0GUHhL': '请至少填写一行包裹明细！',
  '0NMf6s': '创建增值单',
  '2AochY': '商品数',
  '3LM8lU': '请至少填写一行商品明细！',
  '5MxYVI': '账户组总金额',
  '6KBoID': '是否清空？',
  '9U9po2': '客户指定商品SKU及数量，仓库将商品外包装及销售包装拆开，对商品裸货及单品拍照，提供外箱条码1张（拆包前拍照），商品条码照片1张，商品实物照3~4张（商品全览图、商品细节图等）;{break}备注：无论该商品数量多少，针对同一个包裹下的商品只会提供一组辨别照片。',
  '9j7Ejw': '上传附件',
  '9sdcoI': '新建入库增值订单',
  'DjpAUg': '添加所有页商品',
  'FqKI0m': '搜索后显示格式为：商品编码-商品名称-规格【SKU类型-库存单元标准件数(若有)】',
  'G0LOPQ': '查看图片',
  'H4GzP7': '增值对象',
  'Iu8t4K': '服务时效(工作日)',
  'JZ3djF': '请先选择下单仓库',
  'KD95AN': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传5000个商品,超出5000个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M,如果文件过大,请拆分成多个文件分批次上传{break} 4. 导入的商品如果已存在,导入后将覆盖原有商品的数量',
  'KtSFd3': '请选择需要增值选项信息！',
  'N47jAg': '新建库内增值订单',
  'O8jTMP': '请输入商品编码,多个商品请换行输入,最多支持输入{num}个商品',
  'QcZ2zI': '勾选后将清空当前商品明细，自动带出订单内全部商品。',
  'QvJcOP': '增值产品信息',
  'RFAVvS': '客户无需选择具体的包材规格，仓库会根据实际商品的尺重选择合适的包材规格，具体请查看增值详情结果。',
  'RNIttq': '勾选后将清空当前包裹明细，自动带出订单内全部包裹。',
  'UjkhyX': '您已添加单品信息，如果需要切换到不指定单品，系统将自动清空已添加的单品信息，请确认是否需要切换到不指定单品！客户确认后，此按钮切换到关闭状态，系统同步清空商品列表已添加SKU',
  'Vsr+82': '文件上传中...',
  'WrVyB2': '按照商品级维度选择增值指客户仅需选择入库单下具体的商品，无需导入包裹，系统自动关联对应包裹。',
  'XM3VPI': '包裹明细',
  'Xy2gME': '异常明细',
  'YhoqBY': '是否指定单品',
  'YiuYrp': '按照包裹下的商品选择增值',
  'b4xwkc': '添加当前页选中商品',
  'etdYDz': '查看尺重测量商品明细',
  'fSD6JL': '新建增值订单',
  'fmfcfE': '商品总数',
  'gbv1sQ': '导入结果：总共导入{totalCount}条，校验成功{successCount}条，校验失败{errorCount}条',
  'hTBwMe': '标签类型',
  'hh1Cwv': '是否指定批次',
  'iOKwId': '新建出库增值订单',
  'ieevJF': '您切换的产品【{prductName}】不支持您已选择的增值服务【{vasName}】，切换后系统将清空已输入的服务要求，请确认是否切换？',
  'kQ18bf': '查看辨识图片',
  'kS86D/': '产品描述',
  'lV0eI9': '勾选选择订单内全部包裹，将自动带出订单的包裹明细（不包括已终止、已丢失、草稿、已卸货、部分上架、已上架、上架到异常区的包裹）',
  'nc5Ajp': '请勾选你需要操作删除的商品信息',
  'oLcSdY': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传5000个商品，超出5000个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M，如果文件过大，请拆分成多个文件分批次上传{break} 4. 导入的商品如果已存在，导入后将覆盖原有商品的数量',
  'ofdSOM': '确定添加',
  'rtucPA': '勾选选择订单内全部商品，将自动带出订单的商品明细，其中商品数量不包括扣货数量、丢失数量、终止数量、上架数量。',
  'sOnCAV': '您已添加商品信息，如果需要切换到指定单品，系统将自动清空已添加的商品信息，请确认是否需要切换到指定单品！客户确认后，此按钮切换到开启状态，系统同步清空商品列表已添加SKU',
  'stloSU': '清空',
  't0telM': '测量数量',
  'u/Qpw8': '按照商品级维度选择增值',
  'wV4yyB': '请选择需要下单的产品！',
  'xKfgtc': '请选择需要下单的Winit产品！',
  '0hMVUW': '选择订单内全部商品',
  'qbGfXL': '选择订单内全部包裹',
  'HBVOSn': '增值选项选择更换商品包装时，必须选择商品级-补贴原SKU条码或者商品级-更换新SKU条码',
  'vCj0xW': '增值选项选择更换商品包装时，必须选择商品级-补贴原SKU条码',
  'IFrTuT': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传500个商品，超出500个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M，如果文件过大，请拆分成多个文件分批次上传{break} 4. 商品列表按最新导入的商品信息覆盖更新',
  'Rc/YFn': '测量单品数量',
  'bowBV5': '上传标签对应关系',
  'yIwIol': '产品说明',
  '/lVXii': '导入的文件格式不正确，请导入文件后缀为{accept}格式的文件',
  'F0UzrE': '请点击【批量添加】按钮导入单品码',
  'o3sNed': '是否指定单品码',
  'ajg6I7': '增值货物发生变化，系统将清空已输入增值选项对应的服务要求和增值文件，请确认是否修改？',
  '2JJnID': '增值对象发生变化，系统将清空已输入增值选项对应的服务要求和增值文件，请确认是否修改？',
  'Fgj4rD': '您选择的增值服务【{vasName}】只支持针对下单商品在库随机抽取一件进行尺重测量，您可以在【{vasName}】服务要求列点击【查看尺重测量商品明细】查看测量商品明细',
  'BmD3S6': '侧面',
  'wbIglz': '正面',
  'xHvzLQ': '背面',
  'cFgopv': '以上为图例',
  '1sTzME': '注意:出库确认(截单时间内下单订单提交后2个工作日，截单时间后下单订单提交后3个工作日)停止计费.',
  'DQ9abk': '托盘限高(cm)',
  'DXNP2o': '托盘限重(kg)',
  'HaLIN3': '最高码托层数',
  'K741JW': '单层包裹数量',
  'MBR1/w': '批次信息',
  'U7gMvw': '后打单的服务(仓库打包完成后再向供应商获取面单)，显示实物贴的包裹条码；前打单的服务，显示的是系统虚拟的包裹号。',
  'ZDFgJ+': '预估|实际',
  'hBWthA': '您的商品在此仓库已无库存，请补货后再下单或更换其他仓库发货',
  'j3jXuq': '可用余额取自可消费国家为发货地所在国或为ALL的账户中最多的可用余额，如有疑问请询问客服。',
  'l/kT2w': '下载亚马逊装箱清单',
  'm4c9L2': '组托标准-商品分类',
  'onH0MX': '下单商品包含DG商品，为符合供应商要求，系统将自动创建【{name}】的增值服务，并收取相应的增值服务费用，请下单后前往订单详情中查看增值服务及相关费用。',
  'yLU9ZT': '最新轨迹:',
  'uk/z4W': '您当前未签署3.5版本的供应链管理协议，无法下入库单，请<url>点击链接</url>前往签署再进行下单！',
  'SELVtF': '出库数量大于可用库存数，请修改',
  'eEpHfM': '组套',
  'LpECFr': '<fw600>填写tips</fw600>: {break} 1.如果同一订单有多个SKU，请填写多行SKU信息，并在对应的列【卖家订单号】中填写相同卖家订单号，且SKU信息对应的订单信息需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同时填写SKU信息，如果您的SKU较少，建议在#Sheet1 中填写SKU信息{break} 3.如果您的SKU较多，建议您在#Sheet2 中填写SKU信息，SKU信息里面需填写对应的卖家订单号{break} 4.使用《标准出库-平台专用模板》时，若平台为“ebay”，则商品信息*必填Item ID和*Transaction ID、*Platform Seller ID{break} 5.请上传XLSX格式模板, 最多可导入5W条数据，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传{break}',
  '11sq5D': '<fw600>填写tips</fw600>: {break} 1.如果同一订单有多个SKU，请填写多行SKU信息，并在对应的列【卖家订单号】中填写相同卖家订单号，且SKU信息对应的订单信息需保持一致{break} 2.不可在#Sheet1 和#Sheet2 中同时填写SKU信息，如果您的SKU较少，建议在#Sheet1 中填写SKU信息{break} 3.如果您的SKU较多，建议您在#Sheet2 中填写SKU信息，SKU信息里面需填写对应的卖家订单号{break} 4.请上传XLSX格式模板, 最多可导入5W条数据，文件大小上限5M，如文件过大，请拆分成多个文件分批次上传{break}',
  'SJr/PB': 'eBay交易号',
  'XAs3Tz': 'eBay商品ID',
  'O5Xpbm': '增值处理中库存详情',
  'Ot1Uz8': '增值处理中',
  'KgnTRo': '快递面单',
  '0uVfj+': '批次日期[{batchDate}]产品批次号[{batchNo}]',
  'B10A4u': '商品编码[{merchandiseCode}]规格[{specification}]对应的批次日期[{batchDate}]产品批次号[{batchNo}]不存在,请您修改后再下单。',
  'BOUAuk': '商品编码[{merchandiseCode}]规格[{specification}]商品等级[{merchandiseGrade}]',
  'G/6Nal': '商品编码[{merchandiseCode}]规格[{specification}]]条码值[{barcodeValue}]不存在,请您修改后再下单。',
  'OOKwuL': '发货数量',
  'hG1yrq': '只允许填写<=可用库存数量的正整数',
  'iBWZUW': '可用库存不足,请您修改后再下单。',
  'mYXlzB': '条码值[{barcodeValue}]',
  'K6oqA6': '如何新增出库单',
  'JbYw2T': '库存不足,商品编码为：[{merchandiseCode}],规格[{specification}],商品等级[{merchandiseGrade}]',
  'RLYGF8': '仅限更新退回商品，才能批量放弃更新',
  '/U1cNQ': '登录邮箱',
  '1axc5j': '账号登录日志',
  '3YYAIP': '登录时间',
  'yBaWS7': '入库标签特征',
  'bFBzZ6': '入库标签特征指您实际包裹的贴标特征，请您按照实际情况进行选择！',
  'Ya9ARR': '请注意：在【海运整柜100%A+包裹】场景下，<red>每个整柜只能对应一个入库单</red>。请勿创建多个入库单或将一个入库单的货物分散放置在多个柜子中。',
  'bZZ7HX': '入库特殊业务场景',
  'ZkEwxh': '包裹类标签文件(批量)',
  'k5tKw4': '托盘类标签文件(批量)',
  'svkYiG': '上传文件标签对应关系',
  'vJHNAb': '商品类标签文件(批量)',
  'yyCms8': '订单类标签文件(批量)',
  '+oGSwv': '校验结果:被承运商验证为"地址错误"',
  '2gCQ22': '地址准确性校验',
  'MRrqU5': '您填写的收货地址被承运商验证为“地址错误”，建议您修正地址后下单。 使用错误的地址下单可能导致包裹投递失败，同时产生地址检验/修正费用。',
  'XpGvSQ': '地址准确性校验结果',
  'b5PSBI': '以下是建议地址, 请与收货人确认后再参考使用:',
  'x8DYRv': '地址校验异常，请联系客服报障',
  'A/vtZJ': '校验结果:被承运商验证为"地址正确"',
  '7l6zxJ': '弹窗公告',
  'OTY7H9': '该入库标签特征仅支持满足以下条件的SKU进行下单：{break}1、SKU的管理方式=商品化管理；{break}2、SKU的商品包裹类型=A+包裹；{break}3、SKU出库是否采集包裹码=否；{break}4、SKU批次管理类型≠保质期管理/生产批次管理；',
  '9JvAYe': '由于选择了增值服务【{vasName}】，尾程产品的收费金额及打包尺寸已发生变化，请确认是否查看变化？',
  'Og4xZy': '方案校验不通过',
  'P+RbEx': '当前统计值(不包含当前订单):',
  'VZm9tI': '当前订单值:',
  'e1mqpb': '预警值:',
  'C3m66g': '请再次输入相同的密码',
  'FKnMw9': '确认密码',
  'Pdx/YD': '密码',
  'ViVQNi': '角色',
  'cHq4Ya': '子账号管理',
  'gsk33w': '重置密码',
  'hzZoDq': '角色选择',
  'mxnPQs': '您确定要删除此子账号吗？',
  'EMs8M0': '导出报错文件',
  'D/UEIs': '立即付款',
  'xJrIYj': '验货途径',
  '10wVQz': '订单单品数的结束值不能超过9999',
  '4Ci0HB': '包装类别',
  '5F2n3z': '出库加包装规则',
  '6EIwDL': '编辑规则',
  '720Q8J': '查看规则',
  '8huAxo': '新增规则',
  'BCUZhM': '包装规则',
  'D5PNZX': '修改仓库系统将清空已选择的适用产品，需要重新选择适用的尾程产品，请确认是否切换？',
  'FLwmFx': '是否适用',
  'I7l7ML': '适用产品',
  'QuBYs8': '订单最大货型',
  'Wm6V6+': '订单单品数',
  'cfh9l+': '加包装规则',
  'fSrVg2': '修改为[{name}]时，系统将清空已添加的产品，请确认是否修改？',
  'g1o9oC': '适用尾程产品',
  'iKvNmh': '当您下单触发了WINIT复合打包限制规则时, 是否允许WINIT尝试加纸箱出库？{break} <radio></radio>{break} <span>注:WINIT复合打包限制规则参考【WINIT海外仓仓储尾程价格表尾程通用仓库操作】</span>',
  'qDfdJy': '产品已失效，请删除',
  'qwf9Nq': '产品[{winitProductName}]已存在，请勿重复添加',
  's1TEO4': '订单单品数输入的结束值要大于等于起始值',
  'tbiToK': '适用条件',
  'yJT89v': '请添加产品',
  'Caegz9': '订单最大货型：TM>T240>T120>T50>T25',
  'Ot+gGB': '当订单上未指定加包装且SKU上未指定加包装时，可选择在此处维护加包装规则，维护后，系统将按照此规则加包装',
  'TLFHiO': '订单单品数汇总后的值{break} 注：{break} - SKU类型为“套装产品”，单品数=库存单元标准箱件数*套数{break} - SKU类型为“箱产品”，单品数=库存单元标准箱件数*箱数{break} - SKU类型为“单一产品”，单品数=件数{break}',
  'lvDzTm': '请确认是否保存?',
  'eQfOBk': '您在偏好中设置了出库加包装规则，系统已按设置的规则加了包装，如果您不想加包装出库，请到偏好设置中停用规则',
  'Z4U9y+': '查看附件',
  'uY05bw': '不指定加包装',
  'cYiz82': '二级货型',
  's9YTfW': '件型',
  'sPfnYX': '一级货型',
  '2+PyVI': '指没有进出口资质，可以在本地进行交易采购的公司',
  'UnEWFb': '用于海外进口清关和海外仓出入库用途',
  'c5Nj/U': '用于头程清关出口报关',
  '/XIGWB': 'UK正常清关注册的客户可选择这个报关方式。DE客户能提供VAT+EORI号可选择为普通清关注册。UK直发递延进口商注册选择普通清关。',
  'XJzSbr': '需要使用德国电商清关的客户没有EORI下单选择使用的。没有EORI号的客户不使用我们头程为了注册德国LUCID也可以选择这个报关方式，可不填写EORI号，但是必须提供VAT号。',
  'dSTziS': '您的万邑联账号费用已经逾期超过30个自然日，我司已将本账号标记为系统坏账客户，并按约定处理了您的库存，如有疑问请咨询销售或客服。',
  'wRwbQA': '使用客户自有进口商做进口清关时，缴纳关税，暂不缴纳VAT增值税。UK的进口商申请该清关方式需要“英国税务代理的抬头信纸申明函”发至指定邮箱（可咨询销售开通），上传“PVA申请函”“出入库授权协议”“PVA声明函”。',
  'lCh5Kb': '坏账客户提示',
  'WgC6Gs': '正在导出中, 稍后可在 “<url>导出中心</url>” 查看',

  '42AeNT': '是否带有粉末',
  'Fm+Ssn': 'SKU指定入库包裹类型使用说明如下，请先仔细阅读后再打开。<url>《查看操作指引》</url>{break}{break}确认要启用支持SKU指定入库包裹类型吗？',
  'GCht0S': '支持SKU指定入库包裹类型',
  'GDVEVI': '是否带有磁性',
  'z0PUTp': '启用后，可针对SKU指定入库包类型',
  '++UdMT': '预计维护完成时间',
  '+LILpx': '规定时效',
  '0QchEc': '后续每200个商品任务会加1天维护时效',
  '6ybLAG': '已选中【{x}】条维护任务，其中超时【{y}】条，未超时【{z}】条',
  '7BlR/x': '商品【{code}】存在的草稿或维护退回的信息会同步删除，是否确认失效？',
  '8mYf5w': '是否开启',
  '8qzVqS': '加急维护',
  '9qDeNq': '提交时间相近的Winit会基于相同链接的商品进行合并为一个维护任务!',
  'BZjeOY': '≤200个/天',
  'FP7zbE': '00:00-24:00 提交的注册任务，第二天（工作日）18:00前维护完毕',
  'IeOpzM': '没有可操作的维护任务号',
  'L6GHh6': '加急维护提交失败',
  'Lnr2xY': '仅限注册待维护、注册退回、已发布、更新退回、更新待维护的商品，才能批量上传文件',
  'N7+Dp2': '任务号',
  'OMd2yU': '请选择需加急维护的商品后提交！',
  'OeLJXG': '周六 00:00-周日24:00 提交，第三天（自然日）18:00前维护完毕',
  'QR4q16': '不满足加急条件',
  'SNpV1H': '提交加急',
  'UEJHOb': '已选中【{x}】条维护任务',
  'UTPKAA': '周六至周日',
  'V4yQzj': '是否关闭',
  'VgW/4b': '提交注册日期',
  'XyFive': '仅限注册待维护的商品，才能加急维护',
  'Zbdxq5': '12:01-24:00 提交，第三天（自然日）12:00前维护完毕',
  'abtEse': '此维护任务已加急！',
  'cAoMRy': '商品【{code}】存在待维护的信息，暂不允许失效！',
  'g2t/yp': '商品注册任务量',
  'j9fgJe': '周一至周五',
  'k28aoI': '任务类商品数量',
  'kVa+IR': '打印条码',
  'o1jOma': '批量加急维护',
  'qqc3Vv': '提示：维护“未超时”的任务单次最多支持{totalQuantity}条，仅限{singleQuantity}次/月[本月剩余{remainingQuantity}次]',
  'qrgvkO': '法定节假日（中国）',
  'rKcJu1': '注册的商品会在{time}内维护完毕！',
  's5Fwma': '维护时效',
  'uYmUBT': '00:00-12:00 提交，第二天（自然日）18:00前维护完毕',
  'v0kTyH': "2024年8月31日起，商品注册模版新增'带粉末''带磁性'信息录入，请下载新模板提交商品注册信息！",
  'wGnRfF': '维护任务号',
  'wNzGut': '已发布的商品若修改需要维护信息，则需等维护通过后才会更新商品信息',
  '0/uZ2D': '已出账单的剩余待还金额按还款币种为USD换算展示，随每天浮动汇率变化。由于每天汇率变动及不同还款币种所用汇率不同，此金额仅供参考。实际还款请参照还款预估的待还金额。',
  '25Iz53': '剩余待还金额',
  'fBDO16': '转出账户ID',
  'sZYtw3': '1. 仅支持标准出库订单并需要补充增值服务。{break} 2. 批量下单页面不提供智能推荐功能。{break} 3. 请务必填写客户订单号，这是必填项。{break} 4. 所有上传的订单必须选择相同的仓库，如果订单涉及不同出库仓库，请分开提交。{break} 5. 每次最多可导入200个订单，文件大小限制为5M。如果文件过大，请分割成多个文件逐批上传。{break} 6. 操作步骤：先上传批量模板文件，然后提交增值服务，最后点击确认。{break}',
  '6uYvTI': '关联第三方条码数量',
  'GoNHt2': '关联商品规格',
  'Gr8TCE': '请先上传标签文件！',
  'Hh/ZWd': '增值订单号',
  'NuOfGy': '关联商品的条码类型',
  'OnpWLD': '关联的库存单元标准件数',
  'PMOlhJ': '关联第三方条码用于当仓库收到货物的条码无法识别,实际为客户的第三方商品/单品条码,客户可以下发该增值进行关联三方条码并下发仓库进行上架!',
  'T89W3a': '下载文件',
  'UfoHwU': '单号类型',
  'V9S9uv': '文件名[{name}]重复，请重新选择！',
  'cO5UFq': '关联SKU类型',
  'ggcKT8': '第三方条码',
  'giMLRM': '{eventNo}异常单号不存在',
  'm34H3v': '唯一标识码',
  'oijERP': '关联异常单',
  'rl5zz3': '文件大小不能超过{maxSize}M!',
  'vEYQZT': '单号',
  'vEuIg5': '标识码类型',
  'wmnWea': '关联商品编码',
  '6EEpFW': '若需删除标签文件，将同时删除原标签文件对应关系，请确认是否删除？',
  'XaZQMp': '若需重新上传标签文件，将清空原标签文件对应关系，请确认是否重新上传？',
  'Ds9qr8': '异常信息未登记第三方商品条码，无法选择该增值',
  'uS1tJ+': 'X/Y，X表示下单销毁商品数量，Y表示实际销毁商品数',
  'RC/HA7': '检测该增值服务已输入相关内容，下调数量将清空对应信息，确认是否清空？',
  'VX99e/': '销毁商品数量',
  'khx6h/': '该原子仅支持异常单入口下发!',
  '7eLyWG': '请选择要删除的商品',
  'QUMHES': '标签编码',
  'cErjIB': '恢复默认商品信息',
  'fn6TWE': '继续创建增值单',
  'nM2tb2': '暂存待处理',
  'x8lXXz': '重置成功',
  'Dg4vC0': '下单单品数量',
  'G5g/iN': 'X/Y，X表示下单销毁单品数量，Y表示实际销毁单品数量',
  'XbQUq7': '销毁单品数量',
  'xBu6OX': '完成单品数量',
  'f2lZyL': 'X/Y，X表示下发的贴标数量，Y表示实际完成的贴标数量',
  '/BhYUx': '处理方式',
  '4jItZi': 'VIP客制化指标',
  'jw6ytD': '报告',
  '0iQEVl': '同步主库存',
  '2Zx7sc': '当前数据获取时间2024-01-01 14:00:01 数据仅供预览',
  '3Pjapv': '请确保所有TEMU上建联的商品已分配组织及库存。未分配组织的商品将默认库存为{num}，会影响平台推单等操作{break} 目前存在{count}个商品当前组织库存数量为{count}，请尽快处理。 {link}',
  '3tpUnz': '如需调整商品库存分配，请在[库存管理-组织库存]中修改',
  '4Aiv9I': '当前数据获取时间2024-01-01 14:00:01 数据仅供预览，仅展示已完成匹配的万邑联商品和相应的平台商品',
  '6wHk32': '不在提醒',
  '8GCFT0': '同步平台',
  '8GRnN/': '万邑联商品',
  '8PygXr': '是否同步库存',
  '99t1qc': '支持分平台分配组织库存：帮助您锁平台，防超卖',
  '9n4qMZ': '同步库存类型',
  'Ca63SP': '平台同步更新指引',
  'EiExyD': '支持更多新平台同步库存：新增Temu,AliExpress平台库存同步配置',
  'GP4y0X': '库存变更后实时同步',
  'HR1sZX': '预览同步数据',
  'IWTIB3': '如需调整商品匹配关系，请在[平台同步-商品匹配]中修改',
  'J2ZoaX': '平台店铺',
  'JyARXC': '万邑联商品*数量',
  'M271K5': '同步库存规则配置',
  'MRcDmq': '同步组织库存',
  'MTYOZl': '去修改',
  'O6aX6h': '目前存在{X}个店铺未分配组织，请尽快处理。（涉及店铺：{platformAccountList}）{break} {XXX}店铺匹配到多个组织，暂不支持同步库存,目前存在{num}个商品当前组织库存数量为{count}，请尽快处理 {link}',
  'OsWrOU': '请选择指定商品',
  'Oyp6Ar': '指定店铺&仓库',
  'Q5Q+On': '指定国家',
  'QIhVr/': '如有疑问，请联系客服',
  'R2VEw4': '库存同步页面优化',
  'RcwF2N': '请选择规则状态',
  'SG7Fui': '多个商品名称需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'WZS4/k': 'eBay平台每xx分钟同步一次',
  'YTTk6E': '请选择规则名称',
  'YXJ9aP': '同步规则',
  'ZlfiBd': '指定商品',
  'b2W4L8': '更新成功',
  'cNOkF1': '已启用',
  'czv8e1': '站点',
  'dno1/E': '请先选择平台及库存规则',
  'fAuz9u': '预览库存数据',
  'fj7l5p': '请选择同步规则',
  'g6zRLA': '定时同步',
  'hAqYO7': '同步组织库存暂仅支持选择区域。若需同步某几个仓库库存总和，请在组织库存中分配',
  'iPtOqD': '自动发货下单后同步',
  'iYsMdD': '请选择指定国家',
  'jVHk8u': '店铺名称',
  'jqPOW5': '原eBay库存配置规则：挪入此页面管理，若您存在历史配置的规则，数据将一并迁移',
  'k214kS': '多个商品编码需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'lYWbGM': '您的商品在此仓库已无库存，请更换其他仓库下单',
  'nM5rsV': '预计同步库存数量',
  'o+Tex7': '万邑通海外仓',
  'qdXN6d': '选择商品',
  'sH8P2N': '已停用',
  't4qfmz': '查看规则介绍',
  'tyq1B+': '请选择指定店铺',
  'ua9R+2': '请选择同步库存类型',
  'wR9gzr': '仅同步已完成商品匹配的平台商品',
  'xciusM': '指定店铺&仓库&商品',
  'xiHXtm': '指定店铺',
  'yt9qAF': '请选择同步平台',
  'ywHog2': '规则状态',
  'wgY9RU': '切换同步库存类型，将会丢失当前列表指定店铺和商品数据。确定要切换嘛？',
  'kAV6Pj': '支持分平台分配组织库存：帮助您锁平台库存，防超卖',
  'mtLIlD': '指定商品&仓库',
  'quEI1p': '为了防止误操作及切换需要一定时间生效，同步库存类型{time}小时内只能切换一次，请谨慎操作',
  '8zd1Pr': '已达切换限制（{time}小时内只能切换一次），请勿频繁操作。若紧急需切换库存类型，请联系客服申请，敬请谅解',
  'QJCj/0': '当前数据获取时间{time} 数据仅供预览',
  'yce93p': '当前数据获取时间{time} 数据仅供预览，仅展示已完成匹配的万邑联商品和相应的平台商品',
  '6fCl6i': '汇率',
  'BB2ikr': '还款批次号',
  'C3Ij5H': '汇率日期',
  'C8HnT4': '还款账单',
  'pKN5uW': '1. 每天下午3点获取招行汇率作为次日的汇率使用，招行汇率查看地址{link}。汇率只展示近7天的数据。{break} 2. 转出币种指有余额的币种，转入币种指有欠款币种，如：充值USD还GBP欠款，则采用当天转出币种是USD，转入币种是GBP的汇率计算。',
  'WZqpxv': 'ISP已还明细',
  'a7wxBc': '还款金额',
  'rGtSfL': '还款时间',
  'th1faz': '还款明细',
  'xqS13l': '海外仓已还明细',
  '1IlxVZ': '汇率查询',
  '1bpn0q': '担保汇率',
  'E1eMGw': '担保记录',
  'I/X6Uf': '担保金额',
  'QbDRWw': '原币币种',
  'feZnQf': '担保币种',
  'q5d3vL': '担保时间',
  'r6xKrc': '原币金额',
  'CzKUXO': '请选择账户',
  'Ebq99k': '请选择账单类型',
  '1prDIo': '选择【一份文件上传包裹标签】，需要您确保文件内包裹标签顺序与装箱清单的包裹顺序一致，Winit将按照此顺序贴标。',
  'F8jfp0': '支持上传多份多页的文件，如单个文件内包含多页标签，则同时需要在对应关系中填写PDF文件的页码，Winit将按照指定的文件和页码贴标。',
  'XZRhcb': '选择【全部ASN标签相同上传一份文件】，需要您确保文件内包裹标签顺序与下单模板的包裹顺序一致，Winit将按照此顺序贴标。',
  'neUz85': '上传文件并提供和包裹的对应关系',
  'pFLKkN': '选择【一份文件上传包裹标签】，需要您确保文件内包裹标签顺序与下单模板的包裹顺序一致，Winit将按照此顺序贴标。',
  'ybewHv': '仅支持上传单份单页的文件，所有处理对象的标签完全相同。',
  'zALpCW': '选择【上传文件并提供和包裹对应关系】，需要您填写各包裹和上传文件的对应关系。支持上传多份文件，如单个文件内包含多页标签，则同时需要在对应关系中填写PDF文件的页码，Winit将按照指定的文件和页码贴标。',
  '2DrbeP': '第三方面单服务',
  'dj20MF': '自提服务1.0',
  'tDSpP/': '自提暂存服务',
  '06OsEH': '包材重量{break}(KG)',
  '47d8N1': '唯一识别码类型',
  '7B53IP': '包材外径尺寸{break}(CM)',
  '9BM1R0': '唯一识别码',
  '9zDqZw': '包材标准尺寸{break}(CM)',
  'EVT5uf': '您可以<url>点击链接</url>注册新的商品后下发更换新SKU条码增值重新提交。',
  'NGH30T': '增值服务：{serviceName} 只支持单一产品，您下单第一步选择的商品存在非单一产品SKU，请修改',
  'Pyomlx': '包材内径尺寸{break}(CM)',
  'Ziq7lV': '包材商品编码',
  'j6ntB1': '客制包材商品条码',
  '/FB7Vp': '组内商品编码',
  '/PTxEF': '启用仓库组',
  '/yffaD': '关闭组织库存',
  '00Xv+h': '已绑定的自动分配规则',
  '05DQ6l': '平台店铺信息',
  '07tt8s': '查看更多记录',
  '1+y1bf': '下单时指定分配 (暂未开放敬请期待...)',
  '1TVzx6': '组织库存{break}可用数量',
  '1ukyO/': '未添加商品',
  '2DPEbO': '导入/导出内容',
  '2FYaur': '请选择退货上架组织',
  '2Hmmtv': '组织编码/组织名称',
  '2UCGrz': '未绑定自动分配规则',
  '2sTxi7': '仓组内仓库',
  '3/8rtJ': '转移库存数量',
  '33DNab': '最多支持{num}个组内商品编码',
  '3nUEa0': '导出初始化模板及数据',
  '3ny3on': '待发库存',
  '3yklXZ': '下单商品',
  '4++SnE': '请选择公共池库存不足处理方式',
  '5Qc7Hj': '字符长度不超过24位',
  '6iBjmn': '组织编码【{x}】在【{y}】已存在，若【{z}】需要使用，组织名称需保持一致，建议选择已有组织编码进行新增操作！',
  '6tZ/1+': '是否关闭？',
  '74azmI': '文件不足需补充？<a>去编辑></a>',
  '83SQTp': '注意：创建仓库组后，API/ERP按主仓返回仓库组内库存信息；另外，仓库组配置的优先级高于原启用仓群管理、跨仓群管理的优先级！',
  '8IM/VX': '切换下单国家，将清空选中仓库和下单商品列表，请确认是否切换？',
  '8PwA5e': '库存设置',
  '8qMOuZ': '对应国家内不存在任意有效组织，<a>前往处理>></a>',
  '9Ai3+n': '注意，删除该平台店铺不再适用此组织库存，可能会影响此平台/店铺后续下单以及库存同步，是否确认删除？',
  '9GOQAZ': '库存管理维度',
  '9pkAz+': '自动分配规则：',
  '9qbR0x': '切换下单国家，将清空选中仓库，请确认是否切换？',
  'A1UnPb': '查看分配策略',
  'AqXCTK': '<url>下载批量下单模板</url>',
  'B8z1Yk': '组织(以下未指定组织库存不足时下单失败)',
  'BEPP+g': '待发库存详情',
  'BUSFFP': '所有商品',
  'CaVbi3': '继续调整',
  'CpPFKX': '不区分店铺管理',
  'EO9v0T': '编辑组内商品',
  'EYW63V': '分配方式',
  'F4fn5Z': '请选择不良品是否可用',
  'FhAaey': '显示近30天变动记录',
  'Fsizc+': '转出组织/名称',
  'GEQM/h': '导入/导出状态',
  'GxLLvQ': '国家【{countryCode}】的组织库存未初始化，不允许进行调整，请先操作进行库存初始化！',
  'H4yCmH': '至少要有一条平台店铺信息',
  'HBuPwU': '同国家组织编码不允许重复',
  'I37xbU': '请填写',
  'IP+jXQ': '店铺',
  'IbZi+n': '不允许重复选择相同的平台和店铺',
  'IrP5Xx': '请选择组织库存不足处理方式',
  'IxwwdH': '库内环节',
  'J1wj7m': '国家内所有组织失效才允许关闭,且关闭后将清空所有失效的组织信息。',
  'JESDBu': '上架后分配',
  'K5FdtU': '出库设置',
  'KGyDeG': '组织管理模式',
  'KeIHG5': '最多支持{num}个商品编码',
  'KsARVE': '入库环节',
  'L+bkwA': '退货上架组织',
  'LiMe6f': '未指定商品组',
  'Lntzil': '未设置[{countryCode}]的组织或未完成分配策略设置，请前往设置后再进行初始化！',
  'Lv0XhX': '国家{nationStr}的全局规则未完成设置，请完善后保存！',
  'MNXVRx': '启用组织库存',
  'MWwpe1': '请选择需要启用的国家',
  'MZdgiP': '冻结件数',
  'Ma8dWp': '指定部分商品',
  'MarGpd': '公共池库存不足处理方式',
  'Mj9ynL': '总可用库存',
  'MnS8fr': '批量下组织库存调整单',
  'O9gLkH': '单据号',
  'OT5/ik': '仓组名称重复',
  'Oxs/IJ': '无法溯源处理方式',
  'P+K6Pr': '分配策略设置',
  'P0CKu+': '组织详情',
  'P6pH0T': '组织编码',
  'PEIjVj': '新增组织',
  'PQbeYX': '商品组编码',
  'PkS0w0': '国家-组织管理模式列表',
  'QHMibT': '待发件数',
  'QavrS/': '规则名称',
  'R0kxbt': '组织库存调整单',
  'R1AWra': '接收组织/名称',
  'RDgk5M': '全局规则',
  'RbyWkB': '部分组织适用',
  'RkMw3V': '适用分配策略详情',
  'S1VEI4': '是否启用组织库存？',
  'SiZzRo': '选择商品组',
  'THHVjx': '新增自定义自动分配规则',
  'Ta3sML': '商品组名称',
  'TqfG+H': '未启用，不可编辑',
  'UXFmnr': '可用变动数量',
  'VCUzC7': '不允许重复选择国家',
  'Vcz4jn': '设置成功',
  'W3MKCX': '无商品组',
  'WDuBaK': '组织编码/名称',
  'WVYZTQ': '添加【{name}】商品组内商品',
  'WiIsHg': '订单类型-操作',
  'Wv1lPZ': '分配策略',
  'XhO5Xk': '新增平台/店铺',
  'YpfZ65': '是否关闭组织库存？',
  'YrE9ZY': '说明：海外每日当地时间0点执行分配！',
  'Z6z+qp': '否，从组织库存排除',
  'ZYpfKh': '是否需自动分配',
  'ZYwocN': '分配比例',
  'ZiIw56': '编辑组织',
  'ZtafHE': '组织名称',
  'a3i5lR': '提示：不良品切为可用进行库存初始化后，不支持变更！',
  'aV9FJR': '关闭成功',
  'ab9zcP': '选择添加',
  'aoVhjJ': '前往组织管理页',
  'bi2QaT': '请选择库存组织',
  'cAOQZZ': '待设置',
  'cvLQUR': '全部组织适用',
  'dKd38j': '请选择无法溯源处理方式',
  'e5yrxb': '出库数量大于组织库存可用数量，请修改',
  'f3Q3B+': '支持中文、英文、数字及基本符号!%-,./',
  'fByLAS': '期末可用库存数',
  'fKDEpS': '最多支持500个商品编码/商品条码',
  'fX8PsS': '期初库存',
  'frT5lF': '是，与良品一致',
  'fxJ2A4': '编辑全局规则',
  'g5duw8': '不良品是否可用',
  'greiLB': '所有组织比例相加不允许超过100%',
  'h9Zi8A': '编辑【{name}】商品组内商品',
  'hD/l+2': '操作类型',
  'iEr7Yj': '公共库存',
  'iPUZTb': '比例',
  'iRUm9e': '暂未设置商品组可先保存规则后再添加或立即前往添加 >>',
  'iw8JBy': '多个组内商品编码需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'jFV/PS': '未启用自动分配，则会默认上架至公共池，启用后会自动分配公共池的库存到适用规则配置组织内。',
  'k4R4oN': '多个编码需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'kFWSjf': '变动时间(北京时间)',
  'kTal8c': '业务单据',
  'lGIYNy': '近期组织库存流水',
  'lH5CEc': '我已知悉仓库配置的使用场景，确认需要使用此功能！',
  'lfUbAE': '生效中',
  'm2P0jx': '找不到店铺？<a>去添加></a>',
  'mA6taV': '注：库存不足向下取值，多余库存分配至公共池。',
  'mNQ9rR': '期末可用库存',
  'njWfGp': '确认移除吗？',
  'oUf21w': '仅支持英文、数字及基本符号!%-,./',
  'ob2lzc': '手动分配',
  'pAVVEX': '批量下单',
  'pSgnf3': '平台',
  'poqfFR': '不允许重复选择组织',
  'qN+r40': '双击切换到批量查询组内商品编码',
  'qT4N0f': '分配节点',
  'qwiW4l': '期初可用库存数',
  'rj1FnG': '可转移库存数量为:{realUsableQty},库存不足',
  'rkGaTC': '查看【{name}】商品组内商品',
  's1JabS': '下单国家',
  'sHewIU': '公共池',
  'sXYWIe': '分配比例设置',
  'satd2e': '查看流水',
  'sgSypa': '切换后将会清空以下列表已添加的数据，是否继续？',
  'stFVYC': '适用分配策略',
  't8rE2T': '组织库存的在库库存不含暂存RM码库存，若不良品配置为不可售，则不包含不良品库存。',
  't9BcSt': '创建组织库存调整单',
  'tIUEDk': '仓组名称',
  'tjYf78': '开启成功',
  'tzxFFx': '输入商品编码',
  'v013Hs': '货物在库内丢失后找回',
  'v58RVX': '请先选择适用国家',
  'vY86r/': '新增商品组',
  'vYSfcl': '组织库存不足处理方式',
  'wfMiN1': '组织',
  'wl0SFW': '库存组织',
  'wuECGB': '请输入0~100整数',
  'xNrgSc': '可转移库存数量',
  'xaJbmp': '关闭后将不会进行自动分配但原分配规则会继续保留，是否继续？',
  'xwLj+1': '未生效',
  'xzpkgM': '退货入库环节',
  'y7IuXR': '编辑自动分配规则',
  'yq0Wfa': '切换下单国家，下单商品列表，请确认是否切换？',
  'yt82oq': '已绑定自动分配规则，无法删除！',
  'yuDBWt': '自动分配商品组配置',
  'ywvM6Z': '适用商品',
  'zSagJu': '管理维度',
  'zbMJYb': 'Winit调整单号：{docNo}',
  'zhvmkQ': '请选择分配节点',
  '7c7h29': '请选择非出库消耗库存的处理方式',
  'EeSMVF': '商品组已有自定义策略，不允许添加！',
  'Feb0g4': '请选择非入库产品加库存的处理方式',
  'Fufjof': '检查策略是否设置完成，<a>前往处理>></a>',
  'WICKWi': '合并查询仓',
  'bK//gf': '非入库产品加库存的处理方式',
  'cV0Yy/': '非出库消耗库存的处理方式',
  'ckk76H': '货物在库内发生丢失、破损冻结、增值出库等非正常出库场景',
  'ctKGBq': '开通组织库存后，支持对Winit同一份库存进行拆分给不同组织(平台，平台店铺，团队/渠道)使用，开启后请继续选择需要启用的国家以及对应的管理模式和库存管理维度。',
  'xTLIgG': '<fw600>操作说明</fw600>: {break} 1、初始化成功后,订单将按照初始化后的库存进行分配冻结,若启用组织库存同步至平台,则会将对应组织的库存数量同步至平台!{break} 2、除指定允许使用公共池组织外,公共池库存对其他组织订单不可用!{break} 3、导入时SKU必须齐全,如存在部分SKU未导入将不成功!{break} 4、当前无库存无需初始化,自动更新库存为初始化完成。{break}',
  '39J8D8': '<strong>平台库存管理</strong>：应用于同一份库存拆分给不同平台或店铺使用，对应平台库存同步支持按分配后的组织进行同步，出库下单需提供平台信息。{break} <strong>团队渠道管理</strong>：应用于同一份库存拆分给不同团队、渠道使用，出库下单必须提供组织编码，与平台推单、ERP推单创建互斥。',
  'CL3sbp': '适用商品组',
  'RfaPml': '<strong>仓库级</strong>：组织库存根据实物库存同步库存，根据具体仓库进行管理库存。{break} <strong>国家级</strong>：组织库存根据实物库存按国家汇总国家内所有仓库的库存，无需分配组织库存至仓库维度，按国家进行汇总管理库存。',
  '5yWDeS': '批量下单失败',
  'gmmv7o': '第{index}行：{msg}',
  'E2W8HL': '组织库存可用数量包含订单所选库存组织的可用数量和公共池库存可用数量。',
  '+0tDgG': '挪入此页面管理，若您存在历史配置的规则，数据将一并迁移',
  '+RzevE': '否：无组织库存',
  '2IQ4IG': '原eBay库存配置规则：',
  '5Jcaq4': 'NEW',
  '8fL2iW': 'eBay平台每30分钟同步一次',
  '9nxpUA': '预计同步库存数据',
  'HxQTfu': '库存同步页面更新如下：',
  'KOB/Zk': '新增Temu,AliExpress平台库存同步配置',
  'eqriiv': '帮助您锁平台库存，防超卖。 平台库存管理暂邀请制开放，请联系客服申请使用权限。',
  'i0lbH+': '支持分平台分配组织库存：',
  's2CUA7': '支持更多新平台同步库存：',
  't2iHNJ': '更新',
  'ud1Gl4': '如有疑问，请联系客服~',
  'LNkhHz': '请确保所有{platform}上建联的商品已分配组织及库存。未分配组织的商品将默认库存为0，会影响平台推单等操作',
  'FiJma7': '帮助您锁平台库存，防超卖。 平台库存管理暂邀请制开放，请联系客服申请使用权限',
  'VZ+X/o': '您暂未开启组织库存权限，请先在[个人中心-偏好设置-库存设置]中开启组织国家权限',
  '0gq9mO': '{platform}平台暂不支持停用库存规则',
  'dWyauH': 'Aliexpress(海外托管)',
  'U2xihl': 'eBay库存规则当前页面已升级，历史配置数据已搬迁，请挪步至库存同步规则页面查看',
  'cUg6/f': '立即跳转',
  'jAdq2h': 'eBay平台暂不支持停用主库存规则，如有需要请在列表删除规则',
  '+gYY+c': '分区级别N天妥投率',
  '/LCltR': '小时',
  'E/bqbL': '分母（实际出库包裹数）：统计时间范围内，实际出库的包裹数；{break}分子（Ascan包裹数）：分母范围内，存在Dscan的包裹数。',
  'IIyGq5': 'Ascan率',
  'd1o3FQ': 'N天妥投率',
  'qYx2dy': '分母（实际出库包裹数）：统计时间范围内，实际出库的包裹数；{break}分子（Ascan包裹数）：分母范围内，存在Ascan的包裹数。',
  'reAu6u': '计算单位',
  '9wjUe/': 'Ascan及时率&平均耗时&Ascan率',
  'mrJoJE': 'Dscan及时率&平均耗时&N天妥投率',
  'utwdg2': '目的分区分组',
  'b6im02': '分母（实际出库包裹数）：统计时间范围内，实际出库的包裹数；{break}分子（Dscan包裹数）：分母范围内，存在Dscan的包裹数。',
  '1la4o2': '长*宽*高{unit}',
  '2s/F3l': '启用条码值库存管理',
  '2z0biH': '#带原木',
  '3XiN1k': '#化工产品',
  '5XYPrq': '#高货值(收费有差异)',
  '6gT400': '#带三合板或高密度板',
  'BKTNSa': '注册长*宽*高/核实长*宽*高',
  'BuWYZW': '#二手商品',
  'FhjmzP': '有过敏原',
  'HGjBIi': '#带磁性',
  'Kmi2zT': '#食品',
  'My7yVH': '#18+',
  'Ob+lrT': '#带粉末',
  'P8thZa': '确定生效? 生效后会立即调整库存查询方式，仓库组内仓库的库存均按主仓返回',
  'PMBp0w': '#带液体',
  'RnLp7c': '注册体积/核实体积',
  'VsgmEm': '仓库组内所有仓库的库存会合并至主仓显示与查询',
  'X0e6vT': '#带电池',
  'Y2Iwjt': '{tip}',
  'e11fjP': '体积{unit}',
  'emULBJ': '#带插座',
  'gsPTjg': '标准箱长*宽*高(cm)',
  'j2GBkQ': '确定失效？',
  'kqV2cw': '重量{unit}',
  'nrVjq9': '#包材商品',
  'rfo4U+': '注册重量/核实重量',
  'vv0hh3': '采集包裹码',
  'wS3w6e': '#退货商品',
  'xsTk6Z': '批次信息实例',
  'RJC56U': '请输入主单号',
  'Vm6LvY': '仓库[{warehouseName}],商品编码[{merchandiseCode}],规格[{specification}]库存发生变化， 禁止出库商品只允许单次自提所有库存，当前可用库存未全部出库，请将所有库存转移到同一个组织后重新添加！',
  '+vP+SG': 'AliExpress(海外托管)24年11月大促',
  '/cApcc': '应锁定量',
  '0GjTAr': '完结状态',
  '14g/Lr': 'AliExpress(海外托管)专享库存活动开始啦，欢迎踊跃参与！',
  '2N4FZ4': '锁库存剩余数量',
  '7C32RF': '《平台锁库存协议》',
  'CYi8IL': '已完结',
  'DMwUe3': '立即参与',
  'JMtGcm': '请先阅读协议',
  'K4E4Fa': '锁库存结余',
  'KrzXJz': 'AliExpress(海外托管)',
  'LMtxPc': '请输入商品编码，支持批量查询',
  'P3HDvw': '锁库存变动',
  'QFscDZ': '我已阅读完毕并同意{a}',
  'QxyKF1': '活动',
  'ULjwS9': '查看指引>',
  'WigRjw': '活动将于{date}日开始，请准时来参与并完成锁定',
  'XqcI4W': '活动时间',
  'YFUi1Q': '锁定量变动日志',
  'gQ4+K1': '日期',
  'ggwfF0': '推送状态',
  'm5TFEu': 'AliExpress(海外托管)锁库存活动导入模板',
  'stTlh/': '尊敬的商家：参与速卖通海外托管专享库存活动配置，速卖通会依据专享库存件数，对于资质符合规则的商家和商品，每次给与最高可达30%货值的提前放款福利，具体规则请在速卖通查看相关公告。 {break}{break} 注意使用前提:{break} 1、需要开启组织库存管理，{a1}{break} 2、需要为AliExpress(海外托管)平台创建唯一专属的组织，并为组织分配相应的商家数量，{a2}{break} 3、授权AliExpress(海外托管)，{a3}{break} 4、平台同步库存规则,AliExpress(海外托管)平台规则切换成组织管理，{a4}{break}',
  'x4lQTo': '尊敬的商家：速卖通会依据专享库存件数，对于资质符合规则的商家和商品，每次给与最高可达30%货值的提前放款福利，具体规则请在速卖通查看相关公告',
  'xxEkqr': '活动版本',
  'zNyLRU': '未完结',
  '/MUt5x': '启用仓库组库存',
  '58hly4': '说明：{break} 1、创建仓库组后，使用Open_API（含对接的ERP系统）按合并查询仓查询库存，则会合并仓库组内的所有仓库的库存后返回，且不支持按仓租内仓库进行查询库存；{break} 2、仓库组配置的优先级高于原启用仓群管理、跨仓群管理的优先级；{break} 3、本期万邑联库存页面查询暂不调整。',
  'YF0J+L': '确定生效? 生效后会立即调整库存查询方式，仓库组内所有仓库的库存均合并后按合并查询仓返回！',
  'lBsCBG': '我已知悉仓库配置的使用场景，确认需要使用此功能！（<span>特别说明：</span>创建仓库组后，使用Open_API（含对接的ERP系统）按合并查询仓查询库存，则会合并仓库组内的所有仓库的库存后返回，且不支持按仓租内仓库进行查询库存。）',
  '19b/CI': '我已知悉仓库配置的使用场景，确认需要使用此功能！（<span>特别说明：</span>创建仓库组后，使用Open_API（含对接的ERP系统）按合并查询仓查询库存，则会合并仓库组内的所有仓库的库存后返回，且不支持按仓组内仓库进行查询库存。）',
  'hBk4PW': '说明：{break} 1、创建仓库组后，使用Open_API（含对接的ERP系统）按合并查询仓查询库存，则会合并仓库组内的所有仓库的库存后返回，且不支持按仓组内仓库进行查询库存；{break} 2、仓库组配置的优先级高于原启用仓群管理、跨仓群管理的优先级；{break} 3、本期万邑联库存页面查询暂不调整。',
  'kjT4OO': '当前您切换验货类型后将清空当前的验货数据，该清空不可逆，请确认是否切换？',
  'IzLc7g': '回退草稿单，会同步取消您创建的预约单，草稿单如果继续提交，请在提交后重新创建预约单！',
  'hopP4K': '文件未上传成功',
  'HKRVa7': '已阅读并同意签署',
  'O1bX+T': '已阅读并同意更新',
  'q9tc4Z': '《万邑通海外仓商业性条款补充协议》',
  'u9tp6T': '《供应链管理协议》',
  'hWtisa': '新单上架信息',
  'R+0iVI': '下载增值结果图片',
  'rZWk1i': '订单批量上传设置：{break} 默认上传后的订单保存为“草稿”状态{break} 您可以选择【直接上传提交】，勾选后，在批量上传页面，您可以选择上传后的订单保存为“出库确认中”状态，上传后无需再提交订单{break}',
  'Ozl3ur': '前往已提交订单',
  'TDChQE': '设置我的上传偏好',
  'WAEEkr': '自提暂存出库（导入草稿订单号）',
  'XUIX90': '已提交',
  'a18vC6': '如果是自提暂存服务 {a}',
  'atrzHq': '自提暂存出库（支持多种增值服务）',
  'hn8/F1': '1. 仅支持需要补充增值的出库订单;{break} 2. 当前页面批量下单的订单不支持智能推荐;{break} 3. 上传的订单的仓库必须相同,若存在不同出库仓库的订单请您分成多次提交{break} 4. 请先上传批量模板文件(一次不允许超过200个单),再提交增值服务,全部上传成功后再点击确认。{break}',
  'lVaxXz': '您同时选择了【指定商品数量装箱】增值服务，请先上传装箱明细，然后再下载【其他包裹类标签或文件】的模板。系统会自动填充包裹序列号，避免重复填写。',
  'm3TyPy': '如果是三方面单服务 {a}',
  'gcULbV': '该功能支持用户批量选择增值服务并上传标签文件，如贴商品标或贴欧代标等。{break}该功能提供自提出库服务，自提订单提交成功后可在指定时间预约到仓提货。',
  '0kI3dV': '待客户确认',
  '2G6+VQ': '以实际报价为准,审核完成后请确认报价',
  '7Yargg': '单品',
  'Kh+jB9': '增值对象发生变化，已经添加的商品信息会被自动删除，确定修改吗？',
  'Yx+rpK': '确认报价',
  'cTokzx': '查看报价',
  '+7FoE0': '1.增值对象=商品时，需为增值指定商品信息。{break}2.增值对象=单品时，需为增值指定单品信息。{break}3.增值对象=其他时，无需为增值指定商品或单品信息，请在下一步选择增值服务产品时提供具体增值需求。',
  '5lK4bN': '仅支持{fileType}格式',
  'rCHoyP': '补充说明',
  'uwmfN9': '1.增值对象=商品时，需为增值指定商品信息。{break}2.增值对象=包裹时，需为增值指定包裹信息。{break}3.增值对象=订单时，无需为增值指定商品或包裹信息，请在下一步选择增值服务产品时提供具体增值需求。',
  '+YI1XG': '单一产品销量参考',
  '+eP0EZ': '使用第三方商品条码',
  '/s++ei': '请仔细核对所维护的第三方商品条码是否正确，若出现错绑或漏绑，后续将会导致上错库存、入库无法识别等异常，产生不必要的异常费用。',
  '11POth': '需出库采集包裹码',
  '2riisj': '风险提示',
  '3mZDwG': '单次拆零需求量',
  '6zMjBQ': '套装产品销量参考',
  'CprVCI': '是否需出库采集包裹码',
  'LHXw9T': '满足未来',
  'PN92Iq': '确认无误导入',
  'QdyY3D': '至少输入2个字符，双击切换至批量查询',
  'WjHtF1': '是否需入库校验实物条码一致',
  'XF2kX7': '设置单次拆零需求量',
  'd9/BRG': '箱产品销量参考',
  'gP0n6A': '开头是',
  'hOA76J': '等于',
  'nMoMXh': '需入库校验实物条码一致',
  'unwvr3': '请输入≤52的正整数',
  'y5s4nK': '至少输入2个字符',
  'yHzId3': '是否使用第三方商品条码',
  'zkVUHd': '最多查询{num}个，双击切换至单个查询',
  'JuNzF9': '此偏好设置默认值会被单个注册页面、注册模版引用，请根据实际业务场景选择！',
  'XKSryg': '默认为无需校验。若选择“校验第三方包裹码与第三方商品码一致”，则此商品在每次创建入库单时将自动生成一个增值服务单，用以在仓库入库上架环节校验第三方包裹码与商品码是否匹配【需收取增值处理费】，校验不一致则将拦截上架。（此功能需联系客户经理申请使用）',
  'gdOugC': '假设当前配置如下：{break} 设置周均销量参考周期：单一产品【近4周】、箱产品【近8周】 {break} 单一产品客户【近4周】总销量为：100件，则周均销量100/4=25 {break} 箱产品客户【近8周】总销量为：40箱，则周均销量为40/8=5 {break} 设置未来需满足的需求量：满足未来【5周】需求量，即 {break} 单一产品需求量：25*5=125件 {break} 箱产品需求量：5*5=25箱 {break} {break} 当单一产品在库可用库存＜125件时，在保留箱产品最小需求量25箱的情况下，将自动触发拆零，以满足单一产品需求量125件。',
  '0jyrwS': '已履约数',
  '3ABpBR': '已出库数',
  '4jTYjW': '已卸货数',
  '5nUP7h': '已Dscan数',
  'JLEpKl': '已Ascan数',
  'awHDKA': '已处理数',
  'hHhj5t': '已上架数',
  'rR8IIy': '已暂存数',
  'g2+Qaz': '及时履约率',
  '0VyNFr': '超时未履约未出库数',
  '2VBdzB': '未履约出库数',
  '3IT9O4': '已履约出库数',
  'fWuU1S': '时效内未履约未出库数',
  'kFqoD8': '已出库',
  'vYm9gA': '未出库',
  '6sRGhD': '应出库日期（海外仓当地时区）',
  'yCcbFa': '分母：目标出库日期范围内，非草稿/客户作废/万邑通作废/抓单失败作废的应出库履约包裹数；{break}分子：分母范围内，实际出库日期<=目标出库日期的包裹数；{break}公式：出库履约率=已履约出数/(已履约出库数+未履约出库数+超时未履约未出库数)；{break}注意：数据非累计值，需要结合日期来查看。{break}例如，20241028，应履约数为10，表示20241028当天应该要出库的包裹数为10（不含20241028之前的应出库数据），其它数值字段同理。',
  '0/oh6t': '所有包裹使用相同的标签，需上传其中一个包裹的文件，请勿上传重复文件。',
  'LOpyZ0': '上传一个单品的文件(请勿上传重复文件)',
  'P1jrho': '所有单品贴相同的标签，需上传其中一个单品的文件，请勿上传重复文件。',
  'SDVcmX': '支持上传多份多页的文件，如单个文件内包含多页标签，则同时需要在对应关系中填写PDF文件的页码，Winit将按照指定的文件和页码进行贴标。',
  'h5KDJr': '上传一个包裹的文件(请勿上传重复文件)',
  'vYrliL': '上传文件(请勿上传重复文件)',
  '/8alR4': '一致',
  '6Fz+Ci': '采集的第三方商品条码',
  'EeMYcH': '采集的条码对应商品是否一致',
  'RENO/4': '采集条码数量',
  'YN26Xr': '不一致',
  'a+1Vch': '采集条码示意图',
  'nSVlEa': '采集的第三方商品条码对应的商品条码',
  'u/mLpO': '不一致原因',
  'wGe4Z6': '采集的第三方包裹条码',
  'wuRf4t': '是否已采集条码',
  'xevV+W': '查看示例图',
  '+3xFjg': '推荐成功',
  '+LWuuv': '单仓推荐结果',
  '+oQtIQ': '出库数',
  '/KORqN': '推荐失败',
  '1ORJ7h': '升级至2.0版本后将无法回退至1.0版本，请您确认是否继续升级？',
  '1Tn8rf': '库存',
  '1ktbT6': '注：升级到2.0版本后，将自动选择最优推荐方案发货',
  '1rSNtA': '可自定义配置仓组',
  '1v9PKl': '智能推荐1.0和2.0版本的差异说明：',
  '4kQRdF': '客户订单号/订单号',
  '7KBSXt': '原下单产品',
  '7eKHJK': '费用最低>时效最短{break} 策略优先级不支持调整{break} <red>仅支持单仓推荐</red>',
  'AvnTVw': '在从1.0版本切换到2.0版本后，系统将根据以上2.0的功能初始化为仓组推荐策略配置。您可以根据需要随时进行自定义修改。',
  'BnTyyZ': '库存数',
  'E5PxaL': '查看日志',
  'EaCNoe': 'SKU信息',
  'FbO006': '原下单仓库',
  'GjDYjH': '1.0中的“GFS”等同于2.0中“平台同步”',
  'Lwij7I': '1.0的智能推荐区域内的仓库不支持自定义配置{break} 2.0可自定义配置仓组，仓组内配置对应的发货仓{break} 如：US_GROUP（{break} USWC2 Warehouse{break} USWC Warehouse{break} USTX Warehouse ）',
  'MP5s1M': '是否推荐',
  'Nj/NFB': '第{num}组',
  'Pi9Eo4': '项',
  'RgJnNO': 'API下单，批量上传，<red>GFS</red>',
  'TLmjdM': '仓库组合',
  'WZhBnF': '设置仓组库存管理规则',
  'XDe/3j': '发货成本',
  'YGCSHM': '1.0不支持自定义配置推荐渠道组{break} 2.0可根据不同的场景设置智能推荐渠道组',
  'Z/43fI': '不推荐的原因',
  'ZGp72g': '推荐结果',
  'aCoNjU': '推荐渠道组',
  'aY0yyd': '仓库优先级',
  'c9diHK': '日志信息',
  'cIkOY/': '推荐产品',
  'e9Qio7': '多仓推荐结果',
  'egHHtR': '当前版本1.0',
  'fJSAuQ': '2.0在原来的1.0策略的基础上增加策略：{break} <red>策略1：优先发多库存的仓库</red>{break} <red>策略2：仓库自定义顺序发货</red>{break} 新增的策略主要为了解决服务成本一致并且时效一致时筛选最优方案的场景，可按<red>优先发多库存的仓库 或按仓库自定义顺序发货</red>',
  'iH0v1D': '下单时间不能超过一个月！',
  'j3KqJP': '差异说明',
  'k8kDSD': '查看条码值信息',
  'mEBtRM': '支持自定义配置',
  'mwckV9': 'API下单，批量上传，<red>平台同步</red>',
  'n82G+/': '支持开启和关闭',
  'nMv4yf': '美国区,德国区,澳洲区',
  'nbwDiz': '推荐仓库',
  'pvjx2D': '如果您需要按仓组维度管理库存，请点击此处，可以“启用仓库组库存”管理。',
  'rpKkGh': '1.0 支持用户在有推荐方案时可以选择自动使用或不使用推荐方案{break} 2.0 默认情况下自动选择推荐方案',
  'rsqXJf': '推荐应用区域',
  'tV+NM4': '查看推荐策略配置',
  'uVM8Tm': '智能推荐日志',
  'wlvXCw': '服务成本最低>时效最短><red>优先发多库存的仓库>仓库自定义顺序发货</red>{break} 策略优先级支持自定义调整{break} <red>支持多仓组合推荐发货</red>',
  'wxm+/v': '立即升级至2.0',
  'ySJxcg': '仓库数量',
  'yqUlmI': '推荐策略',
  'zITEeG': '智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息,基于配置的发货策略计算出最优发货方案(发货仓库和派送方式的组合)后,自动按照最优方案发货{break} 注： {break} - 如果订单为组套订单，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单来源为“平台同步”并且电商平台为“速卖通”或“TIkTok”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果客户下单时指定了批次商品，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单的收货人类型为“FBA转仓-VC订单”或“FBA转仓-非VC订单”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单包含不允许拆单的增值服务，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 预售订单无在库库存不支持推荐仓库和产品发货{break} - 由于下单时未预估地址相关附加费用，可能会导致推荐结果出现偏差。',
  'pi6nIY': '当前版本：2.0',
  'YpNkdi': '导出文件为空',
  'NsbeKg': '不推荐',
  'TWIxab': 'Shein和TEMU平台订单使用【万邑联-平台同步】功能推单，由于平台限制，智能推荐功能将不会生效',
  'tSF35A': '您当前未开通智能推荐产品组的使用权限，请联系商务经理开通权限后再使用',
  'SQH+7B': '此配置信息为当前订单下单时的配置详情，作为分析推荐结果的依据',
  '4F7a+n': '是否属于尾程空运DG',
  'DX+dxO': '是否属于库内DG',
  'Shg80a': '特殊属性',
  'UIUy5F': '是否属于尾程陆运DG',
  'j2Iqat': '是否属于特殊化工产品',
  'MdMQ5M': '最小值必须大于{min}',
  'QpT+5u': '取消增值',
  'sowY5O': '不通过原因',
  'AzxCLr': '材质',
  'WeeDMu': '<span>*</span>',
  'h0QYf0': '请输入英文字母、英文符号、阿拉伯数字！',
  'dWtldt': '品牌',
  'uuoDDb': '用途',
  'KXalXC': '建议申报信息控制在{maxNumber}个以内，发票总金额不能大于{maxMoney}美金{break}线上中文描述仅供参考,请用英文录入实际的申报信息!{break}<url>点击查看填写示例</url>',
  '22iXWV': '重新获取{count}',
  '5pf2is': '验证码',
  '91yqs1': '新手机账号',
  'ChJyT9': '原手机账号',
  'EKMBnU': '修改手机账号',
  'KZfKJ8': '绑定手机号',
  'MogvGG': '微信扫一扫绑定微信',
  'N9hObN': '绑定微信号',
  'TdGnHP': '确认绑定',
  'Z88MpV': '邮箱账号密码',
  'gH3BP7': '账号安全',
  'h+HlJu': '手机号格式不正确!',
  'jy7d7Z': '邮箱账号',
  'jyEJqj': '绑定手机账号',
  'lQSztD': '绑定成功',
  'uWwmzm': '手机账号',
  'wPtgoF': '确认解绑吗？',
  'xC3qW/': '解绑微信号',
  'zusrxt': '取消绑定',
  'Ji9Dwg': '请填写0~9999.99之间的数，最多保留2位小数',
  'nuHfsV': '上传商品申报价值',
  'NTYH7r': '批量上传包裹，如已有包裹信息，表格将会覆盖原数据，如实际为新增包裹，请在原上传表格基础上新增包裹信息再上传或单个新增，否则包裹信息将会覆盖，请注意！',
  'XPznM5': '前往商品维护',
  'evvpFz': '请填写小于等于2000的正整数！',
  'qv9EKm': '已知悉, 下单后再去维护',
  'S150lQ': '不能是B/b开头+19位数字',
  'XdZmSP': '请输入数字、字母、减号或下划线,并且长度小于50个字符',
  '0AGMjg': '请选择状态',
  '1dHd/u': '选中的商品: {break}{codes} {break}未关联GPSR信息,不允许选择!',
  '4q7aWj': '前往添加>>',
  '5IblI+': '制造商名称',
  '6up8TB': '可用模版打印尺寸【',
  '76VQlq': '请输入GPSR名称',
  '7Qb7zk': '标签区域',
  '7nyFdZ': '请输入名称',
  '8OkSrg': 'GPSR信息',
  '97FBSp': '请按需根据销售区域提供相应语言的警示语信息{break}示例：Warnhinweis: Nicht geeignet für Kinder unter 36 Monaten.',
  'AyW7zz': '所需警示合规环保标识',
  'BSpSco': '请选择商品负责人',
  'BU3zeG': '制造商',
  'BrBTkB': '鉴于以下提交的信息，我/我司声明：信息均属实，如有虚假信息导致的任何责任及后果将由我/我司承担',
  'CT8MBi': '适用于某类商品的GPSR信息组成，用于关联需GPSR信息的SKU以及打印相关的GPSR信息标签。',
  'DPAxH+': '编辑制造商',
  'F/D7pU': '标签选择',
  'FPNaML': '负责人详情',
  'GpDYex': '新增制造商',
  'IhWPTD': '打印通用GPSR标签',
  'KXmxRR': '请输入GPSR信息名称',
  'KreuRF': '以上组合打印信息不适用于此尺寸',
  'NVPitr': '选择内容过多，此模版尺寸【{curSize}】无法打印全，请调整模版内容或模版尺寸后继续添加！{enSize}',
  'QP3qdO': '鉴于以下提交的内容，我/我司声明：{break} 1.对于由我/我司的欧盟责任人负责的每件商品{break} a.商品/其包装或随附文件中标有欧盟责任人的名称和联系详情，包括邮政地址{break} b.欧盟责任人拥有符合性声明(或性能声明),并有权访问相关技术文档以证明符合要求{break} 2.如果我/我司的欧盟责任人发生任何变更,将通知贵司{break} 3.信息均属实，如有虚假信息导致的任何责任及后果将由我/我司承担',
  'QTIMTf': '请选择模版打印尺寸',
  'S55u79': '批量关联GPSR信息',
  'SB/wkv': '查看绑定负责人信息',
  'SOyOXk': '自定义警示语',
  'ShuBcR': '请选择制造商',
  'T6MpaR': '请选择GPSR信息',
  'TXtNAs': '模版打印尺寸:',
  'UYhyhR': '此商品GPSR模板+商品条码标签组合不适用于此尺寸打印！',
  'W8/2Ef': '关联GPSR信息',
  'WgR9Ik': '制造商详情',
  'WkR4ou': '打印GPSR标签',
  'X943SP': 'GPSR信息名称',
  'X9Hi81': '编辑负责人',
  'Y0VbfF': '点击下载',
  'YcHiPZ': '无对应供应商信息，{a}',
  'bbSyMZ': '新增GPSR信息模板',
  'diPqGv': '《批量打印条码模板》',
  'glkuPy': '商品条码区域',
  'hWeYWy': '批量打印文件',
  'iFeo32': '请选择类型',
  'k3QotQ': '欧代信息',
  'kUWb/8': '商品负责人区域',
  'lJoEc8': '不能输入中文',
  'lSOSkG': '结尾是',
  'loKQx9': '单次不得超过5000个',
  'mpknBY': '自定义警示语区域',
  'n4VyL8': '此处仅支持打印通用GPSR标签，若需同时打印商品条码信息请前往商品管理关联GPSR信息在对应商品列表打印 ！',
  'nwIvZ2': 'GPSR, 即《通用产品安全法规》(General Product Safety Regulation), 是欧盟为加强产品安全而制定的法规, 旨在确保所有在欧盟市场上销售的产品都是安全的, 以保护消费者的健康和安全。',
  'ppwk5Y': '模版打印尺寸',
  'rA3Nmf': '仅限补充类型全部都为GPSR信息的商品，才能批量关联',
  'sIy67M': '包含',
  'vKMx9x': '编辑GPSR信息模板',
  'w8+5lq': '其他打印项',
  'xp/GZy': '查看关联GPSR信息',
  'yFmk5P': '请先补充商品的GPSR信息',
  'ylF0LP': 'GPSR需补充或更新？<a>去编辑</a>',
  'zGpUl0': '商品负责人&制造商基础信息',
  'zqMDyD': '制造商信息区域',
  'GNCFjw': '{dot}仅支持标签纸打印，单次打印不得超过5000个，打印后请扫描测试。{break}{dot}如您选择添加GPSR信息，则标签将带有已关联的GPSR信息；如果商品未关联GPSR信息，则不允许打印。{break}{dot}如您选择添加欧代信息，则标签将带有已关联的欧代信息；如不选择则不会带有。',
  'MjfT9F': '该制造商已失效，请重新选择',
  'UehsMU': '该商品负责人已失效，请重新选择',
  '3uYLxS': '支持50M以内的jpg,jpeg,png,pdf,zip格式文件',
  'AUuPe6': '至少输入{num}个字符，双击切换至批量查询',
  'FeVrJ/': '文件最多上传{maxCount}个，大小限制50M以内，格式限制为jpg,jpeg,png,pdf,zip',
  'xo2gDa': '打印GPSR信息',
  'yxW56v': '文件格式限制为jpg,jpeg,png,pdf,zip',
  'vXqrEQ': '当前单品管理暂不支持打印GPSR信息组合标签！',
  '3F0pn+': '德国新仓',
  '3Kr6md': '英国一仓',
  '3Z/8DA': '澳洲悉尼仓',
  '4G7TmF': '选择报告月份:',
  '5eIZb1': '出库SI',
  '5knorD': '萨凡纳仓',
  'Ahfns/': '各库龄段资金明细',
  'CpC3w/': '排行',
  'Cx/ZfQ': '美西（太平洋时区）',
  'DlNvpw': '出库单量',
  'FMFuuk': '上月在库SI数量',
  'GP2sjg': 'SI数量',
  'HQ4HZg': '自定义时钟',
  'I7qN1w': 'part.1 履约消费数据',
  'JkcfsV': '澳洲墨尔本仓',
  'K83Hze': '点击跳至最左',
  'KD3+MN': '英国',
  'LfkgD6': '澳大利亚',
  'NWSZS8': '承诺头尾程消费额(折后)',
  'PaWMTl': '履约分析报告',
  'SZC9VK': '各平台出库单量占比',
  'VG2CwF': '点击跳至最右',
  'VahHdx': '新泽西仓',
  'WWLGJO': 'part.2 库存分析',
  'YJ9vOe': '美南仓',
  'YMgB69': '本月在库SI数量',
  'YuT9+d': '美西一仓',
  'Z44f6M': '入库SI',
  'ZgIeSx': '环比',
  'ZwLbdd': '比利时慕斯克龙仓',
  'a6CV9N': '英国四仓',
  'cmmHPa': '美东（东部时区）',
  'dOsMrX': '上月在库资金',
  'dn5c7I': '中欧',
  'er80XZ': '英国三仓',
  'eyNX6K': '占比',
  'fFmC7w': '出库SI数量',
  'gLz/8S': '美东三仓',
  'iVp3lO': '上月出库单量',
  'l9xczl': '二级品类',
  'ngVved': '实际头尾程消费额',
  'oAUHli': '在库资金指商品申报价值',
  'olJJPB': '世界时间',
  'r/enn9': '各库龄段SI明细',
  'rYrCyO': '消费金额',
  's24SFP': '总单量',
  'sS5Zjv': '达标率',
  'suyKfo': '美西二仓',
  'udjnTi': '美中（中部时区）',
  'vETCLF': '本月在库资金',
  'vgNCKm': '德国一仓',
  'vwrLKd': '上月月在库SI占比',
  'w3QnSZ': '出库排行榜',
  'xAHzLe': '本月在库SI占比',
  'xbdSiX': 'part.3 出库品类详情',
  'zWZfR1': '加拿大多伦多仓',
  '+x9sKw': '美西',
  '3u3Azm': '{num}月',
  'ATI8nz': '{warehouse}: {warehouseLabel} 城市: {city}',
  'AzRGCX': '德国',
  'jxIf3M': '美东',
  'GBO8/I': '德国仓',
  'HoMqWj': '英国仓',
  'dG1S3v': '美西仓',
  'h3EF1T': '美东仓',
  'oXc3m5': '1. 如需查询和导出12个月以前的历史数据，请联系在线客服。{break} 2. 授信手续费、逾期手续费及延期手续费，币种CNY/HKD的最小收费金额为0.1，币种GBP/EUR/AUD/USD/CAD的最小收费金额为0.01。',
  'FY4EWV': '仓组内其他仓库',
  '0GyUPW': '预约邮箱',
  '1XXFUz': '计费值',
  '1mj4G9': '价格变动原因',
  '5+hBLi': '订单重量',
  '6qeH3F': '预估托盘数',
  '9f5t0B': '订单体积',
  '9m6tTe': '尾程询价报价 <span>(实际打托数量会影响最终尾程费用,以实际扣费金额为准)</span>',
  'BOsZa4': '目标派送方式',
  'EBLjD7': '尾程询价报价',
  'ETE5vQ': '供应商报价存在波动，请及时确认报价。出库增值作业耗时、实际打托数量等也会影响实际金额',
  'FmPO/g': '打托暂存后再指定具体日期',
  'Gm0Npz': '其他备注',
  'OLzg0F': '单价',
  'OPRrfY': '托盘数量',
  'QcRv4P': '车辆需要GPS',
  'RS2s4f': '跟踪号/凭证号',
  'RrpKm0': '单价有效截至日(当地)',
  'Si3Ovb': '计费单位',
  'UgqSWZ': '计费费率',
  'VS3QW3': '预估尾程费用',
  'VSq34r': '下载提货单',
  'ZV6B7N': '该费用依赖于其他费用金额计算得出时使用。{break}例如通常情况下，燃油附加费=最后一公里派送费*计费费率',
  'ZVG0lB': '超过预估托盘数',
  'aWgms2': '增值待确认',
  'iKD60I': '超过预估提货时间',
  'ihg37s': '依赖费用项',
  'j3vF3/': '投保币种',
  'lYkQcO': '实际尾程费用',
  'lbJx3W': '需要向供应商投保',
  'mF9qHK': '订单数量',
  'oXkCM6': '实际供应商',
  'rCk9U1': '投保金额',
  'rjZWF2': '新建增值单',
  'sgapu/': '预约电话',
  'sgmkqg': '指定车型',
  'xcPr5G': '需要协助预约送货',
  'yvvayC': '指定供应商',
  '+Iqggx': ',请前往<a>预约单管理</a>预约送仓',
  '4F2DLS': '未预约到仓',
  'BHIZbJ': '请选择订单',
  'BqJJ9L': '未到预约节点',
  'C5EziP': '已预约',
  'IToNB2': '是否清空待办项进行查询！',
  'MpeG4C': '待提交预约送仓',
  'PLcKBI': '卸货方式',
  'Q6plNw': '无需预约',
  'QEmJpC': '预约送仓时间(当地)',
  'Ry3L12': '新增预约单',
  'TvlAb1': '预约次数',
  'V6neT7': '待送仓',
  'ZhMON/': '选择待预约订单',
  'h4VFpW': '无法创建预约单，请检查后重新创建预约单！',
  'hdgxlJ': '待预约送仓',
  'jOywIg': '导出暂无数据',
  'q/YRnn': '实际卸货时间(当地)',
  'sLxRLg': '预约卸货时间(当地)',
  'wQCAYD': '包裹数量',
  'x+RSYW': '创建日期',
  'xbSzZ3': '实际送仓时间(当地)',
  'f0PSge': '仅支持按订单送仓方式进行预约派送：送仓方式为散货的预约散货，送仓方式为整柜的预约整柜，送仓方式为快递则无法预约；若订单送仓方式选择错误请回退草稿，重新更改送仓方式和产品后再预约；',
  'XfySEr': '入库单预约状态',
  '+1z4qs': '温馨提示：支持货物入库后，出库时将多个SKU组合为1个单品出库，该服务仅支持2C库存。',
  '/YG20j': '请输入商品组名称',
  '16H+KU': '套装长(cm)',
  '1yjVbf': '商品组',
  '3uBogm': '最多保留4位小数',
  '4g0F/w': '套装可弃重量(kg)',
  '6tylb+': 'EXcel批量新增',
  '7FKIiN': '与成品商品编码重复',
  '7b3ENM': '组套关系',
  'AF0IfM': '组套内商品',
  'AKAQkU': '组套商品/商品组',
  'CoJ9Ff': '组套包装',
  'CxmT/4': '套装商品视频',
  'DlZIxf': '温馨提示：同一商品组套的多个商品支持维护在一个商品组，以减少维护商品组套次數，例如：同一商品多个颜色对应多个SKU，每个颜色的SKU都可以维护为一个商品组。',
  'EI0jby': '商品编码/商品组名称',
  'HGxg7z': '套装高(cm)',
  'JJsTcc': '套装商品示意图',
  'JWHXq+': '组套信息',
  'KX7tJL': '<red>最多上传5张图片，限制为5M以内的jpg,gif,bmp,png格式</red>',
  'N52RjX': '库内组套',
  'NLUeF8': '<red>最多上传3个视频，限制为50M以内的avi,dat,mpg,wmv,asf,rm,rmvb,mov,flv,mp4格式</red>',
  'NcFJGy': '下单时是否填写',
  'ONEZAE': '出库商品组配置',
  'OT8ish': '商品组/商品',
  'OvAUQP': '商品已存在，请勿重复添加',
  'PIOZgH': '组套业务类别',
  'PdjukP': '当组套属性为套装包装，可填写可丢弃重量；{break}可丢弃重量指组套商品进行组套时，包装内可丢弃部分的重量。',
  'Qy13lF': '关联GPSR',
  'RLjqtw': '套装宽(cm)',
  'RnXcAk': '组套包装/组套内商品',
  'TZNHjJ': '新增组套内容',
  'W7HwCn': '商品组名称/商品编码',
  'argxjt': '成品商品编码',
  'brD+uB': '查看组内商品',
  'eEjnyp': '出库组套',
  'eQuhOe': '下单时是否填写为是指下单时订单中需要包含该商品，否则无法进行出库组套；{break}下单时是否填写为否指下单时订单中不需要包含该商品就能完成组套，若包含该商品则不视作组套的部件，作为单独商品售卖。',
  'ebDqUr': '组套对应商品编码',
  'fJMACQ': 'GPSR信息名称最多128字符',
  'iCtpFf': '温馨提示:支持货物入库后，在库内将多个SKU组合为1个SKU并重新上架售卖，该服务仅支持2C库存。',
  'jogDbB': '打印GPSR信息组合标签最大打印数量为{num}',
  'lpeIQF': '温馨提示：组套包装为组套中的包装，该商品在每个组套中只允许存在一个。组套商品为组套的其中一件商品，该商品可为商品组或商品组商品中的任意一件商品。',
  'm0ZYt5': '组内商品编号',
  'nRqQiw': '与组套内容的商品编码有重复',
  'nqSBOq': '组内商品条码',
  'qFYiaJ': '视频格式限制为avi,dat,mpg,wmv,asf,rm,rmvb,mov,flv,mp4',
  'taxXcG': '新增出库组套',
  'uyKP5R': '组套关系名称',
  'vKXaA5': '视频大小限制50M以内',
  'vP/Azq': '只能输入【大写字母】【中文】【小写字母】【数字】【 - 】【 _ 】 【 ( ) 】【 + 】 【 / 】【 @ 】【# 】【 . 】',
  'xrXaSi': '组套内容',
  'yMCuMW': '新增库内组套',
  'EZYGd+': '批量下载POD文件',
  'jwJ5aJ': '下载POD文件',
  '2BYfGC': '平台同步是否对接',
  '6+1lpt': '平台设置',
  '7mS1Ef': '详见操作指引',
  'Far31d': '请启用或添加您当前已使用的电商平台,启用后将控制万邑联平台下拉选择以及页面展示，',
  'L7rr8k': '平台编码',
  'NP8ydP': '启用平台',
  'fmU8aC': '确定停用吗？',
  'gR5+1a': '确定启用吗？',
  'tpXKt6': '添加平台并启用',
  'uIa3Sy': '添加平台',
  'zMawsp': '平台名称',
  'drA1F1': '找不到平台？请联系客服添加',
  '2xD9pN': '与{mount}月环比',
  '80c2cB': '{mount}月出库单量',
  '7OyNT9': '透明计划标签',
  'EArTq/': '不允许',
  'RlFIEF': '必须',
  'RuKykW': '订单最大货型/件型',
  'i0tMJ3': '订单最大货型：TM>T240>T120>T50>T25{break}您可以选择按货型或者件型设置规则',
  'kdNFDD': '订单最大',
  'lXbQ5s': '您已选择了增值服务[贴FBA透明计划标签]，此增值服务不支持选择',
  'utBCZV': '透明计划标与FNSKU标混合标签',
  'HPEdSt': '订单最大“货型”判定规则：TM>T240>T120>T50>T25{break}订单最大“件型”判定规则：超大件>大件>中件>小件{break}您可以选择按货型或者件型设置规则。',
  '06l+Qj': '您好！你提交的商品尺寸最长边 < 15 cm 或者 次长边 < 10cm 时，即使商品已经存在物流包装，受供应商运输要求，会进行加包装处理（出库加包装费用详情)，为了避免产生额外打包费用，建议调整商品的包装要求后再录入正确的尺寸！如您同意出库加包装，可继续进行下一步。',
  '0m04KS': '取消后本次调整的保额将不会生效，按原保额生效，是否确认？',
  '0y8Vak': '仅支持标签纸打印，单次打印不得超过5000个，打印后请扫描测试。',
  '10skDr': '重新投保',
  '2yoQvT': '当前操作不可逆，请确认是否更新为商品化管理！',
  '3g9GU1': '添加示意图',
  '5FCj3u': '确认重新投保？',
  '5Kcusw': '整套|整箱:',
  '5ZDwkw': '请选择该商品的发票等相关证明图片上传，Winit相关工作人员会进行审核相关信息。{break}<red>最多上传5张图片，限制为5M以内的jpg,gif,bmp,png格式。</red>{a}',
  '6XWJXx': '取消投保',
  'A+35EB': '文件格式限制为jpg,jpeg,png',
  'AE/KxE': '单件:',
  'B/XWT5': '调整保额',
  'Ctsw2n': '打印文件生成设置',
  'H/jbhZ': '1.同一国家箱产品箱内每件或套装产品套内每件的投保金额不能超过单一产品的投保金额。{break}2.若箱产品或套装产品的标准件数乘以箱内或套内每件的投保金额超出整箱|整套的限制金额时，则会按对应上限投保金额计算保费！',
  'HJOdSI': '审核信息',
  'K45CNn': '示意图类型',
  'KL1vOZ': '混合存储',
  'KbCL0r': '货主',
  'Kej6Gd': '视频预览',
  'LVH+YI': '投保状态',
  'OgT+gu': '所有SKU生成一份文件',
  'P53D0s': '调整后投保金额',
  'Q0aPTI': '请输入采购金额/件(USD)',
  'QnShZR': '没有币种不支持投保',
  'SIXvYZ': '箱产品投保金额/箱内每件',
  'UFIIqK': '子账戶名称',
  'V5LbEg': '采购金额/件(USD)',
  'YNWh/C': '确认取消投保？',
  'YgLev7': '可用套/箱数',
  'a71RUr': '在途库存详情',
  'aaEmj4': '支持50M以内的jpg,jpeg,png格式文件',
  'aaJRtO': '投保限制金额',
  'be/PB3': '此日期为SKU对应批次信息的日期，由批次属性决定此日期的性质。如：批次属性是生产日期+产品批次号，则此日期为生产日期；批次属性是失效日期+产品批次号，则此日期为失效日期。',
  'd1RUKj': '商品证书资料',
  'd2MeTl': '添加商品示意图',
  'de5n5v': '存在相同国家',
  'fOXNzj': '{dot}仅支持标签纸打印，单次打印不得超过5000个，打印后请扫描测试。{break}{dot}如您选择添加GPSR信息，则标签将带有已关联的GPSR信息；如果商品未关联GPSR信息，则不允许打印。',
  'gneoey': '单一产品投保金额/件',
  'gzDYf6': '商品在【{codes}】已有待审核信息，是否提交更新？',
  'lLL5ZK': '套装产品投保金额/套内每件',
  'lUtVXk': '商品信息示意图',
  'luyAlN': '提交审核时间',
  'mQq9vE': '请输入大于0的数字，且最多保留两位小数',
  'mRtDqK': '在途数量',
  'nLDE+V': '原生效投保金额',
  'o0wl3e': '新增投保',
  'pVTl/X': '批次属性|日期|产品批次号',
  'pa/Hpb': '在库套/箱数',
  'qm6h2z': '投保信息',
  'v742LV': '不同SKU生成单独文件',
  'wDqNy1': '示例',
  'wI3FWu': '请上传采购发票',
  'ye/rJU': '采购发票',
  'zrIs7T': '最近更新时间',
  'X1t/M7': '应补贴包裹条码',
  'ZAOv9w': '实际上架入库单号',
  'b2UFEI': '应上架入库单号',
  'dIycQ5': '实际补贴包裹条码',
  'Numk8A': '关联Winit订单号',
  'cpUlyA': '关联增值单号',
  'DxKC20': '【{serviceName}】必须同时选择增值选项：【{serviceName2}】！',
  'Z0Afjw': '入库-补贴包裹条码',
  '017M9b': '查件信息',
  '83aOrM': '索赔时间',
  'CczxbC': '派送异常类型',
  'DMYki0': '索赔状态',
  'FCcD/q': '处理反馈',
  'KkBukn': '索赔类型',
  'NYJgJy': '索赔流水号',
  'O96nxS': '异常持续天数',
  'PIqc3E': '查件时间',
  'bwU822': '出库仓库',
  'c9Nk2X': '查件状态',
  'dM3hXJ': '查件流水号',
  'goV7bs': '轨迹发生地点',
  'hCubz5': '最近轨迹',
  'no4CjP': '索赔信息',
  'uP/M2r': '轨迹发生时间',
  'w39FKP': '轨迹状态',
  '4xS0E4': '出库订单',
  'OiVSUE': '最低收费',
  'WX6HP8': '无效，请删除此文件并重新上传！',
  'nQPn4+': '无效，请重新上传！',
  'aePiuD': '证书已失效',
  '/KxreR': '库存准时率',
  '2MYr1m': '登录',
  '3S5WCT': '手机号登录',
  '4/Lg7X': '请输入登录密码',
  '9UZxwP': '请输入验证码',
  '9z252s': '扫码注册',
  'I1vr0V': '找回密码',
  'KBVp8X': '请输入手机号',
  'MmsEyp': '注册',
  'OQBMaY': '邮箱登录',
  'Rdb33f': '扫码登录',
  'SWlncS': '预约送仓',
  'VaYh5v': '记住密码',
  'X3Qw1f': '请输入手机验证码',
  'Xjfb5m': '隐私政策',
  'YpskxZ': '出库准时率',
  'b/9R1T': '绑定',
  'd8FaCq': 'Step1 扫码登录',
  'fxYWiK': '请输入邮箱',
  'gI0VX4': '准时投递率',
  'guGupZ': '扫码成功',
  'ngd7Ys': '请输入图形验证码',
  'oIbf2X': '上架准时率',
  'tLW3W3': '手机号',
  'uQXjs5': 'Step2 账号绑定',
  'x3dFer': '请输入密码',
  'xsqOlT': '微信昵称',
  '1ursGp': '登录密码',
  '3izfxn': '微信已注册使用，请勿重新注册',
  '6B5YBg': '登录方式',
  '8Je/Zh': '绑定手机号成功后即注册成功～',
  'B6Yy/p': '支持微信快速登录',
  'BWtB9B': '输入6-32位数字字母组合密码',
  'DQMC7I': '两次密码输入不一致',
  'DiCHhn': '如已有账号，请点击按钮绑定已有账号',
  'GqhYph': '微信登录',
  'Hdrh6x': '请输入联系人姓名',
  'IBJ0+K': '检测到您的账号未绑定微信账号, 为给您提供更便捷的服务, 请尽快绑定微信～ <btn>马上去绑定</btn>',
  'KIo76D': '微信注册',
  'L78Ltd': '修改手机号',
  'L7gdr+': '目前在用/计划用哪个国家的海外仓(可多选)？',
  'NfKGF1': '设置邮箱',
  'O04mT0': '用于接收消息、验证身份（如找回密码、变更安全设置等）',
  'ORpvGU': '设置手机号',
  'QK5ud3': '账号验证',
  'R9+P8F': '恭喜您，邮箱注册成功~ {break} 请前往邮箱{email}激活账号',
  'RXIzb7': '激活邮箱',
  'T8JunI': '请选择注册或绑定账号',
  'UpWtER': '恭喜您，微信扫码注册成功~',
  'V5pGxT': '基本设置',
  'VGdghS': '已阅读并接受 <a1>《用户注册协议》</a1><a2>《隐私政策》</a2>',
  'WZ8gJI': '您目前的年均销售额是多少万人民币？',
  'XOaAVQ': '登录万邑联账号时需要输入的密码',
  'XfP+fO': '没有账号，注册新账号',
  'Z9M13R': '输入邮箱字符长度不能超过50',
  'ag8LxW': '未设置',
  'auukQC': '未找到当前微信号对应的万邑联账号, 请选择：',
  'b9caeM': '请再次请输入密码',
  'bdjhF3': '用于接收消息、验证身份（如找回密码、变更安全设置等），绑定后可支持手机验证码登录',
  'cRkjTF': '修改邮箱',
  'dMPyxp': '关注公众号: WINIT万邑通',
  'eGMWPi': '({count}S) 后进入首页, <url>点击立即跳转万邑联首页</url>',
  'eMnHfD': '邮箱注册',
  'f+xVln': '请输入确认密码',
  'fpHtD6': '账号修改申请已提交，现需要您前往新邮箱激活账号',
  'g4luE6': '已设置',
  'g7ZZYG': '输入邮箱格式错误',
  'idr0Yi': '恭喜您，邮箱注册成功~',
  'lJ5T1S': '重新发送({count}s)',
  'lkvxCD': '请阅读并接受协议',
  'o9sQv+': '立即验证',
  'p6bh5v': '账号密码',
  'qiM7Bf': '微信扫一扫',
  'sPM43N': '前往邮箱',
  'trTcmQ': '(注册成功后可通过手机号登录哦)',
  'uQ97fV': '已有账号，去绑定账号',
  'uWZTJg': '了解更多资讯/享受更便捷服务',
  'yzVtH/': '绑定已有账号',
  'zDhp9Q': '邮箱已存在，请直接登录',
  'zdjQOh': '请选择国家/地区',
  'kYuuSo': '关注公众号',
  'i+upx7': '账号绑定',
  'jIh+uu': '新登录邮箱',
  'kXaBbd': '关注成功',
  '4cBjcA': '现需要您前往新邮箱激活账号',
  '+CITvc': '请输入变动日期',
  '/CmSdr': '<red>请提供完整的操作视频，最多上传1个视频，限制为100M以内的avi,dat,mpg,wmv,asf,rm,rmvb,mov,flv,mp4格式</red>',
  '/DtX+8': '费用类型',
  '21rG2o': '提交日期',
  '3YV16S': '视频大小限制100M以内',
  '3pgC7n': '货权转出',
  '79mGuc': '退货入库',
  '8ME8Ww': '导出明细',
  '8PETXp': '调拨入库',
  'ClOQBe': '期末库存',
  'Cs5PyX': '最多上传1个视频',
  'DH94cn': '期末库存数',
  'F1kRoj': '分类库存详情',
  'GQcXjn': '变动数量',
  'HWx2E7': '近1个年',
  'J6Ocmq': '运单',
  'Jz34C6': '是否需出库采集实物条码',
  'L8O+eh': '近7天日均销量/近7天平均库存',
  'M3MF3I': '最多上传5张图片',
  'MhOy8s': '至少输入{num}个字符',
  'NQQAuQ': '调拨出库',
  'O6N9fg': '近15天日均销量/近15天平均库存',
  'OXAH2B': '变动记录',
  'Ore518': '仓库DOI/国家DOI',
  'PmTJ7o': '若选择采集服务时，万邑通将在出库环节采集对应的包裹条码 或 第三方包裹条码，采集完成后客户可在出库单信息内进行查询，请确认商品实物上存在对应的可采集的包裹条码，否则将产生库内异常。',
  'Qxf3/K': '单品条码导入',
  'SDYfIP': '日期范围最大为365天',
  'SmVbZ0': '待销毁库存详情',
  'WHZ769': '在库库存详情',
  'WsHvnq': '总数量',
  'XllRKa': '不按商品编码/商品条码或单据号查询最多支持范围为92天',
  'ZRBxht': '仓库DOI',
  'bQOgOx': '变动日期',
  'dnJRgq': '仓租日期',
  'eu0qY9': '海外仓储收费单号',
  'fSrpzL': '计费维度',
  'h+EgTN': '丢失确认中库存详情',
  'i2eYXn': '库存数量最大值',
  'l/rrRH': '直发入库',
  'lXOK3F': '库存数量最小值',
  'lZ2LVa': '近30天日均销量/近30天平均库存',
  'o0NSNd': '记账日期',
  'oMimBZ': '库存分类调整',
  'vKjKIG': '请填写海外仓储收费单号或仓租日期',
  'wFphH6': '温馨提示：尊敬的客户，库存流水数据仅支持查询近一年的数据。',
  'x9DBul': '待出库库存详情',
  'xgiTGk': '货权转入',
  'GoU/8N': '退货暂存未处理',
  'Y6FUe2': '查询近15天的记录',
  'AvNm7S': '应上架时间(当地时间)',
  'vbxo3L': '实际上架时间(当地时间)',
  'vkhDdQ': 'X/Y，X表示下发增值数量，Y表示实际完成数量',
  'wwoYQh': '增值数量',
  'hqz2lG': '订单优先级',
  '9HYp2Y': '补充证书',
  'FgvNQH': '请先勾选待补充证书文件的商品！',
  'GM7I33': '待补充证书文件',
  'Ne2nfi': '批量补充证书文件',
  'OKnjZ+': '下载补充商品证书文件模板',
  'XDYV1L': '文件大小请勿超过10M，请压缩后上传',
  'e5PZ02': '支持10M以内的jpg,jpeg,png格式文件',
  'kROGK4': '批量补充证书',
  'x3pfcJ': '请删除无效证书！',
  '08hJjN': '允许装箱',
  '150bCw': '最大值必须>最小值',
  '1jI2sy': '选择A包，默认允许装成A+包',
  '29czDg': '只允许输入大于等于0且2位小数的数字，请修改',
  'EHHXgx': '最大值',
  'EsJkLt': '发货国家',
  'F3dI0f': '最小值必须<最大值',
  'G8A2UL': '装箱限制',
  'HHJhh7': '包裹类型',
  'OZDdKy': '尺寸输入规则：长=最长边, 宽=次长边, 高=最短边',
  'PMguPq': '{name}只允许输入不超过9999.99的数字，请修改',
  'RDvOwC': '包',
  'WZX4M+': '选择B/C包，默认允许装成A和A+包',
  'YIsl98': '最小值',
  'ZEg+9J': '装箱规则',
  'fQudGk': '打包方式',
  'g9sUca': '包裹打包',
  'kLsmQn': '出库装箱规则',
  'nVsYMb': '查看WINIT的默认装箱限制',
  'w0kW9n': '功能描述：用户能够依据订单转电商平台仓或者第三方仓入库时的收件规则，在这里制定对应的装箱规则。比如，按照订单类型、收货人类型、发货国家等业务特性，对即将出库的货物进行分箱和装箱操作。同时，还可以对装箱后的尺寸与重量加以限制。系统会依据用户所设定的规则，自动完成订单的分箱和装箱工作，从而满足电商平台仓或第三方仓的收件要求，有效提升货物在平台仓入库的合规程度。 {break}注：系统按照订单类型、收货人类型、发货国家等业务特性未命中您配置的装箱规则时，仓库打包时默认按WINIT的装箱规则来校验是否符合发货标准',
  'LR8Ac+': '坏账期预估待还仓租（USD）',
  'JK3Fr7': '*此待还金额不包括在账单待还金额内{break}坏账期：{startDate}',
  'hGLhSe': '子订单状态',
  '5VL8XQ': '变动时间',
  '/ZyLUT': '由于供应商条款限制，此处仅展示近60天下单的数据',
  '4uSKD4': '无查件信息',
  'KraNAc': '无索赔信息',
  'ZsFmm2': '尾程异常明细功能说明',
  '96sxGJ': '组套条件',
  'MlJAC5': '同订单内多套是否允许组套出库',
  'xz7u99': '多套表示为2套及2套以上；{break}若配置为【是】则下单1件商品A，命中此组套关系，进行组套出库，下单2件商品A，命中此组套关系，按2个组套处理；{break}若配置为【否】则下单1件商品A，命中此组套关系，进行组套出库，下单2件商品A，不允许按组套处理，常规打包处理。',
  '+6+Mt4': '重算完成日期',
  '237gsE': '纯电',
  '2IVSMv': '折后金额',
  '3RFPFO': '按SKU导出国家内每个仓库的库存数据',
  '3U2acT': '海外仓储收费单号最多查询500个，逗号或换行分隔',
  '5AvkeD': '是否投保商品',
  '5EM4lg': '库位类型',
  '5NdmWL': '仓库编码',
  '6q/POx': '非电池',
  '9DHCGM': '重算备注',
  'Divclz': '是否高货值',
  'DsCXA9': '库龄(天)',
  'EPZLEX': '计费体积(CBM)',
  'GOfCC1': '扣费状态',
  'KcgraU': '是否最小计费',
  'Mjamj2': '运单总体积(CBM)',
  'NlO+UH': '仓储单明细',
  'OJzUfZ': '是否退货',
  'OLcvb/': '#卡片商品',
  'ObUQSf': '导出SKU国家级库存',
  'Oj70/T': '是否化工产品',
  'PwmGND': '导出数据只支持一个月，请将查询时间段调整在一个月内!',
  'QdThDC': '是否DG',
  'URG50E': '折前金额',
  'UnOS5e': '重算后折后金额',
  'ZZrYbK': '是否特殊化工产品',
  'ZZsYN+': '内置',
  'a40x/v': '是否打托',
  'dM/4Cc': '库存数量按SKU+国家合并，不显示仓库',
  'dTWKpE': '本次实收金额',
  'etS3Fs': '重算前折后金额',
  'fBupdr': '导出SKU仓库级库存',
  'fWVI6Y': '外置',
  'g+8vyF': '是否混合存储',
  'gbXvkj': '上架时间',
  'lRACZW': '卡片商品',
  'murDIe': '电池类型',
  'o9bDiv': '是否批次管理',
  'pO9v22': '运单号',
  'qG6wc3': '客户未维护',
  'r9bIiC': '第三方商品条码数量',
  'rvynV4': '是否食品',
  'tbKn4n': '方案备注',
  'uESwgc': '折后单价',
  'vYSK/8': '出库自提仓租单明细',
  'vl8z5u': '库龄',
  'x/6PQh': '单个商品体积',
  'xr1IiE': '暂存日期',
  'z3yq8L': '库龄段',
  'K0MNn8': '请切换主账户【{account}】查询坏账期的仓租明细',
  'N+Y3oq': '存在规格，不支持更新',
  'zz036a': '勾选选择订单内全部包裹，将自动带出订单的包裹明细；',
  '9BSdQ4': '您未开通A+包裹免自验权限，验货类型不能选择=客户自验货，如需开通请点击开通免验按钮开通，谢谢！',
  'laNzSC': '开通权限',
  '6U0Oxp': '地址类型',
  'Ku6RiZ': '不校验',
  'cMFt3E': '地址校验结果',
  'dg3g5T': '校验通过',
  'lO4mGQ': '校验不通过',
  'TWmlF4': '设置我的平台',
  'ZGO+QQ': '出库加卡片',
  'bawz6H': '卡片名称',
  'grKzYm': '卡片编码',
  'i+vMLC': '当您无法在当前下拉菜单中找到想要选择的电商平台时，请点击此处设置您常用的电商平台。',
  'nU2zG1': '张数',
  'tbT5Ro': '查看卡片的数量',
  'llaKUX': '万邑通链接通途erp使用指南',
  '8h34cM': '主账号',
  'NS6ZAt': '子账号',
  'PQlTrS': '客户ID',
  'W7TAOd': '请输入昵称',
  'fuyuYG': '最多输入50个字符',
  'r2nMKU': '账号昵称',
  'tTpIu1': '文件大小不能超过{max}MB',
  'dXaoDL': '实际完成时间(当地)',
  'oyw7Aw': '预计完成时间(当地)',
  'mDab9A': '1、仅支持标签纸打印，单次打印不得超过5000个，打印后请扫描测试。{break} 2、“打印文件生成设置”选择“不同SKU生成单独文件”时，会按打印的【SKU编码】命名文件名称，由于文件名不支持字符【 \\ / : * ? " < > | 】，则在生成的文件名时会自动忽略，请注意核对条码信息，防止误贴。',
  '+vbk++': '所有单品贴相同的标签',
  '7cXxXG': '不同的商品贴不同的标签',
  'Jc5Kpb': '不同的包裹使用不同的标签',
  'YJXDjo': '所有包裹使用相同的标签',
  'nYNtaU': '仅支持【大写字母 小写字母 数字 - _ ( ) + / @ # . * 】，请规范条码格式。',


  '+cSl6d': '荷兰',
  '+hC0sk': '该条件只针对eBay订单生效',
  '+tkLmV': '店铺状态',
  '/fO7DP': '直接提交订单',
  '0UNp8j': 'eBay',
  '0VccOb': '平台账号',
  '0qLmhP': '输入的值必须是大于0',
  '16whGa': '订单总金额范围',
  '18gNnd': '如果该账号存在已同步或发货的订单，停用后会导致跟踪号上传失败等问题，是否确定停用？',
  '1RqymR': '{platform}授权',
  '1wUKTi': '订单货品尺寸=订单中所有商品尺寸的总和{break}海外仓发货：<a>商品匹配</a>成功的WINIT商品的核实长宽高体积重量',
  '2qD539': '授权协议',
  '4LK/OL': '设置发货规则',
  '5XgRM0': '输入的值必须大于等于0',
  '8m5tda': '埃及',
  '9w+ho+': '账号',
  'A4xIfz': '优先级不能为空',
  'BE87UA': '订单包装方式',
  'DjVTN+': '确定要删除选择项吗?',
  'Dm9v6u': '最小值不能大于最大值',
  'Eul4yJ': '意大利',
  'FGIg8D': '卖家 VAT',
  'G6SgR8': '买家支付的运费范围',
  'Gel0iY': '基础信息',
  'HHF8c2': 'Temu(合作仓)',
  'Ha+zt2': 'Amazon',
  'IDWBGn': '确认启用吗?',
  'Ij1E2t': '新增授权店铺',
  'JIWrkV': '加拿大',
  'JPVi93': '开户站',
  'Kc/Zlj': '授权到期时间',
  'L0LvY4': '系统优先匹配编号大的发货规则。',
  'MIDhcI': '选择条件',
  'MyB1Vf': '沙特阿拉伯',
  'P3nNds': 'WINIT-SKU编码',
  'QRUdeg': '墨西哥',
  'R+nmnO': '收件人信息',
  'RclhRU': '已过期',
  'S5OXfB': '确认停用吗？',
  'SnFLvY': '授权时间',
  'Sq+iw6': '已阅读并同意以上内容',
  'Ulf4Sq': '印度',
  'V2qOuC': '距离到期还有<span>{remainingTime}</span>天',
  'V3B10z': '订单货品包含',
  'VWX2nS': '该winit产品需要买家前往万邑通仓库自提包裹，请知悉！',
  'WeINul': '订单货品限制',
  'YMjT8q': '新加坡',
  'Z4sh+T': '1、{platform}店铺绑定多个ERP可能导致订单重复发货，建议只授权单个ERP进行订单发货。{break}2、在{platform}取消订单或者退货退款时，请检查万邑联的订单是否支持取消，擅自取消订单导致的损失由您自行承担。',
  'Zyc92J': '规则优先级',
  'aNVBIV': '法国',
  'bl+MC2': '买家支付的订单总金额',
  'cDfqJs': '删除后此账号无法同步订单，是否确定删除？',
  'd7IajO': 'Prime订单',
  'dO1aKB': '买家支付运费',
  'dtAVnP': '海外仓发货',
  'fp4MWN': '日本',
  'fvYPww': '收件人信息(国家/(省份)州/城市/邮编)',
  'h70zPD': '西班牙',
  'hYtLJi': '发货类型',
  'i18r6F': '已选条件',
  'iKSa2y': '订单处理方式',
  'iKXJaG': '需人工审核订单',
  'lYtwbc': '授权',
  'm8gGy1': '地址限制校验',
  'mB5/6q': '重新授权',
  'mKU5ai': '订单货品',
  'me24Kc': '请至少选择一项',
  'mmpcKu': '买家支付运费在',
  'nlsRat': '请至少选择1项',
  'oIkTDz': 'eGD订单',
  'odP40n': '请输入大于大于0的正整数',
  'r1bZdF': '订单包裹货品尺寸(长/宽/高/体积/重量)',
  'tJ/j09': '如何获取您的Client ID和Client secret，<url>点击查看</url>',
  'tZXPgK': '订单货品尺寸=订单中所有商品尺寸的总和',
  'u+irD5': '店铺类型',
  'uxKWjC': 'Ontrac地址校验不通过时，订单需人工审核',
  'vVkHR3': '买家选择的运输方式',
  'vcSBZu': '巴西',
  'wYVAbQ': '订单包裹货品尺寸',
  'wiNgJe': '店铺URL',
  'xaWTdZ': 'Winit订单货品尺寸(长/宽/高/体积/重量)',
  'yCUO83': '长/宽/高/体积/重量',
  'yXiaSw': 'PlentyMarket',
  'z4ZNAd': '电商平台买家支付的运费，非WINIT运费',
  'zDbzKc': '订单总金额在',
  'zmKE3v': 'Winit订单货品尺寸',
  'zrmbIW': '收件人公司（英文）',
  '+6dbt0': '售出日期',
  '+TDdi+': '同步Tracking No.',
  '+g75jZ': '更改内容',
  '//LABL': '未匹配',
  '/QzWr8': 'shippingServiceName',
  '/WN1qt': '请求结束时间',
  '/XA51t': '没有有效店铺',
  '/YGKRs': '订单提交日期',
  '/cWiGy': '请输入大于等于0的整数',
  '/i/2WU': '预估费用(USD)',
  '/swJ78': '是否默认勾选【E_BAY_MOTORS】站点？',
  '/uC9lN': '已成功发货{count}个',
  '/wP4kI': '返回发货失败列表',
  '/wYx9N': '获取跟踪号后立即上传',
  '/ykFIr': '订单总价',
  '07ZsMQ': '请选择退货上架处理方式',
  '0BxjIA': '请勾选需要删除的内容',
  '0NOsL9': '手动同步',
  '0O3sQ4': '不能选择的产品展示',
  '0XzF3X': '自动同步订单',
  '0lgQh9': '批量取消',
  '17OOxd': 'ShippingServiceName',
  '1DZFGW': '批量解除',
  '1E3TXK': '取消拆单成功',
  '1Eo3x5': '请先授权店铺！',
  '1O2B7E': '您填写的收货地址被承运商验证为"地址错误"，建议您修正地址后下单。{break}使用错误的地址下单可能导致包裹投递失败，同时产生地址检验/修正费用',
  '1ZCq9j': '出库包装方式',
  '1oMwGL': '解除',
  '1pa/Sg': '校验国家、州/城市、邮编失败您可以{a}进行查询。',
  '1yjaIa': '不自动上传Tracking No',
  '229O38': '收件人姓名填充',
  '2E1kQr': '当前发货方式渠道产品建议您勾选ontrac地址校验，下单校验地址是否正确，会一定程度减少因地址错误产生的地址校验附加费，增加妥投成功率哦',
  '2RN82t': '返回修改',
  '2WagLU': '提交发货时，德国地址校验不通过时，订单需人工审核 <Text>(自动发货和手动发货都会校验此限制)</Text>',
  '2dAmhv': '预计发货日期',
  '2wdW7g': '去注册',
  '2zl+/I': '卖家',
  '34Wlc/': '取消发货日期',
  '36KE9A': '至少填写1项，如需添加多个地区，则可以逐个添加下一条下单国家、州、城市、邮编必须与配置完全一致才能匹配',
  '36s7cj': '存在编辑状态的商品，请先保存',
  '3RV/HR': '查看发货成功订单',
  '3Wv3pF': 'Tracking No.',
  '3iHW4o': '点击查看 <url>如何获取您的token</url>',
  '3tg6DW': '平台商品SKU',
  '3v6pY0': '订单发货',
  '47mZrU': '商品详情',
  '49sNcx': 'Sale Price',
  '4da9dh': '是否指定范围',
  '4fIBvJ': '停售',
  '4kkEGQ': '查看已发货订单',
  '4nzYdh': '保存到待人工审核',
  '4qleTw': '立即同步',
  '4zxOXq': '亚马逊店铺ID',
  '5/Py96': '合并收件人信息不相同的订单',
  '5/Rszn': '忽略',
  '5G9UiG': '更新日期',
  '5MorV+': '只允许状态为未下单和下单失败的订单下退货单，请重新选择！',
  '5UknIB': '平台同步将不同步winit跟踪号到ebay后台',
  '5av8fQ': '请选择日期',
  '5c9FcU': '合并发货',
  '5jKlmp': '自动发货规则说明',
  '5oiTur': '同步商品数',
  '5rsaEc': '温馨提示{break}请仔细配置亚马逊渠道，配置错误将可能导致无法获取亚马逊面单等异常情况，请仔细检查您的亚马逊账号如下：{break}1.配置的尾程派送供应商账号必须与我司的仓库地址一致{break}2.配置的ShippingServiceId(渠道代码)海外关联winit渠道编码将应用于后续的发货{break}3.关联的万邑通渠道必须准确(WINIT尾程账号和您自有的尾程账号对应的渠道代码不相同)',
  '5zNZSS': '平台同步操作指引',
  '61Sghw': '收件人街道2',
  '67F4wY': '当前国家/产品不支持详细地址校验',
  '6EcXeL': '未发货',
  '6ct4bd': '您的Token',
  '6fpQZR': '查看可用库存',
  '6gb4KN': '注：自动发货和手动发货都会校验此限制；物流费用包含出库处理费、尾程派送费及其他附加费',
  '6qwXpP': '批量撤回',
  '6xd6//': '请输入1~30位任意字符',
  '73tyqj': '确认拆单',
  '79bjkh': '称呼+姓氏',
  '7McuUb': 'Item Location',
  '7Md/OB': '匹配发货规则失败{count}个{break}',
  '7ZWZR1': '近3天',
  '7gbiqq': '确认取消拆单',
  '7jV4Ao': '海外仓编辑发货',
  '7mpTuJ': 'wish暂仅支持近7天，若时间范围较大，需支持多次调用获取订单。',
  '7oHrmx': '平台商品条码',
  '7srZ22': '当前地址下单',
  '81twis': '返回待审核列表',
  '8Dhcm2': '申报价值规则说明',
  '8GyebP': '确定批量删除选中的商品吗？',
  '8UQNUB': '以下商品已存在，无需重复添加',
  '8Yf49r': '去匹配',
  '8jOBpY': '输入的值必须大于等于0，最多保留4位小数',
  '94xxej': '收件人门牌号',
  '98jk2k': '您尚未绑定任何账号,请点击 <a>绑定账号</a>',
  '9A5e/t': '订单异常原因',
  '9Hmbk+': '地址校验',
  '9Vmjl1': '是否需要系统同步Tracking NO.至平台',
  '9ht+nd': '快捷选择',
  '9xYxPs': '*以上费用为系统预估费用，最终收费根据出库商品实际重量或体积计费。 部分费用无法预估，如地址相关附加费：住宅附加费、地址校验附加费等',
  'A+Qk3q': '出库产品',
  'A0KE+Q': '原订单',
  'A7QEW1': '通过设置自动同步订单规则，匹配商品并自动发货规则，自动上传跟踪号规则，或订单信息替换规则等，系统将按照设置规则处理平台订单',
  'AAcLUC': '提交发货时，申报价值自动计算规则',
  'AEEoPg': '请选择要确认的商品',
  'AFmlFB': 'CarrierWillPickUp',
  'AGCxbg': '出库跟踪号',
  'AapBMy': '平台SKU',
  'Ah+hNu': '国家不相同，禁止合并订单',
  'AjQYZ+': '设置库存同步规则',
  'Ak5IcG': '中邮揽收',
  'Akqn+S': '确认要替换地址信息吗？{break}原地址：{oldAddress}{break}新地址：{newAddress}',
  'Apabzu': '使用ReturnLabel',
  'AqNc7V': '平台绑定',
  'AswY/M': '地址更新',
  'B0s28p': '注：仅同步在Tiktok后台维护了seller-SKU的商品',
  'BGblXM': '输入字符系统自动匹配SKU',
  'BgZm0W': '输入的值必须大于等于0，最多保留6位小数',
  'C+Uxzp': '最多保留小数后6位数',
  'C0XdtD': '地址校验限制',
  'CBne5X': '同步库存',
  'CHw3qK': '暂无设定条件',
  'CQLU7A': 'eBay派送方式',
  'CSYChb': '数量不能大于可用库存',
  'Ci0Gz7': '同步Tracking NO.',
  'Ck0FS5': '下单',
  'Cm99+l': '同步失败',
  'CqjwTi': '取消订单',
  'Cr2Er3': '国家城市邮编校验',
  'Cr5YTm': '提交成功，请到待审核页面查看详情',
  'D76Z0a': '(默认展示最新50条记录)',
  'DMJmu1': '平台售价',
  'DTDZKK': '注意：退货无法退回DEBR2，选择原仓退货会导致无法上传跟踪号',
  'DXA+RX': '该步骤必须配置，否则无法成功上传退货跟踪号',
  'DZ3tLQ': '订单状态统计',
  'DgbZbl': '上传节点',
  'DgtsPS': '商品同步时间范围',
  'E6sBKv': '不支持',
  'EII/T2': 'WINIT标准包装',
  'EMN/3N': '您此次合并订单中有如下合并项信息不同，请核对合并后信息是否准确，若信息错误请自行修改或取消此次合并。',
  'EYeeM/': '打包尺寸:长*宽*高(cm)',
  'EjwiL7': '批量取消订单',
  'En+MQY': '发货失败{count}单',
  'EnXH4I': '仅待发货/发货失败/待审核订单操作',
  'EnmuEU': '商品条码值重复',
  'EptF2N': '卖家ID不相同，禁止合并订单',
  'F+TH2y': '姓氏+名称',
  'F0/hCF': '称呼+姓氏+名称',
  'FERBzi': '详细地址校验失败，原因：{info}',
  'FJb1Tn': '仅待发货/发货失败状态订单操作',
  'FLVSid': 'Token已停用。推单、建联、标发等全部功能已失效',
  'GA2pu4': '是否需要系统为您更新平台的库存',
  'GCx4WP': '请在左边选择条件并设定',
  'GHgc0Z': '匹配商品并自动下单',
  'GM17E7': 'shopify唯一识别该订单下商品的ID，用于向shopify平台确认发货。若手动添加商品则无此信息',
  'GP5t2w': '查看原订单商品',
  'GcJVRw': '不符合自动发货规则的订单将停留在未发货列表。',
  'GeOOM8': 'prime订单禁用该操作！',
  'H635Bj': '退货winit产品',
  'HESoIq': '订单处理规则',
  'HYFiGn': '返回待发货列表',
  'HZFFbs': '指定退货PSC',
  'HeCAli': '用户ID',
  'HizwI7': '同步记录',
  'HkNxGk': '同步中',
  'Hm4LpH': '仅未匹配状态操作',
  'Hn2pQb': '卖家VAT',
  'Hy6d0p': '收件人公司非中文',
  'I3d4Gk': 'variation SKU',
  'I7S1fN': '是否需要系统为您匹配商品，匹配发货规则，并自动下单发货',
  'IHWpGJ': '添加拆分订单',
  'IdgYMG': '请输入信息',
  'IexirJ': '自动同步移除单',
  'IzzAhc': 'Token已被{platform}平台使用',
  'J0Ixtg': '已成功匹配发货规则{count}个, 其中',
  'JFnjqm': '追加发货商品',
  'JLs16Y': '申报价值用于国际派送<Text>(跨境清关，例如：德国海外仓派送至法国)</Text>和发票打印',
  'JNgnyH': '自动发货校验结果',
  'JTWY/n': '电商平台不含税商品金额',
  'JUvp6d': '下单失败',
  'JYmlWa': '退货仓库',
  'Jdb9OB': '卖家订单号，双击切换到多个查询',
  'JezdzU': '请先选择仓库',
  'K27qop': '全部导出',
  'K7rEg4': '订单日志',
  'KC5nMg': '添加下一条',
  'KQr9Qy': '发货方',
  'Kl42ZO': '请填写大于或等于0的数，最多保留2位小数',
  'KsxYm8': '商品刊登时间',
  'L6OOWH': 'Tiktok非美区域订单，暂不支持按SKU数量拆分',
  'Lechn7': '合并订单',
  'LgOGwZ': '是否需要系统同步Tracking NO.和return Tracking NO.至平台<Text>(同时获取派送跟踪号及退货跟踪号后，才上传)</Text>',
  'LkEeD0': '可拆分数量',
  'Lo+WTc': '卖家自送',
  'LoPdId': '请先选择订单',
  'LzQ0Lw': '确认删除？',
  'M3GU+Y': 'Winit出库单号',
  'MIpscV': '同步订单后，当Winit预估物流费用大于设置值时，订单需人工审核 {break} <Text>(自动发货和手动发货都会校验此限制；物流费用包含出库处理费、尾程派送费及其他附加费)</Text>',
  'MNIlmV': '时间范围不能超过7天，请重新选择',
  'MYg06i': '产品库存 Token',
  'MYkSIE': '批量确认',
  'McIP0t': '商品售价',
  'McrsRy': '检测到平台订单地址与当前页面提交的地址信息不一致（订单：{orderNolistStr}），是否需要使用平台最新地址下单？{break}若您已编辑地址，使用当前地址下单即可。',
  'Mg0AQc': '取消拆单',
  'MsI/sQ': '平台售价：0<可填写的数据（2位小数）≤100',
  'N17kGs': 'Winit预估物流费用大于(USD):',
  'N4+kjM': '你好，Winit已完成{platform}海外仓认证啦!{break}{break}第一步，请先阅读授权协议并同意授权获取信息{break}第二步，在{platform}平台补充Winit的账户信息{break}{break}操作完成后，{platform}平台将获取你的海外仓相关信息，并推送订单和商品信息',
  'NDWefD': '退货目的仓',
  'NtMJWV': '同步完成',
  'O/h+jI': '是否需要系统同步Tracking NO.至平台<Text>(获取跟踪号即上传)</Text>',
  'O06joR': '自动发货不通过/异常信息',
  'OXsNWP': '批量发货',
  'OeDSof': '请先选择同步时间，再操作导出。{break}同步时间范围最长支持一年，如时间跨度较大请分批查询再导出。',
  'Oo2KiB': '提交成功{successNum}，提交失败{failNum}。',
  'Ozld0E': '平台账号及站点',
  'P9tr6t': '履行小时数',
  'PBGuz3': '波兰',
  'PBjcAH': '平台商品状态',
  'PO2HVG': '退货订单',
  'PvtavC': '平台商品名称',
  'Q7ENee': '关闭指引',
  'QI6Ef9': '平台商品规格',
  'QKEWl2': '导入匹配',
  'QMaIOh': '优先级(执行顺序从大到小)',
  'Qbz3hj': '本本店铺',
  'R/w0JS': '商品总价',
  'RIGInR': '发货成功{count}单',
  'RMDKuM': '包裹出库时上传',
  'RWLdD9': '请选择2到20个订单进行合并',
  'RY1yFe': '作废退货单',
  'Rrqg+Z': '去授权>',
  'RsiyM6': '通过配对平台商品和WINTI商品，建立二者匹配关系，后续同步订单发货会根据匹配关系处理实际发货商品及数量',
  'S39LBS': '注意{break} 1、单次导入最大支持3000条数据，请分批导入。{break} 2、暂仅支持对未匹配的平台商品批量匹配，导入后自动确认已匹配。{break} 3、若存在一个平台商品需要对应六个及以上的WINIT商品，导入暂不支持请手动完成匹配。{break} 4、Shopify、Wish平台店铺账号请填写店铺ID，详见账号管理。{break}',
  'SFPZaI': '订单范围',
  'SMwamU': '关联winit渠道编码',
  'SPja2U': '订单同步规则说明',
  'SVtGPL': '订单处理失败的原因',
  'SdW6D2': '同步{platform}商品',
  'Sda2Eq': '请先保存正在编辑的商品',
  'Sr3ung': '前缀',
  'Srv1tz': '设置自动退货规则',
  'T/rcpD': 'Token暂未被{platform}平台使用，请及时去平台绑定并完成授权',
  'THApeX': '手工匹配',
  'TL7VCA': '买家派送方式',
  'TVU/FV': '合并项',
  'TfyJrx': '收件人公司',
  'Tiq/oz': '未指定查询商品',
  'TqtWP4': '是否确认撤回？',
  'U+SXZR': '仅待确认状态操作',
  'U0/tzD': '合并前',
  'U7Ceox': '物流费用限制',
  'U8Pz8g': 'IOSS全称是进口一站式服务，是欧盟为减轻低价值货物清关压力，简化相关手续。 {break}1.英国发欧盟，IOSS NO，根据渠道要求是否必填。如DPD',
  'UAX0mp': 'WINIT揽收',
  'UWXTRM': '目前仅OTTO和PLentyMarket平台需配置退货规则，其余平台配置无效',
  'UjYJFb': '仅取消发货订单操作',
  'UnMDmI': '请输入数字',
  'UsHCy4': '拆单发货',
  'VVeUFY': '暂最多统计近3个月订单状态流转数据，统计为拆单或合单后的订单数',
  'VchMSg': '请先设置收件人邮箱替换规则，才可启用',
  'VoFDc0': '自动同步',
  'VuHi5g': '请输入12位及以上的数字或字母',
  'WElSYV': '编辑发货',
  'WN8E36': 'Winit商品编码*数量',
  'WNHZoW': '亚马逊',
  'WNLBrz': '需在WINIT注册商品，用于商品数据管理并和平台商品建立联系',
  'WQKhi4': '您尚未绑定任何账号,请点击{a}',
  'WUjg/Y': '查看发货失败订单',
  'Wdn3bR': '提交成功{successNum}，提交失败{failNum}。<br/>失败的导入数据和失败原因<a>点击下载文件</a>',
  'WonkyG': '收件人电话为空替换',
  'WtVOWa': '同步订单',
  'X+pVqZ': '整数位长度不能超过10',
  'X7hfpR': '待人工审核',
  'X84Qes': '出库单信息',
  'XC4iyK': '请编辑商品添加条码值',
  'XIqLuH': '订单包材类型',
  'XKNWZ0': '暂未设定条件，将默认全部订单。',
  'XSkCPJ': '订单最后更新时间',
  'Y1GIwR': '可按需启用平台，平台启用后可授权店铺',
  'Y6c2bc': '订单发货 Token',
  'YHGW8s': '至少输入2位',
  'YOKKP9': '请选择要解除的商品',
  'YPwzdO': '查看取消发货订单',
  'YUC7c3': '卖家自定义订单号',
  'YfisbY': 'DeliveryExperience',
  'Yq2JvZ': 'eBay每个账户每5分钟仅可以请求同步一次!',
  'YycnMl': '确认启用吗？',
  'Yz3osq': '已同步',
  'Z12huF': '收件人信息禁止超过10000条，请删除后再提交',
  'ZDBa84': '店铺授权',
  'ZKTxLl': '最新地址下单',
  'ZPrnCX': '请选择条件圈定订单范围',
  'ZSQdnW': '您还未授权店铺，请先选择平台再新增授权店铺~',
  'ZbMlwg': 'winit渠道名称',
  'ZcEOKe': '获取',
  'Zd3tQ1': '只允许状态为未下单和下单失败的订单可以取消订单，请重新选择！',
  'ZmVDi/': '增值服务选项',
  'ZphZQT': '平台同步将在跟踪号生成后立即上传到ebay后台，并在包裹出库时再一次同步跟踪号到ebay后台',
  'Zu7b47': '您本次操作将会解绑平台商品ID：{platformItemId}匹配关系。请确认！',
  'a1lp3z': '以下是建议地址，请与收货人确认后再参考使用',
  'a1xnWp': '去设置',
  'aQCUfC': '卖家ID',
  'b/xWVl': '拆分数量',
  'b0To7i': '出库单的仓库和winit产品',
  'b0fqEV': '发货信息',
  'bAi39D': '在售',
  'bBDPB+': '执行完毕',
  'bT3oxz': '未下单',
  'brIRvh': '匹配状态',
  'bt6uNU': '承诺最晚送达时间',
  'c8Qmll': '拆分数量必须大于0正整数，且不能大于可拆分数量',
  'cC9GYY': '同步订单后，收件人姓名填充规则配置',
  'cLWCG2': '平台同步将在包裹出库时同步跟踪号到ebay后台',
  'cee+ea': '请输入小数或整数',
  'cjf5im': '订单总金额',
  'd7t1vH': '设置自动发货规则',
  'dL7/Cj': '确认合并',
  'dOHXx8': '确定要撤回这些订单到待发货？',
  'dRv2q5': '同步时间',
  'dUKR8B': '收件人邮箱替换',
  'dlf0KO': '州',
  'dn8dx4': '出库单的仓库',
  'dxKF+V': '同步订单发货',
  'e++uU2': '买家邮箱',
  'eM8arj': '添加商品',
  'eMX0XN': '平台Carrier',
  'eN8cMr': '重新下单',
  'eZqSrm': '仅待审核订单操作',
  'ehBnJY': '优先级必须大于等于0的整数',
  'f5iZGp': '美区',
  'f7E98A': '币制',
  'fNjlMU': '收件人州',
  'fO5GuU': '发货失败{count}个',
  'fSGNZz': '比利时',
  'fSMR28': '订单量',
  'fSloUl': '通过手动同步或开启自动同步规则，可同步平台已付款未发货的订单至待发货状态。可手动下发海外仓出库单，也可匹配自动发货规则后自动下出库单',
  'fbyUZc': '正在同步中，请稍后回来查看',
  'fem61w': '退货跟踪号',
  'fv+irj': '或',
  'fvi6kx': '当收件人填写的电话为空时，自动替换为配置的电话号码进行下单',
  'g98DW3': '欧区',
  'gIYz64': '是Prime',
  'gQakVR': '您在{platform}已经标记发货，无法重复发货，您可前往{platform}确认；点击下方按钮跳转查看取消发货订单。',
  'gT+x6j': '是否需要同步更新订单信息：收件人信息、备注 <Text>(仅未发货状态才会更新)</Text>',
  'ggZsT6': '信息授权协议',
  'gnb/Dv': '优惠金额',
  'h8NAxo': '付款时间',
  'hJNaRw': '平台仓库和渠道',
  'hb7p0K': '是否需要系统为您匹配商品，匹配发货规则，并自动下单发货<Text>(仅同步在Tiktok后台维护了seller-SKU的商品)</Text>',
  'hboJsJ': '新增收件人信息',
  'heFsnp': '同步已授权店铺',
  'hf/k0S': '计费体积:单品体积累加(CBM)',
  'i/tHnC': '原平台订单已被拆分为以下订单。取消拆单后，如下已拆分的订单将一同合并（合并后可重新拆分）',
  'iAgwMn': '买家信息',
  'iC2h7q': '仅待确认状或已匹配状态操作',
  'iSBznD': '请先选择Winit产品',
  'iSi/Y2': '设置退货规则',
  'icjeQH': '单个添加',
  'ihL77X': '确定批量确认选中的商品吗',
  'j54HZ6': '即将过期，请重新授权',
  'jCDWTA': '确定要取消发货以下订单？',
  'jCc8SG': '{platform}：{value}',
  'jM4EZZ': '该Token仅用在{platform}绑定认证仓使用',
  'jNSZhB': '同步方式',
  'jSChCD': '阅读并同意<url>《授权{platform}查询协议》</url>',
  'jdWfuo': '店铺名称不能超过最大{max}个字符',
  'jmJUwg': '产品渠道已更新，请更新自动发货规则中配置的产品渠道或重新选择产品渠道下单，谢谢配合。',
  'jumY2+': '计划退货数量',
  'k1SuG1': '替换为：',
  'k3KmwO': '提交海外仓出库单成功后，同时自动创建退货单',
  'k4V29T': '订购数量',
  'k5K6Yt': '合并后(可修改)',
  'k6yicO': '是否担保订单',
  'kGU7zi': '请输入数字,并保留两位小数',
  'kpSBU0': '点击这里',
  'kw4Idh': '已提交至待人工审核{count}单',
  'l1E5Kc': '是否确认取消发货？',
  'lXd3or': '{platform}平台暂无有效的授权账号，请先完成店铺授权，{a}',
  'lcVkcM': '确认作废退货单？',
  'ljCEOy': '自动更新订单信息',
  'lkf5xf': '卖家VAT号，需先注册进口商[个人中心-服务设置- 出口商/进口商管理-查看-VAT信息-VAT] {break}1.英国发欧盟，欧盟发英国的订单，根据渠道要求是否必填 {break}2.渠道未要求必填的订单，如为英国出库订单，可填写',
  'lliahm': '更多设置',
  'm15yzY': '请输入1~128位任意字符',
  'm7WXxa': '发货时间',
  'mF20Qh': '已发货',
  'mIbw6U': '收件人公司(英文)',
  'mIw63f': '您本次操作将会确认平台商品ID：{platformItemId}匹配关系。请确认！',
  'mKK9WT': '只允许作废状态为已下单的订单，请重新选择！',
  'mSoKQe': '设置订单发货规则',
  'mmi+vH': '发货商品信息',
  'n0Xfv5': '后缀',
  'n0kndm': '确认取消退货？',
  'nHit3N': '请选择退货winit产品',
  'nLUS2T': '多个卖家订单号换行或英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'nQ+LR9': '使用Return label',
  'ndq6Ec': '待审核{count}个',
  'ngk71+': '退货Winit产品',
  'o4g7EG': '订单详情',
  'oR7wAu': '拆分订单',
  'odb5gY': '商品更新时间',
  'oibt/1': '增值服务项',
  'oud2NS': '售出时间',
  'p6hoaM': '发货日期',
  'p8ioIZ': '自动发货校验不通过原因',
  'pLhC09': '您填写的收货地址被承运商验证为"地址错误"，建议您修正地址后下单。{break}使用错误的地址下单可能导致包裹投递失败，同时产生地址检验/修正费用。',
  'pQhPvh': '公司(英文)',
  'pjDaex': 'custom Label',
  'pqJzJ3': '确定批量解除选中的商品吗？',
  'prz34V': '您是否需要自动同步获取移除单商品明细数据以及移除单跟踪号信息',
  'pyWapc': '发货仓库',
  'pztUhO': '批量导入匹配',
  'qWV6JF': '同步订单后，当Winit预估物流费用大于设置值时，订单需人工审核',
  'ql8RgO': '您需登录OTTO后台，配置退货routing code / 路由ID信息',
  'qo/NLW': '已发数量',
  'rOme4B': 'ShippingServiceId',
  'rPf5tI': 'prime的订单和非prime订单需要分开发货，请仔细检查后重新发货。',
  'rUBnXV': '确认停用吗？停用后平台推单、建联、标发等全部功能将失效，请先在平台取消授权后再停用',
  're1+gV': '请选择退货仓库',
  'rhr13R': '提交订单',
  'rtGwlf': '含有增值服务',
  's+OaHz': '包材',
  's7H+Ea': '原发货仓',
  'sH465R': '下单信息的国家州城市邮编必须全部匹配成功才能校验通过{break}只导入(国家/州/城市/邮编)不相同的收件人信息',
  'sLcGyn': '查看配置操作说明',
  'sNnZ4Y': '发货失败',
  'seO722': '请先设置计算规则，才可启用',
  'slMFds': '出库单的winit产品',
  't5QiVF': '订单处理',
  't9JxrU': '您尚未绑定任何账号，请点击<url>绑定账号</url>',
  'tXGo6k': '请求开始时间',
  'tcek4x': '详细地址校验',
  'tiQ2lL': '自发快递',
  'tiReS9': '配置退货承运信息',
  'toZ02P': '发货成功',
  'tr8ieB': '近1天',
  'trwfSO': '请先选择需要拆分发货的商品，然后添加拆分订单',
  'tx3VXW': '同步时间范围',
  'u7KD5S': '主单中至少存在一个商品，请重新拆分',
  'u7ocgU': '同步订单后，收件人邮箱替换规则配置',
  'uAu2Dr': '输入的值必须大于等于0，最多保留2位小数',
  'uB9dmc': '当前账号暂无<strong>{menuName}</strong>菜单权限，请联系主账号开启',
  'uDkDxI': '商品范围',
  'uK/6iw': '退货上架处理方式',
  'uLupxE': '是否需要系统自动同步订单至订单列表',
  'uRbIR3': '确认授权',
  'uiMchU': '买家ID不相同，禁止合并订单',
  'v1KiUu': 'Winit商品明细',
  'v3+E+w': 'Winit退货单号',
  'vAgZTZ': '已拆单',
  'vBf++D': '请先通过国家城市邮编校验',
  'vDASuh': '该收件人信息已存在，请不要重复添加',
  'vH/+mg': '已选中{count}个订单，是否对选中的订单重新执行自动发货规则？',
  'vOev4X': '平台订单详情',
  'vWi3Vl': '确认取消订单？',
  'vcHJ25': '必填项仅支持英文和数字',
  'vfp0r9': '确定要撤回以下订单到待发货？',
  'vg7n2N': '商品匹配',
  'voSiwO': '收件人街道1',
  'vrfKdo': '平台父SKU',
  'vvpREo': '重新匹配规则',
  'w1k3VB': '跨境店铺',
  'w2H7cS': '平台子SKU',
  'w9f6F7': '退货单状态',
  'wazdM3': '订单更新时间',
  'wiyRvq': '请先勾选商品并确认商品数量',
  'xFL39V': '运费',
  'xJtYaX': '授权信息',
  'xK+WAG': '卖家承诺送达日期(北京时间)',
  'xMN2jr': '拆单',
  'xRG5/O': '订单金额',
  'xRbMLs': '设置规则',
  'xcXdOz': '设置订单匹配规则',
  'xjgdRa': '请选择要取消的订单',
  'xoqs73': '暂无建议地址',
  'xrEY+m': '店铺账号',
  'y27XLJ': '已匹配',
  'y8FQY+': '买家派送类别',
  'yCEYqm': '拆单成功，请在未发货-拆单发货中查看拆单信息',
  'yDkttN': '当前国家不支持城市邮编校验',
  'yVcad6': '提交海外仓出库单成功，同时创建退货单',
  'yeFbaK': '去平台查看',
  'yqcSAM': '同步订单数',
  'yz+0WG': '查看待审核订单',
  'z4UtzG': '当前地址校验结果为不通过，建议您与收货人确认后选择推荐地址下单',
  'z54KMO': '拆单后，若拆分的任一订单已发货则不可撤回。已拆单的订单不支持合并发货',
  'z6dNPk': '订单异常情况',
  'zFjwI6': '商品编码*数量',
  'zWGfdT': '确认撤回？',
  'zZW2wr': '完成授权店铺后，可以在平台同步系统中操作对应平台的相关功能：同步订单、同步商品、上传跟踪号标记发货等',
  'zk7SMq': '请先拆单',
  'zygLEO': '订单创建时间',
  '+O4tBd': '取消下单',
  '7LJCdw': '合作仓对接',
  'FQtWyC': '常规对接',
  'Tmj1qg': '优先级不能超过最大{max}个字符',
  'ks/AJB': '常规对接合作平台： {platform} 等',
  '6nPEWw': '同步库存规则说明',
  'bMei6Y': '合作仓对接模式平台：{platform} 等',
  'ezoUFi': '常规对接合作平台：{platform} 等',
  'fbUD56': '部分平台支持设置订单处理规则，详见平台操作指引。需要在平台商家后台中完成操作',
  'rhY6/6': '完成授权店铺后，即可获取相应token。需要在平台商家后台中完成那定授权操作',
  'txPox+': '匹配平台商品和WINIT商品，建立二者匹配关系。需要在平台商家后台中完成操作',
  'Fil2JU': '查看{platform}操作指引',
  'gb6L3E': '完成配置操作后，平台会自动同步订单,并自动下出库单。{break}注意：此类订单不会展示在平台同步菜单，订单下发成功请在出库单模块中查看，订单下发异常请在平台后台中进行修正后重推。部分平台操作有差异,详见平台操作指引',
  'SLH3v0': '费用设置为0时将不会判断限制规则，若需人工审核请设置大于0数值',
  'LnpBHN': '时效标记',
  '+F2ixr': '时效标记是指订单适用的时效保障服务，与订单选择的渠道或增值服务有关，具体请参考WINIT产品定义',
  '8A3iSu': '您设定的1个电商平台ID【{winitItemSku}】发出【{winitItemQty}】个【{winitItemName}】{break}',
  'u1MvPk': '1. 系统会在每月1号自动生成海外仓账单，每周一自动生成ISP账单。过此时间还未生成账单，则请联系客服。{break} 2. 独立账单&本期支出-本期收入不为0可开具电子发票。{break} 3. 2025年02月01日后发票合规管理后，预开票+后开票的总开票金额超过累计至当前的消费金额时不得开具发票。{break} 4. 发票和账单相关问题，请联系在线客服。',
  'XVpiwO': 'BC包裹条码数',
  '+/g10t': '出库单销售平台',
  '/2o3AV': 'Seller ID',
  '0dJ1P8': '实物商品编码',
  '0djqyQ': '请务必在货物到仓前维护退货跟踪号，否则货物有风险流转为无主货。',
  '0rwflq': '是否Return Label',
  '11Fc73': '检查结果为不良品',
  '1UKfTS': '退货商品({originalMerchandiseSerno})的库存已经不存在，无法关联商品，如有疑问请联系客服，确定提交后该退货商品的状态将更新为已完成，是否确定？',
  '1b6W7N': '出库单子单号',
  '1qoi3T': '图片',
  '2L6ati': '退货',
  '2LDGUc': '超期自动销毁时间',
  '2hr1of': '拍照模版类型',
  '2ll590': 'RMA号',
  '2smMkx': '退货处理时间',
  '3QNffE': '处理时效',
  '3pTMyj': '发件人信息',
  '5IfCJO': '请填写大于0的数字，最多保留4位小数',
  '5hMlW2': '注意：{break} （1）商品需完成注册并审核通过，才能创建退货单。{break} （2）商品化管理的商品，实物到仓前，如能提供第三方商品条码在商品管理页面维护，确保仓库收到实物时能够扫描识别；{break} （3）单品化管理的商品，若下单时无法提供，实物到仓前，如能提供第三方单品条码，务必在库存单品管理页面维护，确保仓库收到实物时能够扫描识别；{break} （4）若实物上无有效识别的第三方条码信息，则仓库收货后会根据商品无条码的异常策略进行处理！',
  '5n9upP': '商品级客户定制拍照模版',
  '68BAPH': '增值服务单',
  '68cqkQ': 'RM码',
  '6pLkXQ': '州省',
  '6vnHwd': '请输入SKU编码, 支持模糊搜索',
  '7/Gips': '处理意见',
  '799kEA': '修改时间',
  '7P6gF1': '下单成功',
  '7UH/y2': '确定提交',
  '7hpKK4': '客户关联SKU后，仓库将退货商品RM标签更换为关联的SKU M码标签，并移库到良品区上架。',
  '7iUz69': '良品处理方式',
  '8Dirwm': '自动销毁时间',
  '8TwOhb': '是否空包',
  '8cDIeY': '针对目前海外仓退货需求，万邑通提供无RMA退货服务，帮助您完善退货管理，接收未进行退货预报的货物，以便您及时处理您的退货库存。',
  'A+jWI7': '创建类型',
  'A63PcF': '暂存时间',
  'AICkca': '定制拍照模版',
  'AlOOoT': '最少支持上传1张，最多支持上传15张模板图片！',
  'B6Z4Gq': '快速退货地址',
  'BDCdKO': '检查结果为不良品处理方式',
  'BQ2Et0': '选择关联商品',
  'BWdJmA': '请务必将以下WINIT退货中心地址（已包含专属退货ID）维护至您的销售平台退货地址或提供给您的买家，带有退货ID的地址将利于仓库识别出您的退货订单。',
  'BnGVAl': '卸货跟踪号',
  'BvC0EG': '客户下单',
  'C72hoh': '请注意完整填写退货地址信息及标号',
  'C8dc7/': '补充退货跟踪号',
  'CeXPpD': '是否投保',
  'D1zVXx': '照片已维护',
  'DBKT4U': '供应商',
  'DBrCz6': '客户退货跟踪号',
  'DdDnkx': '退货中心仓库地址',
  'Dgc9tF': '发件人名称',
  'DlRW4A': '无RMA（无预报）退货指引',
  'ECxCyh': '对应处理方式',
  'EqPEoU': '新复制商品编码',
  'F+1Ly6': '原卸货跟踪号',
  'F97OGz': '根据出库单号:[{orderNo}]查询出库单失败',
  'FCSu4h': '退货数量',
  'FRKa5V': '仓库备注',
  'FTSLqN': '邮编【{postCode}】无可用提货日期 ！',
  'G66ewv': '分类',
  'GbI2f+': '实际拍照数量',
  'GmWdlP': '退货商品({skuCode})的库存已经不存在，无需再销毁，确定提交后退货单内对应商品状态将自动更新为已完成，是否确定？',
  'HcO8E9': '发件人姓名',
  'HuoMXG': '此处商品级策略默认取订单基础内填写策略，支持修改，此处商品级的策略优先级高于订单基础信息内填写策略。',
  'HyER60': '被关联商品信息',
  'ILbEkr': '去注册新商品',
  'IOP/vU': '出库数量|可退货数量',
  'IsemUS': '出错行号',
  'Jpz9XQ': '查看退货增值信息',
  'Kf7UU1': '不良品处理方式',
  'Kv61+4': '派送供应商',
  'KwuNUe': '批量处理',
  'LZMJSc': '实物识别条码',
  'NTRE6D': '查看退货增值单',
  'NcB8kv': '维护方式',
  'OAUF/v': '（4）有RMA退货提交订单必须在货物到仓前提交，否则有可能被判定为无主货。',
  'ODaCbS': '配送时效',
  'ON6UqU': '暂存商品条码',
  'OeMOhC': 'RM码尺重大于被关联的商品的核实尺重,则会更新被关联商品尺重请谨慎选择!',
  'P0LBOd': '处理',
  'PozUc+': '已退回',
  'QBKGFh': '批次属性-日期-产品批次号',
  'QYLVrI': '提示：批量维护后，此次您所选择商品的相关历史照片模板将会清除，系统将采用您此次维护的作为照片模板。',
  'Z+MCSG': '注意:{break} 若退货面单上无退货ID，且商品无可识别的有效条码，货物将会被判断为无主货。{break} <font>为避免无主货的产生和享受更优的退货处理时效，推荐您使用万邑通的Return Label服务或有RMA退货服务。</font>',
  'Qgy4xA': '商品退货策略',
  'R/Mgye': '温馨提示：重新上传会清空原添加的商品信息',
  'R1WVaq': '使用 Winit Return Label服务',
  'RCHqIg': '包裹尺重信息[长*宽*高 重量]: {length}cm*{width}cm*{height}cm {weight}kg',
  'RHHueZ': '请输入退货数量',
  'RdnRuz': '包裹尺重信息',
  'RgICGS': '选择的关联SKU',
  'Rl/75p': 'Return Label',
  'SdbY82': '子出库单号',
  'SopSUH': '检查结果为良品处理方式',
  'T0dYfd': '退货跟踪号允许输入数字、字母和符号，6-60个字符',
  'T29xwd': '增值服务单号',
  'T9MdWR': '仅对 UK & DE 有效；如选择，则该订单下所有SKU适用该VAT。',
  'USFimD': '下单数量 | 实际上架数量',
  'UTeJqS': '原跟踪号',
  'VN6BbB': 'RM码重量',
  'VgURQV': '退货暂存商品处理',
  'WZUGRX': '是否测量尺重',
  'X7zovx': '退货子出库单号',
  'X9Kqav': '检查结果为良品',
  'XDxd9e': '实际上架',
  'Y1zy+s': '仓库将退货商品销毁。',
  'ZEB0yN': '仓库收到的原商品是批次管理商品，被关联的商品不是批次管理商品，是否确定关联？',
  'ZTSz4Y': '您输入的商品编码不存在，请关联已经有的商品，请修改商品编码，或注册新品后再关联新品。',
  'a381GD': '待补充退货跟踪号',
  'a4hXYh': '收货仓',
  'bNrg6s': '退件实物条码',
  'bg+pto': 'RM码尺寸',
  'c9TJu9': '请填写大于0的数字，最多保留2位小数',
  'cEA4zF': '修改者',
  'cYlsil': '客户自定义模板',
  'd9R845': '退货策略',
  'dgvdrA': '实物条码对应SKU编码',
  'dr93it': '下载面单',
  'e0QLxL': '模版拍照数量',
  'eV1I2k': '退货原因',
  'eZPZ8+': '销毁出库单号',
  'eihkgE': '暂存商品信息',
  'fRQ7Hv': 'Scan标识符',
  'fcWN+y': 'WINIT截取',
  'flwayn': '出库子单号',
  'g2+Ax2': '发件人详细信息',
  'gwfFoI': '客户关联SKU后，退货商品保留原RM标签，移库到不良品区上架。',
  'hGqR3l': 'VAT Onwer',
  'hsQeVV': '总费用（USD）',
  'i3I/pa': '待维护',
  'i8C1qO': '有RMA退货地址须包含RMA号，将在创建订单完成后返回。',
  'iJHRJg': '（5）AU Warehouse退货地址为邮局POBOX地址，仅支持使用AU Post服务退回该地址，若使用AU Post之外的服务退回请联系在线客服获取其它退货地址。',
  'j91Q75': 'SKU编码[{searchText}]规格[{specification}]{status}，请使用其他SKU编码！',
  'j9u2yH': '客户备注',
  'kICF+A': 'WINIT订单号',
  'kMLdYw': '订单备注',
  'kPaZ+K': '重置为出库单收件人信息',
  'keDN3D': '退货下单策略',
  'l62Oqo': '取件日期',
  'lCL7h7': '处理费用',
  'loevIq': 'Winit产品及费用预估',
  'mLt8j5': '退货完成时间',
  'mlgAHz': '关联的商品编码',
  'mrYK6Z': '退货商品图片',
  'nKLIK1': '关联商品',
  'nq2M/N': '请填写新复制商品的SKU编码，该SKU仅适用于退货维护',
  'oGfEgE': '退货数量不能大于可退货数量',
  'p4wQ31': '无法提供并取消代办',
  'pAhBaD': '商品名称(中/英)',
  'pGYuf8': '规格型号',
  'pLESa/': 'WINIT退货中心接收货物且能识别到货主后将自动创建退货单',
  'pSpGmB': '仓库增值处理中',
  'qExiwC': '邮箱格式不正确',
  'r4aetI': 'Winit截取跟踪号',
  'rFU4fG': '预计完成日期',
  'sNUB3N': '客户待处理',
  'sVETw+': '退货拍照模板',
  'stoffA': 'VAT Owner',
  'sy+pv5': 'Email',
  't7FHVM': '确认作废吗？',
  'tGXMLl': '退货单品数量',
  'ts37H5': 'VAT/EORI',
  'uADqqT': '退货商品信息',
  'udsQe8': '拍照时间',
  'v/3ZQu': 'WINIT出库',
  'vFVpcn': '未发布',
  'vH85CS': '非WINIT出库',
  'vW2S+F': '不良品上架商品在出库时不能与良品同出库单出库',
  'w1PwZD': '发件人基本信息',
  'wBTrH2': '取件偏好地址',
  'wfl9ZM': 'Winit 订单号',
  'xCdMfz': '非必填项，仅针对 UK & DE 有效，如指定VAT，所有商品按此VAT入库，否则按系统规则分配。',
  'y0wTBC': '买家',
  'y9b1P7': '最多支持上传{maxCount}张模板图片',
  'yJeaIT': 'WINIT退货中心将按照无RMA退货处理策略进行处理',
  'yWr1bK': 'Winit模板',
  'ywoyKz': '申报价值(USD)',
  'zDk1Nv': '将WINIT退货中心地址维护至您的销售平台退货地址或提供给您的买家',
  'zJv/fs': '创建退货单',
  'zVNDbm': '若未维护商品级定制拍照模版,则会按客户级拍照模版处理,若未维护客户级拍照模版则会按Winit标准拍照模版处理。客户级拍照模版费用与Winit标准拍照模版不一致,详情可见产品价卡说明。',
  'zYCqK9': '尺寸(长*宽*高/cm)',
  'zh/BWz': '上门取件信息',
  'QhLnYY': '修改日志',
  'IoOUi9': '订单内[{confirmListCode}]属于不良品出库，是否确认退货仓库接收实物按‘直接上架-良品上架’进行添加良品库存，继续下单则点击‘确认’',
  '8rukt0': '已收件',
  'WSk/X1': '停计自动销毁',
  'eJlU8R': '查看模板图片',
  'AKFq1O': '最新推送时间',
  'UdTynn': '注意：{break} 1、仅在【账号管理】为已启用的eBay账号，库存信息会同步到eBay，您可前往【<a0>账号管理</a0>】查看eBay账号状态；{break} 2、该页面仅展示已绑定的商品信息，未绑定请前往【<a1>eBay认证仓商品管理</a1>】进行绑定；{break} 3、推送认证仓商品有库存和商品尺重限制，详见<a2>操作说明</a2>；{break}',
  'rrWpjk': '最新不推送原因',
  '96PAzm': '提交成功{successNum}，提交失败{failNum}。{break}失败的导入数据和失败原因<a>点击下载文件</a>',
  '3w/ZXS': '无记录（单品未入库或对应操作信息已超2年数据自动归档）',
  '5CPQd8': '当前单品状态',
  '8VJJbj': '单一产品则为单一产品核实体积,箱套产品则为箱套产品对应的核实体积',
  'OpKDTp': '确认切换到【是，与良品一致】吗？',
  'RYj/xc': '箱产品或套装产品的在库箱/套数量',
  'RydShn': '单品条码操作日志信息',
  'WHQp3W': '箱/套数量',
  'Xm1pt6': '普通商品',
  'uZU8sk': '出库下单自动组套的场景下（多套表示为2套及2套以上）；{break}若配置为【是】则下单1件商品A，命中此组套关系，自动进行组套出库，下单2件商品A，命中此组套关系，自动按2个组套处理；{break}若配置为【否】则下单1件商品A，命中此组套关系，自动进行组套出库，下单2件商品A，不允许按组套处理，常规打包处理。',
  '8sL5pg': '数据更新',
  'HhrjUl': '分母：目标出库日期范围内，非草稿 / 客户作废 / 万邑通作废 / 抓单失败作废的应出库包裹数{break}分子：分母范围内，实际出库日期<=目标出库日期的包裹数',
  'UVl8Ye': '导出超时未出库明细（实时）',
  'nxCFhm': '由于更新时间不一致，可能导致此数据与页面【超时出库数】不一致',
  '+QH9aU': '预计国内仓出库',
  '61Q2bA': '预计到海外仓',
  'Cyx0kU': '下单重量',
  'XAVPBS': '该偏好仅应用在下入库单过程的费用预估，其他如下单限制、海外验的预约及违规费计算，不取本偏好的应用',
  'd/umZj': '请注意,选择免自验后,订单将在提交后自动完成验货,无法再修改箱单；{break}且免自验后B/C包裹因未验货系统无子包裹信息，上架后会按未做子包裹标准计费。',
  'rSSvME': '系统将按照您输入的长宽高按照最长边、次长边、最短边进行展示及费用预估',
  'zSDFbF': '下单体积',
  '05TZVT': '出库异常',
  '0Npq7r': '创建出库单',
  '6g9Wst': '待处理暂存订单',
  'AIywwl': '拍照暂存待处理',
  'IocBNZ': '库内异常',
  'KdkO6t': '待确认缺量订单处理方式',
  'VtgkiE': '出库待处理',
  'XNrxUg': '入库异常',
  'cHJ2tH': '入库待处理',
  'IaVnOG': '费用预估偏好设置',
  'cM+3En': '仓库已收货',
  'f9HdOe': '登录IP',
  '+nKXJ/': '设置策略',
  '0TIzQx': '等待审核',
  '16zLrM': '注意：为确保检查效果，请在图片上圈出位置，标记必要的文字说明后再上传',
  '35Ap1W': '是否确定清空商品【{codes}】设置的退货策略，退货时若无商品级策略会按您配置的默认退货策略处理！',
  '4FyYBa': '默认退货策略(客户级)',
  '4wGMni': '派送失败：',
  '5V9CE8': '若海外仓收到退货时“退回商品状态≠正常时”将按照以下优先级匹配退货策略：',
  'Aiuda0': '商品拍照模板',
  'Bdb4rA': '高货值',
  'CVPemq': '商品特性-优先顺序',
  'DbtZiz': '1. 在「商品退货策略」页面配置的商品级退货策略。',
  'EMUWj/': '标准类型',
  'ElZ9N0': '最大支持批量查询{num}条，批量查询时英文逗号隔开或换行！',
  'FWkmOf': '页面模板',
  'GRPOdU': '退货策略匹配优先级为: {break} 商品退货策略>默认退货策略(客户级)>Winit退货策略 {break} *若均未设置"商品退货策略"&"默认退货策略"，则按"winit退货策略”处理。',
  'IsZPwQ': '批量编辑',
  'LJjMp2': 'Winit策略',
  'M0p1ky': '格式支持jpg，png，gif，jpeg',
  'Nu6ukW': '批量清空策略',
  'RJAU9A': '确定清空策略吗？',
  'SEGQZS': '退回商品状态_正常"按照以下优先级匹配退货策略(前往配置):{a1}>{a2}>{a3}',
  'SGo++1': '3. 如果以上1和2都未配置，退货时将采用以下默认策略: 无RMA：拍照暂存 派送失败：直接上架。',
  'U0+OQF': '海外仓收到退货时“退回商品状态=正常时”将按照以下优先级匹配退货策略：',
  'UPxP2W': '良品图片至少上传5张',
  'VN1ezV': '良品图片',
  'W3/yma': '默认退货策略',
  'XwFUS0': '无RMA退货策略',
  'YBQNBm': '若清空商品对应的退货拍照模板,则会按此默认模板进行拍照，若未维护默认模板，则会按WINIT标准SOP进行拍照处理！',
  'YIGFVJ': '若商品未维护对应的退货拍照模板,则会按此默认模板进行拍照,若未维护默认模板,则会按WINIT标准SOP进行拍照处理!',
  'YzOXoA': '1. 在本页面配置的客户级退货策略。',
  'ZMYzQk': '*若均未设置"商品退货策略"&"默认退货策略",则实物退货到仓后会按"winit退货策略"处理，为避免产生不符合预期的退货处理方式，请结合实际业务情况及时配置策略！',
  'aVh0hV': '退货策略维护',
  'ax4G39': '编辑照片',
  'axey37': '退回商品状态',
  'bUJ3KI': '清空策略',
  'c1hxVC': 'Winit退货策略',
  'eivou1': '维护退货拍照模板',
  'hBzbwm': '无RMA：',
  'hXKE17': '通用标准',
  'jJiNOd': '退货商品状态',
  'l0h4gZ': '多个商品编码/商品条码换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  'l8NWUi': '"退回商品状态_非正常"按照以下优先级匹配退货策略(前往配置):{a2}>{a3}',
  'm+CSKJ': '无RMA',
  'mmuRHl': '批量清空',
  'nzf0kE': '2. 按WINIT配置的基础规则【{a}】',
  'o7BHmU': '批量设置策略',
  'oEcYBH': '2. 在本页面配置的客户级退货策略。',
  'p7uXGN': '派送失败退货策略',
  'ppO2BL': '照片数量',
  'rs+KKE': '标准名称',
  's2MRUC': '优先顺序',
  'uE11Jo': '不良品图片',
  'veuVN/': '无RMA和派送失败的退货策略至少填写一项',
  'w7h6tB': '编辑策略',
  'wCQB8y': '请先勾选商品',
  'zETnvF': '商品退货策略设置',
  'zcAqKI': '默认拍照模板',
  '8TxolX': 'Winit将按照以上的规则匹配退货处理策略，请结合实际业务情况提前配置对应的退货策略。',
  'ZxQtHK': '您可以根据需求配置不同的退货处理策略',
  'fhEV6C': '退货商品状态≠正常时，将按照以下优先级匹配退货策略:{a2}>{a3}',
  'kPQvJQ': '退回商品状态=正常时，将按照以下优先级匹配退货策略:{a1}>{a2}>{a3}',
  'Gtlk4r': '商品导入成功，可在已设置页面查看商品',
  'hvJv2u': '(派送失败)',
  'ngTsgq': '(无RMA)',
  '2vV3rp': '该微信绑定多个万邑联账号，请选择登录：',
  '6zf5WP': '当前微信({nickname})已绑定以下账号：',
  'A9zFcw': '最近登录',
  'HO+Y34': '抱歉，当前微信绑定的账号已达上限(最多绑定{bindUserNumLimit}个)',
  'Jpe8pz': '前往登录',
  'RAXpq+': '立即登录',
  'REvR5Z': '扫描登录',
  'RVmna3': '抱歉，当前微信绑定的账号已达到上限(最多绑定{bindUserNumLimit}个)',
  'UNKU4n': '如需继续绑定当前账号，请录入以下信息：',
  'V3DdUR': '该手机号绑定多个万邑联账号，请选择登录：',
  'bVfn2l': '请选择登录账号',
  'dbmZAL': '手机账号不存在或未绑定，请注册或绑定后再登录',
  'h2IpXC': '如需继续修改手机号，请点击确定按钮',
  'hGVOxM': '邮箱密码',
  'i/PpUw': '抱歉，当前微信已绑定过账号，不可再次注册',
  'oacN/h': '当前微信({nickname})已绑定以下账号({bindTotal}个)：',
  'wHkfnl': '当前手机号码({phone})已绑定以下账号：',
  'GtIdEi': '默认验货仓',
  '7mwRSS': '当前该手机号码绑定的账号已达上限(最多绑定{bindUserNumLimit}个)',
  'LtYRX8': '抱歉，修改失败~',
  '2r3IJC': '请输入数值',
  '58WavZ': '自定义字段中文名称',
  'HowtAS': '文本',
  'Jueghe': '客户自定义字段信息',
  'ONR67m': '启用自定义字段',
  'ORgO0e': '最多24个字符',
  'P8Gwzr': '是否确认启用此自定义字段？生效后，API注册、页面注册、模版注册均会按配置内容进行要求提供对应自定义字段信息，无法提供或会影响商品注册。',
  'RptCJU': '是否已了解自定义字段使用场景，确认需要使用？',
  'XlfUm/': '支持最多创建3个自定义字段',
  'YtPtMs': '是否确认不再使用此字段信息？',
  'aZDBrY': '新增字段',
  'bKnbER': '字段类型',
  'dPCJQ/': 'Open API对接字段，无需对接API可忽略',
  'dvrx23': '自定义字段',
  'hMZnus': 'API字段名',
  'ksJ/3u': '扩展配置',
  'pkMcXZ': '此功能支持用户在注册商品信息提供额外信息，用于更好对商品信息进行管理，请根据实际需要选择性开通',
  'pu4ANt': '最多48个字符',
  'qCk2e7': '自定义字段英文名称',
  'rRBPTT': '数值',
  'x4370M': '请输入中英文或数字',
  'xOBjyi': '确认关闭吗？',
  'yYoxkN': '是否必填',
  '5dS8AK': '上传第三方商品条码标签文件',
  'bs3A4X': '第三方商品条码标签文件',
  'iuaNK+': '标签对应关系',
  'C1L/tA': '目前仅支持eBay、Temu、AliExpress、Shopify平台配置规则。其余平台将陆续开放，敬请期待!',
  'Nsa7YE': '请选择平台Location',
  'SFe2Aw': 'shopify平台每30分钟同步一次',
  'f9xwVI': '店铺{account}授权无库存相关权限：read_inventory、write_inventory、read_locations。请检查店铺授权token环节是否有勾选相应的权限。',
  'TB3rBj': '请使用「自提出库-通用模板」进行导入',
  'gYXO5b': '请使用「销毁单通用模板」进行导入',
  'lD87Nv': '请使用「标准出库-平台专用/通用模板」进行导入',
  'UDlvOw': '请输入字母、数字、下划线_、横杠-',
  'eGdiPg': '地址编号为订单批量导入或API下单时使用，由您自定义编写（支持任意字母、数字、下划线_、横杠-），但提交后不可修改',
  '+uX6k3': '发货方式选择偏好',
  'EsdtJQ': '基本信息选择偏好',
  'KxdV6o': '是否默认选择最早的提货时间',
  'LwZj/E': '是否默认选择发货时间最早的物流计划',
  'ReCcIp': '北京时间',
  'SQfknD': '报关方式选择偏好',
  'sm0/fH': '当地时间',
  'JkvJX/': '物流计划偏好设置',
  'NZ5Lvz': '报关方式偏好设置',
  'P2tp7i': '针对国内仓验货且提货类型为Winit上门提货，万邑联下单/API下单会根据偏好选择最早的提货时间进行下单；',
  'PXtCFW': '提货时间偏好设置',
  'yoFShO': '针对Winit承运且客户未选择物流计划，万邑联下单/API下单会根据偏好选择发货时间最早的物流计划进行下单；',
  'Y4m/OW': '仅支持目的国+头程类型+验货类型维护一条报关方式偏好，若匹配到对应偏好，万邑联下单/API下单会根据偏好内容进行下单！',
  '5HNHGL': '是否带有刀片',
  'NyXwQq': '#带刀片',
  'duQQ3H': '带刀片',
  'six1wi': '商品包含能够通过切割人体皮肤对人造成伤害的刀片物品，比如存在锯片、餐具刀、工具刀、剃须刀片等务必勾选。',
  '7bdh+E': '根据英国当地法律法规要求，所有含刀具的商品的包裹必须粘贴年龄限制标签，系统已自动为您添加"检查/补贴年龄限制标签"增值并将在订单中收取相应费用',
  'TBpJ9a': '根据英国当地法律法规要求，所有含刀具的商品的包裹签收时必须验证年龄，系统已自动为您添加"Last Mile VCA"增值并将在订单中收取相应费用',
  '6KfC40': '签署完成',
  '8FOzIZ': '海外仓《供应链管理协议》和《海外仓商业性条款补充协议》{break}由于{a1}和{a2}的内容具有相互关联性，两份协议需要同时签署，您可以点击协议名称查看具体内容。',
  'R+sv2r': '《供应链管理服务协议》',
  'akmnDR': '未到找该协议或该协议不存在',
  'qSrqiP': '海外仓《供应链管理协议》和《海外仓商业性条款补充协议》{break}由于{a1}和{a2}的内容具有相互关联性，两份协议需要同时签署，您已签署最新版本，可点击协议名称查看具体内容。',
  'zESJVr': '《海外仓商业性条款补充协议》',
  'zWDZbi': '不上传万邑通跟踪号码到EBAY（仅比利时仓供应商B2C Europe服务适用）',
  '8vrQgq': '自提出库（导入草稿订单号）',
  'itoONc': '自提服务',
  'lRBa4q': '如果是自提服务 {a}',
  'p4H1SB': '自提出库（支持多种增值服务）',
  'tpI9jm': '自提出库-自提服务',
  'g6wYzy': '支持按卖家提供的平台面单贴至包裹，通过合作承运商派送至买家手中。',
  'nZMq9z': '单品体积累加(CBM)',
  'rwNEpG': '打包尺寸(cm)',
  'qhKv6X': '平台暂仅支持{platform}，请先绑定平台账号',
  'rlIAep': 'OTTO,PLentyMarket',
  '1L4o+6': '上次登录时间',
  'NQMeVr': '每个手机号绑定的数量最多为5个，该手机号已绑定的数量已达上限',
  'e4DUUm': '子账号名称',
  'gT/sAQ': '开发者权限',
  'zlZigq': '昵称',
  'TTS8yp': '开发者权限和允许授权ERP的权限，如当前账号无开发者权限需求，建议关闭',
  '0xa2hp': '打开此权限后，该账号将拥有第三方授权请谨慎开启',

  '7FR7jP': '如未及时关联快递单号，则有可能导致处理为退货或无主货，因此产生的异常费用客户需自行承担，最终收货以WINIT实收为准',
  'VVc+P7': '是否亚马逊移除单',
  'C6x6Tv': '下单费用预估偏好',
  '3ma4nl': '当前产品由于"{error}"原因不可用，您可以选择更换其他包材类型或其他派送方式;如果为复合订单,也可拆单后下单。',
  '5ypbAw': '添加第{i}层包装',
  '8q9EMC': '第{i}层',
  'Atjd5O': '启用双层包装服务',
  'BwGeIF': '在完成客户订单的整体打包后，根据品牌推广或防护需求，在原有包裹外层额外增加一层或两层包装。需要注意的是，当单一包装层无法满足订单的打包要求时，不允许将部分商品单独打包后与其他未完全打包的商品组合，再进行额外包装。',
  'G37PK3': '第三层',
  'GtNbsM': '<strong>示意图</strong>{img}',
  'IELDaK': '已了解此服务的适用场景，确认需要使用双层包装服务？',
  'IUEZRN': '复制商品编码',
  'OHQMeB': '第二层',
  'TdjNLW': '默认为加单层包装服务，若需要使用多层包装服务，请前往偏好设置>商品设置>{a}',
  'V4pQH6': '点击查看示意图',
  'ZiSqLR': '第一层',
  'efGs6k': '包材用途',
  'qke9N+': '商品包装层级',
  'xmBGan': '由于订单中商品中包含礼盒包材，出库加包装增值的信息将会被清除，请重新选择出库加包装服务。',
  'hZJNn1': '由于订单中商品中不包含礼盒包材，出库加包装增值的信息将会被清除，请重新选择出库加包装服务。',
  '/k5tdz': '1. 礼盒包材：用于多层包装的内层，客户需另选外层包装。仓库打包时，先用礼盒包材包装商品，再添加外层包装。(未启用多层包装服务不支持此类包材用途){ break}2. 物流包材：可用作单层包装或多层包装的外层。',
  'hhIIwx': '多层包装服务是在现有出库加包装服务的基础上，额外再增加一层包装材料，以显著提升包装的美观性、保护性能及运输安全性。',
  'PAwxvf': '请务必在货物到仓前及时将所有相关快递单号关联为识别码。若未及时关联，货物可能被误处理为退货或因无法识别货主而被销毁，相关风险及费用由卖家自行承担。{break}最终收货情况将以WINIT实际入库记录为准。',
  'WWz7Q4': '无法提供并取消待办',
  '+AVH+W': '商业地址',
  '+MPom9': '"lift-gate"指的是装在卡车尾部的升降平台,用 于将货物从地面升至卡车的货箱,或者将货物从卡车货箱降至地面。这种设备对于处理重型或大 型货物特别有用,尤其是在没有装卸设施的地 方。在提供升降平台服务时,可能会需要额外的 费用。',
  '+big95': '待WINIT完成装箱、打托并暂存后,补充托盘标签等增值文件。',
  '/dySAg': '同一个仓库，如果有更新的WINIT版本，可点击后刷新切换到WINIT版本',
  '0y5hzY': '切换到WINIT版本',
  '0zyVbu': '供应商名称',
  '2BqPCg': 'FBA仓地址维护操作指引',
  '5wy87y': '该地址已有WINIT更新版本, 您当前使用的是自定义版本',
  '6qy1xl': '增值选项',
  '7SZjFs': '填写收货地址和出库SKU信息, 选择【Global Quote Shipping】的尾程产品, 提交出库单。',
  '7YtkDc': '基于出库单信息, 创建询价增值单, 补充尾程询价所需信息。',
  '7l3fV0': '详细操作指引',
  '8JScbo': '预估托盘数量大于22托，在线报价不支持FBA送仓，请选择人工报价。',
  '8RfQE7': '尾程询价出库单操作指引',
  '8RlcuN': '住宅地址默认不支持垛口卸货，零担派送(LTL)时必须选择Lift-Gate和APPT。FBA转仓默认为商业地址。',
  '8U/rTl': '目前仅限美国支持在线询价。提交询价增值单后，系统将在约5分钟左右完成在线报价，请耐心等待结果后在增值单查询页及时确认报价。',
  '9Cez6q': '已完成第一步, 请继续创建询价增值单',
  'AD5sEw': '报价模式',
  'AXrI4w': '投保',
  'EAOyFB': '第一步:提交出库单',
  'ELWNit': 'FBA地址',
  'ExQ/dx': 'WINIT收集的FBA仓地址库',
  'HG2EsH': '车型名称',
  'HvLzJn': '系统基于订单体积预估的托盘数量，仅供报价参考，最终计费以仓库实际打托数量为准。',
  'JiRAVh': '待WINIT反馈报价后(通过首页待办或邮件通知获知),在增值单查询页面操作确认报价',
  'JsLztN': 'WINIT仓库预约供应商提货,完成出库发货。',
  'K78O7t': 'WINIT版本',
  'KPTVBp': '查看FBA仓地址',
  'LRNoCX': '第五步:仓库预约供应商提货',
  'MAz12w': '版本类型',
  'MG/bFQ': '订单收货人类型',
  'Mbi+c9': '创建询价增值单',
  'Nkqbad': '询价要求',
  'NxHqKo': '提交询价增值单后，WINIT将人工为你向线下供应商询价，并在询价完成后邮件通知您。',
  'OQ0psa': '系统获取报价中, 请5分钟后来查看',
  'Ope61w': '预估托盘数量大于6托，在线报价不支持不住宅地址，请选择人工报价。',
  'OsuCLL': 'FBA仓编号',
  'PaHEXB': 'LTL(零担运输)、FTL(整车运输){break} 1.FBA仅支持LTL。{break} 2.住宅地址仅支持LTL，且必须小于6托。{break} 3.商业地址并且大于22托，仅支持FTL。{break}',
  'PihFBF': 'Lift-Gate',
  'Pp1TTV': '第三步:操作确认报价',
  'QGuvON': '如果发现WINIT地址库不足或不正确，客户可以新增或修改为自定义版本，经WINIT核实后可变更为WINIT版本',
  'QVA75B': '联系人信息',
  'RUSzK5': '切换到WINIT版本成功',
  'Swiv0A': 'FBA仓联系人信息',
  'U0U2in': '收货人地址类型',
  'YcT8hM': 'FBA仓编码',
  'ard8gk': 'APPT',
  'bhbSjx': '期望到达时间',
  'cbqjLX': 'FBA仓地址信息',
  'dRWDB0': '新增FBA地址',
  'dY7J2f': '待报价，请下单后基于<a>操作指引</a>额外再提交询价增值单',
  'enEHaF': '第四步:补充托盘标签等增值',
  'f0EiQE': '客户自定义版本',
  'fMDeau': '当前为WINIT收集的FBA仓地址信息，修改后将保存为客户定义版本，您后续将使用自定义版本，WINIT将核实您修改的内容，如果核实无误，则将您修改后的内容纳入到WINIT地址库。',
  'fXO+U6': '请输入数字英文或横线',
  'fmmUkd': '切换至新版本',
  'hY4Lvl': '保留我的版本',
  'iIP2Yn': 'FBA仓信息，将切换到WINIT版本，是否继续？',
  'iJ+RdK': '仅支持数字、英文、横线',
  'j4y83C': '住宅地址',
  'kfR22B': '人工报价',
  'l3JdZG': '自定义版本',
  'lEIbzS': '请输入FBA仓编码',
  'lsd6bP': '订单基础信息',
  'lyk5VK': 'FBA仓库信息',
  'oDhajK': '在线报价',
  'seveoq': '是否支持垛口卸货',
  'tNh07V': '"APPT"指的是需要协助预约送货。这样可以确保在货物到达时准备就绪,同时也可以帮助运输公司更有效地安排他们的运输计划。',
  'tXv5//': '住宅地址默认不支持垛口卸货',
  'uWDzGt': '第二步:创建询价增值单',
  'uktYmS': '1. WINIT版本：WINIT收集的FBA仓地址库。{break}2. 客户自定义版本：如果发现WINIT地址库不足或不正确，客户可以新增或修改为自定义版本，经WINIT核实后可变更为WINIT版本',
  'vCy5Po': '校验国家、州/城市、邮编失败，您可以<url>点击这里</url>进行查询。',
  'vGdZ04': '仅支持数字、加号、横线、空格、括号',
  'wq9xDI': '版本号',
  '35Hi9P': '依赖成本',
  '1OlJRk': '尾程询价报价 <span>(实际打托数量会影响最终尾程费用，请确认报价的单价，以实际扣费金额为准)</span>',
  'b+NmJQ': 'LTL(零担运输)、FTL(整车运输){break} 1.FBA仅支持LTL。{break} 2.住宅地址不支持大于6托，仅支持LTL。{break} 3.商业地址并且大于22托时，仅支持FTL。{break}',
  'dTGv8M': '必须大于当天',
  'uNwwIP': '当地',
  '0H7ext': '异常关闭时间',
  '1kGGA/': '已关闭',
  'g49BG6': '出库日期（当地）',
  'oDyZLy': '未关闭',
  '6JWI9W': '异常生成时间（当地）',
  '8d7pkA': '异常关闭时间（当地）',
  'WyERxh': '带章账单首页',
  '+X8eaX': '查看异常',
  'BsmZGD': '请输入数字、字母、减号、下划线或空格,并且长度小于50个字符',
  'vlsmJo': '此费用项目设有最低收费门槛，金额为 {currency}{amount}。现依据最低收费标准，当前计算结果已调整至此最低收费额度。如需详细了解收费细则及标准变动情况，请以最新发布的价格表内容为准。',
  'Jf5+Im': '待确认缺量订单',
  '6bE8su': '如果默认的装箱策略无法满足您的业务需求:{break}请点击此处<a>自定义您的装箱规则偏好</a>',
  'ARuxev': '限2长*2宽*2高',
  'CZLnVK': '限制长*宽*高',
  'OTiLOA': '限制体积',
  'PQyi+9': '您尚未配置装箱策略偏好，因此WINIT将采用标准化出库装箱策略执行打包作业。默认策略如下:',
  'RjFpnF': '当策略中支持多种包裹类型时，仓库会综合考量商品特性、体积重量以及运输要求等实际因素，选择合适的包裹类型进行打包。',
  'jeqrK/': '注意:此策略将限制打包成{miss}类包裹。',
  'pidHAI': '查看全部WINIT默认装箱规则',
  'yQjltk': '支持打包的{break}包裹类型',
  'M8w2+G': '第四步:补充托盘标签等增值(非必须)',
  'ZoVbvy': '如需补充增值，请在提交订单时预先选择相应增值。{break} 待WINIT完成装箱、打托并暂存后,补充托盘标签等增值文件。{break} 如未在提交订单时预先选择相应增值，确认报价后仓库不会暂存，直接出库。',
  'e3qaPy': '收货人地址类型为商业地址时，必须提供公司名称。',
  'xHcWNS': '{break}在线询价时，预估托盘数量以系统预估为准。',
  'CDAxI1': '受标签尺寸篇幅限制，SKU编码的长度若超过40位，则超出部分不会打印，不影响条形码识别。',
  'WDxSgQ': '#赠品',
  'h2khcY': '如您选择添加GPSR信息，则标签将带有已关联的GPSR信息；如果商品未关联GPSR信息，则不允许打印。',
  'ihOQRf': '“打印文件生成设置”选择“不同SKU生成单独文件”时，会按打印的【SKU编码】命名文件名称，由于文件名不支持字符【 / : * ? " < > | 】，则在生成的文件名时会自动忽略，请注意核对条码信息，防止误贴。',
  'jMNHyP': '包材内径尺寸(cm)',
  'pkctCa': '打印商品件型信息',
  'vYqf9H': '商品禁止入库，不支持打印标签！',
  '2L50ht': '以下商品在国家是禁止入库，即使打印条码实物张贴也无法创建入库单，确认需要打印？',
  'eB8frW': '自提出库默认使用{break}WINIT出库单号提货',
  'hVMnqa': '您可以选择配置通过WINIT出库单号进行提货。当您勾选此项时，即表示您已确认并授权供应商使用WINIT出库单号进行提货，并自行承担由此产生的相关风险。请务必确保您对WINIT出库单号进行妥善管理。此配置仅对非FBA转仓的订单有效。',
  'wTt7mK': '我已知悉',
  '+rb3z9': '请选择同一个仓库下的异常单',
  '//qX98': '移除单来源',
  '/TyAL3': '销毁后订单(订单数: {totalNum})无法恢复，请再次确认是否一键销毁！',
  '/bEUPt': '共计销毁{orderNum}异常单,请再次确认是否进行销毁!',
  '/suo4m': '异常编号',
  '035Ocl': '*请填写针对该异常所提交的增值服务单流水号，如您还未提交增值服务请<a>点击此处</a>跳转至增值服务页面提交增值服务后填写增值服务单号。',
  '0O5T7r': '{successCount}个移除单成功创建入库单：{inboundOrderNoList}',
  '1Iy4LH': '预计销毁日期',
  '1NYW+/': '异常类别',
  '1WB+di': '处理异常',
  '3JRmkd': '立即查看异常订单',
  '3jtEoL': '紧急通知<tag>即将销毁</tag>',
  '4ZtU8H': '处置中数量',
  '53J/Nd': '执行任务状态',
  '5gRDaT': '最新同步时间',
  '6/g2Xy': '移除单类型',
  '9ZVJ3+': '登记仓库',
  'AvkS7o': '移除单条件',
  'B4z3E3': '我知道了',
  'BFxcTt': '待销毁异常订单',
  'BWTsPT': '异常发生地',
  'ByZHeO': '1、系统将按照一个异常单构建一个增值销毁单下发云仓;',
  'C/fSWX': '移除单更新时间',
  'CSNtjK': '提交入库不通过原因',
  'CfPc0f': '{failedCount}个移除单创建失败，失败原因如下：',
  'D2X2wB': '移除单提交时间',
  'DlDTj8': '请选择需创建增值服务单的异常单',
  'E4dkSU': '修改增值单号',
  'F+eZ2H': 'shipped-quantiy',
  'FsSkcq': '批量处理异常',
  'GLBv34': '自动入库规则配置',
  'GlMRI+': 'tracking-number',
  'H7s5l3': '不限制包裹类型',
  'KjADFd': '执行结果',
  'LGMqRm': '移除单商品属性',
  'LgyOft': '已处置数量',
  'M/DPSo': '移除单状态',
  'N3qOVE': '销毁执行数据只保留30天',
  'NBabp4': '是否移除单',
  'OXdYxg': '全部移除单提交成功，成功创建入库单：{inboundOrderNoList}',
  'P6DzWR': '当前勾选的异常单已有保存的增值单[<a>{orderNo}</a>],请先取消草稿单再发起增值!',
  'PbNM0f': 'carrter',
  'PcKqH0': '实物第三方包裹码',
  'QnDR2H': 'FBA移除单物流信息报告每天更新一次，最新更新时间2024-01-01 12:34',
  'Rcgps+': '已选中{idListLength}个订单，是否对选中的移除单重新执行自动入库规则？',
  'RdBKhC': '请选择需反馈的异常单',
  'SDLjvC': '自动销毁日期：{expectedDestroyDate}（剩余处理时间：{remainHandlingDays}天）',
  'T10lmn': '当前勾选的异常单已有保存的库内订单[<a>{houseNo}</a>],请先取消草稿单再发起增值!',
  'Vwp5Qh': '已选移除单',
  'X6oAf8': '批量提交入库单',
  'YDnB35': '请先勾选数据',
  'ZN9vv0': '仅未提交状态操作',
  'ZTHPCS': '以下移除单已关联入库单或类型为return，不支持提交入库单请重新选择：{break}{removeOrderNos}',
  'ZsgS/g': '如若本次只针对暂存待处理中的部分单品进行增值处理，请您根据暂存商品中的唯一标识码区分，在商品列表删除掉不需要进行本次增值处理的商品，再点击【下一步】继续选择需要操作的增值服务',
  'cCPVaz': '以下移除单已关联入库单或类型为return，不支持提交入库单请重新选择：{break}{removeOrderNos}移除单有误，请重新选择',
  'cg9FE4': '立即处理',
  'ciIGU9': '入库指定包裹类型',
  'dT/edB': 'FNSKU',
  'dkSzVa': '入库单规则',
  'eX5wuL': 'FBA移除单报告每天更新1次，仅更新180天内报告。最新更新时间2024-01-01 12:34 <a1>查看详细介绍</a1>',
  'epqxJG': '二次确认',
  'g1I4y4': '一键销毁异常单',
  'hCtT4f': '属性',
  'hX26oC': '批量反馈',
  'iFtdRX': '首次同步时间',
  'imSP3c': '待处理订单数：',
  'j6L4GB': '取消数量',
  'k+gK7m': '未提交',
  'k4brJy': 'SKU',
  'mZJznr': '批量创建销毁增值单正在执行中,请前往<a>查询执行结果</a>进行查看',
  'mgv9pg': '已发货数量',
  'n6WAyp': '异常环节',
  'nE3EBp': '异常批量反馈',
  'o/9IfL': '提交入库单',
  'p6VkG4': '移除费用',
  'qf+53n': '一键立即销毁',
  'r6tjAG': '重新执行规则',
  's6MvYD': '2、在仓库正式销毁前,如您想取消销毁,您可自行前往<a>万邑联海外仓-全部增值订单</a>页面取消销毁增值单!',
  'tDxB5+': '实物WINIT包裹码',
  'uqTux2': '{orderNum}单（已滞留{stayDays}天）',
  'w7Tfhn': '是否审核通过',
  'wuoIy0': '目前仅支持Amazon平台配置移除单入库规则。',
  'xfLWzZ': '是否采集A+包裹码',
  'yOZtjM': '请至少选择一个异常单！',
  'ycib7Y': '若您在预计销毁日期前仍未处理该异常，系统将自动根据该异常单涉及货物生成销毁增值单，若您的异常货物无需进行销毁，请在该日期前处理异常！',
  'ymrffm': '查看跟踪号',
  'zEhHZc': '查询销毁任务执行结果',
  'lYT4QZ': '<bold>异常订单即将销毁，请立即处理</bold>{break} <span>尊敬的客户：</span>{break} <ul> <li>您有以下订单因异常已被标记为「待销毁」，目前系统已进入强制处理倒计时：{break} <liText></liText> </li> <li>请立即提交增值服务进行处理，逾期系统将自动执行销毁操作并收取销毁费用。</li> <li>如有疑问，可联系在线客服协助，或查阅<a>《WINIT增值与异常服务价格表 - 海外仓异常处理》</a>了解费用标准与流程说明。</li> </ul> <line></line> <space><icon></icon><text>重要声明：若因您未及时处理异常订单导致货物被销毁，相关货物毁损、灭失风险及销毁费用均由您自行承担，我司对此不承担任何责任。请务必重视此次通知！</text></space>',
  'x5AWo7': '<bold>请及时处理异常订单，避免货物被销毁</bold>{break} <span>尊敬的客户：</span>{break} <ul> <li>根据万邑通仓库管理规定，若您的异常订单处于「新提交」或「暂存待客户反馈」状态，且超过 30 天未主动提交增值服务申请进行处理 ，系统将自动执行销毁操作，并收取相应销毁费用，以此保障仓库运营效率。</li> <li>为避免货物损失及额外成本，请尽快确认并处理异常订单。如有疑问，可联系在线客服协助，或查阅<a>《WINIT增值与异常服务价格表 - 海外仓异常处理》</a>了解费用标准与流程说明。</li> </ul> <line></line> <space><icon></icon><text>风险提示：若因您未及时处理异常订单导致货物被销毁，相关货物毁损、灭失风险及销毁费用均由您自行承担，我司对此不承担任何责任。请您务必重视！</text></space>',
  '0nMsYn': '即将销毁',
  '3+yUFF': '优先级长度不能超过{max}位',
  '6Qi/57': '以下移除单已关联入库单或类型不为Return，不支持提交入库单请重新选择：{break}{onReturnOrderNos}{ononWFRs}',
  'AXV/j/': 'FBA移除单报告每天更新{pullCount}次，仅更新{pullFrequency}天内报告。最新更新时间{pullDate} <a1>查看详细介绍</a1>',
  'GXPjP8': '以下移除单已关联入库单或类型不为Return，不支持提交入库单请重新选择：{break}{onReturnOrderNos}{ononWFRs}移除单有误，请重新选择',
  'J1iEpx': '自动入库不通过/提交入库失败原因',
  'R98SA0': '仅未提交/提交失败状态操作',
  'WkbNTV': '提交成功，成功创建入库单：{inboundOrderNoList}',
  'dsinlh': '{successCount}个移除单成功创建入库单：{inboundOrderNoList}{break}',
  'hP8D5r': '系统优先匹配编号大的入库规则。',
  'k9JHsi': '{failedCount}个移除单创建入库单失败，失败原因如下：',
  'nRzQb9': '当移除单所有商品都同一属性才会匹配成功。{break}注：若配置此条件，可售和不可售商品请分开下移除单',
  'qFm139': '{noMatchRuleCount}个移除单匹配自动入库规则失败{break}',
  'rkxcrn': 'carrier',
  'sbvVn+': '执行成功',
  'tTPoBP': '复制失败移除单号',
  'u8ASMN': 'shipped-quantity',
  'uj13LR': 'FBA移除单物流信息报告每天更新{rderPullCount}次，仅更新{rderPullFrequency}天内报告，最新更新时间{rderPullDate}',
  '/N9qIp': '外径',
  '/P3Q7V': '关闭窗口',
  '/W9M3v': '选择了{serviceName}增值后，所有WINIT产品不可用，您可关闭窗口后在产品列表中查看详细原因。',
  '3vwUoT': '判定为不良品是否需拍照',
  '4od2yG': '派送失败的WINIT拍照模版类型',
  'Du8ONy': '定制拍照模版优先级高于WINIT标准模版，若商品已配置定制拍照模版或客户级拍照模版，则此配置不适用，仓库会按定制模版进行拍照，否则按此配置的WINIT模版类型进行拍照。',
  'QdKb8u': '无RMA退货的WINIT拍照模版类型',
  'Ugy0ia': 'WINIT拍照模版类型',
  'WNgpY5': '判定为良品是否需拍照',
  'XSlHT6': '已配置客户级定制拍照模版，此配置暂不生效，若需要使用WINIT标准模版，可前往取消定制模版 <a>点击此处跳转>></a>',
  'hpp6a7': '若选择无需拍照，即表示相信WINIT检查结果，后续存在异常无法提供相关照片信息',
  'rpHIiV': '已配置商品级定制拍照模版，此配置暂不生效，若需要使用WINIT标准模版，可前往取消定制模版 <a>点击此处跳转>></a>',
  '1XWEMv': '平台退货原因',
  '42qy1H': '通过平台订单ID未匹配上相应的出库单号，请检查/确认出库单卖家订单号/电商平台订单号是否传值正确',
  '44+kGE': '查看下单失败订单',
  '7Uao9y': '平台退货ID',
  'AsSGAy': '自动同步退货订单',
  'BZAEo6': '新增退货原因',
  'KMIhD4': '平台退货状态',
  'L2LYhY': '未找到匹配的出库单',
  'TX5626': '请求时间',
  'VnaZN/': '退货状态',
  'XpmFr3': '退货金额',
  'Xwktyf': '目前仅支持{platform}平台。其余平台将陆续开放，敬请期待!',
  'ZUVA4E': '下单失败 {count}单',
  'cvZE/f': '退货订单同步规则说明',
  'fpFH8o': '平台退货单未匹配上出库单，暂不支持下单。{break}{break} 通过平台订单ID未匹配上相应的出库单号，请检查/确认出库单卖家订单号/电商平台订单号是否传值正确。若您可以准确定位出库单，可以手动匹配出库单，注意一旦确认无法修改请谨慎操作。',
  'jgVhXT': '平台退货类型',
  'kG7ECj': '退货仓库地址',
  'kv0q/g': '最多输入{max}个字符',
  'nOsaxu': '手动匹配',
  'nkIyWE': '该退货原因已存在，请不要重复添加',
  'npWR53': '只允许状态为取消订单的订单撤回，请重新选择！',
  'pRhMg1': '退货承运商',
  'piC/s7': '下单成功 {count}单',
  'q4hPiU': '匹配方式',
  'qpub+R': '是否需要系统自动同步退货订单至退货订单列表',
  'rHLNSh': '查看已下单订单',
  'rtEeyT': '不符合自动退货规则的订单将停留在未下单列表。',
  'scMay5': '手动匹配出库单',
  'sqvgrn': '自动匹配',
  'vRc+X0': '退货运输方式',
  'y0M/fZ': '目前仅{platform}平台需配置退货规则，其余平台配置无效',
  'zlJeYF': '自动下单不通过原因/异常信息',
  'zreIM8': '退货ID',
  '/UjyGI': '平台{platform}和TikTok不能同时选择',
  'M0h2VP': '编辑退货原因',
  'RsmTDW': '出库单号存在多个',
  'r6NAzV': '仅支持状态为<strong>{status}</strong>的订单操作',
  '9lEixA': '更多计费信息定制',
  'h/GSwA': '输出文件方式',
  'xtelGq': '海外仓账单计费因子明细下载项目配置',
  '5xobfv': '<strong>配置说明：</strong>{break} 1、在你需要的计费明细大类和费用项前面打钩后点击保存；{break} 2、保存后回到原账单计费明细下载页面，刷新页面重新下拉选中你需要的计费明细进行导出下载；{break} 3、不宜过多的选择无需的计费项目，太多的费用项目会导致下载计费明细失败或者系统使用缓慢；{break} 4、主子账户的配置以主账户为准，子账户没有配置权限；{break} 5、有任何钱包对账问题可以直接联系我们：<a>https://support.qq.com/products/306264</a>',
  'TJX5Wu': '删除会自动解绑商品已关联的第三方商品条码，若需使用注意重新绑定商品！',
  'hgWy9L': '确认删除吗？删除会自动解绑此商品已关联的第三方商品条码，若需使用注意重新绑定商品！',
  'LdRw+j': '1.工厂出具的SDS+运输鉴定报告；或检测公司出具的SDS、产品标签图片',
  'NZioeb': '1.工厂出具的SDS+运输鉴定报告；或检测公司出具的SDS；2.CPNP注册+产品标签图片',
  'Sb09Tb': '1.工厂出具的SDS+运输鉴定报告；或检测公司出具的SDS；2.SCPN注册+产品标签图片',
  'exIT3S': 'SDS、UN38.3测试报告、产品标签图片',
  'l1yTJd': '检测公司出具的SDS、产品标签图片',
  'I2TiMV': 'LTL(零担运输)、FTL(整车运输){break} 1.FBA仅支持LTL，且必须小于等于14托{break} 2.住宅地址不支持大于6托，仅支持LTL。{break} 3.商业地址并且大于22托时，仅支持FTL。{break}',
  'cSQL5W': '预估托盘数量大于14托，在线报价时FBA送仓仅支持小于等于14托，请选择人工报价。',
  'KF+p1c': '尾程费用待报价, 请参考<a>操作指引</a>',
  'xMhgUa': '查看包裹轨迹',
  'Y6U20U': '轨迹名称',
  '+DyXxN': '结果反馈',
  '/RHREI': '申请赔付货物价格总和',
  '/eSpXG': '包装及损坏类型的破损细节',
  '0Crtv6': '大于0的数字，保留两位小数',
  '0KX1jR': '不拆单',
  '0QE4q1': '拆单类型',
  '0oSDZg': '系统提示',
  '16pzIO': '实际赔付金额',
  '1HMYGa': '提交人',
  '2V7sQs': '单据信息',
  '4KPJBi': '文件大小请勿超过{attachmentSizeMax}M，请压缩后上传',
  '4jD36a': '派送方式',
  '4vcHWR': '附件格式/数量:支持格式{attachmentFileFormat},最多上传{attachmentNumMax}个附件,每个附件不超过{attachmentSizeMax}M。(图片上传成功后暂不支持预览功能)',
  '5LSBrI': '包含货物品名、材质、数量等详细信息',
  '5T21V/': '包装不符',
  '5vXAK1': '仓群内',
  '5xr61k': '商品信息描述不足',
  '6UYLU2': '索赔备注',
  '6Ydk+8': '确认供应商到账时间',
  '71P5RG': 'LMA仓库',
  '7IWrtA': '我已经阅读并同意协议',
  '7xGGCf': '请勾选!',
  '9k/Y15': '请输入出库单号或包裹号',
  '9pKQNp': 'surepost转交邮局无索赔',
  '9vmp+C': '您好，您的订单存在拆单的情况，请选择包裹号或快递单号进行索赔',
  'A64kW0': '最多上传 {maxCount} 个文件',
  'ABs//h': '请输入索赔备注',
  'BqZvMO': '确认取消吗？',
  'Cvv7k2': '只能输入字母或数字或-且不大于40位',
  'D7iu6g': '受理时间',
  'DjDXF1': '受理客服',
  'EEunZe': '导出任务已提交，请稍后到任务中心查看',
  'EurVT+': '财务到账日期',
  'Ew2J1p': '必须输入大于0的整数',
  'FCDKaG': '已妥投',
  'FGj5pD': '确认金额',
  'FM6KfN': '提交索赔须知:',
  'FNy4pi': '货值证明不符合要求',
  'GrwYYL': '选择产品不提供索赔服务',
  'H0Kuhb': '索赔结果',
  'HNFUfF': '请上传附件!',
  'Hi/fbr': '索赔结束日期',
  'I5gP3d': '评价等级',
  'Ip2JsU': '索赔申请资料不正确',
  'JPecZE': '小于免赔额供应商拒赔',
  'MHwPat': '流水号',
  'Meo6z8': '附件要求:{message}',
  'N5ov41': '受理信息',
  'NLrJ1E': '出库单状态',
  'Nu9lbs': '拒赔理由',
  'Okhk3M': '新增代客索赔单',
  'PHnJZl': '索赔单号',
  'QDa1XA': '供应商不承认收到包裹',
  'QQLUuU': '请输入英文字符!',
  'Qw55Un': '出库时间',
  'R0SWqT': '评价成功',
  'S0J1qQ': '请填写大于等于 {applyTotalItemPriceMin} 的数，最多保留2位小数',
  'S4FFpE': '出库日期',
  'SrU9lU': '单据详情',
  'SuNgBE': '请输入索赔货物英文描述',
  'THiiin': '受理日期',
  'TXC7kZ': '请选择子订单号',
  'UmXhDu': '《代客索赔服务协议》',
  'VGOA2e': '破损图片证据不足',
  'VmkyQv': '请选择!',
  'Vw3U6j': '买家不配合调查',
  'WeJTWt': '销售价',
  'WfQfPL': '收件人未备案',
  'WhsF10': '通知邮箱',
  'XYe+Jv': '已受理',
  'YIWnSk': '反馈附件',
  'YXPE2M': '请选择索赔类型',
  'ZEEWDf': '请填写 {applyTotalItemPriceMin}-{applyTotalItemPriceMax} 的数，最多保留2位小数',
  'ZdXHn3': '请填写小于等于 {applyTotalItemPriceMax} 的数，最多保留2位小数',
  'a1GC6B': '代客索赔服务协议',
  'aEjIKB': '申请索赔商品数量',
  'ci/d9J': '申请日期',
  'dBccG5': '供应商不回复索赔结果',
  'e3jwTU': '请输入!',
  'eJgUUz': '申请信息',
  'eLONg8': '申请赔付币种',
  'eaF3d8': '超索赔期供应商拒赔',
  'eqH27/': '供应商确认赔付结果时间',
  'fDm5Jz': '所有代客索赔在理赔时效内的最后一个工作日的12:00之前提交，逾时不处理，处理审核的时效为1个工作日！',
  'fDnTRk': '1，客户不能完整无误提供Wint所要求的证明文件或者索赔申请文件；客户不能在有效期内提出索赔，Winit不作受理；{break}2，Winit仅代客户向尾程供应商索赔，对于索赔时效及最终赔付金额Winit不做任何承诺且不承担任何责任，以尾程派送供应商的时效和最终赔付金额为准；{break}3，尾程派送供应商确认的赔偿结果即为索赔的最终结果，Winit不再代客户向尾程派送供应商进行第二次索赔申诉。',
  'foeSsK': '编辑代客索赔单:{compensateApplyNo}',
  'h9CKhv': '系统错误！',
  'hJZyHS': '包裹退回发件人',
  'hMWBOo': '请输入有效的邮箱地址，多个邮箱请用英文逗号分隔',
  'hugHvs': '受理范围',
  'j+a8uD': '请输入邮箱,支持输入多个邮箱,多个使用英文逗号分隔',
  'j2TO8a': '索赔货物英文描述填写说明：',
  'kn569p': '是否为LMA订单',
  'lqR+og': '请输入索赔商品数量',
  'nQ5tSF': '请按 {applyTotalItemPriceType} 输入支持2位小数,需与货值证明金额一致,否则有拒赔风险',
  'nf87O3': '索赔货物英文描述不允许输入 {invalidChar} 等特殊字符',
  'nisQHN': '实际赔付币种',
  'oy+a30': '评价',
  'q2Rokj': '仓群间',
  'qHZ4DP': '人民币换算当地货币的汇率',
  'qdvxnx': '文件格式限制为{allowExtensions}',
  'rfi+L1': '评价原因',
  'trjozq': '受理时效',
  'u02CN/': '供应商确认赔付待到账',
  'vG/J9C': '尾程运费',
  'xIvUPW': '不在供应商受理范围内',
  'xTzl0b': '仓群间+仓群内',
  'xpYYfX': '请输入索赔商品数量不能超过出库商品总数:{merchandiseQTY}',
  'xplETi': '索赔详情',
  'zRl49D': '索赔货物英文描述',
  'zUiu6i': '(支持多选)',
  'DIEfyv': '换行',
  'qpR1hg': '索赔标准说明',
  '+YWu7f': '编辑预约单',
  '3Lerqg': '预约总单品数',
  '4Df3pr': '取消增值预约',
  '6+vQ9D': '物流单',
  '7i3N9K': '删除部分订单',
  '82/C1l': '操作记录',
  'ApzxyV': '备注：{break} 1、若Winit有默认配置分仓比例，系统将自动带出，支持您自行修改；{break} 2、同一个分仓组合的所有仓库的拆单比例加和需等于100%；{break} 3、若Winit有配置仓库对应的底线比例，则配置该仓库的拆单比例应当大于等于底线比例；{break} 4、分仓规则如下说明：{break}',
  'B3tb1+': '当入库单是否支持合并预约=是，指该卖家直发的入库单可以与Winit承运的入库单一起合并预约送仓，客户无需预约，由Winit统一安排预约送仓；若客户需要取消合并预约，可前往万邑联-海外仓-入库单列表-操作列按钮：取消合并预约，自行取消合并预约；',
  'CGZi9F': '预约单到仓',
  'CfgLmO': '时间置换',
  'DLJr86': '重新测量尺重',
  'FhkIRV': '分仓比例偏好设置',
  'FzGNHO': '以下为Winit推荐的分仓组合，您可以针对不同的分仓组合修改对应的仓库优先级和拆单比例作为定制的偏好；',
  'Gm0B5e': '预约单品数',
  'HLw9KS': '是否采集批次信息',
  'HkOkP6': '针对单个暂存商品发起重新测量，若WINIT再次测量结果与本次测量结果未超误差范围则会存在最低收费，若同仓库存在多个暂存商品需重新测量，可前往【退货暂存处理】页面批量发起。',
  'IlmiwX': '预约总商品数',
  'J/JI0w': '预约总包裹数',
  'JbGo8r': '验货包裹数',
  'K7uftF': '柜型',
  'KYyoJH': '商品上架数量是否有差异',
  'OpxFPG': '是否支持合并预约',
  'Ox8M6v': '底线比例%',
  'QznX7j': '拆单比例%',
  'R+Rgaz': '送仓信息',
  'RcmEcd': '回执',
  'U/8+oQ': '封条号',
  'VHAAss': '入库单状态',
  'WFHaMM': '未到仓',
  'XoUWci': '预约重量(kg)',
  'Y/Td5e': '卸货包裹数',
  'ZksbG3': '暂存商品',
  'a3zvco': '定制拍照模版优先级高于WINIT标准模版，若商品已配置定制拍照模版 或 客户级拍照模版，则此配置不适用，仓库会按定制模版进行拍照，否则按此配置的WINIT模版类型进行拍照。',
  'cpMIb6': '增值订单',
  'd7lb9g': '增值预约审批',
  'ewTYYR': '{break}<span>分仓拆单规则：</span>{break}',
  'gVtDem': '分仓组合名称',
  'ggWeEC': '下单包裹数',
  'hXfCth': 'Booking',
  'iM4kr0': '预约体积(CBM)',
  'iXrDXP': '智能分仓的入库单不能在草稿状态打印包裹条码，请下单成功分别在不同拆单后的入库单打印包裹条码！',
  'ioriKB': '上架包裹数',
  'jlGfDt': '取消预约',
  'k1wCYD': '卖家网站',
  'nYLYtl': '<title>温馨提示:</title>{break} <span>1.请指定BC类包裹目的仓</span>{break} <span>2.系统将按照分仓比例对A类包裹自动进行拆分，支持自行调整，确认提交后系统将自动拆分成多个订单</span>',
  'nZ0IYP': '1）A+/A包裹，将包裹下的商品进行汇总，根据商品的单品数量按照分仓比例进行拆分；{break} 2）BC包裹，按照指定目的仓分配；{break} <ml8>如下举例：</ml8>{break} <ml8>1. 下单：下单10个A+包裹，5个A包裹，包裹下的商品均为SKU01，每个A包裹有10个单品；</ml8>{break} <ml8>2. 分仓：分2个仓，仓库A和仓库B，分仓比例为71%和29%，仓库A的优先级高于仓库B；</ml8>{break} <ml8>3. 计算逻辑:</ml8>{break} <ml16>3.1. 计算A+/A包裹的单品数量：10*1+5*10=60个；</ml16>{break} <ml16>3.2. 计算按照单品数量的分仓结果：A仓库：60*71%=42.6个单品，B仓库60*29%=17.4个单品；</ml16>{break} <ml16>3.3. 按照优先级，仓库A优先级高于仓库B，即优先分配仓库A；</ml16>{break} <ml24>3.3.1. 系统默认有A+包裹优先分配；</ml24>{break} <ml24>3.3.2. 最终结果为：仓库A：分配10个A+包裹+4个A包裹，共计50个单品，仓库B：分配1个A包裹，共计10个单品；</ml24>',
  'peLNcQ': '重新预约',
  'u9v0vg': '取消合并预约',
  'v5tuoD': '送仓单',
  'vsat58': '是否智能分仓',
  'x/VGSI': '管理系统',
  'yOnUB/': 'WINIT检查是否拍照',
  'ySu2dq': '增值预约收费',
  'zQgoWI': '包裹是否上架',
  'zfRpkM': '根据勾选的暂存商品,会按仓库的维护汇总创建一个复测增值订单!',
  'iaJF/P': '请务必在下单前确认您在目的仓有充足的库容额度，否则将无法提交订单，您的各仓库容额度可<a>点击此链接</a>进行查看！',
  'X2jA1F': '1）A+/A包裹，将包裹下的商品进行汇总，根据商品的单品数量按照分仓比例进行拆分；{break} 2）BC包裹，按照指定目的仓分配；{break} <ml8>如下举例：</ml8>{break} <ml8>1. 下单：下单10个A+包裹，5个A包裹，包裹下的商品均为SKU01，每个A包裹有10个单品；</ml8>{break} <ml8>2. 分仓：分2个仓，仓库A和仓库B，分仓比例为71%和29%，仓库A的优先级高于仓库B；</ml8>{break} <ml8>3. 计算逻辑:</ml8>{break} <ml16>3.1. 计算A+/A包裹的单品数量：10*1+5*10=60个；</ml16>{break} <ml16>3.2. 计算按照单品数量的分仓结果：A仓库：60*71%=42.6个单品，B仓库60*29%=17.4个单品；</ml16>{break} <ml16>3.3. 按照优先级，仓库A优先级高于仓库B，即优先分配仓库A；</ml16>{break} <ml24>3.3.1. 系统优先分配单品数量多的包裹，直至达到分仓比例；</ml24>{break} <ml24>3.3.2. 最终结果为：仓库A：分配5个A包裹，共计50个单品，仓库B：分配10个A+包裹，共计10个单品；</ml24>',
  'mwgDgO': '{break}<span>分仓规则如下说明：</span>{break}',
  '0pGnRG': '请确认是否创建?',
  'avNw+9': '申请代客索赔',
  'zr9GzM': '取消第三方合并预约',
  'f6Msch': '公司名称仅支持英文、空格、数字、英文格式的连字符（-）、和号（&）、圆括号（( )）、斜杠（/）、句号（.）,请修改后重新输入。',
  'BYrriq': '实际包裹数',
  'DMWygJ': '验货体积(CBM)',
  'NdyxGS': '验货尺重',
  'fqPPUZ': '验货重量(kg)',
  'zalGCs': '下单尺重',
  'W+h03U': '实际尺重',
  'twcbGg': '国内仓抽验后确认数量',
  'y3f54g': '7.如果您需要上传多种收货人类型的订单时，请先拆分订单后再上传。',
  '2+3GNH': '图片限制大小{size}M以内，请压缩后上传',
  '5J4Kg7': '请输入{name}',
  'BuPcLP': '且最多保留{scale}位小数',
  'KJqOG1': '格式错误',
  'ROiSCr': 'sheet页',
  'RYD/kA': '格式限制小于{max}的数',
  'W+zrR1': '文件格式限制为{format}',
  'aPcADB': '长度限制最少{minLength}个字符',
  'fFsRGV': '图片限制格式为{format}',
  'fWCKfV': '格式限制[{min},{max}]区间数',
  'l36qrs': '格式限制大于{min}的数',
  'md1Oyf': '长度限制最多{maxLength}个字符',
  'x5UKly': '长度限制{minLength}-{maxLength}个字符之间',
  'eKgHZC': '多层包装不可选择“不指定包装”',
  'nxlceY': '商品编辑，出口国家/地区不允许选择美国!',
  '/th1fU': '支持预约的入库单量为0！',
  'HxC2VI': '支持预约的入库单量：',
  'gX/Fwn': '备注说明:若您点击创建预约单,系统将支持预约的入库单合并创建一个新的预约单!',
  'lILo+B': '不支持预约的入库单量：',
  'mJ3Mvf': '确认复制吗?',
  'mns98D': '入库单【{orderNo}】已绑定预约单【{bookingNo}】，回退草稿后将取消预约单，届时您将重新创建预约单，确认是否回退到草稿？',
  'qmTv4w': '不支持预约原因',
  'sXp295': '复制创建预约单',
  'wGtjeJ': '是否复制原预约单信息直接创建?',
  '02dIi2': '平台退货单创建时间',
  '1Z7MG0': '平台RMA号',
  '6d79n8': '平台{platform}和eBay/TikTok不能同时选择',
  'CWQV3t': '确认撤回吗？',
  'Gdzq57': '退货发货时间',
  'Gp5HaQ': 'TransactionID',
  'aA7INh': '至少填写1项{break}国家、州、城市、邮编若填写,必须同订单完全一致才能匹配',
  'LD7GZo': 'eBay仅能选择18个月内的日期',
  'M9LPoJ': '平台{platform}和ebay不能同时选择',
  'dtTOxf': '详细地址2',
  'oAwNvZ': '详细地址1',
  'yVadR+': '退货仓库地址详情',
  '+lfBfo': '到账日期',
  '/++xi3': '第三方仓已出库',
  '0LtbFX': '无上网并退货上架',
  '0z9bjM': '补收单',
  '10x/wc': '温馨提醒：财务的审核时间为5个工作日，由于包裹仍有可能延迟更新轨迹，并未丢失，财务会以审核时的最后轨迹状态为准。如若在审核时轨迹有更新，会拒赔此单，但如果赔付后上网也不会额外补收。索赔受理时限为出库日期后第11个自然日至45个自然日内，出库当天为Day 0。',
  '1qZPE9': '此附件指，收到包裹及实物照片（能清晰识别包裹外的快递面单，SI卡头的单品条码/M开头的商品条码）',
  '29WnEW': '索赔被拒',
  '2Kp9u5': '新增标准索赔单',
  '3ESazo': '索赔单据类型',
  '3KXefx': '退货分类',
  '3vdl5d': '超时无上网',
  '3yv61P': '赔付金额',
  '48/DRB': '海外仓库内丢失',
  '4DetPs': '多发货物',
  '4UW5pU': '客户编码',
  '5gdhY5': '商品信息（若需要提供商品信息明细，请您联系在线客服）',
  '6YEHIA': '库间调拨丢失',
  '6Z+XFF': '取消人',
  '6kavqv': '1.选择带A-scan服务的货物交尾程派送供应商后，在出库单状态为“派送中”，对应的尾程派送服务渠道没有有效的派送轨迹生成。{break}2.供应商不接受客户索赔，而且买家证实没有收到货物。{break}3.受理时限为出库日期后第11个自然日至45个自然日内，出库当天为Day 0{break}举例：**订单是10月2日出库，10月2日为DAY 0,索赔的受理时效为10月13日---11月16日',
  '6vg3QB': '注：只允许派送中的包裹申请超时无上网',
  '7qhI2u': '包裹海外仓卸货时间',
  '8cd7j6': '此附件指，图片可清晰看到Winit出库单号或快递单号。',
  '9+KfPI': '请输入索赔说明',
  'ATT7x+': '买家收到实物照片',
  'AnNqLb': '完成客服',
  'B9FX6E': '库间调拨破损',
  'CcSWqn': '空',
  'DQCUED': '海外仓库内破损',
  'DglTqP': '申请标准索赔',
  'DlyXTU': '1. 选择了没有Tracking服务的货物不在此赔偿范围内。{break}2. 澳洲With Registration服务无A-Scan承诺，仅有签收证明，不在此赔偿范围内。{break}3. 申请并获得了尾程供应商赔付（Winit代客索赔服务）的货物不在此赔偿范围内。{break}4. 证明货物已交尾程供应商的，不在此赔偿范围内。{break}5. 客户不能提供Wint所要求的证明文件或者索赔申请文件；',
  'DtcSoO': '索赔金额（USD）',
  'E910VQ': '支持输入出库单号、快递单号、万邑通跟踪号',
  'F9hOqH': '退货运单号',
  'FTHPZP': '赔付金额（USD）',
  'GMOAU7': '面单照片',
  'Hm5SLN': '操作时间(北京时间)',
  'Icf5jG': '此附件指，收到货物的清晰M码或S码照片（能清晰识别SI开头的单品条码/M开头的商品条码）',
  'Ip8eFD': '由于原索赔单已找回，原有索赔金额将补收回来',
  'JP07eh': '单品条码、商品条码照片',
  'K+M9tc': '消息反馈',
  'NdKn8a': '异常产生日期',
  'ODouBx': '商品下架出库单号',
  'ONOXRP': '货物运单号 网上轨迹截图',
  'OqV75t': '单次导出不能超过 {maxExport} 条，请缩小筛选条件再导出',
  'PK7a1r': '头程破损',
  'PbNtRA': '提交成功!',
  'PurMpo': 'Winit海外仓原因导致发错货物。产生串货的情况，或者发错给买家的情况。',
  'QpJsOc': '此附件指，买家向卖家投诉没收到货，并且要求退款或补发的沟通截图，{break}①证明投诉为买家本人 {break}②证明投诉的订单与出库单属于同一个订单。',
  'R1gXZc': '1、客户不能提供Wint所要求的证明文件或者索赔申请文件；{break}2、索赔受理时限为出库日期后80个自然日内，出库当天算Day 0 。',
  'RXddtb': '错交供应商-无法退回',
  'Ryp1al': '第三方仓退仓重新上架',
  'SGO2k0': '第三方仓重新贴标',
  'SnQWkX': '退回货物运单的物流供应商面单',
  'TWpf/3': '客服回复',
  'Tsnb9z': '至少需要有一件商品的索赔数量大于0',
  'U0BwdQ': '编辑标准索赔单:{serial_number}',
  'UgJWyM': '退货入库单',
  'VIiRrc': '库内贴标错误',
  'VerSyC': '数据唯一编码',
  'W02EEZ': '索赔成功',
  'WjqeLR': '到仓未上架丢失',
  'X5zp/w': '买家投诉邮件',
  'YjG8ws': '1. 货物出库10个自然日之后对应的尾程派送运快递单号网上轨迹查询状态（无A-scan轨迹）；{break}2. 买家向卖家投诉没有收到货物的沟通截图，或者证明卖家包裹已按照原订单信息重发或者卖家已根据指定订单退款的截图。',
  'YtXXdL': '此附件指，能证明卖家已完成重发或者退款的截图，或者平台上订单发起退款的截图，{break}①重发截图须体现重发包裹的收件人地址、收件人名，收件人电话信息及商品信息必须与原订单一致{break}②退款截图须包含winit订单号或者快递单号等能证明为该笔订单交易的退款{break}以上信息请在图片中重点标注，以防被错误退回{break}买家投诉邮件和退款或补发截图 二选一提供其中一份符合要求即可。',
  'Z/R8Iz': '整包',
  'ZZg9Ba': '注：只允许派送中、派送成功、派送失败的包裹申请错发货物',
  'ZmnSnN': '退款或补发截图',
  'ZoAvYj': '退货丢失索赔暂不支持线上申请，请按赔付标准提供资料联系在线客服调查退货丢失情况，调查结果若确认退货到仓丢失则Winit会主动发起赔付。',
  'aZHm4k': '快递单号【{trackingNo}】已申请代客索赔【<a1></a1>】，暂不支持重复申请索赔，如有疑问请联系在线客服。',
  'beR0hU': '漏发货物',
  'br1oBU': '客服工单号',
  'c48sip': '此订单已提交过索赔，索赔流水号{serial_num}，请直接查询。',
  'cM7IDg': '赔付币种',
  'dG7pk9': '到账时间',
  'eCWHEh': '1. 面单照片（可见Winit出库单号或快递单号）{break}2. 收到所有单品的清晰M码或S码照片{break}3. 包裹及实物照片。{break}注：如买家/卖家无法提供面单照片和收到货物的清晰M码或S码照片：请联系Winit客服调查，如Winit客服确认仓库错发，将主动发起赔付，并且于确认后的五个工作日内赔偿到账。{break} 1）原出库单号；{break} 2）收到货物的包裹及实物照片； {break}3）买家向卖家投诉收到错货的沟通截图。',
  'eCZEW+': '头程丢失',
  'eKQbFf': '原单',
  'gUvzzF': '错发货物',
  'hDbcfV': '补赔单',
  'hVYsuo': '退货重量',
  'ieLpUT': '原索赔单信息',
  'izFnP+': '注：只允许派送中、派送成功、派送失败的包裹申请退货丢失',
  'j4p94F': '仓库核实漏发的连接或邮件截图',
  'k2mGmc': '此附件指，买家投诉发错货的邮件（能清晰识别到快递单号/ winit订单号 / 卖家订单号 / 电商平台交易单号比如ebay TransactionID, ItemID)',
  'm8Z4lP': '仓库核实错发的链接或邮件截图',
  'mfVObj': '退货丢失',
  'p91JT+': '索赔标注说明',
  'pQ14T/': '云仓卸货记录截图',
  'qG/qcD': '免赔范围',
  'qPibZC': '错交供应商-退回到仓',
  'qzC1QW': '是否是自验货',
  'rUKhaE': '索赔申请资料',
  'tV2A33': '赔付单位',
  'thG2AF': '原索赔单',
  'tjA0bt': '原索赔单流水号',
  'wflzko': '自提出库丢失',
  'wmO+TV': '调拨单',
  'xccF66': '非整包',
  'xfWrWt': '请输入异常类型',
  'ykapbL': '至少需要一件商品',
  's0PQJ3': '库间调拨破损',
  'ZQsadN': '支持输入出库单号、快递单号',
  '7/6GMQ': '状态变更',
  '33niK1': '客户主体变更审核后恢复额度',
  'XI6ZFw': '客户主体变更暂停额度',
  'hBJBNE': '关联',
  'R0/9TS': '标准面单示例',
  '/4W7Tn': '前往已下单订单',
  '03t9MR': '文件上传成功',
  '42OgKJ': '非WINIT出库Return Label订单（使用WINIT退货面单服务）',
  '49sagY': '请根据所需要的下单场景选择正确的模版创建退货单，目前支持以下三个场景下单：',
  '6tHpbq': '如果是WINIT出库退货 <a>点击此处下载《标准退货-WINIT出库非Return Label服务专用模版》</a>',
  '9IJ/fA': '增值处理完成时间',
  'AWqqOx': '标准退货',
  'AyT4mM': '填写出库单号则会自动将原出库单信息【收件人信息、出库商品信息】下载至模版内{break}若存在不支持启动退货的订单，请在输入框中删除对应订单后再下载模版',
  'Ef5GsY': 'WINIT出库Return Label订单（使用WINIT退货面单服务）',
  'GMlLgw': '创建失败(条)',
  'H7pUU5': '当出库单为一单多子单服务时，需要通过子单号发起退货',
  'JZBDVe': '请上传XLSX格式模板, 最多可导入1W条数据，文件大小上限30M，如文件过大，请拆分成多个文件分批次上传',
  'K9c8Oa': '标准退货-WINIT出库非Return Label服务专用模版',
  'NxjxR0': '下载回执',
  'Y9M573': '订单内商品仓库收货后的实际处理完成时间，基于订单内最后一个处理的单品的实际处理策略取值，策略为拍照暂存则为暂存完成时间，策略为直接上架则为上架完成时间， 策略为销毁则为销毁完成时间。',
  'dDZYBp': '已下单的退货订单不支持在此页面更新退货单信息，若创建错误需取消后重新下单',
  'fXYgEh': '非Return Label支持导入成功后在回执文件内获取到收件人以及带RMA号的专属收件地址信息。',
  'gtWL6U': '创建成功(条)',
  'jG47FI': '标准退货-WINIT出库Return Label服务专用模版',
  'kVADjE': '如果是非WINIT出库退货 <a>点击此处下载《标准退货-非WINIT出库专用模板》</a>',
  'mR7h1z': 'WINIT出库非Return Label订单',
  'sQ0mrW': '单次最大支持100个出库单',
  'se3hAx': '如果是WINIT出库退货 <a>点击此处下载《标准退货-WINIT出库Return Label服务专用模版》</a>',
  'w3xp/Q': '订单内订单内最后一个RM商品增值完成时间，订单状态切为已完成。',
  'zV1tv1': '下载模版',
  'zfcyli': '可输入WINIT出库单号，单次最大支持100个出库单，多个可换行或英文逗号(,)隔开',
  'qB8UnK': '三方面单服务',
  '2BMovZ': '撤回成功',
  'Dpm3Fm': '是否要撤回此付款单？',
  'fi6T5Q': '请提供与商品实物、销售商品链接上一致的型号，避免审核退回修改。若没有型号请填写“无”。',
  'iSkSqR': '三方面单订单（通用模板）',
  'kCS8F7': '三方面单订单（平台专用模板）',
  '3C70KE': '请填写数据',
  'ANYnok': '库内',
  'KmPK3s': '当前行的左边申报价值需大于上一行的右边申报价值，请修改后重新提交。',
  'YvHGhi': '填写数字需大于等于0！',
  'ceBz7p': '若您配置了以下偏好，当人工/系统创建箱/套装库存调整单时，将自动获取您的配置偏好，拆箱时进行商品逐件清点；',
  'f9xtGe': '填写数字需大于0！',
  'imKkCz': '是否需逐件清点',
  'rLSVYX': '右边的数字需大于左边数字',
  'sVvA5q': '商品的进口申报价值',
  'yzFo2u': '当您创建箱转单一库存调整单时，若商品满足您配置的进口申报价值区间，拆箱时将进行商品逐件清点；',
  'QElQuf': '近{days}天不再显示',
  'XZVTu9': '校验地址',
  'xEJFBo': '智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息,基于配置的发货策略计算出最优发货方案(发货仓库和派送方式的组合)后,自动按照最优方案发货{break} 注： {break} - 如果订单为组套订单，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单来源为“平台同步”并且电商平台为“速卖通”或“TIkTok”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果客户下单时指定了批次商品，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单的收货人类型为“FBA转仓-VC订单”或“FBA转仓-非VC订单”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单包含不允许拆单的增值服务，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 预售订单无在库库存不支持推荐仓库和产品发货{break} - 当您在【仓组配置】里面选择了【校验地址】，在推荐的过程中会校验地址并且预估地址相关的附加费用；如果您未选择【校验地址】，推荐的过程中将不会校验地址，也不会预估地址相关的附加费用，推荐结果的准确性可能存在偏差。',
  '0n576u': '包裹数(预估|实际)',
  'Dai8r5': '总单品数(预估|实际)',
  'NrTd+i': '出库数量(预估|实际)',
  'Akeoip': '如何进行验货操作?',
  'TMYVPY': '<bold>温馨提示：</bold>{break}如需查询和导出已完结3年以上的历史订单数据，请联系在线客服。',
  'NcucBQ': '<title>地址校验功能使用提示</title>{break} ⚠️ <bold>使用须知</bold>：勾选 “校验地址” 后，在系统推荐的过程中将对您填写的地址进行验证（德国地址校验/住宅地址校验），可能出现以下情况：{break} 1.<bold>下单耗时增加</bold>：校验地址过程需与物流商地址校验接口交互，下单时长可能延长 3~5s；{break} 2.<bold>下单失败风险</bold>：若物流商地址校验接口出现临时故障、网络异常等异常情况，可能导致下单失败。{break} <red>注：请仔细核对以上风险提示信息后谨慎选择，确认勾选即视为接受上述风险。</red>',
  '0f7VEw': '取消失败{failedCount}个请稍后重试{break}',
  '3aeyfd': '未同步',
  '3eKKfh': '仅未同步/同步失败状态订单操作',
  '8QbMUo': '履约中心ID',
  'BYYQoI': 'LPN',
  'HzNUHy': '撤销成功',
  'KBgfjH': '批量撤销',
  'L79/L5': '撤销失败{failedCount}个{break}',
  'M72Spb': '查看同步失败列表',
  'MMYQ00': 'FBA退货单号',
  'MWWv4c': '撤销失败',
  'OA1lI2': '取消失败',
  'OxY5CB': '查看取消同步列表',
  'TwN/uR': '批量同步',
  'W56e0Y': '重新同步',
  'W6bBA3': '查看未同步列表',
  'X8qCBY': '仅取消状态订单操作',
  'XDQ2wC': '同步成功，',
  'XjH2Wi': '同步成功',
  'ZiBmzg': 'LPN码',
  'dPGcC7': '确认同步吗？',
  'dRm8V9': '取消成功，',
  'dcdgId': '取消同步',
  'fsHeVZ': '确认撤销吗？',
  'hR4j9y': '撤销',
  'hYuyFy': '商品同步异常原因',
  'izEwJI': '您未开启FBA退货单同步开关将不会同步报告 <url2>去开启></url2> <a1>查看详细介绍</a1>',
  'j+em3g': '查看已同步列表',
  'nfzk7/': '退货时间',
  'qnqsfV': '同步失败{failedCount}个{break}',
  'rkiG6m': '撤销失败，',
  's6vDiK': 'FBA退货单物流信息报告每天更新{pullCount}次，仅更新{pullFrequency}天内报告。最新更新时间{pullDate} <a1>查看详细介绍</a1>',
  'wKkI7s': '取消失败，',
  'xBcz9a': 'FNSKU',
  'xhmgv4': '撤销成功，',
  'zEIkLk': '同步失败，',
  'zwuANK': '商品同步状态',
  '0tgneD': '已关联',
  '2uzTTX': '成功撤销{successCount}个',
  '3nppSO': '关联失败',
  '6DCH+f': 'Amazon移除单操作说明',
  'AN6GH5': '成功取消{successCount}个',
  'CdINvG': '取消关联',
  'NtY0E8': '成功同步{successCount}个',
  'ex43en': '自动同步移除单&FBA退货单',
  'hXKgDD': '设置自动入库规则',
  'l06LmZ': 'FBA退货单报告每天更新{pullCount}次，仅更新{pullFrequency}天内报告。最新更新时间{pullDate} <a1>查看详细介绍</a1>',
  'o4+t2Y': '您是否需要自动同步获取移除单商品明细数据以及移除单跟踪号信息，同时包括FBA退货单信息获取LPN码以供仓库识别商品',
  'tXji6c': '未关联',
  'CtVsla': '查看未关联列表',
  'KHYPUz': '查看取消关联列表',
  'Mz+pKJ': '同步关联失败',
  'SqFYrJ': '同步关联成功{successCount}个',
  'axjLft': '查看关联失败列表',
  'gLJGbs': '同步关联成功',
  'lquvpq': '查看已关联列表',
  'nu/e3p': '同步关联失败{failedCount}个{break}',
  '0XsEG/': '您未开启移除单同步开关将不会同步报告 <url2>去开启></url2> <a1>查看详细介绍</a1>',
  'YGl5V/': '当前存在{removeOrderNoLength}单已下单但未上架的移除单，请勿直接关闭移除单同步。示例单号：{removeOrderNos}{break}若关闭开关将导致上述订单无法获取新的快递单号/LPN码，仓库将无法识别到仓包裹/商品，请谨慎操作。确定仍要关闭开关吗？',
  '5/YAvH': '可缺比例',
  '6HrVzW': '确认正常出库',
  '6QNfn6': '不同意缺量出库，Winit将自动作废订单。您如要继续发货需重新下单。{break}是否确认，不同意缺量出库？',
  '6khOLR': '缺失SI数',
  '7FWwRs': '您输入的{name}[{value}]非正整数和0，请修改',
  '8Asou7': '最大可缺比例',
  'AHslQm': '缺量订单处理',
  'BHseVz': '向上取整',
  'CnasbR': '您输入的{name}[{value}]非0和最多两位小数的数字和正整数，请修改',
  'DzZZQa': '订单SI数终点',
  'GvnhBj': '您输入的缺量值[{value1}]大于订单SI数[{value2} ]，缺量值只能在订单SI数区间内，请修改',
  'HH0mb1': '您输入的{name}[{value}]非正整数，请修改',
  'HSbl3Z': '订单单品数范围',
  'IZn7Zg': '确认是否修改?',
  'KNTy5n': '您输入的{name}[{value}]超出最大限制100，请修改',
  'MnNgWI': '同意缺量出库后，Winit将安排订单正常交货给供应商;如果为自提单，请尽快安排供应商提货。{break}是否确认同意缺量出库？',
  'PiBHfq': '您输入的{name}[{value}]非正整数或0，请修改',
  'RAuvJQ': '异常处理状态',
  'SSltse': '向下取整',
  'SxJ9GS': '可缺SI数',
  'THF/1n': '确认作废订单',
  'Uk/dcL': '实际发货仓',
  'WrVILK': '直接出库',
  'YfrP7D': '下单SI数',
  'ZWZbtt': '仓群内拆单',
  'aczPp4': '方案确认时间',
  'f2KXxR': '缺量值',
  'fo9KMc': '查看缺量商品',
  'gImTsw': '设置缺量出库规则',
  'hJL5I5': '您输入的{name}[{value}]超出最大限制100000，请修改',
  'hhuy/C': '缺量出库规则',
  'iMwK3P': '已打包SI数',
  'iWsoz/': '方案确认人',
  'jmzqau': '最大可缺单品数',
  'lkqAQX': '确认处理方案',
  'mjQPee': '您输入的订单SI数[{start1}-{end1}]与[{start2}-{end2}]存在重叠区间，请修改',
  'nsr4Y8': '您输入的订单SI数[{value1}]小于等于[{value2}]，终点值必须大于起点值，请修改',
  'p+tMyp': '打包完成时间',
  'pP65KW': '订单SI数起点',
  'x1egnc': '注:对于不在以下规则范围内的订单,如遇缺货,WINIT默认出库规则为"不允许出库"。',
  'zHVyhR': '缺量维度',
  '8U2r1I': '商品分类',
  'Re5nvq': '重新注册商品',
  'UWi7Ma': '商品回执信息',
  'YHQukw': '回执信息',
  'GvZcae': '上传失败原因',
  '+7rXZn': '上架子包裹体积',
  '/rFwLb': '您选择的产品【{winitProductName}】无法在下单时选择提货时间，请您验货完成后前往万邑联-入库单全部订单-待处理事项，补充提货时间，谢谢！',
  '8tfLG5': '修改识别码',
  'Iz/PPI': '子包裹来源',
  'LTXQVa': '打印失败',
  'MHN+5B': '待补充提货时间',
  'TYcOfj': '仓库是否已扫描',
  'aZfMpy': '尊敬的客户您好！下单后您需完成验货，才可将货物发往万邑通国内仓库，否则将产生异常并收取异常费用！若您选择的是Winit上门提货，请验货完成后，登录万邑联-入库全部订单，补充该入库单的提货时间，届时万邑通将在该提货时间安排上门提货，谢谢！',
  'e4T0CT': '非客户',
  'teniS8': '如您发现无法选择提货时间,请修改"物流计划"或将提货类型改成""自发物流"!',
  'xRN4c5': '验货子包裹体积',
  'yejLLK': '维护识别码',
  'DkAqhG': '最大限体积',
  'FKbLCe': '最大限高',
  'YwI4T5': '最大限宽',
  'odbnh2': '最大限重',
  'v8espj': '最大限长',
  '4RJQ5E': '验货设置',
  'E3N588': '是否打开',
  'V3Vt+a': '客户自验货时触发子包裹体积限制',
  'Us+yh+': '说明：{break} 偏好设置打开后将在验货环节限制小件子包裹体积不能超出0.04cbm{break} 若不启用限制，针对小件子包裹体积超出0.04cbm的SKU，WINIT将收取理货费用，请留意相关收费项{break} *请在验货开始前完成偏好设置，偏好设置将不会对已开始验货的订单生效{break}',
  '4NLuER': '支持SKU指定库内摆放方式',
  'JdX94J': '启用后，支持在商品级进行标记商品的存储摆放方式【平放、侧放、竖放等】',
  'hE6rE9': '可选履约要求',
  'tU239Q': '开通服务后，指定摆放方式商品的库存存储费用将会高于普通商品，请结合实际需求谨慎开启。',
  '5X6Sjh': '直接提交：在创建订单时，可一次性提供增值服务所需的完整文件。{break}暂存后补充：创建订单时暂无法提供文件，需等仓库打包暂存完成后再补充。',
  'GU+Vrq': '提交环节',
  'XQZcrd': '暂存后提交',
  'YmPeU6': '提交环节：后续补充文件时，选择补充文件的环节(如暂存后提交)。',
  'iZ4ZzP': '暂存后补充',
  'ky6kSp': '直接提交',
  'vr/2qa': '文件提交方式',
  '22Mqpn': '无有效WEEE注册号',
  '3Qv+VL': '说明：快捷关联将依据”未关联“商品所属的“WEEE类别”，快捷关联该”WEEE类别“且当前”有效“的WEEE注册号，若对应商品无有效类别的“WEEE注册号”则会忽略关联。',
  '5tt4V2': '失效原因',
  '6X472P': '确认并同意使用快捷关联',
  '6uUWc2': '未关联商品的WEEE类别',
  'ICNo7r': '商品摆放方式',
  'EeBRbZ': '未关联的商品对应类别无有效WEEE注册号，请添加提交审核，且审核通过后再进行关联操作！',
  'FRsmym': '已在执行关联，请稍后刷新查看关联情况！',
  'FvspUO': '无未关联的商品。如需更新请使用单个关联或模板导入',
  'G3ZzET': 'WEEE注册文件',
  'GOmMKL': '已关联成功【{qty}】个SKU',
  'IPThwp': '鉴于以上提交的内容，我/我司声明：{break} 1.对于由我/我司的提供德国WEEE注册信息关联的商品有在德国主管部门（Stiftung Elektroaltgeräte Register – EAR）注册备案，并按时申报对应商品投放数据及缴纳回收费用，另外对应商品也印上WEEE标签。{break} 2.如果我/我司的WEEE注册信息发生任何变更，将通知贵司修改。{break} 3.上述提交的所有信息均属实，如有虚假信息导致的任何责任及后果将由我/我司承担。',
  'MZTZvc': '点击可查看',
  'QMEQJC': '更改',
  'V2XaN0': 'WEEE信息列表',
  'XfN2Ck': '最多上传5个文件，限制为5M以内的jpg,png,gif,bmp,pdf格式的文件',
  'YJwhYM': 'WEEE注册号类型',
  'YtGpRh': '新增WEEE信息',
  'YzNYFm': 'WEEE审核信息',
  'cIRvm+': '编辑WEEE信息',
  'dibfnz': '当前商品对应类别无有效WEEE信息，请添加提交审核，且审核通过后再进行关联操作！',
  'l62HOb': '关联时间',
  'oIsHa4': '请指定该类别需关联的"WEEE注册号',
  'oPgCK9': 'WEEE授权代表名称',
  'plTZLU': '快捷关联',
  'quexjV': '以下WEEE类别存在2个及以上"有效"的WEEE注册号，请指定',
  'sqS2Da': '关联状态',
  't2bBzi': '确认取消？',
  'uaCekg': '请输入1到16位数字',
  'uueUH5': '已关联{relQty}条，未关联{unRelQty}条{break} 温馨提示：{break} 1.当前页面展示的商品WEEE类别供您参考，具体商品WEEE类别请以商品的真实信息在德国电气与电子设备废料管理机构Stiftung EAR 注册的为准。{break} 2.请您在维护WEEE信息后，需操作商品关联对应的WEEE注册号，未关联WEEE注册号的商品的德国库存将在2023年7月1日起会被限制出库。',
  'vdYJd/': '关联成功',
  'w3teYZ': '更改WEEE信息',
  'Rhyt5i': '海外隐私数据查看权限',
  'awKGiZ': '开启：子账号可查看海外隐私数据；关闭：不可查看。',
  'uAVsJm': '打开此权限后，代表海外隐私数据可查看，请谨慎开启',
  '0Q61kB': '是否确认',
  '62t33v': '未到仓货物确认',
  '7jTO69': '确认不发货',
  'CQq8b/': '拆',
  'DzM13w': '确认未到仓货物',
  'HGFjmH': '已到仓包裹数/未到仓包裹数',
  'HshCr8': '查看确认结果',
  'Ln/QPz': '拆单来源',
  'Pvjte/': '确认结果',
  'nmidO4': '<span>确认后不可修改，请谨慎操作！</span>{break}请确认勾选包裹（共计<span>{number}</span>个）分批到仓，确认后系统将自动把未到仓包裹拆分成新入库单，拆分成功后将通过邮件进行通知，谢谢！',
  'ob/U9u': '实际已发货需仓库调查',
  'ppLFVk': '温馨提示:若超过3个自然日您仍未进行确认,系统会自动将未到仓的包裹/商品确认不发货,终止未到仓的包裹/商品,后续如您需继续发货请重新创建新的入库单,谢谢!',
  'vMKAQH': '分批到仓，拆分新入库单',
  'xy4O9y': '<span>确认后不可修改，请谨慎操作！</span>{break}请确认勾选包裹（共计<span>{number}</span>个）不再发货，确认后包裹状态将切换成已终止，谢谢！',
  '5cYC+0': '暂无可用产品',
  'zgxeCD': '<span>确认后不可修改，请谨慎操作！</span>{break}请确认勾选包裹（共计<span>{number}</span>个）需仓库进行调查？届时调查结果将通过邮件进行通知，谢谢！',
  'jLakHl': '该入库单整单未到仓，不支持整单拆单！该入库单若需重新预约，请联系客服处理！',
  '/wroH0': '《新供应链管理协议》',
  '8BvNX5': '海外仓《新供应链管理协议》和《新海外仓商业性条款补充协议》和《三方转让协议》{break}由于{a1}和{a2}和{a3}的内容具有相互关联性，三份协议需要同时签署，您可以点击协议名称查看具体内容。',
  'HQiSCu': '《新供应链管理服务协议》',
  'kQA+U7': '《三方转让协议》',
  'mjLaZm': '《新海外仓商业性条款补充协议》',
  's9oyw7': '海外仓《新供应链管理协议》和《新海外仓商业性条款补充协议》和《三方转让协议》{break}由于{a1}和{a2}和{a3}的内容具有相互关联性，三份协议需要同时签署，您已签署最新版本，可点击协议名称查看具体内容。',
  '3ECTBI': '未到仓数量',
  '3fCA1g': '<span>确认后不可修改，请谨慎操作！</span>{break}请确认勾选商品（共计<span>{number}</span>个）不再发货，确认后将更新该商品的终止数量，谢谢！',
  'KMwQTR': '<span>确认后不可修改，请谨慎操作！</span>{break}请确认勾选商品（共计<span>{number}</span>个）需仓库进行调查？届时调查结果将通过邮件进行通知，谢谢！',
  'p7jssq': '已到仓数量',
  'u0wsEP': '<span>仅支持拆分1个新入库单，请确认将需拆分入库单的商品全部勾选再进行拆分，确认后不可修改，请谨慎操作！</span>{break}请确认勾选商品（共计<span>{number}</span>个）分批到仓，确认后系统将未到仓商品拆分成新入库单，拆分成功后将通过邮件进行通知，谢谢！',
  'yEzifq': '拆单数量',
  'LAufzk': '需与我确认',
  '7ZddkT': '订单参考号',
  'Zmhygi': '可填写您公司订单管理系统中生成的订单标识号。此单号可能主要用于对账追踪或自主管理。',
  'pcXfwX': '可填写您在订单管理中所需的其他编号，例如买家下单时的采购单号或平台订单号，此单号可能主要用于买家服务或平台溯源。',
  'IpNHiJ': '请先选择子单出库仓库',
  'GaGT99': '可填写订单管理系统中的订单编号，便于对账追踪或公司内部管理。',
  'y65Bht': '可填写关联订单的辅助编号（如采购单号、平台订单号），便于订单匹配或平台溯源。',
  '+9aDJv': '<bold>标签/指标定义：</bold>{break}SKU温度:截至所选日期,计算该SKU过去30天出库量:高温>=600,600>中温>=100,100>低温>=3,滞销<3;{break}DOI:截至所选日期,计算该SKU近30天日均库存数/近30天日均销售数量;{break}日均库存:截至所选日期,该类SKU过去30天日均库存数据;',
  '4gr3Fd': '180天以上',
  '9kZp/B': '分层占比',
  'AthNL5': '21-30天',
  'B/fJkw': '数据更新:{dateTime}',
  'BIsCsJ': '60-180天',
  'EdFJ9X': '日均库存',
  'FNUvro': '时间日期',
  'FRe/ki': '动销健康度分析-温度DOI矩阵',
  'HyhSJn': '日均库存占比',
  'K9l7PE': '7-14天',
  'KWGy2X': '14-21天',
  'PttrTD': '0-7天',
  'YDZXyV': '中温',
  'ZM8is8': '高温',
  'f+39n8': 'DOI分层',
  'kXNxl6': '分层总计',
  'lG0CFz': '低温',
  'nxyIG4': '无销量',
  'onzGxg': '30-60天',
  'tg2hRM': '商品动销明细数据：<a1>导出</a1>',
  'wkMrVA': '滞销',
  'NwQeEI': '较合理备货周期：能有效避免断货或滞销风险，一般情况下，该分层占比越高，整体备货健康度越优。',
  'WZ7oqy': '较合理备货周期',
  'aKmWey': '较差备货周期',
  'az4jNg': '较差备货周期：整体滞销的情况下，备货却相对较多，容易造成货物积压，不利于资金周转。',
  'oKpe5k': '较优备货周期',
  'qgmxrj': '较优备货周期：在备货较合理情况下，销量也属于高/中温，快速流转的情况下，综合降低了供应链成本。',
  '15bR6/': '<head>尊敬的客户您好：</head><body>万邑通供应链服务提供主体将在10月1日0点变更为新主体名称，您需要与新主体签署《新供应链管理协议》、《新海外仓商业性条款补充协议》和《三方转让协议》，原协议将在9月30日失效，新签署的协议将于10月1日开始生效。此次更新需要您在10月1日前完成阅读并确认新版本协议，否则将影响您的下单。</body><footer>谢谢您的理解与配合，顺祝商祺～</footer>',
  'BiB45X': '请阅读并同意协议',
  'IbreHe': '已阅读并接受',
  'f9W2lq': '已阅读并接受 <a1>《新供应链管理协议》</a1><a2>《新海外仓商业性条款补充协议》</a2><a3>《三方转让协议》</a3>',
  'voly0E': '协议更新通知',
  '+AV6Zf': '导入第三方包裹条码',
  '0+nnZ/': '系统将在您下单是默认勾选对应偏好；',
  '4eMQBe': '若您导入第三方包裹条码，则您验货时可通过导入的第三方条码进行验货！',
  '8Wz3p+': '请先新增商品！',
  'DE6Al9': '验货选择偏好',
  'EgNZ25': '客户自验下单验货选择偏好',
  'PPu6KQ': '下单默认选择：是否明确装箱明细=否(原新自验)',
  'TdHsZ4': '当您选择是否明确装箱明细=是，系统将在您下单是默认勾选对应偏好；',
  'W1pRlN': '第三方包裹条码信息',
  'XIbJH2': '系统将在您API下单时根据偏好默认赋值对应“是否明确装箱明细”字段，若您的偏好选择是否明确装箱明细=否(原新自验)，系统将自动忽略您API传参的包裹明细数据，按照未明确装箱明细(原新自验)创建入库单；',
  'c1AyPu': '系统将在您API下单时根据偏好默认赋值对应“是否免验”字段；',
  'eNhwBJ': '下单默认选择：是否明确装箱明细=是(原旧自验)',
  'elKxGq': '编辑第三方包裹条码',
  'fT/446': '上传第三方包裹条码',
  'hswgDD': '万邑联下单',
  's7F86i': '是否明确装箱明细',
  'yGdlFl': '上传第三方包裹条码为增量上传，不删除原已导入的第三方包裹条码；',
  '7Su32t': '是否已开收据',
  '+6z4NM': '箱体积',
  '/j1Nes': '请至少选择一种允许的装箱规则后再保存。',
  '/lZTGu': '箱规格',
  '/mnsQ1': '超出最大限制 {maxNum}cm，请修改。',
  '0GUSD4': '<strong>侧放：</strong> 次大面朝下（<a>示意图</a>）',
  '1Rn687': '请先选择装箱方案',
  '1hq6tu': '添加包材请勾选箱',
  '2jDOKC': '是否要“恢复推荐方案”，点击“是”，将清空“装箱结果”',
  '3mQBqU': '超托限宽',
  '4OPpGF': '打托策略',
  '4R+53J': '上传标签与托盘的匹配关系',
  '4T3c5t': '箱材类型',
  '4Vwdwu': '限制宽',
  '5AH58r': '件数',
  '5cHCdK': '允许使用的托盘名称',
  '5xJdbe': '查看装箱规则图例',
  '6cfIFr': '恢复推荐方案',
  '77+mEH': '选择【一份文件上传包裹标签】，需要您按照Winit装箱清单的包裹顺序，在亚马逊提交发货信息。确保文件内包裹标签顺序与装箱清单的包裹顺序一致，Winit将按照此顺序贴标。',
  '7m0Fxg': '总数量(箱)',
  '7unEPz': '托盘摆放提示',
  '8KpJnl': '主箱',
  '8WiHte': '整箱出库，不可修改额外加包装',
  '8iPloa': '限制宽必须大于等于托盘自身宽，请重新输入',
  '8kjA/n': '仅支持上传单份文件，确保文件内标签顺序与装箱清单的顺序一致，Winit将按照此顺序贴标',
  'AW3QJJ': '修改后将清空选择的装箱策略，需要重新选择。请确认是否修改？',
  'AaEbak': '全部严格单SKU且单件装箱',
  'BAxU7U': '您输入的装箱数量{packedCount}已超过剩余未装箱SKU件数{qty},请修改。',
  'BB+JEa': '不满意,重新编辑方案',
  'Bqf6pC': '摆放方式',
  'CY12bb': '只允许录入大于0的数，整数位最多8位，小数位最多2位',
  'DTz1y6': '限长*宽*高',
  'DWBvxe': '直接输入单个商品的装箱信息。适合一次添加少量商品时使用，最多支持添加10个商品，且不超过5个箱子',
  'EBTivJ': '超托限长(cm)和超托限宽(cm)至少输入其中一个',
  'EHymsE': '托盘尺寸(长*宽*高cm)',
  'F/duGx': '您更改了订单内的商品，需要重新选择装箱策略及增值服务，请确认是否需要更改?',
  'FG3A/U': '是否要“重新编辑方案”，点击“是”，将清空“打托结果”',
  'FQY5Zq': '直接填写',
  'FSGPan': '侧放',
  'GB20/S': '自身尺寸',
  'H+V3eT': '限制长',
  'HQr2z9': '装箱明细模板',
  'HtD9n3': '箱分组数',
  'IXlNF8': '<font>包裹类型说明：</font>{break} <span>A+包：每箱一种SKU且一件单品</span>{break} <span>A包：每箱一种SKU且多件单品</span>{break} <span>B/C包：每箱多种SKU且多件单品</span>{break} {break} <font>尺寸输入规则：</font>长=最长边, 宽=次长边, 高=最短边',
  'IcGteJ': '装箱明细',
  'IqBDoI': '尾箱件数(件)',
  'JDV8nN': '是否默认规则',
  'JGOafx': '已装箱/预计出库数量',
  'JHgOt4': '选用此装箱方案后，尾程产品的收费金额及打包尺寸已发生变化，请确认是否查看变化？',
  'JvuaYt': '没有相同的箱规格',
  'KlgHAC': '出库装箱/托规则',
  'KqvuBs': '查看打托规则图例',
  'LGc441': '托盘明细模板',
  'LMIuHR': '箱分组编号',
  'MC/oat': '最多支持添加{x}箱，如需添加更多箱，请选择“批量上传”指定装箱。',
  'MafQMV': '总重量',
  'My6AUf': '装载率:{loadingRate} 标准箱件数:{qty}件/箱 箱数:{packageCount} 尾箱包材规则:{sectionPackagingSpecification} 尾箱件数:{sectionPackagingQty}',
  'NEFb2o': '限重',
  'NZY0A1': '打托尺寸限制',
  'Nw033A': '超托尺寸',
  'P7aoMp': '指定方式',
  'PObaEM': '当单个托盘上的任意一个单品的尺寸超过托盘标准尺寸限制时，按超托的限制进行打托。',
  'PoKQTB': '修改后将清空选择的装箱策略及增值服务，需要重新选择。请确认是否修改？',
  'PtqCMz': '主箱规格',
  'PvQePz': '打托结果',
  'QHTjm4': '箱类型',
  'Qab4ip': '<strong>平放：</strong> 最大面朝下（<a>示意图</a>）',
  'SAbxQP': '在此处设置的默认装箱规则，当您下单时选择 “智能推荐装箱” 作为装箱策略，系统将自动选中您预设的默认规则，无需重复手动选择，让装箱设置更高效便捷～',
  'SPdvq8': '选用此装箱方案后，当前选中的WINIT产品【{winitProductName}】不可用，不可用的原因：{errorMsg}。并且无其他可用的WINIT产品，您可以选择“不满意，重新编辑方案”，选择后系统将清除装箱结果和已选择的增值服务。',
  'U9NZ3C': '您更改了订单内的商品，需要重新选择装箱策略，请确认是否需要更改?',
  'VkIinq': '指定装箱说明：装箱作业遵循原箱/箱产品优先出库原则，即有原箱默认按入库时原箱出库，无原箱则按平台仓装箱规则执行',
  'VmZF4A': '是否要“重新编辑方案”，点击“是”，将清空“装箱结果”',
  'W6iRgO': '批量指定箱规格',
  'Wj97H8': '箱重量',
  'WtCeVq': '选择包材',
  'X5GPMQ': '超托限长(cm)必须大于托盘自身长',
  'YLdm+E': '<strong>竖放：</strong> 最小面朝下（<a>示意图</a>）',
  'Ywtwbb': '托盘号',
  'Z1Q2tF': '打托分组编号',
  'a1DFj6': '超托限宽(cm)必须大于托盘自身宽',
  'aWPqMM': '总商品数(件)',
  'ahq67k': '{qty}件/箱',
  'ceEBzP': '修改出库装箱限制',
  'cpRIqR': '添加包材',
  'dJty45': '选用此方案',
  'dVps5P': '打托规则图例',
  'f8UsQV': '装箱策略',
  'fFccZQ': '添加箱',
  'fJxmVT': '修改后将清空选择的增值服务，需要重新选择。请确认是否修改？',
  'foCa09': '装载率',
  'gG/y9A': '不满意，重新编辑方案',
  'gZUjRC': '总打托数量(托)',
  'gb2p8v': '托盘重量',
  'hlxpPC': '总体积',
  'i6zAH3': '标准箱件数',
  'iB17zU': '装箱规则图例',
  'iWyx6Q': '竖放',
  'j77Gcv': '了解打托策略',
  'jILrrg': '装载率:{loadingRate} 标准箱件数:{qty}件/箱 箱数:{packageCount}',
  'jcohPw': '仓库拆箱后重新打包',
  'kTw4K8': '您更改了订单内的商品，需要重新选择增值服务，请确认是否需要更改?',
  'lJtJ5S': '装箱方案',
  'lcA2Az': '重新调整下单SKU',
  'nd8exK': '请设置默认规则后再保存。',
  'ngJ7SC': '直接混箱',
  'np++Iy': '打托规则',
  'nxU6/z': '选择其他WINIT产品',
  'o7U57u': '超托限长',
  'p15MmV': '箱数(箱)',
  'pHZsHe': '点击下载 <a>装箱明细模板</a>',
  'pJZPl3': '散件件数(件)',
  'pvQHbv': '以下商品的尺寸已超出标准托盘尺寸限制，请选择合适的摆放方式以优化托盘空间利用率。',
  'qo/H5E': '总箱数(件)',
  'qyLPwx': '整箱出库，不可修改数量',
  'rJ+S+3': '装箱结果',
  'rJ61OE': '仓库人员将结合商品特性、体积重量以及运输要求等实际因素，选择合适的包裹类型和包材进行打托，后续可查看子订单详情～',
  'rJbKfQ': '托盘标签号',
  'rKbymg': '允许多SKU混装: 按照装载率最优原则, 可能直接打B/C包',
  's7iQpX': '平放',
  'sHIbFj': '当前打托结果为空，请先确认打托方案～',
  'smFqf1': '允许的装箱规则',
  't5KPFV': '选用此装箱方案后，当前选中的WINIT产品【{winitProductName}】不可用，不可用的原因：{errorMsg}。您可以选择“不满意，重新编辑方案”或选择其他WINIT产品。',
  'tYs+0n': '点击下载 <a>打托规则模板</a>',
  'uAFTOr': '使用Excel模板一次性上传多个商品的装箱信息。适合添加大批量商品,一次最多支持上传X个SKU',
  'uGh3tO': '【智能混托，最优装载功能说明】{break} 提供多规格箱体混合码托的智能装载方案，精准适配单托盘满装需求，同步满足承重限制、堆码规范等打托标准，实现空间利用率最大化，满足运输的安全性需求。',
  'uMiwst': '散件装箱',
  'ud70DH': '您输入的装箱数量{packedCount}小于未装箱SKU件数{qty},请修改。',
  'ukE51P': '尾箱规格',
  'vKlKqA': '打托限制',
  'w90uU5': '了解装箱策略',
  'wLwT6c': '托盘标签全部相同',
  'wUpUxY': '按散件直接装箱',
  'wVvPMS': '批量上传',
  'wtq3Zr': '为确保询价和预约送仓能够顺利，请提供FBA Reference No.',
  'xZpDye': '确认此装箱方案',
  'yKH7Zh': '托盘标签存在不同',
  'ysCLVn': '托盘体积',
  'ywBj4W': '箱分组编号/箱号',
  'z+MzSE': '限制长必须大于等于托盘自身长，请重新输入',
  'z/ofGG': '当前装箱结果为空，请先确认装箱方案～',
  'zfLCAh': '全部单SKU且单件打托',
  '+5bHd/': '一份文件上传快递面单和包裹标签',
  '0eBJCK': '总箱数',
  '39gwem': '包裹体积',
  '3WcfMz': '第一个跟踪号',
  '3WwE4J': '更换WINIT产品信息，系统将重新计算装箱方案，请确认是否继续更改？',
  '49fRpD': '处理环节',
  '4MSrUM': '车牌号',
  '4Po5zN': '您可自主指定需要组合打托的包裹，以实现精准的个性化需求。',
  '4g9jXw': '仓库人员根据商品特性和运输要求，灵活选择包材与装箱方式。<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际装箱结果为准。</span>',
  '5e8lgk': '补增值状态',
  '6E6SYp': '规则类型',
  '8T3XtE': '包材规格相同，且箱内的SKU种类与数量完全一致的包裹，视为同一类别。',
  'AiBk8V': '此设置用于决策：当单件货物的长宽尺寸超出标准托盘规格时，是否允许进行打托作业。',
  'C3Xyt8': '箱数',
  'DO+dHk': '自身尺重',
  'Harof5': '您可以自主选择具体的SKU、数量并将其装入指定的箱子中，实现精准的个性化装箱需求。',
  'IIPa06': '待确认增值订单',
  'Im+u+J': '您当前订单包含的单品数量较多，导致系统装箱计算超时。为保障订单快速处理，建议您通过以下方式进行调整：{break} 1、拆分订单：建议将单个订单的单品数量控制在500个以内。拆分后，可分别提交新订单。{break} 2、调整装箱策略：选择“仓库自主装箱”选项，由仓库根据实际库存和包装规则高效完成装箱。{break} 感谢您的理解与配合，完成调整后即可提交订单。',
  'LWh2KY': '提货码',
  'MZoc4B': '预约提货时间(当地)',
  'QsPD6Q': '包裹类别编号/箱号',
  'XTlijw': '请先选择打托方案',
  'ZT1G1j': '提示信息：装箱计算超限',
  'b0twXr': '包裹类别编号',
  'cWxKfh': '全部按A+包裹或箱产品装箱出库',
  'eOA2gX': '系统通过算法自动计算最优的托盘装载方案，帮您节省空间、降低运输成本。',
  'eQ4gDr': '原箱',
  'eeQgv3': '出库装箱打托规则',
  'eno/75': '无主箱规',
  'fSzvk1': '指定包材',
  'kCzdh3': '最大限长*宽*高',
  'kTJOj4': '更换WINIT产品信息，系统将重新计算装箱方案和清除已选的增值服务，请确认是否继续更改？',
  'lGBTLd': '系统通过算法自动计算并推荐最优装载方案与最高效的装箱规格，有效提升空间利用率。',
  'lZ/nB8': '自提类型',
  'm5n5nA': '实际提货时间(当地)',
  'mDGWSk': '您选择的装箱方案已更新，相应的操作费、尾程运费及包裹计费重量均已发生变化。请确认是否立即查看详情？',
  'oIxJPB': '选择【一份文件上传快递面单和包裹标签】，需要您按照Winit装箱清单的包裹顺序，在亚马逊提交发货信息。确保文件内是一页包裹标签一页快递面单交替分布，并且总体顺序与装箱清单的包裹顺序一致，Winit将按照此顺序贴标。',
  'rpoODb': '获取面单后补充',
  'rsm2O2': '仓库人员根据商品特性与运输要求，灵活进行打托。<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际打托结果为准。</span>',
  'tIqy1V': '自提出库订单',
  'uy8FVi': '待处理订单',
  'x1OCBv': '待订单获取到尾程面单后，再进行文件资料的补充',
  'xuHdu0': '标准出库订单',
  'y7/5dq': '散件混装模式',
  'yTOUwm': '装箱作业遵循”箱产品/原箱“<span>优先出库</span>原则。即货物入库时的原箱将作为出库时的首选方式；若无原箱，则按散件重新装箱出库。',
  'yovoCg': '商品按单件混合装箱，极致压缩包裹体积，最大化节省运费。',
  'DzkvrI': '获取面单后补充：因文件中需要填充快递面单号，需等从供应商获取到尾程面单后再补充。',
  '+UD0Nm': '关闭时，子账号不可访问海外数据（出库单收件信息/退件板块/索赔查件板块），开启时允许查看。',
  'hxaUQ3': '不可查看隐私数据',
  'ufuU7X': '可以查看隐私数据',
  '/g7pR0': '或者',
  '1VgmNe': '表达式错误',
  '22mHbq': '左括号',
  '2ipN6G': 'DG标签',
  '3urC7v': '项目',
  '4eaeMn': '关系',
  'BJg14B': '格式异常，请输入0或正整数',
  'ByhhM1': '条件',
  'CoKJg6': '是否启用清除DG标签偏好',
  'CskvE/': '电池能量（电池组或电池芯的瓦时数）（W）',
  'FkUlFv': 'SKU标识是否为尾程空运DG',
  'HE8gpc': 'Winit标签',
  'Iuq4N7': '下单是否自动下发覆盖标签增值',
  'KYlUTy': '下入库单默认下发清除DG标签逻辑说明',
  'O+0Baa': '开启后，入库时将自动清除DG标签',
  'PYQhmH': '右括号',
  'QhGPUl': 'SKU标识是否为尾程陆运DG',
  'TIycpl': '电池包装方式',
  'U8IB+K': '增值图片',
  'XCFG+v': '下单A类包裹是否满足维护偏好',
  'h624iv': '入库增值偏好设置',
  'kNbdh7': '并且',
  'rlpMbP': '非DE',
  'ygrz65': '启用清除DG标签偏好',
  'zbqD5q': '值',
  'WJOgVN': '海外仓测量尺重',
  'hw6hrK': '是否自动下发覆盖标签增值',
  'mNZYcD': 'A+/A包裹是否符合头程DG标签偏好',
  'J9gDP9': '批量注册',
  'y29eMI': '单个注册',
  '252JpO': '返架中',
  'M+WRRO': '商品异常冻结',
  'Pe6Wwv': '禁售',
  'jCdXSN': '丢失调查中',
  '+I/eds': '禁售原因',
  'rrtjDg': '此账号当前未配置共享库存自动拆零全局策略，为了不影响后续订单出库时效，可配置共享库存自动拆零全局策略！{a}配置',
  'tPBhkV': '禁售详情',
  'Lpj+2t': '此策略是为了避免因单一产品不足在出库环节进行拆箱导致影响订单的出库时效，Winit会基于自动拆零的策略进行提前调整库存，若不配置共享库存自动拆零全局策略，将不会提前进行库内拆零，只在出库环节触发库存拆零。',
  'N6olth': '不合规禁售',
  'rHWBj4': '禁售库存仅支持自提出库或销毁，不支持标准出库！',
  'uKmlLO': '标准入库',
  'yg35yu': '返架库存详情',
  'W0H3/3': '目前仅支持eBay、Temu、AliExpress、Shopify、Shein平台配置规则。其余平台将陆续开放，敬请期待!',
  'g7NT9e': 'Token暂未被{platform}平台使用，请及时去平台绑定并完成授权(平台登录需使用当前区域账号)',
  'LTnlBS': '在此处设置的默认托盘，当您下单时（API下单/万邑联下单）系统将自动选中您预设的默认托盘，无需重复手动选择，让下单更高效便捷~',
  'vfW36f': '请设置默认托盘后再保存。',
  'vjX//o': '默认托盘',
  '5dZCxH': '仓库人员将根据商品特性和运输要求，灵活选择包材与装箱方式，具体装箱结果后续可查看子订单详情~ {break}<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际装箱结果为准。</span>',
  'Ma+ddR': '使用Excel模板一次性上传多个商品的装箱信息。适合添加大批量商品,一次最多支持上传{qty}个SKU',
  'fcN9C6': '请注意：允许多SKU混装，将按照装载率最优原则装箱。因此，每个箱子都可能装有多个SKU。',
  'tKqXle': '仓库人员根据商品特性与运输要求，灵活进行打托，具体打托结果后续可查看子订单详情~ {break}<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际打托结果为准。</span>',
  'vEvtsT': '测算装箱结果',
  '1kbSYq': '提单文件',
  '6MBNUQ': '提单号',
  '7rNHUy': '提柜申请',
  'BvS8ua': '导入只支持{accept}格式文件',
  'I2c7n+': 'DO文件',
  'YMvE9K': '实际还柜时间(当地)',
  'YR/KBR': '查看头程物流跟踪',
  'ds+/g8': '修改集装箱号',
  'gqELkK': '预计到港时间',
  'jgq+/y': '提柜信息',
  'rQUakN': '暂未查询到物流记录！',
  'zbDuSi': '请填写英文字母+数字',
  '+AkvtB': '#配件商品',
  'f4cDDj': '限时0费率实时到账',
  'is0zpP': '无Airwallex账号？',
  '+RCnrG': 'Item Title',
  '/w6yVJ': '请选择时间范围',
  'BKJUwf': '你好，Winit已完成加入Amazon MSF对接啦!{break}{break}第一步，请先阅读授权协议并同意授权获取信息{break}第二步，授权Amazon平台店铺账号{break}{break}操作完成后，平台将获取你的海外仓相关信息，并推送订单和商品库存信息',
  'BObRVR': 'orderPlacedTime',
  'ImbJHn': 'lastUpdatedDateTime',
  'SWbb1G': '发货仓库不一致，无法使用批量发货，请重新选择订单',
  'SwNQnT': '温馨提示：{break}1、授权完成的店铺，将自动同步Amazon-MSF订单自动发货，并同步商品库存{break}2、Amazon-MSF订单请勿通过其他方式发货以免造成订单重复发货',
  'V8FkeQ': 'creationDateTime',
  'VgausN': '仅待发货/发货失败订单操作',
  'birAPV': 'buyerOrderld',
  'jqXs1M': 'channelName',
  'qDEUjP': '目前仅支持eBay、Temu、AliExpress、Shopify、AmazonMSF平台配置规则。其余平台将陆续开放，敬请期待!',
  'qVGRIE': 'Quantity',
  'qgWzlQ': 'locationld',
  'rQQzl2': 'shipmentLineltem Id',
  '+V514J': '是否确认取消发货？{break}取消后订单将无法撤回继续发货，请同买家确认订单取消，否则可能引起客诉。',
  'BfSxzs': '目前仅支持eBay、Temu、AliExpress、Shopify、Shein、AmazonMSF平台配置规则。其余平台将陆续开放，敬请期待!',
  'BkMWxm': 'locationId',
  'oAQLO/': '装箱清单',
  'tDw37u': 'buyerOrderId',
  '2PgHwF': '商品{platformItemSku}未添加同步规则',
  'BniMG4': '上传包裹号对应的补贴要求',
  'ENYSkf': '不同订单不同要求',
  'GyW4tb': '所有订单相同要求',
  'I9WLTQ': '期望派送时间',
  'LgA4cL': '仅限货机运输(Cargo Aircraft Only)',
  'Ll79cT': '导入只支持XLSX文件',
  'OKmTEL': '所有包裹相同要求',
  'T3q6qf': '导入模板',
  'a0ONXZ': '锂电池限制-禁止空运/船运',
  'bHi3Ds': '期望送达时间(当地)',
  'eecNUt': '补贴项目',
  'k6d0X+': '批量导入订单补充信息',
  'v0nty8': '不同包裹不同要求',
  'yr4AkT': 'UN标签',
  'j1+jO2': '上传客户订单号对应的补贴要求',
  'Pb7qI/': '共享',
  'j8ekmd': '原箱包装',
  'vt5ccv': '不共享',
  'wVMpVn': '主快递单号',
  'H1T87h': '扩展设置',
  'aGxRt2': '内容',
  'yVms9t': '设置项',
  'HvFvBM': '是否启用API/ERP查询库存排除不良品？',
  'YLWwb+': '是否关闭API/ERP查询库存排除不良品？',
  'bSNLne': '启用API/ERP查询库存排除不良品',
  'ti8G4l': '此配置适用于ERP对接WINIT库存查询需要过滤不良品库存的场景。注：API对接用户支持通过API入参选择是否排除，若API未传参对接也可通过此功能进行排除。',
  '+YUL4t': 'API下单自动创建箱产品',
  'WnKmzk': '自动创建的箱产品是否开启共享库存',
  'XTFlnc': '启用该偏好，当您通过API下单时，系统将自动把下单A包裹转化成箱产品，并通过A+包裹进行下单；',
  'K6A7Ay': '当前增值单取消后，请选择是要继续提交其他增值，还是无需其他增值可以直接出库？',
  'xbWyo8': '继续提交其他增值',
  '+KQIYg': 'eBay账号授权成功',
  '+g5Odt': '成功提交{successCount}个，请等待处理结果{break}',
  '+sOaux': '组合商品长*宽*高',
  '/5kMiS': '请输入最多8位整数，最多保留2位小数',
  '/VKVEv': '是否启用续件费',
  '/eKhN1': '长CM',
  '/ihAwV': '待加入-未提交',
  '03OdFd': '默认库存设置',
  '0rILia': '去匹配>',
  '1NBcfx': '错误',
  '1SepKA': '{countryCode} 启用国际服务,至少要配一个区域的运费和附加费',
  '1wOL8F': '异常分类',
  '21qsQv': '缺货',
  '2B5Uox': 'eBay账号已被{ebayID}客户绑定，无法再次授权其他Winit客户账号。如需更换请线下联系客服进行申请，预计需要三个工作日左右',
  '2M+gaC': 'ebay itemID',
  '2h4etD': '已授权',
  '4LO5kZ': '偏好2',
  '4bdMX+': 'eBay物流服务',
  '5g4L3H': '组合商品',
  '6PECwn': '组合商品重量',
  '7PexH5': '查看授权列表',
  '8FvR5Y': 'eF SKUID',
  '8KPhfG': '待加入-审核中',
  '98O571': '仅待加入-未提交状态操作',
  '9gwy+n': '请输入eBay Custom Label',
  '9ozbDi': '出库单提交日期',
  'A/W0Ji': '温馨提示：{break}1、授权将会跳转至eBay页面，授权完成后自动跳回万邑联页面。{break}2、授权完成的店铺，将自动同步eF订单自动发货，并同步eF商品库存{break}3、eF订单请勿通过其他方式发货以免造成订单重复发货',
  'AlNl2K': '账号授权失败，请重新发起授权',
  'AxfkAU': 'eBay账号授权失败',
  'Bzgqgx': 'Winit产品不一致，无法使用批量发货，请重新选择订单',
  'Do/HOL': '加入',
  'Dtffnt': 'eF异常分类',
  'Du2hdU': '添加组合商品',
  'EXXIMD': '当为手动加入/退出时：{break}需要手动调整商品加入/退出eF{break}加入，eBaylisting库存会同步展示Winit商品库存(站点的所有仓库){break}退出，eBaylisting将会展示设置的默认库存{break}当为自动加入/退出时:{break}根据默认库存判断，自动加入和退出{break}当商品库存>默认库存，自动加入eF，eBaylisting展示Winit商品库存(站点的所有仓库){break}当商品库存≤默认库存，自动退出eF，eBaylisting展示设置的默认库存',
  'ElIu9U': '国内配送服务设置',
  'Ere3ru': '设置eBay eF服务',
  'FcLwLD': '维护eBay平台信息',
  'GkAFNd': 'ebay Custom Label',
  'GmBFbl': '退出失败',
  'HTbmwk': '宽CM',
  'IckH3i': '查看itemId明细',
  'J6Fbmp': 'eBay itemID',
  'JPJyCy': '新增店铺',
  'JoL+d9': '确认重新授权吗？',
  'JyKQRL': '注意：仅针对已设置过eF的商品批量操作加入/退出。若要对商品批量设置服务，请使用批量设置eF功能',
  'Jznt1f': '请选择国家设置一个ef服务',
  'KJrGS5': '取消授权',
  'KObBDp': '已退出',
  'MJ6SAC': '加入失败',
  'Mlalnn': '加入/退出 eF设置',
  'Mp4ZYz': '加入/退出eF',
  'MzxSsq': '设置自动同步商品匹配的店铺',
  'N6j14o': '组合商品属性',
  'Npzogu': '引用偏好数据',
  'OATknL': '修改商品属性',
  'Oex59+': '返回列表',
  'P7HTrM': '维护审核中',
  'PvFlx2': '商品信息完整待加入服务',
  'QnQAmD': '请勾选数据',
  'Qw1FMg': '导入文件加入/退出eF',
  'R9ZH2Y': '导入只支持XLS、XLSX格式文件{break}最多支持1000行数据，如超过请分成多个文件上传',
  'Rl8xeS': '请输入最多8位整数，最多保留3位小数',
  'Rr0WSm': '缺少Custom Label',
  'TRVT74': '注意：US/AU运费设置分区为eBay定义分区，与Winit分区不一致。eBay分区详情请查看<a1>《EF操作手册》</a1>',
  'UyqNZt': '是否组合商品',
  'VQLk5p': '你好，Winit已完成加入eBay fulfilment认证服务啦！{break}{break}第一步，请先阅读授权协议并同意授权获取信息{break}第二步，授权eBay(eF)平台店铺账号{break}{break}操作完成后，平台将获取你的海外仓相关信息，并推送订单和商品库存信息',
  'Wb/9Lq': 'eBay订单ID',
  'XH+l/X': '站点不一致，无法使用批量发货，请重新选择订单',
  'XKyH1B': '维护成功',
  'XOXZPD': '重量KG',
  'ZR0XRH': '当商品退出eF时，希望展示在eBay平台上的默认库存。涉及手动退出和自动退出，以及平台因为限制规则强制退出',
  'ZdrhPk': '当前产品服务时效低于下单物流服务，可能会导致派送时效不达标导致赔付。请谨慎选择',
  'Zryluf': 'eBay Fulfillment服务设置',
  'aRADb+': '服务分组',
  'bfeRdA': '2、通过配对平台商品和WINTI商品，建立二者匹配关系 {a}',
  'bqG/hC': 'eBay Custom Label',
  'byhm83': '是否使用国际配送',
  'cA7vYm': '你好，Winit已完成{platformFullName}海外仓认证啦!{break}{break}第一步，请先阅读授权协议并同意授权获取信息{break}第二步，在{platform}平台补充Winit的账户信息{break}{break}操作完成后，{platform}平台将获取你的海外仓相关信息，并推送订单和商品信息',
  'cKd6w4': '维护失败',
  'cgxdE6': '请选择服务分组',
  'dURpJ2': '已选中{qty}个商品,请进行批量设置EF服务。{break}注意:批量设置将会覆盖掉针对单个商品的历史设置',
  'dgf6Kz': '提交失败{failedCount}个，原因：{break}{reason}',
  'e+f3fS': '查看itemID状态',
  'eBAL2u': 'excel修改加入/退出eF',
  'eHWt7e': '已加入-退出中',
  'eJt1V9': '自动',
  'eah4XJ': '手动',
  'fVg18v': '高CM',
  'hQOH1X': '同步商品匹配',
  'htixct': 'eBay CustomLabel',
  'i03cgN': '同步店铺',
  'i4Byyo': '国际配送服务设置',
  'jjVprn': 'eBay Fulfillment同步设置',
  'jwCzpQ': '添加Winit组合商品及数量',
  'jxmDpa': '导入商品',
  'kd2rGf': '已加入',
  'khc+Ia': '导入成功{successNum}，导入失败{failNum}。{break}失败的导入数据和失败原因<a>点击下载文件</a>',
  'knDAam': '仅支持待加入-未提交、已加入、加入失败、已加入-退出失败、已退出状态批量提交eF',
  'kvVJmi': 'ebay账号',
  'l82W4w': '批量设置eF',
  'lWeKoR': '导入成功{successNum}，导入失败{failNum}。',
  'lnrTIe': '1、完成授权店铺后，可操作对应功能：同步商品及匹配 {a}',
  'ltCWTv': '确认取消授权吗？',
  'lvAG2S': '请输入最多5位整数，最多保留6位小数',
  'mEKJuC': '加入eF状态',
  'mcYu4G': '添加店铺后，即可同步添加已完成商品匹配的eBay商品和Winit商品至当前eF商品管理列表。注意：暂仅一次性添加已匹配数据，后续不会同步更新。若商品匹配发生变更，未加入的商品可删除后再次执行同步；已加入eF的商品需要退出eF修改后再加入',
  'njpUP6': '已加入-退出失败',
  'nofz0U': 'Custom Label重复/异常',
  'pg+yjf': '授权成功，请在列表查看授权账号信息',
  'qtqMeN': '偏好1',
  'rWR+im': '组合商品编码',
  'soCAd+': '偏好使用仅首次引用偏好数据，支持针对当前商品再次修改{break}注意：选择偏好后，若偏好更新当前商品EF服务数据不会同步更新；若商品需更新，请重新设置EF并提交审核，请及时查看审核结果。',
  'tJw7sI': '库存错误',
  'ukoMyS': '请输入重量',
  'vE/mGO': '最大长度为10位数字，2位小数',
  'wCa4U0': '商品待加入异常',
  'xFYQzM': '待加入',
  'xPAc/v': '退出',
  'yKQdCq': '选择配送服务',
  'ywr1LG': 'Itme ID',
  'Jlzdr6': '万邑通全场景高效海外仓{break}卖得好、备得少、综合成本就是少',
  'AHodEs': '外箱采集的SN码',
  'Y2eiCW': '是否完成增值',
  'rurl0x': '外箱采集的SN码图片',
  '+858kB': '日均出库量',
  '/26ehQ': '分析备货情况，优化备货策略',
  '/J1+nW': '120-180天',
  '/dXFkQ': '库存数量占比',
  '/dcLs3': '长尾缺货',
  '0zV38F': '截止所选日期, 该类SKU过去30天日均库存数据',
  '1Uct28': 'SKU详细信息',
  '2IP64b': '备货场景概览',
  '2JNYh6': '标签/截止所选日期, 计算该SKU过去30天出库量，高温≥600, 600>中温≥100, 100>低温≥3, 滞销<3',
  '2j7huF': '极差',
  '34oQh+': '库存分析报告',
  '39zJIR': '库存数(件)',
  '3h1uIj': '长尾最优备货',
  '46DklJ': '畅销最优备货',
  '4S6nZ2': '7~14天',
  '4Y1/MP': '库存数量',
  '5WSDbu': '当前维度暂无数据',
  '5hqTM6': '可售天数超过90天，且近30天销量大于100件',
  '5mq2mp': '{month}月已产生存储费 {amount}USD',
  '5rQZjy': '可售天数 14~60 天，且近30天销量小于100件',
  '6TWotd': '可售天数 14~60 天，且近30天销量大于100件',
  '6Z2+5w': '全部仓库',
  '7CajwD': '疑似滞销',
  '8DZ3T0': '可售天数：90-120天',
  '8PQ6ib': '上述数据不包含新品，日均库存数总计 {sum} 件',
  '8R0XTD': '过去30天销量≥600的SKU的日均库存数汇总 - 在该DOI分层的库存数量',
  '8vXYwp': '显示各DOI分层下不同温度标签SKU的实际日均库存数量',
  '9ZdkeY': '该DOI分层所有温度标签的库存数量总计',
  '9bSO34': '严重滞销',
  '9bZ7dW': '显示各DOI分层下不同温度标签SKU的库存占比情况',
  'AoPi1s': '60~90天',
  'CgmpGr': '可售天数超过90天，且近30天销量在3~100件范围内',
  'Evsugq': '品质标杆',
  'G4q89I': '点击查看疑似滞销SKU明细',
  'GbVzIC': '可售天数：7-14天 | 补货场景：适合空运',
  'GkdN8K': '{countryCode}-{warehouseCode}-日均库存数量分析表',
  'I/0jhD': '14~30天',
  'ICVSdt': '点击查看严重滞销SKU明细',
  'IY3rSF': '{countryCode}-{warehouseCode}-日均库存占比分析表',
  'JGXefD': '点击查看长尾缺货SKU明细',
  'JXxGYT': '该DOI分层所有温度标签的库存数量占比总计',
  'K7Y7hZ': '该DOI分层下，某温度标签的SKU总库存占客户所有SKU总库存的比例',
  'Kc3Byd': '该SKU的日均出库量',
  'L4kgwc': '备货场景',
  'LsPFcF': '过去30天销量在100-599的SKU的日均库存数汇总 - 在该DOI分层的库存数量占比',
  'MoU1SM': '点击单元格可查看具体场景定义',
  'NCEBh6': '库存健康度场景分析',
  'NINLUY': '可售天数 60~90 天，不限近 30 天销量，覆盖畅销 / 长尾品',
  'NLDJt+': '点击查看上月库存分析报告',
  'Opb6fg': '特征',
  'PZSxPC': '可售天数：180天以上 | 补货场景：已出现滞销，需要消化库存',
  'Pp7hrx': '过去30天销量在3-99的SKU的日均库存数汇总 - 在该DOI分层的库存数量',
  'RWHlVK': '标签/指标定义',
  'S01oYn': '日均库存数量占比',
  'TgIPS8': '库存数占比',
  'Tkmxf1': '该DOI分层的所有SKU总库存占客户所有SKU总库存的比例（体现DOI分层的库存权重）',
  'TyBqOs': '导出商品动销明细数据',
  'U8oHOq': '可售天数低于14天，且近30天销量大于100件',
  'aK+HmM': '当前客户的滞销库存数量占比<5%，则文本为：“本月库存健康度评级为极优。库存周转效率处于最佳状态，仓储资源与流动资金利用充分。建议维持现有精细化库存管理策略，可重点投入资源优化畅销品备货节奏，进一步提升整体运营效率。"',
  'aXAH1x': '本品牌',
  'b0/WDq': '合理备货',
  'bpytH2': '0~7天',
  'c+Ctye': '库存占比',
  'dhFvnz': '备货较多',
  'e652NE': '可售天数：30-60天 | 补货场景：适合普船',
  'f8aEjy': '截止所选日期, 计算该SKU近30天日均库存数/近30天日均销售数量',
  'fjhs9t': 'SKU名称(商品名称)',
  'fw5J/X': '根据DOI分层和SKU温度，判断该SKU所属的备货场景类别',
  'gScA5O': '可售天数：0-7天 | 补货场景：难及时补货',
  'j3IhHx': '当前客户的滞销库存数量占比在>40%，则文本为：“本月库存健康度评级为极差。滞销库存已严重侵占核心仓储资源、大量占用流动资金，且可能导致畅销品库存空间被挤压，直接影响整体库存周转率与盈利效率，建议尽快消化库存”',
  'j7q9fm': '过去30天销量＜3的SKU的日均库存数汇总 - 在该DOI分层的库存数量占比',
  'jaUYvO': '畅销缺货',
  'jpnytt': '超低温',
  'kp1/ug': '较优',
  'nHh1If': '极优',
  'nZCtyB': '当前客户的滞销库存数量占比再5~15%，则文本为：“本月库存健康度评级为较优。现有滞销库存控制在合理范围，建议继续保持当前的库存管理策略，重点关注畅销品补货节奏即可。”',
  'nwrCxp': '本月库存健康度评级为',
  'oybLIK': '90-120天',
  'pCZBqi': '点击查看畅销缺货SKU明细',
  'py2OYq': 'SKU温度',
  'qjEp5a': '日均库存数量',
  'qoGZJH': '过去30天销量在100-599的SKU的日均库存数汇总 - 在该DOI分层的库存数量',
  'r/mys+': '可售天数：14-30天 | 补货场景：适合快船',
  'rfWEbZ': '过去30天销量在3-99的SKU的日均库存数汇总 - 在该DOI分层的库存数量占比',
  'rv2S54': '该DOI分层下，某温度标签的SKU库存总和（直接汇总同分组的库存）',
  'sJ8cBQ': '可售天数：60-90天',
  'sS7wyq': '该类SKU近30天无销量，无法计算DOI，单独统计',
  'sTsns5': '当前客户的滞销库存数量占比在15%~40%，则文本为：“本月库存健康度评级为较差。滞销库存已占用部分仓储资源，建议优先排查高库存滞销 SKU，可通过促销活动、库存调拨等方式加速消化，减少资金占用。”',
  'sXUdP8': '较差',
  'st5qfR': 'WINIT履约报告-{month}月库存分析报告',
  'tEXOrZ': '过去30天销量＜3的SKU的日均库存数汇总 - 在该DOI分层的库存数量',
  'v2LNfY': '可售天数低于14天，且近30天销量小于100件',
  'wUEfqW': '该SKU的日均库存数量',
  'xGV2rF': '可售天数：120-180天',
  'xfrc9e': '可售天数超过90天，且近30天销量小于3件',
  'xpNOm9': '温度DOI矩阵',
  'yH0TiS': '过去30天销量≥600的SKU的日均库存数汇总 - 在该DOI分层的库存数量占比',
  'zvoAIf': '30~60天',
  'BHOXG6': '本月库存健康度评级为极差。滞销库存已严重侵占核心仓储资源、大量占用流动资金，且可能导致畅销品库存空间被挤压，直接影响整体库存周转率与盈利效率，建议尽快消化库存',
  'CB0FTm': '本月库存健康度评级为较差。滞销库存已占用部分仓储资源，建议优先排查高库存滞销 SKU，可通过促销活动、库存调拨等方式加速消化，减少资金占用。',
  'SyF7YC': '品类标杆（综合零售）',
  'jsPyiB': '本月库存健康度评级为极优。库存周转效率处于最佳状态，仓储资源与流动资金利用充分。建议维持现有精细化库存管理策略，可重点投入资源优化畅销品备货节奏，进一步提升整体运营效率。',
  't3EZ/p': '本月库存健康度评级为较优。现有滞销库存控制在合理范围，建议继续保持当前的库存管理策略，重点关注畅销品补货节奏即可。',
  'I2haAQ': '想精准管控库存风险，避免滞销积压与资金占用？本报告用客观数据替代经验判断，帮你定位滞销风险。通过数据，解锁更高效的库存管理方案！',
  'S5IKvF': '可售时间超过90天，且显示近30天销量小于3件的SKU详细信息，包括库存和出库情况(按照每个日均库存数量降序排序)',
  'YPCIjO': '可售时间超过90天，且显示近30天销量在3~100件范围内的SKU详细信息，包括库存和出库情况(按照每个日均库存数量降序排序)',
  'eQigZu': '可售时间低于14天，且显示近30天销量小于100件的SKU详细信息，包括库存和出库情况(按照每个SKU的日均出库量/日均库存数量的比值降序排序)',
  'pC8w8l': '可售时间低于14天，且显示近30天销量大于100件的SKU详细信息，包括库存和出库情况(按照每个SKU的日均出库量/日均库存数量的比值降序排序)',
  'Dx3xZs': '可售时间超过90天，且显示近30天销量在3~100件范围内的SKU详细信息，包括库存和出库情况(按照每个SKU的日均库存数量降序排序)',
  'wGenC7': '可售时间超过90天，且显示近30天销量小于3件的SKU详细信息，包括库存和出库情况(按照每个SKU的日均库存数量降序排序)',
  'AoYxot': '畅销最优',
  'UgVDmg': '长尾最优',
  'aI14f6': '库存状态分布',
  '2cEeD0': '悉尼仓',
  '3lXXUZ': '德国2仓',
  'Dp6hUU': '墨尔本仓',
  'ONTDVL': '美西2仓',
  'SmiBHH': '美东5仓',
  'Xc1MK9': '美东3仓',
  'cN4WwM': '英国TW仓',
  'dfM18m': '多伦多仓',
  'hyw36k': '德国1仓',
  'jq8YEp': '美西5仓',
  's3rYvE': '美西1仓',
  'wtLyGS': '英国GF仓',
  '16DzKH': '容器体积',
  '6Sa7PG': '多个单号需换行或用英文逗号隔开，最多支持输入10个单号',
  '6t2pGb': '容器重量（KG）',
  '7WivY+': '容器条码',
  '7iQHhS': '容器体积（CBM）',
  '8AFKQY': '父级容器条码',
  '8nT9ZY': '分批处理',
  '9fCuYD': '批量导入处理',
  'AdLyfK': '源子订单号',
  'Bwqwwx': '重量（kg）',
  'CRrx95': '预计将产生返架费用: <span>{amount}{currency}</span>',
  'EBMdAL': '创建成功',
  'Gu6ve5': '批量返架',
  'HhBSTd': '包装类型',
  'KDST00': '实际出库数量',
  'KffZZe': '总商品数',
  'Qml+Jw': '新订单号',
  'TzdYjm': '全部销毁',
  'UXBFYM': '返架',
  'VGTfHQ': '总共导入{count}条，校验成功{success}条，校验失败{error}条',
  'Ww4mvO': '全部转标准出库',
  'ZeTTNk': '修改处理方式，需重新上传模板文件，确定是否修改?',
  'ZqyX8H': '源单号',
  'bSaNQ3': '本次共选择{count}个容器，预计将产生返架费用：{amount} {currency}',
  'bnfcAI': '容器重量',
  'c8/6P+': '源客户订单号',
  'cS4CeZ': '确认销毁【{code}】等容器吗？',
  'dH6cPS': '全部转自提出库',
  'fMVIuu': '总包裹数',
  'h0JOsy': '容器长*宽*高',
  'lWg/Rm': '返架原因',
  'mnflXu': '确认销毁【{code}】该容器吗？',
  'rHTOUC': '最多支持{num}个订单号',
  'tATKZZ': '暂存完成时间（当地）',
  'vkVx/K': '您所下单的商品体积之和已经超出 {configVolume}cbm，建议您选择此产品。',
  'xxS2pF': '1. 仅支持上传XLS、XLSX格式模板{break} 2. 每个文件最多支持上传5000个容器，超出5000个请拆分成多个文件分批次上传{break} 3. 文件大小上限5M，如果文件过大，请拆分成多个文件分批次上传{break}',
  'zOsH5H': '整单合并处理',
  'LN1bBn': '退货暂存后换新单',
  'LuUUcY': '出库暂存后换新单',
  '1/GyvI': '选中创建新自提单',
  'Ial38i': '按单号合并创建新单',
  'JTfl/3': '选中返架',
  'MO51pO': '按模板导入创建新单',
  'PegTHG': '选中创建新出库单',
  'sN4Z/2': '选中销毁',
  '5LrpOS': '失效待处理',
  'D5Qa5n': '该VAT号经过欧盟官网英国官网链接如下：<a1>What is the UK VAT number you want to check? - Check a UK VAT number - GOV.UK</a1>核实已失效，现VAT名下还有在库（在途）库存，请于时效内处理完毕，逾期未处理，我司将冻结库存，禁止货物出库，后续只能自提和销毁，同时失效的VAT号应英国监管要求，要上报给HMRC机构，请知悉。',
  'PJk9rP': '未检验',
  'gtBqMe': '异常处理中',
  'kTopMl': 'VAT状态',
  'v0fN/N': '剩余{vatRemainExpireDate}天',
  'yrpZqC': '检验中',
  '1z+PUC': '失效VAT号',
  '2Wr8ti': '在库库存=可用库存+不可用库存',
  '4C52jb': '不可用类型',
  'D/IEZc': '退货暂存中',
  'IqhS6n': '不合规冻结',
  'L1oad9': '不合规冻结原因',
  'MZGnPz': '不可用库存',
  'Nkzb4e': '进口商/贸易商',
  'NyrztL': '丢失调查中库存详情',
  'R1UfwV': '失效VAT禁售库存详情',
  'RxOEEB': '不可用原因',
  'Sn+VZl': '退货暂存中库存详情',
  'Tmm/ts': '销售预留冻结库存详情',
  'ZcAx93': '出库暂存中',
  'f0R63Z': '失效VAT禁售',
  'fvgxnz': '不合规冻结库存详情',
  'hGGMo3': '不合规禁售详情',
  'hJLtvk': '禁售时间',
  'j/abtG': '不合规禁售原因',
  'kqVWhs': '失效禁售时间',
  'lMeQIl': '销售预留冻结',
  'q1B+zO': '出库暂存中库存详情',
  'y2IUn0': '商品异常冻结库存详情',
  'ydYOXN': '库存详情',
  'RJpcKu': '失效VAT禁售数量',
  'aaTDNr': '不可用库存数量',
  'cyH+CL': '不可用库存类型',
  'WFc0E0': '<red>请提供完整的操作视频，最多上传1个视频，限制为50M以内的avi,dat,mpg,wmv,asf,rm,rmvb,mov,flv,mp4格式</red>',
  'Da2ffQ': '本功能用于临时锁定销售库存，防止被其他订单占用。锁定后，系统将冻结对应数量的库存；释放后，库存将恢复为可用状态。请务必在释放后及时创建出库单，以避免该部分库存被其他订单分配。{break}请注意：此操作仅冻结库存数量，不会指定或锁定仓库中的具体实物及库位。',
  '0GMK7Y': '锁定/释放销售库存',
  '+swO4L': '注意:修改偏好,将不会影响历史引用偏好的商品数据。{break}如若需要修改商品服务数据,请在[平台同步-eBay Fulfillment商品管理|菜单中重新设置EF服务',
  '3YAh2J': '导出当前商品匹配数据',
  '6cvqQC': '使用偏好将会全量更新服务设置中的所有内容{break}是否要使用偏好?',
  'BPAh3l': '请选择你需要导出的列表信息',
  'GU8kAT': '已加入EF的商品若修改需要维护信息，则需等维护通过后才会更新EF信息',
  'KzSXfU': '根据当前列表信息导出',
  'MyYCNq': '可以提前设置EF服务信息,帮助您快速加入eBayFulfillment服务。',
  'NJ3JfH': '确定删除当前商品吗？',
  'OwvQbz': 'eBa Fulfillment服务偏好',
  'YIvnlG': '请设置一个ef服务',
  'YNHo/g': '导出信息同eF导入模板，支持修改后直接通过excel导入。暂仅支持导出非组合商品的已匹配数据以及不带规格的商品。',
  'c5rvdd': 'eBay Fulfillment偏好',
  'qXGWFz': '按导入eBay eF添加商品模板所需信息导出',
  'y3FPak': '<a1>管理我的eF偏好</a1>',
  'IBAsbe': '待分批处理容器',
  'qs/sEC': '请选择打托策略',
  '0Qjh2e': '请选择条件',
  '1le4VE': '商品类名称',
  '2k/NaR': '支持批量查询，最多支持500个',
  '3kiSJD': '编辑类',
  '62KzCa': '指定SKU',
  '7gWnrn': '确定生效吗？',
  'C0a1YB': '客户自定义分组-类信息',
  'J7BQCH': '配置商品',
  'LUruKv': '新增类',
  'P2ZRxg': '支持64位字符，中、英文以及数字',
  'Tp4hPZ': '组名称',
  'VYPW7Q': '请选择类',
  'aYnWaR': '新增组',
  'leNznf': '初始未分类',
  'ltjhyJ': '类',
  'mR+91E': '确定失效吗？',
  'pfb8mk': '编辑组',
  'rEIk6P': '组',
  's5s2ZC': '类名称',
  'IRsr6r': '查看类{className}内商品明细',
  'aD9f+6': '组内的分类规则',
  'dI3AcE': '已关联的业务策略',
  'fXe0i9': '配置类{className}内商品明细',
  'yGtqiA': '添加类{className}内商品',
  '+eg7JV': '请先选择索赔单',
  '0mnS/Y': '成功数量:{successNum}, 失败数量:{failNum}, 失败数据文件:{a1}',
  '1CaoGO': '请点击下载<a1>导入模板</a1>',
  '1qBbCX': '下载待上传附件索赔单',
  '8o9WZa': '批量提交草稿单',
  '9HoB8V': '待补充附件',
  '9wtfmH': '批量补充索赔附件导入结果，成功{successCount}单/失败{failedCount}单',
  'A3wZYS': '批量上传索赔附件',
  'BoHeLy': '是否有待补充附件',
  'DWtPOJ': '附件格式:支持格式{attachmentFileFormat},每个附件不超过{attachmentSizeMax}M。',
  'Ho12yP': '说明: {break}批量创建后索赔单为草稿状态，需要批量补充索赔附件信息后才能完成索赔单提交。',
  'SfkC0A': '批量新增代客索赔单',
  'UQHOCp': '批量将草稿单变更为已提交状态',
  'UWPWwZ': '暂无上传附件配置',
  'XPpHtm': '上传文件成功：{successUploadNum} 个',
  'Y2g3bc': '文件格式：{allowExtensions}',
  'pVw6Hz': '批量新增索赔草稿文件',
  'u9ZvIB': '批量申请代客索赔',
  'x18yAp': '点击 <a1>下载失败原因</a1>',
  'x6oA5O': '批量补充索赔附件',
  'pTe5/s': '说明: {break} 1、批量补充附件功能仅针对当前选择的草稿状态索赔单，单个附件类型最多上传{attachmentNumMax}个附件，支持只上传部分勾选的索赔单附件，支持只上传部分附件类型的附件。{break} 2、请按“快递单号或出库单号”对附件进行命名，同一单同一附件类型有多个加序号（示例：9200190389086505358894_01、WO10129482224、claim_WO10129182224），否则系统无法识别。{break} 3、同一类型附件索赔单己存在附件文件名相同会覆盖，文件名不同会新增附件。',
  'jTcDk6': '批量补充索赔附件导入结果，成功{successCount}个附件/失败{failedCount}个附件',
  '4q8NAE': '确认批量提交草稿单？',
  'XlpMPJ': '是否需要补充附件',
  '+rqZZp': '取消组',
  '3Pel4Z': '业务对象属性',
  'HT2Yg+': '请设置条件',
  'IffoXK': '且',
  'P9Bukq': '操作符',
  'S5F4CX': '订单作废及费用说明',
  'ZY7dz0': '添加组',
  'c1hrRi': '添加条件',
  'kbdFu6': '条件设置',
  'lH+4LY': '组合现有条件并添加',
  'lNBWTt': '当前订单若作废成功,预计将产生以下费用{break}请注意:订单作废后无法撤销,请您确认是否作废该订单?',
  'p4KceZ': '请注意:订单作废后无法撤销,请您确认是否作废该订单?',
  'zcHSrz': '添加动作',
  'svVpbB': '请在<a>【偏好设置 > 下单设置 > 出库 > 出库装箱打托规则】</a>中，先自定义 “SKU 单独装箱” 的具体条件，设置完成后，装箱时选择该规则，订单内满足条件的 SKU 会自动单独装箱，不满足条件的 SKU 则可混合装箱。',
  '303VyS': '箱内单品条码',
  '9lv9YM': '暂存信息',
  'IOixLx': '拆包暂存',
  'JW+UnW': '确认，已知悉此处理方式',
  'L0npSX': '全部标准出库',
  'TK6NXC': '商品编码-规格',
  'VZOsju': '确认执行此操作?',
  'ZyPM4b': '整托暂存',
  'qfDt0+': '处理模式',
  'rjXuaJ': '预付费用合计 {amount}',
  'utLXuQ': '退货暂存继续上架操作系统将自动为您创建无箱单海外验入库单上架，后续处理费用按入库处理费收取。',
  'vVCO9b': '全部自提出库',
  'yuTIzT': '全部继续上架',
  'CUWc65': '重新上架',
  'IWzg8c': '再次派送',
  'UhU6pD': '请注意：系统将自动为您创建【无箱单预报】入库单，并收取相应的入库处理费及其他相费用',
  'hnI3J7': '确认重新上架',
  'oOO3DI': '请注意：【标准出库单 - 托盘服务】派送失败退回到仓后，WINIT将进行整托暂存，等待您选择后续的处理方式：再次派送、自提出库、全部销毁或重新上架。',
  '+E8UXl': '使用WINIT出库单号提货',
  '3HcSs9': '新单号',
  '5QSXrD': '不可预约',
  '5rjTA7': '总打托数量',
  '9hrTna': '可用不足',
  'FFHf9t': '产能配额预约',
  'FayNbO': '基于仓库实时产能动态分配的可预约时段，客户需在系统提供的可选时间段内选择提货时间，且单时段预约资源设有上限，超出后需选择其他时段。该模式保障资源公平分配与作业效率。',
  'HNAOck': '1、您已提交{bookingPermissionTypeName}，请按提货预约时间安排到仓提货，提货地址信息请在订单详情页面或<a>自提暂存订单处理详情</a>查看；{break}2、请确保增值已完成提交,增值如需变更需取消预约后重新操作；{break}3、为确保您的货物能够准确交付，请及时将提货码告知您的供应商，并要求其在提货时出示提货码。若供应商在提货时无法提供有效的提货码信息，仓库将无法完成交货。提货码信息如下：',
  'MGtIz4': '下载打托明细',
  'MyvkIy': '第三方提货码',
  'RTQq0d': '装箱信息',
  'SdcdsR': '增值预约说明{break}1、提交增值预约后需待审批通过才能安排送仓，审批结果将在1个工作日内通过邮件推送。{break}2、审批通过前取消预约不收取增值预约费用。{break}3、审核通过，如需变更送仓日期，请联系客服！',
  'IbDLTM': '1. 您已提交{bookingPermissionTypeName}，请按提货预约时间安排到仓提货,提货地址信息请在订单详情页面或<a>自提暂存订单处理详情</a>查看；{break}2.请确保增值已完成提交,增值如需变更需取消预约后重新操作；{break}3、为确保您的货物能够准确交付，请及时将提货码告知您的供应商，并要求其在提货时出示提货码。若供应商在提货时无法提供有效的提货码信息，仓库将无法完成交货。提货码信息请在审批通过后在暂存订单处理详情查看。',
  'Syl9aV': '提货码是供应商上门提货的重要凭证。您可以选择填写与供应商约定的第三方提货码；如果未填写，系统将自动生成一个WINIT提货码。为确保您的货物能够准确交付，请及时将此WINIT提货码告知您的供应商，并要求其在提货时出示提货码。若供应商在提货时无法提供有效的提货码信息，仓库将无法完成交货。',
  'U7u9KN': '预约权限类型',
  'ZBkx19': '托盘信息',
  'brwHC8': '预约',
  'cD6kKC': '专属预约单',
  'cpnZ0r': '自提预约协议',
  'dpCjW4': '提货信息',
  'k9/jgR': '预约单说明',
  'nGupIx': '注:仅限仓库工作时间周一至周五10.00-18.00提货',
  'pECeHH': '提货供应商',
  'qG/vmE': '下载提货码',
  'srGye/': '面向专属客户开放的灵活预约通道，不限制时间段与资源配额，支持客户自定义提货时间。该类型突破常规产能限制，通过后台权限配置实现“随需预约”，满足紧急订单、大额批量需求等特殊场景。',
  'tH/9GD': '已选',
  'umqj6F': '可预约',
  'xGjK9D': '订单收货人类型为FBA转仓-VC订单或FBA转仓-非VC订单时，为确保您的货物能够准确交付，请在预约时填写ARN信息，并要求供应商在提货时出示ARN。若供应商在提货时无法提供有效的提货码信息，仓库将无法完成交货。',
  'yK8AbT': '预约提货注意事项：{break}{break}1. 不使用WINIT尾程提货资源交货的自提单必须在系统预约提货时间，并按照预约时间自提，若后续提货时间有变更，需在系统取消原预约并安排重新预约；{break}{break}2. 自提订单发生以下异常，系统将会自动收取违规费用（费用标准详见万邑通异常与增值价卡说明）：{break}{break}1)预约未提货：自提单预约后未在预约时间提货；{break}{break}①需在系统取消原预约并安排重新预约；{break}{break}②订单会继续收取暂存仓储费及在预约提货日期1天后收取滞仓费{break}{break}2)自提单违规取消预约：自提订单已预约，若提货时间有变更，卖家需要在预约时间前2个工作日取消预约则不收费。（预约时间为工作日，按海外仓当地时间计算）。超出此要求时间则收取违规费用。{break}{break}举例：如卖家预约提货时间是2022-6-17，卖家在2022-6-15当天以及之前取消预约不收费。{break}{break}3. 若未按预约时间提货或未预约上门提货，WINIT无法保证提货时效甚至无法提货，客户因此产生的额外费用WINIT不承担。',
  'zzKha6': '您可以选择配置通过WINIT出库单号进行提货。当您勾选此项时，即表示您已确认并授权供应商使用WINIT出库单号进行提货，并自行承担由此产生的相关风险。请务必确保您对WINIT出库单号进行妥善管理。',
  '0JI7MG': '预估价格(原币)',
  '4VYo04': '上传超重标签',
  'Ahc+oL': '注意：根据美国地区服务商提货相关要求，供应商提货时需仓库提供对应BOL信息。请勾选“交接BOL/CMR”增值服务并上传BOL，否则将无法提货。',
  'E86vxA': '仓库操作完本次提交的增值服务后，是否直接出库？',
  'Kh7nco': '您确定不需要增值服务，立即预约提货吗？',
  'TKS7HV': '暂不出库，后续还需补充增值',
  'VWvqOM': '您选择的增值服务[{vasNames}]未提交，点击返回【返回增值服务清单】后，系统可能清除未填写完整的增值服务要求及增值文件，请确认是否继续返回吗？',
  'VlcX6Y': '您确定不需要增值服务？',
  'dPuT2A': '当前取消预约将产生违规取消费，详情请看价卡，取消后需重新预约',
  'eUGVb6': '新增增值服务',
  'jjl3V4': '增值预约未审批通过，当前取消不收费，取消后需重新预约',
  'l7hkkh': '预估价格',
  'lw7+aQ': '检测到您已选择「{vasType}」的增值服务，需按顺序取消对应服务后再操作：{break} {voidSort}。{break} 请先完成取消，感谢配合！',
  'mDNuvx': '无需增值服务，立即预约提货',
  'ncUfOl': '当前取消订单不产生违规费用，取消后需重新预约',
  'oNqy62': '提交成功，您的增值服务已更新至"待处理"页签中，请注意查看~',
  'uFBjIr': '无需增值',
  'vHs/yd': '无需增值立即预约提货',
  'vZhRbW': '返回增值服务列表',
  'f4F33r': '接受',
  '3FSqhT': 'SKU种数',
  '5Cpfb/': '托盘状态',
  '61+I8P': '总库存单元数',
  'UXjvqZ': '总托盘数',
  'UyFfj7': '总单品数',
  '6cGDgA': '提货码信息请在审批通过后在暂存订单处理详情查看。',
  'DQY6It': '更换新自提单',
  'DVN3mT': '全部返架',
  'EN3RCP': '预约单已提交成功～',
  'JYe/i7': '拆单处理',
  'P/iVK7': '检测到您已选择「{vasType}」的增值服务，需先取消该服务后再操作。{break}请先完成取消，感谢配合！',
  'YsZxSd': '容器最新状态',
  'djaofb': '清空时间',
  'hA0cYL': '请您按照预约时间安排到仓提货，提货地址信息可在<a>自提暂存订单处理详情</a>中查看',
  'iF/OW3': '提货码信息如下：<downloadCode>点击此处下载提货码</downloadCode>',
  'rWrGpm': '更换新出库单',
  'sFKm46': '您确认不需要增值服务？点击 “是” 后，仓库将会立即安排出库～',
  'wJRzN6': '1、请确保增值服务已提交完成。如需变更，请先取消当前预约后重新操作；{break}2、为确保您的货物能够准确交付，请及时将提货码告知您的服务商，并要求其在提货时出示提货码；{break}3、若服务商在提货时无法提供有效的提货码信息，仓库将无法完成交货。',
  'DEesVZ': '生成文件方式',
  '+/R6RX': '任务状态',
  '4wdEel': '超出了 <remaining></remaining> 个单号',
  '9jqt68': '批量创建任务',
  'AXARO9': '操作环节',
  'E1T1CC': '下载视频',
  'JTjHlt': '附件格式/数量:支持格式{attachmentFileFormat},每个附件不超过{attachmentSizeMax}M。',
  'O1Fcla': '视频处理完成时间',
  'O6+tgT': '处理成功',
  'RONThN': '子单号',
  'WB2Dlp': '最大支持输入{maxBueinessNo}个订单,多个订单用分号隔开或者换行输入',
  'XCWQC8': '处理详情',
  'bmxEvb': '查看截图',
  'elh3I5': '视频保存时限（天）',
  'jrz36o': '请选择要导出的记录',
  'lJykMl': '处理失败',
  'nU5XCN': '还有可以输入 <remaining></remaining> 个单号',
  'oYCouL': '查看视频',
  'whFLBl': '创建任务',
  'BZtqw8': '请选择要下载的记录',
  'DsN6/g': '<strong>说明：</strong>{break}1、当前视频功能暂仅支持查询“出库打包”环节。{break}2、若系统未能成功查询到视频，请您直接联系客服/客户经理，我们将为您及时处理。',
  'G2+WDL': '获取视频云链失败',
  'PaaQBb': '创建失败',
  'k/ZYCd': '无视频文件',
  'xkHjBa': '批量下载结果',
  '/vrVEz': '<strong>尊敬的客户您好：</strong>{break}{break} 使用视频查询功能前，您需签署《{agreementName}》，请认真阅读并接受协议。{break}谢谢您的理解与配合，顺祝商祺～',
  'Jast2K': '我已阅读并接受',
  'UzxG4z': '协议签署成功',
  'orZ3MI': '协议签署通知',
  '2LSGCJ': '根据订单当前状态及轨迹，作废订单的费用处理规则如下：',
  'J7LVnb': '请注意：订单作废后无法撤销，请您确认是否作废该订单？',
  'JuDvIb': '<font>以下场景下，订单作废成功不收取费用：</font>{break} 1.出库单状态为「出库确认中」；{break} 2.出库单状态为「出库确认」，且订单轨迹中未出现【拣选中】状态（可在子订单详情页查看订单轨迹）。{break}',
  'tOYzEt': '本次共选择订单：{orderList}单',
  'PcipCg': '<font>以下场景下，订单作废成功将产生订单拦截费：</font>{break} 1.出库单状态为「出库确认」，且订单轨迹中已显示【拣选中】。{break} 2.出库单状态为「拣选完成」或「暂存完成」；{break}',
  'DgiUWw': '您尚未开通此报告权限，如有需要请联系商务开通',
  '0pBOr8': '本功能使用组-类两层结构，建议组用于区分使用场景，类用于区分此场景下关联不同的策略。{break}每个组的数据都是所有已发布的SKU，每个组均是基于所有SKU进行分类，一个SKU在同一个组下只允许存在一个类内。',
  '6ZFs0i': '{skuType}[{skuCodes}]的出库数量为 1 {unit}，请确认是否仅{type} 1 {unit}？',
  'Xagh1G': '下架',
  'bEBWR+': '您选择的商品中：',
  '+ey7Yq': 'itemId',
  'PUjSsA': '目前仅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)平台配置规则。其余平台将陆续开放，敬请期待!',
  'PoV573': '是否为EF服务',
  'S/dUu1': 'ef SKUID',
  'lLS+rK': '仅同步已完成注册的平台商品',
  '/TI8v+': '按平台要求，eF平台不允许与其他平台共用一个组织内的库存！',
  'AizcnV': '勾选入库标签特征=未贴包裹码，仅贴商品码后，将清空现有的箱单信息，您需要重新导入箱单，请确认是否勾选？',
  'MSpE0K': '提柜申请已提交，届时万邑通将按照您的提柜申请前往目的港进行提柜，针对该订单您无需进行预约，万邑通提柜送仓完成将邮件通知您，如有任何疑问您可咨询客服，谢谢！',
  'gXvdYK': '该入库标签特征仅支持满足以下条件的SKU进行下单：{break}1、SKU的商品包裹类型=A+包裹；{break}2、SKU出库是否采集包裹码=否；{break}3、SKU批次管理类型≠保质期管理/生产批次管理；',
  'qvErRI': '请注意：在【海运整柜100%A+包裹】场景下，每个整柜只能对应一个入库单。请勿创建多个入库单或将一个入库单的货物分散放置在多个柜子中。',
  '05eCAs': '系统升级通知',
  'DkFwmu': '系统公告',
  'L24ioQ': '标题',
  'MtNsT8': '猜你想选择：',
  '/F5ua7': '角色管理',
  '/kcDRM': '权限分配',
  '0fPGWA': '转入方',
  '39n5YN': '发票生成成功',
  '50JdGS': '新增角色',
  '7WRAqc': '确认接收成功',
  'CwD34X': '转出方',
  'EWyvCn': '货权转移单{orderNo}，状态非“已上架”，不允许生成发票',
  'Eco+Vy': '*权限修改后，相关子账号重新登录后生效',
  'F7+3p7': '发票号',
  'IPlwHh': '转出PVA库存',
  'JiNi3f': '生成发票',
  'T7TK6n': '授权下单',
  'TMLZfW': '确认中',
  'TOmMNL': '角色名称',
  'UlzvsW': '系统生成',
  '4Rjjko': '货权转移单{orderNo}，状态非“确认中"',
  'f/1WBy': '确认接收',
  'j/5P4C': '您确定要删除此角色吗？',
  'k+zCG7': '角色描述',
  'mFr2rC': '拒绝接收成功',
  'mGo/vP': '拒绝接收',
  'v0zMRx': '订单作废后不可恢复，确认作废吗？',
  'vTqH3H': '<font>请注意：为确保【100%A+包裹入库】服务的顺利执行，请按以下规则创建入库单：</font>{break} <font>整柜/整车入库</font>：一个整柜或整车<red>有且仅能对应一个入库单</red>。请勿为一个柜/车创建多个入库单，也请勿将一个入库单的货物分装至多个柜/车。{break} <font>散货入库</font>：同一预约单内，<red>单个SKU有且仅能对应一个入库单</red>。请勿为同一预约单下的同一SKU创建多个入库单，也请勿将一个SKU的入库单拆分至多个预约单。',
  'tXn/GP': '提柜申请已提交，届时万邑通将按照您的提柜申请前往目的港进行提柜，针对该订单您无需进行预约，{break}万邑通提柜送仓完成将邮件通知您，如有任何疑问您可咨询客服，谢谢！',
  '4wYj0s': '按单号精确查询',
  'AnBOmT': '本报表仅统计近12个月标准出库订单的数据。',
  'DQVpB8': '海外仓卸货时间',
  'DcJ5SS': '月份',
  'dm5kaR': '模糊查询仅支持一条记录，至少输入6位',
  'nJMBKl': '延迟',
  'vB+VpF': '{countryCode} 启用国际服务,至少要配一个区域的运费和续件费',
  'wXBORv': '如批量查询，每行输入一条记录，至多不超过{num}行',
  'y7RIrZ': '按单号模糊查询',
  '10cSqN': '入库包材类型',
  'Dyhkec': '关联业务单据号',
  'Ek/myJ': '自定义分组',
  'iicPwU': '请选择组',
  'x4UkYl': '说明：单次最多支持导入10000行数据;导入的单品条码会自动忽酪大小写（例:A001=a001)',
  '4+JGPX': '点击跳转查看',
  'XfMvRR': '商品编码已存在，请勿重复注册',
  'tgl+wy': '电池重量不能大于商品注册重量',
  '6F/qMC': '不能包含中文字符且前后不允许有空格',
  'VzWDBN': '货权转移单号',
  '849JPP': '否：',
  'HWGh4O': '当前数据获取时间{time} 数据仅供预览，仅展示已完成注册的平台商品及加入服务支持的仓库',
  'SMfcim': '{msg}',
  '+74dRQ': '确认作废',
  '8XdH/H': '请注意，当前订单仓库已<font>打包完成</font>。',
  'EJ0ilf': '请注意，当前订单已进入<font>拣选环节</font>（您可在子单详情查看轨迹）。',
  'GElz75': '请注意，当前订单仓库已<font>拣选完成</font>。',
  'K0VbUB': '建议您核实具体情况，并最终确认是否继续。',
  'QUABn3': '当前订单正处于{status}，作废后将无法恢复。{break} 经系统预估，<font>本次作废订单不会产生费用。 </font>请您确认是否继续',
  'Snx1CT': '此时作废订单，<font>将产生额外操作费用</font>，具体如下：',
  'VbK2G8': '尝试拦截作废',
  'W/umjf': '订单状态发生变化',
  'a/7jJk': '订单状态和预估的作废费用已经发生变化，点击确定查看最新预估费用。',
  'pISR6a': '我们将尝试拦截，<font>若拦截成功，将产生以下费用</font>。若拦截失败，订单将正常发出。',
  'snmY5L': '作废订单再次确认',
  'v1TKFQ': '仍要作废',
  '8xggaR': '<bold>温馨提示</bold>：再次下单时，原订单的增值服务不会自动延续。如您需要，请在新订单中重新勾选。{break} <bold>重要提醒</bold>：为避免产生重复订单，在进行“作废”操作后，请确认系统状态是否成功更新。',
  'MmsgRh': '请注意：<font>此作废费用已高于订单总成本（货值 {currency}{totalDeclareValue} + 预估尾程派送费 {currency}{totalFreezeFee} = {currency}{allPrce}）</font>。',
  'yUuXcJ': '作废此订单将产生 {currency}{totalAmount} 的预估费用。',
  '+51v3G': '入库下单错误',
  '+T7oUP': '导出成功',
  '/Ygt9N': '记录为空，请更新查询条件',
  '0K+2Nl': '库存查询',
  '1oRL0R': '至',
  '3Dke5v': '库存分析',
  '4TE3dA': '导出入库单信息',
  '4ZwaVH': '保存本地',
  '4jd2fs': '超时上架',
  '57EBJb': '进行中准时',
  '5e7tR0': '参数错误，请联系客服',
  '5ryQLW': '海外仓库存',
  '8Ly5mZ': '入库及时率',
  'MA9H0D': '商品关联WEEE注册号',
  'NDyvdD': '通知单',
  'NSlIU8': '海外仓出库单',
  'OL8i5W': 'eBay认证仓商品',
  'QTxuNZ': '投保商品管理',
  'QX1e50': '导出中',
  'QxJYio': '进行中超时',
  'SE4xTN': '平台同步导出订单',
  'SwgIXx': 'PVA押金冻结管理',
  'UYfJ4Z': '数据中心',
  'VD3UIl': '押金冻结管理',
  'VVOxxi': '导出内容',
  'ZtIH+x': '仓储收费单明细',
  'hvP05y': '周期',
  'kDoBV6': 'FBA未识别包裹信息',
  'l2fKmn': '准时上架',
  'mygmne': '库龄分析明细',
  'o9bMHL': '大小',
  'oi6ik1': '出库商品组配置',
  'p2ed1q': '增值单列表导出',
  'pkjKfJ': '进行',
  'qSxVi0': '迟到',
  'sCJx+e': '全球送订单',
  'sJqXBl': '导出失败',
  'sWrLcU': '重新导出',
  'slfC8D': '系统异常',
  'tQbfBF': '重试成功',
  'wYl6K+': 'PVA入库明细跟踪',
  'wqlbYC': '费用项明细',
  'PKTV4F': '导出中心数据只保留7天',
  'e2OLRg': '子包裹信息',
  'p7oVuI': 'LMA订单',
  'uUtMYK': '分类库存',
  '90dgBB': '下单时间 月',
  'jnsal6': '报表说明：',
  'KvFZEa': '1、仅统计近12个月入库订单的数据；',
  'fmCKMv': '2、不包含草稿、作废、中止等状态的订单；',
  'o4T3N2': '3、不包含存在客户异常且没有物流单的订单。',
  'w8TzTf': '排队中...',
  '0I4Mwl': '订单中的卖家订单号，无映射则按winit规则自动生成',
  '3+2bo1': 'eBay账号缩写+Order No.',
  'BVLsdQ': '截取分割符号前',
  'Bdu5n5': '=CustomLabel',
  'DGYr7K': '填入需要截取的customlabel',
  'ER9apN': '=CustomLabel中指定分隔符号截取',
  'FNOn2N': '无映射',
  'MKTUwk': '卖家订单号映射规则',
  'MT58zS': 'Order No.',
  'PCGKLz': '截取分割符号后',
  'PIWfVv': '从第一位向后截取',
  'Q8W43H': '可填入需要截取customlabel后测试结果：',
  'Se5OgA': 'Item ID + Transaction ID',
  'T0Qed1': 'Sales Record Number',
  'TgBR1/': '字段长度',
  'WzyWXL': '从最后一位向前截取',
  'XSETFO': '填写字段长度',
  'Z9n0H8': '填写后，系统将按固定长度的前面/后面部分截取',
  'anv9VE': '如：CustomLabel = ABC001，SKU No. = ABC001。',
  'cmEcYe': '商品编码+规格',
  'cvIhux': '截取',
  'dG9rFr': '分割符号',
  'dLDvO0': '如：CustomLabel=ABC_001，SKU No.=ABC。',
  'dgBUXs': '=CustomLabel中指定字段截取',
  'en9HKt': 'eBay账号缩写 + Order Number',
  'gjwW8D': '多属性商品暂不支持，请使用“同步配置-商品匹配”功能',
  'hlzsNt': '测试截取匹配结果',
  'kPrPHg': '填写后，系统将截取此分隔符的前面/后面部分，多个分隔符号以第一个为准',
  'mAn1wq': '如：CustomLabel=ABC001002，SKU No.是CustomLabel前6位字符，即ABC001。',
  'qJQ6c5': '截取结果：',
  'sOdSKZ': '填写分割符号',
  'tUa1Vm': '商品编码映射规则',
  'tbyR9N': '规则',
  'znPwsY': '系统根据映射规则截取customlabel字段，与winit系统中注册的商品编码或商品编码+规格进行匹配',
  '+Wl5kQ': '退货完成',
  'G4onth': '仅支持查询一年以内的的卸货轨迹，如无法查询到请核实退货单的退货时间。',
  'IGSkxG': '长度限制1-20个字符',
  'ITF7LG': '已销毁出库',
  'K0wFa7': '对不起，未查询到该退货运单号信息',
  'MMs0dW': '若您的包裹包含可识别退货信息（退货ID/RMA#/已注册的商品条码），海外仓在卸货后5个工作日内会按退货策略完成处理。',
  'RVmnGY': '请输入退货单号',
  'RzvkXS': '注：eBay账号缩写可进入<a>eBay账号管理</a> 中设置。',
  'm5jINs': '无主货销毁',
  'uhTa0i': '预览',
  '+S9nDE': '您已到达最高返利优惠！',
  '37ySYt': '当前消费{currentValue}{currency},距离更高返利还差{remaining}{currency}',
  '6X3LzI': '当期尾程消费完成情况',
  '6ux/gW': '抱歉，该国家暂无业务激励方案',
  '85SrKm': '友情提示：本方案中的内容未经我司允许，不得以任何形式向第三方泄露，因泄露方案中的内容给我司造成损失的，万邑通将根据您与我司签订的《供应链服务管理协议》中保密条款的相关内容依法追究责任；',
  'C1sxZK': '达标消费额',
  'DZknnb': '上月已享受折扣',
  'Frd9m1': '当前货量',
  'K87Idn': '尾程派送激励方案',
  'K9N76+': '已完成此阶段',
  'LlkHzw': '激励介绍',
  'Qgwwca': '您当前享受折扣',
  'RjguGP': '头程运输激励方案',
  'TFywKD': '当期头程货量完成情况',
  'WWGa6X': '暂无上月折扣数据',
  'WhiSjD': '达标货量',
  'YFWuRp': '已享受优惠查询',
  'bioFIA': '全重量段',
  'cJOO41': '尾程运输上月折扣',
  'eCCg6m': '头程运输上月返利',
  'fk7rme': '当期消费完成情况',
  'hi+lji': '消费总额',
  'kEOHIU': '本版海外仓标准方案生效日期：{releaseDate}（期间若有新版本发布，本版自动失效，已签客户遵照合同约定）',
  'o7lceA': '返利率',
  'u2vr71': '抱歉，您当前暂时未享受到任何折扣！',
  'umu2mn': '海外仓业务激励方案',
  'vOBw66': '重量范围',
  'xEhqVL': '激励标准',
  'm45gH/': '尾程运输本月折扣',
  'AHk13m': '享受更高折扣',
  'eWjKON': '预计下月可享受折扣',
  'j+0loD': '尾程派送方式',
  'N4RO+G': '标签属性',
  'mIetiv': '标签序号',
  'ulOkM+': '标签描述',
  'vVQCFA': '子包裹标签列表',
  'O1Owap': '未分类',
  '+VopDc': '检查结果为不良品{break}处理方式',
  '+mYfas': '检查项目配置',
  '/n+tKs': 'WINIT计划于2026年1月1日起，正式关闭「退货策略维护1.0」的配置入口。',
  '0cMr0D': '点击前往补充',
  '1IIbDN': '其他配置',
  '2BxBTv': '策略待补充信息',
  '2KONJS': '退货策略维护2.0',
  '4HISCS': '历史版本记录',
  '4dEEgP': '下单时质检方案',
  '5tkC4Q': '编辑退货策略',
  '61cDzQ': '确定失效【{name}】吗？',
  '6ytQ75': '商品组类',
  '73eXMD': '需要，按WINIT标准拍摄',
  '7vX7Un': '仅最终处理意见为',
  '9Hn46w': '创建新方案 | 查看所有方案',
  '9YUNcP': '说明: 因下单环节无法获取实际质检结果以及最终处理方式和需加工增值；以上预估费用不含存在质检服务的商品仓库处理费,',
  '9yRzlq': '检查结果判断标准',
  'AI6DDX': '最后一个检查项不允许选择【继续检查】',
  'AtdvGF': '整体照片:',
  'AzJgkv': '2. 策略优先级：',
  'B40RlV': '<bold>最终处理意见如何判定？</bold>{break} 步骤一：仓库按序检查，若触发“处理并结束检查”的结果，则质检流程终止，并采用该结果作为最终意见；{break} 步骤二：若全程无中断，则系统会收集所有检查结果，并按照 销毁 > 拍照暂存 > 不良品上架 > 良品上架 的优先级，确定最终处理意见。',
  'CDdDy+': '需要拍摄整体照片',
  'D23Qrv': '此商品的RMA质检方案中，存在检查项目信息缺失，请<a>前往</a>补充！',
  'DY6+vH': '质检类型-质检项',
  'EECzKR': '执行的加工修复增值',
  'GS1Lum': '执行',
  'GZsvFK': '适用范围',
  'GluGBZ': '退货策略维护1.0',
  'HfSjD4': '1.0版本的历史配置在功能下线后将继续生效。为确保策略统一，请尽快在2.0版本中完成配置，原有策略将在被2.0新策略覆盖后失效。',
  'ISikVi': '质检服务待补充信息',
  'Irs1wT': '质检服务指定质检方案',
  'JEav9w': '是否需要定制打包复原',
  'JK2HF/': '创建商品分类 | 查看所有商品分类',
  'JoXUXa': '示意图',
  'KbwupO': '未执行',
  'LAH16f': '退货策略维护版本升级',
  'MFIIR2': '请先选择品类！',
  'MLSFI9': '适用商品组类',
  'MpyhY0': '1. 功能下线：',
  'ODFB43': '质检方案',
  'OjHnTC': '查看质检结果',
  'Q2tIhz': '上架处理方式',
  'RF4cO0': '发布人',
  'RjQfND': '是否完成检查',
  'TT18ya': '适用SKU级',
  'U5LjS2': 'WINIT收货环节会基于统一标准对商品进行初步判断是否正常以及对应异常！',
  'VWqu6P': '选择品类[<span>{categoryName}</span>]检查项目',
  'WSbvVj': '检查结果-处理方式',
  'X5lvqc': '请输入正整数，数字越小优先级越高',
  'Xqvhg+': '需拍照',
  'YBE8cL': '质检结果',
  'YS1hEm': '需提供信息',
  'Yygon3': '检查结果-处理意见',
  'ZNKoOi': '质检品类',
  'ZSIyhH': '确定生效【{name}】吗？',
  'aMWIVz': '方案版本',
  'bU9iQR': '「退货策略维护2.0」中配置的策略，其优先级高于1.0版本。',
  'bwYTdQ': '新增质检方案',
  'c1d3HN': '此策略存在质检服务待补充信息，为避免影响质检服务正常使用，请及时完成补充。',
  'cGhj/6': '此商品的退货策略中，尚未配置RMA质检服务及质检方案。请<a>前往</a>配置！',
  'dr80Nj': '质检方案维护',
  'dtzzvy': '新增退货策略',
  'fgmSvQ': '质检方案名称',
  'fi0x6R': '需要特殊打包复原',
  'fxqKz3': '发布时间',
  'g/7FFs': '请根据您的需求选择检查项目。WINIT标准检查项已为您自动勾选并锁定，以满足基础质检要求，因此无法取消。{break} 请注意，增选拓展检查项，该部分服务将依据质检等级按项计费。',
  'gFmt0w': '执行加工增值',
  'gskk4+': '查看照片',
  'hBFKEL': '是否执行特殊打包还原:',
  'hDlNTS': '查看质检方案版本<span>[{version}]</span>',
  'hME8oO': '质检方案类型',
  'hTCHMm': '可选加工增值',
  'iwyzfn': '编辑质检方案版本<span>[{version}]</span>',
  'j5Iaok': '适用组-类',
  'jZgtLX': '无需，正常折叠即可',
  'k869y5': '最少支持上传1张，最多支持上传5张模板图片！',
  'kbEx/Z': '检查顺序',
  'l/g30I': '所选收货仓无质检服务权限！',
  'lT4lHY': '3. 过渡期安排：',
  'leNLKM': '策略编码',
  'mXVcp/': '继续检查',
  'mt22Qq': '请选择检查项目',
  'n3ssO6': '无需',
  'nZHz3j': '检查结果为良品{break}处理方式',
  'oMwON9': '质检类型',
  'ozSlY1': '信息类型',
  'p9IpMU': '任一加工无法完成时{break}的处理方式',
  'qFVFrW': '需要，根据SOP进行操作',
  'qKuhZr': '重要提醒：',
  'qZChGk': '检查项目',
  'qaw9Fz': '最大图像大小 10M',
  'qfjmAq': '选择检查项目',
  'quY7u+': '方案类型',
  'sAcyRI': '商品组-类',
  'tYfrZI': '策略优先级',
  'u5ohvf': '最终处理方式:',
  'wDr1QD': '质检项目',
  'wIzG3R': '检查分组',
  'wTnJse': '触发后按此意见处理并结束检查',
  'xDRO8r': '适用商品组-类',
  'zMhU9B': '是否需要全局拍照',
  '5Dydff': '需要拍摄全局照片',
  'D2YSB/': '质检类型-检查分组',
  '0Ajg2F': '期望发货时间',
  'QeOd3T': 'deliveryDateTime',
  'uOBD7S': '新增国家',
  'BTdEai': 'eBay Fulfillment 操作指南',
  '/Q8O28': '设置质检商品组',
  '/btlgL': '补充更详细的质检方案信息：如质检结果示例图、质检结果处理方案、复原标准',
  '7Rp7oM': '吊牌商品编码',
  '8/gXkq': '操作示意图',
  '883yLc': '触发后终止后续检查',
  'AHfgiT': '选择便捷的<{winit}推荐质检方案>',
  'B6p1SV': '最少支持上传1张，最多支持上传3张模板图片！',
  'D4fIn6': '实际吊牌商品编码*数量',
  'DmZnYv': '说明：因下单时无法预知质检结果与处理方式，故预估费用不含质检相关处理费，该部分费用将根据实际情况另行结算，感谢理解。',
  'FpYvaM': '方案选用情况',
  'IUybYJ': '将需要质检的商品进行分组归类，建立清晰的<商品分组>',
  'QUKcOA': '补充质检方案细节',
  'Zxk1bV': '为商品选用方案',
  'dbocUy': '下单吊牌商品编码*数量',
  'kJYqHD': '为不同场景下的各个商品组，配置相应的<退货策略>并关联您在第一步设置好的<质检方案>',
  'nA3Afb': '<bold>最终处理意见如何判定？</bold>{break} <bold>步骤一：</bold>仓库按序检查。若过程中出现触发“终止后续检查”的结果，则提前结束检查；若全程未发生中断，系统将汇总所有检查结果。{break} <bold>步骤二：</bold>根据步骤一结束时所收集到的各项检查结果，系统将按照以下优先级顺序确定最终处理意见：<bold>销毁>拍照暂存>不良品上架>良品上架</bold>',
  'rzkSaC': '创建专属的<自定义质检方案>',
  'xzmXSZ': '维护质检方案',
  'I9UyiL': '请选择吊牌商品编码',
  'sX1llE': '请上传操作示意图',
  '573nH1': '第四步',
  'BmAtwJ': '系统配置异常，请联系在线客服 或 客户经理反馈。',
  'hSm/op': '第三步',
  '79nva+': '近{recentRepaidBillDay}天{count}个账单待还，请在最后还款日前及时还款，若未及时还款，按逾期日利率{rate}收取逾期费用。',
  '+mpYXC': '属于',
  '/KCuQq': '不匹配结尾字符',
  '0wttn2': '出库缺量规则',
  '2lZKYS': '不属于任意一个',
  '2z97tj': '不加包装（使用缠绕膜）',
  '4A/BqL': '优先原箱出库，无原箱则WINIT标准纸箱打包',
  '4qooC7': '确认禁用吗？',
  '5b6SVH': '不匹配开头字符',
  '9D/n/z': '请输入大于等于20%小于等于100%',
  'A2itln': '大于',
  'BQN5Hx': '满足以上加包装条件，则会按照以下优先级尝试加包材；如果无法找到合适的包材，将导致下单失败。',
  'D7AwWR': '匹配结尾字符',
  'EyhCf2': '常规打包',
  'HrwGnE': '匹配开头字符',
  'IUOVvQ': '确认是否删除【{name}】？',
  'KhzCZr': '不为空',
  'L/Uqej': '仅在满足此特定条件（{conditions}）时可支持缠绕膜打包出库，若不符合此条件且订单未选用快递袋、气泡袋或纸箱等包材将导致下单失败。',
  'LGG3nQ': '已选择条件',
  'N38CBT': '大于等于',
  'NOZnfu': '优先基于订单上和SKU上指定的规则加包装，如果订单上且SKU上未指定加包装，则按照下表的单一订单/复合订单配置的规则加包装',
  'P0fYLA': '标准出库/自提出库',
  'QE3tCM': '常规打包-复合订单',
  'Qk2Fwa': '匹配任意正则',
  'SgUr0U': '订单类型为',
  'T7RALq': '常规打包-单一订单',
  'TQEgjF': '{specification}-内径{inner}cm，外径{diameter}cm;重量{innerWeight}kg;承重{bearingWeight}kg',
  'ThN9T7': '自提出库默认使用WINIT出库单号提货',
  'UDzRdE': '纸箱最低装载率',
  'VvAOXx': '一单多面单',
  'XJuKZH': '标准出库/三方面单服务',
  'XrMPG5': '同时满足以下条件时执行规则，无条件则代表所有订单执行该规则',
  'Y+pkUW': '小于',
  'YKYgRu': '增值服务默认值设置',
  'ZV8mXo': '发货国家为',
  'b1hQA+': '验货',
  'bvyU1O': '为空',
  'chN6Xr': '全部包含',
  'czF4u1': '属于任意一个',
  'f0Gcik': '{specification}-长{inner}cm，宽{diameter}cm;重量{innerWeight}kg;承重{bearingWeight}kg',
  'fiZT2Z': '托盘打包',
  'gixfQz': '任意不属于区间',
  'hdX8Pq': '缠绕膜',
  'iGsJxa': '发货人类型',
  'ix+KJM': '不等于',
  'jVIEZ3': '禁用包材规则',
  'kTpKDZ': '查看出库加包装规则设置说明',
  'mpw9oD': '小于等于',
  'oQuDLX': '加包装条件',
  'p4WOam': '同一包裹内商品',
  'p5oi8m': '预设',
  'qiep+I': '全部不包含',
  'r8CWAF': '查看增值服务默认值设置说明',
  'rnpwS0': '所有正则不匹配',
  's5/hma': '复制规则',
  'tzxes+': '设置默认规则',
  'yxG6B5': '收货人类型为',
  'Oo2pw2': '若对费用有异议，WINIT可代为向供应商申诉，具体申诉结果以供应商回复为准。',
  'S6WSou': '为确保下单顺利，请保持此规则为开启状态。',
  'U4i64H': '支持大于等于20小于等于100，支持两位小数',
  'eaSAy1': '费用须知',
  'hOPK15': '开启即代表您知悉：加包装可能产生如人力分拣费、异形包裹附加费等尾程费用，WINIT有权事后补收。',
  'ig4HD7': '若出库订单及SKU层面均未指定包装方式，则以您在此处维护的包装偏好为准。',

  '0PBdTA': '支持大于等于0小于等于100，支持两位小数',
  '2Za3dq': '提示：系统将按优先级顺序匹配规则。',
  '92hxXQ': '纸箱须满足的最低装载率',
  'M2x5Om': '优先使用原箱发货；如无原箱，则使用WINIT标准纸箱进行包装。',
  'SZ9xgJ': '仅当商品总体积达到纸箱容量的 [输入框] % 以上时，才会启用加纸箱。',
  'W8+D0b': '当',
  'bwmdNs': '包材选择方',
  'eqh60T': '禁用包材',
  'jOdBrw': '优先遵循订单或SKU上指定的包装方式。当这两级均未指定时，则以您在下表设置的加包装规则执行。',
  'jprqwi': '请注意：一旦匹配到某条规则，但其中设置的包材无法满足当前订单需求，将导致订单无法成功提交。请确保您的规则中包材配置充足、合理。',
  'l+6ZhQ': '{specification}-长{inner}cm，宽{diameter}cm；重量{innerWeight}kg；承重{bearingWeight}kg',
  'ruLMCq': '{specification}-内径{inner}cm，外径{diameter}cm；重量{innerWeight}kg；承重{bearingWeight}kg',
  'DQmnDh': '客户自选',
  'o7FEk2': 'Winit分配',
  'sbYSy6': '仅在满足此特定条件（订单中仅包含大件商品，{conditions}）时可支持缠绕膜打包出库，若不符合此条件且订单未选用快递袋、气泡袋或纸箱等包材将导致下单失败。',
  'B0hVHU': '班车',
  'IPZmD/': '查看预约包裹',
  '5ug8SP': '系统优先匹配编号大的同步规则。',
  '9YYRcf': '当订单locationID为选中的一个或多个ID则匹配成功；若订单存在其他ID则匹配失败。',
  'MTp0sd': '设置订单同步规则',
  'Tp3jPk': '平台locationID',
  'UojdSt': '请先选择店铺',
  'WzLMak': '目前仅支持Shopify平台配置自动同步规则。',
  'YsrOWu': '编辑locationID',
  'aP/oFv': '同步订单&商品条件',
  'g8mKIE': '您已预约成功，请先取消预约后再操作添加增值',
  'gk6SAm': 'Shopify',
  'hhWF5b': '自动同步规则配置',
  'yuv9uR': '仅同步平台订单中商品locationID为配置的订单和商品信息。不在配置中的商品和订单将不会同步保存。',
  'zkSTJD': 'locationID',
  '42b83H': '若单一订单无适配包材，则不加包装直接出库。',
  '//H9da': '遇到问题不用等！点击右上角【AI客服】，快速获取精准答案，高效解决您的疑问～',
  '2/xUY2': '轨迹描述',
  'D+aQT8': '轨迹地点',
  'O9Dydo': '轨迹类型',
  'VOmITT': '异常生成时间',
  'W2/H8Q': '在线咨询',
  'lb7M58': '立即体验',
  'm7Fe9Q': '稍后提醒',
  'vCVG+U': '建议处理方案',
  'zyNzwM': '轨迹时间',
  '1DGt6b': '标准箱长*宽*高{unit}',
  '1UPiOF': '标准箱长{unit}',
  'J6QDbf': '确认长*宽*高{unit}',
  'Q6n4fg': '电池重量{unit}',
  'Q7nIpV': '确认重量{unit}',
  'W+Bzyl': '标准箱宽{unit}',
  'rF5c2o': '标准箱重量{unit}',
  'yXUP/+': '标准箱高{unit}',
  '/+ndT1': '订单是否含子包裹',
  '1jPngw': '箱材规格/箱材编码',
  'CdxiZ3': '修改装箱限制',
  'Itr6lw': '跳过提醒',
  'b7VRoN': '实际',
  'd/ONmD': '批量指定包材',
  'nvXY53': '若您选择 “API 推单” 方式，推单时系统将默认按当前配置的装箱策略及规则自动完成装箱；若采用 “万邑联 - 单步下单”，系统会直接按您预设的偏好展示装箱策略及规则，无需手动选择，让下单操作更高效便捷～',
  'rFHv5s': '装箱策略及规则',

  '4xOx+o': '线上充值单',
  '6UsC+5': '入库单交易明细',
  '9DCtKT': '账户交易明细',
  'Am2G5d': '线下充值单',
  'Ban2xz': '周帐单',
  'Blh176': '库间调拨单交易明细',
  'BwuVZ7': 'ISP信用交易明细',
  'D2cPwp': 'OWHS信用交易明细',
  'DJDZm5': '手续费明细',
  'FKiuoZ': 'UPS原始账单文件类型',
  'P99UIJ': '支付调用交易',
  'Qn4ZJ7': '出库单交易明细',
  'R+16Rx': '新报表管理',
  'UUtqvk': '未处理',
  'UowarN': 'ISP信用账单',
  'Vt6fEY': '信用账单',
  'WSy4T+': '导出时间区间',
  'WWNyCw': '待入账充值单',
  'Y5g8Te': '现金交易明细',
  'a+Meoo': '海外仓信用账单',
  'ajO1Yd': '额度信息',
  'c1Ov+v': '所有报表内容仅保留1周，一周后自动清除',
  'c1yyOH': '付款人审核导出',
  'dpdA01': '仓储收费交易明细',
  'e/Kla9': 'ISP交易明细',
  'iVjOaJ': '已导出',
  'n+a2gw': '正在处理',
  'oFuiXN': '收入结算单明细',
  'oiAyXn': '收入对账结果',
  'qhdw65': '月帐单',
  'r0N3YU': '现金冻结交易明细',
  'rp4YdL': '导出异常',
  't/lC2V': '信用冻结交易明细',
  'uncTHU': '库间调拨单',
  'xjS3qP': 'ISP对账导出excel文件类型',
  'b7f9/d': '标签/截止所选日期, 计算该SKU过去30天出库量，高温≥600, 600>中温≥100, 100>低温≥3, 超低温<3',
  '/W2550': '复测尺寸',
  '1shlp5': '申诉中',
  '3rVAtp': '申诉失败',
  '4hHXvr': '收入',
  'C0aYMc': '测算成功-不可申诉',
  'C6V18R': '原费用',
  'Mp1p5g': '差异费用',
  'N/NSFM': '费用项重算状态',
  'NpOV17': '应收',
  'OpFlc4': '申诉成功',
  'RP3KQM': '重算执行日期',
  'Rlyigi': '尺重变更日期',
  'TPYRkz': '申诉原因',
  'UOD37Y': '新费用',
  'Uqv0qr': '复测图片',
  'XZPExn': '重算单据号',
  'bAgRYE': '申诉截止日期',
  'ciSKVC': '查看申诉',
  'hbBX4R': '费用项类型',
  'ibGw3L': '单据日期',
  'jh3sUQ': '复测尺重图片',
  'kREBCU': '扣费成功',
  'kSfHBY': '收费日期',
  'nloyV1': '重算截止日期',
  'p/PaxD': '差异总金额',
  'qlqr7V': '重算失败',
  'slPSb/': '测算成功-可申诉',
  'u1D872': '申诉',
  'v8+0OK': '复测重量',
  'vkjFzi': '重算开始日期',
  'wlAKI+': '重算任务ID',
  'yaqV36': '重算成功',
  'p2StB1': '导出数据只支持一个月，请将查询时间段调整在一个月内！',
  'pCAB8K': '日期范围不能超过355天',
  'nmEIaT': '遇到问题不用等！点击右上角{aiBtn}，快速获取精准答案，高效解决您的疑问～',
  'C5uoG9': '是否出库{break}冻结VAT',
  'Cfi1QF': '是否要求英{break}国本地VAT',
  'ayVWWJ': '是否填写Eaby{break}SellerID',
  'k5V2i1': '是否签署PVA{break}进口承诺函',
  'opq3xJ': '是否签署{break}PVA申请函',
  '+3BCby': '{region}仓库入库管理质量数据',
  '/BLtk+': '指标数值',
  '2nQM1/': '{region}仓库出库派送质量数据',
  '4BanNe': '{type}率',
  '4JQSJ4': '{region}仓库退货处理质量数据',
  '4c7clp': '<=1天妥投率',
  '4ogMrT': 'D1 06:00Ascan比例',
  '5GwH/k': '达标',
  '5bO/vj': '退货卸货及时率',
  '6+cS9s': 'D0 24:00Ascan比例',
  '8g1o3T': '表示未达成目标',
  '8sxPPw': '<=5天妥投率',
  'CC4qyE': '未达标',
  'Cjvc04': '无RMA退货',
  'Dlbh6k': '尾程派送质量',
  'DtQflA': '{type}时效目标',
  'E8nUQr': '<=14天妥投率',
  'G4Cg+g': '<=4天妥投率',
  'GM78L2': '绿色背景',
  'GkZeI+': '出库派送质量',
  'Kez/zi': '<=7天妥投率',
  'L5GYuC': 'D3 24:00Ascan比例',
  'LRdkg3': '{region}仓库尾程物流时效数据',
  'LeT+rO': '库存健康度',
  'Mm4f9o': 'D2 12:00Ascan比例',
  'MniuVV': '<=6天妥投率',
  'NCjXYb': '{type}平均耗时（小时）',
  'NN9mm/': '退货处理质量',
  'Ncm89Z': 'D1 12:00Ascan比例',
  'NlcrDa': 'D1 18:00Ascan比例',
  'OxzUDc': '<=3天妥投率',
  'QFFPhw': '{region}-{name}业务环节',
  'RET0ZI': '表示超额完成目标',
  'S3ijv4': 'D2 06:00Ascan比例',
  'SBgk1D': 'Ascan平均耗时(小时)',
  'Sr9DZQ': '澳洲市场',
  'TBXETG': 'TOB（企业客户）',
  'YRVQwi': '有RMA退货（Return label）',
  'ZaJqci': 'D1 24:00Ascan比例',
  'ZcUqFC': 'D3 12:00Ascan比例',
  'aUFcH3': '红色背景',
  'amFFbq': '<=13天妥投率',
  'arsh33': '妥投率',
  'b32F5l': '入库管理质量',
  'bwu9tI': '欧洲市场',
  'dYo8lQ': '标签/指标定义{break} SKU温度:标签/截止所选日期, 计算该SKU过去30天出库量，高温≥600, 600>中温≥100, 100>低温≥3, 超低温<3{break} DOI:截止所选日期, 计算该SKU近30天日均库存数/近30天日均销售数量{break} 日均库存:截止所选日期, 该类SKU过去30天日均库存数据{break}',
  'dxM+62': '<=2天妥投率',
  'eWHkTw': '<=8天妥投率',
  'ehRq3Q': 'TOC（个人客户）',
  'fBZUil': 'D2 24:00Ascan比例',
  'gU2RPE': '目标值',
  'hEZmKt': 'Dscan时效明细',
  'hmxEAM': '北美市场',
  'iAc1uK': '履约质量报告',
  'iU9ECC': '<=9天妥投率',
  'jCvvE9': 'WINIT履约报告-{title}',
  'jiggJ0': '出库派送质量(TOC)',
  'n1xD0M': 'D2 18:00Ascan比例',
  'nHjvuO': '<=11天妥投率',
  'nZ2ohi': '<=10天妥投率',
  'ntVbOw': '尾程物流质量',
  'qY9pNj': 'D3 18:00Ascan比例',
  'qdwlqH': '有RMA退货（非Return label）',
  'r9nrCn': 'Dscan平均耗时(日)',
  'tWxzCK': '>15天妥投率',
  'uih03I': '出库派送质量(TOB)',
  'v3QnyV': 'D3 06:00Ascan比例',
  'vmNCLW': '卸货及时率',
  'wV4K52': 'Ascan时效明细',
  'ypRgWq': '<=15天妥投率',
  'ytPRt8': 'WINIT实际达成',
  'zi01v/': '<=12天妥投率',
  '1yVezl': '{region}仓库退货质量数据',
  '2EQl5D': 'Ascan及时率/目标及时率',
  '2UCAT/': '包裹数量(件)/总数量占比',
  '3HPRdL': '点击查看上月履约质量报告',
  'Cf4Dxe': '{region}仓库入库质量数据',
  'DxD84c': '退货质量',
  'KCPw20': '出库质量',
  'KETrVd': '数据更新:{updateDate}',
  'bP+DXy': 'Dscan及时率/目标及时率',
  'ebeXB4': '有RMA退货（非Return Label）',
  'i7/n4q': '自营网站',
  'kPgNRf': '{type}时效明细',
  'n8wokX': '库存健康度-温度DOI矩阵',
  'r9hPjy': '有RMA退货（Return Label）',
  's7xX25': '出库运单',
  'wa+GQk': '入库质量',
  'yoE23F': '实际出库包裹数',
  '/VLPAR': '应Ascan包裹数(件)/总数量占比',
  '9qSePb': '{type}平均耗时（日）',
  'HzZNGd': '应Dscan包裹数(件)/总数量占比',
  '0ADeXp': '当前目标值为WINIT标准，各平台维度标准将在下期上线',
  'ArtXNn': 'A/Dscan时效表格',
  'BGefxq': '*下方时效数据中的Day均按工作日',
  'S2N7yW': 'Dscan时效表格',
  'UpARF1': '<=N天妥投率',
  'bs+f21': '统计维度',
  'g+DdcS': '应出库包裹数(件)/总数量占比',
  'smMCna': 'Ascan时效表格',
  'HOx5Gm': 'SKU存在审核不通过退回信息，请',
  'K2Knso': '库存来源',
  'VLkMXm': '自有进口商新递延清关',
  'YPMVhh': '前往配置',
  'kFpo0l': '暂存仓储单明细',
  'nFd8Op': '使用客户自有进口商新递延清关做进口申报，缴纳关税，进口暂不缴纳VAT增值税。',
  'S1UW0D': '前往更新',
  'kbXdMn': '卸车完成',
  '2RcAEK': '卸车实际开始时间(当地)',
  'Z3oDda': '卸车实际完成时间(当地)',
  'i24dmn': '目标卸车完成时间(当地)(客户)',
  '+zITmD': '确认取消',
  '/9nx66': '待受理',
  '2RSxtZ': 'LMA出库',
  '3Xtdou': '取件人时间',
  '4dXcaE': '查件单号',
  '4db2vs': '注：预计在10个工作日内收到反馈',
  '5COJCU': '查询方式',
  '5n+nEm': '请填写!',
  '6gddnv': '支持最多输入300个子订单号批量申请，用英文格式逗号隔开。例如：输入W0111111111A,W0111111111B,W02222222222C或 直接复制表格数据添加。',
  '8K3n/q': '已提交供应商查件',
  '8bfXLo': '查件类型',
  '9BjcPI': '收货人城市',
  'AXYXL1': '失败订单数：{sumErr}',
  'BwttVT': '收货人电话',
  'GRcYPa': '（预计会在10个工作日内收到反馈）',
  'HbuMn5': '收货人街道2',
  'J22fiQ': '申请尾程查件',
  'LSu7mi': '请输入正确的邮箱地址',
  'PNaem7': '此操作将作废原申请单：{serialNumber}，生成新申请单。是否确定提交？',
  'Rmy+/j': '支持最多输入300个快递单号批量申请，用英文格式逗号隔开。例如：输入111111111,22222222或 直接复制表格数据添加。',
  'UGJiTJ': '支持最多输入300个出库单或包裹号批量申请，用英文格式逗号隔开。例如：输入LMA010000000200CN,LMA010000000200CN,LMA010000000200CN或 直接复制表格数据添加。',
  'UQtFd4': '超过 <remaining></remaining> 个',
  'UhOXYz': '收货人email',
  'WNS2rG': '前往查看成功申请单',
  'XMWZ7W': '反馈时间',
  'YnkdZ4': '成功提交查件订单数：{sumSuc}',
  'Zk/ICr': '还能输入 <remaining></remaining> 个',
  'bRnJvw': '收货人姓名',
  'fCZa1O': '申请签收证明（POD）',
  'fobnc0': '退回选项',
  'h9ocDd': '商品英文品名',
  'kES5v8': '请填写查件原因等备注信息',
  'nxOK10': '支持最多输入300个出库单或包裹号批量申请，用英文格式逗号隔开。例如：输入W0111111111,W022222222,W0333333333或 直接复制表格数据添加。',
  'pFDH8b': '超时未妥投',
  'q07jrc': '说明: {break}1、以下订单存在拆单情况，请选择需要查件的子订单号或快递单号 {break}2、点击确定后,将为您合并数据,并切换至按子订单号查询方式查询',
  'qsIJNh': '收货人州',
  'rC41Ru': '附件格式/数量:支持格式{attachmentFileFormat},最多上传{attachmentNumMax}个附件,每个附件不超过{attachmentSizeMax}M',
  'rW9+Sw': '部分妥投',
  'sXA8Hu': '以下为失败订单:',
  'siLxjW': '支持最多输入300个包裹号批量申请，用英文格式逗号隔开。例如：输入LMA010000000200CNA,LMA010000000200CNB,LMA010000000200CNC或 直接复制表格数据添加。',
  'vO6qbO': '查件结果',
  'w0OdQ5': '收货人国家',
  'wJ6xYQ': '确定要取消这条尾程追踪记录吗？',
  'xQ11Dd': '妥投未收到',
  'yOT8p7': '收货人街道1',
  'yVvdHC': '查退回原因',
  'zYluLh': '海外仓出库',
  'zuhcw0': '收货邮编',
  '1JeJN7': '实际上架时间(当地)',
  'o+ag/q': '预计上架时间(当地)',
  '8uMLuW': '异常发生时间',
  '2m0yvL': '加Winit包装：指客户选择加Winit标准包材，不关联判断SKU设置的包装方式{break} 不加Winit包装：指客户选择不加包装，不关联判断SKU设置的包装方式{break} 包材类型：部分包材类型Winit可能未准备，结果如为无合适包材可选择其他包材测算{break} 计算复合打包限制：选择Y时，按照70*60*60 加PSC尺寸限制打包，选项为人工选择，系统不自动判断实际是否会触发限制。{break} 打包结果取值原则：在符合限制的多种打包结果中取周长（长+2*宽+2*高）最小的值。',
  '7sNu+S': '测算',
  'CWPyfS': '包裹长',
  'MA/Mn5': '计算复合打包限制',
  'UNr9ES': '输入的值必须是大于0的整数,且最多4位',
  'WWFTye': '是否加Winit包装',
  'XikQEu': '若SKU类型为单一产品，请填写出库单商品个数；若SKU类型为套装产品，请填写出库的套数',
  'dFl4jM': '测算结果',
  'gIOerf': '包裹宽',
  'n5n1OS': '包裹高',
  '+iNy1w': '作业启动模式',
  '/1QYno': '等报价，运费确认后再开始作业',
  'BNCADB': '无需暂存，打包后直接出库',
  'KkzMm4': '仓库立即作业，若后续运费不合适可转为自提',
  'LFKMDI': '当前订单的作业启动模式为【仓库立即作业，若后续运费不合适可转为自提】{break} 在确认报价前，仓库已经开始作业，请确认打包后是否还需要暂存？',
  'Z3Riil': '请先选择发货仓',
  'o03lm4': '需暂存，还需要补其他增值',
  'rqJgva': '当前订单的作业启动模式为【仓库立即作业，若后续运费不合适可转为自提】{break} 在确认报价前，仓库已经打包完成，请确认需要补其他增值？',
  '9GFPa8': '需补增值，前往订单处理页',
  'Wiixeg': '无需补增值，直接出库',
  '9OiRk/': '平台退货履约ID',
  'BL3caE': '退货履约单状态',
  'RT4t52': '退货订单名称',
  'SITYoM': '平台{platform}和eBay/TikTok/shopify不能同时选择',
  'SYgdsw': 'eBay Fulfillment服务偏好',
  '3TBBLJ': '如需重新选择处理方式，系统将自动作废{storageBusinessNo}【{storageOutboundStatusName}】【{storageBusinessSceneName}】，请确认',
  'vhSqCh': '重新选择处理方式',
  'w11zgT': '{returnGoodsOrderNo}重新选择处理方式，系统作废原处理方式创建单据',
  '1yn9kZ': '库存转移数量',
  '4yMMq7': '销售退货',
  '76+Fks': '取消销售',
  '9jgpXZ': '货权转移日期',
  'EznFZ5': '冻结数量',
  'JPZ+FG': '经营单位',
  'N0gitK': '子账户名称',
  'T2OhL9': '待上传资料',
  'VP1jIv': 'M码',
  'Z63W6m': '销售出库',
  'Z85O4V': '货权转移时间',
  'ZRD6CI': '转移数量',
  'bA403s': '关联单据号',
  'clh844': '关联销售单号',
  'dMeRwF': '转入库存总数',
  'iFuCVP': '退货单作废',
  'keBtGB': '转出库存总数',
  'mJ6Rya': '是否PVA',
  'uol1F5': '货权转移类型',
  'vb+EJD': '转移原因',
  'AYhu7z': '直接输入单个商品的装箱信息。适合一次添加少量商品时使用，最多支持添加10种商品，且不超过5个箱子（非原箱/箱产品）',
  'FXbf/N': '整箱出库，不可额外加包装',
  'J3ny5z': '当箱子里面的数量为1时，才支持选择包材为“不加包装”',
  'WqgvIj': '最多支持添加{x}箱（非原箱/箱产品），如需添加更多箱，请选择“批量上传”指定装箱。',
  'a+FHIT': '不额外加包装（原包装）',
  'qCrGhM': '包材规格/包材编码',
  'NAML+W': '若您通过API下单，系统将自动应用当前设定的装箱策略。{break}若您在万邑联进行下单，订单页面将默认选用此偏好设置，您也可根据实际需要在下单时随时调整。',
  'PKAG7q': '装箱规则-条件设置',
  'iGal4w': '请输入包材编码；若未输入，系统将自动推荐有库存的适配规格。',
  'kS+WhZ': '仓库自主加包装',
  '8HakYW': '下单偏好：装箱策略及规则',
  'KAFHjX': '装箱规则偏好',
  'SiGjJP': '装箱策略偏好',
  'i7hr5i': '确认要撤回改订单吗?撤回后请在未发货页签中手动编辑发货,不及时发货会影响平台时效考核。',
  'yyoFou': '忽略已绑定数据',
  '7ndvwC': '投保有效期',
  'A0f0/k': '投保保额',
  'JCLJ1E': '保费币种',
  'NFlgV7': '投保箱数/套数',
  'Q2RQiv': '关联订单号类型',
  'cmGX6v': '投保日期',
  'dJDoS9': '保费金额',
  'ecwmuS': '投保单号',
  'pl49Yd': '投保单品总数',
  'wpcxNG': '投保单品数量',
  '/1DQhx': '按批次查询时，仅可查询批次商品，仅支持查询在库、已下单未入库、已预约未上架3类库存属性',
  '1ndhGR': '是否有剩余可用额度',
  '2gQoSe': '限制项目',
  '5K9Hwk': '在库+已下单未入库',
  '5tSmdq': '商品限制属性',
  'ETuiyY': '限制值',
  'Ih1vCg': '商品是否高货值',
  'JDsBXq': '客户限制条件',
  'PCnNO2': '剩余额度',
  'V6APKW': '预约限制',
  'XetU9f': '查询维度',
  'Xp5lvu': '在库可用值',
  'Y10AHt': '在库',
  'Zzw4rv': '在库+已预约未上架',
  'axS6oX': '指Winit对客户入库限制库存推荐的查询条件组，选择后即不能选择商品带电池、商品电池功率、商品是否高货值、包装方式、其他属性筛选项',
  'e9zkGw': '其他属性',
  'eq0G/k': '方案名称',
  'gsiAen': '预警值',
  'hiBbus': '库存限制',
  'iVJdmg': '现有值',
  'kZZRbD': '商品带电池',
  'l8LunG': '限制规则',
  'lO7FcR': 'SKU数量：{skuQty}，SKU体积：{inTransitVolume}CBM，SI数量：{itemQty}（备注:根据当前所选择的查询条件汇总）',
  'mZbqYV': '已预约未上架',
  'n83qoO': '数据刷新时间：{time}',
  'pFHvk7': '入库库容资源额度',
  'qZgAkG': '商品电池功率（WH）',
  'qc2vsi': '已下单未入库',
  'ray6Xr': '在途值(已下单未入库)',
  'sofh2q': '库存属性',
  'u+2dkd': '方案说明',
  'S1jwaU': '种类',
  'r6qzDG': '包装',
  'D1YrAF': '大包标签',
  'TxJxc3': '海外仓出库日期',
  'VqfoRn': '大包状态',
  'emU+Eq': '已到海外仓',
  'm1liyd': '大包号',
  'oHApkd': '大包条码',
  'ooeZJH': '到达海外仓日期',
  'QuQimk': '说明：单次最多支持导入20000行数据;导入的单品条码会自动忽酪大小写（例:A001=a001)',
  '4g/YNM': '低级别服务运费不能大于等于高级别',
  "/l2Id0": "当前选中的订单号[{orderNos}]不是待预约状态，请修改后重新选择【批量预约提货】。",
  "6LvyX5": "您选择的订单包含托盘自提（{palletNos}）与包裹自提（{packageNos}）两种类型。因货物形态不同，暂不支持一起预约，请您分开选择同类型订单后重新操作。",
  "AEVtQQ": "修改第三方提货码",
  "IY3FXR": "您当前选择的订单中存在不同的提货码，请确认是否修改成同一个提货码？",
  "JAHjpN": "批量预约",
  "Jtowgc": "批量预约提货",
  "McPFaa": "新第三方提货码",
  "f4NmJd": "您选择的订单[{orderNos}]分属不同的发货仓。暂不支持一起预约，请您分开选择同发货仓订单后重新操作。",
  "iIGDFN": "当前选中的订单号[{orderNos}]不是预约成功状态，不支持修改预约信息，请修改后重新选择【批量修改预约信息】。",
  "jHGQ5p": "请输入新提货码",
  "lVnIuK": "原第三方提货码",
  "oyfZ7G": "批量修改预约信息",
  '/dZoKR': '对比结果',
  '203KK1': '幅度: {resultRatio}',
  '51Xeya': '多个单号用逗号或者空格隔开，最多支持 {n} 个单号',
  '6UtugB': '（电商清关）',
  '9CfUdP': '支持上传pdf/bmp/jpg/png格式的文件',
  'BWxabz': '标签来源',
  'DTE63f': '采集部分商品',
  'E+V4qJ': '冻结单号',
  'E94VE7': '（运费+DUTY+进口VAT）',
  'EVdExE': '（传统清关）',
  'Eh8ecU': '不允许清除的标签',
  'Ezd3IN': '被标记为“禁止覆盖”的标签',
  'GGVXel': '已解冻金额',
  'Hih1cN': '采集范围',
  'ITEyhW': '一次导入不能超过100条数据，请删除部分数据后再导入。',
  'JuzkYv': '剩余冻结金额最大值',
  'KJ8w2z': '上传需要采集的商品信息',
  'MIfGVs': '上传示意图',
  'NZ5BVa': '金额: {comparedResult}',
  'O2HC+u': '申报价格总额或',
  'Pt4b9+': '关税税率',
  'QTZ0Y9': '对比结果(USD)',
  'SasUDH': '选择此项后，WINIT将优先采集外箱标签上的SN码。{break} 请注意：{break} ① 请您确保外箱所粘贴的SN码与箱内单品实际SN码一致。若两者不符，由此引发的异常及相关责任将由您自行承担。{break} ② 若外箱未粘贴完整的箱内单品SN码，为保障操作准确性，仓库将自动转为开箱采集。',
  'T/xzrY': '选中的订单不产生违规费用，取消后需重新预约。',
  'TTEs1k': '货权转移',
  'TdfPoy': '剩余数量',
  'V74Nnm': '电商清关',
  'VMdkVZ': '手动输入',
  'XMmUru': '请注意：选择此项即表示您同意：仓库将开箱采集箱内单品SN码。此操作将拆开原箱包装（胶带），请确认操作。',
  'XdgqX6': '剩余冻结金额',
  'ZMLOdj': 'VAT No.',
  'aP7Y4s': '源单类型',
  'bHoKa/': '传统清关',
  'blqDHs': '综合成本',
  'ckW6cz': '条件查询',
  'dDGFPE': '剩余冻结金额最小值',
  'dT/4mA': '批量取消预约',
  'f065td': '请先选择文件',
  'fZSqu5': '押金冻结金额',
  'fph6KW': '搬仓',
  'gzdH4A': '单品应缴增值税(USD)',
  'htJN69': '出库单要求增值补贴的标签',
  'iWRgTe': '冻结日期',
  'ia3MaQ': '已出数量',
  'ivyd8M': '仅支持针对商品化管理的SKU采集，单品化管理的SKU，系统会默认追踪并反馈出库单品码，无需您再额外提交采集SN码的增值服务。',
  'j4FqiC': 'DGb标签',
  'jt8XHR': '采集外箱上的SN码',
  'k6nibR': '指定标签{index}',
  'mLD2Rk': '计算结果明细对比',
  'meL30M': '(共 {total} 条记录)',
  'mmiuH1': '仅保留<tooltip>不允许清除的标签</tooltip>，其余全部清除',
  'nFZLVS': '计算结果',
  'oz+tJE': '指定标签',
  'pAsUMd': '尾程出库',
  'pGxqSP': '开箱采集SN码',
  'pdT4l0': '清关模式',
  'q9mfG6': '对比比例(%)',
  'qwBnz+': '数据来源',
  'r79YLd': '单品申报价值(USD)',
  'rjl+EA': '海关建议申报价值总额',
  'sW4ZUc': '批量查询',
  'thhsjq': '选中的订单[{orderNos}]将产生违规取消费，详情请看价卡，取消后需重新预约。',
  'yKSKEE': '最多支持输入{n}个单号',
  'yaM9oN': '标签示例',
  '/BHFm2': '入驻进度查询',
  '/GaNdh': '上传指定标签',
  '/TzrDD': '请务必上传指定标签～',
  '0SYcTZ': '仅采集导入的商品',
  '6+8CRa': '请选择国家',
  '6EyN8h': 'Winit初筛通过',
  '9c1hzl': '入驻申请状态',
  'rJGLim': '（已发送绿色通道邮件）',
  'EuHa/E': '订单中存在单品化管理的SKU[{skuCode}]，系统会默认追踪并反馈出库单品码，无需您再额外提交采集SN码的增值服务，此增值仅采集商品化管理的SKU',
  'FXfS9v': '邮编查询工具',
  'G+eQ6Y': '电商清关计算器',
  'GBRNdf': '申请编号',
  'JBvtCq': '箱产品/原箱 采集位置',
  'KYK6eH': '入驻平台',
  'Kqtpf2': '已提交平台',
  'N6ajdw': '平台审核失败',
  'SMmJ95': '平台审核通过',
  'NEpuF0': '城市、州、邮编需至少填写一项',
  'YulXiJ': '订单内所有商品都需要采集',
  'cBcQ2x': '当前选中的订单号[{orderNos}]不是预约成功状态，不支持取消预约信息，请修改后重新选择【批量取消预约】。',
  'fEklXb': '查询结果',
  'k8fjyM': '选择【仅保留不允许清除的标签,其余全部清除】时，将自动去除其他选项，是否确定选择？',
  'lp414l': '仅保留不允许清除的标签，其余全部清除',
  'r3cJxf': '国家/城市/州/邮编查询',
  'yGydU8': '最多支持上传{maxCount}个文件',
  'yRcdbz': '申请状态',
  'M/dbSE': 'Winit初筛不通过',
  'qpJ1Q8': '入驻进度信息',
  'sd8yW7': 'Winit初筛通过',
  '3x03jC': '定制标签',
  '411c5X': '上传SN码位置示意图',
  'hbqoJB': '部分商品采集',
  'k48Ow1': '支持上传bmp/jpg/jpeg/png格式的文件，且每张图片最大1M',
  's68RTA': '文件大小超过1M',
  '+5l5RU': '提单',
  '+YZ9D0': '万邑通进口商',
  '+fWkMw': '自有出口商',
  '+sTzV8': '每个记录至多上传20个附件！',
  '/ne/E8': '订单列表',
  '/x7nZy': '添加订单',
  '/xZBur': '1.快递--请上传快递公司原始发票和报关单；{break} 2.空运/海运（整柜或散货）---请上传英国进口报关文件C88和E2或者CDS entry文件{break} 3.转仓--请上传货物合法进口清关资料{break}',
  '04hsSz': '无需上传',
  '0Aqamd': '进口报关方式',
  '29WiJt': '请选择项目!',
  '3MVwP5': '下载资料',
  '3dIgTz': '自有进口商',
  '3mYFsT': '万邑通将应英国海关税务总局总署（HMRC）要求提供相应的信息和文件',
  '5f/tmO': '关联订单',
  '5ha5za': '所选订单存在不同的进口商',
  '7hCnwL': '文件资料',
  '92mnHT': '进口文件下载',
  'A0dboq': '无进口商',
  'DNhsJs': '添加成功!',
  'ETsbI4': '进口申报资料',
  'ElSBFf': '提单收货人',
  'EswQfb': '品名描述',
  'HHvf84': '生成日期',
  'HYBpDp': '出口报关单',
  'Hy9KWe': '说明，每个品名单独一行输入',
  'ILoiBi': '资料详情',
  'IuHG6+': '无文件',
  'KYBCb+': '订单查询',
  'KyeBiS': '金融出口商',
  'QaWo2G': '提单发货人',
  'R4dmjn': '等待上传',
  'RA4e41': '自报关',
  'Rz9imW': '已开票',
  'ThBqN+': '批量下载',
  'Ty8kO6': '第三方出口商',
  'U1mKIE': '到仓时间',
  'WoxXMD': '所选订单存在不同的订单进口商，是否继续提交？',
  'WwhSzz': '管理进口商',
  'Xah/LD': '提交提单资料',
  'YL79u+': '待上传直发英国文件',
  'a1FoJJ': '上传文件说明',
  'b3QMvT': '运输资料管理',
  'dApyqa': '运输资料下载',
  'djX2Ag': '新增提单信息',
  'f0ik7b': '发票下载',
  'fIjF3a': '可按CTRL批量选择文件上传{break} 支持jpg，gif，png，jpeg，pdf，doc，docx，xls，csv，xlsx，每个附件不超过5M,每条记录至多上传20个附件！',
  'fh7G1f': '订单进口商',
  'hfAmiH': 'ENTRY NO（MRN NO）',
  'jl5HLa': '万邑通出口商',
  'jo21HT': '所选进口商与文件不一致原因',
  'kM0bHJ': '直发英国文件上传',
  'myXsKd': '已申请',
  'nLN0mF': '出口报关方式',
  'nt+PjS': '进口报关资料',
  'pxHrbj': '进口税单',
  'pzpMYc': '选中的订单中有未完成验货的，提单不生成默认信息',
  'q8devg': '第三方进口商',
  'smovHs': '请填写大于0的数，最多保留{number}位小数',
  'xptZYF': '出口报关资料',
  'ypVf0h': '提单信息',
  '+wet4N': '验证码错误',
  '4TJ3fw': '按住滑块，拖拽验证',
  '5LHKKt': '6-32位，且包含字母、数字、特殊字符中至少两种',
  '6AJEH3': '新密码',
  '9ljNkr': '重新发送',
  'CALdTq': '用微信找回密码',
  'NvFWAN': '最多200字符',
  'NzYMJp': '请使用已绑定{a}账号的微信扫码确认',
  'PzWEi/': '用邮箱找回密码',
  'QNdRrx': '两次输入的密码不一致',
  'RMNNp4': '请确认密码',
  'SkmWND': '用手机号找回密码',
  'TZjLzQ': '新密码设置成功，请前往登录~',
  'VVnTpe': '该微信账号未绑定当前邮箱，请使用绑定邮箱的微信扫码验证',
  'W7shU1': '提供账号信息',
  'Y8fUsW': '请选择方式',
  'Z5Nevj': '修改密码',
  'ejs0A3': '请输入手机号码',
  'iTrKWD': '记得密码？返回{a}',
  'pTv/F0': '点击下方{a1}按钮，我们将向您{a2}发送邮件以验证您的账户',
  't0nA+i': '安全验证',
  'tqxH2C': '请输入有效的邮箱',
  'uGp2R1': '确认发送',
  'w2+gpZ': '我们已向您发送电子邮件以验证您的账户，请检查您的{a2}收件箱并完成验证，如果您未收到邮件，请点击这里要求{a1}',
  '1NA8y/': '重置密码失败',
  'YAH/13': '质检服务仅支持基于具体商品组-类配置，不允许选择适用所有商品',
  'e2ng4d': '多个商品条码需换行或用英文逗号隔开，最多支持{num}个，双击切换到单个查询',
  '81cy/S': '支持上传bmp/jpg/png/jepg/gif格式的文件',
  '02WhE8': '反馈内容',
  '4R5GEq': '首页',
  '9mMWiw': '创建问题工单',
  'L/NHRt': '变更状态',
  'Lb+A3a': '答复',
  'LqIgJ0': '问题/建议分类',
  'Mx2ytz': '录屏',
  'OjLqmy': '未知',
  'UJM0aP': '截图',
  'W1XmWz': '第',
  'XPFi6q': '条',
  'bRWVNo': '模块_功能页面',
  'e4xBZM': '条，共',
  'gGSndD': '我',
  'jlVsSp': '反馈记录',
  'oeAKKH': '功能建议详情',
  'pqjc9a': '功能建议',
  '1t+SIt': '待分批处理包裹/托盘',
  'UhLIyC': 'OTTO平台创建退货单，请选择return label退货服务。否则下退货单失败，会导致平台订单标发失败。',
  'B5WNzT': '<font>以下场景下，订单作废成功将产生订单拦截费：</font>{break} 1.出库单状态为「出库确认」，且订单轨迹中已显示【拣选中】；{break} 2.出库单状态为「出库确认」，且从供应商获取到尾程面单（仅部分供应商，详见价卡）；{break} 3.出库单状态为「拣选完成」「打包完成」或「暂存完成」。',
  'F88GCy': '货权转移明细列表',
  'Ggi6gC': '<font>以下场景下，订单作废成功不收取费用：</font>{break} 1.出库单状态为「出库确认中」；{break} 2.出库单状态为「出库确认」，且订单轨迹中未出现【拣选中】状态（可在子订单详情页查看订单轨迹）。{break} 3.出库单状态为「出库确认」，且未从供应商获取到尾程面单。',
  'h0xL1u': '此时作废订单，<font>将产生面单取消费用</font>，具体如下：',
  'hEd0nU': '货权转移列表',
  'pTH9Tb': '请注意，当前订单仓库已<font>出库确认</font>，并且从供应商获取到尾程面单。',
  'Us7j0k': '本次共选择订单：{orderList}单。{break}若作废成功，预计将产生作废费用：<span>{money}<a>下载费用明细</a></span>',
  '1LwUBD': '关键词',
  '7wLx36': '勾选后取消不可恢复上次选择，请确认！',
  '9UefLp': '标签',
  '9cCkiO': 'Webhook地址',
  'E/+KA9': '订阅对象',
  'FBDWRn': '请输入消息标题',
  'FuniBX': '变更主联系人',
  'H4wovK': '请输入Webhook地址',
  'JAIyUz': '通知消息',
  'JqgJGX': '订阅人/邮箱/手机号码',
  'NvLtl+': '一般',
  'OS0LiT': '新增订阅',
  'PPbRVY': '请先验证webhook地址',
  'SaWUeK': '消息一级分类',
  'Se+Fml': '订阅类型',
  'TB0+MB': '订阅对象名称',
  'VCA4P7': '是否订阅',
  'W5ZChw': '订阅语言',
  'WG5j22': '订阅角色',
  'YQjCEJ': '消息二级分类',
  'Yb84w9': '重要程度',
  'anJ1Qt': '请选择标记数据',
  'f+39S3': '请选择订阅内容',
  'geJ09d': '添加时间',
  'gh/3UH': '推送时间',
  'hj+c+u': '去设置订阅角色',
  'jhsT9N': '职务/备注',
  'kdTh+7': '标记已读',
  'ktaxSw': '未读',
  'luc2Nr': '同步订阅短信',
  'nDCjZ5': '确认全部标记已读？',
  'nVQlZW': '全部订阅',
  'pTYW3/': '已验证',
  'qK1KCj': '全部标记已读',
  'rHCuQ1': '重要',
  'sKrE9C': '验证',
  'sjRsMZ': '订阅所有“重要”通知',
  'uENXqC': '请在 个人中心 - 我的资料 - 联系人信息 变更主联系人',
  'xq3BbG': '该主题为主联系人强制订阅，不可取消勾选。',
  'z/zD9X': '机器人名称',
  'zkfr4X': '选择角色，则默认订阅该角色对应订阅内容',
  'zmDYiF': '订阅权限',
  'E4mrQc': 'Webhook 地址：参考 <a>获取机器人Webhook</a>',
  '/rSdLg': '31-60天',
  '0IOfTn': '91-120天',
  '1Fjaq+': '货值',
  '7PBmg9': '151-180天',
  '7bxNmH': '181-365天',
  'B5zlty': '未出库天数段',
  'C0WfWt': '61-90天',
  'CeraFI': '在库体积',
  'E8+w5M': '截止日期',
  'EHUOf7': '近30天平均销量最大值',
  'KtoCy3': '超180天未出库',
  'OLULP8': '查询日期',
  'Q9GryY': '121-150天',
  'QMF2SE': '近30天平均销量',
  'SutcRd': '未出库区间段',
  'X8reig': '超60天未出库',
  'hkJnTx': '365天以上',
  'iQLiiJ': '近30天平均销量最小值',
  'k6/mVV': '超90天未出库',
  'kZ0gWm': '超150天未出库',
  'krNXZs': '仓群DOI',
  'md/ktr': '超365天未出库',
  'nEOgoo': '在库数量',
  'tMo2Zv': '未出库天数',
  'vGXXMs': '超120天未出库',
  'vHrtsr': '温馨提示：库龄分析明细数据中在库数量已排除待销毁库存，商品未出库天数不会统计销毁出库记录！目前只支持查询60天内的数据。',
  'y0pCCP': '超30天未出库',
  'yE2ftt': '30天内有出库',
  'zSTmkX': '30天以内',
  '1Z0q20': '礼品卡币种',
  '5CxfGD': '导出使用记录',
  '95Hp/S': '查看使用记录',
  '9Usr+K': '礼品卡管理',
  '9WR7+x': '申领礼品卡',
  'ASFlCO': '使用记录',
  'KlWMzW': '已激活',
  'NCSj7q': '费用原币币种',
  'NvMM+d': '批量激活',
  'RWLYAl': '礼品卡生效日期',
  'UQs3Nl': '面值',
  'ZCDASn': '活动名称',
  'aN+DgN': '激活时间',
  'b/np9H': '过期时间',
  'dsUPu7': '卡号',
  'g7PNrP': '礼品卡使用金额',
  'hV++l4': '订单履约场景',
  'kXhKwt': '已用完',
  'nHyNVr': '礼品卡余额',
  'sCayEg': '费用原币抵扣金额',
  'xISm1t': '激活',
  'xRUwu0': '余额',
  'yIVw3+': '使用限制说明',
  '/CSTCd': '*特别说明：',
  'FgKwXB': '1.礼品卡使用不支持订单补收、退费。',
  'rL3SDa': '2.同一订单的同费用下只允许抵扣一张满足条件礼品卡，有多张优先抵扣先过期的，过期时间相同则使用抵扣金额大的礼品卡。',
  'Ro2qcz': '是否不良品混合存储',
  '8qXhbV': '异常单[{eventNo}]已经提交过标准增值单[<a>{orderNo}</a>]，请从原来增值订单-暂存待处理继续创建增值！',
  'WvkP+p': 'API下单忽略非批次商品的批次入参信息',
  '/gzqUq': '异常单[{eventNo}]已经提交过标准增值单[<a>{orderNo}</a>]，不允许批量创建增值，请从原来增值订单-暂存待处理继续创建增值！',
  'wLp4S1': '备注：若您开启了此偏好，针对非批次商品或者是入库批次的商品，若您API下单传参了保质批次管理或者生产批次管理的批次信息，系统将自动忽略该信息进行下单。',
  'MfyMkP': '请先选择“发货国家”',
  '/VTvju': '收费币种',
  '1PGUKz': '不收费',
  '2qIWkk': '调整前SKU类型',
  '3uLrd9': '收费金额',
  '441EO8': '调整前信息',
  '5PA3dx': '该订单选择了箱产品破损后按单一产品上架的增值服务，此单一产品来源于对应的箱产品。',
  '5c2lA7': '已收费',
  '8CXErc': '实际调整信息',
  '9pf+1/': '单品明细',
  'AkqrWy': '库存类型调整单',
  'BpshEj': '收费状态',
  'FgGPtz': '系统生成的单为下述3类：{break}出库单分配共享库存时，自动触发的整箱/套拆零服务；{break}在创建入库单时选择了单品转整箱的增值服务，且转箱成功而自动生成的调整单据；{break}在创建入库单时选择了箱产品破损后按单一产品上架增值服务，且转单一产品成功而自动生成的调整单据；',
  'Fwsf/M': '柜号',
  'HPY1mp': '系统生成的单为：在创建入库单时选择了单品转整箱的增值服务，且转箱成功而自动生成的调整单据',
  'KznAti': '子包裹数量',
  'LsLx7J': '调整后库存单元数量(个/套/箱)',
  'MIqUrD': '库存类型调整单号',
  'MKUN8s': '下单信息',
  'NOYwTf': '收费明细',
  'TA/dF+': '不良品数量',
  'Thb3IK': '调整前库存单元数量(个/套/箱)',
  'UQJOTC': 'Winit作废',
  'bM/rWy': '该订单选择了箱产品破损后按单一产品上架的增值服务，部分单一产品来源于对应的箱产品。',
  'bS1ela': '关联SG',
  'cPOcLF': '当天',
  'crf+ux': '作废中',
  'dYxO8a': '调整的库存组织',
  'eOSHuj': '调整后SKU类型',
  'eqSzQH': '应完成时间(当地)',
  'gZTbq+': '调整来源',
  'ghuJzS': '是否需要收费',
  'iTkG5n': '良品数量',
  'ih/an8': '作废时间',
  'itKAwe': '异常反馈',
  'm2weIk': '客户作废',
  'mLZov4': '异常流程',
  'mcwf7W': '分类库存调整单',
  'mvFsMl': '是否拆箱逐件清点',
  'oCtS+Y': '调整后信息',
  'rfLmih': '未收费',
  'rvag4g': '作废失败原因',
  'uLI4ok': '子包裹明细',
  'uQwOYT': '收费时间',
  'vfZB01': '触发环节',
  'w6ZZc4': '预计/实际影响SLA',
  'wG10je': '调整中',
  'FAvugZ': '异常定义',
  'O2MhLZ': '邮件发送配置',
  'Vi8Lwt': '请选择配置',
  '0axu1J': '包裹类别数',
  'DJAqHM': '托盘尺寸限制',
  'Pq4RvP': '包裹类别编号/包裹号',
  'RmJtzp': '实收总金额（币种）',
  'bDWm20': '每箱件数',
  'dwmkO8': '<a>标准说明文案</a>',
  'fRe2FR': '预估总金额（币种）',
  'EA+JnO': '验证成功',
  '7Y8msb': '导出/导入状态',
  'DvfSVz': '前往设置',
  'QpRtOT': '执行中',
  'XWtLrG': '数据已为您导入，是否已成功请在列表中查看，如数据量较大，可能需要稍等一会',
  'mD6tbQ': '导出/导入内容',
  'nap+VW': '数据已为您导出，请在列表中下载，如数据量较大，可能需要稍等一会',
  'z3f/YA': '尺重来源',
  'I60VBo': '<strong>德国仓初始化说明：</strong>{break}德国库存初始化选择的VAT号请确保已维护德国包装法号（LUCID号）,{break}并请确保在途订单也维护好有LUCID号的进口商，{break}否则初始化将在7月1日后失效，需重新初始化。',
  'pWnuuW': '<strong>操作说明：</strong>{break}请先导出各仓还在库的SKU清单，输入对应SKU输入有效的VAT号后导入。{break}一次只能导出或导入一个仓库的数据，不允许单仓多次导入，且导入后不可再修改。{break}导入时SKU必须齐全，如存在部分SKU未导入将不成功（请注意导出与导入间隔期的新入库SKU）。',
  'PfM5xX': '电池重量应小于商品注册重量',
  '64x/DJ': '<strong>温馨提示：</strong>此商品为裸货，因未设置出库包装方式，存在出库下单失败的风险。为避免影响出库，建议您：{break}<strong>1. 快速启用：</strong>直接启用出库加包装-系统预设规则 【裸货加快递袋】（若已启用，请忽略）。{break}<strong>2. 自定义配置：</strong>为裸货或其所在商品分组创建专属的包装规则，{a}。',
  'LWZ8r8': '(查看包装分类说明)',
  '38BVhg': '暂停出库，还需提交其他增值',
  'Efi7Rw': '暂停出库',
  'SZNjiF': '无需增值直接预约提货',
  'So7SRd': '仓库会拦截出库，等待新的增值单',
  'm325Qd': '仓库不会等待新增值，直接出库',
  'pZTxK9': '暂停出库订单',
  '3K1yMY': '库内监控材料',
  'KqTHNC': '库内截图',
  'Uo35I9': '点击视频链接打开视频（只有已申请查询并获取视频的单据有库内视频信息，超期文件无法打开',
  'aidSjp': '点击截图链接下载文件（只有已申请查询并获取视频的单据有库内截图信息，超期文件无法打开）',
  'nbGLjI': '库内视频',
  '1Xj+fp': '<strong>说明：</strong>{break}1、当前视频功能暂仅支持查询"出库打包"环节。{break}2、截至目前支持查询的国家和仓库有:美国、英国、DEBR2仓。不支持查询的国家和仓库有:澳大利亚、加拿大、DEBR仓。{break}3、若系统未能成功查询到视频,请您直接联系客服/客户经理,我们将为您及时处理。',
  '9WJ3hf': '您目前存在未提交的增值服务[{serviceName}]，请点击“确认提交”后再提交预约信息。',
  'lV87ri': '功能描述：用户能够依据订单转电商平台仓或者第三方仓入库时的收件规则，在这里制定对应的装箱规则。比如，按照订单类型、订单履约场景、发货国家等业务特性，对即将出库的货物进行分箱和装箱操作。同时，还可以对装箱后的尺寸与重量加以限制。系统会依据用户所设定的规则，自动完成订单的分箱和装箱工作，从而满足电商平台仓或第三方仓的收件要求，有效提升货物在平台仓入库的合规程度。 {break}注：系统按照订单类型、订单履约场景、发货国家等业务特性未命中您配置的装箱规则时，仓库打包时默认按WINIT的装箱规则来校验是否符合发货标准',
  'oQEw+5': '智能推荐下单是指系统根据客户下单时买家地址、派送方式、海外仓库存等信息,基于配置的发货策略计算出最优发货方案(发货仓库和派送方式的组合)后,自动按照最优方案发货{break} 注： {break} - 如果订单为组套订单，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单来源为“平台同步”并且电商平台为“速卖通”或“TIkTok”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果客户下单时指定了批次商品，不支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单的订单履约场景为“FBA转仓-VC订单”或“FBA转仓-非VC订单”，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 如果订单包含不允许拆单的增值服务，支持推荐发货仓库和派送方式，不支持拆到多个仓库发货{break} - 预售订单无在库库存不支持推荐仓库和产品发货{break} - 当您在【仓组配置】里面选择了【校验地址】，在推荐的过程中会校验地址并且预估地址相关的附加费用；如果您未选择【校验地址】，推荐的过程中将不会校验地址，也不会预估地址相关的附加费用，推荐结果的准确性可能存在偏差。',
  'veHerq': '一、若货物不属于转仓场景请选择订单履约场景为“买家订单”；{break} 二、转仓货物若属于以下场景请选择对应订单履约场景：{break} 场景1、Amazon Seller Central账号补货至亚马逊仓库，请选择“FBA转仓-非VC订单”{break} 场景2、Amazon Vendor Central账号补货至亚马逊仓库，请选择”FBA转仓-VC订单“{break} 场景3、不需要更换商品标签且收货人非Amazon仓库，请选择“转第三方仓”。{break}',
  'FEfuAq': '默认产品',
  'H8hS8Q': '请配置具体的发货国家后再选择指定产品。',
  'MVIVPx': '页面下单默认产品',
  'PzFoST': '出库下单步骤"<span>3</span>产品信息"默认产品配置',
  'Q+xlLd': '指定产品',
  'U0xV2c': '订单履约场景即将更新，需要将您的增值服务文件全部清空。',
  'Vavxm/': '7.如果您需要上传多种订单履约场景的订单时，请先拆分订单后再上传。',
  'bCNs4z': '默认产品分类',
  'fbz9dH': '默认产品分组',
  'STmIBX': '是否妥投',
  'nxPf1g': '订单履约场景为FBA转仓-VC订单或FBA转仓-非VC订单时，为确保您的货物能够准确交付，请在预约时填写ARN信息，并要求供应商在提货时出示ARN。若供应商在提货时无法提供有效的提货码信息，仓库将无法完成交货。',
  'fczSMH': '近30天仓储费',
  'A3v8+M': '部分国家适用',
  'HYjlvY': '组套关系适用范围',
  'yn0Z1T': '全部国家适用',
  '+UQ2eB': '超出视频保存期限后无法在线下载视频，您若是需要长期保存视频需要下载到本地电脑端。',
  '2j7A41': '库内视频查询任务通知',
  'CkgJHS': '还剩 {seconds}秒',
  'LCaGPE': '无效时间',
  'PAXSjK': '视频保存时限(天)',
  'ewjsQ3': '还剩 {minutes}分 {seconds}秒',
  'nFv12a': '还剩 {hours}小时 {minutes}分 {seconds}秒',
  'nbY55F': '还剩 {days}天 {hours}小时 {minutes}分 {seconds}秒',
  'rLegUs': '还剩',
  'umzznh': '是否已完成视频查看/下载',
  'IoKeBc': '未完成视频查看/下载',
  'ZWDLuK': '客户在线查看/下载视频状态',
  'eyh8B0': '已完成视频查看/下载',
  'g0zndJ': '未完成',
  'mdXvfZ': '视频文件仅在有效保存期内开放下载，逾期将关闭下载权限。如需长期保存请在有效期内完成本地备份。',
  'uEOZtc': '本功能用于临时锁定销售库存，防止被其他订单占用。{break}锁定后，系统将冻结对应数量的库存；释放后，库存将恢复为可用状态。{break}请务必在释放后及时创建出库单，以避免该部分库存被其他订单分配。{break}<red>请注意：此操作仅冻结库存数量，不会指定或锁定仓库中的具体实物及库位。</red>',
  'DM3pHW': '视频处理SLA',
  'UM4UnF': '多个关键词需换行或用英文逗号隔开,最多支持{num}个,双击切换到单个查询',
  'j8igBS': '超出了 <remaining></remaining> 个商品条码',
  'lcAMwu': '还有可以输入 <remaining></remaining> 个商品条码',
  'ovsuH1': '最大支持输入{maxSku}个订单,多个订单用分号隔开或者换行输入',
  't2OPU9': '质检编码',
  '45lH3G': '最大支持输入{maxSku}个商品,多个商品用分号隔开或者换行输入',
  'pNyaJv': '视频处理目标完成时间',
  'Fxyurl': '如RT单号内有超过5个商品，建议填写商品条码,否则视频时间太长，导致拉流失败；最大支持输入{maxSku}个商品，多个商品用分号隔开或者换行输入。',
  '89V9jv': '<strong>说明：</strong>{break}1、当前视频功能暂仅支持查询*出库打包、退货质检"环节。{break}2、出库打包环节：截至目前支持查询的国家和仓库有:美国、英国、DEBR2仓。不支特查询的国家和仓库有:澳大利亚、加拿大、DEBR仓。{break}3、退货质检环节：截至目前支持查询的仓库有：USKY3仓、USKY5仓, {break}4、若系统未能成功查询到视频,请您直接联系客服/客户经理,我们将为您及时处理',
  '+jm37H': '请输入Rithum账号',
  '1rwX6s': 'Rithum账号',
  'ASwJRg': 'Client Secret',
  'FfoP3r': '请输入Client ID',
  'LZtUTs': '请输入Client Secret',
  'U5+MBC': 'Client ID',
  'Z6U+rH': '请输入备注信息',
  'pSlZth': 'Token有效期',
  'vDYlCJ': 'eBay订单号ID',
  'z5aOWE': 'Rithum商品ID',
  'L/pf+d': '拆单后系统无法上传跟踪号，需要手工上传跟踪号',
  'Bo7i+/': '创建视频下载任务',
  'CJkoZ/': '质检视频',
  'PVQZGn': '最终处理方式',
  'akHEml': '是否执行特殊打包还原',
  'apn9Xp': '整体照片',
  'OWchTO': '店铺年营业额',
  'S1M0+D': '德国(Germany) (EUR)',
  'lx500t': '国内(China) (RMB)',
  'TP2mcZ': '全球(Global) (USD)',
  '+P419K': '仓库编码信息',
  '+xf5LH': '1. WINIT版本：WINIT收集的仓库地址库。{break}2. 客户自定义版本：如果发现WINIT地址库不足或不正确，客户可以新增或修改为自定义版本，经WINIT核实后可变更为WINIT版本',
  '/VFVLw': '保险',
  '0xNKc0': '预约通知',
  '12KbCB': '仓库类型',
  '1RHbXm': '请填写正确的电话号码',
  '1n00Pf': '妥投前补充',
  '2wyrYZ': '全部不启用',
  '2xmNc6': '全部启用',
  '3/G8js': '提交方式',
  '5HuwKj': '查看仓库地址',
  '5WPh1K': '收货详细信息',
  '6DlX5w': '满足以下条件，则会按照以下预设的默认值选中增值，并预选服务要求{break}包裹类型增值：包裹内任一商品满足条件，则下单按默认设置预设增值服务。{break}托盘类增值：托盘内任一商品满足条件，则下单按默认设置预设增值服务。{break}订单类增值：订单内任意商品满足条件，则下单按默认设置预设增值服务',
  '6V8ZWK': '增值处理对象',
  '6fmxsV': '请务必在妥投前在[海外仓 > 出库 > 订单处理]页面补充文件，否则可能会妥投失败',
  '8NfVgn': '尾程派送必需资料',
  'FMruey': '修改为WINIT收集的地址',
  'FUE1Xh': '切换至WINIT版本',
  'FVnYDW': 'WINIT收集的仓库编码库',
  'HCqQh3': '签收',
  'IfNpby': '仓库地址维护操作指引',
  'JNA7rx': '是否确定关闭增值服务启用设置？关闭后默认所有增值均可使用。',
  'JpUbUj': '增值服务启用设置',
  'OTr06+': '前往第一步修改',
  'Pnu7pK': '仓库联系人信息',
  'QEvtRI': '客户自定义',
  'QVos5P': '请选择增值服务',
  'RK6igF': '第{number}份',
  'T4UDYW': '仅支持PDF格式',
  'UAGX0o': '请填写小于11位的数字',
  'UCi1ha': '增值默认值',
  'V9pblS': '仅支持字母（大小写）、数字、连字符(-)、下划线(_)',
  'VEeyMn': '新增仓库地址',
  'XwddT+': '仓库信息',
  'ZqGdmU': '请填写文件中条码对应的包裹标签号。',
  'ahJ0bo': '当前为WINIT收集的仓库地址信息，修改后将保存为客户定义版本，您后续将使用自定义版本，WINIT将核实您修改的内容，如果核实无误，则将您修改后的内容纳入到WINIT地址库。',
  'btwTap': '资料名称',
  'cGw/dK': '是否确定开启增值服务启用设置？开启后可针对不同的增值服务设置是否启用。',
  'eW0mE7': '物流单据号',
  'fFdCB/': '保留自定义版本',
  'hOuetV': '补资料状态',
  'k52nEU': '平台仓地址管理',
  'l+s9v9': '规则条件',
  'lAXhml': '直接提交必须上传文件',
  'lZc15H': '重要须知：平台仓库地址信息由WINIT收集提供，仅供参考。请您务必在下单前登录平台卖家后台核对官方地址，若有不符，请新增自定义地址。',
  'oQcYUf': '清关',
  'p1foSY': '请选择提交方式',
  'pSzJbd': '同一个增值服务，符合多条规则时，下单按照优先级最高的配置预选增值服务',
  'q+bzsZ': '请输入仓库编码',
  'qEa+3w': '适用订单履约场景',
  'qd0uEq': '选择',
  'qfegYk': '增值服务的默认设置',
  'qnV5+U': '查看操作指引',
  'qyWbSL': '填写公司名称后，【尾程派送必须资料】可能会发生变化，请核实后再提交订单。',
  'vRzyZ4': 'WINIT预设',
  'vpLMUD': '平台类型',
  'wU0X4a': '清空公司名称后，【尾程派送必须资料】可能会发生变化，请核实后再提交订单。',
  'x3DxSw': '要求',
  'xbgk/K': '仓库所在国家',
  'xvTd17': '无需修改继续提交',
  'yEdgdM': '提交方式：',
  'zHkAhj': '请务必在出库前在[海外仓 > 出库 > 订单处理]页面补充文件，否则仓库不会操作出库',
  'xYVdAi': '当同一增值服务同时命中多条规则时，下单时将按优先级最高的规则配置进行预选。',
  'KeVFuf': '我们为您提供了一项自定义偏好的增值服务设置功能，您可以根据自己的需求选择不同的增值服务内容进行设置。',
  '/zb/9N': '自定义增值启用设置',
  'gt+BYr': '自定义增值默认设置',
  'Iblz/N': '同时满足以下条件时执行规则',
  '/6D15a': '<strong>第一步 文件命名&打包</strong>{break}<s>将您需上传的文件命名后，压缩打包上传；也可直接选择文件上传。</s>{break}<a>注意: 文件名称不可重复。</a>',
  '1e+lfh': '单个文件上传',
  '2VaUeR': '共上传失败{count}个文件。请修改后重新上传~',
  '2sc1lw': '<strong>第二步 选择文件类型</strong>{break}<s>整理相同类型的文件进行一键上传。(如:FCC证书、FDA证书、MSDS)。</s>',
  'CMk7q2': '请输入文件类型',
  'DVfUAF': '<strong>第三步 上传压缩包/文件</strong>{break}<s>点击上传文件/压缩包 上传，并点击解析文件。（或者框选多份文件）</s>{break}<a>注意: 仅支持上传一个压缩包或多个文件，不可混合上传。</a>',
  'DatzNt': '压缩包仅支持上传一个',
  'G+kKIz': '文件大小请勿超过100MB',
  'GJD8OT': '仅支持上传一个压缩包或多文件，不可混合上传',
  'KKrGjP': '批量文件上传',
  'Oww89Y': '上传中',
  'R8Yt/D': '上传失败',
  'a8yr7M': '解析文件',
  'b5UHNR': '点击上传文件/压缩包',
  'ffS1Wg': '文件名称不可重复',
  'j20JY3': '多个文件上传，最多支持100个',
  'jESzgk': '共上传{total}个文件，其中上传成功{success}个文件，上传失败{fail}个文件。请修改后重新上传~',
  'jWpBuZ': '共上传成功{count}个文件。',
  'vH0KYs': '正在解析文件请等待~~',
  'hYiq/5': '已上传其他文件，不可再上传压缩包',
  'uHyP+I': '已上传压缩包，不可再上传其他文件',
  'Powhxj': '支持jpg, jpeg, png, pdf格式文件；如选择多个文件上传，最多支持100个{break}压缩包最大 100MB，压缩包支持.zip文件',
  'MLfjNu': '确认删除选中的文件吗？',
  'rsjPmA': '请选择要删除的文件',
  '/8l7B/': '申诉费用项',
  '0+AICR': '审核结果',
  '06gaSA': '发起订单费用申诉',
  '1ccOSo': '承运人',
  '4PD/Ca': '确认复测数据',
  '52epuj': '点击查看《2026万邑通标准海外仓入库禁限运清单》',
  '5uo0iz': '请上传尺重图片',
  '7eFbwy': '请先选择申诉单',
  '8k2AYo': '尺寸（长*宽*高（cm））',
  'AgNSLU': '处理信息',
  'AiPEqG': '目标更新时间',
  'B5G8Q/': '费用项币种',
  'BkrrAn': '申诉结果',
  'DqjMgY': '商品-宽',
  'L2f/fL': '<strong>说明：图片格式支持png、jpg、jpeg每个类型最多支持上传一张图片</strong>',
  'NgvUpD': '请输入大于0且最多2位小数的数字',
  'OvzMGf': '出口申报价值：指向出口国海关申报的货物交易价格。{break}该价格通常是货物在出口国出口时的实际销售价格。{break}举例：中国工厂出口一个商品，成本￥80，境内运费￥5，利润￥15，则该商品的出口申报价值=80+5+15=￥100',
  'PVQpzu': '批量提交草稿',
  'RzFgS0': '批量创建草稿',
  'UItCWS': '请确认或重新发起商品复测',
  'YVowea': '已提交供应商',
  'Zv76CL': '禁止入库商品',
  'avSJC2': '仅草稿状态操作',
  'dPvdln': '商品-重量',
  'eODzg7': '进口申报价值：指向进口国海关申报的货物完税价格。{break}该价格以货物的成交价格为基础，并应当包括货物运抵进口国起卸前的运输及相关费用、保险费。{break}举例：一个商品从中国运至美国，货物成交价：12.8USD，国际运费：1.5USD，保险费：0.2USD，则该商品的进口申报价值=12.8+1.5+0.2=14.5USD',
  'fgri9f': '申诉单号',
  'fr3ntC': '<strong>申述说明：</strong>{break} 1、当前订单费用申诉仅支持尾程附加费。；{break} 2、尺寸类附加费申诉-系统自动查询最近3个月内最新的商品复测信息,勾选确认是否使用该复测信息进行申诉(如不认可复测数据,请重新发起商品复测)<a1>发起商品复测</a1>；{break} 3、尺寸类附加费申诉-无可用库存商品进行复测情况下，需手动填商品真实尺重和上传对应图片，需手动填写时商品的尺寸+重量信息和尺重图片都必填；{break} 4、包装类附件费-需手动填商品真实尺重和上传对应图片，需手动填写时商品的尺寸+重量信息和尺重图片都必填；{break}',
  'hvBg88': '复测重量（kg）',
  'iLafuf': '申请单号',
  'ip5cx2': '您好，当前账号未签署《销售包装商品海外仓免责协议》，不允许销售包装直接出库，若需请前往<a>[个人中心-服务与合同]</a>中签署此协议。',
  'kOn88E': '商品-高',
  'mMV/jz': '复测重量（cm）',
  'mSN2yH': '没有查到订单号，请重新输入跟踪号！',
  'pnBgir': '尺重图片',
  'tx48V6': '商品-长',
  'u80eLf': '复测尺寸（长*宽*高（cm））',
  'weyGoU': '费用项金额',
  'wgyfWx': '流转记录',
  'xf0qAj': '批量提交草稿尺重类费用类型的申诉单将默认使用当前系统获取的复测数据，请确认当前的复测数据是否与您需要提交申诉的商品长宽高重一致',
  'zfds0r': '批量创建草稿文件',
  'zw7iku': '订单补收时间',
  'DEQRoM': '仅看',
  'yfYA0b': '不看',
  '7/ENeL': '库龄段内最大库龄',
  'BHZZaE': '数据分析模式为T+1,不支持查询当天数据',
  'Uh/9e9': '导出SKU每个仓库的库龄分析明细',
  'g+nQhV': '导出SKU国家级汇总的库龄分析明细',
  'l8Ee+W': '统计分析日期',
  '5/sVZa': '注意：打托及装箱结果为算法测算值，仓库实际打包情况可能存在差异，最终以实际打包结果为准。',
  '7IJ5BW': '展开全部',
  'MmLF/d': '当前配置的打托限制，支持下单时选择打托尺寸限制',
  'Pvsnbq': '收起全部',
  'f4xheU': '面单校验失败，订单已作废',
  'kJQBzE': '注：若所选 SKU 为 “箱产品”，禁止在表格中填写装箱信息，系统将依据该箱产品对应库存单元的标准箱件数进行出库',
  'lu8rjz': '装箱作业遵循<span>”箱产品/原箱“优先出库</span>原则。即货物入库时的原箱将作为出库时的首选方式；若无原箱，则按散件重新装箱出库。',
  'pTNeVB': '{break}请注意：允许多SKU混装，将按照装载率最优原则装箱。因此，每个箱子都可能装有多个SKU。',
  'xS397O': '限制类型',
  'EuX4xu': '通过以下装箱策略生成装箱方案后，包裹数量可能发生变化，系统已清除批量导入时上传的补贴包裹条码增值服务，请在确定装箱方案后重新选择补贴包裹条码增值服务并上传文件。',
  'GgxSpv': '下单偏好：打托策略及规则',
  'hetIOa': '系统已清除批量导入时选择的加包装方式，请在以下装箱策略中重新选择包装方式。',
  '+y6h2D': '密码必须为6-32位，且包含字母、数字或特殊字符中的至少两种',
  '5mxOVM': '<strong>温馨提示：</strong>修改密码不影响已经授权的第三方应用使用，为了您的资金和信息安全，如您已授权其他应用，成功变更密码后，请前往-个人中心-<a1>获取Token</a1>，进行Token更新。',
  'OKlhp/': '原密码',
  'TAdFnk': '确认新密码',
  'YcmSjW': '请输入新密码',
  'cBEBNV': '密码修改成功，请重新登录',
  'siMfC6': '请输入原密码',
  'H1lPwr': '密码格式错误',
  '0vQ+P7': '衡量货物到仓后（订单有到仓记录）在目标卸货日期内完成卸货扫描的比例',
  'DKVSAG': '衡量货物到仓后（订单有到仓记录）在目标上架日期内完成上架的比例',
  'MtH1Jn': '衡量货物卸货后（包裹有扫描记录）在目标上架日期内完成上架的比例',
  'Sasajn': '衡量货物卸货后（包裹有扫描记录）在目标时间内完成退货处理的比例',
  'mq0IED': '衡量在实际出库日期范围内，错发漏发订单占实际出库订单的比例',
  'nVDQvd': '衡量货物下单后（订单状态为：出库确认）在目标出库日期内完成出库的比例',
  'r1W38P': '衡量货物下单后（订单状态为：出库确认）在应完成暂存时间内完成暂存的比例',
  's4iMkY': '衡量货物下单后（订单状态为：出库确认）在目标出库时间内完成出库的比例',

  'w+Hm5T': '异常单[{eventNo}]已经提交过标准增值单[<a>{orderNo}</a>]且为草稿状态，请从草稿增值订单继续创建增值！',
  'WAZY5Z': '根据中国相关法律法规及监管要求，通过富友支付渠道进行的交易数据，可能会被同步至中国税务机关和中国外汇管理部门。请您理解并配合相关税务及外汇合规要求。',
  '9ybqTC': '主账户账单欠款100USD,子账户无欠款且有余额，在账单还款节点，会自动从子账户转入100USD到主账户用于账单还款。',
  'BfY6zk': '我已知悉并确认',
  'b6Ftgn': '若您的欠款账户主体无法充值，系统会在账单还款节点自动进行平账还款处理，若您不想平账还款，请在账单自动还款前使用欠款账户主体进行充值还款。',
  'c+6Mcc': '平账还款后，主账户账单欠款还清',
  's66VWi': '案例',
  'hEw5Zd': '账单欠款',
  'iJEe/7': '平账还款通知',
  'pHsWN7': '自动购汇优先级',
  'rJHovg': '进行还款操作，处理完毕后，账单预估待还金额将自动更新。不同账户之间会进行跨账户还款。',
  'olAL8z': '上传格式仅限于jpg, gif, png, jpeg, pdf, doc, xls, csv, docx, xlsx',
  'Jb9xrm': '若您不希望触发跨账户平账还款，请在账单自动还款前，使用对应欠款账户的主体完成充值并还款。',
  'P7F6p5': '即日起取消“担保还款”，启用“跨账户平账还款”，对同时存在余额与欠款的账户：会先进行内部购汇实还；实还后仍有余额，会自动用于归还其他欠款账户。',
  'mtnGvg': '跨账户平账还款通知',
  '8QYba6': '商品编码，双击切换到批量查询',
  'CTSFb2': 'LPN码退仓默认增值',
  'EmoOE5': '无增值服务～',
  'yvrcJY': '扫描LPN码',
  '3hr4e+': '亚马逊移除单LPN码退仓处理偏好',
  'kgwERZ': '<title>当您启用【亚马逊移除单LPN码退仓处理偏好】，WINIT将根据您维护的偏好规则自动下发增值服务，规则的优先级为：商品级偏好 > 客户级偏好</title>{break}<title>请注意：</title>{break}<span>只有实物上贴有LPN码的货物，WINIT才会执行增值处理并收取相应费用</span>{break}<span>实物上没有粘贴LPN码的货物将正常上架，不受影响</span>{break}<title>若您未启用该偏好设置，则所有货物将默认直接上架，不进行任何LPN码相关的增值处理。</title>',
  'kEZSHt': '请输入2~9999的正整数',
  'K/rVnU': '库存调整单拆箱商品逐件清点',
  '2PjyVY': '测量后重量(kg)',
  '3PU34C': '测量前长*宽*高(cm)',
  'DM58vT': '测量后长*宽*高(cm)',
  'LFF3YN': '商品尺重来源',
  'nOswfr': '测量前重量(kg)',
  'JIjYxo': '点击设置',
  'f+w9o7': '平台指定发货仓库',
  'W2Q4xC': '请先选择操作环节',
  'YetEPs': '是否提交索赔',
  'c3ZveH': '调查目的',
  'UWnDgh': '选择"是否提交索赔"时，需选择创建时间范围，且日期范围不能超过[31]天',

  '9Zelye': '请输入0~1区间的数字，最多保留两位小数',
  'MrxaHb': '固定值',
  'QKkbFX': '请输入误差范围',
  'QPW4nT': '误差范围',
  'UiYhnn': '误差范围类型',
  'WNgP0R': '仓库称重重量(kg)',
  'fLVutH': '入库包裹称重误差范围偏好',
  'qqtFhJ': '请输入0~10区间的数字，最多保留两位小数',
  'saDtih': '百分比',
  '5eqsQ4': '开启该偏好设置后，您可自定义入库包裹的称重误差范围。货物到仓后，系统将自动比对仓库实称重量与包裹验货重量；若差值超出您设置的误差范围，系统将自动登记该包裹为称重异常，您可提交增值服务申请处理该异常。',
  'VGwJX0': '备注：目前万邑通并非所有仓库均支持包裹流水线称重服务，具体支持该服务的仓库清单，您可联系客服咨询获取。',
  'TbsaPf': '批次库存重要提示：',
  'U7FwM7': '当前系统仅记录<strong>订单级的批次信息</strong>，未记录包裹与批次的对应关系。{break}若您执行拆单，原订单的批次信息将分摊至新订单中，<strong>因此新订单中记录的批次信息可能与实物批次不一致。</strong>{break}<strong>请注意：</strong>发生退货时，系统将按出库记录的批次回库，进而影响后续的库存批次准确性及效期管理。{break}<strong>请您确认：</strong>{break}<checkbox>我已充分知悉上述情况，并自行承担由此带来的库存管理风险。</checkbox>',
  '+h2y9F': '所选子订单[{shippingNos}]的容器类型包含托盘、包裹等多种类型,无法合并处理,请调整后重新提交',
  'ifPB9z': '按单号合并处理',
  '/fR/9R': '尺重类',
  '0w8AQY': '包裹尺寸（长*宽*高（cm））',
  'Az+wsj': '申诉费用类型',
  'IvBH95': '确定删除当前申诉单吗？',
  'ZXxh9p': '确定批量删除选中的申诉单吗？',
  'k/Fdcc': '包装类',
  'u7l5xi': '批量删除草稿',
  'wrq36m': '当前申诉单申诉要求已发生变化,将为你刷新申诉数据,请按最新申诉要求提交申诉。',
  'za91kF': '请选择要删除的申诉单',
  'h/44mD': '<strong>申述说明：</strong>{break} 1、当前订单费用申诉仅支持尾程附加费；{break} 2、尺重类附加费申诉，系统自动查询最近12个月内最新的商品复测信息，勾选确认是否使用该复测信息进行申诉(如不认可复测数据，请重新发起商品复测)<a1>发起商品复测</a1>；{break} 3、尺重类附加费申诉，当无可用库存商品进行复测或一个包裹包含多个商品的情况下，系统将自动查询出库时包裹的尺重信息进行申诉。{break}',

  '7jPRVd': '根据比例计算推送数为小数时将向下取整。请注意临界值的库存同步数量。',
  'Bg7ijV': 'FBM退货单报告每天更新{pullCount}次，仅更新{pullFrequency}天内报告。最新更新时间{pullDate}',
  'FHACGw': '{platform}平台每30分钟同步一次',
  'HdmoCU': '解决方案',
  'cDiSfJ': '平台退货单请求时间',
  's+52Wu': '当前数据获取时间{time}数据仅供预览，仅展示已完成匹配的万邑联商品和相应的平台商品',
  'sgfWtm': '目前仅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)、Tiktok、Amazon平台配置规则。其余平台将陆续开放，敬请期待!',
  'xJyOfr': '平台{platform}和eBay/TikTok/shopify/Amazon不能同时选择',
  '2C1sgV': '原商品条码',
  '2ksSH+': '包装材料',
  '3m+rLI': '备注不能超过1000个字符',
  '46Zfck': '下载模板',
  '56Mr7j': '请输入关键字',
  '7ZJI4v': '模板更新日期：{date}',
  '92t0OL': '增值分类',
  'D/L2ET': '国内仓增值服务(DWVS)',
  'D24vq6': '确定要取消这条增值服务申请吗？',
  'DjbRc6': '支持格式：{formats}，单个文件不超过{size}M',
  'FaA57c': 'W补单',
  'Hkp4HH': '线下配送供应商',
  'Jy1MK4': '诚信机制',
  'KWyyzx': '服务报价',
  'L+pJgC': '第三方编码(拍照)',
  'MTXmQC': '服务定义',
  'Mx0ZLV': '附件格式支持：jpg,jpeg,pdf,xlsx,xls,doc,docx,rar,zip',
  'NCJ4K3': '原M码',
  'NEW+As': 'WB包裹号',
  'OQxzDl': '补贴商品条码*补贴商品数量',
  'PaiOKY': '请上传增值服务附件',
  'Qlp7Vi': '实际完成日期',
  'Rkav/l': '线下配送单号',
  'SLfQbs': '服务类别',
  'TV87OQ': '文件格式限制为jpg,jpeg,pdf,doc,docx,xls,xlsx,zip,rar',
  'TvheV6': '文件格式限制为.xls,.xlsx',
  'VtfDWk': '修改预计完成时间从',
  'WyaP/1': '原M码-包装材料',
  'XwamxK': '原商品条码*原商品数量',
  'Zo/F1x': '增值服务附件',
  'ZujT6m': '您好，您海外仓账户可下单余额不足，请先充值再下单。',
  'biNaN+': '实际完成时间',
  'c88ldb': '文件大小请勿超过20M，请压缩后上传',
  'd2OCAd': '增值单',
  'd4gxj9': '原入库单号',
  'ezVhiW': '货币',
  'faVuvQ': '预计完成时间',
  'g2suWA': '实际托盘数量',
  'gEdTsX': '附件和备注至少填写一项',
  'hVrEDt': '仓库已处理',
  'hg+ipZ': 'FNSKU/第三方编码',
  'hroK4P': '受理状态',
  'ja6+IG': '压缩包不可超过20M',
  'kRVlNZ': '出库单-SKU-M码',
  'o4dmMm': 'M码数量',
  'oIfPYs': '下载增值服务模板',
  'pFR/sR': '<strong>申请范围（仅针对国内仓增值服务）：</strong>{break} 1. 揽收增值：指您的货物在WINIT提货环节需要WINIT安排人员搬运，针对此部分货物您需要增值操作；{break} 2. 收货增值：指您的货物自发物流到WINIT国内仓库时，需要在仓库的收货时间提供的超时收货增值服务操作；{break} 3. 退货增值：指您的货物已经到达WINIT国内仓库后您需要将货物退回，针对此部分货物您需要增值服务操作；{break} 4. 库内增值：指您的货物需要国内仓库提供标签更换（或清除），重量尺寸复核、商品拍照、销毁等增值服务操作；{break} <strong>温馨提醒：</strong>有最低收费的增值服务项，若"单价*计量总数"低于基础收费的，按基础收费收取。{break} 具体可受理的增值服务选项及更多的内容，您可以点击下载：<guideLink>国内仓增值服务说明</guideLink>查阅。{break} 若您需选择的增值服务项未在此范围内，请您及时联系在线客服确认。',
  'pf5GO+': '服务异常单号',
  'pzCFfS': '文件大小请勿超过{size}M，请压缩后上传',
  'rkRZDZ': '原包裹条码',
  'sJAZkX': '服务SLA',
  'vOShGA': '入库单-集装箱',
  'vRKqEJ': '服务单详情',
  'vlAfAg': '补贴包裹条码',
  'w39+Yw': 'M码-SKU-数量',
  'xAJEgV': '如有多个文件，请用压缩的形式上传，压缩包不可超过20M',
  'xw+LAO': 'M码-SKU',
  'Rt7R5q': '非标包材',
  '13hSB5': '登录子账户签署',
  '/Kjec2': '收件人州/省',
  '/gjvWG': '解绑成功',
  '/hIsI9': '计费Winit产品',
  '/swipJ': '发件人VAT',
  '07/CHe': '主联系人邮箱',
  '0LH9gq': '导入成功，预计{time}分钟后完成处理',
  '0yGDMb': '确认发货时间',
  '1nQ6Q0': '在途中',
  '4ez7K0': '订单信息不存在',
  '5cSTPo': '已签收',
  '5gwWsl': '请输入取消原因',
  '7PWaoz': '系统检查到已导入过该EXCEL文件，是否强制重复导入？',
  '7pSDDW': '原快递单号',
  '8hjdXb': '刷新token将会导致原有的token失效，请及时前往ERP、万邑链分销平台等第三方平台更新授权，否则影响正常的ERP下单等功能。',
  'BPpVvR': '下载失败数据',
  'C4NBzM': '导出任务已创建',
  'Ce7vZx': '导入失败数量',
  'Dmtj/G': '请选择可取消的订单',
  'Iq4nof': '获取中',
  'JNnt7j': '包裹条码地址',
  'KGUCkP': '导入记录',
  'KdAzze': '下单Winit产品',
  'LT+72I': '感谢使用万邑通开发者，为了给卖家提供更好得OpenAPI服务，万邑通已经在2019年3月升级了V2.0的授权模式，修复了V1.0授权模式的漏洞，数据安全性更高，V1.0的版本即将下线，请及时升级为V2.0',
  'Oi8z2o': '确认并刷新',
  'OqW32/': '退货包裹信息',
  'PSAuem': '最后一次请求时间 (created)',
  'PZl5gn': '修改人',
  'SFuc4p': '是否ReturnLabel',
  'SG9nY5': '注册手机号',
  'SMp/wI': '收件人地址2',
  'SqYZf7': '收件人地址1',
  'TI/7v4': 'Token刷新成功',
  'Ti/ykE': '下载DG文件',
  'Tq9B8M': '确认出库',
  'U/PBbo': '应用 (Platform)',
  'U12LPk': '供应商快递',
  'WArcN1': '<fw600>注意</fw600>: {break}1.如同一订单有多个包裹，则相同sellerOrderNo的多行包裹信息将被合并到一个订单中。{break}2.如同一包裹有多个商品，则相同parcelNo的多行商品信息将被合并到一个包裹中。{break}3.请上传已填写商品信息的XLS、XLSX格式模板。{break}4.文件大小上限10M，单次最大导入5万行数据，如文件过大，请拆分成多个文件上传，谢谢配合。{break}',
  'XgAe2+': '批量导出面单',
  'ZQQMPa': '投递失败',
  'aBZwNm': '共{total}个，成功{success}个，失败{failed}个，获取中{obtaining}个',
  'ab/bzw': '请选择已下单状态的订单',
  'b9hLXj': '当前Token',
  'bLeaYX': '点击下载《导入模板》',
  'blFOFv': '批量导出订单',
  'eiF6p5': '文件大小不能超过10M',
  'fWgRNR': '发件人EORI',
  'fha7dM': '请求账号 (app_key)',
  'hY87MC': '返回主订单信息',
  'jgn9zI': '取消信息',
  'kLKiKo': '手机号验证',
  'mnKvul': '失败列表',
  'pgJo0v': '最后一次调用时间',
  'q2ri9c': '单次最大导入5万行数据。{a}',
  'qNjqDv': '该账号暂无权限，请在主账号【个人中心-角色管理】中开通权限',
  'qnt35F': '取消结果',
  'r+H/+u': '申报英文名称',
  'sT8cX0': '导入成功数量',
  'se42so': '请先上传文件',
  'tYYS5g': '轨迹地址信息',
  'uH+8Ls': '验证码已发送',
  'uLKavV': '刷新Token',
  'xF3rQS': '修改内容',
  'xHrvKs': '批量确认出库',
  'yzVagq': '文件大小上限10M，单次最大导入5万行数据',
  'zG0cS1': '打印结果',
  'zcrIG3': '邮箱验证',
  '/bblSw': '*请填写针对该异常所提交的增值服务单流水号，如您还未提交增值服务请{break}<a>点击此处</a>跳转至增值服务页面提交增值服务后填写增值服务单号。',
  '/dO0Zh': '发票号，双击切换到批量查询',
  '6qp+Kh': '发票还在生成中，请稍后再下载',
  'Z6i0fj': '共{total}条记录',
  'eIUAml': '转入方VAT',
  'f5YTQ8': '发票{invoiceNo}还在生成中，请稍后再下载',
  't//uHV': '转出方VAT',
  'tWahWO': '请选择需要下载的发票',
  'v20n+9': '最多支持{num}个查询，当前{curlength}个查询',

  '7iY70N': '存在格式不正确的邮箱：{emails}',
  'WiV6jm': '请输入邮箱地址',
  'd9Uwtz': '最多支持输入10个邮箱',
  'daJRgP': '当申诉单状态发生变更时，将向以下邮箱发送通知：',
  'um8Poz': '邮箱设置',
  'x9rnrD': '请输入邮箱，支持输入多个邮箱，多个使用英文逗号分隔',
  '8KzClh': '<bold>温馨提示：</bold>{break}仅支持查看近一个月的日志记录',
  'T9ePA4': '下单失败原因',
  'sDKJow': '下单结果',
  '9i33Yv': '抽验后商品尺重信息',
  'ANUUVO': '该入库标签特征仅支持满足以下条件的SKU进行下单：{break}1、SKU的商品包裹类型=A+包裹/A包裹；{break}2、SKU出库是否采集包裹码=否；{break}3、SKU批次管理类型≠保质期管理/生产批次管理；',
  'c9QG6o': '抽验前商品尺重信息',
  'kaQdAy': '批量下载图片',
  'OCL2Hd': '抽验服务单',
  'rF6BoJ': '登记时间',
  'rWkOBK': '服务单状态',
  'x5w3KZ': '下载图片',
  'xgsqna': 'SKU尺重是否超过误差范围',
  'K/8VsZ': '无图片',
  '1v4cYx': '创建库存组织',
  'Xkr/pI': '<font>【100% A+/A包 无包裹条码入库】规则声明</font>{break} 为确保服务高效执行，请在创建入库单时严格遵守以下“一对一”规则：{break} <font>一、预约要求：</font>同一预约单内，单个SKU仅限对应一个入库单。请勿将单一SKU拆分至多个入库单 或 预约单；{break} <font>二、快递要求：</font>同一快递单号仅限对应一个入库单，入库单必须维护快递单号，否则到仓将无法识别。{break} <font>三、箱规要求：</font>同一预约单/入库单内，单个SKU仅限一种箱规。{break}{break} <font>👉 核心原则： 一SKU一单 / 一SKU一箱规 / 一快递单号一入库单号</font>',
  '6HyNip': '分摊后单个商品体积CBM',
  '8Bk/YO': '货物物理形态',
  '91i84+': '单件嵌套增量尺寸{unit}',
  'AES1eq': '单件嵌套增量尺寸',
  'AN/RCB': '自定义库存属性',
  'BN5b0w': '下单时指定分配',
  'KHtG0z': '文件不足需补充？<a>去上传></a>',
  'KynRtO': 'WINIT批次',
  'L4saUx': '库位体积',
  'Tc8oZC': '支持jpg, jpeg, png格式文件；如选择多个文件上传，最多支持100个{break}压缩包最大 100MB，压缩包支持.zip文件',
  'USpNz6': '嵌套示意图',
  'g5/oeV': '文件格式限制为jpg,jpeg,png,zip',
  'gqm/zX': '是否支持嵌套',
  'hWycP/': '嵌套方向',
  'r9C7Fo': '库位数量',
  'wkw7IC': '示意图类型:',
  'xFDeT3': '#吊牌商品',
  '6joCxB': '汽摩配商品',
  'GBjJpf': '轮胎',
  'enruIK': '一级特殊品类',
  'v3Rbes': '二级特殊品类',
  'CIpP+n': '单件占用体积 × 商品件数',
  'EFcehB': '单件商品的实际尺寸体积(长×宽×高)',
  'FVlbv8': '文件最多选择{maxCount}个',
  'L4WfIN': '单件占用体积',
  'RbUaBU': '单件商品体积 × 商品件数',
  'ZpfNBt': '计费总体积(CBM)',
  'ahWSuC': '单件商品体积',
  'fKRO0W': '若未达到最小计费体积，仅在最高库龄段按[SKU最小计费体积]，其他库龄段为0；{break}若达到最小计费体积，则等于占用总体积。',
  'hLf5JI': '商品总体积',
  'iVsoMZ': '1.普通存储：单件商品体积；{break}2.嵌套存储：该SKU同属性/批次的所有库存占用的库位体积/商品件数',
  'puDJsX': '占用总体积(CBM)',
  'wRZzeg': '嵌套商品单个商品体积分摊明细',
  '+zFuPB': '最多只能新增10条数据',
  '31gOZg': '确定生效?',
  '3aUs7u': '出库数量大于组织库存可用数量',
  '7LDk4s': '支持最多创建10个自定义库存属性',
  '8ShkGV': '是否启用自定义库存属性？',
  '8YT1ZR': '文件名（含后缀）过长，最大长度为128个字符',
  'GYK7aF': '自定义库存属性名称',
  'H7i3dw': '字符长度不超过20位',
  'NRcfui': '合计出库数量',
  'QC5nqj': '请输入批次号',
  'RKMg83': '批量修改自定义分类库存属性',
  'TpQ4Z2': '自定义分类库存属性',
  'Y0FWdh': '已上传{count}/{total}个文件',
  'YJckwc': '开关用于控制是否启用自定义库存分类功能，开启后可为商品设置不同属性值进行精细化库存管理。',
  'YQYqch': '没有模板文件',
  'knmGbF': '支持修改自定义分类库存属性的订单列表',
  'ksIiO+': '系统为每个自定义库存属性自动生成的唯一标识，格式为CIA+两位数字（如CIA01），用于区分不同属性值。',
  'rY/OTa': '自定义库存属性CODE',
  '8f3Q/+': '转出方和转入方不能相同',
  'JpSsbk': '请先上传商品信息',
  'K4c0o9': '请选择转入方',
  'h/Hllz': '请选择转出方',
  'zJnAnC': '文件中未解析到有效商品数据',
  'C0R9tL': '请<a>点击此处</a>下载箱单信息模板。',
  '3GPqgs': '结算账户ID',
  '3ddBdi': '渠道商主账户',
  '5uMoeS': '结算账户名称',
  '9tuJMY': '渠道商子账户',
  'Mb7YiT': '处理日志',
  '63a55U': '经营类型',
  'ICk0T+': '下载提货凭证',
  'ZUlm9o': '注意：为确保您的货物能够准确交付，请及时将提货码告知您的服务商，并要求其在提货时出示提货码。若服务商在提货时无法提供有效的提货码信息，仓库将无法完成交货。',
  'xzJES5': '审批通过',
  'Ln4xjm': '审批不通过',
  'Ud1aVE': '待交货',
  'sYItjX': '已提货',
  'RcmOHt': '提交补增值',
  'lgIr5X': '不加包装（原包装出库）',
  'yBUeMr': '订单发货凭证',
  '+6Oqq8': '多仓整柜调拨',
  '/1UKIF': '尾程总运费',
  '/8GfsH': '四',
  '/9tj9L': '导入文件名',
  '0M0TxV': '3)直发订单预约未到仓：直发订单预约后未按时到仓，即超出预约送仓日期当天',
  '0uRy1k': '一',
  '0uUXzW': '2.卸货完成后可提空柜，实际卸货时间请在列表中查看；',
  '1ACUbT': '①仓库有权拒收(特别为整柜货物)；',
  '1Azre4': '调拨',
  '1hHAA2': '预约协议',
  '1yOoPu': '预约单集装箱号修改为【{containerNo}】，将同步更新入库单的集装箱号，请确认是否修改？',
  '2658Fp': '最优仓配送单位成本',
  '2F+lpC': '最低保留数量-USWC Group',
  '2mkpp2': '4）直发订单取消预约违规：',
  '2yeWUE': '6、以上说明及定义若有变动，需以最新版价卡为准；',
  '3OEi4n': '{num}、AU仓库需Drop整柜到WINIT海外仓，卖家可在Drop2个工作日后提空柜!',
  '3Oulgi': '确认更新预约单？',
  '3ePWxW': '尾程总费用',
  '4NqD9g': '已成功',
  '4eiz1r': '当前订单数量',
  '5Jt3jD': '箱单导入',
  '5PPi66': '当前预约为增值预约，若已收取增值预约费用，<red>取消后将不会退还</red>，确认取消？',
  '7Byi8m': '预约体积',
  '7ONEE4': '请先选择柜型和卸货方式',
  '7byHbN': '不能超过100个字符',
  '7wqm1H': '灰色表示预约单超出可预约量，请选择其他时段，如无其他时段或所有时段均为灰色，请选择其他日期或者提交增值预约',
  '7zmjeC': '最晚调拨日期',
  '88ZQzP': '已为您生成草稿单，因库存数据在实时变化，请仔细检查后再提交',
  '8bSe2D': '单仓不调拨',
  '8bV7Eg': '如选择BC类包裹目的仓群，BC类包裹总重量总体积不能为0；如无BC类包裹，请勿选目的仓群',
  '8ygnMt': '计费重',
  '98snx+': '温馨提醒：若直发订单未在预约当天到仓，系统会自动取消预约，后续送仓需要重新预约，否则订单到仓后将按未预约送仓收取违规费用。若卖家需要送仓，但系统未触发自动取消预约，卖家可自行取消预约后重新预约。',
  '9R3rKz': '一键下单',
  'ATArx7': '所选订单的目的仓与当前订单列表的目的仓不一致，请重新选择',
  'Bbb+xm': '暂无文件可下载',
  'COPDHA': '集装箱号应为四位大写字母+7位数字，请检查后提交',
  'Cbiwqw': '单仓目的仓',
  'Cu164M': '提前DROP到仓时间指将柜子DROP到仓库的时间，不等于预约卸货时间。',
  'D+06qU': '海运整柜',
  'DC6Ho0': '2、如是整柜DROP卸货，请准确填写联系人、联系电话、邮箱等信息，仓库将按照联系人信息通知提回空柜。',
  'DNvJVy': '头程明细',
  'DOJH5Q': '始发地',
  'DUh2HX': '历史日均销量',
  'DYyX3T': '请输入托盘数量',
  'DrawKq': '2)直发订单提前送仓：直发订单已预约，但提前安排送仓（非预约送仓当天），即：送仓日期<预约日期',
  'DybI9o': '最晚下单日期',
  'E4piJY': '箱单导入成功',
  'EmwQQW': '预约说明：',
  'F28y5s': '确定取消该预约单吗？',
  'FkqZd5': '请根据实际情况填写关联单号(快递单号、提单号或其它能够识别订单的唯一单号)，如包裹条码无法识别时，可作为识别订单依据。如一但无法识别订单，以异常包裹进行处理，将会影响上架时效!',
  'FtgJ3c': '收货时间',
  'GUQlNv': '3、若卖家预约时选择的实际送仓方式与事实不符，视为未预约送仓；',
  'Go3Yk0': '总SKU数',
  'HTWUVn': '卖家预约后若预计无法按时送仓，在一定时间范围内取消可免费取消；超出免费取消时间范围将会收取取消预约违规费，具体免费取消时间范围及收费标准请查看最新版《万邑通异常与增值价卡说明》；',
  'HTa4JK': '目的地',
  'Ht7i9O': '头程单位成本',
  'IVF1Ki': '仓组',
  'IeNIkX': '仅支持xls/xlsx格式文件',
  'JH+HU8': '推荐发货方式',
  'Jg2/qY': '建议补货量',
  'KyfE2Y': '指定仓组',
  'M404r0': '二',
  'NU27nj': '调拨在途(KYN|TX)',
  'NuSd3i': '调拨在途',
  'OVc0wE': '没有数据',
  'Op4tNz': '箱单文件导入',
  'P+Va8u': '选择日期',
  'PoT6AG': '非最优仓发货SI数量',
  'PpB0X4': '总运费',
  'QvUtKi': '调拨总运费',
  'RL8oaG': '预约单创建成功',
  'RLjQNE': '预约重量',
  'S/Qx5D': '文件内容为空',
  'S7QkvX': '3.如预约送仓时间都为灰色不可选，请选择其他日期',
  'SWZEJI': '分仓比例',
  'T0HUpc': '当前预约单已过允许取消时间（当地时间预约送仓日期前 {advanceDateQty} 个工作日中午12点），如确认取消将收违规则取消预约费用（{currency}）：{amount}，确认取消预约？',
  'T7LV0R': '方案汇总(USD)',
  'TJCrq3': '可用库存(WC|KYN|TX)',
  'TuXHDV': '②若仓库安排收货，无法保证卸货时效，并将收取违规费用',
  'TybHeW': '提前DROP到仓时间',
  'U/IJT+': '请选择送仓时间',
  'UDZql1': '备货天数',
  'UZylhz': '审批备注',
  'Uf04rk': '2、直发订单发生以下异常，系统将会自动收取违规费用（费用标准详见万邑通异常与增值价卡说明）：',
  'VCv9iq': '多仓直发',
  'WYHxWn': '三',
  'XdU5ui': '可售天数',
  'XmyT7Q': '差价：不调拨预计尾程成本-调拨后预计尾程成本-调拨成本{break}{break}建议调拨数量：基于三仓历史30天日均销量和在库库存计算的理论调拨数量{break}{break}一键下单：系统自动筛选差价大于0的SKU数量生成草稿单{break}{break}导出：如调拨推荐需调整SKU数量较多，可导出文件，进行处理后在调拨单中导入下单',
  'Y3AngN': '审批结果',
  'YFPd5r': '订单总数量不能超过100',
  'Yz/BQg': '可预约(CBM)',
  'Z9ZnUG': '价差-USTX Group',
  'Za03Z3': '1.预计卸货时间请以预约后预约单管理列表中时间为准；',
  'aA+aj6': '预约时间',
  'bFBjSK': '五',
  'c/IOKb': 'SKU明细',
  'cg+X+P': '预约编码',
  'ckVhDS': '预约单修改失败，请重试',
  'dwuQx4': '预约送仓注意事项：',
  'e/+InV': '价差-USKYN Group',
  'eISfUy': '5、对于预约卸货方式为DROP的预约单，若未在预约送仓时间当天送仓，WINIT无法保证卸货时效，若货代产生压柜费/滞箱费等异常费用需卖家自行承担；若因卖家问题导致WINIT卸货产生额外费用，将有权向卖家补收。',
  'eLwCE1': '预计销量增幅',
  'eaPY96': '仍未到仓',
  'fEnr2e': '建议调拨数量-USTX Group',
  'g/+igE': '1、直发散货及直发整柜类订单必须在系统预约送仓，并按照预约时间将货物送达。',
  'g0mKuT': 'A/A+类包裹信息',
  'g2ziRJ': '非最优仓配送单位成本',
  'gyr3Is': '预约成功后，请下载打印POD并在送仓时使用此POD签收交接，否则仓库有权拒收货物。',
  'h++FGi': '申请期间',
  'h/vUnD': '请选择日期和送仓时间段',
  'hnqFVO': '物流供应商',
  'iR0js9': '预约包裹数',
  'j9Auje': '导出错误文件',
  'kWNgsD': 'VIP预约',
  'kgzI/H': '建议调拨数量-USKYN Group',
  'l1JdsU': '请输入正确的邮箱格式，多个邮箱用英文逗号隔开',
  'l2uDIN': 'BC类包裹信息',
  'lNPW6X': '1、请根据实际情况填写信息，如填写信息不符，仓库有权拒收!',
  'lcMHHh': '4、对于预约卸货方式为LIVE的预约单，若未在预约送仓时间前后2个小时内送达，WINIT无法保证卸货时效，若货代产生超时等待费等异常费用需卖家自行承担；若因卖家问题导致WINIT卸货产生额外费用，将有权向卖家补收。',
  'lrZQOk': '预约单修改成功',
  'mYTAaf': '确定取消该预约单审批吗？',
  'n1JFjW': '限制数量',
  'oSDHEp': '多个邮箱用英文逗号隔开',
  'oiMin5': '最优仓发货SI数量',
  'pqiPMV': '增值预约说明：',
  'quHuln': '说明：',
  'rCAxM4': '送仓时间',
  'rRDd1R': '单SI总成本',
  'sIeNFX': '需在系统取消原预约并安排重新预约；',
  'sOqgP2': '已失败',
  't2ENq8': '预计上架日期',
  't68ZGk': '适用国家/地区：US{break}{break}适用客户：头程发单独整柜，散货，空运，目标在多仓配置库存{break}{break}包裹类型限制：A或A+类包裹，BC只有一个默认仓库，不参与尾程计算{break}{break}尾程测算：只测算A与A+类包裹内SKU，只测算小于200lbs商品{break}{break}箱单总体积：小于75CBM{break}{break}SKU：需为已注册商品，SKU数量建议勿超过200，超过可能因为网络等原因导致测算失败{break}{break}分仓比例：导入箱单中可定义各SKU分仓比例，未指定的默认用主界面的分仓比例需为已注册商品{break}{break}发单仓不调拨：BC类包裹有输入信息时，只输出此目的仓群一个方案',
  'tT3dfa': '卸货方式为DROP时，WINIT将在卸货完成后发送信息给此邮箱，请填写准确。如有多个邮箱，请以英文逗号隔开，否则将接收不到邮件。',
  'tt6STd': '添加失败',
  'u4MnQs': '2、审批通过前取消预约不收取增值预约费用。',
  'uGhPgf': '请输入供应商名称',
  'uhVC9h': '所有内容仅保留30天，30天后自动清除',
  'urHj4j': '1、直发散货及直发整柜类订单必须在系统预约送仓，并按照预约时间将货物送达。若后续送仓时间有变更，需在系统取消原预约并安排重新预约；',
  'vdmRcs': '海运散货',
  'vx1jHW': '集装箱留夜',
  'w3HHEl': '预计断货日期',
  'wQ6Hav': '日均销量*30(WC|KYN|TX)',
  'wbWE3u': '计算',
  'xFqUvC': '确认创建预约单？',
  'yeCGlM': '六',
  'z+4Ml7': '头程总运费',
  'z/pOEL': '预约单创建失败，请重试',
  'zU0td4': '预计卸货日期：',
  'zaFQyH': '1、提交增值预约后需待审批通过才能安排送仓，审批结果将在1个工作日内通过邮件推送。',
  'zjDJEU': '单位成本',
  'zkbzRU': '1)直发订单未预约送仓：直发订单到仓后发现未预约（包含预约单到仓后发现有部分订单未预约）；',
  'zqtkWa': '导出SKU明细',
  '4VZtf3': '该订单对应SKU在仓库存在部分单品丢失，目前可出库商品已完成打包，{bold}。',
  '4WkUeY': 'step1 点击下方按钮，跳转至【创建增值单】页面；',
  '5SfEB4': '订单装箱策略为"智能推荐装箱"或"客户指定装箱"时选"是"，其余选"否"。',
  '98W2f1': '该订单的增值服务已完成操作。',
  '9E4t9T': '下单是否已上传包裹/托盘/订单增值文件',
  'A1iv06': '重新补贴增值文件',
  'C6dwoc': '同意缺量出库后，Winit将安排订单正常交货；{break}若为自提单，请尽快预约提货。',
  'D8RIAD': '以下增值服务仓库已经操作完成，如需{bold}，请在【全部订单】界面基于此订单，点击【创建增值单】提交补贴要求（增值服务：出库非标增值(特批)-出库其他服务需求）。',
  'Eg/Q5a': 'step2 在页面中选择增值服务：「出库非标增值（特批）-出库其他服务需求」',
  'KFLFxe': '是否指定装箱',
  'MSt+a0': '以下增值服务仓库还未操作，请您确认以下增值服务是否需要{bold}：',
  'Md16EN': '装箱尺寸、重量及件数已发生变更',
  'OsPvEX': '暂存并更换增值文件后出库',
  'PdsWYk': '如需更换增值文件：',
  'YgIHDj': '无需更换，直接缺量出库',
  'ZqmL/w': '取消出库',
  'bQShmQ': '下单是否已上传增值文件',
  'buMQVc': '下单时已上传包裹、托盘、订单增值文件中任意一种则选"是"，均未上传选"否"。缺货场景下，已上传文件的订单可能需要替换文件后再出库。',
  'mX6eqN': '您输入的{name}[{value}]非正整数，最小限制1，请修改',
  'oHD0Wg': '重新上传增值文件',
  'rjHMrk': '获取增值服务列表失败，请关闭后重试',
  'wKCm42': '请注意：每个订单仅限重提1次增值申请，请务必确认所有需求填写完整。',
  'yh4SUs': '更换文件出库',
  'yvtLPB': '确认无需更换增值文件，直接缺量出库？{break}同意缺量出库后，Winit将安排订单正常交货给供应商;如果为自提单，请尽快安排供应商提货。',
  'zbRNyc': '确认后，系统将取消您勾选的增值服务并自动跳转到【订单处理】界面，您可重新提交增值文件。',
  '+pUZ2c': '组合操作工时/h',
  '/Curu/': '下单的批次日期',
  '1mkIyt': '实际使用的包材规格',
  '47WapO': '拆分组号',
  '4QJCil': '组合前商品编码',
  '4uIuDS': '下单第三方单品码',
  '7ETl22': '拆分前商品规格',
  'A7tbkQ': '组合组号',
  'AetEIm': '单品贴标明细',
  'HHo9uh': '是否贴标',
  'IHXnmK': '组合后商品实物贴标条码',
  'JHSxnG': '实际使用的包材类型',
  'Jmx7kq': '下单的包装方式',
  'JzQZko': '下单的商品等级',
  'LYq20E': '下单的包材类型',
  'Oxy6mI': '拆分后商品实物贴标条码',
  'TGq3dm': '拆分操作工时/h',
  'U9So1E': '组合前库存单元标准件数',
  'VvO7WL': '下单的包材规格',
  'Vz/H86': '组合前商品规格',
  'WwOxr3': '组合后SKU类型',
  'aKVgRI': '拆分前SKU类型',
  'aZocHe': '拆分前库存单元标准件数',
  'c99Spy': '拆分后商品规格',
  'clwzFz': '组合前SKU类型',
  'fpeqzZ': '组合后库存单元标准件数',
  'h//zxe': '下单的批次号',
  'irKGZX': '拆分后库存单元标准件数',
  'kN9oyw': '检查不通过原因',
  'lIKAwH': '组合后商品编码',
  'o5X07X': '拆分后SKU类型',
  'r3mB6U': '组合后商品规格',
  't78c/q': '组合数量',
  'tLfxSA': '拆分前商品编码',
  'txTZkG': '原包破损销毁单品数',
  'wH3X/0': '拆分后商品编码',
  'x1v1yl': '增值完成数量',
  'w6c28E': '实际调整数量',
  'CeNCTb': '退货增值服务',
  'Mig4cI': '请输入增值服务名称',
  'eCNlUz': '请输入{minValue}-{maxValue}的整数',

  '+KlP6R': '<strong>第三步 上传压缩包/图片</strong>{break}<s>上传图片/压缩包上传</s>{break}<s>(可框选上传多张图片)</s>',
  '0z1mV/': '实际上架商品策略',
  'A36OtU': '【SKU】格式:',
  'B6a4K7': '上传成功，共上传{count}张图片。',
  'Btwv+5': '组-类名称,检查项目,检查结果判断标准,图片序号1-5',
  'Cv6Pdx': '多个文件上传，最多支持{maxLength}个',
  'Dvqe17': '文件大小请勿超过{maxSize}MB',
  'F6s36W': '部分上传失败，共上传{total}张图片，其中{fail}个上传失败。请重新上传~',
  'HPQemJ': '点击上传图片/压缩包',
  'OgEnZT': '【组-类】格式:',
  'Q7U7AT': '<strong>第二步 压缩文件</strong>{break}<s>(此步非必需)</s>{break}<s>上传图片过多，可先压缩打包</s>',
  'YHV5T1': '图装品类-针织衫,销售{break}包装是否缺失破损脏污,{break}合格,1',
  'aSkMEx': '商品编码,检查项目,检查结果判断标准,图片序号1-5',
  'gofBHI': '重命名规则:',
  'hmpnRF': '上传失败，共上传失败{count}张图片',
  'par2Tu': '举例:"服装品类-针织衫,销售包装是否缺失破损脏污,合格,1"',
  'rn2+vO': '文件格式限制为{fileType}',
  'sbQMLh': '<strong>第一步 重新命名</strong>{break}<s>将您的图片重新命名</s>{break}<s>(命名规则查看下方)</s>',
  'xtFAYC': '举例:"SKU001,销售包装是否缺失破损脏污,不合格,1"',
  'PA/154': '批量上传图片',
  'P6fguC': '图片名称',
  'moeTsb': '压缩包最大 {length}MB{break}每个【组-类】【SKU】最少上传1张，最多支持上传{singleMaxLength}张图片{break}若超过5张，系统会自动覆盖原数据。{break}压缩包支持{archiveExtensions}文件{break}图片格式支持{imageExtensions}',
  '+/C3V3': '仅允许英文、数字、字符，最大支持120个字符',
  '+OaqN3': '最少支持上传1张，最多支持上传{maxCount}张模板图片！',
  '2xxt0V': '【SKU】格式:商品编码,图片序号 注：如有规格,在商品编码后使用英文逗号,隔开',
  '7ZIju2': '每个商品均有其固定的尺码。请在 <适用SKU级> 界面中，以文本形式为每个商品填写对应的尺码。仅支持英文字母与数字（例如：S、M、L、XL、36、38、40）',
  'IgfTgz': '实际档贴商品编码*数量',
  'QLPDSp': `仅英文字母（a-z, A-Z）、数字（0-9）、常用英文标点（,.;:!?-/()'"）、空格、换行`,
  'U66mh1': '已补充信息',
  'VaMwVh': 'SKU0012,1.png',
  'YFQOtu': '举例:"SKU0012,1.png、SKU0012,2.png、SKU0015,黑色,1.png"',
  'de6utO': '请输入内容',
  'mXgCKO': '批量上传文本',
  'tBHcCS': '请选择商品编码',
  'tkQZxH': '下单档贴商品编码*数量',
  'zLJ4n4': '最大支持120个字符',
  '0XIMDJ': '前往已创建草稿',
  'Ah/Oag': '下载失败文件',
  'oBtpWm': '待确认查件',
  'JqcS0L': '销毁处理',
  'YG6DZz': '确认后，所选订单将全部执行{bold}，货物将不再保留。请确认是否继续？',
  '6xeDr7': '组内没有未读消息',
  'E0bHrY': '加载更多',
  'VHkWk8': '没有更多数据',
  'b/4MR8': '消息状态',
  'g8yytK': '已读',
  'jG/Vu6': '点击收起',
  'jWoM3f': '请选择一条消息查看详情',
  'mao1Hs': '点击展开',
  'xM8iPW': '点击将组内所有消息标记为已读',
  'gyBhng': '不支持选择线上渠道。此处默认的付款渠道仅供参考，实际付款时可选用系统上的任一渠道',
  'jyt5cs': '以下第三方包裹条码在系统中已存在，是否确认重复入库？',
  'H+XwXJ': '请输入数字、字母、减号、下划线或空格,并且长度不少于5且不超过128个字符',
  'tQOkKV': '请输入第三方包裹条码',
  'FIIG+B': '未查到包材商品，请确认是否已维护包材信息',
  '2dN1oP': '6位数字验证码',
  '4poD2P': '上次登录成功时间',
  '64rf6L': '为您的账号提供额外的安全保护。开启后，使用邮箱+密码登录时，除密码之外还需要输入手机短信验证码才能完成登录，有效防止密码泄露导致的账号被盗风险。',
  '9vgnTW': '第二步 绑定新手机号',
  'A9J8qN': '第一步 验证当前手机号',
  'BAaueF': '确认接收验证码手机号',
  'Bo4W0X': '发送失败',
  'FVhoeo': '手机短信验证（短信验证码将发送至您的手机）',
  'GSz70z': '继续登录',
  'GbVzjW': '开启双因子认证需要绑定手机号，用于接收登录验证码。',
  'HIxnWR': '新手机号：',
  'Kq3A21': '手机号：',
  'OF47vj': '请输入新手机号',
  'QlcAF5': '更换成功',
  'Slgi07': '登录是否开启双因子认证',
  'Tmwttq': '验证码错误或已过期',
  'V5+7Vd': '开启双因子认证',
  'a4eQd6': '验证手机号',
  'es2f2w': '验证码：',
  'fvqSaK': '当前手机号:',
  'gr6+Ku': '为确认您的身份，我们将在登录时向该手机号发送验证码，请确保该手机号能接收到验证码。',
  'ilbOZH': '验证码格式不正确',
  'pg2Zrh': '手机号格式不正确',
  'v58se4': '验证方式',
  'wsIzRQ': '登录验证',
  'y2hVhr': '请输入6位验证码',
  'uP7/F/': '新手机号不能与当前手机号相同',
  '5t3OvC': 'WINIT出库Return Label服务专用模版',
  'KP0qqu': 'WINIT出库非Return Label服务专用模版',
  'SUYlwz': '如果是WINIT出库退货',
  'Theats': '<a>点击此处下载《WINIT出库非Return Label服务专用模版》</a>',
  'Vy1821': '<a>点击此处下载《非WINIT出库Return Label服务专用模板》</a>',
  'lQbHaU': '<a>点击此处下载《非WINIT出库非Return Label服务专用模版》</a>',
  'ol18mf': '是否整包销毁',
  'rGuBTT': '<a>点击此处下载《WINIT出库Return Label服务专用模版》</a>',
  'xzJJFB': '如果是非WINIT出库退货',
  'SZZFJv': '请选择商品 {sku} 的自定义分类库存属性',
  'pvfzZN': '撤回失败',
  'zcFTzN': '是否确认撤回该 SKU 的注册申请？撤回后将退回并终止审核流程，需重新提交注册。',
  '+kNGFj': '新增产品小组时，自动赋予小组优先级（按创建顺序递增：1, 2, 3...）',
  '1yvLHE': '自动优先级规则',
  '6BKlvh': '{names}已经重复，请修改后再确认',
  '9ETVMH': '+ 新增产品小组',
  '9uzVsM': '删除后优先级自动重新编号',
  'Fxj6Zh': '新增产品小组',
  'HsTxdY': '在小组内新增产品时，自动赋予产品优先级（按添加顺序递增：1, 2, 3...）',
  'J74Zh0': '产品小组名称不能重复',
  'NLXhrj': '产品{productName}在产品组{groupName}中已存在',
  'Ptuq5B': '产品小组下需要存在产品',
  'SywXus': '产品组[{productGroupName}]下[{subGroupName}]产品[{productNames}]',
  'bBSqB/': '小组优先级',
  'hm6rEG': '删除小组',
  'nOONQR': '产品小组数量已达上限（最多{count}个）',
  'rbekyj': '请添加产品小组',
  'uywlC0': '产品小组中PSC不能重复',
  'wMLc2I': '拖拽产品小组前方的 ≡ 图标可调整小组优先级顺序，拖拽产品行的 ≡ 图标可调整产品优先级顺序',
  'wf3UDG': '请输入小组名称',
  '+FtfyI': '由客户注册的评估维度计算',
  '+P5szr': '长(CM)',
  '1avWrI': '折叠难度等级',
  '58J0vS': '评估维度对比',
  '8jnsLg': '折叠视频',
  'AP8nQh': '仓库评定值',
  'AqLCD4': '仓库判定客户折叠方案无法执行或不合理',
  'HJhYOM': '仓库评定等级：',
  'HaA4wY': '沿用客户值',
  'JjujPU': '客户注册等级：',
  'LKH8GC': '仓库实测值',
  'LWVCnq': '折叠后重量：',
  'Lf3sAC': '折叠后宽：',
  'MaY1Uy': '客户注册值',
  'Mmgunh': '查看视频链接',
  'NBlfTe': '增值服务尚未完成，仓库暂未提交复核结果',
  'Oxv4Sq': '增值明细 - 测量商品折叠尺重',
  'PcZu3h': '仓库复核结果',
  'RKqZlb': '折叠后长：',
  'SJWwn3': '客户折叠视频',
  'UgdEZ1': '仓库尚未提交复核结果',
  'XOQHXR': '由仓库评定的评估维度计算',
  'Xa8cFE': '待仓库复核',
  'b8Ge4E': '仓库尚未上传',
  'd+Hky2': '宽(CM)',
  'dQ3Yo3': '折叠后高：',
  'eoI1f5': '增值服务完成后，仓库将在此处回传实测尺寸重量、评估维度评分及折叠视频',
  'fH56ZI': '仓库折叠视频',
  'fabLLN': '折叠尺寸重量对比',
  'jwtadX': '评估维度',
  'k+30OI': '高(CM)',
  'kBhsM3': '仓库确认客户折叠方案可执行，实测数据已回传',
  'mvIkQl': '复核通过',
  'qVDx5J': '查看复核结果',
  'qvU5DC': '复核不通过',
  'wenYEM': '客户注册折叠信息',
  'e6oBFj': '{codeName} ({score}分)',
  'yV8cJU': '暂无图片内容',
  'fLvjrT': '最多展示5张图片，点击可放大查看',
  'ZL8ECg': '暂无视频内容',
  '+IywH2': '折叠方案名称',
  '+iKIxg': '请选择折叠方案',
  '/wxs/V': '开启本功能，即视为您已充分知悉、理解并自愿接受上述风险。',
  '0CytZx': '商品中文名',
  '22uhgj': '折叠方案信息',
  '26iWHp': '启用「折叠尺寸」功能后，您可在系统中维护商品的折叠尺寸及方案。仓库作业人员将依据您填报的方案，对商品进行折叠并打包发货。',
  '3G/Y6u': '折叠分数(提交值/仓库核实)',
  '3OnTSz': '仓库复核值',
  '3SDs3M': '暂时放弃折叠方案',
  '3ejdft': '新增折叠方案',
  '4ONBYD': '新增折叠商品',
  '6xYThs': '实测计费与补收风险：',
  '7ElLD6': '难度等级',
  '7NhkOW': '请上传折叠示意图',
  '7Ryszk': '小批量测试：',
  '820Rmu': '启用后，支持对商品配置折叠方案并按折叠尺寸出库',
  '8NtNJD': '不规则折叠（无固定步骤）',
  '8QU2kq': '高敏商品慎用：',
  '8dIERc': '方案信息加载中，请稍后',
  '9d5w4X': '原始尺寸(长/宽/高 CM)',
  '9iksrZ': '折叠后尺寸(长/宽/高 CM)',
  '9mx6Dl': '以下为系统根据商品自动判定项',
  'AUtGtv': '折叠动作',
  'AZTDDu': '分',
  'Afjr+M': '当前评分合计：',
  'AgoDYU': '为帮助您优化商品包装、合理降低物流成本，万邑通系统已上线「折叠尺寸」维护功能。为确保仓配履约顺畅，避免售后争议，请在启用该功能前，仔细阅读并充分理解以下内容：',
  'B6JAav': '定期核对"预报"与"实测"尺寸的差异，及时调整系统内的商品基础信息，以免因频繁的"费用补收"影响您的店铺利润核算。',
  'CSJ4/m': '加工前件型',
  'D+EPnl': '规则折叠',
  'D8z0sL': '确保指引清晰：',
  'DOC2nO': '我已知晓并同意',
  'DmSDbT': '四、使用建议',
  'DpZzWb': '折叠评分维度（参考）',
  'DyKYSz': '操作示意',
  'EPC9wx': '折叠方案配置',
  'Er4hMs': '填报错误与异常风险：',
  'FOyYsM': '折叠操作视频',
  'FQQECq': '必填',
  'GTvlQu': '难度等级规则',
  'GgrAXu': '根据上述评分规则计算折叠总分后，将按照下述规则匹配难度等级，出库时将按难度等级收取折叠费用：',
  'HYu/QZ': '折叠总分',
  'Hn8jHg': '评分规则',
  'INyG/e': '(点击查看评分维度详情)',
  'Id5C6a': '三、免责声明',
  'IdCX/r': '折叠分数',
  'JLXsRX': '请选择折叠动作',
  'JzEEKa': '折叠商品',
  'KP+O+b': '复核状态',
  'KdctYQ': '请务必上传清晰、无歧义的折叠图示和视频，并确保尺寸数据真实准确，避免因信息偏差造成额外的仓库处理费或运费差异。',
  'Kwl+8x': '不通过原因：',
  'L/r4E4': '商品英文名',
  'L/tGo1': '方案名称/编码',
  'L29CXA': '请选择折叠方式',
  'M70WBZ': '已添加',
  'MKrIC1': '复核失败',
  'Mhah4V': '不规则折叠',
  'NBni3Y': '确认删除该折叠方案？',
  'NcPOg3': '▶ 折叠评分维度',
  'Nj3dpI': '无关联',
  'Nucwe1': '复核失败时，商品已禁止出库，重新关联折叠方案审核通过后商品将自动解除禁售并按新的折叠方案出库',
  'NvkaqN': '复核状态：',
  'Ou64NO': '方案复核与阻断风险：',
  'Q2kiiZ': '添加步骤',
  'QHoyk4': '仓库严格按系统方案执行。因折叠方案设置错误、信息不全、配图/视频指引有歧义导致的打包异常或损失，由卖家自行承担。',
  'QQh0pA': '关联商品数',
  'QTyqRQ': '第{num}步',
  'ScDs/p': '一、功能说明',
  'T7btJ9': '折叠前尺寸',
  'ThdQMz': '折叠后尺寸(提交值/仓库核实)',
  'ThoN94': '请输入方案名称',
  'TmWFp3': '折叠方案',
  'UKBPDX': '重新关联折叠方案',
  'V8aw7Z': '仓库复核反馈',
  'WTxcRs': '条码',
  'WVOOTv': '多人协同性',
  'Wg/mIe': '请选择处理方式：',
  'XkkLpf': '客户提交值',
  'Xv84Oh': '该商品已添加',
  'XzYyze': '确认成功',
  'YaADOB': '复核失败后，商品将禁止出库，需要客户处理。',
  'YbNnek': '复核失败时，商品已禁止出库，重新关联折叠方案审核通过后商品将自动解除禁售并按新的折叠方案出库。',
  'YxeAt2': '打分规则与具体释义',
  'ZMUCpZ': '折叠评分维度',
  'ZRGMvK': '支持批量查询，多个用逗号或换行分隔，最多支持500个',
  'b0hYiw': '商品外观与售后风险：',
  'bZuFX3': '仓库会对方案进行人工复核。若复核不通过（如方案无法实现、难度过高），商品将无法正常出库。卖家需及时取消折叠或更新方案，因停滞导致的发货延误由卖家自行承担。',
  'fO7Wn9': '折叠商品信息',
  'fxWATB': '第{num}步：{action}',
  'h1MojX': '建议首次使用时，先选取少量商品进行打样测试，确认实际折叠效果及包裹尺寸符合预期后，再批量复制推广。',
  'h5uE2n': '折叠可能导致商品产生折痕、褶皱，影响展陈效果或买家开箱体验。由此引发的客户投诉、退换货及售后争议，由卖家自行承担。',
  'hI0fuz': '仓库操作视频',
  'k4qjyi': '方案编码',
  'kSqUPs': '复核失败确认状态',
  'kfqn3k': '是否有关联商品',
  'lw/rgu': '折叠方式',
  'mbqow5': '对比项',
  'miLi7a': '最多256个字符',
  'n9qGGl': '去确认',
  'nec8ps': '关注账单波动：',
  'oZ5jEg': '折叠难度',
  'p2Ual4': '复核失败时，商品已禁止出库，暂时放弃折叠方案后商品自动解除禁售，可按未折叠出库',
  'pFnTni': '尺寸(长×宽×高)',
  'pN5HUe': '已关联方案',
  'q086bg': '去确认 >',
  'qj1Wl+': '请上传折叠操作视频',
  'qlGCOp': '折叠步骤',
  'qrzyEa': '折叠示意图',
  'qtod5Z': '商品编码/条码',
  'rBP3eh': '二、风险提示',
  'rNAPzj': '折叠后尺寸(CM)',
  's+52fT': '评估要素',
  'sbQ3JR': '对于高价值、易损、易皱或对展陈外观有严格要求的商品，请务必谨慎评估是否使用该功能。',
  'srAxbu': '复核失败确认',
  'tY2lx1': '启用出库折叠',
  'tYbn5d': '难度等级(提交值/仓库核实)',
  'tbLVjd': '卖家预报的折叠尺寸仅供参考。商品实际打包时的库内操作、尾程运费及渠道匹配，均以仓库最终实测数据为准。若预报与实测不符，万邑通将依据实测数据自动补收差额费用（追溯计费），并可能引发渠道匹配受阻或时效延误。',
  'uItXZV': '确认关闭启用折叠尺寸吗？',
  'uyRBQ9': '请选择处理方式',
  'vNTqpX': '图片预览',
  'wMGqy7': '请先选择折叠方案',
  'xQ0lpl': '复核失败时，商品已禁止出库，暂时放弃折叠方案后商品自动解除禁售，可按未折叠出库。',
  'xYnPVU': '确认删除该折叠商品？',
  'xdZhq5': '折叠评分对比（提交值 vs 仓库复核值）',
  'xj42AN': '风险告知书',
  'xonsuo': '衡量内容（判定标准）',
  'yIlbSY': '有关联',
  'ypUR3X': '折叠尺寸功能风险告知书',
  'yylzFW': '因使用「折叠尺寸」功能而产生的商品形变、消费者投诉、退款退货、费用补收、出库拦截等各类售后与经济争议，万邑通均不承担相关赔偿或法律责任。',
  'zlj40+': '不规则折叠无固定的折叠步骤，请在折叠示意视频中做清晰示范。',
  '8kMV7u': '<red>请上传折叠示意图，需包含：初始平铺状态、折叠中间状态、折叠完成状态；如有特殊处理步骤（如翻转、固定等）请标识并做说明。最多上传5张图片，限制为5M以内的jpg、gif、bmp、png格式。</red>',
  'OnzNXC': '折叠示意图示例',
  '4yZdWb': '极低风险',
  '6OVHj9': '常规操作',
  '7DSPGR': '1个动作',
  '8Bdau9': '高度依赖',
  '8YgDYw': '必须使用耗材',
  'Anmv5v': 'T3（中等加工）',
  'AwQkTs': '高阻力',
  'DyKz+/': '复核中',
  'FWYyCD': '3个动作',
  'HX9vPx': '长边3折',
  'IsB4B1': 'T1（简单）',
  'K6aW2A': '已复核',
  'PKTs4u': '需精确对齐或角度控制',
  'QbZDtu': '低阻力',
  'R2lFCJ': '无需额外加固',
  'SUrk8j': '待校验',
  'SpyA8i': '已确认',
  'eLh34B': '复杂判断',
  'fi3/Ij': '4个动作及以上',
  'ia6jWE': 'T2（轻加工）',
  'qNMv8B': '中阻力',
  'r8CLmb': '短边对折',
  'rbO1Zc': '较高风险',
  'vD5jGb': 'T4（复杂加工）',
  'vyHj86': '长边对折',
  'w6/mi5': 'T5（定制加工）',
  'xV9GAM': '待复核',
  'y5TSsz': '2个动作',
  'zZ7K/0': '无要求',

  '+ckE5q': '自定义规则 - 点击跳转编辑页',
  '+he445': '限制高',
  '/BT6LH': '每个国家设置一条默认托盘，当您下单时（API下单/万邑联下单）系统将按【订单履约场景】+【发货国家】+【订单类型】自动选中您预设的默认托盘，无需重复手动选择，让下单更高效便捷~',
  '/QiwF7': '开启后可自定义各包裹类型的尺寸和重量限制，关闭则使用WINIT预设标准值',
  '0/05jB': '超托最大长*宽(cm)',
  '18txdT': '自定义的装箱规则仅允许A+包裹，仓库只会打包成A+包裹，如果需要调整，请前往<a>偏好设置 > 出库装箱打托规则 > 修改装箱规则</a>',
  '1XIOoQ': '自定义打托尺寸限制',
  '2ki+EH': '偏好设置>出库装箱打托规则>修改装箱规则',
  '2onNlK': '允许超托时，超托限长和超托限宽不能同时为空',
  '3LoS6X': '您在装箱限制中【允许出库的包裹类型】只选择了A+包，后续下单会按照您维护的偏好单箱单件出库，请再次确认是否不允许出库其余包裹类型',
  '57A25u': '请先选择一个标准等级后，再点击查看说明。',
  '6BP2WV': '您选择的发货国家【{names}】未配置默认的托盘限制，请配置后再提交。',
  '6MCtrP': '最大限长*宽*高(cm)',
  '6QlKYT': '在此配置的打托规格，可供您在下单环节自主勾选；若未勾选，系统将自动应用下方设置的默认托盘。{break}<b>⚠️请注意：托盘限高与限重均包含托盘自身高度与重量。</b>',
  '6RxoC7': '若您选择了指定的WINIT包材规格，仓库将依照您指定的包材进行装箱打包。仅在尾箱商品数量不足，无法充分利用包材空间时，为提升装载率，仓库将更换尺寸更加匹配的包材完成装箱。',
  '6rfgyr': '添加自定义托盘规格',
  '7E9ZuP': '为了提供更流畅的操作体验，当前页面于2026年5月23日进行更新。将原有的包裹规则和托盘规则合并管理，并优化了操作流程。',
  '8qklB4': '是否允许大件超托',
  '8rBHI7': '基于当前订单的订单履约场景，仅允许A+包裹，仓库只会打包成A+包裹，如果需要调整，请前往<a>偏好设置 > 出库装箱打托规则 > 新增自定义装箱规则</a>',
  '94r+du': '历史版本 {versionNo}',
  'ABy1Q9': '自定义装箱限制',
  'C90sDl': '仅本单使用',
  'Co5I9q': '托盘最大限宽超出最大限制{maxNum}，请修改。',
  'FFF/0W': '当以托盘形态出库时，应用以下限制',
  'G2DazA': '请选择托盘规格',
  'G7aUQb': '直接输入单个商品的装箱信息。适合一次添加少量商品时使用，最多支持添加10种商品，如果超过5个箱子（非原箱/箱产品），请点右侧按模板进行上传。',
  'GPpRyd': '<a>查看标准说明</a>',
  'GrtwPH': '历史版本',
  'I0AabQ': '需自定义打托尺寸限制？',
  'IDZF+u': '沿用"包裹形态出库"时的限制',
  'InsjbD': '<b>装箱打托规则：</b>{break}WINIT已预设默认装箱打托规则，如未满足您的需求，您可自定义规则。需注意：相同【订单履约场景】+【发货国家】+【订单类型】仅支持维护一条自定义规则。{break}<b>规则优先级说明：</b>{break}1.自定义规则 > WINIT预设规则{break}2.订单履约场景层级越小，优先级越高{break}例如：订单履约场景：平台仓 → FBA → VC，则规则优先级为：VC > FBA > 平台仓',
  'Kd6DFN': '允许',
  'Mo8VZW': '包裹类型说明：{break}A+包：每箱一种SKU且一件单品{break}A包：每箱一种SKU且多件单品{break}B/C包：每箱多种SKU且多件单品',
  'NrsSFS': '选择B/C包时会自动勾选A+包和A包；选择A包时会自动勾选A+包',
  'O/6b4k': '偏好设置 > 出库装箱打托规则 > 新增自定义装箱规则',
  'OpRKUu': '托盘最大限高超出最大限制{x}，请修改。',
  'PIpde6': '当以包裹形态出库时，应用以下限制',
  'PYNsHB': '托盘最大限长超出最大限制{maxNum}，请修改。',
  'PgWP74': '偏好设置 > 出库装箱打托规则 > 修改装箱规则',
  'Pt6pX8': '下单偏好',
  'Qaco0J': '不指定则由仓库按需加包装',
  'R+YG8D': '最大值{max}',
  'R0uumR': '确认提交',
  'Rxpxbs': '请填写0~9999.999999之间的数',
  'SyZfMJ': '不启用',
  'T2mjhs': '托盘规格',
  'Tz1rLW': '未填写',
  'UAXlTL': '指定WINIT包材规格',
  'VDPfzE': '当前显示为WINIT预设限制值，若不符合您的业务需求，您可自定义修改。若未修改，则系统将默认以原规则执行。如果WINIT预设发生变化，则会自动应用最新的WINIT预设规则。',
  'XSG5MB': '<b>一、通过万邑联下单：</b>{break}当装箱/打托策略配置为"智能推荐装箱/打托"或"仓库自主装箱/打托"时，订单页面将默认按照该偏好对应的策略与规则执行装箱、打托操作。{break}当装箱/打托策略配置为"客户指定装箱/打托"时，订单页面将默认采用该装箱策略，您可上传指定的装箱/打托清单，完成自定义装箱、打托。{break}您也可在下单时，根据实际业务需求随时调整上述设置。{break}<b>二、通过 API 下单：</b>{break}当装箱/打托策略配置为"智能推荐装箱/打托"或"仓库自主装箱/打托"时，系统将按照预设置的策略与规则完成装箱、打托。{break}当装箱/打托策略配置为"客户指定装箱/打托"时，因当前暂不支持上传指定装箱/打托清单，即便勾选该选项，系统仍将按"仓库自主装箱/打托"策略执行。',
  'XbMhDq': '允许出库的包裹类型',
  'Y4+DI1': '如您选择允许超托，当单件货物的长宽尺寸已超出标准托盘规格时，将按照超托限长、超托限宽来进行打托作业。{break}<b>注：高度和重量限制默认与前面不超托的配置一致。</b>',
  'ZxcjWC': '大件超托的最大限长*宽',
  'c7Gr0e': '托盘最大限高超出最大限制{maxNum}，请修改。',
  'dJ6P4F': '请填写数字且不超过9999.999999',
  'e0f36U': '范围0~9999.99',
  'eE00S5': '装箱规则名称：',
  'f1Ytxn': '您在托盘限制中【允许出库的包裹类型】只选择了A+包，后续下单会按照您维护的偏好单箱单件出库，请再次确认是否不允许出库其余包裹类型',
  'f8UFNh': '<font>包裹类型说明：</font> <span>A+包：每箱一种SKU且一件单品</span> <span>A包：每箱一种SKU且多件单品</span> <span>B/C包：每箱多种SKU且多件单品</span> {break} <font>尺寸输入规则：</font>长=最长边, 宽=次长边, 高=最短边',
  'fJrZna': '查看出库装箱/打托规则',
  'fN+ZcF': '装箱/打托策略及规则',
  'gouM9H': '编辑出库装箱/打托规则',
  'hISg6v': '是否要将本次自定义的打托尺寸限制保存为偏好？',
  'hrWiy/': '个人中心-服务设置-偏好设置-出库-出库装箱打托规则',
  'ihxtB1': '您当前未配置自定义装箱打托规则。如需将本次设置的打托尺寸限制保存为偏好，可前往【{link}】进行添加。',
  'ip8dK4': '装箱限制：',
  'jeA4XC': '最大限重(kg)',
  'lCZcaY': '该【订单履约场景】+【发货国家】+【订单类型】存在托盘出库的场景，需要维护打托偏好及限制规则',
  'lR42Sf': '加入偏好，下次自动应用',
  'leTgXY': '偏好设置>出库装箱打托规则>新增自定义装箱规则',
  'pBIVP3': '装箱限制将重置为WINIT预设限制值，是否确定不再使用自定义装箱限制？',
  'poOH7Q': '新增出库装箱/打托规则',
  'qFuqIi': '未完成自定义设置',
  'r2IQV+': '已完成自定义设置',
  's/HYTy': '基于当前选择的订单履约场景、发货国家、订单类型无法查询到WINIT预设的限制规则，请选择自定义装箱限制。',
  'srr4QC': '确认删除该规则？',
  'tJodAf': '请先选择"发货国家"',
  'terT9Z': '限宽',
  'uD2fw9': '规则来源',
  'uOHtrA': '是否存在托盘出库',
  'uvDeZu': '装箱规则允许的包裹类型：',
  'vk9qd9': '知道了，仅本单使用',
  'wqv8fJ': '请填写大于0的数',
  'x0loNq': '最大限制体积(m³)',
  'xiXj0t': '限长',
  'y/d6hW': '打托规格配置',
  'y9MLne': '已填写',
  'y9e5pn': '当前平台收货仓默认的限制高度',
  'yWAEoF': '当前自定义规则超出WINIT预设标准，是否确认保存？',
  'z59dN9': '为避免异常情况，每种包裹类型都需要提前设置尺重限制。',
  'vS3JrY': '适用发货国家/是否下单默认规格',
  '0UEzyc': '请按顺序完成上方学习以解锁',
  '3mtqbh': '当前学习进度',
  '4YmEll': '继续上次学习，',
  '7yA19M': '跳过后该模块学习进度将标记为100%，所有步骤自动解锁。',
  '8D5vlV': '⚠️风险提示',
  'I+852a': '链接已复制',
  'LeROQa': '全部跳过，我已知悉',
  'Ow/wZi': '服务未开通',
  'PnBZCt': '新手指南',
  'U2JLej': '确认跳过',
  'YDxecj': '未开始',
  'ZDsp2U': '请先完成"卖家入驻和系统配置"中的资料提交和服务开通，才能使用该功能。',
  'aIrpM5': '已复制',
  'gsHKqP': '确定，继续跳过',
  'ji6SmL': '继续学习',
  'rLcwmd': '整体学习进度',
  'sRgYwK': '跳过学习后，您将无法获得系统操作指引，可能影响后续业务操作。确认跳过吗？',
  'hzXNb6': '抱歉～暂无该页面操作权限',
  'sg0SbV': '请先在 个人中心-资料管理 页面提交资料开通服务，等待人工审核通过后即可开通操作权限哦～',
  'zg8dMt': '去提交资料',
  '+Y+qJW': '文档（帮助文档）',
  't8lGeH': '去操作（跳转页面）',
  'vFgsNr': '视频（教程视频）',
  'JmcooD': '如果ERP推单并且需要同步Tracking NO，则需要在「平台同步 > 商品匹配 > Shopify」中维护商品匹配关系。如果不维护，针对一个订单多个跟踪号，系统则只能上传一个跟踪号到Shopify平台。',
  'SuJ6Y+': '系统将根据商品尺寸，从您在库的该类型客制包材中自动匹配最合适的包材。若无法匹配，将按您选择的方式处理。',
  // 入库覆盖标签偏好设置
  '0HOUTr': '调整优先级',
  '0m+JH1': '标签覆盖组合',
  '1gYyVg': '请选择清除标签类型',
  '55ug9C': '调整后，该规则的匹配优先级将降低。',
  '9f5hRc': '客户自提供覆盖标签',
  'BQcLxf': '下移',
  'F6idOC': '自定义标签需要上传清除标签示例图',
  'FppcdS': '选中「自定义标签」后需上传示例图，供仓库操作人员识别并清除对应标签',
  'G67RcH': '覆盖的标签类型',
  'HDuLWx': 'WINIT标签-白标',
  'HV9qgw': '请选择覆盖标签尺寸规格',
  'IE37Ac': '（优先级最高）',
  'IJwvjn': '开启后，入库下单时系统将根据下方规则自动下发覆盖标签增值服务',
  'JhV03g': 'WINIT标签-带图文',
  'Kx4mtI': '一、匹配条件（满足条件时自动下发）',
  'Ljnhpd': '客户自提供覆盖标签需要上传覆盖标签图片',
  'Pv4ATk': '选中「客户自提供覆盖标签」后需上传客户提供的标签图片',
  'QJ59zq': '规则按优先级从高到低匹配，命中第一条规则后停止匹配，不再继续往下。可通过上下箭头调整规则优先级。',
  'RV2TpZ': '入库覆盖标签偏好设置',
  'SRXhGA': '偏好规则列表',
  'STYRVg': '（优先级最低）',
  'TEs+AV': '覆盖',
  'UMXIBV': '上传覆盖标签',
  'UR1C+p': '暂无规则，请点击上方按钮新增',
  'W/U9cW': '编辑偏好规则',
  'W3RezG': '自定义标签',
  'WWNMkw': '调整成功',
  'X84aIR': '请选择覆盖标签类型',
  'ZGXiJi': '尺寸规格：',
  'b7Hn2j': '覆盖标签图片：',
  'c6qxc5': '上传示例图（支持多份）',
  'cOY61P': '清除',
  'eNSBG6': '查看覆盖标签示例图',
  'eTJFGJ': '二、标签覆盖组合（自动下发的增值内容）',
  'hXMo+d': '匹配条件',
  'izhn6M': '清除标签示例图：',
  'kybTOB': '覆盖标签示例图',
  'lucwJt': '查看清除标签示例图',
  'oiPE7z': '新增偏好规则',
  'rHpLZ7': '调整后，该规则将优先于其他规则被匹配。',
  'srr4QC': '确认删除该规则？',
  't/oV+c': '清除标签示例图',
  'w40Ttp': '清除的标签类型',
  'wCBYZz': '启用覆盖标签偏好',
  'wOHHSJ': '上移',
  'z8wlxI': '确认将 规则 {priority} {direction}至 优先级 {target}？',
  'Y7aSxo': '仅支持 jpg、png、pdf 格式文件',
  'rl5zz3': '文件大小不能超过{maxSize}M!',
  'HNW17u': '存在上传失败的文件，请删除后重新上传',
  'LSLKRz': '文件正在上传中，请稍后再试',
  'ZnXkoX': '请配置至少一条匹配条件',
  'ftLnx1': '清除标签',
  'jiKPgo': '覆盖标签',
  'fKvnkn': '暂无示例图',
  '+FDO1E': '入驻联系人邮箱',
  '/XxWUC': '自有海外仓直接填写自有海外仓，如没有，填写“无”',
  '/q5fD8': '是否在英国/东南亚本地有海外仓',
  '01n1lw': '该品牌是否已在德国当地拥有R标',
  '0sn8j/': '请填写姓名',
  '1wOLiI': '做独立站意向',
  '2cyTCk': '已提交(需等待 {day1} 个工作日) ——> 初筛通过已同步提交给平台(需等待 {day2} 个工作日) ——> 平台通过',
  '2towDA': '美国站近一年销售额(USD)',
  '387HdI': '是否有自建海外仓或第三方海外仓',
  '49iOzF': '企业/品牌类型',
  '4L3xFT': '公司规模（员工数量）',
  '5grmob': '请填写邮箱',
  '5rJPKe': '希望开通ManoMano的国家站点',
  '6C4ze5': '主要产品类目',
  '6jglbI': '品牌商标注册地',
  '6nYN2s': '请选择是否有自建海外仓或第三方海外仓',
  '6udigR': '公司性质',
  '7V8auA': '单品牌全渠道近一年的销售额(USD)',
  '7gK7Rj': '在经营中的店铺最近一季度平均月销售额(USD)',
  '7wp+GP': '其它电商平台单站点单账号近一年的销售额(USD)',
  '85GJe2': '账号负责人电话',
  '8xAjhV': '卖家联系人信息',
  '9aEF/T': '店铺货源',
  '9bKiBE': '请务必确保邮箱可以接收邮件，发放注册链接',
  'A3JVko': '营业执照公司名称',
  'AyGOuG': '亚马逊德国、eBay德国、Kaufland 或其他平台店铺/独立站后台截图',
  'B4jhFM': '账号注册用邮箱',
  'BZ219V': '请填写中文名称',
  'BgUDFC': '入驻状态',
  'D6nMUK': '主营类目',
  'DU8pzO': '请填写公司法定名称',
  'DcPRut': '请填写您常用的QQ号',
  'DhEqZS': '您的微信号',
  'E92Gy6': '新增链接',
  'EL4b8j': '请填写其它北美电商平台的“店铺”链接',
  'EPp062': '德国公司名',
  'Ems0C9': '如有，请填写海外仓服务商名',
  'EoXCE9': '业务模式',
  'F+ij7Y': '是否已办理该德国公司的VAT',
  'FPYNcH': '请填写1到11位数字',
  'GzrOsm': '申请的二级类目',
  'H26cpN': '20字以上，150字以内',
  'Hh+8lr': '填写您目前主营产品类目',
  'IcnW+V': '其它北美电商平台的“店铺”链接',
  'InYzo7': '您计划是做英国市场还是东南亚市场',
  'Iv0cZc': '法人国籍',
  'JonMgV': 'SKU数量',
  'JzufF9': '您常用的QQ号',
  'KIfH+Q': '请填写20到150位任意字符',
  'KQOzSw': '电子邮箱',
  'KqTHNC': '库内截图',
  'L4jOeD': '填写主营的具体二级类目',
  'LxjC12': 'QQ号',
  'MdKKAC': '其它电商平台的店铺链接',
  'NG02nv': '公司所在区域',
  'NuSU2V': '中文填写',
  'Nwgq9f': '是否拥有德国当地海外仓',
  'OOfHj5': '法人姓名',
  'Ot/X5z': '入驻联系人信息',
  'P6ktCt': '填写中文名',
  'P8S+b1': '是否有德语客服人员',
  'R4mfIu': '例如，亚马逊店铺/速卖通店铺/天猫/京东/独立站优先，或其他',
  'SNeIpX': '亚马逊欧洲站, Allegro, Fnac/darty 等等',
  'U3/OiC': '其它欧洲电商平台店铺链接',
  'Uo35I9': '点击视频链接打开视频（只有已申请查询并获取视频的单据有库内视频信息，超期文件无法打开',
  'VFVI+w': '填写具体金额',
  'VwT6Ym': '请填写金额',
  'WIRiiO': '主营产品（具体二级类目）',
  'WXHb1+': '请务必保持电话畅通，将作为后续主要联络方式',
  'X+Zymb': '公司简介或者罗列出公司的优势',
  'XEsuFF': '请填写主营产品',
  'XXh7Kw': '营业执照中文名称',
  'XwN70f': '请填写亚马逊德国, eBay德国, Kaufland,或者其他平台店铺/独立站链接',
  'Y0L01Z': '正在运营的欧美跨境电商平台链接',
  'YI7fqG': '第三方平台链接',
  'Z1d1dA': '入驻品牌名',
  'ZcMSoa': '请填写营业执照公司名称',
  'aIq9ik': '其它（eBay、Amazon）北美电商平台单站点单账号近一年的销售额(USD)',
  'aidSjp': '点击截图链接下载文件（只有已申请查询并获取视频的单据有库内截图信息，超期文件无法打开）',
  'bN8SdN': '企业/品牌简介',
  'bNQ47y': '重新编辑',
  'bilPnX': '公司主营产品',
  'c9DIEs': '填写英文或汉语拼音 例：中- Zhang San or 英- Rachel Green',
  'crZAUj': '申请人QQ号',
  'csAYl3': '电子产品类目必须填写是否有Weee',
  'd+drZB': '如果有 请填写 将有机会对接引流项目',
  'fqBdzm': '公司法定名称',
  'gGYhmd': '账号负责人姓名',
  'gKaGa2': '填写美国站销售平台（是否有亚马逊/沃尔玛/独立站）',
  'gP+ldf': '入驻联系人姓名',
  'gVUjRH': '请务必确保电话畅通',
  'gqZa18': '中国公司办地址',
  'hC7WeL': '企业/品牌官网',
  'i2HQKK': '入驻联系人电话',
  'i8orsr': '销售额',
  'iTutLd': '您拥有的品牌名称',
  'jJeioA': '法人',
  'k0TWda': '正在使用的独立站平台',
  'kUTW+Q': '申请人电话',
  'l+0j0U': '以上电商平台过去30天销售额',
  'lC0TIO': '请填写具体金额',
  'lCo8xA': '请填写1到20位数字',
  'm8yqtX': '请填写微信号',
  'mkiqo/': '中国公司名',
  'nVPQ6u': 'Shopify独立站网址',
  'oFGnIc': '中国公司的营业执照{break}德国公司的营业执照{break}法人手持护照和身份证的拍照件{break}德国当地海外仓的发货证明{break}德语客服人员的德语证书',
  'pKBw1k': '{platform} 入驻申请',
  'pb7ufS': '账号负责人邮箱',
  'pe5tUK': '美国站销售平台',
  'pnPqSu': '公司全名',
  'q9+Dhh': '请填写注册邮箱',
  'qDJlru': '客单价 (USD)',
  'qDga7W': '您距离入驻成功需要等多久：',
  'qjVIUB': '海外仓服务商名称',
  's7Ufrr': '是否有直播/短视频运营经验',
  'u1sMF4': '请提供证件并打包发送',
  'u6/UxW': '请提供以下证件并打包发送',
  'udZJ3q': '只填数字，不需要货币符号',
  'uqYkNh': '如没有操作过其他平台 填“否”，如有请填写具体金额',
  'v725h2': '请填写电话',
  'v8b14F': '请填写联系人姓名',
  'vc/KMI': '立即入驻',
  'w+7yLR': '跨境电商近一年销售额(USD)',
  'w6hWi5': '账号负责人微信',
  'x6NFpn': '客户单价 (USD)',
  'xToKvz': 'TikTok账号名称（没有请填无）',
  'yMUv2D': '请填写1到60位任意字符',
  'q1fRx5': '亚马逊德国，eBay德国，Kaufland等店铺的后台销售截图',
  '+7V2pl': '共',
  '/1JAw2': '英文品名',
  '8970ZG': 'Winit计费产品',
  '9SA/lA': '出库信息',
  'GZcPC1': '返回主信息',
  'QkwbXX': '(*以下时间取操作地点当地时区)',
  'fD8+70': '条记录',
  'fGrEYv': '收件人Email',
  'yF/N68': '验证码校验失败',
  '3/Oz1Q': '订单：【{orderIds}】为平台面单发货，不允许合单',
  '4HJ+hu': '不同步库存',
  '6M9rWS': '查看未发货订单',
  'Boxv3o': '平台仓库id',
  'Bpo42k': '万邑通仓库',
  'Cp9jJx': '请输入1~100的正整数',
  'D+aqEf': '请输入0~1000000的正整数',
  'Fx2qpm': 'Tiktok平台数据授权与免责协议',
  'Hd8vWP': '仓库库存数量 X',
  'JXyArZ': '仓库匹配',
  'PAK8Nq': '阅读并同意',
  'PaIEXA': '同步仓库实际库存',
  'RI3DFS': '确认签署',
  'SQfl8g': '《TikTok平台面单免责协议》',
  'V7Hm5N': '安全库存设置',
  'VKrL6o': '物流成本最优',
  'ZFAL2b': 'Tiktok平台面单出库的订单，不使用选择的发货方式，以平台提供的发货方式为准。',
  'bGcjx4': '库存同步数量',
  'cZA4KD': '同步固定值',
  'gBPBiQ': '目前仅支持 eBay、eBay eF、Temu、AliExpress、Shopify、Shein、Amazon(MSF)、Tiktok平台配置规则。其余平台将陆续开放，敬请期待!',
  'ie/swL': '确定重试吗？',
  'kMFVJj': '物流时效最优',
  'pR5Kts': '重试',
  'qUjxg7': '平台面单物流服务',
  'qvnXLa': '平台面单类型订单和普通订单不允许批量发货',
  'rbvotq': '当库存推送数小于等于',
  'sZjg8x': '订单产品不一致，不允许批量操作',
  'uLJq8F': '临界库存同步',
  '9xi3Ju': '使用',
  'EtZQBV': '规则按优先级从高到低匹配，命中第一条规则后停止匹配，不再继续往下。可通过拖拽调整规则优先级。',
  'bNYcA1': '不包含',
  // ========== UserCenter / SubCompany 简体中文 ==========
  '+9DG38': '合同变更联系人',
  '+CApE9': '30万人民币/每月~100万人民币/每月',
  '+Hoc+l': '商业登记证示例',
  '+cIuZr': '联系传真',
  '+yzo5G': '合同及协议编码',
  '/29Euc': '3月',
  '/7kcrm': '身份证号码格式不正确（15-18位字母数字）',
  '/BNN7i': '服务及合同',
  '/CE92s': '账户信息(账号已开通，可正常使用)',
  '/StN3o': '请输入营业执照号',
  '/cT1pT': '香港身份证号码',
  '/v6znS': '街道/镇',
  '0/NBwM': '您的变更资料已提交，{countdown} 秒后自动跳转...',
  '00Dl+I': '请选择客户类型',
  '0XhRJ5': '501-1000人',
  '0hlEvZ': '付款人中文名',
  '0o9tL0': '10月',
  '0v065z': '海外客户',
  '0vqd6C': '付款人类型',
  '13TWwp': '开通中',
  '1ku3tW': '法人代表',
  '1ucY54': '验证账户使用者身份证扫描件',
  '1vy0rP': '子账户注册',
  '24fCGT': '待再次审核',
  '2IUda7': '电商属性',
  '2RFenw': '营业执照扫描件',
  '2TsfbW': '邀请子账户',
  '2klgKR': '个人',
  '2qGweW': '澳门身份证号码',
  '32l3EA': '被邀请信息',
  '36Utyl': '区号',
  '3Mzomi': '支持 jpg, png, jpeg, pdf，大小小于5M',
  '3Qa+El': '查看样例',
  '3Uobx0': '申请人护照号',
  '3XFSkD': '确认拒绝邀请？',
  '3rV78M': '文件上传支持格式 jpg, png, gif, jpeg, bmp, 文件大小小于5M。证件照片需清晰、完整、无反光。',
  '3vyvYW': '身份证号码',
  '472GLl': '法人身份证号码',
  '4dF7v6': '快速添加子账户',
  '4femBB': '关系证明文件',
  '5ZMEGU': '已通过',
  '5d/2Vz': '仓库所在地',
  '5teFfD': '邀请方公司名称',
  '658jXb': '价卡群体',
  '69FfwB': '（下列主体将是你使用万邑联平台各项服务与功能的唯一法律主体与缔约主体）',
  '6CESlO': '请选择证件类型',
  '6HPRD5': '《协议签署确认函》',
  '6YaQo+': '证件号码已存在',
  '6bNLQY': '清关代理协议',
  '6byXVU': '商业登记证号',
  '6cqEcl': '个人地址',
  '6fZv9O': '700万人民币/每月~3000万人民币/每月',
  '7AMsUx': '文件上传支持格式jpg，jpeg，png，pdf，文件大小小于5M。',
  '7ThyFd': '香港身份证扫描件',
  '7XpSSu': '驾驶证/其他证件号码',
  '7fcykz': '地址证明文件',
  '7s6ur5': 'OCR识别失败，请手动输入',
  '7spWbI': '中国香港/台湾/澳门客户',
  '8H2OHK': '中国香港客户',
  '8IjGQX': '样本',
  '8P/G1N': '护照/当地身份证',
  '8bJTvq': '确认撤回邀请？',
  '8l5TcI': '澳门身份证',
  '8ugzNj': '文件上传支持格式 jpg, png, gif, jpeg, bmp，文件大小小于5M',
  '9A3C2h': '子账户与主账户的关系',
  '9FtIgY': '驾驶证或其他证件号码',
  '9HIsg3': '公司注册证书',
  '9cdIhE': '1月',
  '9h+nqk': '11-50人',
  '9p3Tkx': '最多60个字符',
  '9wzk8E': '起始日期',
  'A2THfo': '认证材料已提交，审核通过后将自动开通额度服务。',
  'ADhUgT': '客户基本信息',
  'AH8FM1': '客户名称已存在',
  'APEnMa': '电商平台月均总营业额（万元人民币）',
  'AQe5/5': '公司名称需与充值主体名称一致',
  'AhUzIA': '请输入护照号码',
  'B3w1/1': '重新签署',
  'BMABZJ': '法人身份证/护照、营业执照',
  'BOfsuX': '子账户信息',
  'BOox40': '子账户ID',
  'BZAJ5w': '法人身份证有效期',
  'BfMW6T': '请输入申请人姓名',
  'BjsAw0': '上传（最多{max}张）',
  'BuE30c': '区县',
  'BxgAk/': '不允许变更客户名称',
  'C94f9k': '经营品类',
  'CMtdKT': '2. 认证信息',
  'Cc5pXc': '新主体的清关代理协议',
  'CeSENy': '是否与账户主体一致',
  'D3sd4t': '变更资料',
  'D9AaM/': '其他信息',
  'DB77Ln': '请阅读并确认',
  'DKkkv9': '香港身份证',
  'DOP2hn': '长期',
  'DXcpHk': '无效的变更类型参数',
  'DYXVSj': '海外仓国家',
  'EoVLzL': '示例(HK)',
  'EpFNtd': '成交第一要因',
  'EpVYM2': '海外仓《供应链管理协议》和《海外仓商业性条款补充协议》',
  'EwUCWH': '不允许的文件格式，支持 jpg, jpeg, png, pdf',
  'F3QGoQ': '签约时间',
  'FOGW3w': '是否使用除eBay外的电商平台',
  'FeWWMh': '驾驶证扫描件',
  'FfuHbC': '公司注册证书示例',
  'FnimtQ': '协议名称',
  'FoE46O': '主子账户关系',
  'G1RZwj': '为顺利提交资料，请根据您的客户类型和开户类型提前准备对应的材料',
  'GXi4YZ': '已提供',
  'GhUVYq': '协议签署确认函',
  'Gk7LWL': '1-10人',
  'GqjTbU': '登录账号',
  'GvnX5P': '已生效',
  'H3ZtQe': '签署',
  'HUgN5U': '认证材料提交成功',
  'IC1h4R': '证件类型',
  'IN3tvo': '护照示例',
  'IOMpyN': '驾驶证号码',
  'ISdltD': '账户组列表',
  'IvAEHK': '申请人姓名',
  'Izxr3P': '如您收到邀请，请确认邀请方信息后选择接受或拒绝。',
  'J0euZj': '请输入护照号',
  'J5KYh7': '公司注册证书扫描件',
  'J8aQci': '100万人民币/每月~300万人民币/每月',
  'JM0Z8+': '小于30万人民币/每月',
  'JW4xKl': '驾驶证或其他证件扫描件',
  'JgARuC': '接受邀请',
  'Jnvy7T': '坏账客户不允许添加子账户',
  'JwpS8H': '12月',
  'JygcLG': '澳大利亚客户',
  'KBEkaQ': '公司规模',
  'KEPXlg': '是否有VAT税号',
  'KY9Lch': '该子账户删除后，将不再存在于当前账户组中，您确认删除吗？',
  'KlDbAb': '代运营',
  'L1PAth': '企业',
  'LBAV1N': '以个人为单位与万邑通建立合作关系的客户',
  'LOIsbN': '付款主体账户管理',
  'LPi8CO': '法人代表姓名',
  'LQAdg1': '请填写公司名称',
  'LU2K5S': '2月',
  'LWEs1S': '子账户与主账号的关系',
  'LeUTRH': '变更中详情信息',
  'LzpMjm': '工厂所在地',
  'M5YDuP': '温馨提示：账户列表中管理的是账户组所有账户，如果您需要使用其他主体来付款，您可以将付款主体添加为您的子账户。如您的主账户主体无法付款，请直接变更主账户主体，无需注册子账户。',
  'MEEiLH': '请输入详细地址',
  'MFXP7H': '所属主账户',
  'MMCAZ8': '请输入商业登记号码',
  'Mjfa6o': '11月',
  'N4QdRi': '文件大小不能超过5MB',
  'N52KMq': '详细地址',
  'N8hPDs': '护照号码',
  'NOW26J': '请输入统一社会信用代码',
  'NVG0yN': '客户注册地址的证明文件',
  'O19lil': '请确认您提交的个人资料真实有效，如有虚假信息将承担相应法律责任。',
  'OcjtgQ': '我已阅读并确认以上关系证明内容',
  'Oj4FyF': '变更中详情',
  'Oq50W9': '证件号码',
  'PCFi32': '大于等于3000万人民币/每月',
  'PTl9Bi': '300万人民币/每月~700万人民币/每月',
  'PdlThh': '请输入客户名称',
  'QK7qOF': '验证账户使用者身份证姓名',
  'QS6VWp': '5月',
  'Qxp8mo': '已邀请信息',
  'R/iqJm': '验证信息人姓名',
  'ROXEVo': '身份证号码格式不正确',
  'RtJnaj': '请输入姓名',
  'SE63qT': '组织机构代码证',
  'SG7SHS': '是否使用第三方ERP系统',
  'SKyitS': '请输入法人身份证号码',
  'SfysDv': '注册地为中国大陆地区的企业客户或使用大陆身份证注册的个人客户',
  'SiO92D': '我已阅读并确认《关系证明-朋友及非直系亲属》',
  'T3xGmR': '主/子账户',
  'TBiYNm': '法人代表身份证扫描件',
  'TCvPX4': '邀请状态',
  'TX+ka3': '已拒绝',
  'Tdq1Gf': '身份证扫描件',
  'TkMY1P': '材料上传',
  'UB7ax/': '新主体的主子关系证明',
  'UDEIri': '澳门身份证扫描件',
  'UEiMSy': '身份验证',
  'UrM0bR': '认证信息',
  'UtCIn0': '8月',
  'V7gB+B': '请输入法人代表姓名',
  'VOBapr': '注册地为澳大利亚以外的其他国家的企业客户或国籍为澳大利亚以外的海外个人客户',
  'VPQA6P': '快速添加子账户，默认会将付款人信息加载到子账户添加页面，您也可在页面编辑修改。',
  'WPDMcF': '营业执照号',
  'WaLVm1': '清关代理协议和授权委托书',
  'Wg4cCI': '请输入身份证号码',
  'WocH+A': '7月',
  'X8fPpI': '已归档',
  'XI+CCX': '我已阅读并确认通过',
  'XaOtBT': '香港永久性居民身份证、香港居民身份证均可',
  'XbArtN': '法人身份证与姓名不匹配',
  'XubzYT': '客户名称需与充值主体名称一致',
  'Xvdst0': '商业登记号码',
  'YAQ7rx': '对接平台信息',
  'YIAhsY': '系统',
  'YLFpFt': '推荐客户',
  'YSy2/s': '1. 账户信息(账号已开通，可正常使用)',
  'YZSsDz': '注册地为澳大利亚的企业客户或国籍为澳大利亚的个人客户',
  'YjJIvk': '若您未提供，将无法新增Winit承运服务的订单。',
  'Yk4XHE': '经营信息',
  'ZI8d7M': '商业登记证号码',
  'ZYI5Al': '邀请发送成功',
  'Zmfa+l': '省份',
  'aArN9y': '接受成功',
  'aWgexz': '补充资料提交',
  'aXAhIL': '请填写与身份证一致的姓名',
  'arv4g+': '请选择城市',
  'b4+bD9': '澳洲',
  'bFDGAE': '最多50个字符，不允许中文',
  'bQM+7I': '认证材料已提交，请等待审核。',
  'bXRVNi': '客户名称(姓名)',
  'bXi2Wm': '护照号',
  'bjU+OH': '由于',
  'blw6Vt': '签署时间',
  'bwPC7o': '认证材料上传',
  'bzXZCY': '申请人证件类型',
  'c9ATtu': '提交资料需要准备的材料',
  'cZdEMH': '主子关系证明',
  'cxptRD': '为保证{subName}功能的正常使用，{subName}默认签署{mainName}已签署的以下协议，以及{mainName}后续签署和更新的协议，{subName}默认同步签署。',
  'd+bdlp': '1、请上传6个月以内的带有地址信息的水电煤费用账单、固话缴费账单、物业费用缴费账单、信用卡账单等任一能够证明地址正确性的图片，并确保图片中的用户名和地址信息与注册时您填写的客户名称和联系地址的一致性；',
  'd6hPUr': '请输入驾驶证/其他证件号码',
  'd9ivKd': '填写客户信息',
  'dLQBLA': '分机号',
  'dTFZrp': '若此协议内容与您的线下签署的协议有差异，以线下协议为准。',
  'dbqd/9': '（合同期限：{startDate} - {endDate}）的所有内容',
  'dmZTUz': '是否自建工厂',
  'dozWHK': '文件照片需清晰、完整、无反光。',
  'dtUNQA': '请输入法人代表身份证号',
  'e9YEZh': '请上传账户关系证明文件',
  'eILZXl': '法人代表身份证有效期',
  'echU02': '材料类型',
  'eckayc': '支持 jpg, png, jpeg, pdf 格式，文件大小不超过5M',
  'ew9IbS': '账号异常，请联系您的销售代表',
  'ewqgLV': '已撤回',
  'f3175/': '申请开通海外仓时，需此项材料已经提供并审核通过。',
  'fKQkIL': '3、文件上传支持格式 jpg, png, gif, jpeg, bmp，单个文件小于5M。',
  'fQx7n8': '法人代表护照号',
  'fQyKmo': '服务类型',
  'fXseSl': '公司固定电话',
  'fhnTp9': '合同编号',
  'fjdGBq': '已接受',
  'g8CVty': '身份证',
  'gNViUK': '请输入驾驶证号码',
  'gcxyYc': '税务登记证',
  'gxsu0P': '的内容具有相互关联性，两份协议需要同时签署，您可以点击协议名称查看具体内容。',
  'h18w+Q': '待维护账户（原付款人信息）',
  'hRTXpg': '变更客户名称后，信用额度将暂停使用，请确认是否已申请新协议？',
  'hanZNQ': '加载失败',
  'hswXDb': '法人代表身份证号',
  'i660Gu': '法人代表证件类型',
  'iFu/jb': '101-500人',
  'iMrHyx': '主账户ID',
  'jIYWiV': '账户信息',
  'jWrnD6': '主账户名称',
  'jbO5eW': '额度协议',
  'jwGGQC': '温馨提示：如您的主账户主体无法付款，请直接变更主账户主体，无需注册子账户，以免造成主账户无法还清欠款。',
  'k3ggh8': '请选择开户类型',
  'k9Z1aG': '时效的稳定性',
  'kD/WOs': '注册地为中国香港/澳门/台湾的企业客户或使用中国香港/澳门/台湾身份证注册的个人客户',
  'kUfI5j': '文件不存在，正在重新生成，请稍后再试',
  'kll/tx': '以企业或组织为单位与万邑通建立合作关系的客户',
  'koPxOB': '子账户注册成功',
  'kokU70': '请上传必填材料：{labels}',
  'kpIbQC': '上传（最多3张）',
  'kpoJ9o': '合同期限',
  'kyvQ8G': '当前状态不允许操作',
  'lRRe8a': '查看示例',
  'liumu4': '账户名',
  'mAWXCU': '2、营业执照作为地址证明的，如为复印件，需复印后加盖公章；如为扫描件，需加盖电子公章；',
  'mMZYKe': '签署失败',
  'mQsRy2': '资料管理',
  'mRq6Fw': '请输入个人地址',
  'mv7klT': '未同意',
  'nBK3U2': '如何提供?',
  'nKEZEf': '已更新',
  'nTGLyC': '推荐您来注册的销售代表的联系邮箱',
  'nhhUEK': '护照扫描件',
  'noKt4Z': '护照/驾驶证/其他证件，商业登记证',
  'nwyXo8': '个人照片',
  'ny0ynj': '身份证有效期',
  'nykDD6': '关联证明文件',
  'oIaB29': '请正确填写，一旦提交不可自行修改',
  'ocW47+': '已同意',
  'ov2Tnz': '钱包可消费的国家',
  'pEclQv': '特定服务',
  'pGg2Jq': '4月',
  'pTMsfn': '9月',
  'pvwIWk': '付款人英文名',
  'q0msCl': '是否自有IOR',
  'qJ7ha/': '护照姓名',
  'qkZeU+': '个体客户',
  'qrkKt7': '请输入商业登记证号',
  'r/tdDN': '护照/驾驶证/其他证件',
  'r1bZJl': '重新提交关系证明',
  'rB0rpK': '撤回邀请',
  'rBYkkv': '销售淡季',
  'rZK6Nv': '合同号',
  'rtsk2b': '拒绝',
  'rvmG34': '的内容具有相互关联性，三份协议需要同时签署，您可以点击协议名称查看具体内容。',
  'rwwA42': '合同及协议',
  's4UXY6': '商业登记证扫描件',
  's9xFxt': '和',
  'sa0zjq': '若您变更客户名称（万邑联平台各项服务的法律主体），原主体缔结的合同协议需要重新签署，请同意以下协议，其他协议如有需要请至个人中心-服务与合同签署。',
  'sizSxZ': '驾驶证/其他证件',
  'slLSac': '海外仓《新供应链管理协议》和《新海外仓商业性条款补充协议》和《三方转让协议》',
  'sotoMX': '子账户认证状态',
  'swVIZ8': '是否有开发团队',
  'tHCcFc': '子账户注册成功，充值后帐户可正常使用。您可以即刻补充认证资料，也可以在7天内补充认证资料。',
  'tHhycC': '账户关系证明文件',
  'tK+g+d': '不允许的文件格式，支持 jpg, png, gif, jpeg, bmp',
  'tgev/Q': '如头程运输方式想使用winit承运，请您先提供您签署完成的清关代理协议和授权委托书。',
  'u1fYB+': '确认保存其他信息的修改吗？',
  'uJtC0k': '护照',
  'v4Nkiu': '公司注册证书编号',
  'v5e10Y': '法人护照、商业登记证',
  'vRhbL7': '6月',
  'vfyv2v': '请输入公司注册证书编号',
  'vlq+5R': '请选择省份',
  'vpFnVy': '企业信息',
  'vxhTE0': '坏账客户不允许操作',
  'w5rc6W': '供应链信息',
  'wO5MxF': '请选择关系类型',
  'wmZ7YZ': '正面示例',
  'wmwYjQ': '合同主体变更三方协议',
  'wu5dwO': '销售旺季',
  'x+okXO': '请确认您的身份信息是否正确？',
  'xGq1Su': '1000人以上',
  'xXMsQn': '重新提交认证',
  'xsN0zZ': '公司注册证书示例：',
  'xxkXLy': '51-100人',
  'yAibl7': '是否自有品牌',
  'yD1dFr': '反面示例',
  'yXEBUd': '驾驶证/其他证件扫描件',
  'ygr6yk': '自运营',
  'ygyLem': '是否自建仓',
  'zrPHhb': '添加子账户',
  '5WtksW': '文件解析失败，请检查文件格式',
  'Jv29lf': '发送频率',
  'OgmspG': '收件邮箱',
  'gdqRti': '提交成功，打开批量任务中心查看结果',
  'itqntG': '邮箱格式不正确：{emails}',
  'sae4DD': '批量任务中心',
  'x8Anbh': '多个邮箱请用英文逗号间隔',
  '95EEUk': '订单产品出现多个产品组处理方式',
  'BFquwc': '请务必在出库前在[海外仓 > 出库 > 订单处理]页面补充资料内容，否则仓库不会操作出库',
  'CbTnzf': '下单报错',
  'D57dEh': '预约窗口',
  'GUC5Ld': '请务必在妥投前在[海外仓 > 出库 > 订单处理]页面补充资料内容，否则可能会妥投失败',
  'GXkv7X': '实际用量',
  'HU/sk6': '请输入ASN',
  'IIPVBV': '（2）如果下单时指定产品信息，则会遇到订单产品出现多个产品组情况，处理方式选择下单报错则遇到这种情况直接下单失败，处理方式选择直接使用下单产品不使用智能推荐，下单不会失败，订单直接使用指定的产品出库，不会使用智能推荐功能去选择最优的产品出库',
  'RPDXWq': '直接使用下单产品不使用智能推荐',
  'YgJy9e': '当前存在跨组重复的产品配置，切换为标准类别后将清除重复配置，是否继续？',
  'ZOK20H': '实际装箱结果',
  'ZT6Wlf': '出库处理费-标准包装打包费/出库处理费-复合打包附加费 按实际装箱结果为准',
  'ZzfHpZ': '包材费用将根据打包完成后的{b1}进行结算，最终费用以仓库{b2}为准。',
  'cRQFUR': 'PSC：{names}同时出现在多个产品组中，已按「订单产品出现多个产品组处理方式」配置处理冲突。',
  'fWHxHn': '请选择预约窗口',
  'ilS24x': '资料内容',
  'qao8cv': '（1）如果下单时选择产品组，则不会出现订单产品出现多个产品组情况',
  'r9Pakk': 'ASN',
  // '2nPj6J': '<bold>标签/指标定义：</bold>{break}SKU温度:截至所选日期,计算该SKU过去30天出库量:高温>=600,600>中温>=100,100>低温>=3,滞销<3;{break}DOI:截至所选日期,计算该SKU近30天日均库存数/近30天日均销售数量;{break}日均库存:截至所选日期,该类SKU过去30天日均库存数据;{break}剔除新品库存：SKU最早上架时间距今<60天',
  '5L5HWp': '剔除新品库存',
  'GIpWfV': 'SKU最早上架时间距今<60天',
  'QuupS2': '（2）汽配类，高温>=30，30>中温>=10，10>低温>=3，超低温<3； （系统默认通用标准，主营汽配可联系您的销售变更类目配置。）',
  'SIqgtx': '<bold>标签/指标定义：</bold>{break}SKU温度:截至所选日期,计算该SKU过去30天出库量:高温>=600,600>中温>=100,100>低温>=3,滞销<3;{break}（1）非汽配类划分：高温>=600，600>中温>=100，100>低温>=3，超低温<3；{break}（2）汽配类，高温>=30，30>中温>=10，10>低温>=3，超低温<3； （系统默认通用标准，主营汽配可联系您的销售变更类目配置。）{break}DOI:截至所选日期,计算该SKU近30天日均库存数/近30天日均销售数量;{break}日均库存:截至所选日期,该类SKU过去30天日均库存数据;{break}剔除新品库存：SKU最早上架时间距今<60天',
  'nUaOH0': '（1）非汽配类划分：高温>=600，600>中温>=100，100>低温>=3，超低温<3；',
  '6aITvx': '<bold>标签/指标定义：</bold>{break} {symbol}SKU温度:截至所选日期,计算该SKU过去30天出库量:高温>=600,600>中温>=100,100>低温>=3,滞销<3;{break} （1）非汽配类划分：高温>=600，600>中温>=100，100>低温>=3，超低温<3；{break} （2）汽配类，高温>=30，30>中温>=10，10>低温>=3，超低温<3； （系统默认通用标准，主营汽配可联系您的销售变更类目配置。）{break} {symbol}DOI:截至所选日期,计算该SKU近30天日均库存数/近30天日均销售数量;{break} {symbol}日均库存:截至所选日期,该类SKU过去30天日均库存数据;{break} {symbol}剔除新品库存：SKU最早上架时间距今<60天',
  '+OQSHt': '适用客户',
  '6SaKc3': '操作视频',
  'RKDS0B': '打托等级名称',
  'clwNaF': '点击查看具体说明',
  'jOosuV': '<a>点击查看具体说明</a>',
  'QN7qT1': '已认证或（已开通服务）的账户且主子关系证明审核通过，才可以作为付款发起账户。',
  'Bklei+': '系统计算折叠分数与难度等级，若系统审核不通过，可在对应方案内失效此商品后关联其他方案。',
  'CuAg0e': '首次出库前由仓库进行复核，若符合失败可放弃折叠出库或重选方案。',
  'GPqzPr': '维护折叠方案',
  'SoPWko': '新增方案，填写折叠方案、步骤、折叠示意图、折叠视频。',
  'XZ25+X': '提交系统审核',
  'gTOf0A': '仓库复核',
  'it9ahA': '关联折叠商品',
  't5QRAS': '近半年',
  't6fdxD': '选择方案，添加商品，确认折叠后尺寸信息。',
  'iy9fgm': '说明: {break}1.批量一次最多创建{maxDraftNum}单草稿单。{break}2.创建后请先在草稿页确认当前所选的商品复测信息是否认可,不认可请重新复测商品后,再重新申诉。{break}3.申请尺重类费用系统自动查询最近12个月内最新的商品复测信息,提交草稿后,即代表同意使用万邑通复测结果进行申诉;当无可用库存商品进行复测时,系统自动查询出库时包裹的尺重信息进行提交。{break}',
  'ANUBEZ': '自主装箱/打托 由仓库根据实际装载情况判断是否混装，混装时机和方式不做承诺。',
  'BBAB0l': '优先单SKU装箱（按装载需要混箱）',
  'BwLBVN': '批量下载（{count}）',
  'G5kS8+': '优先同类包裹打托（按装载需要混托）',
  'Lguoj3': '未找到POD文件（{count}个单号）',
  'LhUQLV': '风险提示：',
  'UKe03t': 'POD 文件查询结果',
  'famGVR': '系统已查询到以下快递单号的POD文件，您可以直接下载。',
  'fbFvrI': '系统已查询到以下快递单号的POD文件，您可以直接下载。对于未找到POD的单号，可选择继续提交查件申请。',
  'kTlf72': '为未找到的单号提交查件',
  'kzQni7': '提交失败（{count}个单号）',
  'qSLsI7': '已找到POD文件（{count}个单号）',
  'zGe/VP': '下载POD',
  'G+vm8C': '仅当装箱策略选择智能推荐装箱或客户指定装箱时，支持选择优先同类包裹打托。',
  'CYcS4F': '仓库人员根据商品特性与运输要求，灵活进行打托，具体打托结果后续可查看子订单详情~ {break}<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际打托结果为准。仓库将根据实际装载情况判断是否混装，混装时机及方式不作承诺。</span>',
  'IKLLzL': '仓库人员将根据商品特性和运输要求，灵活选择包材与装箱方式，具体装箱结果后续可查看子订单详情~ {break}<span>重要提示：如您选择此策略，则视为您授权并同意以仓库最终的实际装箱结果为准。仓库将根据实际装载情况判断是否混装，混装时机及方式不作承诺。</span>',
  '+LqiLB': '拆单成功',
  '0An1WL': '新入库单将自动继承原单信息',
  '14C8J/': '中转仓',
  '2qsyUR': '确认后，已选的 {count} 个包裹将从 {from} 中转至 {to} 完成入库。中转费用按合同约定计费。',
  '34Nm6H': '确认中转',
  '4Q4ztC': '查看订单详情',
  '5imQHj': '请勾选需要拆出的包裹',
  '7EfxeQ': '个（全部）',
  '7zajKA': '选择包裹',
  'AeBvmu': '拆出包裹数',
  'AwPWk2': '选择中转类型',
  'AwzhnY': '入库单内所有包裹统一中转至新目的仓',
  'Bd3f88': '入库单拆单',
  'Cvrnz2': '请选择中转类型',
  'Dcy1/5': '查看新入库单',
  'FdU90R': '选择目的仓',
  'FmmsT+': '请勾选需要中转的包裹',
  'FpjLEL': '中转仓（原目的仓）',
  'HpFbBI': '确定要作废该中转单吗？',
  'IgzD9u': '新入库单已自动发起海外中转，无需额外操作。',
  'JWJ+/S': '入库单 {orderNo} 的中转已成功发起。',
  'JWrk7G': '个包裹拆出',
  'Jk3X8R': '海外中转',
  'L4D0ff': '仅显示已配置的中转仓库（基于Winit产品+目的仓配置）',
  'LeVkNq': '包含包裹数',
  'LelI4l': '整单中转：所有',
  'M7LM+x': '选择新目的仓',
  'MuCcVn': '请选择新的目的仓',
  'NfBRBZ': '整单中转',
  'PjSYqs': '新Winit产品',
  'Q9iQHY': '多个用换行或逗号隔开',
  'QUbxVa': '入库单信息',
  'RVNwaA': '中转发起成功',
  'SmkREh': '原目的仓（中转仓）',
  'TfptPu': '原单剩余包裹',
  'TpX3uS': '是否海外中转',
  'ULVDFv': '新入库单已生成，自动继承原单的Winit产品、发货计划等信息。您可以在入库全部订单中查看并对其进行后续操作。',
  'WgLwa5': '请至少选择一个包裹',
  'Y77Gxw': '已选择',
  'aJkyQ0': '中转类型',
  'bBUl8w': '中转包裹数',
  'bM4NKj': '目的仓和中转仓不能是同一个仓库！',
  'dQ9VyS': '包裹单号',
  'gjgB7K': '部分中转：请在下一步选择需要中转的包裹',
  'iIH0vE': '新目的仓',
  'j6EyHL': '个包裹中转',
  'jfJdT8': '已将选中的 {count} 个包裹从原入库单 {orderNo} 拆出，生成新入库单：',
  'juLnBd': '作废成功',
  'ktQROn': '中转已发起，所有包裹将从原目的仓中转至新目的仓完成入库。可在订单详情中查看中转进度。',
  'l3cE5+': '已选的 {count} 个包裹',
  'laEPdF': '中转状态',
  'lmbxWv': '拆出的包裹将生成新的入库单，自动继承原单的Winit产品、目的仓、验货信息等，无需重新填写。',
  'mBz8fo': '选择部分包裹中转至新目的仓，其余包裹留在原单',
  'mZ/ix2': '当前目的仓',
  'mj7TCE': '已将选中包裹拆为新入库单并自动发起中转，原入库单剩余包裹不受影响。可在入库全部订单中查看两个单据。',
  'qA8a8u': '个包裹将中转',
  'rZEho1': '您即将对入库单 {orderNo} 执行拆单操作：',
  's99Nb4': '拆单信息',
  'sLD7EO': '包裹总数',
  'szz1uP': '暂无轨迹信息',
  'tOJdpO': '中转信息确认',
  'tUAYlD': '已从入库单 {orderNo} 成功拆出包裹，生成新入库单。',
  'warsjn': '部分包裹中转',
  'xJXdl5': '中转轨迹',
  'yqgS2d': '拆单后将生成新的入库单，此操作不可撤销，请确认无误后提交。',
  'zd/qTo': '中转入库单号：',
  'QT4kgx': '请选择预约仓库相同的订单创建预约单，已发起中转的入库单的预约仓库是中转仓，未发起中转的入库单的预约仓库是目的仓！',
  '1R2faN': '新的Winit产品',
  'mKTpg9': '系统根据配置自动匹配Winit产品，不可手动修改，中转包裹将使用该Winit产品完成中转入库。',
  '+c+COK': '海外仓入库完成',
  '+loinA': '拣选异常',
  '/1L/Ya': '计费重({unit})',
  '5vjKo1': '请选择文件',
  '9nYt4g': '批量导入将清空原输入/导入SKU数据',
  'AbnhUS': '预计冻结金额',
  'EJ3SFH': '拣选完成',
  'Em6cvX': '总重量(kg)',
  'GxOf0U': '请先添加商品信息',
  'HK4jwl': '不能大于可用库存',
  'HgKGiV': '打包完成',
  'Io/uF/': '长({unit})',
  'J1yTE1': '请先选择商品',
  'LAYnKu': '长*宽*高({unit})',
  'LTIAEF': '打包异常',
  'Mw6BFk': '体积({unit})',
  'SA7tfX': '您确定作废选中的出库单？',
  'Wb/RGJ': '重量({unit})',
  'Y9zNap': '进仓完成',
  'Zew02R': '您的账户余额低于预计冻结金额，将无法提交提货单，请及时',
  'at3b+O': '进行批次管理的商品【{codes}】暂不支持进行库间调拨，请修改商品信息。',
  'eO/IUc': '您的账户余额',
  'f4sjzU': '宽({unit})',
  'h3KPr3': '海外仓上架完成',
  'i10W+Z': '继续提交',
  'lrcTTN': '下单导入模板',
  'm8+2gt': '进行多SKU类型管理的商品【{codes}】暂不支持进行库间调拨，请修改商品信息。',
  'n6s9y/': '不支持退货商品',
  'oymnKM': '下调拨单',
  'qYU7sG': '高({unit})',
  'ud12Je': 'Winit跟踪号',
  'vbbD6x': '调拨产品',
  'w5Q/br': '调拨商品',
  'xi7zM4': '库间调拨',
  '9i32k6': '预估费用查询失败',
  'LLMOrF': '调整前库存单元数',
  'SUoa+u': '预估金额',
  'ZL+MoW': '切换{field}的同时会将已添加的商品删除，请确认是否切换{field}',
  'cn9+pn': '可调整库存单元数(箱/套)',
  'eHEMay': '不能大于可调整库存单元数(箱/套)',
  'ePmeDm': '拆箱商品逐件清点偏好设置',
  'zv8drN': '当前预约为增值预约，若已收取增值预约费用，取消后将不会退还，确认取消？',
  '88qyGm': '取消预约后如送仓需重新预约，确认取消预约？',
  'DkkSLz': '请阅读并勾选协议',
  'Ps22Sc': '预计卸货日期',
  'dIXyA7': '审批说明',
  's6flrP': '此预计卸货日期为预估时间，需以审批通过时预计卸货日期为准',
  '+KGCki': '请输入法人代表护照号',
  '0J80uO': '验证账户使用者身份证号码',
  '0fSxpD': '欢迎使用万邑通',
  '0ijY0r': '3. 开通并使用',
  '1Lc3fb': '3. 港澳个人/企业，需要护照/身份证',
  '1Xpl5b': '周一~周六 09:30-18:30',
  '1weoYE': '寄件人手机',
  '21YVhF': '提供清关代理协议和授权委托书',
  '2rhiSN': '恭喜您！已成功提供清关代理协议和授权委托书。',
  '2xgBZt': '银行预留手机号',
  '4RhMJm': '请选择营业额',
  '4gzwfO': '省/州',
  '5Br/27': '2. 大陆企业用户，需要企业法人身份证/护照、营业执照、地址证明',
  '5dIO1y': '《线上小包+服务协议》',
  '6EZQnj': '鉴于万邑通为贵方提供物流管理服务，就贵方主账户（以下简称"主账户"）和贵方新增子账户（以下简称"子账户"）的关系，贵方声明并确认如下： 1. 贵方确认主账户与子账户为同一实际控制人控制或者具有关联关系。 2. 贵方确认主账户对子账户因使用万邑通各项服务而产生的债务承担连带保证责任。 3. 主子账户在使用万邑通各项服务的过程中，如出现违规行为（包括但不限于运输违禁品、侵犯他人知识产权等），万邑通有权对主子账户采取相同的处理措施。',
  '6RGTQg': '如有疑问请联系客服',
  '7oM8cP': '是否拥有IT系统开发团队',
  '7yTSYL': '国际达仓(FBA)服务',
  '8Mpenh': '如开通物权保管单的服务，请点击右上角【在线咨询】咨询',
  '8Pf78d': '1. 选择服务',
  '90DlR1': '声明书',
  '9YD9zW': '您也可以：',
  'AT8jzy': '海外仓服务',
  'BFtNdx': '代理协议页2',
  'BGUkPS': '开通服务咨询',
  'CzizdQ': '去认证',
  'DJyE9w': '请输入登录账号',
  'DeW7me': '温馨提示：{break}如果您意向变更关键信息（客户名称、证件号码和开户类型），需要上传{link}，您可以提前准备此合同签署后的扫描件。{break}客户名称变更审核通过后，原主体的{agency}将失效、相关的{relation}将变为审核不通过，请您及时提供{newAgency}、{newRelation}；{warn}{break}如有疑问请联系对应的销售或客服咨询。',
  'FHar07': '很抱歉，您的资料审核不通过，请根据以下不通过原因修改后重新提交',
  'FO8HwP': '2. 填写信息',
  'HdY1ln': '您想使用哪些产品？',
  'HkqhLb': '示例(DE)',
  'IXaNMx': '请填写完整验证信息',
  'J5gibL': '您可随时登录查看审核进度',
  'KAd/I+': '第1页示例',
  'KDEGxk': '请提交收件邮件地址',
  'LcjamZ': '企业客户：请填写营业执照上完整的公司名称',
  'M2zKeY': '请填写银行卡号',
  'MSqVZ1': '3. 主联系人',
  'MYcqLd': '提供',
  'NvdTs3': '进入万邑通',
  'O9n3RX': '发送验证码',
  'OQBTGI': '如果后收到材料，点击下方【上传资料】上传',
  'OdIKCB': '帮助卖家将大宗商品批量运送到国际各品牌跨境电商平台仓库配送全球的物流末端服务',
  'Of6YPc': '寄件地址',
  'OkZkZj': '已线下提供，无需邮寄',
  'P/vC/z': '专为轻准电商提供经济快递服务国际各品牌跨境电商及买家的最优经济路线',
  'P37sWB': '1. 提交资料所需要准备的材料',
  'PRzU2R': '已开通服务',
  'PbHiU1': '您的账户存在欠费，暂时无法开通新服务，请先完成费用结清。',
  'PnBZCt': '新手指南',
  'QH+N9+': '请上传所有协议图片',
  'QUei3X': '请输入银行预留手机号',
  'QtI7kN': '文件上传支持格式：jpg,png,gif,jpeg,bmp，文件大小小于5M',
  'Qtfwk/': '当前资料',
  'R+dDnK': '4. 海外个人用户，需要护照',
  'SU+VLr': '点击进入',
  'SUR3uB': '您的主体信息正在变更中，请等待完成后再开通服务',
  'TAeOSl': '代理协议页3',
  'TOKgDI': '主联系人是您在万邑通的主要联系人，系统会将重要通知发送到主联系人的邮箱和手机',
  'V8oU7w': '示例(UK)',
  'VGgJF7': '配力购拓展供体运营及铺配置市场，增长对外贸易服务',
  'WQ6eD4': '法人代表护照扫描件',
  'WgINdV': '查看样本',
  'XNooSI': '示例(AU)',
  'XjPqWa': '个体客户所需资料',
  'YXQOSI': '前往变更主体',
  'YaRSs3': '格式不正确',
  'Z0sJ3u': '手机号码必须为数字',
  'ZtiXo0': '请输入公司名称',
  'a3p4+m': '企业客户所需资料',
  'alScLc': '产品介绍',
  'bXmxV6': '温馨提示：{break}如果您意向变更关键信息（客户名称、证件号码和开户类型），您需要上传{link}，需要重新签署{credit}和{agency}，您的新主体需要提前签署上述合同并准备扫描件。{break}客户名称变更生效后，原主体的清关代理协议将失效，额度协议将失效，相关的主子关系证明将变为审核不通过，请您及时提供新主体的清关代理协议、新主体的额度协议以及新主体的主子关系证明；{warn}{break}如有疑问请联系对应的销售或客服咨询。',
  'bcO3DM': '代理协议页1',
  'bhdAVg': '第2页示例',
  'cS3uAM': '个人客户：请填写身份证上的姓名',
  'cT+TM6': '操作失败！请等待资料审核通过后再签署清关协议。',
  'cdEZcI': '2. 填写申请资料',
  'cjVt7P': '坏账客户不可用',
  'cr3PBp': '请输入联系人',
  'd0PEzZ': '确定要取消授权吗？',
  'd5fyCd': '电话客服',
  'dAmvz8': '公司名称/客户名称已存在',
  'dEBQta': '分销服务',
  'dSKZh7': 'ISP服务',
  'e+pjZj': '请耐心等待...协议约在一个工作日寄到您的邮箱',
  'eFvFoh': '立即开通',
  'etMKVx': '返回重新提交主体资料',
  'frzcHZ': '电商平台月均营业额',
  'fy+hiL': '1. 大陆个人用户，需要身份证、地址证明',
  'gAlCCc': '请选择您所需要的产品服务',
  'jC5PcU': '开通服务所需资料',
  'jfGyLt': '授权委托书页2',
  'komV6f': '合同及协议编号',
  'l9PDt/': '上传资料',
  'lKLi66': '操作失败！请先点击右上角登录帐号二级菜单【开通服务指引】开通海外仓服务，再进行此操作。',
  'mcoHvq': '主体资料审核已通过',
  'mh/8yw': '请选择钱包可消费的国家',
  'mw/y6w': '定义合作有效期的地址',
  'njMKo0': '港澳客户请按证件上显示的姓名填写',
  'nogv8V': '寄件人',
  'nr7bST': '变更了关键信息（客户名称、证件号码、开户类型等）时，请下载"<a>合同主体变更三方协议</a>"签署并上传；',
  'ogAJPw': '万邑通为您提供一站式跨境物流解决方案，包括海外仓储、国际达仓、ISP小包及分销等全方位服务。',
  'p8QAaO': '请勾选服务协议',
  'pUZ4q7': '授权委托书页1',
  'paDSa5': '主联系人变更后，系统默认的邮件和短信订阅以及找回密码功能将发送到新的联系人邮箱和手机号码，请确认填写。',
  'pdwVpx': '验证账户使用者身份证有效期',
  'peVto9': '在线解答您的咨询、办理、受理',
  'pmOHMy': '我已阅读并同意{link1}及{link2}',
  'qE1Dl+': '配力购拓展供体运营及铺配置市场，匹配海外市场分布通渠率，增长对外贸易服务。',
  'r/TTkp': '提供须知',
  'riCoWg': '5. 海外企业用户，需要企业法人护照、商业登记证',
  'rmsXMq': '查看资料详情',
  's5woUU': '上传已签署的协议回传件',
  's7aJO6': '银行卡号',
  'tZBs5t': '开始',
  'tgl43v': '资料已提交成功，我们将在1-2个工作日内完成审核',
  'tjiU4g': '分机',
  'tmuXtr': '专为大卖家提供商品批量运送至海外仓存储、交易成交后配送至买家及退货等增值服务',
  'u5ZBsZ': '寄件人邮箱',
  'w52iDk': '合同期限：{startDate} - {endDate}',
  'wJR7KF': '正面示例(头像面)',
  'x+hx89': '邮寄方式',
  'x2XJq3': '立即咨询',
  'x88sZJ': '认证',
  'xJoLq6': '反面示例(国徽面)',
  'zMrCID': '新建邮箱地址',
  'ziT67U': '立即授权',
  '0AYQ4O': '新增子账户',
  '2UZfqj': '请填写身份证有效期',
  '2xSZ3s': '如您无需使用富友充值，可忽略此提示。',
  '3Qj8Ey': '文件上传支持格式jpg，jpeg，png，pdf，文件大小小于5M。文件照片需清晰、完整、无反光。',
  '3YUWW0': '关系证明 (扫描件/复印件/照片均可)',
  '3q8UGf': '请阅读并勾选确认',
  '4hV2p6': '请输入紧急联系人电话',
  '4ytGna': '请填写客户名称',
  '5xLi4r': '请选择电商平台月均总营业额',
  '6x+VFm': '本公司/本人亦同意，本账号的额度可分享至本账户组内任一账号，同时，如账户组内任一账号触发《担保协议》的担保责任，贵司亦有权停止向本账号的提供服务。',
  '7ayFnj': '请正确填写客户名称，与合同签约名称一致，一旦提交将无法修改',
  '8fBHBI': '本公司/本人承诺，该声明真实有效，如有违背，本公司/本人承担全部赔偿责任。',
  'DTIhVg': '支持 jpg, png, jpeg, pdf 格式，文件大小不超过5M。文件照片需清晰、完整、无反光。',
  'EuZwE2': '您大约需要等待1个工作日即可审核完毕，待审核通过后需要完成相关协议签署，请耐心等待资料审核。',
  'G5rRTS': '身份验证失败',
  'HoKcxU': '请输入收件人Email',
  'I3hgJA': '本公司/本人同意，本账户组内任一账户可销售本账户库存，同时，如账户组内任一账号项下的钱包余额与库存因故被冻结，贵司均亦有权冻结本司/本人账号项下的钱包余额和库存。',
  'J9BBV7': '如果你已经和编辑协商并签署了"清关代理协议和授权委托书"，不需要我们在线给你寄送这委托书，请勾选此项。',
  'MFmMMP': '本人/本公司确认，以上信息真实有效。如有违背，本人/本公司承担全部赔偿责任。',
  'NRyVCE': '子账户当前仅支持出库和退货业务，选择国家，表示子账户仅支持所选国家仓库的出库单。比如：选择US，所有US仓的出库单均可以归属到当前子账户',
  'QSApnT': '坏账客户不允许新增子账户',
  'RPyXoX': '该名称已存在，请确认',
  'Rv++fr': '已邀请',
  'T2cK0M': '合同有效期',
  'Vw5IgN': '收件联系人姓名',
  'XBLRbl': '请输入收件联系人姓名',
  'Y/0iZJ': '详情请见万邑联公告：',
  'YAlOmH': '身份证号',
  'YDux6E': '账号名称',
  'ZQYAGh': '线下已提供',
  'ZurE3P': '资料提交成功！',
  'eGO5h/': '该名称已被使用',
  'erj1yA': '该手机号已被注册',
  'lzseXh': '该证件号码已存在，请确认',
  'nOKRRS': '如开通过程有任何疑问，请点击右上角【在线咨询(AI)】咨询。',
  'o3inPO': '请正确填写公司名称，与合同签约名称一致，一旦提交将无法修改',
  'pwiaf4': '注意：接受邀请并验证通过，则此账户作为该账户的子账户，无法再接受其他邀请。',
  'q7wQgd': '{countdown} 秒后自动跳转，立即跳转',
  'qBz+pd': '身份证与姓名不匹配',
  'rT+IsV': '请输入紧急联系人',
  'sVbO2z': '提交身份验证',
  'seQfmX': '提交关联证明',
  'sneOFd': '声明函',
  'vKNDOz': '开通时间',
  'xxmXbQ': '请上传关系证明文件',
  'z259bI': '邀请失败',
  'zALLNK': '因富友支付渠道人民币出境的政策要求，需要对大陆-企业客户和大陆-个人客户的相关资料项做有效性、完整性校验。提交资料时请您提前确认资料的有效性，建议提供最新的资料文件，否则将无法使用富友充值，甚至面临充值失败退回的风险。',
  'zUaBWY': '邀请',
  'RMSKAT': '每个客户仅能申请一次变更名称或类型，您已变更过一次，不支持再次变更，如有疑问请咨询客服。',
  '7MLoBp': '订单【{orderNo}】不满足预约条件或不存在，请检查',
  'LJBSgJ': '共 {total} 条',
  'QBGTlS': '订单号不能为空',
  'UzRdmP': '{num}、如是整柜DROP卸货，请准确填写联系人、联系电话、邮箱等信息，仓库将按照联系人信息通知提回空柜。',
  'apXnDe': '订单号不能超过100个',
  'jqi6+v': '所选订单的目的仓不一致，无法创建预约单',
  '1c6LDN': '客制包材编码',
  '2gEo49': '订单明确指定场景',
  '35dnG8': '作废订单：',
  '3Q3MF1': '更换WINIT包材：',
  '53MVz2': '保存配置',
  '6x0xR6': '规则说明：',
  '7mBmA2': '报错提示',
  '7zxWzW': '包材排除配置',
  '9/2b1I': '冲突处理方式',
  'A9n84m': '说明：出客制包材库存不足时，系统将按以下配置处理订单，未配置则默认「作废订单」。',
  'DBDOxo': '客制包材',
  'EDhiUB': '配置保存后将自动推送云仓系统。',
  'FJzTjL': '请选择打包方式',
  'G7MDWq': '编辑排除规则',
  'HT7nGY': '直接下单',
  'I3vZ/T': '请选择客制包材编码',
  'IFB2eq': '新增排除规则',
  'L3SPWo': '当订单/SKU指定包材与排除规则冲突时，按规则中配置的「冲突处理方式」执行。',
  'LrThAO': '命中排除规则的包材不参与智能推荐和下单选择。',
  'N98qnm': '请输入规则名称，不可重复',
  'OKWdoC': '选择需要排除的包材规格',
  'PCZwld': '客制包材缺量处理方式',
  'SoPUpI': '出库加包装配置',
  'TSXSjM': 'WINIT包材规格',
  'UrE8yI': '订单下单时报错拦截，提示用户「指定包材与排除规则冲突，请更换包材」。适用于需要用户确认的场景',
  'UxZZYu': 'WINIT包材规格 和 客制包材编码 为选填项，但必须填写其中一项',
  'VVu71G': '更换WINIT包材',
  'YCbLtb': '客制包材缺量时直接作废订单，云仓不发货',
  'YVtXEN': '一单多包裹打包客制包材缺量时默认更换WINIT包材之库，不支持设置操作订单',
  'bWd3aD': '排除包材',
  'cmaIxX': 'WINIT包材规格 和 客制包材编码 必须填写其中一项',
  'fqrDS1': '下发提示：',
  'k7epGn': '配置保存后将自动推送云仓系统',
  'khGlAG': '客制包材缺量时仓库自行换成合适的WINIT标准包材继续出库',
  'mTsgKL': '配置包材排除规则和客制包材缺量处理方案',
  'u6CUJT': '冲突处理',
  'v+NFbW': '排除规则',
  'xeTVHA': '排除条件',
  'yoWkrt': '订单/SKU指定的包材符合包材排除规则时，以订单/SKU指定的包材下单',
  'z58bKI': '冲突处理：',
  'w6lsmO': '1. 请务必填写客户订单号，这是必填项。{break} 2. 所有上传的订单必须选择相同的仓库，如果订单涉及不同出库仓库，请分开提交。{break} 3. 每次最多可导入200个订单，文件大小限制为5M。如果文件过大，请分割成多个文件逐批上传。{break} 4. 操作步骤：先上传批量模板文件，然后提交增值服务，最后点击确认。{break}',
  '7H1d1S': '异常类型 TOP 5',
  'I5RfGb': '确定处理吗？',
  'PAWk7K': '本日新增',
  't/TC7E': '操作状态',
  '1tzsQb': '港澳台身份证明',
  'HA7GIy': '其他证件',
  'KTfVtd': '社保证明/劳动合同',
  'ewq7ga': '户口本',
  'hlPhA8': '请填写订单包装对应的包材类型',
  's5WurW': '结婚证',
  'HlmrMx': '联行号',
  'uq5Uzv': '银行代码',
  'y/6o2M': '开户名',
  '3/P5TI': '待寄件',
  'jD1Oyu': '已寄件',
  'nTvggn': '待查件',
  'r1mcOg': '待收件',
  '8WhlVp': '1、请上传最新版营业执照。（避免后续无法使用富友充值，或富友充值无法到账被退回）',
  'in6pv9': '2、文件上传支持格式 jpg, png, gif, jpeg, bmp，单个文件小于5M',
  '+u4OEX': '增值附件',
  '/+KIkw': '请输入电话',
  '2LR7Bk': '切换盘点方式将清空商品明细，确认切换?',
  '6sLMW0': '盘点结果明细',
  '78f9nf': '预估盘点的理论工时时长：',
  '7U4OZ3': '盘点类型',
  '83xMhL': '是否全部库存盘点',
  'ALCnoI': '到仓人员',
  'AZW0JL': '外箱条码',
  'ChOVyr': '盘点方式',
  'EtaVvI': '箱内商品盘点结果',
  'GJCFCQ': '请选择关联账号',
  'GKsEYw': '动态盘点：客户无需停止推单；静态盘点：盘点期间出库确认环节将被拦截',
  'GMtO6C': '盘点SI总数（下单|实际）',
  'H3sCL2': '少货',
  'HoKTsV': '查看增值结果',
  'IRWpZq': '删除盘点客户将清空商品，确认删除盘点客户？',
  'KGFzKs': '箱内商品库存差异件数',
  'Ka/Io8': '盘点正本快递信息',
  'M6PlA2': '切换快捷下单方式将清空商品明细，确认切换？',
  'Me/sPx': '箱产品逐件清点明细',
  'MtOFjZ': '箱内商品库存在库数量',
  'N+bIJl': '盘点准确率（SKU数）',
  'NPXmOW': '新增人员',
  'OuafM9': '请至少添加一位到仓人员',
  'QBn98f': '快递费',
  'Tbnf1W': '所选时间不在该仓库可用盘点时间内，提交后将触发审批流程，由运营人员在后台审批通过后才能下发增值单；该仓库正常上班时间为：{workTime}',
  'UwfpmS': '自定义属性',
  'WEo103': '更换仓库将清空商品明细，确认更换仓库？',
  'Z/iCTZ': '期望结束时间必须大于期望开始时间',
  'cjiBb5': '盘点客户账号',
  'dwlSYa': '差异件数',
  'eXAo9i': '箱内商品实际盘点数量',
  'evYjxL': '准确',
  'f5aifa': '张',
  'iSWFr7': '盘点单品明细',
  'lAeyEd': '商品编码[{merchandiseCode}]规格[{specification}]在库库存不足，请您修改后再下单',
  'lBNsWH': '盘点单号',
  'mVdFCk': '预估盘点的理论工时时长',
  'nskr0G': '盘点方式在第一步选择，如需修改请返回上一步',
  'p5sT8O': '盘点结果',
  'pUWFPW': '盘点SKU数',
  'qfntuf': '费用=盘点总工时×增值工时费',
  'r0hf7Y': '年/月/日',
  'rGqmhK': '库位',
  'rj0CJB': '请选择拜访日期',
  'rx76l3': '期望开始时间必须小于期望结束时间',
  't0C80u': '盘点准确率（SI数）',
  'vW8q5o': '拜访日期',
  'w9FoQd': '多货',
  'wErrs4': '该功能未开放，敬请期待',
  'wzHNwV': '快递面单图片',
  'xK/w2b': '在库库存不足，请您修改后再下单。',
  'xS0ers': '盘点SI总数(下单|实际)',
  'yiElpc': '客户指定分组数不能超过到仓人数({count})',
  'zsVDet': '实际盘点数量',
  '2umuoE': '提前提供抽盘比例，以便仓库预估人力安排。',
  '98/n0f': '提示：因抽盘货物需盘点当日现场指定，当前无法预先估算费用，最终收费以当天实际盘点数量为准。',
  'bqP00r': '审计人员如到现场，请告知需要几组盘点人员，仓库将提前按组配备盘点人员。',
  'hcxV9X': '可多选当前客户的关联账号进行盘点',
  'qzsQNP': '盘点期间拍摄的所有照片仅供本次盘点记录与核对使用，请勿对外发布或用于其他用途。如因对外泄露引发任何纠纷或损失，万邑通有权追究相应责任。',
  'sO8GLG': '如您需要将盘点签字正本邮寄至指定地址，将涉及以下收费：·WINIT承运：由万邑通安排邮寄，相关快递费用将向您收取。·WINIT无法承运：客户需自行提供发运面单并预约供应商上门提货，万邑通将收取协助交运的附加服务费。',
  'tZJUhF': '说明：将同一SKU在不同库位的盘点数据汇总合并，便于从商品维度查看整体盘点结果。',
  'wC9qVV': '盘点结果明细（按SKU汇总）',
  'g9nrIG': '盘点SI总数（在库|实际）',
  'Xr3iLB': '指定UN编码',
  'jVeNe7': '商品信息维护的UN编码',
  '5Y0NX/': '带电附属信息',
  'diePMJ': '请输入大于等于1的整数',
  '0Bl1I/': '未申请，取消变更',
  '1+EFeX': '变更客户名称后，信用额度将暂停使用。如需继续使用额度服务，请在变更前申请新协议。',
  '2VuMXA': '同一集团/同一控股人关系需提交两份材料，缺一不可：① 万邑通模板声明文件（需双方盖章）② 第三方关系证明材料（如企查查截图）',
  '2rtqtD': '提货车型',
  '3XqWd1': '请上传万邑通模板声明文件',
  '4AqZuL': '申请代客索赔（需您到代客索赔管理人工创建代客索赔申请单）',
  '50FxDt': '头程询价报价 <span>(实际打托数量会影响最终头程费用，请确认报价的单价，以实际扣费金额为准)</span>',
  '5QgGeE': '目标到仓时间',
  '6ngvxG': '本地揽收地址',
  '7CgrYB': '账号异常，请联系您的销售代表{salerInfo}',
  'ATqkIU': '确认处理方式',
  'CgGs+i': '提货地址类型',
  'DhscDp': '申请代客索赔-自动生成索赔申请草稿单（注意：此方式仍需要您到代客索赔管理补充索赔信息及资料后确认提交。）',
  'EX9Om/': '仓库收货地址',
  'F0XcGu': '导出全部失败记录',
  'FhwORH': '预估头程费用',
  'KlYmmc': '重新提交证明',
  'M5I+Tc': '快捷操作',
  'NJ/NF/': '检测到以下运单已超时，支持索赔',
  'NeFbk5': '已申请新协议',
  'NmMPWV': '预计揽收时间（本地时间）',
  'OVRt0j': '收货仓库',
  'R68w20': '前往代客索赔',
  'Ryn9QL': '请提供甲乙公司实为同一集团/同一法人/同一股东/同一控股人的证明材料；如：企查查内公司法人/股东截图。支持格式jpg，jpeg，png，pdf，文件大小小于5M。',
  'S68Ovq': '取消变更',
  'STkN9e': '运单数量',
  'TB1zPI': '检测结果',
  'U9tgAX': '【材料一】WINIT模版证明文件',
  'UTbJVx': '是否存在DG商品',
  'Udgm+Y': '时间与备注',
  'XCM+/O': '确认进行客户名称变更？变更后信用额度将暂停使用，直至新协议生效。',
  'Xq6UP0': '请为所有行选择处理方式',
  'Z+7bu2': '预计揽收时间',
  'cjZZ0V': '头程询价报价',
  'd+4/21': '是否需要尾板',
  'fIt5Xg': '请下载附件模板，填写完整并加盖双方公章后上传。支持格式jpg，jpeg，png，pdf，文件大小小于5M。',
  'hV2Ott': '实际头程费用',
  'hVF3KL': '支持 jpg, png, jpeg, pdf 格式',
  'haFwvF': '请选择您的处理方式',
  'iyFbgI': '【材料二】证明文件截图',
  'kt3jz+': '继续提交查件申请',
  'm37N51': '目标到仓时间（本地时间）',
  'm3931M': '前往标准索赔',
  'nHw56+': '街道',
  'owsVek': '建议处理方式',
  'qQ3ujN': '请上传关系证明材料',
  'rKSG5U': '揽收货物信息',
  'uIzYCq': '确认变更',
  'vJupx8': '验证信息人身份证有效期',
  'wL2135': '无需处理',
  '/F5P6C': '可选条码位置',
  '/RSLq0': '文件上传支持格式 jpg, png, gif, jpeg, bmp, 文件大小小于5M。',
  '3FqV77': '完整条码（扫描原始值）',
  '7ZFWJJ': '请从左侧选择条码位置',
  '7fuevf': '您可以通过拖拽调整质检类型、检查分组和检查项目的排序',
  '8OBdgQ': '退货序列号',
  'AmumwD': '表达式',
  'C/PA/R': '重置为默认顺序',
  'EnXlhr': '存储字段',
  'FeGA3a': '同步范围',
  'FqK9c4': '确认并保存',
  'IQ0HLa': '添加样本',
  'J8oiXY': '附加增值服务',
  'LUSqnQ': '请先生成有效规则',
  'LuPAIp': '采集说明',
  'OdhwLg': '生成规则',
  'TPATep': '当前已保存规则',
  'Tf+EeR': '识别条码位置',
  'V91z5g': '仅在退货处理作业环节生效。启用后可指定条码所在位置及扫描优先级，引导仓库准确找到条码。',
  'V98Jt3': '更换包装',
  'Vesyaw': '至少需要3组样本',
  'VyjPWN': '全部展开',
  'WLT41E': '仅在退货处理作业环节生效。启用后可设定截取逻辑，从扫描原始值中提取出商品条码用于匹配。',
  'WxVFaa': '请输入多组样本：左列填扫描到的完整条码，右列填期望提取出的商品条码。系统自动推导截取规则，输入越多越准确（建议至少3组）。',
  'YPWr5t': '当前方案未选择「包装检查」分组，请配置包装处理方式',
  'byRQrX': '保留原包装可能存在破损/污损风险，可能影响二次销售',
  'epxUn5': '每个已选位置都必须上传图片',
  'fFfZBY': '推导成功',
  'gJDiKh': '包装处理方式',
  'is41YI': '配置变更实时同步至海外仓（CWM）',
  'j7wLuz': '全部收起',
  'kC/jbD': '条码截取规则',
  'kqoce7': '商品条码（期望截取结果）',
  'oHyBI0': '查询支持',
  'oO+ieb': '包装处理配置',
  'odD6mi': '请至少输入3组有效样本',
  'py/we0': '存在未填写完整的样本行，请填写完整或删除多余行',
  'qJmtAN': '启用时必须配置至少一个条码位置',
  'qa14Fy': '替换图片',
  'qxbg6U': '已选位置（拖拽排序，序号=优先级）',
  'raE12f': '图片大小不能超过5M',
  'tuGlzF': '{projectCount}个分组，{itemCount}个检查项目',
  'u7LJPC': '补贴商品条码',
  'vab3GQ': '上传图片',
  'vbQVrq': '条码采集',
  'yIRROV': '检查分组下的必检项目，不支持删除！',
  'zmdHfX': '{count}个检查项目',
  'zvxx4M': '如需修改，请重新输入样本并生成规则',
  'ETrVHz': '此配置仅在退货处理环节生效。请选择商品条码所处的实际位置，并设定扫描的优先顺序，以便操作员快速、准确地找到条码。WINIT 将尽量按此配置执行作业。本配置为操作指引，最终处理结果以现场实际操作为准。',
  'pf1Kiz': '此配置仅在退货处理环节生效。启用后，WINIT 将自动记录完整的原始扫描码，作为退货序列号记录。',
  'xYS0LQ': '此配置仅在退货处理环节生效。请输入您截取前的号码以及截取后的号码案例，WINIT就根据您提供的案例自动推导出截取规则，规则生效后，现场将按照截取后的条码进行作业操作。',
  'KJAQ59': '条码采集（退货序列号记录）',
  'imC1Uc': '退货订单列表可按退货序列号精准查询',
  'kTIdLR': '仅在退货处理作业环节生效。启用后仓库扫描的原始码将作为退货序列号回传并绑定到对应库存。',
  'vHRJyo': '启用后，仓库在退货收货环节扫描到的完整原始条码将被记录为该商品的退货序列号（唯一码），并通过系统回传绑定到对应库存记录。',
  'gRDR6v': '退货序列号（collectGoodsBarcode）',
  '/Bv6+f': '主体变更审核通过后，当前账户被分配的这部分额度将被立即暂停，在主子关系审核通过后，被暂停的额度才会恢复！',
  '09d8/y': '请选择时段',
  '44PnfQ': '未申请',
  'GZX8nB': '导入组合商品',
  'Np2ifd': '退费金额',
  'O47wOv': '额度提示',
  'POitLI': '首次申诉信息：',
  'Z555H+': '主体变更审核通过后，额度将于审核通过当天的23:59:59失效！您是否已申请新主体的额度？',
  'g/G0D9': '申诉类型',
  'jwRl9i': '结果时间',
  'oZm0IU': '下载组合商品导入模板',
  'sbnNMK': '上次申诉信息：',
  'wBalnh': '新主体变更生效后，新额度协议审核配置约需3个工作日，额度在审核及配置期间将暂停。若无异议，请继续操作。',
  'x/bJdB': '使用范围：当一个平台商品对应多个万邑通商品。',
  '/Axoyw': '发起成功',
  'F3k4N8': '发起库内复核',
  'RPlhiI': '占用库位数量',
  'cs8RMy': '请输入商品条码',
  'eT8fYP': '请选择复核仓库',
  'i35X4Z': 'winit批次号',
  'qmps2V': '库位计费明细',
  '5exYYY': '产品批号',
  'SST615': '单件商品体积(CBM)',
  '1OnAvh': '满足此单需最低配置额度至:',
  'A5U/MC': '额度缺口:',
  'TcelN2': '当前订单占用:',
  'WjVYaQ': '当前已使用（不含此单）:',
  '0f2PTD': '该费用仅为预估费用，若您未预约送仓将按照未预约收费',
  'FiMb3G': '需折叠商品列表（共{count}个）',
  'mLL5e4': '需折叠商品：',
  '/WTGil': '尊敬的客户，您好！我们已提取到您提交异常的订单（单号：{orderNo}）的打包发货视频，经分析：',
  '/cG8F3': 'Winit海外仓原因导致发漏货物。产生串货的情况，或者发漏给买家的情况。',
  '18FqUS': '注：只允许派送中、派送成功、派送失败的包裹申请{type}货物',
  '1sSVAc': '错发',
  '6QWeU+': '如果您对分析结果有异议，仍可继续提交索赔申请，请上传相关证明附件。',
  '75l/Ac': '视频获取后将自动进行分析，届时请关注状态变更通知。',
  '9JN3xh': '请先查看或下载出库视频后，再提交索赔申请',
  'Fstkz3': '待确认视频调查结果',
  'HZEoZT': '出库视频调查中',
  'HkZoUO': '在线查看',
  'IHNzKZ': '经以上视频分析，初步判断未出现您提到的商品错发/漏发',
  'IlwOEh': '出库视频分析结果',
  'KXSeuQ': '此附件指，买家投诉{type}货的邮件（能清晰识别到快递单号/ winit订单号 / 卖家订单号 / 电商平台交易单号比如ebay TransactionID, ItemID)',
  'OVIKXM': '获取视频下载链接失败',
  'S+R2AK': '索赔单号：{serial_number}',
  'UMyC/x': '经以上视频分析，初步判断出现了您提到的商品错发/漏发',
  'VOpmmN': '查看索赔列表',
  'VlsVYE': '提交成功，我公司需要进一步对是否错发/漏发做人工分析，请您耐心等待，我们会尽快反馈。',
  'WJz4ka': '该订单暂无出库视频，系统已自动创建视频查询任务。',
  'fYJd5n': '1. 面单照片（可见Winit出库单号或快递单号）{break}2. 收到所有单品的清晰M码或S码照片{break}3. 包裹及实物照片。{break}注：如买家/卖家无法提供面单照片和收到货物的清晰M码或S码照片：请联系Winit客服调查，如Winit客服确认仓库漏发，将主动发起赔付，并且于确认后的五个工作日内赔偿到账。{break} 1）原出库单号；{break} 2）收到货物的包裹及实物照片； {break}3）买家向卖家投诉收到漏货的沟通截图。',
  'gfwt4b': '我已知晓，取消索赔',
  'hUNff2': '视频分析时间线（仓库当地时间）：',
  'lps+xX': '仍要提交索赔',
  'pLFSsa': '1、客户不能提供Wint所要求的证明文件或者索赔申请文件；{break}2、超索赔受理时效，不予赔付。具体索赔受理时效请以Winit最新公布价卡为准。',
  's3T3pR': '索赔单将进入质控审核环节，质控人员将调取视频进行人工复核。',
  'sPHPen': '出库视频:',
  'vP8rqE': '漏发',
  'vhT71n': '请先点击右上角登录账号二级菜单【开通服务指引】开通海外仓服务，再进行此操作。',
  'Zq+Se6': '在 {scanTime}，员工对商品 {merchandiseSerno}（{merchandiseName}）进行扫描复核（第{sequence}件）',
  '+VCZz4': '修改后的Winit产品',
  '1Ao7np': '单次最多200单，所有字段均为必填。',
  '1d6EK6': '第{num}行目的港"{port}"不在可选范围内，请从下拉选项中选择',
  '2gBezr': '第{num}行预计到港时间格式不正确，请使用 YYYY-MM-DD HH:mm 格式',
  '7J1W1n': '根据入库单的验货类型选择对应产品，同一批次仅支持相同头程类型的入库单',
  '8MEOQq': '预计到港时间(北京时间)',
  '8nD5JW': '从Excel复制后点击第一个单元格，按Ctrl+V粘贴即可自动填入多行多列',
  '9AGywt': '请选择修改后的Winit产品',
  'Kf4Oor': '请填写入库单信息',
  'PMapov': '单次最多200单，支持换行、逗号、空格分隔',
  'PqD7nU': '请输入入库单号',
  'R3d2Zf': '修改Winit整柜港提派',
  'XBtag+': '修改类型后将清空已填写内容，请确认？',
  'Zdsm2X': '修改Winit产品后将清空已填写内容，请确认？',
  'e/EtSz': '第{num}行存在未填写的必填字段',
  'iTLwLH': '提交修改',
  'rUzgju': '批量修改订单',
  'xWNt8l': '修改100%A+/A包裹（无包裹条码）',
  'zqILSF': '单次最多200单',
  'g/Za+0': '支持从Excel直接复制粘贴，按Tab分列、换行分行自动填入。',
  '0NaB0z': '请输入Winit入库单号，单次最多200单，支持换行、逗号、空格分隔',
  'bYsu3+': 'API无箱单下单自动拆分识别码',
  'ydktLD': '分隔符',
  'korflh': '<title>备注：</title>{break}<span>您开启此偏好后，请维护对应的拆分分隔符号，系统将根据您维护的分隔符号进行拆分。{break}分隔符格式：支持最大长度10字符，不允许包含字母，数字。{break}如维护英文逗号“,”，针对无箱单预报单，若您API下单传参了多个识别码，系统将自动按照英文逗号拆分进行下单。{break}举例：若识别码传参为【00340312892440215576,00340312892440215601】，系统将自动拆分成【00340312892440215576】和【00340312892440215601】两个识别码进行下单。</span>',
  'bbQdax': '入库单号重复：{nos}，请检查后重新提交',
  '/HL9iL': '<title>备注：</title>{break}<span>您开启此偏好后，请维护对应的拆分分隔符号，系统将根据您维护的分隔符号进行拆分。{break}分隔符格式：支持最大长度10字符，不允许包含字母，数字。{break}如维护英文逗号","，针对无箱单预报单，若您API下单传参了多个识别码，系统将自动按照英文逗号拆分进行下单。{break}举例：若识别码传参为【00340312892440215576,00340312892440215601】，系统将自动拆分成【00340312892440215576】和【00340312892440215601】两个识别码进行下单。</span>',
  '2nM0La': '请输入分隔符',
  'K2BzuE': '入库单号重复：{nos}，请检查后重新提交',
  'ae3z74': '分隔符最大支持10字符',
  'dWBLP6': '主子关系证明未审核通过，请重新提交主子关系证明并等审核通过再操作',
  '1hZYqM': '主子关系证明审核不通过不允许提交，请提交主子关系证明并等审核通过再操作',
  '/On9qX': '预约模式',
  'v+v1Hz': '越库/合流预约',
  '4PTy7k': '普通入库预约',
  'xYiYWb': '预约总件数',
  'X4Y2RY': '出库件数',
  'WV+ROF': '当前预约单已过允许取消时间（当地时间预约送仓日期前 {advanceDateQty} 个工作日{cancelTime}点），如确认取消将收违规则取消预约费用（{currency}）：{amount}，确认取消预约？',
  '2kn2QD': '出库单类型',
  '9SQhL0': '客户波次号',
  'Fl0md0': '越库包裹来源',
  'I32zDQ': '是否越库订单',
  'MQRJm/': 'Winit波次号',
  'VsvL0B': '预约件数',
  'ZRZ2D4': '出库单件数',
  'c/r3gS': '包裹履约方式',
  'jWGCbt': '纯越库订单',
  'kFKQU4': '越库在库混合订单',
  'm1EQXR': '越库入库单【{crossOrders}】和普通入库单【{normalOrders}】不能混合预约',
  'nraiDe': '可预约(件)',
  'oLh6eL': '越库类型',
  'rcGMvc': '波次信息',
  'x6qgBE': '包裹卸货时间',
  'z5BWKU': 'Winit波次到仓时间',
  'FhyCgU': '您的报价已确认；{break}WINIT仓库将联系您填写的提货联系人，确认最终揽收时间及预计到仓时间。请您创建预约单并按照预计到仓时间进行预约；请下载附件BOL作为提货交接凭证。提货当天，WINIT将使用BOL纸质单据进行现场交接和签收确认。',
  'PwoQ9d': '下载BOL提货凭证',
  '/7etjS': '选中弃置',
  '3zg9jr': '弃置完成',
  '7oFoNK': '第二步:创建非标增值单',
  '8vOmaS': '全部弃置',
  'L1RpeK': '弃置',
  'RlJdy9': '请创建非标增值单，若未正常创建，后续订单无法正常进行',
  'S+8BUO': '请填写订单包装对应的包材类型',
  'WmoT2W': '下载销毁凭证',
  'XztFHH': '出库单操作指引',
  'Z/oOll': '基于出库单信息, 创建非标增值单。',
  'jqT0Ti': '填写收货地址和出库SKU信息, 选择产品【出标/增值】, 提交出库单。',
  'neKvVH': '处置出库',
  'oEK6zS': '在Winit海外仓当中的滞销品进行销毁或弃置处理,从而减少卖家库存及仓储费',
  'ozcVKW': '已完成第一步, 请继续创建非标增值单',
  'qEMCPi': '创建非标增值单',
  '1PSjMh': '注意：未创建非标增值单，订单将无法继续安排处理。',
  'Ck4MBK': '出库单已成功提交（当前状态：出库确认中）！',
  'M+ttFe': '将在库滞销或不良库存进行弃置或销毁处理，帮助卖家快速释放库存并减少仓储费。',
  'rQpp0X': '专业销毁操作指引',
  'wQcQi0': '客户放弃指定库存货物的所有权及后续处置权，由 WINIT 对货物进行自主处置。处置方式可能包括合规转售、资源回收利用或环保处理。',
  'yBmy5W': '对库存货物进行物理破坏或交由专业机构无害化处置，确保彻底无法二次销售，处理完成后将出具相应的销毁证明。',
  'yg+Zko': '由于专业销毁属于线下定制化服务，需委托第三方资质机构处理，且不同品类（如普货/危废/TS合规）的处理标准与费用存在差异，请继续创建非标增值单以确认销毁方案与服务报价。',
  'PYH+gX': '不推荐产品（使用订单产品）只推荐仓库',
  'Q0smbN': '（2）如果下单时指定产品信息，则会遇到订单产品出现多个产品组情况，处理方式选择下单报错则遇到这种情况直接下单失败，处理方式选择不推荐产品（使用订单产品）只推荐仓库，下单不会失败，订单直接使用指定的产品出库，不会使用智能推荐功能去选择最优的产品出库',
  '4QtXfF': '客户放弃指定库存货物的所有权及后续处置权，由 WINIT 对货物进行自主处置。处置方式可能包括资源回收利用或环保处理。',
  '+NIPLv': '报关补充信息',
  '+yabwR': '关联入库单：',
  '/nQkzo': '驳回',
  '1XOnrV': '上传报关资料',
  '1Xk/0Q': '该报关资料同时关联了 {count} 个入库单：{orders}',
  '36iBqe': '支持 xlsx / xls 格式',
  '3KtggC': '审核人：',
  '3YYYgM': '驳回后，系统将自动发送驳回通知邮件至报关行（包含驳回原因），并抄送客户。报关行修正后将重新出具预录单。',
  '3nxaFG': '备注不能超过2000字符',
  '64CZXO': '修正后重新上传将同步更新所有关联订单。',
  '6aRJjQ': '点击或拖拽文件上传附件',
  '6gZ3dk': '商品{no}：{name}',
  '6y2aQX': '9810/9710关联单号',
  '8WMnSl': '未填写，',
  '9Obhoh': '请输入驳回原因',
  '9TAz6Y': '导入提示',
  '9opxaf': '共校验 {total} 项，通过 {pass} 项，不通过 {fail} 项',
  'AQ9twL': '暂无审核记录',
  'BbyQrr': '第三步：上传报关资料（',
  'BjcN87': 'AI审核不通过',
  'DJq/pp': '驳回原因',
  'EHEJCe': '驳回原因不能超过500字符',
  'Ei7lyw': '下载报关信息模板',
  'G4a26M': '填写"{value}"，',
  'HwOzec': '报关资料信息',
  'ICeSwc': '请输入正确的邮箱格式',
  'J0ZKwN': '多个邮箱用逗号分隔',
  'JMshma': '确认驳回',
  'JOqHcX': '人工审核不通过',
  'JSzuMh': '表头',
  'JTfWyA': '请上传Excel文件',
  'KbVEHM': '报关资料表头信息校验（{count}项）',
  'Kj9Usf': '当前版本',
  'LPOKOG': '报关资料已通过AI审核，已自动进入待发送队列。系统将在配载完成后自动发送至报关行。',
  'MFgDzg': '搜索或输入入库单号',
  'NMLDeP': '上传附件：',
  'O2I3YI': '请输入联系邮箱',
  'Ou2Wt3': '审核类型：',
  'PRRcLo': 'AI审核通过',
  'Pzur0w': '支持 jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx 格式，可多文件上传',
  'RaguVe': '点击此区域上传',
  'T4fH20': '上传报关资料附件',
  'UVi3d0': '审核时间：',
  'Ub9kru': '不支持该文件格式，请上传jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx格式的文件。',
  'UcM4B/': '暂无报关资料',
  'UzmisV': '预录单附件',
  'VGoWnS': '人工审核结果',
  'VK50At': '报关资料',
  'VX2B6y': '9810/9710 订单编号（非必填）',
  'VnKOxH': '第一步：下载导入模板',
  'WTLdPG': 'AI审核',
  'WW7GfS': '报关资料审核通过',
  'WfS4rv': '操作人：',
  'WyB8ig': '报关资料表体信息校验（{fieldCount}项 × {itemCount}条商品）',
  'Xgj8wy': '驳回预录单',
  'Y5h3t2': '确认预录单',
  'YVdj/s': '确认导入',
  'YcKsDx': '9810/9710订单编号',
  'cf+Gh6': '当前版本附件',
  'dKY1TQ': '请上传报关资料附件',
  'dc4Xir': '关联入库单',
  'de8EBC': '客户订单号：',
  'fBdsjg': '单一窗口E编码',
  'foYkxO': '请输入备注信息（选填）',
  'g1cKwj': '暂无版本记录',
  'h8e2WN': '附件数量已达上限（10个），请删除后重新上传',
  'ib4rj9': '判定依据',
  'jIpNnE': '必填）',
  'jO9shU': '（根据入库单号自动带出）',
  'jjo9Gz': 'AI审核结果',
  'kle3CD': '人工审核',
  'lZFv6p': '上传资料时自动带入，不可编辑，自动更新',
  'lipHr3': '请上传报关资料',
  'nEvz7V': '驳回原因：',
  'oBTdvg': '请填写驳回预录单的原因，报关行将收到此内容...',
  'ogt+tK': '确认上传',
  'pFP+/B': '单一窗口E编码（非必填）',
  'pxnIia': '报关资料状态',
  'qODon7': 'AI审核不通过，需修正后重新上传',
  's5+02b': '人工审核通过',
  'sy7m/m': '支持jpg/png/jpeg/pdf/doc/docx/xls/csv/xlsx格式文件，可多文件同时上传',
  'u12O09': '校验项',
  'uRhhXO': '历史报关资料',
  'vgp2rG': '批量上传报关资料',
  'wWOv+i': '请修正以上问题后，点击「重新上传资料」提交新版本',
  'xRxIHw': '下载报关资料模板',
  'yd14jk': '导入成功，共上传 {count} 条记录',
  'ypUU3i': '文件大小超过10MB，请压缩后重新上传',
  'zof5x4': '第二步：上传填写好的Excel文件（',
  'zuc4Gg': '支持上传报关资料的订单列表',
  '25BYK8': '轨迹变更日志',
  '8Q4uC2': '客户放弃指定库存货物的所有权及后续处置权，由 WINIT 对货物进行自主处置。处置方式包括资源回收利用或环保处理等。',
  'GZLZSR': '修改次序',
  'RuItAS': '修改前时间',
  'dHOT0C': '修改原因',
  'uh9L8a': '修改后时间',
  '5tnI7K': '您好，申请尾程代客索赔-妥投未收到需要保证索赔资料的真实合法，请您先签署承诺书。',
  'AthyIZ': '填写发货信息',
  'JKZJgL': '承诺书签署',
  'Mxplhy': '批量已读',
  'PoyMGI': '尾程派送异常功能说明',
  'RFu03m': '修改PSC',
  'RdLh4C': '修改后的Winit产品(PSC)',
  'UXLhwo': '未妥投',
  'VHHcWu': '请填写发货信息',
  'c5LwpD': '同一批入库单将统一修改为此PSC',
  'cXHXi2': '商品标签信息',
  'dEMknn': '入库单号列不可编辑（来自第一步），其他列支持Excel粘贴',
  'hwW/0c': '请补充每个入库单的集装箱号、提单号、目的港、预计到港时间。支持Excel粘贴。',
  'l6I9d3': '承诺书内容',
  'ljL3gz': '第一步（修改Winit产品）已完成并锁定，入库单的Winit产品已修改成功。请继续填写发货信息。',
  'mxHH+s': '预计到港时间(北京)',
  'rcOn5i': '标签条码',
  'uOmHPQ': '同意并签署',
  'ux5ZBe': '请确认',
  'vfyAfP': '请选择修改后的Winit产品(PSC)',
  'yx7oLR': '查看商品标签信息',
  'Gqafh0': '实际卸车完成时间',
  'IuLtpQ': '现场作业照片',
  'JmzURT': '实际柜型',
  'Kdy15G': '（本地时间）',
  'dpyNCw': '实际集装箱号',
  'fTpv4q': '实际卸货方式',
  'laeHnj': '实际装货方式',
  'zPXseg': '关联的客户预约单号',
  '/mLHLD': '打印时间',
  '24Thgy': '商品【{sku}】请选择 {count} 个要删除的包裹',
  '8Twc0c': '复用上一次打印条码 + 自动新增',
  '9ZPZgL': '确认选择',
  'Bnkh4w': '复用上一次打印条码',
  'CGQ3Xl': '复用上一次打印条码 + 手工删除多余条码',
  'I5FiGK': '确认处理',
  'KI/GdI': '📦 条码变更处理',
  'LLJsOt': '粘贴多个包裹序号或包裹条码，每行一个或用逗号/空格分隔',
  'LzT6io': '全部删除',
  'NNq6ji': '已选 {selected}/{need}',
  'NYKIRS': '复用 {reuse} 个原条码，自动新增 +{add} 个',
  'Nipe8P': '需手工选择 {count} 个多余条码删除',
  'O7pZSc': '商品【{sku}】请选择 {count} 个历史条码',
  'UcWFNn': '确认全部删除？',
  'Ur/Bod': '当前数量',
  'Xcvnrr': '确认处理后，系统将打印全部包裹条码（包含复用的原条码和新生成的条码），请注意核对。',
  'Xm1i12': '全部重新生成',
  'YSJbfi': '打印说明',
  'bdu6F4': '选择历史条码',
  'bueIW/': '批量查询（粘贴包裹序号/包裹条码）：',
  'cAcaUk': '支持换行、逗号、空格分隔',
  'evOQEG': '系统自动生成 {count} 个新条码',
  'f8t63R': '原打印条码数',
  'jOnpg1': '需从历史打印记录中选择 {count} 个条码复用',
  'k/OmWi': '选择历史打印过的条码',
  'kN/irF': '系统按包裹序号自动删除最后 {count} 个',
  'kZTCdQ': '处理方式规则：系统根据「原打印条码数」与「当前数量」的差异，自动匹配变更类型与可选处理方式。',
  'kx92Hl': '个，需要选择',
  'vSs2OO': '变更类型/判断条件',
  'vUQyA/': '复用上一次打印条码 + 系统按包裹序号自动删除最后 {count} 个',
  'yIKZNo': '已选择的历史记录',
  'ztV27A': '选择要删除的包裹',
  'zxz7sF': '💡系统已加载该 SKU 的历史打印条码记录，请勾选需要复用的条码。',
  '20mYrK': '生效时机',
  '7CoGIn': '第三方面单服务补贴 UN 标签',
  '7cJiqy': '我已阅读并同意上述条款',
  '9JcidQ': '增值服务规则',
  'AxBfyF': '订单类型：自提出库-第三方面单服务常规打包产品',
  'COdnuj': 'OSF8V1743 补贴锂电池运输标签',
  'H1otQv': '请选择{field}的属性',
  'HONX1w': '确认关闭自动补贴？',
  'KaKkWJ': '确认关闭',
  'LevjV3': '规则类型：',
  'NVof2I': '未开启：系统不再为您的自提-第三方面单服务的订单自动构建补贴锂电池 UN 运输标签增值，存在 USPS 罚款风险',
  'P3poe9': '修改包装信息会导致个性化打包增值清空，请确认是否修改包装信息',
  'PN0uPP': '增值服务规则为系统规则，满足条件时自动触发对应增值服务。系统规则不可编辑、不可删除。',
  'RsPUtK': '开启前请阅读以下事项',
  'aVmQ6K': '请确认您已了解以下风险与责任：',
  'b5OmiM': '锂电池商品未维护 UN 编码时下单会被阻断',
  'bSLvFe': '开启「第三方面单服务补贴 UN 标签设置」后，系统将对您的第三方面单服务常规打包订单执行以下动作：',
  'cBrdf6': '提示：如果有多个包裹，所有包裹都会执行勾选的服务',
  'h3nC41': '生效范围',
  'iLAIH1': '因商品信息不准确导致的 USPS 罚款、错贴、漏贴由',
  'jdelkV': '结合商品 UN 编码自动选择对应的 UN 标签类型',
  'juz0lL': '同意并开启',
  'o+e1vO': '前置校验',
  'qW2sWh': '关闭后，系统不再为您的自提-第三方面单服务的订单自动构建补贴锂电池 UN 运输标签增值。',
  'sxiXs2': '增值编码',
  't8LW1B': '规则名称：',
  'uKG0B0': '第三方面单服务补贴 UN 标签设置',
  'ucT0L6': '关闭本功能后，系统不再自动补贴，仓库线下识别可能存在遗漏',
  'upQelj': '自动识别商品符合 USPS Hazmat 合规要求并构建',
  'vAuKNM': '您承担',
  'vO3xCd': '开启后：商品符合 USPS Hazmat 合规要求自动构建补贴锂电池 UN 运输标签增值，规避 USPS 罚款风险',
  'ws0XMU': '开启后立即对新下单生效，历史订单不追溯',
  'zTkyPu': '请确保您在 MMS 维护的商品电池信息、UN 编码、USPS Hazmat 合规字段准确无误',
  'Q3OEyt': '自提出库模板',
  '7ZdcxH': '费用总计',
  '9GajoZ': '回退草稿',
  '9Z+Yzp': '是否缺量',
  'COTXe/': '批量导入将清空原输入/导入SKU数据；仅支持 XLS/XLSX 格式，文件大小限制 5M',
  'GgMgwh': '请选择批次日期',
  'LZDlcg': '已入库',
  'Py3OyW': '下载导入模板（含SKU类型/批次/等级/自定义属性等11列）',
  'RJj9NN': '超过可用库存',
  'TZcm4S': '下单数量|发货仓拣选数量|目的仓商品预分拣数量|目的仓上架数量',
  'Wsui9Z': '回退中',
  'dDmQcT': '请确认是否回退草稿？',
  'hUREVs': '是否全部库存调拨',
  'leJYmZ': '实际扣费金额与预估金额可能不一致，以实际扣费金额为准',
  'oHlEPm': '不允许的文件格式，请上传 XLS/XLSX',
  'qOPvJP': '请输入产品批次号',
  'vRL430': '文件上传失败，请重试',
  'S5Stcp': '打包数量|目的仓商品预分拣数量|目的仓上架数量',
  'YzhdUJ': '上架完成',
  '+UErHL': '请先选择增值服务！',
  '2XormZ': '选择增值服务',
  '6asrX+': '选项加载失败，',
  'EFyLnr': '选择处理方式',
  'FKfuYc': '切换处理方式将清空已填写内容，请确认是否切换？',
  'GvqKSj': '从下方组合中选择一个（单选）',
  'JI+iiO': '输入入库单号',
  'JKx8s3': '加载失败，',
  'JdHJMh': '入库单号校验失败',
  'KdSCWh': '支持批量粘贴，每行一个或用逗号/空格分隔',
  'RFYLDS': 'WINIT创建新入库单上架',
  'RR36mz': '客户创建新单上架',
  'WqCD+7': '将清空已填写内容，请确认是否切换？',
  'X+OwBR': '该异常不支持选择!',
  'YMPCBA': '当前异常场景无可用处理方式，请联系客服。',
  'dAO3T4': '暂存',
  'dtlrnv': '价格(USD)',
  'eMI1Th': '已达最大500个入库单号，超出部分已忽略',
  'fUVx+F': '自提',
  'fdnK/M': '离开将丢失当前填写内容，是否确认？',
  'kJtA/G': '请先选择处理方式！',
  'qsj7Cv': '根据您输入的入库单号未匹配到处理方式为【客户创建新单上架】的增值服务！请刷新后重试',
  'rT1Nil': '填写服务要求',
  'rmOWn8': '请粘贴或输入客户新单的入库单号（例：WI50000001）',
  'w1h6bJ': '粘贴内容过大，请分批粘贴',
  'ygqWgW': '原单上架',
  'zvHAkW': '当前处理方式暂无可用增值服务，请联系客服申请特批。',
  '1hqMwB': '格式疑似不正确',
  'TzWVXx': '上次提交',
  'YiYwCO': '填写进度',
  'YjdPjx': '填写要求',
  'b5kCtF': '待选择',
  'jw8OnZ': '填写中',
  'mdMlwG': '已填写完成',
  'n6HlL+': '或使用逗号/空格分隔',
  '64/HXZ': '关闭本功能后，系统不再自动补贴',
  'QYN6KE': '请确保您在 商品管理 维护的商品电池信息、UN 编码、USPS Hazmat 合规字段准确无误',
  '1S13GM': '未开启：无论是否符合 USPS Hazmat 合规要求，Winit 都不会自动下发补贴锂电池 UN 标签增值服务。如客户需补贴锂电池 UN 标签，则应自行下发相应增值。',
  '3I/koe': '自提出库-第三方面单服务-美国仓库',
  '5d3yZi': '生效时间',
  'DkZgMf': '若锂电池商品未维护 UN 编码，则无法下发OSF8V1743增值且下单失败',
  'JVIiNL': '关闭后,系统不再为您的自提-第三方面单服务的订单自动下发补贴锂电池UN运输标签增值。',
  'b1RX5n': '使用范围',
  'hx8gUx': '开启即生效',
  'y2h80L': '开启后：订单内任意商品含锂电池，且不符合 USPS Hazmat 合规要求时，Winit 将自动下发补贴锂电池 UN 标签增值服务，降低 USPS 罚款风险。',
  'za/zJ1': 'OSF8V1743补贴锂电池运输标签',
  'FfFaqm': '关联跟踪号',
  '/+VB3y': '标签条码格式与 EAN不匹配，需为 12 位纯数字',
  '/aKsXS': '批量上传成功',
  '1rB/Z5': '标签内容',
  '50W5Rn': '标签格式=EAN，标签条码为12位纯数字',
  '9D1q0F': '是否打印商品编码',
  'Gdsg//': '填写标签内容',
  'I3Cawd': '商品标签信息不能为空',
  'K1QScR': '标签条码:',
  'MdzU66': '说明：标签尺寸100x60mm, 主条码位于标签中部,「商品编码」位于示签右下角（当「是否打印商品编码」= 是 时显示）。 平台商品名称、商品状态、原产地按顺序展示；主条码类型由「打印格式」决定（EAN / UPC / CODE 128）。',
  'U7YTet': '标签条码格式与 CODE128 不匹配，最多20个字符，只能输入数字和字母',
  'W6B/ZV': '若订单履约场景为"转第三方仓/买家订单"，请填写',
  'WVEsfT': '打印格式',
  'XqtpZ3': '标签格式=CODE 128，标签条码限制20个字符，仅允许输入数字+字母',
  'dYIiDZ': '请填写标签内容',
  'guajX8': '标签条码格式与 UPC不匹配，需为 11 位纯数字',
  'ih2fEa': '请填写标签条码',
  'jilYXi': '标签格式=UPC，标签条码为11位纯数字',
  'lYSvAE': '根据您选择的收货人类型，请填写对应编码信息:',
  'mNTg67': '若订单履约场景为"平台仓-Walmart"，请填写',
  'o6LxpZ': '若订单履约场景为"平台仓-FBA(VC)/FBA(SC)"，请填写',
  'pXMwr5': '填写完成后，系统将基于您提供的编码自动生成条形码信息。为确保条形码准确有效，请务必核对并填写正确的编码内容。',
  'qL9rhl': '编码，12位的纯数字编码',
  'hF5h/M': '标签格式=CODE 128，标签条码不能超过20个字（允许少于20个字），仅允许输入数字+字母',
  'D7qtVC': 'EAN-13：国际通用商品条码，固定 13 位纯数字，用于国内超市、零售商品外包装，扫码收银必需。',
  'hnHHof': 'UPC-A：北美商品条码，固定 12 位纯数字，用于销往美国、加拿大的零售商品。',
  'iTw7tD': 'CODE 128：最常用的通用条码，可含数字 + 字母 ，长度≤20个字，适合仓储、物流、内部单号、箱标等场景。',
  'moupQK': '打印标签条码的格式，如无特殊要求，则选择系统默认的<b>CODE 128</b>格式即可，各格式场景如下：',
  '+u5rcb': '已预约SLOT（CBM）',
  '/QFie7': '分配和预约明细',
  '03oH+l': '请先查询出有效的预约单2',
  '34aN7u': '请先查询出有效的预约单1',
  '4un7lV': '已预约 SLOT',
  '56e0bu': '预约单号2',
  '6ndV9k': '保存修改',
  'A5tL4O': '编辑天SLOT',
  'Ag1TbG': '预约卸货时间',
  'FEQqGe': '本周',
  'FEe9ks': '以下日期的天SLOT不能低于已预约SLOT：{days}',
  'N7bcSG': '当天剩余可占用SLOT（CBM）',
  'PvY4GQ': '请输入预约单号',
  'Zfx7GJ': '天SLOT总和（{total} CBM）不能超过周SLOT（{weekly} CBM）',
  'axsjIx': '单',
  'cpOa69': '预约单2',
  'gRT7HC': '周SLOT',
  'gyOgWt': '天SLOT（CBM）',
  'jjy0PS': '预约单1',
  'oRLj7v': '保存分配',
  'ox0R2v': '终止类型',
  'pr55PD': '分配天SLOT',
  'ttucU+': '关联预约单',
  'xPf0w5': '已分配天SLOT',
  'y+nJm9': '仓库休息',
  'z2xGPm': '预约送仓时间',
  'OGlQt5': '日期【{date}】已分配天SLOT需要≥已预约SLOT【{booked}】',
  '+2wUa+': 'Winit商品状态',
  '+vFteY': '请输入TT入库单号，如CUST-20260420-001',
  '/MLSJ+': '通过 Excel 导入未注册商品清单，系统按行注册商品、提交发布审核并自动建联；其他所需注册信息将直接从 TiktokFBT 商品数据自动导入。若商品已注册但需新增进口国的关联，也需通过此方式导入注册该进口国。若 TiktokFBT 商品信息缺失，则自动保存为草稿，需手动补齐信息后提交发布审核。单次 ≤ 500 条。',
  '/PdBsH': '导入的商品ID/Barcode',
  '/qd06T': '校验凭证',
  '/ys4jP': '货主 ID',
  '0+Dqij': '删除后订单将永久移除，不可恢复。',
  '1U7QvB': '失败：{count}',
  '1jNGJ9': '请检查商品 ID / Barcode 是否属于该 TiktokFBT 货主 ID，确认后重新提交。',
  '2Y4K/H': '注：以下费用为预估费用，账户可用余额小于系统预估费用则无法提交订单，烦请在下单前确保账户可用余额充足。',
  '2qTuwe': '请输入 TiktokFBT 货主 ID',
  '2xmYN3': '提交成功，已生成头程运输单',
  '3DX5OB': '请输入货主简称',
  '3SL4WI': '货主 ID：',
  '3UR/Cs': '·共 {total} 条',
  '4CagJY': '失败明细',
  '4JFxZB': '创建头程运输单',
  '4ShKdS': '收货尺寸',
  '4UPNap': '首次创建头程运输单？请按以下 3 步完成前期配置',
  '4lBG/a': '校验凭证至少 2 个',
  '4uT0Nv': '全部命中，可提交绑定',
  '5Q1wC+': '绑定新 TiktokFBT 货主 - 校验失败',
  '5em3kd': '下单箱数',
  '6FDAdc': '关联的TT商品条码',
  '7+qmpn': '卸货重量',
  '8EQrqZ': '绑定新货主',
  '8FEREW': '验货件数',
  '9v/D4V': '已绑定客户 ID：',
  'A9BUVZ': '批量快速注册',
  'AQtV7m': '下单件数',
  'Ac+XIc': '，万邑联账号：',
  'AmgwF0': '绑定 TiktokFBT 货主',
  'B/ipI7': '运输轨迹',
  'D0R7zD': '重新建联',
  'E94zBi': '点击或拖拽上传 Excel（.xlsx / .xls，单次 ≤ 500 条）',
  'Fh7YPD': '万邑通已和 TiktokFBT 深入合作，支持客户直接快速创建头程运输单，直接发货至 TiktokFBT 仓。',
  'Fx/yiw': '补充信息',
  'H/DRyY': '卸货体积(CBM)',
  'Hrb1O1': '校验',
  'HxBS4j': '批量关联',
  'IVmm5R': '请选择货主',
  'J//5tH': '验货重量',
  'JUyiEx': 'TiktokFBT 商品 ID',
  'JqMC+q': '解绑货主',
  'L6M3HO': '卸货箱数',
  'O2/AyA': '头程运输单号：',
  'OMr4eM': 'TT入库单号',
  'OQrhwl': '绑定时间：',
  'OkXJwu': '重新校验',
  'P+tJNO': '确认解绑{count}个商品吗？',
  'PF3ERh': '下单|收货|验货|卸货',
  'PON3xy': '确认解绑该 TiktokFBT 货主吗？',
  'PYVuTl': '请先选择提货地址！',
  'PdaTsL': 'Step 3 · 完成以上步骤即可在【入库 - 头程运输单】中创建订单',
  'Pgy5nC': '收货箱数',
  'QgltAQ': '成功：{count}',
  'QxIgO8': '命中·万邑通账号',
  'RSr4CH': '下单尺寸',
  'TFPba5': '货主简称：',
  'Tksazo': '该 TiktokFBT 货主 ID 已被其他万邑联客户绑定',
  'ToroOE': '货主简称',
  'ULyz5A': '该货主下 {count} 条已关联商品全部同步置为「已解绑」',
  'URyjAi': '第 {row} 行',
  'Vkac+c': '已解绑',
  'WnwfhL': '确认解绑',
  'XXMltT': '部分商品在该货主下未查到归属，请核对后重新提交',
  'XjkJXt': '提交头程运输单',
  'YcGgvm': '解绑后：',
  'ZYV6bl': '每行 1 个，支持 TiktokFBT 商品 ID 或 Barcode',
  'Zqsx9N': '开启 TiktokFBT 头程运输',
  'aEWVKN': '验货箱数',
  'bVwEuw': '绑定失败',
  'bc+mEK': '注册重量',
  'ceOmHh': '收货体积(CBM)',
  'cgikOb': '请选择物流计划',
  'dmGeZC': '批量解绑',
  'eWdu63': '注册|核实',
  'esQHyz': 'Step 2 · 完成 TiktokFBT 商品和万邑通商品建联',
  'fYxisF': '货主 ID {ownerId} 下无此商品 ID',
  'gHhyK6': '支持批量粘贴，多个用逗号或换行分隔',
  'ggCQtQ': '收货重量',
  'h79tjH': '下单|收货',
  'hjT3DZ': '批量关联（已注册商品）',
  'hz0Wmf': '注册尺寸',
  'iNwVgn': '确认解绑该商品吗？',
  'iPONvw': '具体操作如下：',
  'ixAXfT': '适用场景：客户在万邑通已注册商品，与 TiktokFBT 商品做关联。系统按「国家 + 第三方商品条码 → TiktokFBT 商品 ID」查询，命中多个 TiktokFBT 编码则报错。单次 ≤ 500 条。',
  'jPwEDg': '运输单号',
  'jhilUP': '选择货主',
  'kHvnhz': '确认重新建联该商品吗？',
  'lkqKU+': '重新建联成功',
  'muygN6': '查询和校验',
  'mxJ2RN': '一个 TiktokFBT 货主 ID 全局仅允许绑定一个万邑联账号。如需绑定到当前账号，请先联系原客户解绑，或联系万邑通运营协助处理。',
  'nDAVFw': '卸货件数',
  'pOzKhw': '收货件数',
  'rxpvne': 'TiktokFBT 货主 ID',
  'sJa05X': '回退后订单将变为草稿状态，可重新继续下单再次提交。',
  'svu+m3': '支持通过 FBT 商品快速注册万邑通商品',
  't5oTEY': '输入TT入库单号，系统将自动查询对应的入库单，并校验入库单下所有商品是否已完成关联。校验通过后进入创建向导。',
  'tGJZ+G': '绑定新 TiktokFBT 货主',
  'tXJ03I': '解绑结果',
  'urlMn/': '支持后续重新绑定，历史关联可通过「重新建联」快速恢复',
  'wSdWu+': '终止后订单将不可恢复，请确认是否终止？',
  'x+xja9': '每行 1 个，支持 TiktokFBT 商品 ID 或 Barcode，至少 2 个',
  'xjWHGB': '请选择提货类型',
  'yEXHj/': '已绑定 TiktokFBT 货主（{count}）',
  'ya32Dh': '导入完成',
  'yj3b8Q': '批量快速注册（未注册商品）',
  'zjun/X': 'Step 1 · 绑定 TiktokFBT 货主',
  'A7PkTj': '命中TiktokFBT批次管理商品，已为您自动开启批次管理权限。同时商品已默认使用TiktokFBT商品的批次管理信息。',
  'EyDu5z': '绑定货主ID',
  'Ru9X3s': '批量导入 卖家SKU 商品，建立 客户商品 ↔ TT 商品 关联',
  'a27VWc': '提供货主ID + 至少 2 个校验商品ID，MIMS 校验通过后建立绑定',
  'eKqSaD': '当前',
  'ggF6+v': '点击或拖拽上传 Excel（.xlsx / .xls，单次 ≤ 300 条）',
  'h/0cCn': '输入 TT 入库单号 → 校验通过 → 填写运输单',
  'vONXo4': '三方条码',
  'zJ8Ntt': '商品同步并关联',
  'WYeRKr': '通过 Excel 导入未注册商品清单，系统按行注册商品、提交发布审核并自动建联；其他所需注册信息将直接从 TiktokFBT 商品数据自动导入。若商品已注册但需新增进口国的关联，也需通过此方式导入注册该进口国。若 TiktokFBT 商品信息缺失，则自动保存为草稿，需手动补齐信息后提交发布审核。单次 ≤ 300 条。',
  '2TipcB': '未注册万邑通商品，请使用[批量快速注册]，将直接用平台商品信息注册并关联。 已注册万邑通商品，请使用[批量关联]，将批量关联平台商品。',
  'EX1Jzw': '适用场景：客户在万邑通已注册商品，与 TiktokFBT 商品做关联。系统按「国家 + 第三方商品条码 → TiktokFBT 商品 ID」查询，命中多个 TiktokFBT 编码则报错。单次 ≤ 300 条。',
  'hyXT/t': '提供货主ID+至少2个Tiktok商品ID，校验通过后建立绑定',
  '/YUuzV': '作废要求已经通知仓库，待仓库确认是否成功作废',
  '0Q0/dW': '确认并关闭签署',
  'BKtWp2': '订单将无法提交，需更换指定包材后重新下单',
  'UGkT0P': '拦截下单',
  'X7nCJV': '我已阅读并同意以上协议',
  'eDNxm3': '忽略对应的排除规则，订单可正常提交',
  'sZy6WK': '请同意以上协议',
  'sjBT8L': '查看排除规则',
  'x5h+4q': '中国大陆地址选择区域后，邮编将自动填写',
  'Lkn1XH': '增值自动触发规则',
  'S2Y15B': '出库加包装相关配置',
  'Z/0cr1': '关闭规则请知悉以下协议内容',
  'cMwFvA': '已知悉',
  'cPu3iv': '关联商品条码',
  '+0oPPG': '<bold>最终处理意见如何判定？</bold>{break} <bold>步骤一：</bold>仓库按序检查。若过程中出现触发"终止后续检查"的结果，则提前结束检查；若全程未发生中断，系统将汇总所有检查结果。{break} <bold>步骤二：</bold>根据步骤一结束时所收集到的各项检查结果，系统将按照以下优先级顺序确定最终处理意见：<bold>销毁>拍照暂存>不良品上架>良品上架</bold>',
  '/1QQlL': '总件数=每箱件数*箱数',
  '/D5MgW': '商品信息不能为空！',
  '9vqlvE': '请输入大于0的数字，最多两位小数',
  'AS5sYN': '确定要批量删除选中的商品吗？',
  'EGrucD': '退货质检',
  'G22Twb': '【{info}】未维护商品包裹类型A+/A，请维护后再进行下单！',
  'MqloPV': '同一个商品不能新增多条！',
  'U9SWt3': '是否完成质检',
  'V3UDXJ': '包裹长宽高(cm)',
  'd+Twhp': '删除商品会同时删除其关联的包裹数据，确定删除？',
  'jElDms': '大于0，最多两位小数',
  'vV8RQq': '总件数',
  'E/4rGQ': '填写收货地址和出库SKU信息, 选择需要【非标增值】,提交出库单。',
  'U/8V+P': '处置',
  'Y90SUR': '您未选择增值或您选择的增值无需暂存后补充资料，订单将不会进入暂存流程',
  'eLoNJr': '自提订单需暂存，请在订单更新暂存后补充增值资料',
  'gw/emU': '您选择了增值且需要暂存后补充资料，订单需暂存，请在订单更新暂存后补充增值资料',
  'hIhiH9': '勾选此选项后，出库单将保持为"出库确认中"状态，等待客户提交额外的非标增值订单才会将任务下发给仓库进行拣选操作',
  'qREhKj': '选中处置出库',
  'EH3soQ': '2. 如客户配置了拍照暂存定制模板，将优先使用定制模板；未配置定制模板，则默认采用万邑通质检全局拍照模板。',
  'EaLlzm': '温馨提示：当客户选择质检后的处理方式为拍照暂存时，此字段的处理策略将更新为拍照暂存',
  'bUHpnt': '1. 因拍照暂存服务自带照片，选用该处理方式时，客户无需额外勾选全局拍照服务。',
  '51giX6': '（数据截至 {date}）',
  'AuZRr4': '已扣费欠款(USD)',
  'MC/rfG': '立即还款',
  'Pbubl4': '账户存在逾期欠款，已被列为坏账客户。清偿全部欠款后方可恢复下单与发货权限。',
  'in6jZn': '（已冻结）',
  'v+ZDR0': '资金信息',
  'wUWLaA': '当前总欠款(USD)',
  'xUDpHO': '当前为坏账客户，如需取消坏账标记，请还清总欠款 {amount} USD',
  '936OGI': '批量下载电子收据',
  'ubXjRA': '坏账期间未扣仓租费（USD）',
  'eNv+ZF': '包装及损坏类型的破损细节选择“其他”时，索赔备注需要填写破损细节',
  '+/wf+u': '单个商品体积（{volume} CBM）',
  '8HFbFG': 'V = {v}（CBM）',
  'Fz1L32': '无法识别嵌套方向，请重新选择',
  'Fz2EAa': '沿最短边嵌套',
  'Nh6Ixk': '沿次长边嵌套',
  'Rf24jR': 'Y={a}（向上取整）',
  'XnhwRe': '单个库位体积（{volume} CBM）',
  'ZQyYos': '单件占用体积 V（CBM）随预期库存数量 Y 变化曲线',
  'b0chiT': '件数为 {counts} 时嵌套商品单件体积最小',
  'g4dEnk': '嵌套商品单件体积曲线',
  'gZ+ZoG': '嵌套库位匹配模拟计算',
  'l27O3i': '沿最长边嵌套',
  'pMqwj0': 'Y = {y}（件）',
  'zZgnnM': '嵌套商品单件体积与单个商品体积交点，Y={a}（向上取整）',
  'PGscWZ': '请先完善以下必填信息：{fields}',
  '5d9IGP': '嵌套方向是指商品在库内进行嵌套存储时，可以堆叠嵌套新增的方向（点击图片查看大图）',
  'PAlllX': '模拟在库库存件数',
  'ZrZB8l': '单件嵌套体积',
  'J4Q2/A': '正在计算是否需要嵌套…',
  '4QnKNq': '最优库位',
  '7sdlr4': '{name}（{length} × {width} × {height} cm，{volume} CBM）',
  'AgHbP5': '不满一个库位仍按一个库位计费，建议增加备货量，提高库位利用率。',
  'Di6ekN': '图例解读：',
  'FJxziP': '在库件数超过 {a} 件时，单件平均占用体积为 {aVolume} CBM，小于商品体积 {itemVolume} CBM，使用嵌套计费理论上可节省仓租。',
  'Yt3SAv': '单件最小平均占用体积：{xCbm} CBM',
  'fqoFr6': '嵌套计费测算结果',
  'nzDFlX': '单库位最多存放：{bestCount} 件',
  'pPm4PB': '单库位存满 {b} 件时，单件平均占用体积最低，为 {x} CBM，仓租节省最多。',
  'JrVsmG': '嵌套库位都无法装下，请勿使用嵌套商品。',
  'ZWHEC0': '查看测算明细',
  'h6F76V': '在库件数＞{a}件时，推荐嵌套计费：嵌套后单件平均占用体积更小；≤{a}件时不推荐。',
  'kH3pAE': '不推荐嵌套计费：嵌套后单件平均占用体积更大。',
  '33XNhl': '经测算，在 {length} × {width} × {height} cm 的库位中最多可存放 {bestCount} 件。嵌套后的单件最小平均占用体积为 {x} CBM，大于商品体积 {itemVolume} CBM，因此不推荐使用嵌套计费。',
  'FJdrbY': '经测算，在 {length} × {width} × {height} cm 的库位中最多可存放 {bestCount} 件。嵌套后的单件最小平均占用体积为 {x} CBM，等于商品体积 {itemVolume} CBM，因此不推荐使用嵌套计费。',
  '4CVs8w': '不推荐嵌套计费',
  'ZZStup': '不推荐嵌套计费：嵌套后单件平均占用体积与商品体积相同。',
  'BCSAaC': '商品主图',
  'PjJ8Hm': '商品主体正面图，以商品主体为核心，清晰展示商品外观形态及品牌、型号、规格等关键信息的图片。',
  'rvBYko': '图片大小限制10M以内',
  't/jdWn': '是否RFID标签',
  'xBK+Po': '图片格式限制为{formats}',
  '+bZkH5': '入库限制额度预警通知配置',
  '+ual19': '当您生效了该偏好且维护了具体的比例值，当您的库容限制额度使用率达到您的比例值时，系统将通过邮件通知您，请注意查收！',
  'Nu4Dmo': '%，系统将邮件通知您，请注意查收！',
  'VsyDN2': '限制下单',
  'VtIlog': '限制预约',
  'Z4eFFb': '只能输入1~100以内的正整数！',
  'evKwR6': '已消耗',
  'ygL0Ou': '当您的限制额度使用率达到',
  'rvBPE9': '关联的TT商品编码',
  'lnIXeF': '预约单状态',
  'qoyajK': '提示失败信息',
  'uFMzYD': '送仓单号',
  '6OLyVt': '请填写所有面单文件的第一页跟踪号',
  '7rz7kX': '支持多个 PDF 文件；每个文件上传后需填写该文件第一页跟踪号，系统据此识别跟踪号位置。',
  'AShfCC': ' 说明：上传每个面单 PDF 后需人工填写该文件第一页跟踪号（用于系统 OCR 定位跟踪号所在位置），再上传关系表指定每个包裹（BOX 号）对应哪个 PDF 的哪一页，系统据此识别其它页跟踪号并与关系表比对，不一致则报错。',
  'OMm85S': '只支持上传 XLSX 格式的文件',
  'W42Ljf': '请输入该文件第一页跟踪号',
  'b0oR2h': '使用一单多面单渠道，请点击"下一步"确定装箱方案后再基于装箱结果上传面单文件。',
  'omnQsM': '上传中...',
  'rE9cml': '当前选择"常规打包"：下一步显示跟踪号+第三方面单上传，产品服务仅显示常规打包 PSC。',
  'sgVKxe': '第一页跟踪号',
  'wPcSJS': '上传包裹与面单的关系',
  'zGCJkF': '下载包裹与面单关系模板',
  '9jkNMN': '请输入客制包材编码',
  'NoCyvl': '是否购买Amazon Buy Shipping',
  'RZfR1q': '当前费用仅供参考，部分费用项暂无法确定，最终以实际收费为准。',
  '4AdVUI': '联系电话不能超过20个字符',
  '9s/SpT': '不支持该文件格式，请上传jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z格式的文件。',
  'CcgLlj': '支持 jpg/gif/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z 格式，可多文件上传',
  'HiaUtp': '该费用按实际包裹计收，暂无预估',
  'lMmy7Y': '客户联络备用手机号、座机（选填）',
  'p+bCwQ': '支持jpg/png/jpeg/pdf/doc/docx/xls/csv/xlsx/zip/rar/7z格式文件，可多文件同时上传',
};
